﻿(function () {
    "use strict";

    //$.ajax({
    //    url: 'settings.json', dataType: 'json', async: false, success: function (settings) {
    //        window._settings = settings;
    //    }
    //});




    window._base = {
        extendDeep: function extendDeep(dst) {
            angular.forEach(arguments, function (obj) {
                if (obj !== dst) {
                    angular.forEach(obj, function (value, key) {
                        if (dst[key] && dst[key].constructor && dst[key].constructor === Object) {
                            extendDeep(dst[key], value);
                        } else {
                            dst[key] = value;
                        }
                    });
                }
            });
            return dst;
        },
        mobileAndTabletcheck: function () {
            var check = false;
            (
                function (a) {
                    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
                        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)) check = true
                })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        }
    }
})();

﻿var _gaq = _gaq || [];

(function (window, angular) {
    'use strict';

    var underscore = angular.module('underscore', []);
    underscore.factory('_', function () {
        return window._; // assumes underscore has already been loaded on the page
    });



    angular.
        module("digitalWallet", ['ionic', 'ngRoute', 'serverConnection', 'underscore', 'jmdobry.angular-cache', 'ngPostMessage', 'Cal4U', 'calshtifomat', 'calceleb', 'calP2P', 'calFollowApp', 'digitalVouchers', 'calmail', 'blockCard', 'angucomplete-alt', 'onlineForms', 'paymentSpread', 'transferOrders', 'ngAnimate', 'toastr']);

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';

    angular.module('digitalWallet')
        .config(mainRoute)
        .run(mainConfig);

    mainRoute.$inject = ['$stateProvider', '$urlRouterProvider', '$httpProvider', '$angularCacheFactoryProvider', '$ionicConfigProvider', '$locationProvider', '$provide', 'WorkerProvider', 'toastrGlobalProvider'];

    function mainRoute($stateProvider, $urlRouterProvider, $httpProvider, $angularCacheFactoryProvider, $ionicConfigProvider, $locationProvider, $provide, WorkerProvider, toastrGlobalProvider) {

        toastrGlobalProvider.init();
        WorkerProvider.register();

        $locationProvider.hashPrefix('!');
        //$locationProvider.html5Mode(true);
        delete $httpProvider.defaults.headers.common["X-Requested-With"];

        $angularCacheFactoryProvider.setCacheDefaults({
            capacity: 1000,
            storageMode: 'sessionStorage'
        });

        $ionicConfigProvider.views.swipeBackEnabled(false);

        //$httpProvider.interceptors.push('httpInterseptorService');

        $stateProvider
            .state('dw', {
                url: "/digital",
                abstract: true,
                templateUrl: "cal-digital.html",
                resolve: {
                    sso: function ($q, accountService, lobbyUiService) {
                        var defer = $q.defer();
                        lobbyUiService.loader.show();
                        accountService.loginSso().finally(function () {
                            lobbyUiService.loader.hide();
                            defer.resolve({ result: true });
                        });

                        return defer.promise;
                    },
                    multitab: function ($q, connection, appData, accountService, $timeout) {
                        var defer = $q.defer();
                        if (!connection.isLoggedIn() && !appData.BankAccounts) {
                            accountService.login().finally(function () {
                                defer.resolve();
                            });
                        }
                        else {
                            $timeout(function () {
                                defer.resolve();
                            })
                        }

                        return defer.promise;
                    }
                }
            })
            .state('dw.lobby', {
                url: "/lobby",
                views: {
                    'contentBody': {
                        controller: "lobbyCtrl",
                        templateUrl: "app/main/templates/envelope.html"
                    }
                },
                data: {
                    module: 0,
                    lobby: true
                }
            })
            // ***** authentication module pages
            // ****************************************************************
            .state('dw.login', {
                cache: false,
                url: "/login/:nextPage/:type/:sso/:restricted/:takanonTouch/:command/:isOtpData/:query/:step/:fromCallVU"/* touch: /:restricted/:takanonTouch */,
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/connect.html",
                        controller: "connectCtrl"
                    }
                }
            })
            // *****
            // account module pages
            // ****************************************************************
            .state('dw.account-home', {
                url: "/account",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/accountHome.html",
                        controller: "lobbyCtrl"
                    }
                },
                data: {
                    module: 1
                }
            })
            // *****
            // wallet module pages
            // ****************************************************************
            .state('dw.wallet-home', {
                url: "/wallet",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/walletHome.html",
                        controller: "lobbyCtrl"
                    }
                },
                data: {
                    module: 4
                }
            })
            // *****
            // benefits module pages
            // ****************************************************************
            .state('dw.benefits-home', {
                url: "/benefits",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/benefitsHome.html",
                        controller: "lobbyCtrl"
                    }
                },
                data: {
                    module: 3
                }
            })
            // *****
            // service module pages
            // ****************************************************************
            .state('dw.service-home', {
                url: "/service",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/serviceHome.html",
                        controller: "lobbyCtrl"
                    }
                },
                data: {
                    module: 5
                }
            })
            .state('dw.generalActions-home', {
                url: "/generalActions",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/generalActions.html",
                        controller: "lobbyCtrl"
                    }
                },
                data: {
                    module: 8
                }
            })
            .state('dw.contact-cal', {
                url: "/contactcal",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/contactCalDetails.html",
                        controller: "serviceCtrl"
                    }
                },
                data: {
                    module: 5
                }
            })

            .state('dw.calhull-home', {
                url: "/calhull",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/calHullHome.html",
                        controller: "lobbyCtrl"
                    }
                },
                data: {
                    module: 6
                }
            })
            .state('dw.block-card-home', {
                url: "/blockhome",
                analyticsUrl: '/vp/managecards/',
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/block-card-home.html",
                        controller: "lobbyCtrl"
                    }
                },
                data: {
                    module: 7
                }
            })
            // *****
            // envelope pages
            // ****************************************************************
            .state('dw.legal-terms', {
                url: "/terms",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/legal-terms.html",
                        controller: "lobbyCtrl"
                    }
                }
            })
            .state('dw.data-security', {
                url: "/secured",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/data-security.html",
                        controller: "lobbyCtrl"
                    }
                }
            }).state('dw.register357', {
                url: "/account/register357/:nextPage/:type/:sso/:command",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/register357.html",
                        controller: "register357Controller"
                    }
                },
                data: {
                    isHideNavicon: true
                }
            })/* touch: route */
            .state('dw.touch-taknon', {
                url: "/touch-taknon",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/touch-taknon.html",
                        controller: "touchTaknonCtrl"
                    }
                }
            })
            .state('dw.loanFrame', {
                cache: false,
                url: "/loanFrame/",
                params: {
                    path: { value: '', squash: true }
                },
                views: {
                    'contentBody': {
                        controller: "loanCtrl"
                    }
                },
                resolve: {
                    loan: function (sso) {
                        return sso;
                    }
                }
            })
            .state('dw.openBanking', {
                url: "/openBanking",
                views: {
                    'contentBody': {
                     templateUrl: "app/main/templates/openBanking.html",
                        controller: "openBankingCtrl"
                    }
                }
            })
            .state('dw.updateAddress', {
                url: "/updateAddress",
                views: {
                    'contentBody': {
                        templateUrl: "app/account/templates/updateAddress.html",
                        controller: "updateAddressController"
                    }
                }
            })
            .state('dw.insightsFrame', {
                cache: false,
                url: "/insightsFrame",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/insightsFrame.html",
                        controller: "insightsFrameCtrl"
                    }
                },
                resolve: {
                    loan: function (sso) {
                        return sso;
                    }
                }
            })
            .state('dw.touch-legal-terms', {
                url: "/touch-terms",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/touch-legal-terms.html"
                    }
                }
            })
            // *****
            // Payment Spread
            // ****************************************************************
            .state('dw.payment-spread-form', {
                url: "/paymentSpread",
                views: {
                    'contentBody': {
                        templateUrl: "app/paymentSpread/templates/paymentSpreadForm.html",
                        controller: "paymentSpreadCtrl as vm"
                    }
                }
            })
            // *****
            // New Chat Iframe
            // ****************************************************************
            .state('dw.new-chat-frame', {
                url: "/newChatFrame",
                views: {
                    'contentBody': {
                        templateUrl: "app/main/templates/newChatFrame.html",
                        controller: "newChatCtrl as vm"
                    }
                },
                resolve: {
                    auth: function ($q, connection, $timeout, lobbyUiService) {
                        var defer = $q.defer();
                        if (!connection.isLoggedIn()) {
                            $timeout(function () {
                                lobbyUiService.go('dw.login', { nextPage: 'dw.new-chat-frame' });
                                defer.reject();
                                return;
                            });
                        }

                        $timeout(function () {
                            defer.resolve(true);
                        });

                        return defer.promise;
                    }
                }
            })
            .state('dw.updateMail',
            {
                url: "/updateMail",
                cache: false,
                views: {
                    'contentBody': {
                        templateUrl: "app/updateMail/updateMail.html",
                        controller: "updateMailCtrl as vm"
                    }
                }
            })
            .state('dw.internetId',
            {
                url: "/internetId",
                cache: false,
                views: {
                    'contentBody': {
                        templateUrl: "app/internetId/internetId.html",
                        controller: "internetIdCtrl as vm"
                    }
                }
            })
            
        
        $urlRouterProvider.otherwise("/digital/lobby");
    }

    mainConfig.$inject = ['$rootScope', 'lobbyStateService', 'lobbyUiService', '$q', 'backService', 'lobbyDataService', '$ionicPlatform',
        'errorService', 'dataService', 'googleAnalyticsService', 'appSettings', 'appData', 'restrictService',
        '$timeout', '$injector', '$location', 'connection', 'tokenService', 'register357Service', '$state', '$stateParams',
        'nativeAppBannerService', 'sessionStorageTransferService'];

    function mainConfig($rootScope, lobbyStateService, lobbyUiService, $q, backService, lobbyDataService, $ionicPlatform, errorService,
        dataService, googleAnalyticsService, appSettings, appData, restrictService, $timeout, $injector, $location, connection,
        tokenService, register357Service, $state, $stateParams, nativeAppBannerService, sessionStorageTransferService) {

        //if (appSettings.env === "PROD") {
        //    if (!window._base.mobileAndTabletcheck()) location.href = "https://www.cal-online.co.il/";
        //    document.domain = "cal-online.co.il";
        //}

        var queryString = $location.search();
        var token = queryString.token;

        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }

        var hideNavBar = inIframe();//(queryString.hidenavbar && queryString.hidenavbar == "true") ? true : null;


        console.log("hideNavBar: ", hideNavBar);
        dataService.sessionManager.clearAndSave("hidenavbar", hideNavBar);
        
        var campaignParams = {
            utm_source: queryString.utm_source,
            utm_medium: queryString.utm_medium,
            utm_campaign: queryString.utm_campaign
            /*utm_campaign: queryString.utm_term,
            utm_campaign: queryString.utm_content*/
        };

        if (token && token.length && token.length > 0) {
            $rootScope.getOtpDataByToken = token;
        }

        function filterAccountByIsEffective(accounts) {
            var copyAccounts = angular.copy(accounts);

            var filterAccounts = [];

            _.each(copyAccounts, function (account) {
                var filterCards = _.filter(account.Cards, function (card) {
                    return card.IsEffectiveInd == true;
                });

                if (filterCards.length > 0) {
                    account.Cards = filterCards;
                    filterAccounts.push(account);
                }
            });

            return filterAccounts;
        }

        $rootScope.$on('$stateChangeStart', function (event, toState/*, toParams, fromState, fromParams*/) {
            /* touch: restirctedRoute */
            restrictService.restirctedRoute(event, toState).then(function (status) {
                if (status) {
                    lobbyUiService.navigate("dw.login", {}, {
                        nextPage: toState.name,
                        restricted: true
                    });
                }
            });
            /* touch: end restirctedRoute */
            $rootScope.$broadcast('lobbyEvent::StateChanging', { targetState: toState, targetEvent: event });
        });
        $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState/*, fromParams*/) {

            var token = $rootScope.getOtpDataByToken;
            $rootScope.getOtpDataByToken = null;
            if (token && token.length && token.length > 0) {
                tokenService.getOtpDataByToken(token);
            }
            //if (toState && toState.name) {
            //    $rootScope.state = toState.name;
            //}

            //$rootScope.$broadcast('lobbyEvent::StateChanged', { targetState: toState, srcState: fromState });
            //googleAnalyticsService.trackPage(toState.url);
            //conversionService.fireRemarketingPixels();
            $rootScope.$broadcast('lobbyEvent::StateChanged', { targetState: toState, srcState: fromState });
            var page = toState.analyticsUrl || toState.url;
            if (toState.analyticsUrl && toState.paramsService) {
                var paramsService = $injector.get(toState.paramsService);
                if (paramsService) {
                    page += paramsService[toState.paramMethod]();
                }
            }

            if (campaignParams.utm_source || campaignParams.utm_medium || campaignParams.utm_campaign)
                $location.search(campaignParams)

            googleAnalyticsService.trackPage(page);
            
        });


        if (navigator.platform == 'iPad' || navigator.platform == 'iPhone') {
            window.ontouchstart = function () {
                $timeout(function () {
                    if (angular.element(".expander.fix-bottom").length > 0) {
                        $(".expander.fix-bottom").css("display", "none");
                    }
                });

            }

            window.onscroll = function () {
                var iPadPosition = window.innerHeight + window.pageYOffset - 58.5; // 45 is the height of the Footer
                var element = $(".expander.fix-bottom");
                element.css("position", "absolute");
                element.css("top", iPadPosition);
                element.css("display", "block");
            }
        }

        ionic.Platform.ready(function () {

            ionic.Platform.fullScreen(true, false);

            /* Google Analytics */
            if (window.analytics) {
                window.analytics.startTrackerWithId(appSettings.environment.current.gaAccount);
            } else {
                window.ga = window.ga || function () { (ga.q = ga.q || []).push(arguments) }; ga.l = +new Date;
                ga('create', appSettings.gaAccount, 'auto');
                ga(function (tracker) {
                    var gId = tracker.get('clientId');
                    if (gId && gId.length > 0) {
                        ga('set', 'dimension2', gid);
                    }
                    ga('send', 'pageview');
                });

            }

            /* End Google Analytics */

            nativeAppBannerService.init();
            sessionStorageTransferService.init();
        });
    }

})(window, window.angular);
﻿//(function (window, angular) {
//    'use strict';

//    angular.module("digitalWallet")
//        .constant('appSettings', {
//            version: "100.0.0",
//            os: "04",
//            environment: (function () {
//                var current = 'PROD',
//                    options = [];

//                if (location.origin == "http://localhost") { current = 'DEV' };

//                options['DEV'] = {
//                    base: 'http://localhost/',
//                    server: 'http://localhost/Cal4U-Dev/',
//                    mobile: true,
//                    env: 'DEV',
//                    commonServer: 'http://localhost/CommonServices/',
//                    cellebServer: 'http://54.93.62.32:10080/ws_api/main.py/celleb/celleb',
//                    gaAccount: 'UA-34396915-2'
//                },
//                 options['TEST'] = {
//                     base: 'http://test.cal-online.co.il/',
//                     server: 'http://test.cal-online.co.il/Cal4U-Test/',
//                     mobile: true,
//                     env: 'TEST',
//                     commonServer: 'http://test.cal-online.co.il/Cal4U-Test/CommonServices/',
//                     cellebServer: 'http://54.93.62.32:10080/ws_api/main.py/celleb/celleb',
//                     gaAccount: 'UA-34396915-2'
//                 },
//                options['STAGE'] = {
//                    base: 'https://stage-restservices.cal-online.co.il/',
//                    server: 'https://stage-restservices.cal-online.co.il/Cal4U-Test/',
//                    mobile: true,
//                    env: 'STAGE',
//                    commonServer: 'https://stage-restservices.cal-online.co.il/CommonServices/',
//                    cellebServer: 'https://celleb.co.il:10443/ws_api/main.py/celleb/celleb',
//                    //http://54.93.62.32:10080/ws_api/main.py/celleb/celleb
//                    gaAccount: 'UA-34396915-2'
//                },
//                    options['PROD'] = {
//                        base: 'https://www.cal-online.co.il/',
//                        server: 'https://restservices.cal-online.co.il/Cal4Uecredit/',
//                        mobile: true,
//                        env: 'PROD',
//                        commonServer: 'https://restservices.cal-online.co.il/CommonServices/',
//                        cellebServer: 'https://celleb.co.il:10443/ws_api/main.py/celleb/celleb',
//                        gaAccount: 'UA-632119-27'
//                    }

//                return {
//                    current: options[current]
//                }
//            })()
//        });

//})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('sessionStorageTransferService', sessionStorageTransferService);

    sessionStorageTransferService.$inject = ['$rootScope'];

    function sessionStorageTransferService($rootScope) {

        // transfers sessionStorage from one tab to another
        function _sessionStorage_transfer(event) {
            if (!event) { event = window.event; } // ie suq
            if (!event.newValue) return;          // do nothing if no value to work with
            if (event.key == 'getSessionStorage') {
                // another tab asked for the sessionStorage -> send it
                localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
                // the other tab should now have it, so we're done with it.
                localStorage.removeItem('sessionStorage'); // <- could do short timeout as well.
            } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
                // another tab sent data <- get it
                var data = JSON.parse(event.newValue);
                for (var key in data) {
                    sessionStorage.setItem(key, data[key]);
                }
                $rootScope.$broadcast('sessionStorageUpdated', null);
            }
        };

        function init() {
            window.addEventListener("storage", _sessionStorage_transfer, false);

            // Ask other tabs for session storage (this is ONLY to trigger event)
            if (!sessionStorage.length) {
                localStorage.setItem('getSessionStorage', 'foobar');
                localStorage.removeItem('getSessionStorage');
            };

        }

        return {
            init: init
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('speachRecognition', speachRecognition);

    speachRecognition.$inject = ['$q', '$timeout'];

    function speachRecognition($q, $timeout) {
        /**
         * Initialzie speachRecognition service.
         *
         * @param args
         */
        function init(args) {
            // If carolina as global variable not exist defined a default empty object.
            if (!Carolina) {
                return Carolina = {};
            }

            // Init the core of the voice recognition 3rd party library.
            Carolina.init({
                lang: 'he-IL',
                logLevel: 1, // 0 is NO_LOGS , 1 INFO_MODE, 2 DEBUG_MODE, 3 ULTRA_DEBUG_MODE.
                quality: 1, // 0 is BAD QUALITY result capture and 1 is GOOD QUALITY result capture.
                maxAlternatives: 1,
                continuous: false,
                interimResults: false,
                callbacks: args.callbacks
            });
        }


        function isSupportVoiceRecognition() {
            return Carolina.isSupportVoiceRecognition();
        }


        function isListening() {
            return Carolina.isListening();
        }


        function start() {
            Carolina.start();
        }


        function stop() {
            Carolina.stop();
        }


        function abort() {
            Carolina.abort();
        }

        return {
            isSupportVoiceRecognition: isSupportVoiceRecognition,
            init: init,
            start: start,
            isListening: isListening,
            stop: stop
        };
    }
})(window, window.angular);
(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('webpushNotfication', webpushNotfication);

    webpushNotfication.$inject = ['$state'];

    function webpushNotfication($state) {
        var notficationSupported = false;


        /**
         * Initialzie speachRecognition service.
         *
         * @param args
         */
        function init(args) {
            if (ionic.Platform.isWebView() && cordova.plugins.notification) {
                // Notification plugin installed.
                notficationSupported = true;

                // Attach handler when user click on notification.
                cordova.plugins.notification.local.on("click", function (notification) {
                    $state.go(notification.data.link);
                });

                notify = nativeNotify;
            }
            else {

                if (!window.Notification) {
                    console.error('Desktop notifications not available in your browser. Try Chromium.');
                    return;
                }


                // Desktop notfication is available in the browser.
                notficationSupported = true;

                notify = browserNotify;
            }
        }


        /**
         * Send web push notification.
         *
         * @param notificationOptions
         * @returns {{init: init, notify: notify}}
         */
        function browserNotify(notificationOptions) {
            // If the notfication feature is not supported end execution.
            if (!notficationSupported)
                return;

            // If the user not have granted permission end execution.
            if (window.Notification.permission !== "granted")
                window.Notification.requestPermission();

            if (!navigator.serviceWorker)
                return;

            navigator.serviceWorker.ready.then(function (registration) {
                registration.showNotification(notificationOptions.title, {
                    body: notificationOptions.body,
                    icon: notificationOptions.icon || 'icon.png',
                    vibrate: [200, 100, 200, 100, 200, 100, 200],
                    tag: ''
                });
            });
        }


        /**
         * Send native push notification.
         *
         * @param notificationOptions
         * @returns {Function}
         */
        function nativeNotify(notificationOptions) {
            // If the notfication feature is not supported end execution.
            if (!notficationSupported)
                return;


            var currMessageID = 1,
                nativePushNotification = function(notificationOptions) {

                console.log('Sending native notification => ', notificationOptions);

                    cordova.plugins.notification.local.schedule({
                        id: 1,
                        title: notificationOptions.title || '',
                        text: notificationOptions.body || '',
                        icon: notificationOptions.icon || '',
                        data: {link: notificationOptions.link}
                    });
                };

            return (function() {
                cordova.plugins.notification.local.hasPermission(function (granted) {
                    console.log('Permission has been granted: ' + granted);

                    if (granted) {
                        nativePushNotification(notificationOptions);
                        currMessageID++;
                    } else {
                        cordova.plugins.notification.local.registerPermission(function (granted) {
                            console.log('Permission has been granted: ' + granted);

                            if (granted) {
                                nativePushNotification(notificationOptions);
                                currMessageID++;
                            }
                        });
                    }
                });
            }());
        }


        function notify() {}


        init();


        return {
            notify: notify
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('serverConnection', []);

    angular.module('serverConnection').config(serverConnectionConfig);

    serverConnectionConfig.$inject = ['$httpProvider'];

    function serverConnectionConfig($httpProvider) {

        $httpProvider.defaults.useXDomain = true;

        delete $httpProvider.defaults.headers.common["X-Requested-With"];
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';

    angular.module("digitalWallet")
        .directive('focusOnShow', focusOnShow);

    focusOnShow.$inject = ['$timeout'];

    function focusOnShow($timeout) {
        return {
            restrict: "A",
            link: function ($scope, $element, $attr) {
                if ($attr.ngShow) {
                    $scope.$watch($attr.ngShow, function (newValue) {
                        if (newValue) {
                            $timeout(function () {
                                $element[0].focus();
                            }, 0);
                        }
                    })
                }
                if ($attr.ngHide) {
                    $scope.$watch($attr.ngHide, function (newValue) {
                        if (!newValue) {
                            $timeout(function () {
                                $element[0].focus();
                            }, 0);
                        }
                    })
                }

            }

        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .controller("homeCtrl", homeCtrl);

    homeCtrl.$inject = [
        '$scope', '$ionicSideMenuDelegate', '$ionicPlatform', '$http', '$sce', '$log', 'lobbyUiService', 'lobbyDataService',
        'connection', '$window', 'appData', '$rootScope', '$route', '$routeParams', '$timeout', '$ionicScrollDelegate', 'errorService', 'backService',
        'googleAnalyticsService', 'lobbyStorageService', 'appSettings', 'webpushNotfication', 'dataService','customerIndication'
    ];

    function homeCtrl($scope, $ionicSideMenuDelegate, $ionicPlatform, $http, $sce, $log, lobbyUiService, lobbyDataService,
        connection, $window, appData, $rootScope, $route, $routeParams, $timeout, $ionicScrollDelegate, errorService, 
        backService, googleAnalyticsService, lobbyStorageService, appSettings, webpushNotfication, dataService,customerIndication) {

        $rootScope.members =
        {
            IS_NEW_VERSION: "IS_NEW_VERSION",
            ionSideMenuExpand: false
        };
        //webpushNotfication.notify({title: 'כ.א.ל', body: 'רוצה לקחת הלוואה?'});
        //customerIndication.getIndicationForCustomer();
        $scope.appData = appData;

        $scope.appData.backOverrideFN = null; 

        $scope.appData.noConnection = false;


        /**
         * Indicate flag that represent the state of the search bar if is currently active or inactive.
         * 
         * @property
         * @type boolean
         */
        $scope.isSearchBarActive = false;

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
            $scope.isSearchBarActive = false;
        });


        $scope.noHistory = !backService.hasHistory();

        $scope.reportAppLaunched = function (url) {

            //console.log("App Launched Via Custom URL: " + url);

            var pageId = url.substring(url.indexOf('pageId=') + 7);

            if (pageId && pageId != 'undefined') {
                lobbyDataService.getAppPageRoute(pageId).then(function (startRoute) {
                    if (startRoute) {
                        lobbyUiService.navigate(startRoute);
                    }
                });
            }
        }

        $scope.hideLeftArrow = function (bankAccounts, bankIndex) {

            var currentIndex = $scope.appData.selectedBankAccountIndex;

            if (typeof bankIndex != 'undefined') {
                currentIndex = bankIndex;
            }

            if (bankAccounts) {
                return bankAccounts.length <= 1 || currentIndex == 0;
            } else {
                return !$scope.appData.BankAccounts || $scope.appData.BankAccounts.length <= 1 || currentIndex == 0;
            }
        }

        $scope.hideRightArrow = function (bankAccounts, bankIndex) {

            var currentIndex = $scope.appData.selectedBankAccountIndex;

            if (typeof bankIndex != 'undefined') {

                currentIndex = bankIndex;
            }

            if (bankAccounts) {
                return bankAccounts.length <= 1 || currentIndex == bankAccounts.length - 1;
            } else {
                return !$scope.appData.BankAccounts || $scope.appData.BankAccounts.length <= 1 || currentIndex == $scope.appData.BankAccounts.length - 1;
            }
        }

        $scope.toggleRightSideMenu = function () {
            $ionicSideMenuDelegate.toggleRight();
        };

        $scope.toggleLeftSideMenu = function () {
            $ionicSideMenuDelegate.toggleRight();
        };

        $scope.goBack = function () {
            backService.back();
        }


        /**
         * Open the main search bar over the lobby,
         * Should replace the static header view with a custom search bar.
         * 
         * @function
         * @returns undefined
         */
        $scope.openSearchBar = function ($event) {            
            $event.preventDefault();
            $scope.isSearchBarActive = true;

            console.log('Opening the search bar component => ', $scope.isSearchBarActive);
        }


        /**
         * Close the main search bar over the lobby,
         *
         * @function
         * @returns undefined
         */
        $scope.closeSearchBar = function () {
            $scope.isSearchBarActive = false;

            console.log('Closing the search bar component => ', $scope.isSearchBarActive);
        }


        $scope.callService = function () {
            googleAnalyticsService.insertEvent({ page: 'Customer service', eventName: 'Call now - customer service', action: 'Call' });
        }

        $scope.goHome = function () {
            lobbyUiService.navigate('dw.lobby');
        };

        $scope.simulateLogin = function () {
            $ionicSideMenuDelegate.toggleRight();

            setTimeout(function () {
                $rootScope.$broadcast('accountLoggedIn', null);
            }, 1000);

        }

        $scope.toggleRight = function () {
            $rootScope.members.ionSideMenuExpand = !$rootScope.members.ionSideMenuExpand;
            $ionicSideMenuDelegate.toggleRight();
        }
        // abandon modal message
        $scope.openLeadModal = function () {
            lobbyUiService.modalDialog.create('app/main/templates/loan-lead.html').show(
            {
                ok: function () { lobbyUiService.popup.alert('אישור', 'ארעה שגיאה בלתי צפויה'); },
                cancel: function () { lobbyUiService.popup.alert('סגור', 'ארעה שגיאה בלתי צפויה'); }
            });
        }

        // process loading animation
        $scope.showLoading = function () {
            lobbyUiService.loader.show();
        }
        // global navigation method
        $scope.navigate = function (url, options, page) {

            //console.log(options.id, options.state);

            googleAnalyticsService.insertEvent({ page: page, id: options.id });

            lobbyUiService.navigate(url, options);
        }
        $scope.captionize = function (item) {
            return lobbyUiService.captionize(item);
        }
        
        $scope.getCalChoiceAccount = function () {

            var calChoiceAccounts = [];

            for (var i = 0; i < $scope.appData.BankAccounts.length; i++) {
                var cardsToDisplay = [];
                for (var j = 0; j < $scope.appData.BankAccounts[i].Cards.length; j++) {
                    if ($scope.appData.BankAccounts[i].Cards[j].IsCalChoiceCard) {
                        $scope.appData.BankAccounts[i].Cards[j].CardIndex = j;
                        cardsToDisplay.push($scope.appData.BankAccounts[i].Cards[j]);
                    }
                }
                if (cardsToDisplay.length > 0) {
                    $scope.appData.BankAccounts[i].calChoiceCards = cardsToDisplay;
                    $scope.appData.BankAccounts[i].AccountIndex = i;
                    $scope.appData.BankAccounts[i].CalChoiceAccountIndex = calChoiceAccounts.length;
                    calChoiceAccounts.push($scope.appData.BankAccounts[i]);
                }
            }

            return calChoiceAccounts;
        }

        $scope.logout = function () {
            lobbyUiService.loader.show();
            $scope.appData.showSpinner = true;


            connection.logout($scope.appData.token);
        };

        $scope.back = function () {

            window.history.back();
        };
        $scope.$on(
            "$destroy",
            function () {
                $timeout.cancel($scope.appData.sessionTimeout);

            }
        );
        $scope.$on('loggedOut', function () {

            lobbyStorageService.clearAppData();

            $timeout(function () {
                $ionicScrollDelegate.$getByHandle('sideScroll').scrollTop();
            }, 0);

            connection.token = null;

            $scope.appData.showSpinner = false;

            $scope.appData.inProcess = false;

            lobbyUiService.loader.hide();

            lobbyUiService.go("dw.lobby");


        });

        $scope.$on('bannersLoaded', function () {

            $ionicPlatform.ready(function () {
                if (!navigator.splashscreen)
                    return;
                if (ionic.Platform.isAndroid()) {
                    navigator && navigator.splashscreen.hide();
                    $scope.navigateFromPush();
                }
            });
        });

        $scope.messages = [];

        /*$scope.$on('sessionStorageUpdated', function () {
            var token = dataService.sessionManager.read('authToken') || null;
            token && login(token, null, false);
        });*/

        $scope.$root.$on('$messageIncoming', function (event, data) {
            var _data = angular.fromJson(data);

            //$scope.messages.push(angular.fromJson(data));
            //var _data  = $scope.messages[0];

            if (_data) {

                if (_data.event == "login") {
                    login(_data.token, _data.url, true);
                }
            }
        });

        function login(token, url, redirect) {

            lobbyUiService.loader.show();

            if (token) connection.setToken(token);

            if (!$scope.appData.metaData) {
                // cal4u
                connection.getMetaData().then(function (response) {

                    $scope.appData.metaData = response;

                    $scope.initAccount().then(function () {

                        if (redirect) {
                            if (url && url.toLocaleLowerCase().indexOf("http") === 0) {
                                window.location.href = url; //$window.open(url);

                                url = "dw.lobby";
                            }

                            lobbyUiService.go(url);
                        }                        
                    });

                }, function (error) {
                    errorService.handleError(error, $scope.init);
                });
            }
            else {
                $scope.initAccount().then(function () {

                    if (redirect) {
                        if (url && url.toLocaleLowerCase().indexOf("http") === 0) {
                            window.location.href = _data.url; // $window.open(url);
                            url = "dw.lobby";
                        }

                        lobbyUiService.go(url);
                    }

                });
            }
        }

        $scope.initAccount = function (isOtp) {

            var accountPromise = connection.getAccount();

            return accountPromise.then(function (response) {

                $scope.appData.CustomerInfo = response.CustomerInfo;

                if (isOtp) {
                    $scope.appData.BankAccounts = $scope.filterAccountByIsEffective(response.BankAccounts);
                } else {
                    $scope.appData.BankAccounts = response.BankAccounts;
                }

                if (!$scope.appData.BankAccounts || $scope.appData.BankAccounts.length == 0) {
                    errorService.handleError([
                        {
                            response: {
                                Response: {
                                    Status: {
                                        SeverityCode: 'E',
                                        SeverityNumber: '001'
                                    },
                                    DialogBox: {
                                        Content: 'לא ניתן לקבל מידע אודות הכרטיסים שברשותך. באפשרותך לפנות לאתר Cal-Online.',
                                        Title: '',
                                        OKButtonText: 'סגור'
                                    }
                                }
                            },
                            action: "noCards"
                        }
                    ], $scope.getAccount);

                    return;
                }

                $scope.appData.needRefreshAccount = false;

                lobbyUiService.loader.hide();

                $rootScope.$broadcast('accountLoggedIn', response);
            }, function (error) {
                errorService.handleError(error, $scope.getAccount);
            });
        }


        $scope.navigateFromPush = function () {
            if ($scope.appData.fromPush) {
                lobbyUiService.navigate($scope.appData.fromPush);
                $scope.appData.fromPush = null;
            }
        }

        $scope.$on('noConnection', function () {
            if ($scope.appData.noConnection == false) {
                var _promise = lobbyUiService.popup.noConnection();

                $scope.$on("$destroy", function () {
                    $timeout.cancel(_promise);
                });

                $scope.appData.noConnection = true;
            }
        });

        $scope.openExternal = function (url, action) {

            if (action) {
                switch (action) {
                    case 1: // password recovery
                        googleAnalyticsService.insertEvent({ page: 'Login', eventName: 'Password recovery', action: 'Click' });
                        break;
                    case 2: // joining
                        googleAnalyticsService.insertEvent({ page: 'Login', eventName: 'Joining cal-online', action: 'Click' });
                        break;
                    default:
                        break;
                }
            }

            lobbyUiService.openExternal(url);
        };

        $scope.reload = function () {
            $window.location.reload();
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .controller("connectCtrl", connectCtrl);

    connectCtrl.$inject = [
        '$scope', '$rootScope', 'lobbyUiService', 'connection', '$stateParams', 'errorService', 'googleAnalyticsService', '$timeout', '$state', 'appData', 'appSettings', 'backService',
        "$ionicHistory", "dataService", '$sce', 'lobbyDataService', 'tokenService', 'customerIndication','commService'];

    function connectCtrl($scope, $rootScope, lobbyUiService, connection, $stateParams, errorService, googleAnalyticsService, $timeout, $state, appData, appSettings, backService,
        $ionicHistory, dataService, $sce, lobbyDataService, tokenService, customerIndication,commService) {

        //if (connection.isLoggedIn()) {
        //    console.log("Not Logged In ConnectCtrl Rr");
        //    commService.backToHomePage();
        //    //lobbyUiService.go('dw.lobby');
        //}


        //get user details from token
        var isOtpData = lobbyUiService.getParams('isOtpData');
        var otpData = {};
        if (isOtpData) {
            otpData = tokenService.getData();
        }

        var loginType = !lobbyUiService.getParams('type') || lobbyUiService.getParams('type') > 2 ? 0 : lobbyUiService.getParams('type');

        var clientParams = {
            guid: appSettings.siteId,
            logo: true,
            modal: false,
            logintype: loginType,
            styletype: "1",
            title:"כניסה ללקוחות כאל",
            userId: otpData.idNumber,
            last4Digits: otpData.last4Digits
        }

        $scope.connectUrl = function () {
            return $sce.trustAsResourceUrl(appSettings.connect);
        };




        //reset account
        if (typeof ($scope.appData.token) === 'undefined' || $scope.appData.token === null) {
            $scope.appData.BankAccounts = {};
            $scope.appData.selectedBankAccountIndex = 0;
            $scope.appData.shownCardIndex = 0;

            if ($scope.appData.myAccount)
                $scope.appData.myAccount.status = 0;
            $scope.appData.token = null;
        }


        var command = lobbyUiService.getParams('command') || '';
        //handle chat
        if (command === 'open-chat') {
            window.loginChatWindow = lobbyUiService.openExternal('', '', true);
        }


        //handle session
        if (appData.sessionTimeout)
            $timeout.cancel(appData.sessionTimeout);

        if (appData.metaData) {
            var tOut = appData.metaData.SessionTimeout * 1000;
            appData.sessionTimeout = $timeout(function () {
                errorService.handleError(sessionErrorObject);
            }, tOut, false);
        }

        function handleLogin(result) {

            var token = result.token;
            var loginType = 0;
            if (typeof result.innerLoginType !== 'undefined') {
                loginType = result.innerLoginType;
            } else {
                loginType = result.loginType;
            }

            var loginTypeDescription = '';
            var loginEnum = { userName: 0, otp: 1 }
            if (loginType == loginEnum.userName)
                loginTypeDescription = 'userName';
            else
                loginTypeDescription = 'otp';
            var loginTypeObject = { description: loginTypeDescription, value: loginType };
            $ionicHistory.clearCache();
            dataService.sessionManager.save('loginType', loginTypeObject);
            dataService.sessionManager.save('authToken', token);
            dataService.sessionManager.save('siteId', appSettings.siteId);
            $scope.appData.token = token;
            //$stateParams.type = $stateParams.nextPage == "dw.margarita" ? "" : $stateParams.type; // maybe: $stateParams.type = $stateParams.type == "2" ? "" : $stateParams.type;
            $stateParams.type = $stateParams.type == "2" ? "" : $stateParams.type;
            connection.setToken(token);

            if (!$scope.appData.metaData) {
                // cal4u                
                connection.getMetaData().then(function (response) {
                    $scope.appData.metaData = response;
                    initCallCenter();
                }, function (error) {
                    errorService.handleError(error, $scope.init);
                });
            } else {
                initCallCenter();
            }





            var accountPromise = connection.getAccount();
            accountPromise.then(function (response) {
                $scope.appData.CustomerInfo = response.CustomerInfo;
                $scope.appData.BankAccounts = filterEffectiveCards(response.BankAccounts);
                if (!$scope.appData.BankAccounts || $scope.appData.BankAccounts.length == 0) {
                    errorService.handleError([
                        {
                            response: {
                                Response: {
                                    Status: {
                                        SeverityCode: 'E',
                                        SeverityNumber: '001'
                                    },
                                    DialogBox: {
                                        Content: 'לא ניתן לקבל מידע אודות הכרטיסים שברשותך. באפשרותך לפנות לאתר Cal-Online.',
                                        Title: '',
                                        OKButtonText: 'סגור'
                                    }
                                }
                            },
                            action: "noCards"
                        }
                    ], $scope.getAccount);

                    dataService.sessionManager.save('appData', $scope.appData);
                    return;
                }

                dataService.sessionManager.save('appData', $scope.appData);
                $scope.appData.needRefreshAccount = false;
                $scope.routeParams = {};
                $scope.routeParams.nextPage = lobbyUiService.getParams('nextPage') || 'dw.myaccount';
                $scope.routeParams.command = lobbyUiService.getParams('command') || '';
                $scope.routeParams.type = lobbyUiService.getParams('type') || '1';
                $scope.routeParams.sso = lobbyUiService.getParams('sso') || false;
                $scope.routeParams.query = $stateParams.query;


                $rootScope.$broadcast('accountLoggedIn', response);

                /*check if user has debt. if not, check if user needs to refresh details
                if (!appData.CustomerInfo.isCustDebt)*/
                //if ($scope.routeParams.nextPage != "dw.openBanking") {
                //    customerIndication.getIndicationForCustomer();
                //}


                lobbyUiService.navigate($scope.routeParams.nextPage,
                    { type: $scope.routeParams.type, sso: $scope.routeParams.sso, command: $scope.routeParams.command, location: 'replace', query: $scope.routeParams.query },
                    { location: 'replace' });

            }, function (error) {
                    if (error[0].response.Response.Status.SeverityCode.toLocaleLowerCase() == 'w' && error[0].response.Response.Status.SeverityNumber == '003') {
                        ga('set', 'page', '/vp/connect/step2/account-login-unavailable');
                        ga('send', 'pageview');
                    }

                    errorService.handleError(error, $scope.handleLogin);
            });



        }
        function filterEffectiveCards(accounts) {
            var copyAccounts = angular.copy(accounts);

            var filterAccounts = [];

            _.each(copyAccounts, function (account) {
                var filterCards = _.filter(account.Cards, function (card) {
                    return card.IsEffectiveInd == true;
                });

                if (filterCards.length > 0) {
                    account.Cards = filterCards;
                    filterAccounts.push(account);
                }
            });

            return filterAccounts;
        }
        function initCallCenter() {
            lobbyDataService.getCallCenters().then(function (callCenter) {
                $scope.callCentersPhoneNumber = callCenter[0].phoneNumber[0].number;
            });
        }


        var messageHandler = function (e) {
            console.info('child said:', e.data);
            var messageData = e.data;
            if (typeof e.data === 'string' && (/^[\],:{}\s]*$/.test(e.data.replace(/\\["\\\/bfnrtu]/g, '@')
                .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
                .replace(/(?:^|:|,)(?:\s*\[)+/g, ''))))
                messageData = JSON.parse(e.data)

            var connectWindow = angular.element('#connectIframe')[0];

            switch (messageData.operation) {
                case 'connectReady':
                    //clear appData obj before login 
                    var hidenavbar = dataService.sessionManager.read('hidenavbar');
                    dataService.sessionManager.clear();
                    dataService.sessionManager.save('hidenavbar', hidenavbar);
                    connectWindow.contentWindow.postMessage({ operation: 'params', params: clientParams }, '*');
                    break;
                case 'token': //get access token to cal rest                   
                    handleLogin(messageData);
                    break;
                case 'close':
                    console.log("ConnectCtrl Err Cancel Login dw.lobby")
                    commService.backToHomePage();
                   // lobbyUiService.go('dw.lobby');
                    break;
            }
        }

        window.addEventListener("message", messageHandler);


        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            var from = fromState.name;
            if (from === 'dw.login') {
                window.removeEventListener("message", messageHandler);
            }
        });


    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
    .controller("lobbyCtrl", lobbyCtrl);

    lobbyCtrl.$inject = [
        '$scope', '$rootScope', 'lobbyUiService', 'appData', '$stateParams', '$state'
    ];

    function lobbyCtrl($scope, $rootScope, lobbyUiService, appData, $stateParams, $state) {
        lobbyUiService.loader.hide();
        $scope.appData = appData;
        $scope.appData.isHideNavicon = false;
        
        $rootScope.params = $stateParams.path;

        $scope.$on('$ionicView.beforeEnter', function (e, viewData) {
            viewData.enableBack = true;
        });
        $scope.bannersShowPager = true;
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
           .controller('loginController', loginController);

    loginController.$inject = [
        '$scope', '$rootScope', 'connection', 'appData', 'lobbyUiService', 'errorService', '$timeout', 'googleAnalyticsService',
        '_', '$ionicScrollDelegate', 'lobbyDataService', 'register357Service', 'SmsService',
        /* touch: dep */ 'EncryptionService', 'isTouchIDAvailable', 'touchKeyStore', 'dataService', '$stateParams', 'tokenService', 'kycRefreshCustomerService'
    ];

    function loginController($scope, $rootScope, connection, appData, lobbyUiService, errorService, $timeout, googleAnalyticsService,
        _, $ionicScrollDelegate, lobbyDataService, register357Service, SmsService, /* touch: dep */EncryptionService, isTouchIDAvailable, touchKeyStore, dataService, $stateParams, tokenService, kycRefreshCustomerService) {

        $scope.appData = appData;

        var fromVouchers = $stateParams.nextPage.indexOf('vouchers') > -1;
        if (fromVouchers)
            googleAnalyticsService.trackPage('/vp/digital-voucher/otp/popup-screen/');

        var isOtpData = lobbyUiService.getParams('isOtpData');
        var otpData = {};
        if (isOtpData) {
            otpData = tokenService.getData();
        }

        $scope.loginDetails = {
            user: '',
            pass: '',
            otpPass: '',
            /* touch: */
            touchFlag: false,
            uuid: ''
        };

        $scope.routeParams = {};

        $scope.callCenters = [];

        $scope.CustomerInfo = {
            idNum: otpData.idNumber || '',
            last4Digits: otpData.last4Digits || ''
        };

        if ($scope.CustomerInfo.idNum && $scope.CustomerInfo.last4Digits) {
            $timeout(function () {
                $scope.sendOtp();
            });
        }

        $scope.forms = {

        }

        $scope.slider = {
            animate: false,
            sliderTransitionEnd: false,
            notFinish: false,
            expanded: false
        }

        $scope.initCallCenter = function () {

            lobbyDataService.getCallCenters().then(function (callCenter) {
                $scope.callCentersPhoneNumber = callCenter[0].phoneNumber[0].number;
            });
        };

        $scope.init = function () {
            
            $timeout(function () {
                $ionicScrollDelegate.$getByHandle('loginScroll').scrollTop();
            }, 0);

            googleAnalyticsService.insertEvent({ page: 'login', id: 1 });

            if (!$scope.appData.metaData) {
                // cal4u
                
                connection.getMetaData().then(function (response) {

                    $scope.appData.metaData = response;

                    $scope.initCallCenter();

                }, function (error) {
                    errorService.handleError(error, $scope.init);
                });
            } else {
                $scope.initCallCenter();
            }

            $scope.stage = 0;
            
            $scope.resetLogin();
            
            $scope.animate = true;

            $scope.title = 'התחברות';
            
            /* touch: if (typeof($scope.appData.token) === 'undefined' || $scope.appData.token === null) {*/
            if (typeof ($scope.appData.token) === 'undefined' || $scope.appData.token === null) {
                $scope.appData.BankAccounts = {};
                $scope.appData.selectedBankAccountIndex = 0;
                $scope.appData.shownCardIndex = 0;

                if ($scope.appData.myAccount)
                    $scope.appData.myAccount.status = 0;
                $scope.appData.token = null;
            }
            $scope.appData.showSpinner = false;

            lobbyUiService.loader.hide();
        };

        $scope.isTouchIDSupported = false;
        //isTouchIDAvailable.isAvailable().then(
        //function () {
        //    $scope.isTouchIDSupported = true;
        //},
        //function (error) {
        //    $scope.isTouchIDSupported = false;
        //    console.log(error);
        //});


        $scope.routeTouchChecked = lobbyUiService.getParams('takanonTouch') || false;
        $scope.isTouchIDChecked = Boolean($scope.routeTouchChecked) == true ? true : EncryptionService.getTouchTakanon();
        $scope.isTouchReq = EncryptionService.getIsTouchReq();
        $scope.restrictedArea = false;
        $scope.restrictedArea = lobbyUiService.getParams('restricted') || false;
        $scope.touchNotLogin = false;
        if (EncryptionService.getTouchLogin()) {
            $scope.touchNotLogin = true;
        }

        $scope.showTouchResBtn = function () {
            if ($scope.isTouchIDSupported) {
                if ($scope.isTouchReq) {
                    return false;
                } else if ($scope.isTouchIDChecked) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }

        // invoke the touch popup
        if ($scope.isTouchReq && !$scope.restrictedArea) {
            touchKeyStore.getKey().then(
                function (result) {
                    $scope.touchGuid = result;
                    $scope.isTouchReq = true;
                    EncryptionService.setIsTouchReq(true);

                    lobbyUiService.loader.show();
                    var promise = connection.postTouchLogin($scope.touchGuid);
                    promise.then(function (response) {

                        if (response.Response.Status.SeverityCode == "I" && response.Response.Status.SeverityNumber == "001") {
                            lobbyUiService.loader.hide();
                            lobbyUiService.popup.expertionTouchTime(response.Response.Status.Message);
                        }
                        else {

                            $scope.appData.token = response.AuthenticationToken;
                            connection.token = response.AuthenticationToken;
                            dataService.sessionManager.save('authToken', connection.token);

                            var isNotRegistered357 = register357Service.isNotRegistered357(response.Response);
                            //set keyChain
                            touchKeyStore.setKey(EncryptionService.setHash(response.TouchGuid));
                            EncryptionService.setTouchLogin(true);

                            $scope.getAccount(response.Response.Custom == "otp", isNotRegistered357);
                        }

                    }, function (error) {
                        lobbyUiService.loader.hide();
                        errorService.handleError(error, $scope.init);
                    });
                },
                function (result) {
                    console.log(result);
                });
        }

        var showTouchReqOk = function () {

            $('body').append('<div id="touchOverlay" class="touch-vilon-wrapper">' +
               '<div class="touch-vilon-contant">' +
                    '<div class="touch-vilon-image"></div>' +
                    '<h3 class="touch-takanon-txt">הצטרפותך לשירות</h3>' +
                    '<h3 class="touch-takanon-txt">כניסה באמצעות טביעת אצבע</h3>' +
                    '<h3 class="touch-vilon-success-text">אושרה בהצלחה</h3>' +
                '</div>' +
            '</div>');

            setTimeout(function () {
                $('#touchOverlay').remove();
            }, 3000);
        }

        /** Touch Id functionality end **/

        $scope.goButtonPressed = function () {
            $scope.login();
        };

        $scope.login = function () {
            
            /* touch: isTouchIDChecked*/
            if ($scope.isTouchIDChecked) {
                $scope.loginDetails.touchFlag = true;
                $scope.loginDetails.uuid = EncryptionService.getUuid();
            } else {
                $scope.loginDetails.touchFlag = false;
            }

            /* touch: end isTouchIDChecked*/

            var command = lobbyUiService.getParams('command') || '';
            if (command === 'open-chat') {
                window.loginChatWindow = lobbyUiService.openExternal('', '', true);
            }

            var promise = connection.login($scope.loginDetails);

            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();

            promise.then(function (response) {
                $scope.appData.token = response.AuthenticationToken;

                /* touch: call EncryptionService*/
                EncryptionService.setTouchLogin(false);
                if (response.TouchGuid != '') {
                    showTouchReqOk();
                    //notify callVU
                    //set keyChain
                    touchKeyStore.setKey(EncryptionService.setHash(response.TouchGuid));
                    EncryptionService.setIsTouchReq(true);
                }

                /* touch: call EncryptionService*/

                //if come from ivr and touchFlag=true and login succeed than notify callvu

                var isNotRegistered357 = register357Service.isNotRegistered357(response.Response);

                $scope.getAccount(false, isNotRegistered357);

            }, function (error) {
                window.loginChatWindow && window.loginChatWindow.close();
                lobbyUiService.loader.hide();
                errorService.handleError(error, $scope.login);
            });
        };

        $scope.getAccount = function (isOtp, isNotRegistered357) {
            var accountPromise = connection.getAccount();
            accountPromise.then(function (response) {

                $scope.appData.CustomerInfo = response.CustomerInfo;

                $scope.appData.BankAccounts = $scope.filterAccountByIsEffective(response.BankAccounts);
               

                if (!$scope.appData.BankAccounts || $scope.appData.BankAccounts.length == 0) {
                    errorService.handleError([
                        {
                            response: {
                                Response: {
                                    Status: {
                                        SeverityCode: 'E',
                                        SeverityNumber: '001'
                                    },
                                    DialogBox: {
                                        Content: 'לא ניתן לקבל מידע אודות הכרטיסים שברשותך. באפשרותך לפנות לאתר Cal-Online.',
                                        Title: '',
                                        OKButtonText: 'סגור'
                                    }
                                }
                            },
                            action: "noCards"
                        }
                    ], $scope.getAccount);

                    dataService.sessionManager.save('appData', $scope.appData);
                    return;
                }

                dataService.sessionManager.save('appData', $scope.appData);

                $scope.appData.needRefreshAccount = false;

                $scope.routeParams.nextPage = lobbyUiService.getParams('nextPage') || 'dw.myaccount';
                $scope.routeParams.command = lobbyUiService.getParams('command') || '';
                
                $scope.routeParams.type = lobbyUiService.getParams('type') || '1';

                $scope.routeParams.sso = lobbyUiService.getParams('sso') || false;

                $scope.routeParams.query = $stateParams.query;

                lobbyUiService.loader.hide();

                $rootScope.$broadcast('accountLoggedIn', response);

                var query = $scope.routeParams.query;
                try {
                    query = JSON.parse($scope.routeParams.query);
                }
                catch(e) {}

                var nextpageParams = angular.extend({
                    location: 'replace'
                }, query);

                if (isNotRegistered357) {
                    register357Service.setOtp(isOtp);

                    lobbyUiService.navigate('dw.register357', { nextPage: $scope.routeParams.nextPage, type: $scope.routeParams.type, sso: $scope.routeParams.sso, command: $scope.routeParams.command, location: 'replace', query: $scope.routeParams.query },
                        {
                            location: 'replace'
                        });

                    return;
                } else {
                    lobbyUiService.navigate($scope.routeParams.nextPage, { type: $scope.routeParams.type, sso: $scope.routeParams.sso, command: $scope.routeParams.command, location: 'replace', query: $scope.routeParams.query },
                        query);
                    //debtInfoService.getCustDebtInfo($scope);
                    kycRefreshCustomerService.refreshCustomerDetails($scope);
                    return;
                }                

            }, function (error) {

                errorService.handleError(error, $scope.getAccount);
            });

        }

        $scope.toggleTitle = 'לכניסה באמצעות שם משתמש';

        $scope.toggleLogin = function () {
            
            if ($scope.slider.notFinish)
                return;

            var tempStage;

            $scope.slider.notFinish = true;

            if ($scope.slider.expanded) {
                //console.log('OTP');
                $scope.title = 'התחבר';
                tempStage = 0;
                googleAnalyticsService.insertEvent({ page: 'login', id: 2 });
                $scope.toggleTitle = 'לכניסה באמצעות שם משתמש';

            } else {
                $scope.title = 'התחבר';
                tempStage = 1;
                //console.log('login');
                googleAnalyticsService.insertEvent({ page: 'login', id: 1 });
                $scope.toggleTitle = 'לכניסה באמצעות ת.ז';
            }
            $timeout(function () {
                $scope.slider.expanded = !$scope.slider.expanded;
                $scope.stage = tempStage;
            }, 0);
        }

        $scope.filterAccountByIsEffective = function (accounts) {
            var copyAccounts = angular.copy(accounts);

            var filterAccounts = [];

            _.each(copyAccounts, function (account) {
                var filterCards = _.filter(account.Cards, function (card) {
                    return card.IsEffectiveInd == true;
                });

                if (filterCards.length > 0) {
                    account.Cards = filterCards;
                    filterAccounts.push(account);
                }
            });

            return filterAccounts;
        }

        $scope.resetLogin = function () {
            $scope.title = 'התחברות';
            $timeout(function () {
                $scope.$apply(function () {
                    //var obj1 = $('.slideable');
                    //obj1[0].style.position = 'fixed';
                    var obj2 = $('#otp0');
                    obj2[0].style.display = 'block';
                    $scope.stage = 0;
                });
            }, 500);

        }

        $scope.logCall = function () {
            googleAnalyticsService.insertEvent({ page: 'login', id: 5 });
        }

        $scope.sendOtp = function () {
            if (fromVouchers) {
                googleAnalyticsService.trackPage('/vp/digital-voucher/otp/form-submit/');
            }
            if (!$scope.validateOtp()) return;
            googleAnalyticsService.insertEvent({ page: 'login', id: 3 });

            if (ionic.Platform.isAndroid()) {
                SmsService.getOtpPassword().then(function (code) {
                    $timeout(function () {
                        if (code && code[0])
                            $scope.loginDetails.otpPass = code[0];
                    }, 0);

                }, function (data) {
                    //console.log(data);
                });
            }

            $scope.stage = 0;
            var promise = connection.postCalWalletSendOTP($scope.CustomerInfo.idNum, $scope.CustomerInfo.last4Digits);
            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();

            promise.then(function (response) {

                $scope.tempToken = response.Token;
                $scope.phoneNumber = response.PhoneNumber;
                $scope.stage = 2;
                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
                
                if (response.OTP) {
                    $scope.loginDetails.otpPass = response.OTP;
                    $scope.verifyOtp();
                }
                else {
                    $scope.loginDetails.otpPass = '';
                }

                $timeout(function () {
                    $ionicScrollDelegate.$getByHandle('loginScroll').scrollTop();
                }, 0);

            }, function (error) {
                errorService.handleError(error, $scope.sendOtp);
            });
        };

        $scope.verifyOtp = function () {
            if (fromVouchers) {
                googleAnalyticsService.trackPage('/vp/digital-voucher/otp/code-entered/');
            }

            if ($scope.loginDetails.otpPass.toString().length == 0) {
                $scope.alert('יש למלא סיסמה', 'אישור');
                return;
            }

            if ($scope.loginDetails.otpPass.toString().length < 6) {
                $scope.alert('הסיסמה שהוזנה אינה תקינה', 'אישור');
                return;
            }

            googleAnalyticsService.insertEvent({ page: 'login', id: 4 });

            /* touch: EncryptionService.getUuid */
            $scope.loginDetails.uuid = EncryptionService.getUuid();
            /* touch: end EncryptionService.getUuid */

            var command = lobbyUiService.getParams('command') || '';
            if (command === 'open-chat') {
                window.loginChatWindow = lobbyUiService.openExternal('', '', true);
            }

            var promise = connection.postCalWalletVerifyOTP($scope.tempToken, $scope.loginDetails.otpPass, $scope.isTouchIDChecked, $scope.loginDetails.uuid);
            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();
            promise.then(function (response) {

                $scope.appData.token = response.AuthenticationToken;
                connection.token = response.AuthenticationToken;
                errorService.token = response.AuthenticationToken;
                dataService.sessionManager.save('authToken', connection.token);

                /* touch: setTouchLogin */

                EncryptionService.setTouchLogin(false);
                if (response.TouchGuid != '') {
                    showTouchReqOk();
                    //set keyChain
                    touchKeyStore.setKey(EncryptionService.setHash(response.TouchGuid));
                    EncryptionService.setIsTouchReq(true);
                }
                /* touch: end setTouchLogin */

                $scope.nextPage = lobbyUiService.getParams('nextPage');
                $scope.command = lobbyUiService.getParams('command');
                if (!$scope.nextPage)
                    $scope.nextPage = 'dw.lobby';

                var isNotRegistered357 = register357Service.isNotRegistered357(response.Response);

                $scope.getAccount(true, isNotRegistered357);

            }, function (error) {
                errorService.handleError(error, $scope.verifyOtp);
                window.loginChatWindow && window.loginChatWindow.close();
            });
        };

        $scope.validateOtp = function () {
            //padding for phone number
            var errMsg = '';
            if (!$scope.CustomerInfo) {
                errMsg = 'יש למלא ת.ז.';
            } else {
                var id = $scope.CustomerInfo.idNum;
                //padding for id
                if (id && id.length > 4) {
                    var padding = '';
                    for (var i = 9 - id.length; i > 0; i--) {
                        padding += '0';
                    }
                    id = padding + id;
                }

                if ($scope.forms.otpForm.$valid) {
                    if ($scope.CustomerInfo.last4Digits.length > 3) {
                        if ($scope.validateId(id)) {
                            $scope.CustomerInfo.idNum = id;
                            return true;
                        } else {
                            errMsg = 'מספר ת.ז. שהוזן אינו תקין.';
                        }
                    } else if (!$scope.validateId(id)) {
                        errMsg = 'אחד מהנתונים שהוזנו אינו תקין';
                    } else {
                        errMsg = '4 ספרות אחרונות של כרטיס אשראי אינן תקינות.';
                    }
                } else { //if the form is not valid
                    if ($scope.forms.otpForm.$error.required.length > 1) {
                        errMsg = 'יש למלא ת.ז.';
                    } else if ($('#idNum').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ת.ז.';
                    else if ($('#4Digits').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא 4 ספרות אחרונות של כרטיס אשראי.';
                    else if ($('#idNum').val().length < 5) {
                        errMsg = 'יש למלא מספר ת.ז. בן 9 ספרות.';
                        if ($('#4Digits').val().length < 4 || !$scope.validateId(id)) {
                            errMsg = 'אחד מהנתונים שהוזנו אינו תקין';
                        }
                    } else if ($('#4Digits').val().length < 4) {
                        errMsg = '4 ספרות אחרונות של כרטיס אשראי אינן תקינות.';
                        if (!$scope.validateId(id)) {
                            errMsg = 'אחד מהנתונים שהוזנו אינו תקין';
                        }
                    } else if (!$scope.validateId(id)) {
                        errMsg = 'מספר ת.ז. שהוזן אינו תקין.';
                    }
                }
            }

            $scope.alert(errMsg, 'סגור');

            return false;
        };

        $scope.alert = function (errMsg, btnTxt) {
            if (navigator.notification)
                navigator.notification.alert(
                    errMsg,
                    function () {
                        /*Do Nothing*/
                    },
                    ' ',
                    btnTxt
                );
            else {
                lobbyUiService.popup.alert(errMsg, 'נא לשים לב');
            }
        }

        $scope.validateId = function (id) {
            var idnum = id;

            var idnum1 = idnum.substr(0, 1) * 1;
            var idnum2 = idnum.substr(1, 1) * 2;
            var idnum3 = idnum.substr(2, 1) * 1;
            var idnum4 = idnum.substr(3, 1) * 2;
            var idnum5 = idnum.substr(4, 1) * 1;
            var idnum6 = idnum.substr(5, 1) * 2;
            var idnum7 = idnum.substr(6, 1) * 1;
            var idnum8 = idnum.substr(7, 1) * 2;
            var idnum9 = idnum.substr(8, 1) * 1;

            if (idnum1 > 9)
                idnum1 = (idnum1 % 10) + 1;
            if (idnum2 > 9)
                idnum2 = (idnum2 % 10) + 1;
            if (idnum3 > 9)
                idnum3 = (idnum3 % 10) + 1;
            if (idnum4 > 9)
                idnum4 = (idnum4 % 10) + 1;
            if (idnum5 > 9)
                idnum5 = (idnum5 % 10) + 1;
            if (idnum6 > 9)
                idnum6 = (idnum6 % 10) + 1;
            if (idnum7 > 9)
                idnum7 = (idnum7 % 10) + 1;
            if (idnum8 > 9)
                idnum8 = (idnum8 % 10) + 1;
            if (idnum9 > 9)
                idnum9 = (idnum9 % 10) + 1;

            var sumval = idnum1 + idnum2 + idnum3 + idnum4 + idnum5 + idnum6 + idnum7 + idnum8 + idnum9;

            sumval = sumval % 10;
            if (sumval > 0) {
                return false;
            }

            return true;
        };

        $scope.analytics4NonCustomer = function(){ 
            googleAnalyticsService.trackPage('/vp/click/not-cal-customer');
        }

        //add blue bg after slider is up
        //console.log('on transitionend');

        $scope.init();
    }

})(window, window.angular);
﻿(function(window, angular) {
    'use strict';
    angular.module('digitalWallet')
    .controller('register357Controller', register357Controller);

    register357Controller.$inject = [
        '$scope', '$rootScope', 'connection', 'appData', '$sce', 'lobbyUiService', 'register357Service', '$ionicScrollDelegate', '$state',
        '$timeout', '$ionicSideMenuDelegate', '$ionicNavBarDelegate', 'lobbyStorageService', 'errorService'
    ];

    function register357Controller($scope, $rootScope, connection, appData, $sce, lobbyUiService, register357Service, $ionicScrollDelegate, $state, $timeout, $ionicSideMenuDelegate, $ionicNavBarDelegate, lobbyStorageService, errorService) {
        var internetChannelIndex = 3;
        var cellularChannelIndex = 2;
        var successMessage = 'תודה שהגדרת את ערוצי המידע והתקשורת שלך עכשיו תוכל לעשות מה שטוב בשבילך בכל הערוצים המקוונים של חברת Cal';

        $scope.appData = appData;
        $scope.appData.isLoggedIn = connection.isLoggedIn();
        $scope.appData.isHideNavicon = $state.current.data.isHideNavicon;

        if (!$scope.appData.isLoggedIn) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.bankCharges' }, { location: 'replace' });
            return;
        } else if (register357Service.is357Done()) {
            lobbyUiService.go('dw.lobby');
            return;
        }

        $ionicSideMenuDelegate.canDragContent(false);

        $timeout(function () {
            $scope.appData.backOverrideFN = $scope.goBackAndKillSession;
        }, 100);

        $scope.title = "הגדרות ערוצי השירות והמידע";

        $scope.register357Form = new Object();
        $scope.register357Form.isShowList = true;
        $scope.register357Form.agreeToTerms = true;
        $scope.register357Form.switchButton = { isChecked: true };
        $scope.register357Form.channels = register357Service.getInitData();

        $scope.setSelectedItem = function (item, index) {
            $scope.register357Form.channels[index].selected.channelId = index + 1;
            $scope.register357Form.channels[index].selected.levelId = item.id;
        };

        $scope.register357Form.update = function () {
            if (isDataValid()) {
                if ($scope.register357Form.agreeToTerms) {
                    lobbyUiService.loader.show();

                    register357Service.update($scope.register357Form.channels).then(function (data) {
                        lobbyUiService.loader.hide();

                        if (data.Response.Status.SeverityCode == 'W' && data.Response.Status.SeverityNumber == '003') {
                            register357Service.getMessage('יש לבצע הזדהות על מנת לבצע פעולה זו.', function () {
                                lobbyUiService.go('dw.login', { nextPage: 'register357' });
                                return;
                            });
                        } else if (data.Response.Status.SeverityCode != 'S') {
                            register357Service.getMessage('לא ניתן לבצע את הפעולה אנא נסה שוב במועד מאוחר יותר.', function () {
                                lobbyUiService.go('dw.login', { nextPage: 'register357' });
                                return;
                            });
                        } else {

                            register357Service.getMessage(successMessage, function () {

                                var nextPage = lobbyUiService.getParams('nextPage');

                                var type = lobbyUiService.getParams('type') != '' ? lobbyUiService.getParams('type') : '1';

                                var sso = lobbyUiService.getParams('sso');

                                var command = lobbyUiService.getParams('command') || '';

                                register357Service.set357Done();
                                $scope.appData.isHideNavicon = false;
                                $scope.appData.backOverrideFN = null;

                                $ionicSideMenuDelegate.canDragContent(true);

                                lobbyUiService.navigate(nextPage, { type: type, sso: sso, command: command }, { location: 'replace' });
                            });
                        }

                    }, function (error) {
                        lobbyUiService.loader.hide();

                        errorService.handleError(error);
                        //register357Service.getMessage('שגיאת מערכת');
                    });
                } else {
                    lobbyUiService.popup.alert('יש לאשר תנאים משפטיים');
                }
            }
        };

        var isDataValid = function () {
            var isOtp = register357Service.getIsOtp();

            if (isOtp && !register357Service.isInternetAndCellularChecked($scope.register357Form.channels,
                internetChannelIndex,
                cellularChannelIndex)) {
                register357Service.getMessage('יש לאשר ביצוע פעולות וקבלת מידע בערוצים אינטרנט וסלולר בכדי ליהנות משירות זה.', function () {
                    $scope.register357Form.channels[internetChannelIndex].selected.levelId = 3;
                    $scope.register357Form.channels[cellularChannelIndex].selected.levelId = 3;
                });

                // remove after modal test
                $scope.register357Form.channels[internetChannelIndex].selected.levelId = 3;
                $scope.register357Form.channels[cellularChannelIndex].selected.levelId = 3;

                return false;
            } else if (!isOtp && !register357Service.isInternetChecked($scope.register357Form.channels, internetChannelIndex)) {
                register357Service.getMessage('יש לאשר ביצוע פעולות וקבלת מידע בערוץ אינטרנט בכדי ליהנות משירות זה.', function () {
                    $scope.register357Form.channels[internetChannelIndex].selected.levelId = 3;
                });

                // remove after modal test
                $scope.register357Form.channels[internetChannelIndex].selected.levelId = 3;
                return false;
            }

            return true;
        };

        $scope.register357Form.doc = {
            url: 'CalDocs?id=Register357.html'
        }

        $scope.register357Form.goToInfo = function () {
            $scope.title = 'תקנון התכנית';
            $scope.register357Form.showTerms = true;
            $scope.appData.backOverrideFN = $scope.goBack;
        };

        $scope.goBack = function () {
            if ($scope.register357Form.showTerms) {
                $scope.title = 'הגדרות ערוצי השירות והמידע';
                $scope.register357Form.showTerms = false;

                $timeout(function () {
                    $scope.appData.backOverrideFN = $scope.goBackAndKillSession;
                }, 100);
            }

            return;
        }

        $scope.goBackAndKillSession = function () {
            //console.log('$scope.goBackAndKillSession');

            lobbyStorageService.clearAppData();
            connection.logout($scope.appData.token);

            $ionicSideMenuDelegate.canDragContent(true);
            $scope.appData.isHideNavicon = false;
            lobbyUiService.go('dw.login', { nextPage: 'register357' });

            $scope.appData.backOverrideFN = null;

            return;
        };

        $scope.$on("$destroy", function () {
            $scope.appData.backOverrideFN = null;
            $scope.appData.isHideNavicon = false;
            $ionicSideMenuDelegate.canDragContent(true);
        });

        $ionicScrollDelegate.$getByHandle('reg357Scroll').scrollTop();
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
    .controller("serviceCtrl", serviceCtrl);

    serviceCtrl.$inject = [
        '$scope', '$rootScope', 'lobbyDataService'
    ];

    function serviceCtrl($scope, $rootScope, lobbyDataService) {
        $scope.callCenters = [];

        lobbyDataService.getCallCenters().then(function (callCenter) {
            $scope.callCenters = callCenter;
        });
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    
    /* touch: touchTaknonCtrl*/
    angular.module("digitalWallet")
        .controller("touchTaknonCtrl", touchTaknonCtrl);

    touchTaknonCtrl.$inject = ['$scope', '$state', 'EncryptionService', 'lobbyUiService'];

    function touchTaknonCtrl($scope, $state, EncryptionService, lobbyUiService) {

        $scope.ckTouchAgree1 = false;
        $scope.ckTouchAgree2 = false;

        $scope.move2login = function () {
            // EncryptionService.setTouchTakanon(true);
            lobbyUiService.navigate("dw.login", { location: 'replace' }, { takanonTouch: true });
        }

    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("iframeOnload", iframeOnload);

    function iframeOnload() {
        return {
            restrict: 'A',
            scope: {                
                callback: '&iframeOnload',                
            },
            link: function (scope, element, attrs) {                
                element.on('load', function () {
                    return scope.callback();
                });
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
    .directive("customInput", customInput);

    function customInput() {
        return {
            restrict: "A",
            link: function (scope, element) {
                element.attr({ autocomplete: 'off', autocapitalize: 'off', spellcheck: 'false', autocorrect: 'off' });
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("dwAppBanners", dwAppBanners);

    dwAppBanners.$inject = [
        '$rootScope', '$timeout', '$ionicSlideBoxDelegate', '$ionicScrollDelegate', 'lobbyUiService', 'lobbyDataService',
        'lobbyStateService', 'appData'
    ];

    function dwAppBanners($rootScope, $timeout, $ionicSlideBoxDelegate, $ionicScrollDelegate, lobbyUiService, lobbyDataService,
                lobbyStateService, appData) {
        return {
            restrict: 'E',
            replace: true,
            controller: [
                '$scope', function ($scope) {
                    $scope.banners = [];
                    $scope.openExternalLink = function (url) {
                        lobbyUiService.openExternal(url);
                    }
                }
            ],
            templateUrl: 'app/main/templates/banners.html',
            link: function ($scope, element, attrs) {

                var initializeSlider = function (banners, shouldUpdate) {
                    var module = lobbyDataService.getModule();
                    if (!module)
                        return;

                    var moduleBanners = module.banners;


                    moduleBanners = moduleBanners.filter(function (item) { return banners.indexOf(item.image) != -1 });
                    $scope.banners = moduleBanners;
                    if ($scope.banners.length == 1) {
                        $scope.bannersShowPager = false;
                    }
                    else {
                        $scope.bannersShowPager = true;
                    }
                    $timeout(function () {
                        if (shouldUpdate) {
                            $ionicSlideBoxDelegate.$getByHandle('bannersHandler').update();
                        }
                        if (!appData.bannersLoaded) {
                            appData.bannersLoaded = true;
                            $rootScope.$broadcast('bannersLoaded');
                        }
                    }, 200);
                }

                lobbyDataService.loadMetaData().then(function () {

                    // try get all banners
                    var banners = lobbyUiService.bannersArchive.getAll();
                    if (!banners)
                        return;

                    if (banners.length == 0) {
                        banners = lobbyUiService.bannersArchive.create(lobbyDataService.modules()).getAll();
                        lobbyUiService.preloadImages(banners).then(function (data) {
                            banners = $.map(data, function (img) { return img.image; });
                            lobbyUiService.bannersArchive.fill(banners);
                            initializeSlider(banners, true);
                        });
                    }
                    else {
                        initializeSlider(banners, false);
                    }
                });
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
    .directive('dwHeaderLogo', dwHeaderLogo);

    dwHeaderLogo.$inject = ['$q', '$timeout', 'lobbyStateService'];

    function dwHeaderLogo($q, $timeout, lobbyStateService) {
        return {
            restrict: "EA",
            replace: true,
            controller: [
                '$scope', function ($scope) {
                    $scope.hasHistory = false;
                    $scope.$on('lobbyEvent::ContentReady', function () {
                        $timeout(function () {
                            $scope.hasHistory = !lobbyStateService.current.resolve().isLobbyView();
                        }, 100);
                    });

                    $scope.$on('lobbyEvent::StateChanged', function () {
                        $timeout(function () {
                            $scope.hasHistory = !lobbyStateService.current.resolve().isLobbyView();
                        }, 100);
                    });
                }
            ],
            template: '<div ng-if="!hasHistory" class="header-logo"><span id="cal-logo"></span><span id="diners-logo"></span><div>',
            link: function ($scope) {
                $timeout(function () {
                    $scope.hasHistory = !lobbyStateService.current.resolve().isLobbyView();
                }, 100);

            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
    .directive("dwHtmlContent", dwHtmlContent);

    dwHtmlContent.$inject = ['$http', 'lobbyUiService', 'lobbyDataService'];

    function dwHtmlContent($http, lobbyUiService, lobbyDataService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                source: '@'
            },
            controller: [
                '$scope', function ($scope) {
                    lobbyUiService.loader.show();
                    lobbyDataService.loadHtmlDocument($scope.source).then(
                        function (data) {
                            $scope.content = $.parseHTML(data);
                            lobbyUiService.loader.hide();
                        },
                        function () {
                            lobbyUiService.loader.hide();
                        }
                    );
                }
            ],
            template: '<div class="terms" ng-bind-html="content | trusted"></div>',
            link: function ($scope, element) {
                $scope.$watch('content', function (newvalue) {
                    lobbyUiService.loader.show();
                    if (newvalue) {
                        var current;
                        for (var i = 0; i < newvalue.length; i++) {
                            current = $(newvalue[i]).html();
                            if (current && current.length > 0) {
                                element.append($.trim($(newvalue[i]).html()));
                            }
                        }
                        setTimeout(function () {
                            element.addClass('active');
                            lobbyUiService.loader.hide();
                        }, 2000);
                    }
                });
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("dwMenuContent", dwMenuContent);

    dwMenuContent.$inject = ['$rootScope', '$ionicSideMenuDelegate', '$ionicPlatform', '$timeout', 'lobbyUiService', 'lobbyDataService', 'errorService'];

    function dwMenuContent($rootScope, $ionicSideMenuDelegate, $ionicPlatform, $timeout, lobbyUiService, lobbyDataService, errorService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/main/templates/slide-menu.html',
            controller: [
                '$scope', function ($scope) {
                    $scope.menuItems = [];
                }
            ],
            link: function ($scope, element, attrs) {
                var bind = function () {
                    $('a.item', element).on('click', function () {
                        $ionicSideMenuDelegate.toggleRight();
                    });
                }
                var initialize = function () {
                   var menuItems = lobbyUiService.clearDependencies(lobbyDataService.sideMenuItems());
                   $scope.menuItems = menuItems.map(function (parentItem) {
                       parentItem.items = _.filter(parentItem.items, function (_item) {
                           return !_item.hideType || _item.hideType != 2;
                       });

                       return parentItem;
                   });
                }

                $scope.$on('accountLoggedIn', function (source, accountData) {
                    $timeout(function () {
                        initialize();
                    }, 500);
                });

                $scope.$on('loggedOut', function (event, response) {
                    $timeout(function () {
                        initialize();
                    }, 550);
                });

                /* touch: */
                $scope.$on('logoutTouch', function (event, response) {
                    $timeout(function () {
                        initialize();
                    }, 550);
                });
                /* touch: */

                //$scope.$on('lobbyEvent::ContentReady', function(source, data) {
                //    initialize();
                //});

                //lobbyDataService.waitForMetaData().then(function() { initialize(); });

                lobbyDataService.loadMetaData().then(function () {
                    initialize();
                }, function (error) {
                    errorService.handleError(error);
                });

                $timeout(bind, 0);
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("dwMenuFooter", dwMenuFooter);

    dwMenuFooter.$inject = ['$timeout', 'lobbyDataService', 'lobbyUiService'];

    function dwMenuFooter($timeout, lobbyDataService, lobbyUiService) {
        return {
            restrict: 'E',
            replace: true,
            controller: [
                '$scope', function ($scope) {
                    $scope.footerData = {
                        version: null,
                        lastEntry: null
                    };
                }
            ],
            template: '<section class="nav-footer"><div><span ng-show="footerData.lastEntry">תאריך כניסה אחרון: {{footerData.lastEntry}}</span></div><div style="display:none;"><span>גרסה:</span> {{footerData.version}}</div></section>',
            link: function ($scope) {
                var initialize = function (accountData) {
                    $scope.footerData = {
                        version: lobbyDataService.getVersion()
                    };

                    if (accountData && lobbyUiService.connection.isLoggedIn()) {
                        $scope.footerData.lastEntry = accountData.CustomerInfo.LastEntryDate;
                    }
                }

                $scope.$on('accountLoggedIn', function (source, accountData) {
                    $timeout(function () {
                        initialize(accountData);
                    }, 550);
                });

                $scope.$on('loggedOut', function () {
                    $scope.footerData.lastEntry = null;
                });

                lobbyDataService.loadMetaData().then(function () {
                    initialize();
                });
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("dwModuleMenu", dwModuleMenu);

    dwModuleMenu.$inject = ['$q', '$timeout', 'lobbyUiService', 'lobbyDataService', 'lobbyStateService', '$window','commService'];

    function dwModuleMenu($q, $timeout, lobbyUiService, lobbyDataService, lobbyStateService, $window, commService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/main/templates/module-menu.html',
            controller: [
                '$scope', function ($scope) {
                    $scope.items = [];
                    $scope.filteredItems = [];
                    $scope.alignedMenuItems = "";
                    $scope.alignedMenuItemsContainer = "";
                    $scope.alignedMenusContainer = "";
                }
            ],
            link: function (scope, element) {

                var MAX_MODULES = 4; // num of items to fit without scroll

                //scope.setMenuHeight = function () {
                //    var navContent = $('ion-nav-view.content-body');

                //    var targetView = $('> ion-view.module-view:nth-child(2)', navContent);

                //    var navHeight = parseFloat(angular.element('ion-nav-bar.content-header').outerHeight());

                //    var deviceHeight = parseFloat(angular.element($window).height());

                //    if (targetView.length == 0) {
                //        // animation is done, there is only one instance
                //        targetView = $('> ion-view.module-view:first-child', navContent);
                //    }

                //    var content = targetView.find('ion-content').first();

                //    if (targetView.hasClass('content-view')) {
                //        // content is textual, set default height
                //        content.css('height', '45%');

                //        element.css('height', deviceHeight - content.height() - navHeight);
                //    } else {

                //        var deviceWidth = parseFloat(angular.element($window).width());

                //        var n = deviceHeight - navHeight - (deviceWidth * 0.625);

                //        element.css('height', n);
                //    }
                //}

                // create & attach menu elements to list 
                scope.initialize = function () {
                    var module = lobbyDataService.moduleMenuItems();
                    
                    if (module.parent) {
                        
                        element.attr('module', module.parent.index);
                        element.attr('lobby', lobbyStateService.current.resolve().isLobbyView());
                    }

                    $timeout(function () {
                        var newItems = lobbyUiService.clearDependencies(module.items);

                        if (scope.items.compare(newItems) == false) {

                            newItems = _.filter(newItems, function (_item) {
                                return !_item.hideType || _item.hideType != 1;
                            });
                            
                            //if display equals 2 display menus side by side
                            scope.items = newItems;                            
                            
                            var display = 0;

                            if (module != null)
                                display = module.display;                           
                            if (display == 2) {                            
                                scope.alignedMenuItems = "new-menu-display-item";
                                scope.alignedMenuItemsContainer = "new-menu-display";
                                console.log("aligned menus");
                                scope.alignedMenusContainer = "aligned-menus-container";
                            }
                            else {
                                console.log("regular menus");
                                scope.alignedMenuItems = "";
                                scope.alignedMenuItemsContainer = "";
                                scope.alignedMenusContainer = "";
                                commService.backToHomePage();
                            }

                            if (scope.items.length == MAX_MODULES) {
                                // fit exactly N items (without scrolling)
                                element.addClass('fit');
                            } else if (scope.items.length > MAX_MODULES) {
                                // overflow N items, with scroll
                                element.addClass('overflow');
                            }
                        };
                    }, 0);
                }

                lobbyDataService.loadMetaData().then(function () {
                    scope.initialize();
                   // scope.setMenuHeight();
                });
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
    .directive("dwSphereMenu", dwSphereMenu);

    dwSphereMenu.$inject = ['lobbyDataService', 'lobbyUiService', 'lobbyStateService', '$ionicSideMenuDelegate', 'googleAnalyticsService'];

    function dwSphereMenu(lobbyDataService, lobbyUiService, lobbyStateService, $ionicSideMenuDelegate, googleAnalyticsService) {
        return {
            restrict: 'E',
            replace: true,
            template: '<div />',
            link: function ($scope) {
                var autoBehavior = {
                    count: 0,
                    duration: 5000,
                    suspended: false,
                    tick: function () {
                        this.count += 1000;
                    },
                    timeout: function () {
                        return this.count > this.duration && this.suspended == false;
                    },
                    reset: function () {
                        this.suspended = false;
                        this.count = 0;
                    },
                    suspend: function () {
                        this.suspended = true;
                    }
                }

                var spheres = [], backdrop = null, menu = null;

                /***
                /* show/hide menu & backdrop
                /*************************************/
                var toggle = function () {
                    if ($('li:first-child', menu).position().top == 0) {
                        expand();
                    } else {
                        collapse();
                    }
                }

                var expand = function () {
                    autoBehavior.suspend();

                    // show the backdrop & attach click behavior
                    //backdrop.css({ 'bottom': '0', opacity: '.4' });
                    backdrop.addClass('pull-down-backdrop').removeClass('push-up-backdrop');
                    // wait a bit for backdrop animation to progress, then expand menu items
                    setTimeout(function () {
                        for (var i = 0; i < spheres.length - 1; i++) {
                            $(spheres[i]).css({ 'top': (menu.outerHeight() + 6) * (i + 1) * -1, 'opacity': 1 });
                        }
                    }, 100);
                }

                var collapse = function () {
                    // hide the side menu
                    if ($ionicSideMenuDelegate.isOpen()) {
                        $ionicSideMenuDelegate.toggleRight();
                    }
                    backdrop.addClass('push-up-backdrop').removeClass('pull-down-backdrop');
                    setTimeout(function () {
                        for (var i = 0; i < spheres.length - 1; i++) {
                            $(spheres[i]).css({ 'top': '0', 'opacity': '0' });
                        }
                    }, 10);

                    autoBehavior.reset();
                    autoHide();
                }

                var created = function () {
                    return !($('.sphere-menu', $('body')).length == 0 && $('.sphere-backdrop', $('body')).length == 0);
                }

                var hide = function () {
                    if (menu)
                        menu.switchClass('visible', 'hidden');
                }

                var show = function () {
                    if (menu)
                        menu.switchClass('hidden', 'visible');
                }

                var autoHide = function () {
                    autoBehavior.tick();
                    //console.log('auto hide :: count: ' + autoBehavior.count + ' :: timeout: ' + autoBehavior.timeout());
                    if (autoBehavior.timeout()) {
                        //console.log('auto hide timouet occured!');
                        autoBehavior.reset();
                        hide();
                    } else {
                        setTimeout(function () { autoHide(); }, 1000);
                    }
                }

                lobbyUiService.notify.verticalSwipe(function () {
                    //console.log('content has been vertically swiped!')
                    if (canShow()) {
                        show();
                        autoBehavior.reset();
                        autoHide();
                    }
                });

                var canShow = function () {
                    var state = lobbyStateService.current.resolve();
                    return !state.isLobbyView() && !lobbyUiService.sphereMenu.excluded(state);
                }

                var initialize = function () {

                    var data = lobbyDataService.sphereMenuItems();

                    data.push({ caption: '', icon: 'ico-logo', url: '', index: 0.5 }); // home page button                            

                    // create & append ui backdrop to DOM
                    backdrop = $('<div class="sphere-backdrop"></div>')
                        .appendTo('BODY')
                        .on('click', function () {
                            collapse();
                        });

                    // create & append ui menu elements to DOM
                    menu = $('<div class="sphere-menu hidden"></div>').appendTo('BODY');

                    var elements = $('<ul />').appendTo(menu);

                    // create & attach menu node elements to list 
                    for (var i = 0; i < data.length; i++) {

                        //var onclick = data[i].url ? 'click="lobbyUiService.navigate(\'' + data[i].url + '\')"' : '';
                        spheres.push($('<li />')
                            .appendTo(elements)
                            .addClass('sphere-node')
                            .append($('<a id="spr' + i + '" href="javascript:void(0)" title="' + data[i].caption + '"></a>').
                                on('click', function () {

                                    var index = parseInt($(this).attr('id').replace('spr', ''), 10);

                                    var menue = lobbyDataService.sphereMenuItems();

                                    if (menue[index]) {
                                        {
                                            var pageId = (menue[index].id) ? parseInt(menue[index].id, 10) : 0;

                                            googleAnalyticsService.insertEvent({ page: 'all pages', id: pageId });

                                            lobbyUiService.navigate(menue[index].url, menue[index]);
                                        }
                                    }
                                }).addClass(data[i].icon)));
                    }
                    // attach collalpse behavior to each element
                    $('li:not(:last-child)', elements).on('click',
                        function () {
                            collapse();
                        }
                    );
                    // attach toggle behavior to trigger button
                    $('li:last-child', menu).on('click', function () {
                        toggle();
                    });
                }

                $scope.$on('lobbyEvent::ContentReady', function () {
                    if (!created()) {
                        initialize();
                    }
                });

                lobbyDataService.loadMetaData().then(function () {
                    initialize();
                });
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
    .directive("dwSplash", dwSplash);

    function dwSplash() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/main/templates/splash.html',
            controller: [
                '$scope', function ($scope) {
                    $scope.$watch('appData.bannersLoaded', function (newVal) {
                        if (newVal == true) {
                            angular.element('ion-view.module-view').removeClass("overlay-z");
                        }
                    });
                }
            ]
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
    .directive("loginSlider", loginSlider);

    loginSlider.$inject = ['$timeout'];

    function loginSlider($timeout) {
        return function ($scope, $element) {
            $element.off('transitionend webkitTransitionEnd oTransitionEnd');
            $element.on('transitionend webkitTransitionEnd oTransitionEnd', function () {
                $timeout(function () {
                    $scope.slider.sliderTransitionEnd = !$scope.slider.sliderTransitionEnd && $scope.slider.expanded;
                    $scope.slider.notFinish = false;
                    //console.log('end: ' + $scope.slider.sliderTransitionEnd);
                }, 0);

            });
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalWallet')
    .directive("cardsSlider", cardsSlider);

    cardsSlider.$inject = ['$timeout', '$ionicSlideBoxDelegate'];

    function cardsSlider($timeout, $ionicSlideBoxDelegate) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'app/main/templates/cardsslider.html',
            scope: {
                account: '=',
                hideAccount: '@',
                onAccountChange: '&',
                onCardChange: '&',
                title: '@'
            },
            link: function (scope, iElement, iAttrs) {

                scope.init = function () {

                    scope.initAccountSlider(0).then(function () {
                        scope.updateCardSlider(0);
                    });
                }

                scope.hasAccount = function () {
                    return scope.account.bankAccounts && scope.account.bankAccounts.length > 0;
                }

                scope.accountNext = function () {
                    var _promise = $timeout(function () {
                        $ionicSlideBoxDelegate.$getByHandle('accountHandler').next();

                    }, 500);

                    scope.$on("$destroy", function () {
                        $timeout.cancel(_promise);
                    });
                }

                scope.cardSlideChange = function (index) {
                    scope.account.currentCardIndex = index;
                    scope.onCardChange({arg1: index});
                }

                scope.accountPrev = function () {

                    var _promise = $timeout(function () {
                        $ionicSlideBoxDelegate.$getByHandle('accountHandler').previous();

                    }, 500);

                    scope.$on("$destroy", function () {
                        $timeout.cancel(_promise);
                    });
                }

                scope.accountSlideChange = function (index) {

                    scope.account.showSlider = false;

                    scope.account.currentAccountIndex = index;

                    scope.onAccountChange({arg1:index});

                    scope.updateCardSlider(0);
                }

                scope.initAccountSlider = function (index) {
                    var _promise = $timeout(function () {
                        $ionicSlideBoxDelegate.$getByHandle('accountHandler').update();
                    }, 200).then(function () {
                        $ionicSlideBoxDelegate.$getByHandle('accountHandler').slide(index);
                        scope.account.showSlider = true;
                    });

                    scope.$on("$destroy", function () {
                        $timeout.cancel(_promise);
                    });

                    return _promise;
                }

                scope.updateCardSlider = function (index) {
                    var _promise = $timeout(function () {

                        $ionicSlideBoxDelegate.$getByHandle('cardsHandler').update();

                    }, 500).then(function () {
                        $ionicSlideBoxDelegate.$getByHandle('cardsHandler').slide(index);
                        scope.account.showSlider = true;
                    }).finally(function () {
                        scope.slideBoxReady = true;
                        lobbyUiService.loader.hide();
                    });

                    scope.$on("$destroy", function () {
                        $timeout.cancel(_promise);
                    });

                    return _promise;
                }

                scope.to = function (index) {
                    $ionicSlideBoxDelegate.$getByHandle('cardsHandler').slide(index);
                }

                scope.hideLeftArrow = function (bankAccounts, bankIndex) {
                    if (scope.account) {

                        var currentIndex = scope.account.currentAccountIndex;

                        if (typeof bankIndex != 'undefined') {
                            currentIndex = bankIndex;
                        }

                        return bankAccounts.length <= 1 || currentIndex == 0;
                    }

                    return true;
                }

                scope.hideRightArrow = function (bankAccounts, bankIndex) {

                    if (scope.account) {

                        var currentIndex = scope.account.currentAccountIndex;

                        if (typeof bankIndex != 'undefined') {

                            currentIndex = bankIndex;
                        }

                        return bankAccounts.length <= 1 || currentIndex == bankAccounts.length - 1;
                    }

                    return true;
                }

                scope.init();
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
    .directive("moduleNode", moduleNode);

    moduleNode.$inject = ['$q', '$timeout', 'lobbyUiService', 'lobbyDataService', 'lobbyStateService', '$window', '$rootScope'];

    function moduleNode($q, $timeout, lobbyUiService, lobbyDataService, lobbyStateService, $window, $rootScope) {
        return {
            restrict: 'C',
            link: function (scope, element, attrs) {
                if (!scope.$last) return;

                var w = angular.element($window);

                w.bind('resize', function () {
                    scope.setMenuHeight();
                });

                var MAX_MODULES = 4; // num of items to fit without scroll

                scope.setMenuHeight = function () {
                    var modulesList = element.parent();

                    var w = angular.element($window);



                    var o = $('#page-wrapper').width() * 0.625;

                    //console.log(modulesList.prev());

                    var wrapHomeMenu = modulesList.prev();
                    if (wrapHomeMenu && wrapHomeMenu.hasClass('contact-section')) {
                        var h = wrapHomeMenu.outerHeight(true);
                        if (h > 10) {
                            o = h;
                        }
                    }

                    var heightBanner = o;//modulesList.prev().height();

                    var heightContainer = modulesList.closest('ion-content').outerHeight(true);


                    var x = Math.ceil(heightContainer - heightBanner) + 1;

                    //console.log("modulesList.parent()", modulesList.parent());
                    //var heightContainer = modulesList.parent().height();

                    //if (heightContainer < 260) {

                    // heightContainer = modulesList.parent().parent().height();
                    //}

                    //var x = heightContainer - heightBanner;

                    //console.log('heightContainer: ', heightContainer);
                    //console.log('heightBanner: ', heightBanner);

                    //console.log('x: ', x);

                    if (x <= 220) {
                        x = 220;
                        modulesList.parent().css('overflow-y', 'auto');
                    }

                    modulesList.height(x);

                    if (modulesList.children().length < MAX_MODULES) {
                        var y = modulesList.children().length;
                        modulesList.children().height((100 / y )+  "%");
                    }
                }

                //console.log(element.parent().is(':visible'));
                // var container = element.parent();
                //if (!container.is(':animated')) {
                element.parent().slideDown('fast', function () {
                    //        console.log('here');
                    scope.setMenuHeight();
                });
                //}
            }

        }

    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("cal4uIframe", cal4uIframe);

    cal4uIframe.$inject = ['appSettings', '$rootScope'];

    function cal4uIframe(appSettings, $rootScope) {
        return {
            replace: true,
            template: '<iframe src="" class="c4u-iframe"></iframe>',
            restrict: "E",
            scope: {
                source: '@src'
            },
            link: function (scope, element) {

                var params = $rootScope.params;
                $rootScope.params = '';
                if (!params) params = ''; else params = '#' + params;

                element.attr({ src: appSettings.base + scope.source + params });
            }
        }
    }

    window.addEventListener("scroll", function () {
        try {
            if (elem[0].style.display != 'none') {
                var top = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
                console.log(top);
                if (top >= elemOffset) {
                    elem.css('position', 'fixed');
                    elem.css('top', '80px');
                } else {
                    elem.css('position', 'absolute');
                    elem.css('top', '200px');
                }
            }
        } catch (e) {

        }

    });

    window.addEventListener('message', function (event) {
        try {
            var data = JSON.parse(event.data);
            if (data.type == 'showSticky') {
                if (data.show == 'true') {
                    elem.css('display', 'block');
                } else {
                    elem.css('display', 'none');
                }
            }

            if (data.type == 'scroll2Top') {
                if (window.pageYOffset > 100) {
                    $('body').animate({
                        scrollTop: 0
                    }, 400);
                }
            }

            if (data.type == 'changeTitle') {
                document.title = data.title;
                var metas = document.getElementsByTagName("meta");
                for (var i = 0; i < metas.length; i++) {
                    if (metas[i].name.toLowerCase() == "description") {
                        metas[i].content = data.description;
                    }
                }
            }
        } catch (e) {

        }


    });
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("dwModuleHomePageButtons", dwModuleHomePageButtons);

    dwModuleHomePageButtons.$inject = ['$q', '$timeout', 'lobbyUiService', 'lobbyDataService', 'lobbyStateService', '$window', '_', 'appSettings'];

    function dwModuleHomePageButtons($q, $timeout, lobbyUiService, lobbyDataService, lobbyStateService, $window, _, appSettings) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/main/templates/home-page-buttons.html',
            link: function (scope, element) {
                // var md = new MobileDetect($window.navigator.userAgent);
                // if (!md.phone() && !md.tablet()) {
                //     window.location.replace(appSettings.desktopSite);
                // }

                //if (!window._base.mobileAndTabletcheck()) {
                //    window.location.replace(appSettings.desktopSite);

                //}

                var MAX_MODULES = 5; // num of items to fit without scroll

                scope.isHomePageButtons = true;

                scope.setMenuHeight2 = function () {

                    var navContent = $('ion-nav-view.content-body');

                    var targetView = $('> ion-view.module-view:nth-child(2)', navContent);

                    var navHeight = parseFloat(angular.element('ion-nav-bar.content-header').outerHeight());

                    var deviceHeight = parseFloat(angular.element($window).height());

                    if (targetView.length == 0) {
                        // animation is done, there is only one instance
                        targetView = $('> ion-view.module-view:first-child', navContent);
                    }

                    var content = targetView.find('ion-content').first();

                    if (targetView.hasClass('content-view')) {
                        // content is textual, set default height
                        content.css('height', '45%');

                        element.css('height', deviceHeight - content.height() - navHeight);
                    } else {

                        var deviceWidth = parseFloat(angular.element($window).width());

                        element.css('height', deviceHeight - navHeight - (deviceWidth * 0.625));
                    }

                }

                // create & attach menu elements to list 
                scope.initialize2 = function (metaData) {
                    scope.homePageButtons = metaData.homePageButton;

                    var itemsLength = _.filter(scope.homePageButtons, function (_item) {
                        return !_item.hideType || _item.hideType != 1;
                    }).length;

                    $timeout(function () {

                        if (itemsLength == MAX_MODULES) {
                            // fit exactly N items (without scrolling)
                            element.addClass('fit');
                        } else if (itemsLength > MAX_MODULES) {
                            // overflow N items, with scroll
                            element.addClass('overflow');
                        }
                    }, 0);
                }

                lobbyDataService.loadMetaData().then(function (metaData) {
                    if (metaData) {
                        scope.initialize2(metaData);
                        //  scope.setMenuHeight2();
                    }
                });
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';

    angular.module("digitalWallet")
    .directive('searchBarComponent', SearchBarComponent);

    SearchBarComponent.$inject = ['$q', '$timeout', 'lobbyDataService', 'lobbyUiService', 'speachRecognition', 'googleAnalyticsService', '$filter'];

    function SearchBarComponent($q, $timeout, lobbyDataService, lobbyUiService, speachRecognition, googleAnalyticsService, $filter) {
        return {
            restrict: "E",
            replace: true,
            controller: [
                '$scope', function ($scope) {
                    var searchBy;

                    $scope.navigateQueryResult = function (url, item) {
                        googleAnalyticsService.insertEvent({ page: url, eventName: searchBy, action: 'Click' });
                        // Navigating to specifec url with his item data.
                        lobbyUiService.navigate(url, item);

                        // When navigating to new page we close the search bar.
                        $scope.onClose();
                    }

                    $scope.onChange = function () {
                        searchBy = 'type search';
                        $scope.filteredItems = $filter('calSearch')($scope.menuItems, $scope.query);
                    }

                    $scope.clearQueryStatment = function () {
                        googleAnalyticsService.insertEvent({ page: $scope.query, eventName: searchBy, action: 'Click' });
                        $scope.query = '';
                    }

                    $scope.isListening = false;

                    $scope.speechEnd = false;

                    $scope.isSupportSR = false;


                    /**
                     * On user click on the mic icon to activate carolina js listening lifecycle of getting
                     * User voice as string to our client.
                     */
                    $scope.onMicTouch = function () {
                        $scope.isListening = !speachRecognition.isListening();

                        return speachRecognition.isListening() ? speachRecognition.stop() : speachRecognition.start();
                    };


                    /**
                     * Closing the navbar component and clearing the query.
                     */
                    $scope.onClose = function () {
                        $scope.clearQueryStatment();
                        $scope.closeSearchBar();
                    };


                    /**
                     * Do manually render trigger the digest cycle.
                     */
                    function ngManuallyRender() {
                        console.log('Try to manually trigger the digest cycle.');

                        if (!$scope.$$phase) {
                            console.log('Start new digest');
                            $scope.$digest();
                        }
                    }

                    /**
                     * Lifecycle of carolina js on start user talking.
                     */
                    function onStart(args) {
                        console.log('ON_START:: Callback => ', args);
                    }


                    /**
                     * Lifecycle of carolina js on end user talking.
                     */
                    function onEnd(args) {
                        console.log('ON_END:: Callback => ', args);

                        $timeout(function () {
                            $scope.speechEnd = false;
                            $scope.isListening = speachRecognition.isListening();
                        });
                    }


                    /**
                     * Lifecycle of carolina js on error.
                     */
                    function onError(args) {
                        console.log('ON_ERROR:: Callback => ', args);

                        $scope.isListening = speachRecognition.isListening();

                        ngManuallyRender();
                    }


                    /**
                    * Lifecycle of carolina js getting notify about chunk user input voice as string text.
                    */
                    function onChunkStream(chunk) {
                        console.log('ON_CHUNK_STREAM:: Callback => ', chunk);

                        // Empty could not catch any speaking chunk.
                        if (!chunk) {
                            return;
                        }

                        searchBy = 'voice search';
                        $timeout(function () {
                            $scope.query = chunk;
                            $scope.filteredItems = $filter('calSearch')($scope.menuItems, $scope.query);
                        })

                        //ngManuallyRender();
                    }

                    /**
                     * This function will invoke when the user not have the right permission.
                     */
                    function onNoPermission() {
                        if (ionic.Platform.isIOS()) {
                            lobbyUiService.popup.alert('יש להיכנס להגדרות הטלפון ולאפשר הרשאת מיקרופון וזיהוי קולי באפליקציית ארנק Cal4U', '', 'סגור');
                        } else {
                            lobbyUiService.popup.alert('יש להיכנס להגדרות הטלפון ולאפשר הרשאת מיקרופון באפליקציית ארנק Cal4U', '', 'סגור');
                        }
                    }


                    /**
                     * This function will be invoke when we receive from the carolina lib that the recognition is avilable.
                     */
                    function onDevicePlatformSupport(isSupported) {
                        $timeout(function () {
                            $scope.isSupportSR = isSupported;
                        });
                    }


                    /**
                     * Event when user speech end.
                     */
                    function onSpeechEnd() {
                        console.log('ON_SPEECH_END:: Callback');

                        $timeout(function () {
                            $scope.speechEnd = true;
                        });
                    }


                    function init() {
                        console.info('Initializing search bar component.');

                        $scope.menuItems = [];

                        $scope.queryResults = [];

                        $scope.query = '';

                        lobbyDataService.loadMetaData().then(function (metadata) {
                            if (!metadata.menu) {
                                console.error('There is no menu item from metadata.');
                                return;
                            }

                            metadata.menu.forEach(function (menuElement) {
                                $scope.menuItems = $scope.menuItems.concat(menuElement);
                                var mItem = $.extend({}, menuElement);
                                if (mItem.hide) {
                                    mItem.items = null;
                                }

                                if (mItem.items) {
                                    mItem.items = mItem.items.map(function (item) {
                                        item.parentCaption = item.caption;

                                        return item;
                                    });

                                    $scope.menuItems = $scope.menuItems.concat(mItem.items);
                                }
                            });
                            metadata.homePageButton.forEach(function (menuElement) {
                                $scope.menuItems = $scope.menuItems.concat(menuElement);
                            });
                        });

                        // Intialize voice recognition library.
                        speachRecognition.init(
                            {
                                callbacks: {
                                    context: this,
                                    onStart: onStart,
                                    onError: onError,
                                    onEnd: onEnd,
                                    onChunkStream: onChunkStream,
                                    onNoPermission: onNoPermission,
                                    onDevicePlatformSupport: onDevicePlatformSupport,
                                    onSpeechEnd: onSpeechEnd
                                }
                            });

                        $scope.isSupportSR = speachRecognition.isSupportVoiceRecognition();
                    }

                    init();
                }
            ],
            scope: {
                /*
                 * Pass close search bar callback.
                 */
                closeSearchBar: '&',
                focusOn: '='
            },
            templateUrl: 'app/main/templates/search-bar.component.html',
            link: function ($scope, $element, $attr) {

            }

        };
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("dwFirstTimeBanners", dwFirstTimeBanners);

    dwFirstTimeBanners.$inject = [
        '$rootScope', '$timeout', '$ionicSlideBoxDelegate', '$ionicScrollDelegate', 'lobbyUiService', 'lobbyDataService',
        'lobbyStateService', 'appData', 'appSettings'
    ];

    function dwFirstTimeBanners($rootScope, $timeout, $ionicSlideBoxDelegate, $ionicScrollDelegate, lobbyUiService, lobbyDataService,
                lobbyStateService, appData, appSettings) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/main/templates/first-time-banners.html',
            controller: function () {

                var vm = this;
                vm.showFirstTimeBanners = false;
                vm.firstTimeBanners = {};
                vm.buttonFadeIn = "";
                vm.bannersfirsttimehandler = $ionicSlideBoxDelegate.$getByHandle('bannersfirsttimehandler');

                vm.firstTimeBannersArrowLeft = function () {
                    vm.bannersfirsttimehandler.previous();
                }

                vm.firstTimeBannersArrowRight = function () {
                    vm.bannersfirsttimehandler.next();
                }

                vm.firstTimeBannersShowLeftArrow = function (banner) {
                    if (vm.bannersfirsttimehandler.currentIndex() == 0)                         
                        return false;
                    vm.buttonFadeIn = "";
                    return true;
                }

                vm.firstTimeBannersShowRightArrow = function (banner) {
                    if (vm.bannersfirsttimehandler.currentIndex() == (vm.bannersCount - 1)) {
                        vm.buttonFadeIn = "fadein-button";
                        return false;
                    }
                    vm.buttonFadeIn = "";
                    return true;
                }

                vm.firstTimeBannersShowCloseMenu = function (banner) {
                    if (vm.firstTimeBanners[vm.bannersCount - 1] == banner) {                        
                        return true
                    }
                    return false;
                }

                vm.closeFirstTimeBanners = function () {
                    vm.showFirstTimeBanners = false;
                    var wasFirstTimeBannersDisplayed = window.localStorage.getItem($rootScope.members.IS_NEW_VERSION);
                    if (wasFirstTimeBannersDisplayed == 'undefined' || wasFirstTimeBannersDisplayed == null) {
                        window.localStorage.setItem($rootScope.members.IS_NEW_VERSION, appSettings.version);
                    }
                    else if (wasFirstTimeBannersDisplayed != appSettings.version) {
                        window.localStorage.setItem($rootScope.members.IS_NEW_VERSION, appSettings.version);
                    }
                    console.log('first time banners were closed');
                }

                vm.firsTimeBannersDisplayContentTitle = function (banner) {
                    if ((banner.Content != null && banner.Title != null) && (banner.Content != "" && banner.Title != ""))
                        return true;
                    return false;
                }

                vm.firstTimeBannersImageDiv = function (banner) {
                    if ((banner.Content != null && banner.Title != null) && (banner.Content != "" && banner.Title != ""))
                        return "first-time-banner-img-div";
                    return "";
                }

                vm.firstTimeBannersFullImage = function (banner) {
                    if ((banner.Content != null && banner.Title != null) && (banner.Content != "" && banner.Title != "")) {
                        //console.log("small image, banner.Title= " + banner.Title + " banner.Content= " +banner.Content);
                        return "img-first-time";
                    }
                    //console.log("full image");
                    return "first-time-banner-full-img";
                }

                var initializeSlider = function (banners, shouldUpdate) {
                    vm.firstTimeBanners = banners;
                    vm.bannersCount = vm.firstTimeBanners.length;
                    $timeout(function () {
                        if (shouldUpdate) {
                            var bannersfirsttimehandler = $ionicSlideBoxDelegate.$getByHandle('bannersfirsttimehandler');
                            console.log('initialize');
                            bannersfirsttimehandler.update();
                        }
                    }, 200);
                }

                lobbyDataService.loadMetaData().then(function () {
                    vm.isFirstTimeBannersLoaded = true;
                    var wasFirstTimeBannersDisplayed = window.localStorage.getItem($rootScope.members.IS_NEW_VERSION);
                    console.log('wasFirstTimeBannersDisplayed = ' + wasFirstTimeBannersDisplayed)
                    if (null === wasFirstTimeBannersDisplayed || wasFirstTimeBannersDisplayed != appSettings.version) {
                        var banners = lobbyDataService.firstTimeBanners();
                        if (banners != null && banners.length > 0) {
                            initializeSlider(banners, true);
                            vm.showFirstTimeBanners = true;
                            console.log('first time banners loaded');
                        }
                        else {
                            vm.showFirstTimeBanners = false;
                            console.log('first time banners is false');
                        }
                    }
                    else {
                        vm.showFirstTimeBanners = false;
                        console.log('first time banners were loaded already');
                    }
                });
            },
            controllerAs: 'vm',
            bindToController: true
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
	'use strict';

	angular.module("digitalWallet")
    .directive('offlineComponent', OfflineComponent);

	OfflineComponent.$inject = [];

	function OfflineComponent($q, lobbyDataService, lobbyUiService, speachRecognition) {
		return {
			restrict: "E",
			replace: true,
			controller: [
                '$scope', function ($scope) {
                	$scope.isOffline = false;
 
                	function init() {
                		if (!navigator.onLine) {
                			$scope.isOffline = true;
                		}

                		console.log('Initialized offline component');
                	}

                	init();
                }
			],
			scope: {

			},
			templateUrl: 'app/main/templates/offline.component.html'
		};
	}

})(window, window.angular);
(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .provider('Worker', WorkerProvider);

    WorkerProvider.$inject = [];

    function WorkerProvider() {
        // Parameters to first register the worker service.
        var _settings = {};

        this.register = function () {
            console.info('Registering worker service!');

            // If the browser is not support service worker kill this as soon as possible.
            if (!navigator.serviceWorker) {
                console.error('This browser not support service workers');
                return;
            }

            //POC
            /*return navigator.serviceWorker.register('./sw.js').then(function (r) {
                console.log('SW Registered => ', r);                

            }).catch(function (error) {
                console.error('Could not register service worker => ', error);
            })*/
        }

        this.$get = function () {
            return {
                register : this.register
            }
        };
    }
})(window, window.angular);
(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('webpushNotfication', webpushNotfication);

    webpushNotfication.$inject = ['$state'];

    function webpushNotfication($state) {
        var notficationSupported = false;


        /**
         * Initialzie speachRecognition service.
         *
         * @param args
         */
        function init(args) {
            if (ionic.Platform.isWebView() && cordova.plugins.notification) {
                // Notification plugin installed.
                notficationSupported = true;

                // Attach handler when user click on notification.
                cordova.plugins.notification.local.on("click", function (notification) {
                    $state.go(notification.data.link);
                });

                notify = nativeNotify;
            }
            else {

                if (!window.Notification) {
                    console.error('Desktop notifications not available in your browser. Try Chromium.');
                    return;
                }


                // Desktop notfication is available in the browser.
                notficationSupported = true;

                notify = browserNotify;
            }
        }


        /**
         * Send web push notification.
         *
         * @param notificationOptions
         * @returns {{init: init, notify: notify}}
         */
        function browserNotify(notificationOptions) {
            // If the notfication feature is not supported end execution.
            if (!notficationSupported)
                return;

            // If the user not have granted permission end execution.
            if (window.Notification.permission !== "granted")
                window.Notification.requestPermission();

            if (!navigator.serviceWorker)
                return;

            navigator.serviceWorker.ready.then(function (registration) {
                registration.showNotification(notificationOptions.title, {
                    body: notificationOptions.body,
                    icon: notificationOptions.icon || 'icon.png',
                    vibrate: [200, 100, 200, 100, 200, 100, 200],
                    tag: ''
                });
            });
        }


        /**
         * Send native push notification.
         *
         * @param notificationOptions
         * @returns {Function}
         */
        function nativeNotify(notificationOptions) {
            // If the notfication feature is not supported end execution.
            if (!notficationSupported)
                return;


            var currMessageID = 1,
                nativePushNotification = function(notificationOptions) {

                console.log('Sending native notification => ', notificationOptions);

                    cordova.plugins.notification.local.schedule({
                        id: 1,
                        title: notificationOptions.title || '',
                        text: notificationOptions.body || '',
                        icon: notificationOptions.icon || '',
                        data: {link: notificationOptions.link}
                    });
                };

            return (function() {
                cordova.plugins.notification.local.hasPermission(function (granted) {
                    console.log('Permission has been granted: ' + granted);

                    if (granted) {
                        nativePushNotification(notificationOptions);
                        currMessageID++;
                    } else {
                        cordova.plugins.notification.local.registerPermission(function (granted) {
                            console.log('Permission has been granted: ' + granted);

                            if (granted) {
                                nativePushNotification(notificationOptions);
                                currMessageID++;
                            }
                        });
                    }
                });
            }());
        }


        function notify() {}


        init();


        return {
            notify: notify
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('dataService', dataService);

    dataService.$inject = [];

    function dataService($q, appSettings, $interval) {

        var sessionManager = (function () {
            return {
                read: function (key) {
                    var jsonObj = sessionStorage.getItem(key);
                    if (jsonObj) {
                        return angular.fromJson(jsonObj);
                    }
                    return null;
                },
                save: function (key, value) {
                    if (value && key) {
                        sessionStorage.setItem(key, angular.toJson(value));
                    }
                    return value;
                },
                clear: function (key) {
                    if (key) {
                        sessionStorage.removeItem(key);
                    } else {
                        sessionStorage.clear();
                    }
                },
                clearAndSave: function (key, value) {
                    if (key) {
                        sessionManager.clear(key);
                    }
                    if (value && key) {
                        sessionManager.save(key,value);
                    }
                }
            };
        })();

        var cacheManager = (function () {
            return {
                read: function (key) {
                    var jsonObj = localStorage.getItem(key);
                    if (jsonObj) {
                        return angular.fromJson(jsonObj);
                    }
                    return null;
                },
                save: function (key, value) {
                    if (value && key) {
                        localStorage.setItem(key, angular.toJson(value));
                    }
                    return value;
                },
                clear: function (key) {
                    if (key) {
                        localStorage.removeItem(key);
                    } else {
                        localStorage.clear();
                    }
                }
            };
        })();

        return {
            sessionManager: sessionManager,
            cacheManager: cacheManager
        }
    }


})(window, window.angular);

﻿(function(window, angular) {
    'use strict';
    angular.module("digitalWallet")
    .factory('appData', appData);

    appData.$inject = ['dataService'];

    function appData(dataService) {
        return dataService.sessionManager.read('appData') || {};
    }

})(window, window.angular);

﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
    .factory('backService', backService);

    backService.$inject = ['$rootScope', 'appData', 'lobbyStateService', '$window', '$timeout'];

    function backService($rootScope, appData, lobbyStateService, $window, $timeout) {

        return {
            back: function () {
                //console.log('going back from service');
                if (angular.isFunction(appData.backOverrideFN)) {

                    appData.backOverrideFN();

                    //console.log('custom back');
                } else {
                    //console.log('window back');

                    if (typeof device != "undefined" && device.platform == "Android") {

                        var currentPage = lobbyStateService.current.resolve();

                        if (currentPage.data && currentPage.data.lobby && currentPage.data.lobby == true) {
                            navigator.app && navigator.app.exitApp && navigator.app.exitApp();
                        }
                    }
                    if ($rootScope.filteredTransactionResultsVisible) {
                        $rootScope.filteredTransactionResultsVisible = false;
                        $rootScope.$broadcast("filteredTransactionResultsVisibleChanged");
                    }
                    else if ($rootScope.stopStandingOrder)
                    {
                        console.log("*****$rootScope.stopSatndingOrder is true******");
                        $rootScope.$broadcast("stopStandingOrderVisibleChanged");
                    }
                    else {
                        $window.history.back();
                    }  
                }
            },
            goBack: function (howManySteps) {
                if (howManySteps && howManySteps > 0) {
                    window.history.go(howManySteps * -1);

                } else {
                    //console.log('window back');
                    window.history.back();
                }
            },
            forward: function (howManySteps) {
                if (howManySteps) {
                    window.history.go(howManySteps);

                } else {
                    window.history.forward();
                }
            },
            pushState: function (state) {
                $timeout(function () {
                    window.history.pushState(state.obj, state.title, state.url);
                }, 0);
            },
            replaceState: function (state) {
                window.history.replaceState(state.obj, state.title, state.url);
            },
            hasHistory: function () {
                return lobbyStateService.current.resolve().isLobbyView() == false;
            }
        }

    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('lobbyUiService', lobbyUiService);

    lobbyUiService.$inject = [
        '$rootScope', '$q', '$location', '$ionicLoading', '$ionicModal', '$ionicPopup', '$ionicSideMenuDelegate', '$ionicGesture', '$timeout',
        'lobbyStateService', 'lobbyDataService', 'appData', '$window', 'googleAnalyticsService', 'chatService', 'ssoService', '$interval'
       /* touch: */, 'touchKeyStore', 'EncryptionService', 'restrictService', '$injector', '$state', 'dataService', 'appSettings'];

    function lobbyUiService($rootScope, $q, $location, $ionicLoading, $ionicModal, $ionicPopup, $ionicSideMenuDelegate, $ionicGesture, $timeout,
        lobbyStateService, lobbyDataService, appData, $window, googleAnalyticsService, chatService, ssoService, $interval
                /* touch: */, touchKeyStore, EncryptionService, restrictService, $injector, $state, dataService, appSettings) {
        var _api = null;

        return _api = {
            connection: {

            },
            clearDependencies: function (nodes) {
                // recursively iterate menu nodes and filter dependencies rules.
                // exmp: add/remove login-dependant nodes according to login state.
                var iterate = function (_nodes) {
                    var cleared = $.grep(_nodes, function (n) {

                        if (n.hide) {
                            return null;
                        } else if (n.items) {
                            n.items = _api.clearDependencies(n.items);
                            return n.items;
                        } else if (n.dependency === "login") {
                            if (_api.connection.isLoggedIn()) {
                                return n;
                            }
                            return null;
                        }/* touch: */
                        else if (n.dependency === "login-touch") {
                            if (EncryptionService.getIsTouchReq() && _api.connection.isLoggedIn()) {
                                return n;
                            }
                            return null;
                        }
                        else {
                            return n;
                        }
                    });

                    return cleared;
                };

                return iterate(angular.copy(nodes)); // send a copy to preserve original data
            },
            bannersArchive: (function () {
                var _apiBanners = [];
                var _banners = [];
                return _apiBanners = {
                    create: function (modules) {
                        $.map(modules, function (module) {
                            $.each(module.banners, function (i, banner) {
                                if (!_banners.contains(banner.image)) {
                                    return _banners.push(banner.image);
                                }
                            });
                            return null;
                        });
                        return _apiBanners;
                    },
                    fill: function (images) {
                        _banners = images;
                    },
                    getAll: function () {
                        return _banners;
                    },
                    hasData: function () {
                        return _banners.length > 0;
                    },
                    contains: function (bannerImage) {
                        return _banners.contains(bannerImage);
                    },
                    push: function (bannerImage) {
                        if (!_banners.contains(bannerImage)) {
                            _banners.push(bannerImage);
                        }
                    }
                }
            })(),
            moduleArchive: (function () {
                var _modules = [];
                return {
                    hasData: function () {
                        return _modules.length > 0;
                    },
                    contains: function (moduleId) {
                        return _modules.contains(moduleId);
                    },
                    push: function (moduleId) {
                        if (!_modules.contains(moduleId)) {
                            _modules.push(moduleId);
                            //console.log('%%%%%%%%% modules archive ' + _modules);
                        }
                    }
                }
            })(),
            listenTo: (function () {
                // ****
                // an interface to implement common event handling ('swipe' / 'swiperight' / 'swipeleft' / 'doubletap' / 'tap' / 'scroll')
                // ********
                return {
                    swipe: function (element, callback) {
                        $ionicGesture.on('swipe', callback, element);
                    }
                }
            })(),


            notify: (function () {
                // ****
                // an interface to brodcast event firing
                // ********
                return {
                    verticalSwipe: function (callback) {
                        $ionicGesture.on('swipeup', callback, $('body'));
                        $ionicGesture.on('swipedown', callback, $('body'));
                    },
                    contentSwipe: function (callback) {
                        $ionicGesture.on('swipeup', callback, $('body'));
                    },
                    contentReady: function () {
                        $rootScope.$broadcast('lobbyEvent::ContentReady');
                    },
                    metaDataLoaded: function (data) {
                        $rootScope.$broadcast('lobbyEvent::MetaDataLoaded', data);
                    },
                    bannersLoaded: function () {
                        $rootScope.$broadcast('lobbyEvent::BannersLoaded');
                    },
                    metaDataFailed: function () {
                        $rootScope.$broadcast('lobbyEvent::MetaDataFailed');
                    }
                }
            })(),
            sphereMenu: (function () {
                // ****
                // sphere menu logic
                // ********

                // the sphere will show only on none-module views. in addition,
                // this is an array of urls in which also NOT to display the sphere menu
                var excludedViews = ['/digital/splash', '/digital/lobby'];

                return {
                    excluded: function (state) {
                        return ($.inArray(state.path(), excludedViews) >= 0);
                    }
                }
            })(),
            captionize: function (item) {
                if (item.devices) {
                    return 'multi..';
                }
                return item.caption;
            },
            getParams: function (key) {
                return lobbyStateService.current.resolve().getParams(key);
            },
            go: function (url, routeParams, stateParams) {

                if ($ionicSideMenuDelegate.isOpen()) {
                    $ionicSideMenuDelegate.toggleRight();
                }

                lobbyStateService.current.goToState(url, routeParams, stateParams);
            },
            navigate: function (url, options, routeParams) {

                if (url) {

                    if (appData.inProcess === true) {

                        _api.popup.abandon(url, options);
                        return null;
                    }

                    if (!_api.connection.isLoggedIn()) {
                        if (url.indexOf('expressLoan') > -1) {

                            var popup = _api.popup.loanLead();
                            $rootScope.loanLeadClosePopup = function () {
                                popup.close();
                            }
                            return null;

                        } else if (url.indexOf('fixedPayout') > -1) {
                            _api.popup.fixedDebit();
                            return null;

                        } else if (url.indexOf('calchoicePayout') > -1) {
                            _api.popup.calChoice();
                            return null;
                        }
                    } else {

                        if (url.indexOf('calchoicePayout') > -1) {

                            var calChoiceAccounts = [];

                            for (var i = 0; i < appData.BankAccounts.length; i++) {
                                var cardsToDisplay = [];
                                for (var j = 0; j < appData.BankAccounts[i].Cards.length; j++) {
                                    if (appData.BankAccounts[i].Cards[j].IsCalChoiceCard) {
                                        appData.BankAccounts[i].Cards[j].CardIndex = j;
                                        cardsToDisplay.push(appData.BankAccounts[i].Cards[j]);
                                    }
                                }
                                if (cardsToDisplay.length > 0) {
                                    appData.BankAccounts[i].calChoiceCards = cardsToDisplay;
                                    appData.BankAccounts[i].AccountIndex = i;
                                    appData.BankAccounts[i].CalChoiceAccountIndex = calChoiceAccounts.length;
                                    calChoiceAccounts.push(appData.BankAccounts[i]);
                                }
                            }

                            appData.calChoiceAccounts = calChoiceAccounts;;

                            if (!appData.calChoiceAccounts || appData.calChoiceAccounts === 0) {
                                _api.popup.calchoiceLead();
                                return null;
                            }
                        }
                    }

                    if (url.indexOf('service-and-support/whatsapp') > -1 || url.indexOf(appSettings.whatsappLink) > -1) {
                        _api.connection.identificationServiceRequest().then(function () { }, function () { });
                    }
                }

                var target = {
                    navigation: '1',
                    window: '2',
                    command: '3',
                    inApp: '4'
                }

                var defaults = {
                    abandonBehavior: false,
                    type: target.navigation
                }

                options = angular.extend(defaults, options);

                // close after clicking
                if ($ionicSideMenuDelegate.isOpen()) {
                    $rootScope.members.ionSideMenuExpand = false;
                    $ionicSideMenuDelegate.toggleRight();
                }

                if (!options.state && url) {
                    options.state = url;
                }

                // check if target view is restricted to authenticated users only
                var isLoginPage = lobbyStateService.current.resolve().isLoginView();

                //isLoginPage === false 

                var navOptions = { notify: true };

                if (isLoginPage === true) {
                    navOptions.location = 'replace';
                } else if (options.location)
                    navOptions.location = options.location;

                if (options.nextPage && options.type != target.navigation) {
                    routeParams.type = options.type;
                    routeParams.command = options.command;
                    options.type = target.navigation;
                }

                switch (options.type) {
                    case target.command:
                        {
                            // handle special commands (not urls)
                            switch (options.command) {
                                case 'redirect-to-ecredit-product':
                                case 'redirect-to-ecredit-products':
                                case 'redirect-to-ecredit': {
                                    _api.go('dw.loanFrame');
                                    break;
                                }
                                case 'logout':
                                    {
                                        if (!options.abandonBehavior) {
                                            _api.popup.abandon(url, options);
                                        } else {
                                            _api.connection.logout();
                                        }

                                        options.abandonBehavior = !options.abandonBehavior;

                                        break;
                                    }
                                case 'logout-touch':
                                    {
                                        _api.popup.abandonTouch();
                                        break;
                                    }
                                case 'open-chat':
                                case 'open-chat-bot':
                                    {
                                        if (!_api.connection.isLoggedIn()) {
                                            // set target view as nextpage value, update url, 
                                            // cancel view transition if current view is already login
                                            //navOptions.notify = isLoginPage === false;

                                            var _routeParams = {
                                                nextPage: options.state,
                                                type: options.type,
                                                command: options.command
                                            };

                                            var _self = this;

                                            var go = function () {
                                                _self.go('dw.login', _routeParams, navOptions);
                                                return;
                                            };

                                            go();
                                        }
                                        else {
                                            if (options.command != 'open-chat-bot') {
                                                var chatWindow = window.loginChatWindow || _api.openExternal('', options.devices, true);
                                            }
                                            chatService.inserNewChatDetails().then(function (res) {
                                                var chatUrl = res.guid ? url + '?' + 'profile=' + res.profile + '&lang=' + res.language + '&t=' + res.guid + '&' + options.query : url + '?' + options.query;
                                                //_api.openExternal(chatUrl, options.devices, true);
                                                if (options.command == 'open-chat-bot') {
                                                    //location.href = chatUrl
                                                    window.open(chatUrl);
                                                    _api.navigate(null, { state: 'dw.lobby' }, {});
                                                }
                                                else {
                                                    chatWindow.location.href = chatUrl;
                                                    window.loginChatWindow = null;
                                                    if ($state.current.name === 'dw.login') {
                                                        _api.navigate(null, { state: 'dw.account-home' }, {});
                                                    }
                                                }
                                            });
                                        }
                                        break;
                                    }
                                case 'open-popup-calmail':
                                    {
                                        var extOptions =
                                        {
                                            cssClass: 'dw-popup-cover',
                                            title: '',
                                            templateUrl: 'app/main/templates/calMail4U.html',
                                            buttons: [
                                                {
                                                    text: '<img src="content/images/calmail-btn.PNG" class="joinImg" />',
                                                    type: 'button-positive',
                                                    onTap: function () {
                                                        _api.navigate(url, {
                                                            type: '2',
                                                            sso: true
                                                        }, {});

                                                        return true;
                                                    }
                                                }
                                            ]
                                        };

                                        googleAnalyticsService.insertEvent({ page: 'mobical info page', eventName: 'show help - enter', action: 'enter' });

                                        var stop = null;

                                        var cancelInterval = function (event) {
                                            $interval.cancel(event);
                                        }

                                        return $timeout(function () {

                                            var _popupCalMail = $ionicPopup.show(extOptions);

                                            angular.element('.dw-popup-cover .close-btn').ready(function () {

                                                stop = $interval(function () {
                                                    if (angular.element('.dw-popup-cover .close-btn')) {

                                                        angular.element('.dw-popup-cover .close-btn').on('click', function () {
                                                            _popupCalMail.close();
                                                        });

                                                        cancelInterval(stop);
                                                    }

                                                }, 100);
                                            });

                                            return _popupCalMail;

                                        }, 400);
                                    }
                                case 'refresh-user-details': // .../#!/digital/login//3//true//refresh-user-details///
                                    {
                                        var connectSrv = $injector.get('connection');

                                        var bpm051SuccessFunc = function (response) {
                                            var status = response.ReturnedSeverityCode.toLowerCase();
                                            if (status == "s") {
                                                if (typeof (Storage) !== "undefined") {
                                                    localStorage.setItem("KycLastTimeShown", "route from sms");
                                                }
                                                _api.openExternal(response.UrlFormes, "", true);
                                                console.log("bpm051 returned status s");
                                            }
                                            else if (status == "i") {
                                                var dialogBoxText = "לא נדרש רענון לקוח, הנך מועבר להמשך פעילות";
                                                showPopup(dialogBoxText);
                                                console.log("bpm051 returned status i");
                                            }
                                            else {
                                                var dialogBoxText = "לא ניתן להשלים את הפעולה כרגע, אנא נסה שנית מאוחר יותר.";
                                                showPopup(dialogBoxText);
                                                console.log("bpm051 returned status different than s or i");
                                            }

                                            function showPopup(dialogbox) {
                                                var popup = {};
                                                popup.btns = [];
                                                popup.btns.push(
                                                    {
                                                        text: "אישור",
                                                        type: 'button-positive',
                                                        onTap: function () {
                                                            return;
                                                        }
                                                    });
                                                _api.popup.alert(dialogbox, null, null, null, popup.btns, true, null);
                                            }

                                        }

                                        var bpm051ErrorFunc = function (error) {
                                            var dialogBoxText = "לא ניתן להשלים את הפעולה כרגע, אנא נסה שנית מאוחר יותר.";
                                            showPopup(dialogBoxText);
                                            console.log("Refresh customer details from sms: connection.executeBpm051() failed. response: " + error);
                                        }

                                        connectSrv.executeBpm051().then(bpm051SuccessFunc, bpm051ErrorFunc);
                                    }
                            }

                        }
                    case target.navigation:
                        {
                            if (options.restrictedExplicitly || lobbyDataService.getNavRestriction(options.state, options.items)) {
                                // check current login state

                                if (!_api.connection.isLoggedIn()) {
                                    // set target view as nextpage value, update url, 
                                    // cancel view transition if current view is already login
                                    //navOptions.notify = isLoginPage === false;

                                    var _routeParams = {
                                        nextPage: options.state
                                    };

                                    var _self = this;

                                    var go = function () {
                                        _self.go('dw.login', _routeParams, navOptions);
                                        return;
                                    };

                                    restrictService.checkIsRestricted(options.state).then(function (status) {
                                        if (status) {
                                            _routeParams.restricted = true;
                                        }
                                        go();
                                    }, function () {
                                        go();
                                    });
                                }
                            }

                            if (options.nextPage) {
                                routeParams.nextPage = options.nextPage;
                            }

                            this.go(options.state, routeParams, navOptions);
                            break;
                        }
                    case target.window:
                        {
                            var query = '';

                            if (options.sso) {
                                // check current login state

                                if (!_api.connection.isLoggedIn()) {

                                    _api.go('dw.login',
                                        {
                                            nextPage: options.state,
                                            type: 2,
                                            sso: true
                                        }, navOptions
                                    );
                                } else {
                                    ssoService.insertSsoDetails().then(function (res) {

                                        var sep = url.indexOf("?") > 0 ? "&" : "?";
                                        query = sep + 'sid=' + res.Token;
                                        _api.openExternal(url + query, options.devices, true);

                                        if (isLoginPage || lobbyStateService.current.resolve().is357View()) {
                                            _api.go('dw.lobby');
                                        }
                                    });
                                }
                            } else {
                                _api.openExternal(url, options.devices, true);
                            }

                            break;
                        }
                    case target.inApp:
                        {
                            this.openExternal(url, options.devices);
                            break;
                        }

                    default:
                        break;
                }

                return null;
            },
            popup: (function () {
                /***
            /* handling abandon behavior via popup element
            /******/
                var settings = {
                    title: '',
                    template: '<p></p>',
                    cssClass: null,
                };
                return {
                    calchoiceLead: function (cancelCallBack) {
                        var extOptions = angular.extend(settings,
                            {
                                cssClass: 'stacked-buttons',
                                title: 'פירעון CalChoice',
                                btnClose:true,
                                template: '<header>לא נמצא כרטיס CalChoice המשוייך למנוי זה.<br/>CalChoice - הכרטיס היחיד המאפשר לך לבחור כמה לשלם בכל חודש.</header>',
                                buttons: [
                                    {
                                        text: 'להזמנת כרטיס',
                                        type: 'button-positive',
                                        onTap: function () {
                                            _api.navigate(null, { state: 'dw.wantCard' }, { code: '2204' });
                                        }
                                    },
                                    {
                                        text: 'ביטול',
                                        type: 'button-negative',
                                        onTap: (cancelCallBack) ? cancelCallBack : function () {
                                            _api.navigate(null, { state: 'dw.account-home' }, {});
                                        }
                                    }
                                ],
                            });

                        return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
                    },
                    calChoice: function () {
                        var extOptions = angular.extend(settings,
                            {
                                title: 'פירעון CalChoice',
                                btnClose: true,
                                template: '<header>כרטיס CalChoice מאפשר לכם לבחור בכל חודש מחדש את גובה סכום החיוב החודשי</header>',
                                buttons: [
                                    {
                                        text: 'לביצוע פירעון',
                                        type: 'button-positive',
                                        onTap: function () {
                                            _api.navigate(null, { state: 'dw.calchoicePayout' });

                                        }
                                    },
                                    {
                                        text: 'להזמנת כרטיס',
                                        type: 'button-positive',
                                        onTap: function () {
                                            _api.navigate(null, { state: 'dw.wantCard' }, { code: '2204' });
                                        }
                                    }
                                ],
                            });

                        return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
                    },
                    fixedDebit: function () {

                        var extOptions = angular.extend(settings,
                            {
                                cssClass: null,
                                title: 'חיוב חודשי קבוע',
                                template: '<header>קובעים מראש גובה חיוב חודשי קבוע בכרטיס, ואין הפתעות בסוף החודש!</header>',
                                buttons: [
                                    {
                                        text: 'לבחירת סכום',
                                        type: 'button-positive',
                                        onTap: function () {
                                            _api.navigate(null, { state: 'dw.fixedPayout' });
                                        }
                                    },
                                    {
                                        text: 'בפעם אחרת',
                                        type: 'button-negative',
                                        onTap: function () {
                                            return;
                                        }
                                    }
                                ],
                            });

                        return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
                    },
                    digitalVouchers: function (ctrlScope, title, body, url, urlParams, buttons, hideXBtn, buttonsLables, analyticsContent) {
                        var closeBtn = '';
                        if (!hideXBtn) {
                            var closeBtn = '<img class="close-popup" src="content/images/close.svg" ng-click="voucherClosepopup()" />';
                        }

                        buttonsLables = buttonsLables || {};

                        var extOptions = angular.extend(settings,
                            {
                                /*scope: ctrlScope,*/
                                title: '',
                                cssClass: 'vouchers-popup',
                                template: '<header>' + title + '</header><div>' + body + closeBtn + '</div>',
                                buttons: buttons || [
                                    {
                                        text: buttonsLables.OK || 'כן',
                                        type: 'button-positive',
                                        onTap: function () {
                                            if (analyticsContent) {
                                                googleAnalyticsService.trackPage(analyticsContent);
                                            }
                                            $rootScope.$broadcast('voucherSkipValidation');
                                            _api.navigate(null, { state: url }, urlParams);
                                        }
                                    },
                                    {
                                        text: buttonsLables.Cancel || 'לא',
                                        type: 'button-negative',
                                        onTap: function () {
                                            return;
                                        }
                                    }
                                ],
                            });

                        return $ionicPopup.show(extOptions);
                    },
                    loanLead: function () {

                        var extOptions = angular.extend(settings,
                            {
                                cssClass: 'loan-buttons',
                                template: '<i class="icon ico-loan"></i><header>הלוואה בהתאמה אישית ישירות לחשבון הבנק שלך</header><img class="close-popup" src="content/images/close.svg" ng-click="loanLeadClosePopup()">',
                                buttons: [
                                    {
                                        text: 'לקבלת הלוואה',
                                        type: 'button-positive',
                                        onTap: function () {
                                            _api.navigate(null, { state: 'dw.loanframe' });
                                        }
                                    },
                                    {
                                        text: 'מעדיף שתחזרו אליי',
                                        type: 'button-regular',
                                        onTap: function () {
                                            _api.navigate(null, { state: 'dw.wantLoan' });
                                        }
                                    }
                                ]
                            });

                        return $ionicPopup.show(extOptions);
                    },
                    noConnection: function () {
                        var extOptions = angular.extend(settings,
                            {
                                cssClass: null,
                                title: 'שגיאה קישורית',
                                template: '<header>אין חיבור לרשת.<br/>בדוק את החיבור ונסה שנית.</header>',
                                buttons: [
                                    {
                                        text: 'המשך',
                                        type: 'button-positive',
                                        onTap: function () {
                                            $window.location.reload();
                                            appData.noConnection = false;
                                            //_api.navigate('dw.lobby');
                                        }
                                    }
                                ],
                            });
                        return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
                    },
                    alert: function (text, title, buttonText, callback, buttons, isClose, cssClass) {

                        var extOptions = angular.extend({}, settings,
                            {

                                cssClass: (cssClass) ? cssClass : null,
                                title: (title) ? title : '',
                                template: '<header>' + text + '</header>',
                                btnClose: isClose,
                                buttons: (buttons) ? buttons : [
                                    {
                                        text: (buttonText) ? buttonText : 'סגור',
                                        type: 'button-positive',
                                        onTap: function () {
                                            if (callback && angular.isFunction(callback)) {
                                                return callback();
                                            }
                                        }
                                    }
                                ],

                            });
                        return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
                    },
                    message: function (template, text, title, css, buttonText, callback, buttons, isClose) {

                        var extOptions = angular.extend({}, settings,
                            {
                                cssClass: css,
                                title: (title) ? title : '',
                                templateUrl: template,
                                btnClose: isClose,
                                buttons: (buttons) ? buttons : [
                                    {
                                        text: (buttonText) ? buttonText : 'סגור',
                                        type: 'button-positive',
                                        onTap: function () {
                                            if (callback && angular.isFunction(callback)) {
                                                return callback();
                                            }
                                        }
                                    }
                                ],
                            });
                        return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
                    },
                    indicationMessage: function (templateText, subHeader, title, css, buttonText, callback, buttons, isClose) {
                        var extOptions = angular.extend({}, settings,
                            {
                                cssClass: css,
                                title: (title) ? (subHeader != null ? title + '<br/>' + subHeader : title) : '',
                                template: `
                                        <div class="cusotmer-indications-wrapper">
                                            <div class="indicator-text">`+ templateText + `</div>
                                        </div>
                                        `,
                                btnClose: isClose,
                                buttons: (buttons) ? buttons : [
                                    {
                                        text: (buttonText) ? buttonText : 'סגור',
                                        type: 'button-positive',
                                        onTap: function () {
                                            if (callback && angular.isFunction(callback)) {
                                                return callback();
                                            }
                                        }
                                    }
                                ],
                            });
                        return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
                    },
                    marketingMessage: function (template, cssClass, isClose,buttons) {
                        var extOptions = angular.extend({}, settings,
                            {
                                cssClass: cssClass,
                                templateUrl: template,
                                btnClose: false,
                                buttons: buttons,
                            });
                        return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
                    },
                    messageText: function (template, text, title, css, buttonText, callback, buttons, isClose) {
                        var extOptions = angular.extend({}, settings,
                            {
                                cssClass: css,
                                title: (title) ? title : '',
                                template: (template) ? '' : '<header>' + text + '</header>',
                                templateUrl: template,
                                btnClose: isClose,
                                buttons: (buttons) ? buttons : [
                                    {
                                        text: (buttonText) ? buttonText : 'סגור',
                                        type: 'button-positive',
                                        onTap: function () {
                                            if (callback && angular.isFunction(callback)) {
                                                return callback();
                                            }
                                        }
                                    }
                                ],
                            });
                        return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
                    },
                    messageWithScope: function (template, text, title, css, buttonText, callback, buttons, isClose, scope) {


                        var extOptions = angular.extend({}, settings,
                            {
                                cssClass: css,
                                title: (title) ? title : '',
                                templateUrl: template,
                                scope: scope,
                                btnClose: isClose,
                                buttons: (buttons) ? buttons : [
                                    {
                                        text: (buttonText) ? buttonText : 'סגור',
                                        type: 'button-positive',
                                        onTap: function () {
                                            if (callback && angular.isFunction(callback)) {
                                                return callback();
                                            }
                                        }
                                    }
                                ],
                            });
                        return $timeout(function () {
                            var ionicPop = $ionicPopup.show(extOptions);
                            angular.extend(scope, {
                                ionicPop
                            });
                        }, 200);
                    },
                    /* touch: */
                    alreadyTouchDelete: function (title) {
                        var extOptions = angular.extend(settings,
                            {
                                cssClass: null,
                                title: '',
                                template: '<header><p>' + title + '</header>',
                                buttons: [
                                    {
                                        text: 'סגור',
                                        type: 'button-positive',
                                        onTap: function () {
                                            touchKeyStore.removeKey();
                                            EncryptionService.setIsTouchReq(false);
                                            EncryptionService.setTouchTakanon(false);
                                        }
                                    }
                                ],
                            });
                        return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
                    },
                    expertionTouchTime: function (title) {
                        var extOptions = angular.extend(settings,
                            {
                                cssClass: null,
                                title: '',
                                template: '<header><p>' + title + '</header>',
                                buttons: [
                                    {
                                        text: 'הצטרפות',
                                        type: 'button-positive',
                                        onTap: function () {
                                            touchKeyStore.removeKey();
                                            EncryptionService.setIsTouchReq(false);
                                            EncryptionService.setTouchTakanon(false);
                                            $rootScope.$broadcast('logoutTouch');
                                            _api.navigate("dw.touch-taknon");
                                        }
                                    },
                                    {
                                        text: 'לא עכשיו',
                                        type: 'button-negative',
                                        onTap: function () {
                                            touchKeyStore.removeKey();
                                            EncryptionService.setIsTouchReq(false);
                                            EncryptionService.setTouchTakanon(false);
                                            $rootScope.$broadcast('logoutTouch');
                                        }
                                    }
                                ],
                            });
                        return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
                    },
                    abandonTouch: function (url, options) {
                        var extOptions = angular.extend(settings,
                            {
                                cssClass: null,
                                title: '',
                                template: '<header><p>האם אתה בטוח שברצונך לבטל את שירות זיהוי בטביעת אצבע?</p></header>',
                                buttons: [
                                    {
                                        text: 'אישור',
                                        type: 'button-positive',
                                        onTap: function () {
                                            _api.connection.deleteTouch().then(function (res) {
                                                console.log("deleteTouch");
                                                touchKeyStore.removeKey();
                                                EncryptionService.setIsTouchReq(false);
                                                EncryptionService.setTouchTakanon(false);
                                                $rootScope.$broadcast('logoutTouch');
                                                $('body').append('<div id="touchOverlay" class="touch-vilon-wrapper">' +
                                                    '<div class="touch-vilon-contant">' +
                                                    '<div class="touch-vilon-image"></div>' +
                                                    '<h3 class="touch-takanon-txt">הסרת שירות טביעת</h3>' +
                                                    '<h3 class="touch-takanon-txt">אצבע באפליקציה</h3>' +
                                                    '<h3 class="touch-vilon-success-text">בוצעה בהצלחה</h3>' +
                                                    '</div>' +
                                                    '</div>');

                                                setTimeout(function () {
                                                    $('#touchOverlay').remove();
                                                }, 3000);

                                            }, function (res) {
                                                console.log("deleteTouch error:", res);
                                                if (res[0].response.Response.Status.SeverityCode === "W" && res[0].response.Response.Status.SeverityNumber === "001") {
                                                    _api.popup.alreadyTouchDelete(res[0].response.Response.Status.Message);
                                                } else {
                                                    var errorService = $injector.get("errorService");
                                                    errorService.handleError(res, function () { }).then(function () { });
                                                }
                                            });
                                        }
                                    },
                                    {
                                        text: 'ביטול',
                                        type: 'button-negative',
                                        onTap: function () {

                                        }
                                    }
                                ],
                            });
                        return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
                    },
                    /* end touch: */
                    abandon: function (url, options) {
                        var extOptions = angular.extend(settings,
                            {
                                cssClass: null,
                                title: '',
                                template: '<header><p>האם אתה בטוח שברצונך לצאת מעמוד זה?</p><p>לתשומת לבך, פרטיך לא ישמרו.</p></header>',
                                buttons: [
                                    {
                                        text: 'אישור',
                                        type: 'button-positive',
                                        onTap: function () {
                                            appData.inProcess = false;
                                            try {
                                                switch (lobbyStateService.current.resolve().name()) {
                                                    case 'dw.calchoicePayout':
                                                        googleAnalyticsService.insertEvent({ page: 'Calchoice payment', eventName: 'Leave CalChoice Payment - Confirm', action: 'Click' });
                                                        break;
                                                    case 'dw.expressLoan':
                                                        googleAnalyticsService.insertEvent({ page: 'Credit Solutions', eventName: 'Leave Loan Request - Confirm', action: 'Click' });
                                                        break;
                                                    case 'dw.fixedPayout':
                                                        googleAnalyticsService.insertEvent({ page: 'Credit Solutions', eventName: 'Leave Monthly Payments - Confirm', action: 'Click' });
                                                        break;
                                                    default:
                                                }
                                            } catch (e) {

                                            }

                                            _api.navigate(url, options);
                                        }
                                    },
                                    {
                                        text: 'ביטול',
                                        type: 'button-negative',
                                        onTap: function () {
                                            //appData.inProcess = true;
                                            try {
                                                switch (lobbyStateService.current.resolve().name()) {
                                                    case 'dw.calchoicePayout':
                                                        googleAnalyticsService.insertEvent({ page: 'Calchoice payment', eventName: 'Leave CalChoice Payment - Cancel', action: 'Click' });
                                                        break;
                                                    case 'dw.expressLoan':
                                                        googleAnalyticsService.insertEvent({ page: 'Credit Solutions', eventName: 'Leave Loan Request - Cancel', action: 'Enter' });
                                                        break;
                                                    case 'dw.fixedPayout':
                                                        googleAnalyticsService.insertEvent({ page: 'Credit Solutions', eventName: 'Leave Monthly Payments - Cancel', action: 'Enter' });
                                                        break;
                                                    default:
                                                }
                                            } catch (e) {

                                            }
                                            return;
                                        }
                                    }
                                ],
                            });
                        return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
                    }
                }
            })(),

            modalDialog: (function () {
                _api = null;
                /***
            /* handling abandon behavior via modal dialog element
            /******/
                return _api = {
                    create: function (template) {
                        $ionicModal.fromTemplateUrl(template, {
                            scope: $rootScope,
                            animation: 'slide-in-up'
                        }).then(function (modal) {
                            $rootScope.modal = modal;
                        });
                        return _api;
                    },
                    show: function () {
                        $rootScope.$on('$destroy', function () {
                            $rootScope.modal.remove();
                        });
                        // Execute action on hide modal
                        $rootScope.$on('modal.hide', function () {
                            // Execute action
                        });
                        // Execute action on remove modal
                        $rootScope.$on('modal.removed', function () {
                            // Execute action
                        });

                        // return a promise to ve resolved when show animation ends
                        $timeout(function () { $rootScope.modal.show(); }, 100);
                    },
                    hide: function () {
                        // return a promise to ve resolved when hide animation ends
                        return $rootScope.modal.hide();
                    }
                }
            })(),
            preloadImages: function (images) {
                /***
            /* handling pre loading of images 
            /******/

                var dfdAll = $q.defer();

                // handle each image loading, track success | failure indication for each one
                var loadOne = function (item) {
                    $('<img />').attr('src', item.path)
                        .on('load', function () {
                            item.success = true;
                            item.dfd.resolve();
                        })
                        .on('error', function () {
                            item.success = false;
                            item.dfd.resolve();
                        });
                }

                // create & save an array of loading promisses, one for each image 
                var promisses = [];
                for (var i = 0; i < images.length; i++) {
                    promisses.push($.extend({}, { id: i, path: images[i], dfd: $q.defer(), success: false }));
                }

                // wait for all loading promisses to be completed
                $q.all($.map(promisses, function (item) {
                    return item.dfd.promise;
                })).then(function () {
                    // create a collection of successfuly loaded urls 
                    var loaded = $.map(promisses, function (item) {
                        if (item.success) {
                            return { id: ++i, image: item.path }
                        }

                        return null;
                    });
                    // resolve all promisses, return to caller
                    dfdAll.resolve(loaded);
                });

                // try load each image
                for (var j = 0; j < promisses.length; j++) {
                    loadOne(promisses[j]);
                }

                return dfdAll.promise;
            },
            loader: {
                hide: function () {
                    $ionicLoading.hide();
                },
                show: function () {

                //    var _template = '<div class="animation ion-loading-c" role="alert" aria-busy="true"></div><div class="msg">טוען נתונים...</div>';
                    var _template = '<div class="cal-loading-new"></div>';
                    $ionicLoading.show({
                        template: _template
                    });
                }
            },
            openExternal: function (url, platforms, isExternal) {
                if (isExternal) {
                    var target = url;
                    var ua = navigator.userAgent.toLowerCase();

                    if (ua.indexOf("android") > -1) {
                        return window.open(target, '_blank', 'location=yes');
                    } else {
                        return window.open(target, '_blank', 'location=yes,enableViewportScale=yes,closebuttoncaption=סגור');
                    }
                }
                else {
                    window.location.href = url;
                }

                return false;
            },
            setWindowHeight: function (offsetSub) {
                if (!offsetSub) {
                    offsetSub = 32;
                }
                var contentHeight = parseInt(screen.height - offsetSub);
                if (parseInt(contentHeight) < 528)
                    contentHeight = 528;
                angular.element(".scroll").css('min-height', contentHeight + "px");
            },
            hideNavBar: function () {
                try {
                    $timeout(function () {
                        return dataService.sessionManager.read('hidenavbar') || false;
                    },3000)
                  

                } catch (ex) {
                    console.log(ex);
                    return false;

                }
            }
        }

    }

})(window, window.angular, _);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('lobbyStateService', lobbyStateService);

    lobbyStateService.$inject = ['$state', '$rootScope', '$stateParams', '$location'];

    function lobbyStateService($state, $rootScope, $stateParams, $location) {
        // ****
        // wrap, manage, parse & query the current state (from ui state router)
        // all methods under 'current' api element referes to the current ui state
        // ********
        var _api;
        var resolveState = function(target) {

            var _current = target || $state.current;
            return $.extend({}, _current,
            {
                getData: function() {
                    if (this.hasData()) {
                        return _current.data;
                    }
                    return undefined;
                },
                getParams: function(key) {
                    if (!key) {
                        return $state.params;
                    } else {
                        return $state.params[key];
                    }
                },
                name: function() {
                    // get the current path (location)
                    return _current.name;
                },
                path: function() {
                    // get the current path (location)
                    return _current.url.source;
                },
                hasData: function() {
                    // parse the data attached to the current state
                    return typeof (_current.data) != 'undefined';
                },
                isModuleView: function() {
                    if (this.hasData()) {
                        // parse the 'module' parameter on the data object attached to the current state
                        return typeof (_current.data.module) == 'number';
                    }
                    return false;
                },
                isLobbyView: function() {
                    if (this.hasData()) {
                        return typeof (_current.data.lobby) != 'undefined';
                    }
                    return false;
                },
                isLoginView: function() {
                    return $state.is('dw.login');
                },
                is357View: function() {
                    return $state.is('dw.register357');
                }
            });
        };

        var _goToState = function(url, routeParams, stateParams) {
            //console.log('going to ' + url + ' :: route params: ' + JSON.stringify(routeParams) + ' :: state params: ' + JSON.stringify(stateParams));            

            /*if (url === 'dw.login') {
                if (!stateParams) {
                    stateParams = {};
                }

                stateParams.location = 'replace';
            }*/
            $state.go(url, routeParams, stateParams);
        };

        var goToLocation = function(url) {
            $location.path(url.replace('#', ''));
        };

        var _checkConnection = function() {

            if (!navigator || !navigator.connection)
                return true;

            var networkState = navigator.connection.type;

            return networkState != navigator.connection.NONE;

            /*var states = {};
        states[Connection.UNKNOWN]  = 'Unknown connection';
        states[Connection.ETHERNET] = 'Ethernet connection';
        states[Connection.WIFI]     = 'WiFi connection';
        states[Connection.CELL_2G]  = 'Cell 2G connection';
        states[Connection.CELL_3G]  = 'Cell 3G connection';
        states[Connection.CELL_4G]  = 'Cell 4G connection';
        states[Connection.CELL]     = 'Cell generic connection';
        states[Connection.NONE]     = 'No network connection';

        return  states[Connection.NONE];*/
        }

        _api = {
            current: {
                resolve: resolveState,
                goToState: _goToState,
                goToLocation: goToLocation,
                checkConnection: _checkConnection
            }
        };

        return _api;
    }
})(window, window.angular);
﻿(function (window, angular, _) {
    'use strict';
    angular.module("digitalWallet")
    .factory('httpInterseptorService', httpInterseptorService);

    httpInterseptorService.$inject = ['$rootScope', '$q'];

    function httpInterseptorService($rootScope, $q) {

        return {
            request: function (config) {

                var canceler = $q.defer();

                config.timeout = canceler.timeout;
                if (config.url.indexOf('.html') > -1) {
                } else {
                    if (!navigator || !navigator.connection) {
                    } else {
                        var networkState = navigator.connection.type;

                        if (networkState == navigator.connection.NONE) {
                            $rootScope.$broadcast('noConnection');
                            canceler.resolve();
                        }
                    }
                }

                return config || $q.when(config);
            }
        };


    }
})(window, window.angular, _);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('lobbyCommService', lobbyCommService);

    lobbyCommService.$inject = ['appSettings'];

    function lobbyCommService(appSettings) {
        // ****
        // wraps & handles the communication actions
        // ********
        return {
            connection: {},
            getMetaData: function () {
                var versionWasNotDisplayed = false;
                var isNewVersion = window.localStorage.getItem("IS_NEW_VERSION");
                if (isNewVersion == 'undefined' || isNewVersion === null) {
                    versionWasNotDisplayed = true;
                }
                else if (isNewVersion != 'undefined' && isNewVersion != appSettings.version)
                    versionWasNotDisplayed = true;
                return this.connection.genericConnection('GET', 'CalWalletMetaData?', 'IsNewVersion=' + versionWasNotDisplayed + '&CurrentVersion=' + appSettings.version + '&OperatingSystem=' + appSettings.os);
            },
            getDocument: function (docName) {
                return this.connection.genericConnection('GET', 'caldocs?', 'CurrentVersion=' + appSettings.version + '&OperatingSystem=' + appSettings.os + '&id=' + docName);
            },
            insertSsoDetails: function (cardId) {
                return this.connection.genericConnection('POST', 'CalSso/', cardId + '?' + 'CurrentVersion=' + appSettings.version + '&OperatingSystem=' + appSettings.os);
            },
            inserNewChatDetails: function (pageUrl) {
                return this.connection.genericConnection('PUT', 'Chat/InserNewChatDetails', '?' + 'CurrentVersion=' + appSettings.version + '&OperatingSystem=' + appSettings.os, '{"pageUrl":"' + pageUrl + '"}');
            },
            insertOnlineFormsDetails: function () {
                return this.connection.genericConnection('POST', 'OnlineForms', '?' + 'CurrentVersion=' + appSettings.version + '&OperatingSystem=' + appSettings.os);
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular, _) {
    'use strict';
    angular.module("digitalWallet")
        .factory('lobbyDataService', lobbyDataService);

    lobbyDataService.$inject = ['$state', '$rootScope', '$http', '$q', 'lobbyStateService', 'lobbyCommService', 'appSettings'];

    function lobbyDataService($state, $rootScope, $http, $q, lobbyStateService, lobbyCommService, appSettings) {
        // ****
        // handles data (mainly metameta) manipulation & process
        // ********
        var _api;
        var _metaData = null;
        var _restricted = {};

        var assertMetaData = function(data) {

            for (var i = 0; i < data.menu.length; i++) {
                var items = data.menu[i].items;
                if (items) {
                    for (var j = 0; j < items.length; j++) {
                        if (items[j].state) {
                            _restricted[items[j].state] = items[j].restricted;
                        }
                    }
                }
            }
        }

        var metadataPromise;
        var loadMetaData = function () {
            if (metadataPromise) {
                return metadataPromise;
            }

            metadataPromise = lobbyCommService.getMetaData()
                                   .then(function (response) {
                                       console.info("load metadata");
                                       _metaData = response.ResponseMetaDataEntity;
                                       assertMetaData(_metaData);
                                       $rootScope.$broadcast('lobbyEvent::MetaDataLoaded', _metaData);
                                       return _metaData;
                                   }, function (error) {
                                       throw error;
                                   });

            return metadataPromise;
        }

        var loadHtmlDocument = function(docName) {
            var q = $q.defer();
            lobbyCommService.getDocument(docName + '.html')
                .then(function(response) {
                        return q.resolve(response);
                    }, function(error) {
                        return q.reject(error);
                    }
                );

            return q.promise;
        }


        // parse side menu items, sort both top level & sub level items
        var getMenuItems = function() {
            return _metaData.menu.sort(function(a, b) {
                if (a.items) {
                    a.items.sort(function(a1, a2) {
                        return parseFloat(a1.index) - parseFloat(a2.index);
                    });
                }
                return parseFloat(a.index) - parseFloat(b.index);
            });
        }

        // parse module items, sort both modules & each module's banners
        var getModuleItems = function() {
            if (_metaData) {
                return _metaData.modules.sort(function(a, b) {
                    if (a.banners) {
                        a.banners.sort(function(a1, a2) {
                            return parseFloat(a1.index) - parseFloat(a2.index);
                        });
                    }
                    return parseFloat(a.index) - parseFloat(b.index);
                });
            }
            return [];
        }

        var getFirstTimeBannersItems = function () {
            if (_metaData) {
                //console.log('_metaData = ' + JSON.stringify(_metaData));
                return _metaData.FirstTimeBanners;    
            }
            return [];
        }

        // select a menu node by id (see utils.js for 'normalize()' method)
        var selectMenuNode = function(nodeId) {
            var menuItems = getMenuItems();
            return $.grep(menuItems, function(menuItem) {
                return (nodeId == menuItem.id);
            }).normalize();
        }

        // get the menu node for each module
        var modulesMenuItems = function() {
            // gets the default level: top (envelope) view
            var moduleItems = getModuleItems();
            return $.map(moduleItems, function(module) {
                if (module.menuId) {
                    return selectMenuNode(module.menuId);
                }
                return undefined;
            }).sort(function(a, b) {
                return parseFloat(a.index) - parseFloat(b.index);
            });
        }

        // get the sphere menu nodes
        var sphereMenuItems = function() {
            var sphereItems = modulesMenuItems();
            // manualy add a 'home' button (TODO: replace this with home button from metadata)
            sphereItems.unshift({ caption: '', icon: 'ico-home', url: '#/', index: 1, state: 'dw.lobby' });
            return sphereItems;
        }

        // construct the lobby modules menu
        var lobbyMenuItems = function() {
            
            var display = 0;
            var items = [],
                module = undefined,
                state = lobbyStateService.current.resolve();

            // get the current module id from state object
            if (state.hasData() && !state.isLobbyView()) {
                var moduleItems = getModuleItems();
                // get the module data object from local collection
                module = $.grep(moduleItems, function(n) {
                    return (state.data.module == n.id);
                }).normalize();

                if (module) {
                    // get the specified module menu data nodes
                    var nodes = selectMenuNode(module.menuId);
                    if (nodes) {
                        items = nodes.items;
                        display = nodes.display;
                    }
                }
            }
            // fall back to default top most level menu
            if (items && items.length == 0) {
                // gets the default level: top (envelope) view
                items = modulesMenuItems();
                // make sure items are sorted
                items.sort(function (a, b) {
                    return parseFloat(a.moduleIndex) - parseFloat(b.moduleIndex);
                });
            }
         
            return {
                parent: module,
                items: items,
                display: display
            }
        }

        var getModule = function(targetState) {
            var state = lobbyStateService.current.resolve(targetState);

            if (state.hasData()) {
                // get the module data object from local collection
                var moduleItems = getModuleItems();

                return $.grep(moduleItems, function(n) {
                    return (state.data.module == n.id);
                }).normalize();
            }

            return null;
        }

        // get the banners for the active module
        var getModuleBanners = function() {
            var module = getModule();

            if (module) {
                return module.banners.sort(function(a, b) {
                    return parseFloat(a.moduleIndex) - parseFloat(b.moduleIndex);
                });
            }
            return [];
        }

        var getCallCenters = function() {

            var deffered = $q.defer();

            if (_metaData)
                deffered.resolve(_metaData.callCenters);
            else {
                loadMetaData().then(function(res) {
                    deffered.resolve(res.callCenters);
                });
            }
            return deffered.promise;
        }

        var getVersion = function() {
            //return _metaData.application.version;
            return appSettings.version;
        }
        var getLastEntryDate = function() {
            return _metaData.application.lastEntry;
        }

        //var getMetaDataTimeout = function() {
        //    return MetaDataTimeout;
        //}
        //var MetaDataTimeout = 30000;
        //var isMetaDataReady = function(counter, deffered) {
        //    var ellapsed = MetaDataTimeout - counter;
        //    //console.log('----- waiting for meta data ' + ellapsed / 1000 + ' seconds ellapsed..');
        //    if (typeof _metaData != 'undefined' && _metaData != null) {
        //        //console.log('----- meta data ready after ' + ellapsed / 1000 + ' seconds ..');
        //        deffered.resolve();
        //    } else if (counter > 1000) {
        //        counter -= 1000;

        //        setTimeout(function() {
        //            isMetaDataReady(counter, deffered);
        //        }, 1000);
        //    } else {
        //        deffered.reject();
        //    }
        //}

        //var waitForMetaData = function() {
        //    var q = $q.defer();
        //    isMetaDataReady(MetaDataTimeout, q);
        //    return q.promise;
        //}

        var dataReady = function() {
            return typeof _metaData != 'undefined' && _metaData != null;
        }

        var getAppPageRoute = function(apppageid) {
            var deferMetaData = $q.defer();

            if (!apppageid) {
                deferMetaData.reject(null);
            } else {
                loadMetaData().then(function() {

                    var pageid = parseInt(apppageid, 10);

                    var selectedItem;

                    _.each(_metaData.menu, function(menu) {
                        if (menu.id == pageid) {
                            selectedItem = menu;
                            return;
                        }

                        var itms = _.findWhere(menu.items, { id: pageid });

                        if (itms) {
                            selectedItem = itms;
                            return;
                        }
                    });

                    deferMetaData.resolve(selectedItem ? selectedItem.state : null);

                    return deferMetaData.promise;
                });
            }

            return deferMetaData.promise;
        }

        var getMetaData = function(section) {
            for (var node in _metaData) {
                if (_metaData[node] != null && section == node) {
                    return _metaData[node];
                }
            }
            return undefined;
        }

        // determin if navigation url requires authorization before executing
        // menu item is checked, then its parent (can hold global restriction for all children)
        var getNavRestriction = function(state) {
            return _restricted[state] == true;
        }

        var getMenuNode = function() {
            return $.grep(_metaData.menu, function(n) {
                if (n.menuId == id) {
                    return n;
                }
                if (n.items) {
                    return $.grep(n.items, function(n1) {
                            if (n1.menuId == id) {
                                return n1;
                            }

                            return null;
                        }
                    );
                }
                return undefined;
            });
        }

        // parse & process metadata
        _api = {
            getModule: getModule,
            getMenuNode: getMenuNode,
            getNavRestriction: getNavRestriction,
            //getMetaDataTimeout: getMetaDataTimeout,
            dataReady: dataReady,
            //waitForMetaData: waitForMetaData,
            loadHtmlDocument: loadHtmlDocument,
            loadMetaData: loadMetaData,
            sideMenuItems: getMenuItems,
            moduleMenuItems: lobbyMenuItems,
            sphereMenuItems: sphereMenuItems,
            modules: getModuleItems,
            firstTimeBanners: getFirstTimeBannersItems,
            moduleBanners: getModuleBanners,
            metaData: getMetaData,
            getAppPageRoute: getAppPageRoute,
            getCallCenters: getCallCenters,
            getVersion: getVersion,
            getLastEntryDate: getLastEntryDate
        }

        return _api;
    }
})(window, window.angular, _);
﻿(function (window, angular, _) {
    'use strict';
    angular.module("digitalWallet")
    .factory('googleAnalyticsService', googleAnalyticsService);

    googleAnalyticsService.$inject = ['$location', 'appData'];

    function googleAnalyticsService($location, appData) {
        var _isDebug = false;
        var actionDictionary =
        {
            'all pages': {
                //sphere
                0: 'loby-home',
                10: 'account-home',
                20: 'benefits-home',
                30: 'wallet-home',
                40: 'customerService-home',
                50: 'calhull',
                60: 'generalActions'
            },
            'lobby': {
                // cal4u              
                11: 'myaccount',
                12: 'loans',
                13: 'fixedPayout',
                14: 'calchoicePayout',
                15: 'debitSpread',
                16: 'paymentSpread',
                17: 'enlargecreditframe',
                18: 'calmail-list',
                19: 'Bank-Charges',

                // benefits
                21: 'cal-store',
                22: 'diners-store',
                23: 'benefitaround',
                24: 'cinemaDiners',
                25: 'calpreflight',
                26: 'dinerspreflight',
                27: 'search-transaction',
                28: 'new1',

                // my wallet
                31: 'vouchers',
                32: 'cashback',
                33: 'p2p',
                34: 'designedcards',
                35: 'roundedforgood',
                36: 'blockhome',
                37: 'blockCard',
                38: 'activateCard',
                39: 'defectiveCard',

                // customer service
                41: 'contactcal',
                42: 'chat',
                43: 'myReferrals',
                44: 'internetCode',
                45: 'emailUpdate',
                46: 'wantCard',
                47: 'trackmycard',
                48: 'wa-chat',
                49: 'insights',

                //calhull
                51: 'mycode',
                52: 'insurance',
                53: 'abroadbenefits',
                54: 'sixt',
                55: 'shicor',
                56: 'arkia',
                57: 'simterra',
                58: 'lupa',
                59: 'traklin',

                61: 'lobby-hok',
                62: 'new2',
                63: 'new3',
                64: 'new4',
                65: 'new5'

            },

            'hamburger': {

                10: 'account-home-Hamburger',
                11: 'myaccount-Hamburger',
                12: 'loans-Hamburger',
                13: 'fixedPayout-Hamburger',
                14: 'calchoicePayout-Hamburger',
                15: 'debitSpread-Hamburger',
                16: 'paymentSpread-Hamburger',
                17: 'enlargecreditframe-Hamburger',
                18: 'calmail-list-Hamburger',
                19: 'Bank Charges-Hamburger',
                20: 'benefits-home-Hamburger',
                21: 'cal-store-Hamburger',
                22: 'diners-store-Hamburger',
                23: 'benefitaround-Hamburger',
                24: 'cinemaDiners-Hamburger',
                25: 'calpreflight-Hamburger',
                26: 'dinerspreflight-Hamburger',
                27: 'search-transaction-Hamburger',
                28: 'new1-Hamburger',
                30: 'wallet-home-Hamburger',
                31: 'vouchers-Hamburger',
                32: 'cashback-Hamburger',
                33: 'p2p-Hamburger',
                34: 'designedcards-Hamburger',
                35: 'roundedforgood-Hamburger',
                36: 'blockhome-Hamburger',
                37: 'blockCard-Hamburger',
                38: 'activateCard-Hamburger',
                39: 'defectiveCard-Hamburger',
                40: 'customerService-home-Hamburger',
                41: 'contactcal-Hamburger',
                42: 'chat-Hamburger',
                43: 'myReferrals-Hamburger',
                44: 'internetCode-Hamburger',
                45: 'emailUpdate-Hamburger',
                46: 'wantCard-Hamburger',
                47: 'rackmycard-Hamburger',
                48: 'wa-chat-Hamburger',
                49: 'insights-Hamburger',
                50: 'calhull-Hamburger',
                51: 'mycode-Hamburger',
                52: 'insurance-Hamburger',
                53: 'abroadbenefits-Hamburger',
                54: 'sixt-Hamburger',
                55: 'shicor-Hamburger',
                56: 'arkia-Hamburger',
                57: 'simterra-Hamburger',
                58: 'lupa-Hamburger',
                59: 'traklin-Hamburger',
                61: 'lobby-hok',
                62: 'new2-Hamburger',
                63: 'new3-Hamburger',
                64: 'new4-Hamburger',
                65: 'new5-Hamburger',
                90: 'Legal-terms-Hamburger',
                91: 'amlot-Hamburger',
                92: 'Information-security-Hamburger',
                93: 'logout-touch-Hamburger',
                94: 'logout-info-Hamburger',
                95: 'Logout-Hamburger'
            },

            'login': {
                1: 'Login - Entrance',
                2: 'Login - ID',
                3: 'Login - ID - continue',
                4: 'Login - ID - send',
                5: 'Login - Click 2 Call'
            },
            'shtifomat': {
                1: 'Car type - entrance',
                2: 'Car type continue - entrance',
                3: 'Shtifomat - correction',
                4: 'Shtifomat - confirmation',
                5: 'Shtifomat - remove',
                6: 'Shtifomat - Thank you',
            }
        }


        



    var getEvent = function (key, id) {
        return actionDictionary[key][id];
    };

    var _trackPage = function (pageName) {

        if(_isDebug){
            console.log('ga: track page', pageName);
            return;
        }

        try {

            if (ga) {
                pageName += getPageSuffix(pageName);
                //window.analytics.trackView(pageName);
                ga('send', 'pageview', pageName);
            }
        } catch (ex) {
        }
    }

    var _insertEvent = function (option) {
        if (_isDebug) {
            console.log('ga: track event', option);
            return;
        }
        try {

            if (ga) {

                var pageName;
                var eventName;
                var action;

                if (option.action) {
                    action = option.action;
                } else {
                    action = 'Click';
                }


                if (option.eventName) {
                    eventName = option.eventName;
                } else {
                    eventName = getEvent(option.page, option.id);
                }


                if (!option.page) {
                    pageName = $location.path().substring($location.path().lastIndexOf('#/') + 2);
                } else {
                    pageName = option.page;
                }
                    
                pageName += getPageSuffix(eventName);


                ga('send', 'event', pageName, action, eventName, 1);
                //window.analytics.trackEvent(pageName, action, eventName, 1);
            }
        } catch (ex) {
        }

    }



        var getPageSuffix = function (eventName) {
            var suffix = '';
            var regEx = new RegExp('calchoice|loan');
            if (appData.BankAccounts && eventName &&
                regEx.test(eventName.toLowerCase())) {                
                var currentBankAccountIndex = appData.selectedBankAccountIndex || 0;
                suffix = '?manpik=';
                suffix += appData.BankAccounts[currentBankAccountIndex].Cards[appData.shownCardIndex || 0].IsIssuedByCalInd ? 'Regular' : 'External';
            }

            return suffix;
        }
         



        var _api = {
            insertEvent: _insertEvent,
            trackPage: _trackPage,
            isDebug: _isDebug
        }

        return _api;
    }
})(window, window.angular, _);

﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('nativeAppBannerService', nativeAppBannerService);

    nativeAppBannerService.$inject = ['googleAnalyticsService'];

    function nativeAppBannerService(googleAnalyticsService) {

        function init() {
            window.addEventListener('beforeinstallprompt', function () {
                googleAnalyticsService.insertEvent({ page: 'מותאם', eventName: 'הופעה', action: 'באנר התקנת אפליקציה' });
            });

            window.addEventListener('appinstalled', function () {
                googleAnalyticsService.insertEvent({ page: 'מותאם', eventName: 'התקנה', action: 'באנר התקנת אפליקציה' });
            });
        }

        return {
            init: init
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('lobbyStorageService', lobbyStorageService);

    lobbyStorageService.$inject = ['$angularCacheFactory', 'appData', '$timeout'];

    function lobbyStorageService($angularCacheFactory, appData, $timeout) {

        var cache = $angularCacheFactory('dwLobbyCache');
        return {
            metaData: function (data) {
                if (data) {
                    cache.put('LobbyMetaData', data);
                }
                return cache.get('LobbyMetaData');
            },
            clearAppData: function () {

                $angularCacheFactory.clearAll();

                $timeout.cancel(appData.sessionTimeout);
                appData.BankAccounts = {};
                appData.selectedBankAccountIndex = 0;
                appData.shownCardIndex = 0;

                if (appData.myAccount)
                    appData.myAccount.status = 0;

                appData.token = null;
            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .service('register357Service', register357Service);

    register357Service.$inject = ['connection', '$ionicPopup'];

    function register357Service(connection, $ionicPopup) {
        var _initData = [
            {
                channel: {
                    id: 1,
                    name: 'דואר'
                },
                levels: [
                    { id: 1, name: 'לא מעוניין' },
                    { id: 2, name: 'מעוניין בקבלת מידע' },
                    { id: 3, name: 'מעוניין בביצוע פעולות וקבלת מידע' }
                ],
                selected: {
                    channelId: 1,
                    levelId: 3
                }
            },
            {
                channel: {
                    id: 2,
                    name: 'מענה קולי'
                },
                levels: [
                    { id: 1, name: 'לא מעוניין' },
                    { id: 2, name: 'מעוניין בקבלת מידע' },
                    { id: 3, name: 'מעוניין בביצוע פעולות וקבלת מידע' }
                ],
                selected: {
                    channelId: 2,
                    levelId: 3
                }
            },
            {
                channel: {
                    id: 3,
                    name: 'sms'
                },
                levels: [
                    { id: 1, name: 'לא מעוניין' },
                    { id: 2, name: 'מעוניין בקבלת מידע' },
                    { id: 3, name: 'מעוניין בביצוע פעולות וקבלת מידע' }
                ],
                selected: {
                    channelId: 3,
                    levelId: 3
                }
            },
            {
                channel: {
                    id: 4,
                    name: 'אתר אינטרנט'
                },
                levels: [
                    { id: 1, name: 'לא מעוניין' },
                    { id: 3, name: 'מעוניין בביצוע פעולות וקבלת מידע' }
                ],
                selected: {
                    channelId: 4,
                    levelId: 3
                }
            }
        ];

        var _isOtp = null;
        var _is357Done = null;

        return {
            getInitData: function () {
                return _initData;
            },
            update: function (data) {

                var request = {};
                request.channelsDefConstant = 21;
                request.channels = new Array();

                for (var i = 0, length = data.length; i < length; i++) {
                    request.channels[i] = {};
                    request.channels[i].channelID = data[i].selected.channelId;
                    request.channels[i].levelID = data[i].selected.levelId;
                }

                return connection.genericConnection('POST', 'CustDetails357/update?', connection.versionAndOSParams, request);
            },
            getMessage: function (message, callback) {
                var popupWindow = $ionicPopup.show({
                    title: message,
                    buttons: [
                        { text: 'סגור', type: 'button-positive' }
                    ]
                });

                popupWindow.then(function (res) {
                    callback(res);
                });
            },
            isNotRegistered357: function (response) {
                return response.Status.SeverityCode == 'S' && response.Status.SeverityNumber == '002';
            },
            setOtp: function (isOtp) {
                _isOtp = isOtp;
            },
            getIsOtp: function () {
                return _isOtp;
            },
            set357Done: function () {
                _is357Done = true;
            },
            is357Done: function () {
                return _is357Done != null ? _is357Done : false;
            },
            isInternetAndCellularChecked: function (channels, internetIndex, cellularIndex) {
                return channels[internetIndex].selected.levelId == 3 &&
                    channels[cellularIndex].selected.levelId == 3;
            },
            isInternetChecked: function (channels, internetIndex) {
                return channels[internetIndex].selected.levelId == 3;
            }
        };
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
    .factory('SmsService', SmsService);

    SmsService.$inject = ['$q'];

    function SmsService($q) {

        var _deffered;

        var smsplugin;

        ionic.Platform.ready(function () {
            if (window.plugins && ionic.Platform.isAndroid())
                smsplugin = cordova.require("info.asankan.phonegap.smsplugin.smsplugin");

        });

        var options = {
            sourcePhoneNumber: 'Cal2Login',
            regexPattern: new RegExp(/\d+/)
        };

        var _isPhoneNumberExists = function (phoneNumber, sourcePhoneNumber) {
            if (sourcePhoneNumber[0] == '0') {
                sourcePhoneNumber = sourcePhoneNumber.substring(1, sourcePhoneNumber.length - 1);
            }

            return phoneNumber.indexOf(sourcePhoneNumber) != -1;
        }

        var _parseData = function (message, regexPattern) {
            return regexPattern.exec(message);
        }

        var _start = function () {
            _deffered = $q.defer();
            if (smsplugin) {
                smsplugin.startReception(function (data) {
                    if (data === undefined || data === null) return;

                    var result = data.split(/>/);

                    var phoneNumber = result[0];
                    var message = result[1];
                    var code;

                    if (_isPhoneNumberExists(phoneNumber, options.sourcePhoneNumber)) {

                        code = _parseData(message, options.regexPattern);

                        _deffered.resolve(code);

                        smsplugin.stopReception();
                    }
                }, function () {
                    _deffered.reject(data);
                    smsplugin.stopReception();
                });
            } else {
                _deffered.reject('not supported');
            }

            return _deffered.promise;
        }

        return {
            getOtpPassword: _start
        }
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('accountService', accountService);

    accountService.$inject = ['appData', 'connection', 'lobbyUiService', '$location', '$timeout', '$q', 'dataService', '$rootScope', 'errorService'];

    function accountService(appData, connection, lobbyUiService, $location, $timeout, $q, dataService, $rootScope, errorService) {
        var _self;

        function loginSso() {
            _self = this;
            var defer = $q.defer();

            var queryString = $location.search();
            var sid = queryString.sid;
            var bsid = queryString.bsid;
            var OTPToken = queryString.OTPToken;
            var sessionID = queryString.sessionID;
            var ssoPromise;
            var isSSO;
            if (OTPToken && OTPToken.length && OTPToken.length > 0 && sessionID && sessionID.length && sessionID.length > 0) {
                isSSO = true;
                if (!appData.metaData) {
                    ssoPromise = {};
                    connection.getMetaData().then(function (resMetadata) {
                        appData.metaData = resMetadata;
                        ssoPromise = execSsoFromExternalSys(OTPToken, sessionID)
                            .then(function (result) {
                                sid = result;
                            });

                        $q.all([ssoPromise]).then(function () {
                            defer.resolve(ssoGuid(sid));
                        }, function () {
                            defer.reject();
                        });
                    });
                }
                else {
                    ssoPromise = execSsoFromExternalSys(OTPToken, sessionID)
                        .then(function (result) {
                            sid = result;
                            defer.resolve(ssoGuid(sid));
                        }, function () {
                            defer.reject();
                        });
                }
            }

            /*isSSO && $q.all([ssoPromise]).then(function () {
                defer.resolve(ssoGuid(defer, sid));
            })*/

            if (!isSSO) {
                //if bank replace sid val with bsid val.
                if (bsid) {
                    sid = bsid;
                }
                $timeout(function () {
                    defer.resolve(ssoGuid(sid));
                }, function () {
                    defer.reject();
                });
            }

            return defer.promise;
        }

        function ssoGuid(sid) {
            var defer = $q.defer();
            if (sid && sid.length && sid.length > 0) {

                var ssoRequest = buildSsoRequest(sid);
                $location.search().sid = null;

                if (!appData.metaData) {
                    connection.getMetaData().then(function (resMetadata) {
                        appData.metaData = resMetadata;
                        return execSso(ssoRequest, defer);
                    });
                }
                else {
                    $timeout(function () {
                        return execSso(ssoRequest, defer);
                    });
                }
            }
            else {
                $timeout(function () {
                    defer.resolve();
                })
            }

            return defer.promise;
        }

        function execSso(ssoRequest, defer) {
            //var defer = $q.defer();
            connection.ssoLogin(ssoRequest)
                .then(function (response) {
                    if (response) {
                        return _self.getAccount(response, defer);
                    }
                }, function () {
                    defer.reject();
                });

            return defer.promise;
        }

        function execSsoFromExternalSys(OTPToken, SessionID) {
            var defer = $q.defer();
            connection.ssoLoginFromExternalSystem(OTPToken, SessionID)
                .then(function (response) {
                    if (response) {
                        defer.resolve(response.Guid);
                    }
                }, function () {
                    defer.reject();
                });
            return defer.promise;
        }

        function buildSsoRequest(sid) {
            return {
                hash: sid,
                type: 1 //SSO
            };
        }

        function filterAccountByIsEffective(accounts) {
            var copyAccounts = angular.copy(accounts);

            var filterAccounts = [];

            _.each(copyAccounts, function (account) {
                var filterCards = _.filter(account.Cards, function (card) {
                    return card.IsEffectiveInd == true;
                });

                if (filterCards.length > 0) {
                    account.Cards = filterCards;
                    filterAccounts.push(account);
                }
            });

            return filterAccounts;
        }

        function getAccount(loginRes, defer) {
            //var defer = $q.defer();
            if (loginRes) {
                connection.setToken(loginRes.calConnectToken);
            }
            var accountPromise = connection.getAccount();
            accountPromise.then(function (response) {
                appData.CustomerInfo = response.CustomerInfo;
                appData.BankAccounts = filterAccountByIsEffective(response.BankAccounts);
                lobbyUiService.loader.hide();
                if (!appData.BankAccounts || appData.BankAccounts.length == 0) {
                    errorService.handleError([
                        {
                            response: {
                                Response: {
                                    Status: {
                                        SeverityCode: 'E',
                                        SeverityNumber: '001'
                                    },
                                    DialogBox: {
                                        Content: 'לא ניתן לקבל מידע אודות הכרטיסים שברשותך. באפשרותך לפנות לאתר Cal-Online.',
                                        Title: '',
                                        OKButtonText: 'סגור'
                                    }
                                }
                            },
                            action: "noCards"
                        }
                    ], getAccount);

                    dataService.sessionManager.save('appData', appData);
                    return;
                }

                dataService.sessionManager.save('appData', appData);
                appData.needRefreshAccount = false;

                var routeParams = {};
                routeParams.nextPage = lobbyUiService.getParams('nextPage'); // || 'dw.myaccount';
                routeParams.command = lobbyUiService.getParams('command') || '';
                routeParams.type = lobbyUiService.getParams('type') || '1';
                routeParams.sso = lobbyUiService.getParams('sso') || false;
                lobbyUiService.loader.hide();

                $rootScope.$broadcast('accountLoggedIn', response);
                if (routeParams.nextPage) {
                    lobbyUiService.navigate(routeParams.nextPage, { type: routeParams.type, sso: routeParams.sso, command: routeParams.command, location: 'replace' },
                        {
                            location: 'replace'
                        });
                }

                defer.resolve();

            }, function () {
                lobbyUiService.loader.hide();
                defer.resolve();
            });

            return defer.promise;
        }

        function login() {
            _self = this;
            var defer = $q.defer();
            if (!appData.metaData) {
                $timeout(function () {
                    var token = dataService.sessionManager.read('authToken');
                    var data = dataService.sessionManager.read('appData');
                    if (token && data) {
                        connection.setToken(token);
                        appData.metaData = data.metaData;
                        appData.CustomerInfo = data.CustomerInfo;
                        appData.BankAccounts = data.BankAccounts;
                        $timeout(function () {
                            defer.resolve();
                        });
                    }
                    else {
                        connection.getMetaData().then(function (resMetadata) {
                            appData.metaData = resMetadata;
                            if (token) {
                                return _self.getAccount({ calConnectToken: token }, defer);
                            }
                            else {
                                $timeout(function () {
                                    defer.resolve();
                                });
                            }
                        }, function () {
                            defer.resolve();
                        });
                    }
                }, 300);
            }
            return defer.promise;
        }

        return {
            getAccount: getAccount,
            loginSso: loginSso,
            login: login
        }
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('ssoService', ssoService);

    ssoService.$inject = ['lobbyCommService', 'appData'];

    function ssoService(lobbyCommService, appData) {

        function insertSsoDetails() {
            var cardId = appData.BankAccounts[appData.selectedBankAccountIndex || 0].Cards[appData.shownCardIndex || 0].Id;

            return lobbyCommService.insertSsoDetails(cardId);
        }

        return {
            insertSsoDetails: insertSsoDetails,
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('chatService', chatService);

    chatService.$inject = ['lobbyCommService', 'lobbyDataService', 'appData','appSettings'];

    function chatService(lobbyCommService, lobbyDataService, appData, appSettings) {
        var pageUrl = '';
        return {
            inserNewChatDetails: function () {
                var metadata = lobbyDataService.loadMetaData();
               // pageUrl = metadata.$$state.value.application.chat.split('-')[0];
                pageUrl = appSettings.chatUrl;
                return lobbyCommService.inserNewChatDetails(pageUrl);
            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';

    angular.module("digitalWallet")
       .factory('EncryptionService', EncryptionService);

    EncryptionService.$inject = ['HashCreactor'];

    function EncryptionService(HashCreactor) {

        var _isTouchLogin = false;

        var getUuid = function () {
            var uuid = typeof device === 'undefined' ? 'RaNdOmStRiNg' : device.uuid;
            return uuid;
        }

        var setHash = function (myGuid) {
            var guid = myGuid;
            var uuid = this.getUuid();
            guid = guid.toUpperCase();
            return HashCreactor.createHash(guid + uuid);
        }

        var takanonStatus = false;
        var isTouchReq = false;

        var setTouchTakanon = function (read) {
            takanonStatus = read;
            return takanonStatus;
        };
        var getTouchTakanon = function () {
            return takanonStatus;
        };

        var setIsTouchReq = function (flag) {
            window.localStorage["isTouchReq"] = flag;
        };
        var getIsTouchReq = function () {
            return JSON.parse(window.localStorage["isTouchReq"] || false);
        };

        var getTouchLogin = function () {
            return _isTouchLogin;
        }

        var setTouchLogin = function (flag) {
            _isTouchLogin = flag;
        }

        var api = {
            setHash: setHash,
            getUuid: getUuid,
            setTouchTakanon: setTouchTakanon,
            getTouchTakanon: getTouchTakanon,
            setIsTouchReq: setIsTouchReq,
            getIsTouchReq: getIsTouchReq,
            getTouchLogin: getTouchLogin,
            setTouchLogin: setTouchLogin
        }

        return api;
    }

})(window, window.angular);

﻿(function (window, angular) {
    'use strict';

    angular.module("digitalWallet")
  .factory('HashCreactor', HashCreactor);

    function HashCreactor() {
        var createHash = function (valueToHash) {
            var sha512 = CryptoJS.SHA512(valueToHash).toString(CryptoJS.enc.Base64);
            return sha512;
        }
        var api = {
            createHash: createHash
        }
        return api;
    }

})(window, window.angular);

﻿(function (window, angular) {
    'use strict';

    angular.module("digitalWallet")
       .factory('isTouchIDAvailable', isTouchIDAvailable);

    isTouchIDAvailable.$inject = ['$ionicPlatform', '$q'];

    function isTouchIDAvailable($ionicPlatform, $q) {

        var deferred = $q.defer();
        var isSupport = null;

        var isAvailable = function () {

            if (navigator.credentials.create) 
                setTimeout(function () { deferred.resolve(); }, 10);
            else
                setTimeout(function () { deferred.reject({ error: "touch not support." }); }, 10);
                    
            return deferred.promise;
        }

        var api = {
            isAvailable: isAvailable
        };

        return api;
    }

})(window, window.angular);

﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet").
       factory("restrictService", restrictService);

    restrictService.$inject = ['$rootScope', 'lobbyDataService', 'EncryptionService', '$q'];

    function restrictService($rootScope, lobbyDataService, EncryptionService, $q) {

        var checkIsRestricted = function (state) {
            var deferred = $q.defer();

            lobbyDataService.loadMetaData().then(function (metadata) {

                var routesDetails;

                if (metadata.routes)
                {
                    routesDetails = metadata.routes.filter(function (routeDetails) {
                        return state.indexOf(routeDetails.routePath) > -1;
                    });
                }

                if (routesDetails && routesDetails.length === 1) {
                    var currentRouteDetails = routesDetails[0];
                    deferred.resolve(currentRouteDetails.isTouchForbidden);
                }
                deferred.resolve(false);
            }, function (error) {
                deferred.reject();
            });

            return deferred.promise;
        }

        var restirctedRoute = function (event, state) {
            var deferred = $q.defer();

            if (EncryptionService.getTouchLogin()) {

                checkIsRestricted(state.name).then(function (isTouchForbidden) {
                    if (isTouchForbidden) {
                        event.preventDefault();
                        deferred.resolve(true);
                    }
                }, function () {
                    deferred.reject();
                });
            }

            return deferred.promise;
        };

        return {
            restirctedRoute: restirctedRoute,
            checkIsRestricted: checkIsRestricted
        }
    }

})(window, window.angular);

﻿(function (window, angular) {
    'use strict';

    angular.module("digitalWallet")
   .factory('touchKeyStore', touchKeyStore);

    touchKeyStore.$inject = ['$q'];

    function touchKeyStore($q) {

        var kc = null;
        var deferred;

        try {
            kc = new Keychain();
            var key = "myFinger";
            var servicename = "כניסה מהירה לאזור אישי";
        } catch (e) {

        }

        var win = function (value) {
            deferred.resolve({ flag: true, result: value });
        };
        var fail = function (error) {
            deferred.reject({ flag: false })
        };

        var win2 = function () {
            deferred.resolve({ result: true });
        };
        var fail2 = function (error) {
            deferred.reject({ result: false })
        };

        var getKey = function () {
            deferred = $q.defer();
            kc && kc.getForKey(win, fail, key, servicename);
            return deferred.promise;
        };

        var setKey = function (hash) {
            deferred = $q.defer();
            kc && kc.setForKey(win2, fail2, key, servicename, hash);
            return deferred.promise;
        };

        var removeKey = function () {
            deferred = $q.defer();
            kc && kc.removeForKey(win2, fail2, key, servicename);
            return deferred.promise;
        };

        var _api = {
            getKey: getKey,
            setKey: setKey,
            removeKey: removeKey
        }

        return _api;
    }

})(window, window.angular);

﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('tokenService', tokenService);

    tokenService.$inject = ['connection', 'lobbyUiService', '$state', '$stateParams'];

    function tokenService(connection, lobbyUiService, $state, $stateParams) {

        var _data = {};

        return {
            getData: function() {
                return _data;
            },
            getOtpDataByToken: function (token) {
                var request = { token: token };
                connection.getOtpDataByToken(request).then(
                    function (data) {
                        if (data && data.IdNumber && data.Last4Digits) {
                            _data.idNumber = data.IdNumber;
                            _data.last4Digits = data.Last4Digits;
                            lobbyUiService.go('dw.login', { isOtpData: true });
                        }
                    }, function () {
                        //error
                    });
            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('newChatService', newChatService);

    newChatService.$inject = ['$rootScope', 'appData', 'appSettings', 'lobbyDataService', 'lobbyCommService', 'connection', 'lobbyUiService', '$state', '$stateParams'];

    function newChatService($rootScope, appData, appSettings, lobbyDataService, lobbyCommService, connection, lobbyUiService, $state, $stateParams) {

        function inserNewChatDetails() {
            var metadata = lobbyDataService.loadMetaData();
            var pageUrl = appSettings.chatUrl;
            return lobbyCommService.inserNewChatDetails(pageUrl);
        }

        function openChat() {
            var vm = this;
            
            if (!vm.iframeChat) {
                inserNewChatDetails().then(function (res) {
                    var settingUrl = appSettings.chatUrl;
                    var chatUrl = res.guid ? settingUrl + '?' + 'profile=' + res.profile + '&lang=' + res.language + '&t=' + res.guid + '&' : settingUrl;
                    vm.iframeChat = chatUrl;
                });
            }
        }

        return {
            openChat: openChat
        }
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('serverConnection')
        .factory('connection', connectionService);

    connectionService.$inject = ['$http', '$rootScope', '$q', 'errorService', '$timeout', 'appData', 'lobbyUiService', 'lobbyCommService', 'appSettings', '$ionicHistory', 'dataService'];

    function connectionService($http, $rootScope, $q, errorService, $timeout, appData, lobbyUiService, lobbyCommService, appSettings, $ionicHistory, dataService) {

        var currentVersion = appSettings.version;

        // OS Temp Value - For Testing ONLY!
        //var os = navigator.platform = 'Android';
        var os = navigator && navigator.platform == 'iPhone' ? 'iOS' : 'Android';

        var versionAndOS = 'CurrentVersion=' + currentVersion + '&OperatingSystem=' + os;


        var baseUrl = appSettings.server;
        var calConnectUrl = appSettings.calConnectServer;


        errorService.requestsSent = 0;
        errorService.responsesRecieved = 0;

        var httpErrorObject = {
            response: {
                Response: {
                    Status: {
                        SeverityCode: 'E',
                        SeverityNumber: '001'
                    },
                    DialogBox: {
                        Content: 'בשל תקלה לא ניתן להשלים את הפעולה. יש לנסות מאוחר יותר',
                        Title: ' ',
                        OKButtonText: 'נסה שנית',
                        CancelButtonText: 'סגור'

                    }
                }
            },
            action: "http"
        },
            sessionErrorObject = [{
                response: {
                    Response: {
                        Status: {
                            SeverityCode: 'E',
                            SeverityNumber: '002'
                        },
                        DialogBox: {
                            Content: 'לחץ אישור על-מנת להזדהות שוב',
                            Title: 'התנתקת מהמערכת',
                            OKButtonText: 'אישור'
                        }
                    }
                },
                action: "http"
            }], sessionExpiredObject = [{
                response: {
                    Response: {
                        Status: {
                            SeverityCode: 'E',
                            SeverityNumber: '004'
                        },
                        DialogBox: {
                            Content: 'לחץ אישור על-מנת להזדהות שוב',
                            Title: 'התנתקת מהמערכת',
                            OKButtonText: 'אישור'
                        }
                    }
                },
                action: "http"
            }], noConnectionErrorObject = [{
                response: {
                    Response: {
                        Status: {
                            SeverityCode: 'E',
                            SeverityNumber: '003'
                        },
                        DialogBox: {
                            Content: 'אין חיבור לרשת.\nבדוק את החיבור ונסה שנית.',
                            Title: 'שגיאה קישורית',
                            OKButtonText: 'נסה שנית',
                            CancelButtonText: 'סגור'
                        }
                    }
                },
                action: "http"
            }];


        var connection = {

            token: dataService.sessionManager.read('authToken') || null,
            versionAndOSParams: versionAndOS,
            // This function handles all the http calls for the other functions
            genericConnection: function (connectionMethod, connectionAction, connectionParameters, connectionData, connectionSuccessFunction,
                connectionErrorFunction, restartServiceDeferred, ignoreToken, isCalconnect) {

                var args = arguments;
                var deferred = {};
                if (!restartServiceDeferred) {
                    deferred = $q.defer();
                    args[6] = deferred;
                }
                else {
                    deferred = restartServiceDeferred;
                }

                // Set All the needed Connection data into one object 
                if (this.checkConnection() == false) {
                    errorService.handleError(noConnectionErrorObject);
                    return deferred.promise;
                }

                // Check if a diffs success function is wanted
                var successFunction = (angular.isFunction(connectionSuccessFunction)) ? connectionSuccessFunction : function (response) {
                    if (!response.Response) {
                        deferred.resolve(response);
                    }
                    else if (response.Response.Status.SeverityCode != 'W' && response.Response.Status.SeverityCode != 'E') {
                        deferred.resolve(response);
                    }
                    else {
                        var errorObject = {};
                        errorObject.response = response;
                        errorObject.action = connectionMethod + "_" + connectionAction;
                        deferred.reject([errorObject, args, 'genericConnection']);
                    }
                };

                // Check if a diff error function is wanted
                var errorFunction = (angular.isFunction(connectionErrorFunction)) ? connectionErrorFunction : function (data, status, headers, config) {
                    //errorService.handleError(httpErrorObject);
                    if (status === 403 || status === 401) {
                        //errorService.handleError(sessionExpiredObject);
                        deferred.reject(sessionExpiredObject);
                    }
                    else {
                        deferred.reject([httpErrorObject, args, 'genericConnection']);
                    }
                };

                var authHeader = !ignoreToken && this.token && this.token != 'undefined' ? { 'Authorization': 'CALAuthScheme ' + this.token } : '';
                if (authHeader) { authHeader['X-Site-Id'] = appSettings.siteId; }

                //console.log("calling: " + url + connectionAction + connectionParameters + " data " + JSON.stringify(connectionData) + " headers " + JSON.stringify(authHeader));

                var url = baseUrl;
                if (isCalconnect) { url = calConnectUrl }

                $http({ method: connectionMethod, url: url + connectionAction + connectionParameters, data: connectionData, headers: authHeader })
                    .success(successFunction)
                    .error(errorFunction);
                if (this.token && appData.metaData) {
                    $timeout.cancel(appData.sessionTimeout);
                    errorService.token = this.token;
                    var tOut = appData.metaData.SessionTimeout * 1000;
                    appData.sessionTimeout = $timeout(function () {
                        errorService.handleError(sessionErrorObject);
                    }, tOut, false);
                }
                return deferred.promise;
            },

            login: function (login, restartServiceDeferred) {

                var args = arguments;
                var deferred = {};
                if (!restartServiceDeferred) {
                    deferred = $q.defer();
                    args[6] = deferred;
                }
                else {
                    deferred = restartServiceDeferred;
                }
                var selfie = this;
                var data = {
                    Password: login.pass,
                    UserName: login.user,
                    /* touch:  RememberMe obj*/
                    RememberMe: {
                        IsRememberMe: login.touchFlag,
                        UUID: login.uuid,
                        authMethods: 2
                    }
                };

                if (this.checkConnection() == false) {
                    errorService.handleError(noConnectionErrorObject);
                    return deferred.promise;
                }

                $http.call(this, { method: 'POST', url: url + 'CalAuthenticator?' + versionAndOS, data: data })
                    .success.call(this, function (response) {
                        $ionicHistory.clearCache();
                        if (response.Response.Status.SeverityCode == 'S') {
                            selfie.token = response.AuthenticationToken;
                            dataService.sessionManager.save('authToken', selfie.token);

                            if (appData.sessionTimeout)
                                $timeout.cancel(appData.sessionTimeout);

                            var tOut = appData.metaData.SessionTimeout * 1000;
                            errorService.token = selfie.token;
                            appData.sessionTimeout = $timeout(function () {
                                errorService.handleError(sessionErrorObject);
                            }, tOut, false);

                            deferred.resolve(response);
                        }
                        else {
                            var errorObject = {};

                            errorObject.response = response;
                            errorObject.action = 'POST_CalAuthenticator?';
                            deferred.reject([errorObject, args, 'login']);
                        }
                    })
                    .error(function (data, status, headers, config) {
                        $ionicHistory.clearCache();
                        deferred.reject([httpErrorObject, args, 'login']);
                    });

                return deferred.promise;
            },

            postOpenLead: function (data, restartServiceDeferred) {

                var args = arguments;
                var deferred = {};
                if (!restartServiceDeferred) {
                    deferred = $q.defer();
                    args[6] = deferred;
                }
                else {
                    deferred = restartServiceDeferred;
                }


                var header = null;
                var header = {
                    'Authorization': 'CalAuthScheme ' + this.token,
                    'X-Site-Id': appSettings.siteId
                }

                //                if (data.RequestType != '02') {
                //                    data.ResolutionCode = null;
                //                    data.MemberNum = null;
                //                }

                // Set All the needed Connection data into one object
                if (this.checkConnection() == false) {
                    errorService.handleError(noConnectionErrorObject);
                    return deferred.promise;
                }

                $http.call(this, { method: 'POST', url: baseUrl + 'CalCustomerService?' + versionAndOS, data: data, headers: header })
                    .success.call(this, function (response) {
                        if (response.Response.Status.SeverityCode == 'S') {
                            deferred.resolve(response);
                        }
                        else {
                            var errorObject = {};
                            errorObject.response = response;
                            errorObject.action = 'POST_CalCustomerService?';
                            deferred.reject([errorObject, args, 'postOpenLead']);
                        }
                    })
                    .error(function () {

                        deferred.reject([httpErrorObject, args, 'postOpenLead']);
                    });

                var tOut = appData.metaData.SessionTimeout * 1000;
                appData.sessionTimeout = $timeout(function () {
                    errorService.handleError(sessionErrorObject);
                }, tOut, false);
                return deferred.promise;
            },

            logout: function () {
                var promise = this.genericConnection('DELETE', 'CalAuthenticator?', versionAndOS);
                promise.finally(function () {
                    if (appData.sessionTimeout) {
                        $timeout.cancel(appData.sessionTimeout);
                    }
                    $rootScope.$broadcast('loggedOut');
                    connection.setToken(null);
                    dataService.sessionManager.clear('authToken');
                    //$stage.go('dw.login');
                });
            },

            postCalWalletSendOTP: function (idNum, last4Digits) {
                return this.genericConnection('POST', 'CalWalletAuthenticatorOTPSend?', '', { Client: 1, Last4Digits: last4Digits, UserID: idNum });
            },
            /* touch: touchFlag, uuid , RememberMe obj*/
            postCalWalletVerifyOTP: function (token, OTPPassword, touchFlag, uuid) {
                return this.genericConnection('POST', 'CalWalletAuthenticatorOTPVerify?', '', {
                    Client: 1,
                    OTP: OTPPassword,
                    Token: token,
                    RememberMe: {
                        IsRememberMe: touchFlag,
                        UUID: uuid,
                        authMethods: 2
                    }
                }, null, null, null, true);
            },

            /* touch: new moethod */
            postTouchLogin: function (hash) {
                return this.genericConnection('POST', 'CalGeneralAuthenticator/GeneralLogin?', '', { Hash: hash.result, Type: 2 });
            },

            deleteTouch: function () {
                return this.genericConnection('GET', 'CalTouch/DeleteTouchidRecord?', versionAndOS);
            },
            /* touch: end new moethod */
            getMetaData: function () {
                return this.genericConnection('GET', 'api/CalGeneralData/GetMetaData?', versionAndOS);
            },

            ssoLogin: function (request) {
                lobbyUiService.loader.show();
                var deferred = $q.defer();
                var selfie = this;
                selfie.token = null;
                this.genericConnection('GET', 'Authentication/SSO?', 'sid=' + request.hash, null, null, null, null, null, true)
                    .then(function (response) {
                        lobbyUiService.loader.hide();
                        $ionicHistory.clearCache();
                        if (response.calConnectToken) {
                            selfie.token = response.calConnectToken;
                            dataService.sessionManager.save('authToken', selfie.token);
                            dataService.sessionManager.save('siteId', appSettings.siteId);

                            if (appData.sessionTimeout)
                                $timeout.cancel(appData.sessionTimeout);

                            var tOut = appData.metaData.SessionTimeout * 1000;
                            errorService.token = selfie.token;
                            appData.sessionTimeout = $timeout(function () {
                                errorService.handleError(sessionErrorObject);
                            }, tOut, false);

                            deferred.resolve(response);
                        }
                        else {
                            var errorObject = {};

                            errorObject.response = response;
                            errorObject.action = 'POST_CalAuthenticator?';
                            deferred.reject([errorObject, args, 'login']);
                        }
                    }, function () {
                        deferred.reject();
                        lobbyUiService.loader.hide();
                    })

                return deferred.promise;
            },

            ssoLoginFromExternalSystem: function (OTPToken, SessionID) {
                var request = {
                    SessionID: SessionID,
                    OTPToken: OTPToken
                };
                return this.genericConnection('POST', 'api/CalSsoExternal/SetLoginForSSO?', versionAndOS, request);
            },

            getAccount: function () {
                return this.genericConnection('GET', 'CardsByAccounts?', versionAndOS);
            },

            getCreditFrame: function (accountID) {
                return this.genericConnection('GET', 'CalCreditFrame/', accountID + '?' + versionAndOS);
            },

            getCardData: function (cardID) {
                return this.genericConnection('GET', 'CampaignsByCardMetaData/', cardID + '?' + versionAndOS);
            },

            getUserBenefitsBalance: function (request) {

                return this.genericConnection('POST', 'api/CalBenefits/GetUserBenefitBalance?', versionAndOS, request);
            },

            getTransactionsFromDateToDate: function (cardID, fromDate, toDate) {

                return this.genericConnection('GET', 'CalTransactions/', cardID + '?' + versionAndOS + '&FromDate=' + fromDate + '&ToDate=' + toDate);
            },

            getTransactionsDebitMonthDebitYear: function (cardID, debitMonth, debitYear) {
                return this.genericConnection('GET', 'CalTransactions/', cardID + '?' + versionAndOS + '&DebitMonth=' + debitMonth + '&DebitYear=' + debitYear);
            },

            getTransactionDetails: function (transID, numerator) {

                return this.genericConnection('GET', 'CalTransDetails/', transID + '?' + versionAndOS + '&Numerator=' + numerator);
            },

            getTransDenialToken: function (transID, numerator) {

                return this.genericConnection('GET', 'CalTransDenial/', transID + '?' + versionAndOS + '&Numerator=' + numerator + '&Web=true&Url=' + encodeURIComponent(location.href));
            },

            getTransNextPage: function () {
                return this.genericConnection('GET', 'CalTransNextPage/?', versionAndOS);
            },

            getSectorSummary: function (cardID, fromDate, toDate) {

                return this.genericConnection('GET', 'CalSectorsSummary/', cardID + '?' + versionAndOS + '&FromDate=' + fromDate + '&ToDate=' + toDate);
            },

            getBankDebits: function (accountID, debitLevel, debitType, fromMonth, toMonth, fromYear, toYear, cardID) {

                return this.genericConnection('GET', 'CalBankDebits/', accountID + '?' + versionAndOS + '&DebitLevel=' + debitLevel + '&DebitType=' + debitType + '&FromMonth=' + fromMonth + '&FromYear=' + fromYear + '&ToMonth=' + toMonth + '&ToYear=' + toYear + '&cardID=' + cardID);
            },

            getCardEligiblityStatus: function (cardID) {
                return this.genericConnection('GET', 'CardEligiblityStatus/', cardID + '?' + versionAndOS);
            },

            getLoanPaymentsRange: function (cardID, amount) {
                return this.genericConnection('GET', 'LoanPaymentsRange/', cardID + '?RequestedAmount=' + amount);
            },

            getSimulateLoanRequest: function (cardID, requestAmount, paymentsNum) {
                return this.genericConnection('GET', 'SimulateLoanRequest/', cardID + '?' + versionAndOS + '&RequestedAmount=' + requestAmount + '&NumberOfPayments=' + paymentsNum);
            },

            getApproveLoanRequest: function (cardID) {
                return this.genericConnection('GET', 'ApproveLoanRequest/', cardID + '?' + versionAndOS);
            },

            getFixedDebitStatus: function (cardID) {

                return this.genericConnection('GET', 'FixedCardDebit/', cardID + '?' + versionAndOS);
            },

            getFixedDebitDiscloser: function (cardID, amount) {
                return this.genericConnection('GET', 'FixedCardDebit/', cardID + '?' + versionAndOS + '&RequestedAmount=' + amount);
            },

            putFixedDebitStatus: function (cardID) {
                return this.genericConnection('POST', 'FixedCardDebit/', cardID + '?' + versionAndOS);
            },

            getStatus: function (cardID) {
                return this.genericConnection('GET', 'CalChoice/', cardID + '?' + versionAndOS);
            },

            getPaymentsOptions: function (cardID) {

                return this.genericConnection('GET', 'CalChoiceRepayment/', cardID + '?' + versionAndOS);
            },

            getPaymentsRange: function (cardID, optionCode) {

                return this.genericConnection('GET', 'CalChoiceRepayment/', cardID + '?' + versionAndOS + '&RequestedPaymentOptionCode=' + optionCode);
            },

            // Check For Bad URL
            getSimulation: function (cardID, requestAmount, cvv, expirationDate) {

                return this.genericConnection('GET', 'CalChoiceRepayment/', cardID + '?' + versionAndOS + '&RequestedAmount=' + requestAmount + '&Cvv=' + cvv + '&ExpirationDate=' + expirationDate);
            },

            postPaymentsOptions: function (cardID) {
                return this.genericConnection('POST', 'CalChoiceRepayment/', cardID + '?' + versionAndOS);
            },

            getPaymentsDeatails: function (request) {

                return this.genericConnection('POST', 'api/Payments/GetTransactionDetails?', versionAndOS, request);
            },

            UpdateTransactionPayments: function (request) {
                return this.genericConnection('POST', 'api/Payments/UpdateTransactionPayments?', versionAndOS, request);
            },
            SimulateCreditPaymentsRequest: function (request) {
                return this.genericConnection('POST', 'api/Payments/SimulateCreditPaymentsRequest?', versionAndOS, request);
            },

            getHtml: function (source) {
                return this.genericConnection('GET', source, '', '', null, null, null);
            },
            isLoggedIn: function () {
                return this.token;
            },
            setToken: function (token) {
                this.token = token;
            },
            checkConnection: function () {

                if (!navigator || !navigator.connection) {

                } else {
                    var networkState = navigator.connection.type;

                    if (networkState !== undefined && networkState == navigator.connection.NONE) {
                        return false;
                    }
                }

                return true;
            },
            GetCreditFrameInfoForCard: function (cardID) {

                return this.genericConnection('GET', 'CalGetCreditFrameInfoForCard/', cardID + '?' + versionAndOS);
            },
            IncreaseFrameForCard: function (cardID) {

                return this.genericConnection('GET', 'CalIncreaseFrameForCard/', cardID + '?' + versionAndOS);
            },
            debitSpreadGetCardEligiblityStatus: function (cardId) {
                var request = {
                    cardId: cardId
                };

                return this.genericConnection('POST', 'api/MonthlyDebitPaymentSpread/GetCardEligibilityStatus?', versionAndOS, request);
            },
            debitSpreadGetSpreadPaymentsRange: function (request) {
                return this.genericConnection('POST', 'api/MonthlyDebitPaymentSpread/GetSpreadPaymentsRange?', versionAndOS, request);
            },
            debitSpreadSimulateSpreadRequest: function (request) {
                return this.genericConnection('POST', 'api/MonthlyDebitPaymentSpread/SimulateSpreadRequest?', versionAndOS, request);
            },
            debitSpreadApproveSpreadRequest: function (selectedCardId) {
                var request = {
                    "cardId": selectedCardId
                };

                return this.genericConnection('POST', 'api/MonthlyDebitPaymentSpread/ApproveSpreadRequest?', versionAndOS, request);
            },
            debitSpreadClearSpreadRequest: function (cardId) {
                var request = {
                    "cardId": cardId
                }
                return this.genericConnection('POST', 'api/MonthlyDebitPaymentSpread/ClearSpreadRequest?', versionAndOS, request);
            },
            getAllDigitalVouchers: function () {
                return this.genericConnection('GET', 'api/CalDigitalVouchers/GetAllVouchers?', versionAndOS);
            },
            getDigitalVoucherDetails: function (request) {
                return this.genericConnection('POST', 'api/CalDigitalVouchers/GetVoucherDetails?', versionAndOS, request);
            },
            getEligibilityForVoucher: function (request) {
                return this.genericConnection('POST', 'api/CalDigitalVouchers/GetEligibilityForVouchers?', versionAndOS, request);
            },
            createPaymentForVouchers: function (request) {
                return this.genericConnection('POST', 'api/CalDigitalVouchers/CreatePaymentForVouchers?', versionAndOS, request);
            },
            getHistoryForVouchers: function (request) {
                return this.genericConnection('POST', 'api/CalDigitalVouchers/GetHistoryForVouchers?', versionAndOS, request);
            },
            getHistoryVoucherDetails: function (request) {
                return this.genericConnection('POST', 'api/CalDigitalVouchers/GetHistoryVoucherDetails?', versionAndOS, request);
            },
            getOtpDataByToken: function (request) {
                return this.genericConnection('POST', 'api/CalToken/GetData?', versionAndOS, request);
            },
            getIndicationForCalMailOrSms: function (request) {
                return this.genericConnection('GET', '/calmail/GetIndicationForCalMailOrSms?ServiceCode=1&&TransCommonServicesIndication=20', versionAndOS, request);
            },
            updateCustomerInformation: function (request) {
                var request = {
                    "CustEmail": request.CustEmail,
                    "IccSourceMessage": request.IccSourceMessage
                }
                return this.genericConnection('POST', 'api/calmail/UpdateCustomerInformation?', versionAndOS, request);
            },
            updateCalMailOrSms: function (request) {

                return this.genericConnection('POST', 'api/calmail/UpdateCalMailOrSms?', versionAndOS, request);
            },
            getDigitalServices: function (request) {
                return this.genericConnection('GET', 'api/calmail/GetDigitalServices?', versionAndOS, request);

            },
            getReportList: function (request) {

                return this.genericConnection('POST', 'api/calmail/GetReportList?', versionAndOS, request);
            },
            getExpenseReportPDF: function (request) {
                return this.genericConnection('POST', 'api/calmail/GetExpenseReportPDF?', versionAndOS, request);
            },
            getBlockedCardDetails: function (request) {
                return this.genericConnection('POST', 'api/CalBlockCard/GetBlockedCardDetails?', versionAndOS, request);
            },
            getCustomerDetails: function (request) {
                return this.genericConnection('POST', 'api/CalBlockCard/GetCustomerDetails?', versionAndOS, request);
            },
            updateCardStatus: function (request) {
                return this.genericConnection('POST', 'api/CalBlockCard/UpdateCardStatus?', versionAndOS, request);
            },
            checkCardCVV: function (request) {
                return this.genericConnection('POST', 'api/CalBlockCard/CheckCardCVV?', versionAndOS, request);
            },
            getInstallmentPlanTransactions: function (request) {
                //return this.genericConnection('POST', 'api/CalBlockCard/CheckCardCVV?', versionAndOS, request);
            },
            UpdateTransactionInstallment: function (request) {
                //return this.genericConnection('POST', 'api/CalBlockCard/CheckCardCVV?', versionAndOS, request);
            },
            GetValidForPaymentSpread: function () {
                return this.genericConnection('POST', 'api/PaymentSpread/GetValidForPaymentSpread?', versionAndOS);
            },
            UpDateRemoveBelongingForCards: function (request) {
                return this.genericConnection('POST', 'api/PaymentSpread/UpDateRemoveBelongingForCards?', versionAndOS, request);
            },
            setAuthenticData: function (request) {
                return this.genericConnection('POST', 'api/OnlineForms/Post?', versionAndOS, request);
            },

            refreshCustomerDetails: function () {
                return this.genericConnection('GET', 'api/CustomerRefresh/RefreshCustomerDetails?', versionAndOS);
            },
            getDateToShowPopUp: function (lastTimeShown) {
                var request = {
                    "lastTimeShownDate": lastTimeShown
                }
                return this.genericConnection('POST', 'CustomerRefresh/GetDateToShowPopUp?', versionAndOS, request);
            },
            getFilteredTransDetails: function (request) {
                return this.genericConnection('POST', 'api/CalFilteredTransactions/GetFilteredTransactions?', versionAndOS, request);
            },
            getStandingOrders: function (request) {
                return this.genericConnection('POST', 'api/CalStopStandingOrder/GetStandingOrders?', versionAndOS, request);
            },
            getStandingOrdersDetails: function (request) {
                return this.genericConnection('POST', 'api/CalStopStandingOrder/GetStandingOrdersDetails?', versionAndOS, request);
            },
            CancelStandingOrder: function (request) {
                return this.genericConnection('POST', 'api/CalStopStandingOrder/CancelStandingOrder?', versionAndOS, request);
            },
            transferStandingOrders: function (request) {
                return this.genericConnection('POST', 'api/CalTransferStandingOrders/TransferStandingOrders?', versionAndOS, request);
            },
            transferStandingOrdersGetValidCards: function () {
                return this.genericConnection('POST', 'api/CalTransferStandingOrders/GetValidCards?', versionAndOS);
            },
            executeBpm051: function () {
                return this.genericConnection('GET', 'api/CustomerRefresh/RefreshUser?', versionAndOS);
            },
            getConnectAuth: function () {

                return this.genericConnection('GET', 'authentication/auth/', '','' ,'' ,'' ,'' ,'' , true);
            },
            getInternetCode: function (request) {
                return this.genericConnection('POST', 'api/CalGetInternetCode/CalGetInternetCode?', versionAndOS, request);
            },
            getIndicationForCustomer: function (request) {
                return this.genericConnection('POST', 'api/CustomerIndications/GetIndicationForCustomer?', versionAndOS, request);
            },
            updateBankingInfoConsent: function () {
                return this.genericConnection('POST', 'api/CustomerIndications/UpdateBankingInfoConsent?', versionAndOS);
            },
            updateCreditInfoConsent: function (request) {
                return this.genericConnection('POST', 'api/CustomerIndications/UpdateCreditInfoConsent?', versionAndOS, request);
            },
            setDataForDebtPaymentPage: function () {
                return this.genericConnection('POST', 'api/CustomerIndications/SetDataForDebtPaymentPage?', versionAndOS);
            },
            openDebtLead: function () {
                return this.genericConnection('POST', 'api/CustomerIndications/OpenDebtLead?', versionAndOS);
            },
            getCreditInfoConsentIndication: function (request) {
                return this.genericConnection('POST', 'api/CreditRepositories/GetCreditInfoConsentIndication?', versionAndOS,request);
            },
            updateCreditInfoConsentAndCheckBDI: function (request) {
                return this.genericConnection('POST', 'api/CreditRepositories/UpdateCreditInfoConsentAndCheckBDI?', versionAndOS, request);
            },
            identificationServiceRequest: function () {
                return this.genericConnection('GET', 'IdentificationWebServiceRequest', '');
            }
        };
        errorService.connection = connection;
        lobbyUiService.connection = connection;
        lobbyCommService.connection = connection;
        return connection;
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("serverConnection")
        .factory('errorService', errorService);

    errorService.$inject = ['$location', 'lobbyUiService', 'appData', '$timeout', '$q', '$window', '$rootScope',
        'touchKeyStore', 'EncryptionService', '$injector','$state','commService'];

    function errorService($location, lobbyUiService, appData, $timeout, $q, $window, $rootScope,
        touchKeyStore, EncryptionService, $injector,$state,commService) {
            var errorPromise;

        return {

            errorIsOnFlag: false,
            connection: {},
            token: {},
            
/* Main Error handeling function */
            handleError: function () {
                var params = arguments;
                var self = this;
                var deferred = $q.defer();
                var error = params[0][0];
                var args = params[0][1];
                var callingFunction = params[0][2];
                var rssFunction = params[1];
                var iconClass = params[2];
                var isPopupIonic = params[3];

                var status = error.response.Response.Status,
                    errorPopup = error.response.Response.DialogBox;

                if (!errorPopup.CancelButtonText) {
                    errorPopup.CancelButtonText = '';
                }

                if (!errorPopup.Title || errorPopup.Title == '') {
                    errorPopup.Title = ' ';
                }

                if (error.action == 'GET_CalChoiceRepayment/')
                    if (args[2].indexOf('RequestedPaymentOptionCode') != -1)
                        error.action = 'GET_CalChoiceRepayment/_1';
                    else if (args[2].indexOf('RequestedAmount') != -1)
                        error.action = 'GET_CalChoiceRepayment/_2';

                if (error.action == 'GET_FixedCardDebit/' && args[2].indexOf('RequestedAmount') != -1)
                    error.action = 'GET_FixedCardDebit/_1';

                if (error.action == 'GET_CalChoiceRepayment/')
                    if (args[2].indexOf('RequestedPaymentOptionCode') != -1)
                        error.action = 'GET_CalChoiceRepayment/_1';
                    else if (args[2].indexOf('RequestedAmount') != -1)
                        error.action = 'GET_CalChoiceRepayment/_2';

                var errorKey = error.action + '_' + status.SeverityCode + '_' + status.SeverityNumber,
                    errorActions = self.errorDictionary[errorKey],
                    returnURL = status.ReturnUrl;


                appData.showSpinner = false;
                lobbyUiService.loader.hide();

                if (!errorActions || errorActions.OK == "NPU") {
                    //this caused double popup, took the fix from DigitalApp
                    //showPopup(errorPopup.Content, errorPopup.Title, { ok: errorPopup.OKButtonText, cancel: errorPopup.CancelButtonText }, isPopupIonic);
                    return false;
                }
                else {
                    showPopup(errorPopup.Content, errorPopup.Title, { ok: errorPopup.OKButtonText, cancel: errorPopup.CancelButtonText }, isPopupIonic);
                }


                function showPopup(message, title, buttonLabels, isPopupIonic) {
                    var ua = navigator.userAgent.toLowerCase();
                    var lableText = '';
                    if (navigator.notification) {
                        if (ua.indexOf("android") > -1)
                            lableText = buttonLabels.ok + (buttonLabels.cancel ? (',' + buttonLabels.cancel) : '');
                        else
                            lableText = (buttonLabels.cancel ? (buttonLabels.cancel + ',') : '') + buttonLabels.ok;


                        navigator.notification.confirm(
                            message,
                            callback,
                            title,
                            lableText
                        );

                    }
                    else {

                        var _btns = [];

                        if (buttonLabels.ok) {
                            _btns.push(
                                {
                                    text: buttonLabels.ok,
                                    type: 'button-positive',
                                    onTap: function () {
                                        if (callback && angular.isFunction(callback)) {
                                            var action = errorActions.OK;
                                            deferred.resolve(action);
                                            self.getWantedAction(action, { returnURL: returnURL, args: args, callingFunction: callingFunction, rssFunction: rssFunction });
                                        }
                                    }
                                });
                        }

                        if (buttonLabels.cancel) {
                            _btns.push(
                                {
                                    text: buttonLabels.cancel,
                                    type: 'button-negative',
                                    onTap: function () {
                                        if (callback && angular.isFunction(callback)) {
                                            var action = errorActions.Cancel;
                                            deferred.resolve(action);
                                            self.getWantedAction(action, { returnURL: returnURL, args: args, callingFunction: callingFunction, rssFunction: rssFunction });
                                        }
                                    }
                                });
                        }

                

                        if (!buttonLabels.cancel && !buttonLabels.ok) {
                            _btns.push(
                                {
                                    text: 'סגור',
                                    type: 'button-positive',
                                    onTap: function () {
                                        if (callback && angular.isFunction(callback)) {
                                            var action = errorActions.OK;
                                            deferred.resolve(action);
                                            self.getWantedAction(action, { returnURL: returnURL, args: args, callingFunction: callingFunction, rssFunction: rssFunction });
                                        }
                                    }
                                });
                        }



                        lobbyUiService.popup.alert(message, title, null, null, _btns, false, iconClass);
                    }

                    function callback(button) {
                        if (ua.indexOf("iphone") > -1 && lableText.indexOf(',') > -1)
                            if (button == 1)
                                button = 2;
                            else
                                button = 1;
                        var action;
                        if (button == 1 || button == true) {
                            action = errorActions.OK;
                            deferred.resolve(action);
                        }
                        else {
                            action = errorActions.Cancel;
                            deferred.reject(action);
                        }
                        self.getWantedAction(action, { returnURL: returnURL, args: args, callingFunction: callingFunction, rssFunction: rssFunction });
                    }

                }
                return deferred.promise;

            },


            /*
                Helper function - returns the corresponding action according to the given action key
                Parameters:
                    action - the action key
                    additionalData - all of the data needed to create the wanted action
            */


            execService: function(serviceName, methodName) {
                return $injector.get(serviceName)[methodName]();
            },

            getWantedAction: function (action, additionalData) {
                console.log(">>>getActionStart", action);
                switch (action) {
                    case 'BTS':
                        window.history.back();
                        break;
                    case 'BTA':
                        break;
                    case 'CSS':
                        commService.backToHomePage();
                       // lobbyUiService.go('dw.account-home');
                        break;
                    case 'CAS':
                        break;
                    case 'CPT':
                        break;
                    case 'PFC':
                        return true;
                    case 'WTC':
                        commService.backToHomePage();
                       // lobbyUiService.go('dw.lobby');
                        break;
                    case 'SE':
                        lobbyUiService.go('dw.login');
                        break;
                    case 'OBS':
                        lobbyUiService.openExternal(additionalData.returnURL);
                        break;
                    case 'RSS':
                        if (angular.isFunction(additionalData.rssFunction)) {
                            additionalData.rssFunction();
                        } else {
                            this.connection.logout();
                        }
                        break;
                    case 'ASD':
                        navigator.app && navigator.app.exitApp && navigator.app.exitApp();
                        break;
                    case 'GTL':
                        commService.backToHomePage();
                        //this.connection.logout();
                        break;
                    case 'MAS':
                        $timeout(function () {
                            lobbyUiService.go('dw.myaccount');
                        }, 10);

                        break;
                    case 'CTP':
                        window.open('tel:' + additionalData.returnURL, '_system');
                        break;
                    case 'STW':
                        lobbyUiService.navigate('dw.wallet-home');
                        break;
                    case 'BH':
                        lobbyUiService.navigate('dw.benefits-home');
                        break;
                    case 'RAS':
                        $window.location.reload();
                        break;
                    case 'LO':
                        if (appData.sessionTimeout) {
                            $timeout.cancel(appData.sessionTimeout);
                        }
                        lobbyUiService.go('dw.login',{ nextPage: $state.current.name });
                        $rootScope.$broadcast('loggedOut');
                        break;
                    case 'P2P':
                        lobbyUiService.navigate('dw.p2p-home', { location: 'replace' });
                        break;
                    case 'TOU':
                        lobbyUiService.popup.alreadyTouchDelete(res.Response.Status.Message);
                        break;
                    case 'DT':
                        touchKeyStore.removeKey();
                        EncryptionService.setIsTouchReq(false);
                        EncryptionService.setTouchTakanon(false);
                        $rootScope.$broadcast('logoutTouch');
                        break;

                    case 'TA':
                        this.execService('blockCardService', 'UpdateAgain');
                        //blockCardTryAgainService.UpdateAgain();
                        break;
                    case 'BK':
                        commService.backToHomePage();
                        //lobbyUiService.go('dw.block-card-home');
                        //blockCardTryAgainService.UpdateAgain();
                        break;

                        

                    default:
                        break;
                }

                return false;
            },

            /*
                The keys are constructed by concatenating the connection method with
                connection action and the severity code and number.
                The value represents the actions to be preform by the OK/Cancel buttons,
                This actions are set by representing actions keys:
        
                BTS - navigate Back To current Screen.
        
                OBS - Open Browser Screen and navigate to returnedURL.
        
                RSS - Re-Start Service.
               
                ASD - Application Shut Down.
        
                BTA - navigate Back To the function Activation screen.
    
                NPU - No Pop Up is Needed.
    
                WTC - navigate to the  Welcome To Cal screen.
                CSS - navigate to Credit Solution Screen.
                CAS - navigate to Choose Amount Screen.
                MAS - navigate to My Account Screen.
                CPT - navigate to Choose Payment Type screen
                PFC - navigate to Choose Payment type For given Card
                GTL - navigate to Login Screen
                CTP - Call
                BH - navigate to Stifomat welcome screen
                STW - navigate to Stifomat welcome screen    
                null - No Action Needed.
            */

            errorDictionary: {

                // Still need to check with Amit.B about some of the actions
                'POST_CalAuthenticator?_W_001': { OK: 'BTS', Cancel: null },
                'POST_CalAuthenticator?_W_002': { OK: 'BTS', Cancel: null },
                'POST_CalAuthenticator?_W_003': { OK: 'BTS', Cancel: null },
                'POST_CalAuthenticator?_W_004': { OK: 'OBS', Cancel: 'BTS' },
                'POST_CalAuthenticator?_W_005': { OK: 'RSS', Cancel: 'BTS' },
                'POST_CalAuthenticator?_W_006': { OK: 'RSS', Cancel: 'BTS' },
                'POST_CalAuthenticator?_W_041': { OK: 'RSS', Cancel: 'BTS' },
                'POST_CalAuthenticator?_W_042': { OK: 'BTS', Cancel: null },
                'POST_CalAuthenticator?_W_043': { OK: 'OBS', Cancel: 'BTS' },
                'POST_CalAuthenticator?_W_044': { OK: 'OBS', Cancel: 'BTS' },
                'POST_CalAuthenticator?_W_045': { OK: null, Cancel: null },
                'POST_CalAuthenticator?_W_048': { OK: 'OBS', Cancel: 'BTS' },
                'POST_CalAuthenticator?_W_049': { OK: 'OBS', Cancel: 'BTS' },
                'POST_CalAuthenticator?_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'POST_CalAuthenticator?_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'POST_CalAuthenticator?_W_103': { OK: 'OBS', Cancel: 'BTS' },
                'POST_CalAuthenticator?_E_001': { OK: 'RSS', Cancel: 'BTS' },

                'POST_CalGeneralAuthenticator/GeneralLogin?_W_001': { OK: null, Cancel: null },
                'POST_CalGeneralAuthenticator/GeneralLogin?_W_002': { OK: null, Cancel: null },
                'POST_CalGeneralAuthenticator/GeneralLogin?_W_003': { OK: 'DT', Cancel: null },
                'POST_CalGeneralAuthenticator/GeneralLogin?_W_004': { OK: null, Cancel: null },

                'GET_CalTouch/DeleteTouchidRecord?_W_001': { OK: 'TOU', Cancel: 'TOU' },

                // No need to any action or alert
                'DELETE_CalAuthenticator?_W_001': { OK: null, Cancel: null },
                'DELETE_CalAuthenticator?_W_002': { OK: null, Cancel: null },
                'DELETE_CalAuthenticator?_E_001': { OK: null, Cancel: null },
                'DELETE_CalAuthenticator?_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'DELETE_CalAuthenticator?_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'DELETE_CalAuthenticator?_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_CardsByAccounts?_W_001': { OK: 'WTC', Cancel: null },
                'GET_CardsByAccounts?_W_002': { OK: 'RSS', Cancel: 'ASD' },
                'GET_CardsByAccounts?_W_003': { OK: 'GTL', Cancel: null },
                'GET_CardsByAccounts?_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CardsByAccounts?_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_CardsByAccounts?_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_CampaignsByCardMetaData/_W_001': { OK: 'WTC', Cancel: null },
                'GET_CampaignsByCardMetaData/_W_002': { OK: 'WTC', Cancel: null },
                'GET_CampaignsByCardMetaData/_W_003': { OK: 'RSS', Cancel: 'WTC' },
                'GET_CampaignsByCardMetaData/_W_004': { OK: 'RSS', Cancel: 'WTC' },
                'GET_CampaignsByCardMetaData/_E_001': { OK: 'RSS', Cancel: 'WTC' },
                'GET_CampaignsByCardMetaData/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CampaignsByCardMetaData/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_CampaignsByCardMetaData/_W_103': { OK: 'OBS', Cancel: 'BTS' },


                'GET_CalTransactions/_W_001': { OK: 'BTA', Cancel: null },
                'GET_CalTransactions/_W_002': { OK: 'BTA', Cancel: null },
                'GET_CalTransactions/_W_003': { OK: 'BTA', Cancel: null },
                'GET_CalTransactions/_W_004': { OK: 'RSS', Cancel: 'BTA' },
                'GET_CalTransactions/_W_006': { OK: 'RSS', Cancel: 'BTA' },
                'GET_CalTransactions/_W_007': { OK: 'RSS', Cancel: 'BTA' },
                'GET_CalTransactions/_E_001': { OK: 'RSS', Cancel: 'BTA' },
                'GET_CalTransactions/_E_002': { OK: 'RSS', Cancel: 'BTA' },
                'GET_CalTransactions/_W_005': { OK: 'BTA', Cancel: null },
                'GET_CalTransactions/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CalTransactions/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_CalTransactions/_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_CalTransDetails/_W_001': { OK: 'BTA', Cancel: null },
                'GET_CalTransDetails/_W_002': { OK: 'RSS', Cancel: 'BTA' },
                'GET_CalTransDetails/_W_003': { OK: 'RSS', Cancel: 'BTA' },
                'GET_CalTransDetails/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CalTransDetails/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_CalTransDetails/_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_CalSectorsSummary/_W_001': { OK: 'BTA', Cancel: null },
                'GET_CalSectorsSummary/_W_002': { OK: 'BTA', Cancel: null },
                'GET_CalSectorsSummary/_W_003': { OK: 'BTA', Cancel: null },
                'GET_CalSectorsSummary/_W_004': { OK: 'BTA', Cancel: null },
                'GET_CalSectorsSummary/_W_005': { OK: 'RSS', Cancel: 'BTA' },
                'GET_CalSectorsSummary/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CalSectorsSummary/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_CalSectorsSummary/_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_CalCreditFrame/_W_001': { OK: 'NPU', Cancel: null },
                'GET_CalCreditFrame/_W_002': { OK: 'NPU', Cancel: null },
                'GET_CalCreditFrame/_W_003': { OK: 'NPU', Cancel: null },
                'GET_CalCreditFrame/_W_004': { OK: 'NPU', Cancel: null },
                'GET_CalCreditFrame/_W_005': { OK: 'NPU', Cancel: null },
                'GET_CalCreditFrame/_E_001': { OK: 'NPU', Cancel: null },

                'GET_CalCreditFrame/_1_W_001': { OK: 'BTS', Cancel: null },
                'GET_CalCreditFrame/_1_W_002': { OK: 'BTS', Cancel: null },
                'GET_CalCreditFrame/_1_W_003': { OK: 'RSS', Cancel: 'BTS' },
                'GET_CalCreditFrame/_1_W_004': { OK: null, Cancel: null },
                'GET_CalCreditFrame/_1_E_001': { OK: 'RSS', Cancel: 'BTS' },

                'GET_CalGeneralData?_W_001': { OK: 'ASD', Cancel: null },
                'GET_CalGeneralData?_W_002': { OK: 'ASD', Cancel: null },
                'GET_CalGeneralData?_W_003': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CalGeneralData?_E_001': { OK: 'ASD', Cancel: null },
                'GET_CalGeneralData?_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CalGeneralData?_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_CalGeneralData?_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_CalBankDebits/_W_001': { OK: 'BTS', Cancel: null },
                'GET_CalBankDebits/_W_002': { OK: 'BTS', Cancel: null },
                'GET_CalBankDebits/_W_005': { OK: 'BTS', Cancel: null },
                'GET_CalBankDebits/_W_006': { OK: 'BTS', Cancel: null },
                'GET_CalBankDebits/_W_007': { OK: 'BTS', Cancel: null },
                'GET_CalBankDebits/_W_008': { OK: 'BTS', Cancel: null },
                'GET_CalBankDebits/_W_003': { OK: 'RSS', Cancel: 'BTS' },
                'GET_CalBankDebits/_W_004': { OK: 'RSS', Cancel: 'BTS' },
                'GET_CalBankDebits/_E_001': { OK: 'RSS', Cancel: 'BTS' },
                'GET_CalBankDebits/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CalBankDebits/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_CalBankDebits/_W_103': { OK: 'OBS', Cancel: 'BTS' },


                // W_004 W_003 NO actions
                'GET_CardEligiblityStatus/_W_001': { OK: 'CSS', Cancel: null },
                'GET_CardEligiblityStatus/_W_002': { OK: 'CSS', Cancel: null },
                'GET_CardEligiblityStatus/_W_005': { OK: 'CSS', Cancel: null },
                'GET_CardEligiblityStatus/_W_003': { OK: 'NPU', Cancel: null },
                'GET_CardEligiblityStatus/_W_004': { OK: 'NPU', Cancel: null },
                'GET_CardEligiblityStatus/_W_006': { OK: 'OBS', Cancel: 'CSS' },
                'GET_CardEligiblityStatus/_W_007': { OK: 'RSS', Cancel: 'CSS' },
                'GET_CardEligiblityStatus/_E_001': { OK: 'RSS', Cancel: 'CSS' },
                'GET_CardEligiblityStatus/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CardEligiblityStatus/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_CardEligiblityStatus/_W_103': { OK: 'OBS', Cancel: 'BTS' },
                'POST_api/MonthlyDebitPaymentSpread/GetCardEligibilityStatus?_W_011': { OK: 'RSS', Cancel: 'WTC' },
                "POST_api/MonthlyDebitPaymentSpread/GetCardEligibilityStatus?_W_004": { OK: 'RSS', Cancel: 'WTC' },

                'GET_LoanPaymentsRange/_W_001': { OK: 'CSS', Cancel: null },
                'GET_LoanPaymentsRange/_W_002': { OK: 'CSS', Cancel: null },
                'GET_LoanPaymentsRange/_W_003': { OK: 'CSS', Cancel: null },
                'GET_LoanPaymentsRange/_W_004': { OK: 'CAS', Cancel: null },
                'GET_LoanPaymentsRange/_W_005': { OK: 'CAS', Cancel: null },
                'GET_LoanPaymentsRange/_W_006': { OK: 'CAS', Cancel: null },
                'GET_LoanPaymentsRange/_W_007': { OK: 'RSS', Cancel: 'CSS' },
                'GET_LoanPaymentsRange/_E_001': { OK: 'RSS', Cancel: 'CSS' },
                'GET_LoanPaymentsRange/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_LoanPaymentsRange/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_LoanPaymentsRange/_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_SimulateLoanRequest/_W_001': { OK: 'CSS', Cancel: null },
                'GET_SimulateLoanRequest/_W_002': { OK: 'CSS', Cancel: null },
                'GET_SimulateLoanRequest/_W_006': { OK: 'CSS', Cancel: null },
                'GET_SimulateLoanRequest/_W_008': { OK: 'CSS', Cancel: null },
                'GET_SimulateLoanRequest/_W_004': { OK: 'CAS', Cancel: null },
                'GET_SimulateLoanRequest/_W_005': { OK: 'CAS', Cancel: null },
                'GET_SimulateLoanRequest/_W_003': { OK: 'CAS', Cancel: null },
                'GET_SimulateLoanRequest/_W_007': { OK: 'RSS', Cancel: 'CSS' },
                'GET_SimulateLoanRequest/_E_001': { OK: 'RSS', Cancel: 'CSS' },
                'GET_SimulateLoanRequest/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_SimulateLoanRequest/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_SimulateLoanRequest/_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_AproveLoanRequest/_W_001': { OK: 'CSS', Cancel: null },
                'GET_AproveLoanRequest/_W_002': { OK: 'CSS', Cancel: null },
                'GET_AproveLoanRequest/_W_004': { OK: 'CSS', Cancel: null },
                'GET_AproveLoanRequest/_W_003': { OK: 'RSS', Cancel: 'CSS' },
                'GET_AproveLoanRequest/_W_005': { OK: 'RSS', Cancel: 'CSS' },
                'GET_AproveLoanRequest/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_AproveLoanRequest/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_AproveLoanRequest/_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_FixedCardDebit/_W_001': { OK: 'CSS', Cancel: null },
                'GET_FixedCardDebit/_W_002': { OK: 'CSS', Cancel: null },
                'GET_FixedCardDebit/_W_003': { OK: 'NPU', Cancel: null },
                'GET_FixedCardDebit/_W_004': { OK: 'NPU', Cancel: null },
                'GET_FixedCardDebit/_W_005': { OK: 'OBS', Cancel: 'CSS' },
                'GET_FixedCardDebit/_W_006': { OK: 'NPU', Cancel: null },
                'GET_FixedCardDebit/_W_007': { OK: 'RSS', Cancel: 'CSS' },
                'GET_FixedCardDebit/_E_001': { OK: 'RSS', Cancel: 'CSS' },
                'GET_FixedCardDebit/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_FixedCardDebit/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_FixedCardDebit/_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_FixedCardDebit/_1_W_001': { OK: 'CSS', Cancel: null },
                'GET_FixedCardDebit/_1_W_002': { OK: 'CSS', Cancel: null },
                'GET_FixedCardDebit/_1_W_003': { OK: 'CAS', Cancel: null },
                'GET_FixedCardDebit/_1_W_004': { OK: 'CAS', Cancel: null },
                'GET_FixedCardDebit/_1_W_005': { OK: 'CAS', Cancel: null },
                'GET_FixedCardDebit/_1_W_006': { OK: 'RSS', Cancel: 'CSS' },
                'GET_FixedCardDebit/_1_W_007': { OK: 'CSS', Cancel: null },
                'GET_FixedCardDebit/_1_W_008': { OK: 'CAS', Cancel: null },
                'GET_FixedCardDebit/_1_E_001': { OK: 'RSS', Cancel: 'CSS' },
                'GET_FixedCardDebit/_1_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_FixedCardDebit/_1_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_FixedCardDebit/_1_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'PUT_FixedCardDebit/_W_001': { OK: 'CSS', Cancel: null },
                'PUT_FixedCardDebit/_W_002': { OK: 'CSS', Cancel: null },
                'PUT_FixedCardDebit/_W_003': { OK: 'RSS', Cancel: 'CSS' },
                'PUT_FixedCardDebit/_W_004': { OK: 'CSS', Cancel: null },
                'PUT_FixedCardDebit/_E_001': { OK: 'RSS', Cancel: 'CSS' },
                'PUT_FixedCardDebit/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'PUT_FixedCardDebit/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'PUT_FixedCardDebit/_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_CalChoice/_W_001': { OK: 'MAS', Cancel: null },
                'GET_CalChoice/_W_002': { OK: 'MAS', Cancel: null },
                'GET_CalChoice/_W_004': { OK: 'MAS', Cancel: null },
                'GET_CalChoice/_W_005': { OK: 'MAS', Cancel: null },
                'GET_CalChoice/_W_003': { OK: 'OBS', Cancel: 'MAS' },
                'GET_CalChoice/_E_001': { OK: 'RSS', Cancel: 'MAS' },
                'GET_CalChoice/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CalChoice/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_CalChoice/_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_CalChoiceRepayment/_W_001': { OK: 'CSS', Cancel: null },
                'GET_CalChoiceRepayment/_W_002': { OK: 'CSS', Cancel: null },
                'GET_CalChoiceRepayment/_W_003': { OK: 'CSS', Cancel: null },
                'GET_CalChoiceRepayment/_W_004': { OK: 'OBS', Cancel: 'CSS' },
                'GET_CalChoiceRepayment/_W_005': { OK: 'RSS', Cancel: 'CSS' },
                'GET_CalChoiceRepayment/_E_001': { OK: 'RSS', Cancel: 'CSS' },
                'GET_CalChoiceRepayment/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CalChoiceRepayment/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_CalChoiceRepayment/_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_CalChoiceRepayment/_1_W_001': { OK: 'CSS', Cancel: null },
                'GET_CalChoiceRepayment/_1_W_002': { OK: 'CSS', Cancel: null },
                'GET_CalChoiceRepayment/_1_W_003': { OK: 'CPT', Cancel: null },
                'GET_CalChoiceRepayment/_1_W_004': { OK: 'RSS', Cancel: 'CSS' },
                'GET_CalChoiceRepayment/_1_W_005': { OK: 'CPT', Cancel: null },
                'GET_CalChoiceRepayment/_1_W_006': { OK: 'CPT', Cancel: null },
                'GET_CalChoiceRepayment/_1_W_008': { OK: 'CPT', Cancel: null },
                'GET_CalChoiceRepayment/_1_W_009': { OK: 'CPT', Cancel: null },
                'GET_CalChoiceRepayment/_1_W_010': { OK: 'CPT', Cancel: null },
                'GET_CalChoiceRepayment/_1_W_011': { OK: 'CPT', Cancel: null },
                'GET_CalChoiceRepayment/_1_W_012': { OK: 'CPT', Cancel: null },
                'GET_CalChoiceRepayment/_1_E_001': { OK: 'RSS', Cancel: 'CSS' },
                'GET_CalChoiceRepayment/_1_W_007': { OK: 'PFC', Cancel: 'CPT' },
                'GET_CalChoiceRepayment/_1_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CalChoiceRepayment/_1_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_CalChoiceRepayment/_1_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'GET_CalChoiceRepayment/_2_W_001': { OK: 'CSS', Cancel: null },
                'GET_CalChoiceRepayment/_2_W_002': { OK: 'CSS', Cancel: null },
                'GET_CalChoiceRepayment/_2_W_003': { OK: 'CAS', Cancel: null },
                'GET_CalChoiceRepayment/_2_W_005': { OK: 'CAS', Cancel: null },
                'GET_CalChoiceRepayment/_2_W_006': { OK: 'CAS', Cancel: null },
                'GET_CalChoiceRepayment/_2_W_007': { OK: 'CAS', Cancel: null },
                'GET_CalChoiceRepayment/_2_W_008': { OK: 'RSS', Cancel: 'CSS' },
                'GET_CalChoiceRepayment/_2_E_001': { OK: 'RSS', Cancel: 'CSS' },
                'GET_CalChoiceRepayment/_2_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CalChoiceRepayment/_2_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'GET_CalChoiceRepayment/_2_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'POST_CalChoiceRepayment/_W_001': { OK: 'CSS', Cancel: null },
                'POST_CalChoiceRepayment/_W_002': { OK: 'CSS', Cancel: null },
                'POST_CalChoiceRepayment/_W_003': { OK: 'RSS', Cancel: 'CSS' },
                'POST_CalChoiceRepayment/_E_001': { OK: 'RSS', Cancel: 'CSS' },
                'POST_CalChoiceRepayment/_W_101': { OK: 'OBS', Cancel: 'ASD' },
                'POST_CalChoiceRepayment/_W_102': { OK: 'BTS', Cancel: 'ASD' },
                'POST_CalChoiceRepayment/_W_103': { OK: 'OBS', Cancel: 'BTS' },

                'POST_CalCustomerService?_W_001': { OK: 'BTA', Cancel: null },
                'POST_CalCustomerService?_W_002': { OK: 'BTA', Cancel: null },
                'POST_CalCustomerService?_W_003': { OK: 'RSS', Cancel: 'BTA' },
                'POST_CalCustomerService?_E_001': { OK: 'RSS', Cancel: 'MAS' },
                'POST_CalCustomerService?CardsByAccounts_E_001': { OK: 'RSS', Cancel: 'MAS' },

                'POST_CalWalletAuthenticatorOTPSend?_W_001': { OK: null, Cancel: null },
                'POST_CalWalletAuthenticatorOTPSend?_W_002': { OK: 'CTP', Cancel: 'BTS' },
                'POST_CalWalletAuthenticatorOTPSend?_W_003': { OK: 'CTP', Cancel: null },
                'POST_CalWalletAuthenticatorOTPSend?_E_001': { OK: 'CTP', Cancel: null },

                'POST_CalWalletAuthenticatorOTPVerify?_W_001': { OK: 'RSS', Cancel: null },
                'POST_CalWalletAuthenticatorOTPVerify?_W_002': { OK: null, Cancel: null },
                'POST_CalWalletAuthenticatorOTPVerify?_W_003': { OK: 'RSS', Cancel: 'BTS' },
                'POST_CalWalletAuthenticatorOTPVerify?_W_004': { OK: 'OBS', Cancel: 'BTS' },
                'POST_CalWalletAuthenticatorOTPVerify?_W_005': { OK: 'OBS', Cancel: 'BTS' },
                'POST_CalWalletAuthenticatorOTPVerify?_E_001': { OK: 'CTP', Cancel: null },

                'http_E_001': { OK: 'RSS', Cancel: null },
                'http_E_002': { OK: 'GTL', Cancel: null },
                'http_E_003': { OK: 'RAS', Cancel: 'ASD' },
                'http_E_004': { OK: 'LO', Cancel: 'WTC' },
                'noCards_E_001': { OK: 'GTL', Cancel: 'GTL' },
                'GET_CalShtifomatGetMetaData?_E_0001': { OK: 'STW', Cancel: null },
                'GET_CalShtifomatGetMetaData?_E_0002': { OK: 'STW', Cancel: null },
                'GET_CalShtifomatGetMetaData?_E_0003': { OK: 'STW', Cancel: null },
                'GET_CalShtifomatGetMetaData?_W_0001': { OK: 'STW', Cancel: null },

                'POST_CalShtifomatCheckSubscribeCust?_W_0001': { OK: 'STW', Cancel: null },
                'POST_CalShtifomatCheckSubscribeCust?_E_0001': { OK: 'STW', Cancel: null },
                'POST_CalShtifomatCheckSubscribeCust?_E_0002': { OK: 'STW', Cancel: null },

                'POST_CalShtifomatCheckSubscribeNumMem?_E_0001': { OK: 'STW', Cancel: null },
                'POST_CalShtifomatCheckSubscribeNumMem?_E_0002': { OK: 'STW', Cancel: null },
                'POST_CalShtifomatCheckSubscribeNumMem?_W_0001': { OK: 'STW', Cancel: null },

                'POST_CalShtifomatClubSubscribe?_E_0001': { OK: 'STW', Cancel: null },
                'POST_CalShtifomatClubSubscribe?_E_0002': { OK: 'STW', Cancel: null },
                'POST_CalShtifomatClubSubscribe?_W_0001': { OK: 'STW', Cancel: null },

                'POST_CalShtifomatClubUnSubscribe?_E_0001': { OK: 'STW', Cancel: null },
                'POST_CalShtifomatClubUnSubscribe?_E_0002': { OK: 'STW', Cancel: null },
                'POST_CalShtifomatClubUnSubscribe?_W_0001': { OK: 'STW', Cancel: null },

                'GET_CalWalletMetaData?_W_003': { OK: 'RAS', Cancel: 'ASD' },
                'GET_CalWalletMetaData?_W_001': { OK: 'RAS', Cancel: 'ASD' },
                'GET_CalWalletMetaData?_W_002': { OK: 'OBS', Cancel: 'ASD' },
                'GET_CalWalletMetaData?_E_001': { OK: 'RAS', Cancel: 'ASD' },

                //follow app
                'GET_api/calFollowApp/GetMetaData?_W_004': { OK: 'STW', Cancel: 'STW' },
                'GET_api/calFollowApp/GetMetaData?_E_001': { OK: 'STW', Cancel: 'STW' },

                'GET_api/calFollowApp/GetDocumentInfo?_W_001': { OK: 'STW', Cancel: null },
                'GET_api/calFollowApp/GetDocumentInfo?_W_002': { OK: 'STW', Cancel: null },
                'GET_api/calFollowApp/GetDocumentInfo?_W_003': { OK: 'SE', Cancel: null },
                'GET_api/calFollowApp/GetDocumentInfo?_W_004': { OK: 'RSS', Cancel: 'STW' },
                'GET_api/calFollowApp/GetDocumentInfo?_E_001': { OK: 'RSS', Cancel: 'STW' },

                'GET_api/calFollowApp/GetDocumentPhoto?_W_001': { OK: 'STW', Cancel: null },
                'GET_api/calFollowApp/GetDocumentPhoto?_W_002': { OK: 'STW', Cancel: null },
                'GET_api/calFollowApp/GetDocumentPhoto?_W_003': { OK: 'STW', Cancel: null },
                'GET_api/calFollowApp/GetDocumentPhoto?_W_004': { OK: 'RSS', Cancel: 'STW' },
                'GET_api/calFollowApp/GetDocumentPhoto?_W_005': { OK: 'STW', Cancel: null },
                'GET_api/calFollowApp/GetDocumentPhoto?_W_006': { OK: null, Cancel: null },
                'GET_api/calFollowApp/GetDocumentPhoto?_E_001': { OK: 'RSS', Cancel: 'STW' },

                'POST_api/calFollowApp/SetDocumentChanges?_W_001': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/SetDocumentChanges?_W_002': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/SetDocumentChanges?_W_003': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/SetDocumentChanges?_W_004': { OK: 'RSS', Cancel: 'STW' },
                'POST_api/calFollowApp/SetDocumentChanges?_W_005': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/SetDocumentChanges?_W_006': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/SetDocumentChanges?_W_007': { OK: null, Cancel: null },
                'POST_api/calFollowApp/SetDocumentChanges?_W_008': { OK: null, Cancel: null },
                'POST_api/calFollowApp/SetDocumentChanges?_W_009': { OK: null, Cancel: null },
                'POST_api/calFollowApp/SetDocumentChanges?_W_010': { OK: 'RSS', Cancel: 'STW' },
                'POST_api/calFollowApp/SetDocumentChanges?_W_011': { OK: 'RSS', Cancel: 'STW' },
                'POST_api/calFollowApp/SetDocumentChanges?_E_001': { OK: 'RSS', Cancel: 'STW' },

                'POST_api/calFollowApp/DeleteDocument?_W_001': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/DeleteDocument?_W_002': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/DeleteDocument?_W_003': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/DeleteDocument?_W_004': { OK: 'RSS', Cancel: 'STW' },
                'POST_api/calFollowApp/DeleteDocument?_W_005': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/DeleteDocument?_E_001': { OK: 'RSS', Cancel: 'STW' },

                'POST_api/calFollowApp/DeletePhoto?_W_001': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/DeletePhoto?_W_002': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/DeletePhoto?_W_003': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/DeletePhoto?_W_004': { OK: 'RSS', Cancel: 'STW' },
                'POST_api/calFollowApp/DeletePhoto?_W_005': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/DeletePhoto?_E_001': { OK: 'RSS', Cancel: 'STW' },

                'POST_api/calFollowApp/SaveNewDocument?_W_001': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/SaveNewDocument?_W_002': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/SaveNewDocument?_W_003': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/SaveNewDocument?_W_004': { OK: 'RSS', Cancel: 'STW' },
                'POST_api/calFollowApp/SaveNewDocument?_W_005': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/SaveNewDocument?_W_006': { OK: 'STW', Cancel: null },
                'POST_api/calFollowApp/SaveNewDocument?_W_007': { OK: null, Cancel: null },
                'POST_api/calFollowApp/SaveNewDocument?_W_008': { OK: null, Cancel: null },
                'POST_api/calFollowApp/SaveNewDocument?_W_009': { OK: 'RSS', Cancel: 'STW' },
                'POST_api/calFollowApp/SaveNewDocument?_W_010': { OK: 'RSS', Cancel: 'STW' },
                'POST_api/calFollowApp/SaveNewDocument?_W_011': { OK: 'RSS', Cancel: 'STW' },
                'POST_api/calFollowApp/SaveNewDocument?_W_012': { OK: null, Cancel: null },
                'POST_api/calFollowApp/SaveNewDocument?_W_013': { OK: null, Cancel: null },
                'POST_api/calFollowApp/SaveNewDocument?_W_014': { OK: 'RSS', Cancel: 'STW' },
                'POST_api/calFollowApp/SaveNewDocument?_E_001': { OK: 'RSS', Cancel: 'STW' },

                'POST_api/calFollowApp/SendEmail?_W_001': { OK: null, Cancel: null },
                'POST_api/calFollowApp/SendEmail?_W_002': { OK: null, Cancel: null },
                'POST_api/calFollowApp/SendEmail?_W_003': { OK: 'SE', Cancel: 'STW' },
                'POST_api/calFollowApp/SendEmail?_W_004': { OK: 'RSS', Cancel: 'STW' },
                'POST_api/calFollowApp/SendEmail?_W_005': { OK: 'SE', Cancel: 'STW' },
                'POST_api/calFollowApp/SendEmail?_W_014': { OK: 'RSS', Cancel: null },
                'POST_api/calFollowApp/SendEmail?_W_015': { OK: null, Cancel: null },
                'POST_api/calFollowApp/SendEmail?_E_001': { OK: 'RSS', Cancel: null },

                'GET_CalCellebGetMetaData?_E_0001': { OK: 'BTS', Cancel: null },
                'GET_CalCellebGetMetaData?_E_0002': { OK: 'BTS', Cancel: null },

                'POST_CalGenratePaymentCode?_W_0001': { OK: 'BTS', Cancel: null },
                'POST_CalGenratePaymentCode?_W_0002': { OK: 'BTS', Cancel: null },
                'POST_CalGenratePaymentCode?_W_0003': { OK: 'BTS', Cancel: null },
                'POST_CalGenratePaymentCode?_E_0001': { OK: 'BTS', Cancel: null },
                'POST_CalGenratePaymentCode?_E_0002': { OK: 'BTS', Cancel: null },

                'cellebHttp_E_0001': { OK: 'BTS', Cancel: null },

                //p2p
                'GET_CalP2PMetaData?_W_0001': { OK: 'WLT', Cancel: null },
                'GET_CalP2PMetaData?_E_0001': { OK: 'WLT', Cancel: null },


                'POST_CalP2PCheckCustomerInCal?_W_0001': { OK: null, Cancel: null },
                'POST_CalP2PCheckCustomerInCal?_W_0002': { OK: null, Cancel: null },
                'POST_CalP2PCheckCustomerInCal?_W_0004': { OK: null, Cancel: null },
                'POST_CalP2PCheckCustomerInCal?_E_0001': { OK: null, Cancel: null },


                'POST_TransferP2PTransaction?_W_0001': { OK: null, Cancel: null },
                'POST_TransferP2PTransaction?_W_0002': { OK: null, Cancel: null },
                'POST_TransferP2PTransaction?_W_0003': { OK: null, Cancel: null },
                'POST_TransferP2PTransaction?_W_0004': { OK: null, Cancel: null },
                'POST_TransferP2PTransaction?_W_0005': { OK: null, Cancel: null },
                'POST_TransferP2PTransaction?_W_0006': { OK: null, Cancel: null },
                'POST_TransferP2PTransaction?_W_0007': { OK: null, Cancel: null },
                'POST_TransferP2PTransaction?_W_0008': { OK: null, Cancel: null },
                'POST_TransferP2PTransaction?_W_0009': { OK: null, Cancel: null },
                'POST_TransferP2PTransaction?_W_0010': { OK: null, Cancel: null },
                'POST_TransferP2PTransaction?_E_0001': { OK: null, Cancel: null },


                'POST_ManageFavorites?_W_0001': { OK: null, Cancel: null },
                'POST_ManageFavorites?_W_0002': { OK: null, Cancel: null },
                'POST_ManageFavorites?_W_0003': { OK: null, Cancel: null },
                'POST_ManageFavorites?_E_0001': { OK: null, Cancel: null },


                'POST_GetP2PTransactions?_W_0001': { OK: 'BTS', Cancel: null },
                'POST_GetP2PTransactions?_W_0002': { OK: 'BTS', Cancel: null },
                'POST_GetP2PTransactions?_E_0001': { OK: 'BTS', Cancel: null },


                'POST_ApproveP2PTransfer?_W_0001': { OK: null, Cancel: null },
                'POST_ApproveP2PTransfer?_W_0002': { OK: null, Cancel: null },
                'POST_ApproveP2PTransfer?_W_0003': { OK: 'BTS', Cancel: null },
                'POST_ApproveP2PTransfer?_W_0004': { OK: null, Cancel: null },
                'POST_ApproveP2PTransfer?_W_0005': { OK: 'BTS', Cancel: null },
                'POST_ApproveP2PTransfer?_E_0001': { OK: null, Cancel: null },
                'POST_api/calmail/UpdateCalMailOrSms?_W_005': { OK: null, Cancel: null },
                'POST_api/calmail/UpdateCalMailOrSms?_W_006': { OK: null, Cancel: null },
                'POST_api/calmail/UpdateCalMailOrSms?_W_007': { OK: null, Cancel: null },
                'POST_api/calmail/UpdateCalMailOrSms?_E_001': { OK: null, Cancel: null },
                'GET_api/calmail/GetLastMonthReportList?_W_001': { OK: 'WTC', Cancel: null },
                'GET_api/calmail/GetLastMonthReportList?_W_005': { OK: 'WTC', Cancel: null },
                'GET_api/calmail/GetLastMonthReportList?_W_006': { OK: 'WTC', Cancel: null },
                'GET_api/calmail/GetLastMonthReportList?_E_001': { OK: 'WTC', Cancel: null },
                'POST_api/calmail/GetReportList?_W_001': { OK: null, Cancel: null },
                'POST_api/calmail/GetReportList?_W_005': { OK: null, Cancel: null },
                'POST_api/calmail/GetReportList?_W_006': { OK: null, Cancel: null },
                'POST_api/calmail/GetReportList?_W_007': { OK: null, Cancel: null },
                'POST_api/calmail/GetReportList?_E_001': { OK: null, Cancel: null },
                'POST_CalReferrals/GetReferrals?_W_001': { OK: null, Cancel: null },
                'POST_CalReferrals/GetReferrals?_W_002': { OK: null, Cancel: null },
                'POST_CalReferrals/GetReferrals?_W_003': { OK: null, Cancel: null },
                'POST_CalReferrals/GetReferrals?_W_009': { OK: null, Cancel: null },
                'POST_CalReferrals/GetReferrals?_E_001': { OK: null, Cancel: null },
                'POST_api/CalBlockCard/GetBlockedCardDetails?_E_001': { OK: 'BK', Cancel: null },
                'POST_api/CalBlockCard/GetBlockedCardDetails?_W_001': { OK: 'BK', Cancel: null },
                'POST_api/CalBlockCard/GetBlockedCardDetails?_W_002': { OK: 'BK', Cancel: null },
                'POST_api/CalBlockCard/GetBlockedCardDetails?_W_003': { OK: 'BK', Cancel: null },
                'POST_api/CalBlockCard/GetBlockedCardDetails?_W_004': { OK: 'BK', Cancel: null },
                'POST_api/CalBlockCard/GetBlockedCardDetails?_W_005': { OK: 'BK', Cancel: null },
                'POST_api/CalBlockCard/GetBlockedCardDetails?_W_006': { OK: 'BK', Cancel: null },
                'POST_api/CalBlockCard/UpdateCardStatus?_E_001': { OK: 'TA', Cancel: null },
                'POST_api/CalBlockCard/UpdateCardStatus?_W_001': { OK: null, Cancel: null },
                'POST_api/CalBlockCard/UpdateCardStatus?_W_002': { OK: null, Cancel: null },
                'POST_api/CalBlockCard/GetCustomerDetails?_E_001': { OK: 'TA', Cancel: null },
                'POST_api/CalBlockCard/GetCustomerDetails?_W_001': { OK: null, Cancel: null },
                'POST_api/CalBlockCard/GetCustomerDetails?_W_002': { OK: null, Cancel: null },
                'POST_api/CalBlockCard/CheckCardCVV?_E_001': { OK: 'TA', Cancel: null },
                'POST_api/CalBlockCard/CheckCardCVV?_W_002': { OK: 'BK', Cancel: null },
                'POST_api/CalBlockCard/CheckCardCVV?_W_003': { OK: 'BK', Cancel: null },
                'POST_api/CalBlockCard/CheckCardCVV?_W_004': { OK: null, Cancel: null },
                'POST_api/CalBlockCard/CheckCardCVV?_W_005': { OK: null, Cancel: null },
                'POST_api/CalBlockCard/CheckCardCVV?_W_006': { OK: 'BK', Cancel: null },
                'POST_api/PaymentSpread/GetValidForPaymentSpread?_W_001': { OK: 'BTS', Cancel: null },
                'POST_api/PaymentSpread/GetValidForPaymentSpread?_W_002': { OK: 'BTS', Cancel: null },
                'POST_api/PaymentSpread/GetValidForPaymentSpread?_W_003': { OK: 'BTS', Cancel: null },
                'POST_api/PaymentSpread/GetValidForPaymentSpread?_W_004': { OK: 'BTS', Cancel: null },
                'POST_api/PaymentSpread/GetValidForPaymentSpread?_W_005': { OK: 'BTS', Cancel: null },
                'POST_api/PaymentSpread/GetValidForPaymentSpread?_E_001': { OK: 'BTS', Cancel: null },
                'POST_api/PaymentSpread/UpDateRemoveBelongingForCards?_W_001': { OK: 'BTS', Cancel: null },
                'POST_api/PaymentSpread/UpDateRemoveBelongingForCards?_W_002': { OK: 'BTS', Cancel: null },
                'POST_api/PaymentSpread/UpDateRemoveBelongingForCards?_W_004': { OK: 'BTS', Cancel: null },
                'POST_api/PaymentSpread/UpDateRemoveBelongingForCards?_W_005': { OK: 'BTS', Cancel: null },
                'POST_api/PaymentSpread/UpDateRemoveBelongingForCards?_E_001': { OK: 'BTS', Cancel: null },
                'POST_api/PaymentSpread/GetValidForPaymentSpread?_W_006': { OK: 'BTS', Cancel: null },
                'POST_api/Payments/GetTransactionDetails?_W_002': { OK: 'WTC', Cancel: null },
                'POST_api/Payments/GetTransactionDetails?_W_003': { OK: 'WTC', Cancel: null },
                'POST_api/Payments/GetTransactionDetails?_W_004': { OK: 'WTC', Cancel: null },
                'POST_api/Payments/GetTransactionDetails?_W_005': { OK: 'WTC', Cancel: null },
                'POST_api/Payments/GetTransactionDetails?_W_006': { OK: 'WTC', Cancel: null },
                'POST_api/Payments/GetTransactionDetails?_W_007': { OK: 'WTC', Cancel: null },
                'POST_api/Payments/GetTransactionDetails?_W_000': { OK: 'WTC', Cancel: null },
                'POST_api/Payments/SimulateCreditPaymentsRequest?_E_001': { OK: null, Cancel: 'WTC' },

            }
        };
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
      .filter('trusted', trusted);

    trusted.$inject = ['$sce'];

    function trusted($sce) {
        return function (val) {
            if (typeof val === 'string' && val.length > 0) {
                return $sce.trustAsHtml(val);
            }
            return undefined;
        }
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';

    angular.module('digitalWallet').filter('calSearch', function () {
        var languageConverter = {
            'a': 'ש',
            'b': 'נ',
            'c': 'ב',
            'd': 'ג',
            'e': 'ק',
            'f': 'כ',
            'g': 'ע',
            'h': 'י',
            'i': 'ן',
            'j': 'ח',
            'k': 'ל',
            'l': 'ך',
            'm': 'צ',
            'n': 'מ',
            'o': 'ם',
            'p': 'פ',
            'r': 'ר',
            's': 'ד',
            't': 'א',
            'u': 'ו',
            'v': 'ה',
            'x': 'ס',
            'y': 'ט',
            'z': 'ז'
        };

        var reverseLanguageConverter = {};

        function reverseMap() {
            for (var key in languageConverter) {
                if (languageConverter.hasOwnProperty(key)) {
                    reverseLanguageConverter[languageConverter[key]] = key;
                }
            }
        }

        function convertLanguage(query, reverse) {
            var queryHeb = '';
            var converter = reverse ? reverseLanguageConverter : languageConverter;
            angular.forEach(query, function (char, index) {
                queryHeb += converter[char];
            });

            return queryHeb;
        }

        return function (arr, query) {
            query = query.replace(/[^a-zA-Zא-ת0-9/\s״"']/g, '');
            if (!query) {
                return [];
            }

            // Start to search only if the query has more than two letters.
            if (query.length < 2) {
                return [];
            }

            var queryMatch = [];
            query = query.toLowerCase();

            var convertedQuery;
            var regex = new RegExp('^[a-zA-Z]+$');
            if (regex.test(query)) {
                convertedQuery = convertLanguage(query);
                convertedQuery = convertedQuery && convertedQuery.toLowerCase();
            }
            else {
                regex = new RegExp('^[א-ת]+$');
                if (regex.test(query)) {
                    reverseMap();
                    convertedQuery = convertLanguage(query, true);
                    convertedQuery = convertedQuery && convertedQuery.toLowerCase();
                }
            }

            angular.forEach(arr, function (item) {
                if (item.caption.toLowerCase().indexOf(query) !== -1 ||
                    item.caption.toLowerCase().indexOf(convertedQuery) !== -1) {
                   // console.log('Found item filter => ', item);
                    if (item.hide != true) {
                        queryMatch.push(item);
                    }
                    return;
                }

                if (!item.keywords) {
                    //console.log('No keywords for item => ', item);
                    return;
                }

                var foundInKeywords = false;

                item.keywords.forEach(function (keyword) {
                    if ((keyword.toLowerCase().indexOf(query) > -1 ||
                        (convertedQuery && keyword.toLowerCase().indexOf(convertedQuery) > -1))
                        && !foundInKeywords) {
                     //   console.log('Found item filter with keywords => ', item);
                        foundInKeywords = true;
                        if (item.hide != true) {
                            queryMatch.push(item);
                        }
                    }
                });
            });

            return queryMatch;
        }
    })

})(window, window.angular);
﻿var wallet = wallet || {};
wallet.utils = wallet.utils || {};

(function () {
    
    var getPixelRatio = function() {
        var MAX_RATIO = 2;
        var pixelRatio = window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI;
        return pixelRatio <= MAX_RATIO ? pixelRatio : MAX_RATIO;
    }

    this.resolveEmSize = function() {
        var FONT_SIZE = "fontSize";
        var MIN_FONT_SIZE = 15;
        var MIN_WIDTH_FONT_RATIO = 18;
        var $body = $("body");

        //breakpoint will take the font size from body class
        $body.css(FONT_SIZE, "");
        
        var fontSize = parseFloat($body.css(FONT_SIZE).replace('px', ''));
        var screenRatio = getPixelRatio();

        var windowWidth = $(window).width();

        //font size after ratio calc
        var newFontSize = fontSize / screenRatio;
        var actualWindowSize = windowWidth * screenRatio;

        if (actualWindowSize / newFontSize < MIN_WIDTH_FONT_RATIO && screenRatio > 1) {
            newFontSize = (actualWindowSize / MIN_WIDTH_FONT_RATIO);
            if (newFontSize < MIN_FONT_SIZE)
                newFontSize = MIN_FONT_SIZE;
        }

        $body.css(FONT_SIZE, newFontSize);
        //console.log($body.css(FONT_SIZE));
    }

    this.alert = function (options) {

        var html = $('#alert-modal').clone();
        html.find('.alert-title').text(options.title || "ארנק כאל");
        html.find('.alert-content').text(options.content || "מצטערים אך ארעה שגיאה בלתי צפויה. נא לנסות שנית");

        html.find('button.ok').on('click', function () { $.unblockUI(); if (options && options.onClose) options.onClose(); return false; });

        $.blockUI({
            message: html,
            css: {
                width: '250px',
                top: ($(window).height() - 250) / 2 + 'px',
                left: ($(window).width() - 250) / 2 + 'px',
            }
        });
    }
}).apply(wallet.utils); 

Array.prototype.normalize = function(undefined) {
    if (this.length > 1) {
        return this;
    } else if (this.length == 1) {
        return this[0];
    } else {
        return undefined;
    }
}
Array.prototype.remove = function(value) {
    this.splice(this.indexOf(value) == -1 ? this.length : this.indexOf(value), 1);
}

Array.prototype.contains = function (value) {
    return this.indexOf(value) >= 0;
}

Array.prototype.compare = function (b) {
    return $(this).not(b).get().length === 0 && $(b).not(this).get().length === 0;
}

///<summary>
/// Function extension to String.
///	Replaces the placeholder tags '{0}...{n}' with the parameters based on ordinal position of the parameters
///	Example: String.format("The quick {0} fox {2} over the lazy {1}.", "brown", "Dog", "jumps");
///	Output:	The quick brown fox jumps over the lazy Dog.
///</summary>
String.format = function () {
    var currentString = null;
    if (arguments.length != 0) {
        currentString = arguments[0];
        for (var argumentIndex = 1; argumentIndex < arguments.length; argumentIndex++) {
            var modifiedString = new RegExp('\\{' + (argumentIndex - 1) + '\\}', 'gm');
            currentString = currentString.replace(modifiedString, arguments[argumentIndex]);
        }
    }

    return currentString;
};
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .controller("loanCtrl", loanCtrl);

    loanCtrl.$inject = [
        '$scope', '$rootScope', 'lobbyUiService', 'connection', '$stateParams', '$state', 'appData', 'ssoService', 'loan', 'appSettings', 'backService', '$sce'
    ];

    function loanCtrl($scope, $rootScope, lobbyUiService, connection, $stateParams, $state, appData, ssoService, loan, appSettings, backService, $sce) {

        var token = connection.isLoggedIn();
        if (!token) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.loanFrame' }, { location: 'replace' });
            return;
        }

        lobbyUiService.loader.show();

        ssoService.insertSsoDetails().then(function (res) {
            if (res) {
                var url = appSettings.ecreditLoan + "?source=2&suppress=true&sid=" + res.Token;
                console.info("loan url: ", url);
                $scope.loanUrl = $sce.trustAsResourceUrl(url);
                if (navigator.userAgent.toLowerCase().indexOf("safari") != -1) {
                    if (navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
                        window.open(url);
                        window.history.back();
                    }
                    else {
                        window.location = url;
                    }
                }
                else {
                    window.open(url);
                    window.history.back();
                }
            }
            lobbyUiService.loader.hide();
        }, function (err) {
            connection.logout();
            lobbyUiService.go('dw.login', { nextPage: 'dw.loanFrame' });
        });
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .controller("openBankingCtrl", openBankingCtrl);

    openBankingCtrl.$inject = ['lobbyUiService', 'connection', 'ssoService', 'appSettings', '$q'];

    function openBankingCtrl(lobbyUiService, connection, ssoService, appSettings, $q) {

        var token = connection.isLoggedIn();
        if (!token) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.openBanking' }, { location: 'replace' });
            return;
        }

        lobbyUiService.loader.show();

        var url = appSettings.openBankingUrl;

        ssoService.insertSsoDetails().then(function (res) {
            var query = 'bsid=' + res.Token;
            logout().then(function () {
                lobbyUiService.openExternal(url + "?" + query, null, false);
            });
        }, function (err) {
            lobbyUiService.openExternal(url, null, false);
            });

        var logout = function () {
            var deferred = $q.defer();
            var versionAndOS = 'CurrentVersion=' + appSettings.version + '&OperatingSystem=' + ((navigator && navigator.platform == 'iPhone') ? 'iOS' : 'Android');
            connection.genericConnection('DELETE', 'CalAuthenticator?', versionAndOS)
                .finally(function () {
                    connection.setToken(null);
                    sessionStorage.clear('authToken')
                    deferred.resolve();
                    });
            return deferred.promise;
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .controller("insightsFrameCtrl", insightsFrameCtrl);

    insightsFrameCtrl.$inject = [
        '$scope', '$rootScope', 'lobbyUiService', 'connection', '$stateParams', '$state', 'appData', 'ssoService', 'appSettings', 'backService', '$sce'
    ];

    function insightsFrameCtrl($scope, $rootScope, lobbyUiService, connection, $stateParams, $state, appData, ssoService, appSettings, backService, $sce) {

        var token = connection.isLoggedIn();

        if (!token) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.insightsFrame' });
            return;
        }
        //$scope.insightsUrl = function () {        
        //return $sce.trustAsResourceUrl(appSettings.customerInsights);
        //}
        $scope.hideNavBar;


        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        $scope.hideNavBar = inIframe();


        var sid = null;
        ssoService.insertSsoDetails().then(function (res) {
            if (res) {
                var url = appSettings.customerInsights + "?sid=" + res.Token;
                console.info("insights url: ", url);
                $scope.insightsUrl = $sce.trustAsResourceUrl(url);
            }
        }, function (err) {
            flag = false;
            connection.logout();
            lobbyUiService.go('dw.login', { nextPage: 'dw.insightsFrame' });
        });

        var childWin = document.getElementById('insights').contentWindow;

        var flag;
        window.addEventListener("message", function (e) {
            flag = true;
            var dataMsg;
            if (!e.data.hasOwnProperty('request')) {
                dataMsg = JSON.parse(e.data);
            }
            flag = true;

            if (dataMsg) {
                switch (dataMsg.status) {
                    case 'ready': {

                        childWin.postMessage(JSON.stringify({ token: token, sourceChannel: 2 }), '*');

                        break;
                    }
                    case 'move': {
                        flag = false;
                        lobbyUiService.go(dataMsg.goTo);
                        break;
                    }
                    case 'home': {
                        flag = false;
                        lobbyUiService.go('dw.lobby');
                        break;
                    }
                    case 'not connected': {
                        flag = false;
                        lobbyUiService.go('dw.login', { nextPage: 'dw.insightsFrame' });
                        break;
                    }
                    case 'stay': {
                        backService.replaceState('dw.insightsFrame');
                        break;
                    }
                }
            }
        })

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            var from = fromState.name;
            if (from === 'dw.insightsFrame') {
                if (flag) {
                    event.preventDefault();
                    childWin.postMessage({ state: 'leave', goTo: toState }, '*');
                }
            }
        });
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .controller("newChatCtrl", newChatCtrl);

    newChatCtrl.$inject = [
        '$scope', 'lobbyUiService', 'errorService', 'googleAnalyticsService',
        '$timeout', '$sce', 'newChatService'];

    function newChatCtrl($scope, lobbyUiService, errorService, googleAnalyticsService, $timeout, $sce, newChatService) {

        var vm = this;       

        lobbyUiService.loader.show();
        vm.title = "צ'אט עם נציג";
        newChatService.openChat();
        
        vm.newChatUrl = function () {            
            return $sce.trustAsResourceUrl(newChatService.iframeChat);            
        };

        vm.chatLoaded = function () {            
            lobbyUiService.loader.hide();
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calmail', []).config(calmailRoute);

    calmailRoute.$inject = ['$stateProvider'];

    function calmailRoute($stateProvider) {
        $stateProvider
            .state('dw.calmail', {
                url: "/account/calmail",
                cache: false,
                resolve: {
                }
            })
            .state('dw.calmail-register', {
                url: '/account/calmail/register',
                cache: false,
                views: {
                    'contentBody': {
                        templateUrl: "app/calmail/templates/register.html",
                        controller: "registerController"
                    }
                },
                resolve: {
                    initial: function (digitalServices, errorService, lobbyUiService, $timeout, $q) {
                        var deferred = $q.defer();
                        lobbyUiService.loader.show();
                        var customerType = digitalServices.getCustomerType();
                        var digitalType = digitalServices.getDigitalType();
                        if (customerType < 1 || digitalType < 1) {
                            digitalServices.getDigitalServices().then(function (data) {
                                lobbyUiService.loader.hide();
                                deferred.resolve();
                            }, function (err) {
                                if (!lobbyUiService.connection.isLoggedIn()) {
                                    $timeout(function () {
                                        lobbyUiService.go('dw.login', { nextPage: 'dw.calmail-list' });
                                    });
                                }
                                else {
                                    errorService.handleError(err);
                                }

                                lobbyUiService.loader.hide();
                                deferred.reject();
                            });
                        }
                        else {
                            lobbyUiService.loader.hide();
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }
                }
            })
            .state('dw.calmail-success', {
                url: '/account/calmail/success/',
                cache: false,
                views: {
                    'contentBody': {
                        templateUrl: "app/calmail/templates/success.html",
                        controller: "successController"
                    }
                },

            })
            .state('dw.calmail-list', {
                url: '/account/calmail/mail',
                cache: false,
                views: {
                    'contentBody': {
                        templateUrl: "app/calmail/templates/mail.html",
                        controller: "mailController"
                    }
                },
                resolve: {
                }
            })
            .state('dw.calmail-search', {
                cache:false,
                url: '/account/calmail/search',
                views: {
                    'contentBody': {
                        templateUrl: "app/calmail/templates/search.html",
                        controller: "searchController"
                    }
                },
                resolve: {
                    isLoggedIn: function (lobbyUiService, $timeout, $q) {
                        var defer = $q.defer();
                        if (!lobbyUiService.connection.isLoggedIn()) {
                            $timeout(function () {
                                lobbyUiService.go('dw.login', { nextPage: 'dw.calmail-list' });
                                defer.reject();
                                return;
                            });
                        }
                    }
                }
            })
            .state('dw.calmail-pdf', {
                url: "/account/calmail/pdf/:pdfUrl",
                cache:false,
                views: {
                    'contentBody': {
                        templateUrl: "app/calmail/templates/pdfView.html",
                        controller: "pdfViewController"
                    }
                }
            });
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalWallet')
        .factory('digitalServices', function (connection, errorService, $q, appData) {
            //aa
            var _digitalType = 0;  // 1 - registerToCalOnly, 2 - registerToPoalimOnly, 3 - registerDual , 4- notRegister  
            var _customerType = 0; // 1 - calOnly , 2 - poalimOnly, 3 - dual
            var _isRegistered = false;
            var _successCards = {};
            var _poalimEmail = "";
            var _calEmail = "";
            var _cardList = [];
            var setCustomerTypeAndSetDigitalType = function (arr, setDigitalType, setCustomerType) {
                if (setDigitalType && typeof setDigitalType === 'function') {
                    setDigitalType(arr);
                }
                if (setCustomerType && typeof setCustomerType === 'function') {
                    setCustomerType(arr);
                }
            }

            var getPoalimEmail = function () {
                return _poalimEmail
            }

            var setPoalimEmail = function (arr) {
                var digitalReportArrayFiltered = arr.filter(function (arr) {
                    return arr.CalMailType === 76
                });
                if (digitalReportArrayFiltered.length > 0) {
                    return _poalimEmail = digitalReportArrayFiltered[0].Email;
                }
                return "";

            }
            var getCalEmail = function () {
                return _calEmail
            }

            var setCalEmail = function () {
                if (appData) {
                    if (appData.CustomerInfo && appData.CustomerInfo.Email) {
                        _calEmail = appData.CustomerInfo.Email
                    }
                }
            }

            var isRegistered = function () {
                return _isRegistered;
            }

            var setIsRegistered = function (isRegistered) {
                _isRegistered = isRegistered;
            }

            var getSuccessCards = function () {
                return _successCards;
            }

            var setSuccessCards = function (arr) {
                _successCards = arr;
            }
            var getDigitalServices = function () {
                var deferred = $q.defer();
                var that = this;
                connection.getDigitalServices().then(function (res) {
                    if (res.Response && res.Response.Status.Succeeded === true) {
                        that.setIsRegistered(res.DigitalReportArray.some(x => x.IsRegistered == true));
                        that.setPoalimEmail(res.DigitalReportArray);
                        that.setCalEmail();
                        that.setCustomerTypeAndSetDigitalType(res.DigitalReportArray, that.setDigitalType, that.setCustomerType);
                        that.setCardList(res.CardList);
                        deferred.resolve(res);
                    }
                    else {
                        deferred.reject(res);
                    }

                }
                    , function (err) {
                        deferred.reject(err);
                    }
                );
                return deferred.promise;
            }

            var setDigitalType = function (arr) {
                var digitalReportArrayFiltered = arr.filter(function (arr) {
                    return arr.IsRegistered === true && (arr.CalMailType === 76 || arr.CalMailType === 1)
                });

                if (digitalReportArrayFiltered.length === 2) {
                    _digitalType = 3;

                }
                else if (digitalReportArrayFiltered.length === 1 && digitalReportArrayFiltered[0].CalMailType === 76) {
                    _digitalType = 2;

                }
                else if (digitalReportArrayFiltered.length === 1 && digitalReportArrayFiltered[0].CalMailType === 1) {
                    _digitalType = 1;
                }
                else {
                    _digitalType = 4;
                }

            }

            var getDigitalType = function () {
                return _digitalType;
            }

            var setCustomerType = function (customerArr) {
                var digitalReportArrayFiltered = customerArr.filter(function (arr) {
                    return arr.CalMailType === 76 || arr.CalMailType === 1
                });

                if (digitalReportArrayFiltered.length === 2) {
                    _customerType = 3;

                }
                else if (digitalReportArrayFiltered.length === 1 && digitalReportArrayFiltered[0].CalMailType === 76) {
                    _customerType = 2;

                }
                else if (digitalReportArrayFiltered.length === 1 && digitalReportArrayFiltered[0].CalMailType === 1) {
                    _customerType = 1;
                }

            }
            var getCustomerType = function () {
                return _customerType;
            }


            var hasPoalim = function () {
                if (getPoalimCards().length > 0) {
                    return true;
                }
                return false;
            }

            var joinCalMailOrSms = function (serviceReferer) {
                var request = {
                    "ServiceReferer": serviceReferer,
                    "ActionCode": 1,
                    "TransCommonServicesIndication": "37"
                }
                var deferred = $q.defer();
                var that = this;
                connection.updateCalMailOrSms(request).then(function (res) {
                    if (res.Response && res.Response.Status.Succeeded === true) {
                        //ToDo
                    }
                    deferred.resolve(res);
                }
                    , function (err) {
                        deferred.reject(err);
                    }
                );
                return deferred.promise;
            }

            var removeCalMailOrSms = function (serviceReferer) {
                var removeActionCode = 2;
                var request = {
                    ActionCode: removeActionCode,
                    TransCommonServicesIndication: "0",
                    ServiceReferer: serviceReferer
                }

                var deferred = $q.defer();
                connection.updateCalMailOrSms(request).then(function (res) {
                    if (res.Response && res.Response.Status.Succeeded === true) {
                        deferred.resolve(res);
                    }
                    else {
                        deferred.reject(res);
                    }

                }
                    , function (err) {
                        deferred.reject(err);
                    }
                );
                return deferred.promise;
            }

            var getReportList = function (req) {
                var deferred = $q.defer();
                var that = this;
                connection.getReportList(req).then(function (res) {
                    if (res.Response && res.Response.Status.Succeeded === true) {
                        deferred.resolve(res);
                    }
                    else {
                        deferred.reject(res);
                    }

                }
                    , function (err) {
                        deferred.reject(err);
                    }
                );
                return deferred.promise;
            }

            var setCardList = function (arr) {
                if (arr && arr.length > 0) {
                    _cardList = arr;
                }
            }
            var getCardList = function () {
                return _cardList;
            }


            return {
                getDigitalServices: getDigitalServices,
                getDigitalType: getDigitalType,
                hasPoalim: hasPoalim,
                joinCalMailOrSms: joinCalMailOrSms,
                removeCalMailOrSms: removeCalMailOrSms,
                getReportList: getReportList,
                setDigitalType: setDigitalType,
                setCustomerType: setCustomerType,
                getCustomerType: getCustomerType,
                setCustomerTypeAndSetDigitalType: setCustomerTypeAndSetDigitalType,
                getSuccessCards: getSuccessCards,
                setSuccessCards: setSuccessCards,
                getPoalimEmail: getPoalimEmail,
                setPoalimEmail: setPoalimEmail,
                getCalEmail: getCalEmail,
                setCalEmail: setCalEmail,
                isRegistered: isRegistered,
                setIsRegistered: setIsRegistered,
                setCardList: setCardList,
                getCardList: getCardList

            }
        })

})(window, angular);
﻿(function (window, angular) {
    'use strict';

    angular.module('calmail')

        .factory('calMailSrv', function () {
            var _eamil = '';
            var _list = null;
            var _cards = [];
            var _currentCard;
            var _debitDate;
            var _searchDateRange = {};


            var setEmail = function (email) {
                _eamil = email
            }

            var getEmail = function () {
                return _eamil;
            }

            var setList = function (list) {
                _list = list
            }

            var getList = function () {
                return _list;
            }

            var setCardsList = function (cards) {
                _cards = cards
            }

            var getCardsList = function () {
                return _cards;
            }

            var currentCard = function (card) {
                if (card) {
                    _currentCard = card;
                }
                return _currentCard;
            }

            var debitDate = function (date) {
                if (date) {
                    _debitDate = date.replace('/20', '');
                }
                return _debitDate;
            }

            var searchDateRange = function (date) {
                if (date) {
                    _searchDateRange = date;
                }
                return _searchDateRange;
            }



            return {
                setEmail: setEmail,
                getEmail: getEmail,
                getList: getList,
                setList: setList,
                setCardsList: setCardsList,
                getCardsList: getCardsList,
                currentCard: currentCard,
                debitDate: debitDate,
                searchDateRange: searchDateRange,


            }
        })

        .controller('pdfViewController', function ($scope, calMailSrv, appSettings,$timeout,commService) {
      
            commService.showBackButton(true);
            $scope.hideNavBar;
            $timeout(function () {

                var url = appSettings.server + 'api/calmail/GetExpenseReportPDF?last4Digits%3D' + calMailSrv.currentCard() + '%26debitDate%3D' + calMailSrv.debitDate();
                $scope.pdfUrl = 'app/calmail/lib/pdfjs/web/viewer.html?file=' + url;
            },500)

            function inIframe() {
                try {

                    var a = window.self !== window.top;
                    console.log("a", a);
                    return a;
                } catch (e) {
                    return false;
                }
            }
            $scope.hideNavBar = inIframe();

            console.log("$scope.pdfUr;", $scope.pdfUrl);


            $scope.$on('$destroy', function () {
                console.log("DESTROYED pdViewController ???");
                $scope.pdfUrl ='abount:blank';
            });

            $scope.$on('$ionicView.enter', function () {
                console.log("$scope.pdfUr;", $scope.pdfUrl);
            
                removeViewPort();
                addViewport(true, '$ionicView.enter');
            });

            $scope.$on('$ionicView.leave', function () {
                console.log("leaving page");
                $scope.pdfUrl = false;
                $timeout(function () {
                    $scope.pdfUrl = 'abount:blank';
                    //calMailSrv.setList([])
                    addViewport(false, '$ionicView.leave');
                })
       
            });

            function reloadViewPort(dynamicData) {
                removeViewPort();
                addViewport(dynamicData);
            }

            function removeViewPort() {
                $('head meta[name=viewport]').remove();
            }

            function addViewport(dynamicData, calledfrom) {
                var viewportMeta = document.createElement('meta');
                viewportMeta.setAttribute('id', 'myMeta');
                viewportMeta.setAttribute('name', 'viewport');
                var widthScreen = window.screen.width + 'px';
                if (dynamicData) {
                    viewportMeta.setAttribute('content', 'width=' + widthScreen + ' , user-scalable=yes');
                    document.getElementsByTagName("html")[0].style.touchAction = "auto";
                }
                else {
                    viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0');
                    document.getElementsByTagName("html")[0].style.touchAction = "pan-y";
                }
                document.getElementsByTagName("head")[0].appendChild(viewportMeta);
                console.log("view port added, calledfrom: " + calledfrom);
            }

            ga('send', 'pageview', '/vp/calmail_details /step4/success/');

        })
        .controller('mailController', function (commService,$scope, $state, lobbyUiService, lobbyStateService,
            connection, calMailSrv, errorService, appSettings, ssoService, digitalServices, appData, $timeout, $q) {
            $scope.customerType;
            $scope.hideNavBar;


            function inIframe() {
                try {

                    var a = window.self !== window.top;
                    console.log("a", a);
                    return a;
                } catch (e) {
                    return false;
                }
            }
            $scope.hideNavBar = inIframe();
            $scope.digitalType;
            $scope.openTakanon = function () {
                lobbyUiService.popup.message('app/calmail/templates/takanon.html', null, 'תקנון', 'calmail-popup');
            }

            $scope.ansAndQues = function () {
                lobbyUiService.popup.message('app/calmail/templates/ansAndQus.html', null, 'שאלות ותשובות', 'calmail-popup');
            }

            $scope.onChangeCheckBox = function (index) {
                console.log("changeCheckBox INdex", index);
                $scope.showSelectionError = false;
                $scope.selectedGroup.id = $scope.cardSelectionForDual.find(x => x.active === true).id;
            };

            $scope.$on('$ionicView.beforeLeave', function (e, viewData) {
                console.log('>>>>>LEAVING PAGE<<<<<');
                $scope.isRemoveExecuted = false;

            });

            $scope.removeService = function () {
               
                $scope.isRemoveCalMail = true;
                commService.showBackButton(true);
                $scope.isRemoveExecuted = false;
                //appData.backOverrideFN = init;
         
                $scope.header = 'הסרה מדפי פירוט דיגיטליים';
                $scope.isSearch = true; // hide email update link

                $scope.isDual = $scope.customerType === 3;
                $scope.isCal = $scope.customerType === 1;
                $scope.isPoalim = $scope.customerType === 2;



                $scope.cardSelectionForDual = [
                    {
                        "id": 1,
                        "text": "כרטיסי כאל",
                        "caption": "כרטיסי כאל",
                        "active": false,
                        "image":"bluecards.svg"
                    },
                    {
                        "id": 2,
                        "text": "כרטיסי בנק הפועלים",
                        "caption": "כרטיסי בנק הפועלים",
                        "active": false,
                        "image": "pinkcards.svg"
                    },
                    {
                        "id": 3,
                        "text": "כל הכרטיסים",
                        "caption": "כל הכרטיסים",
                        "active": false,
                        "image": "bluepinkcards.svg"
                    }
                ];
                $scope.selectedGroup = {
                    id: 0
                };

                $scope.removeComments = [
                    { "text": "בהסרה מהשירות, דפי הפירוט ישלחו אליך בדואר" },
                    { "text": "ניתן לצפות בפירוט החיובים באתר ובאפליקציית Cal" },
                    { "text": "לא ישלחו הודעות SMS או במייל עם קישור לדפי הפירוט" },
                    { "text": "השינוי יחול ממועד החיוב הקרוב" }
                ];

                $timeout(function () {
                    var realHeight = document.getElementById("realHeightCalMailRemove").scrollHeight;
                    commService.sendHeight(realHeight+60);
                })
            }

            $scope.onSubmitRemoveCalMail = function () {
                console.log("isRemoveExecuted 0 start " + $scope.isRemoveExecuted);
                const calServiceReferer = 1;
                const poalimServiceReferer = 76;
                $scope.showSelectionError = false;

                lobbyUiService.loader.show();

                if ($scope.isDual && $scope.digitalType === 3) {
                    console.log(" $scope.selectedGroup.id", $scope.selectedGroup.id);
                    if ($scope.selectedGroup.id == 0 || $scope.selectedGroup.id == "0") {
                        $scope.showSelectionError = true;
                        lobbyUiService.loader.hide();
                        return;
                    }
                    else {
                        removeCalMailOrSmsForDual();
                    }
                }
                else if ($scope.isCal || ($scope.isDual && $scope.digitalType === 1)) {
                    removeCalMailOrSmsForCalOrPoalim(calServiceReferer);

                    console.log("isRemoveExecuted 3 after " + $scope.isRemoveExecuted);
                }
                else if ($scope.isPoalim || ($scope.isDual && $scope.digitalType === 2)) {
                    removeCalMailOrSmsForCalOrPoalim(poalimServiceReferer);

                    console.log("isRemoveExecuted 3 after " + $scope.isRemoveExecuted);
                }

                console.log("isRemoveExecuted 4 end " + $scope.isRemoveExecuted);
            }

            var removeCalMailOrSmsForDual = function () {
                var removeResponse = {};
                const calServiceReferer = 1;
                const poalimServiceReferer = 76;

                if ($scope.selectedGroup.id === 3) {
                    digitalServices.removeCalMailOrSms(calServiceReferer).then(function (calRes) {
                        $scope.isRemoveExecuted = true;
                        //HERE
                        $('body').addClass('finish');
                        commService.showBackButton(false);
                        parent.postMessage({ call: "dwProcessEnd" }, '*');
                        removeResponse.calReferer = calRes;
                        if (removeResponse.calReferer.Response && removeResponse.calReferer.Response.Status.Succeeded === true) {

                            digitalServices.removeCalMailOrSms(poalimServiceReferer).then(function (poalimRes) {
                                removeResponse.poalimReferer = poalimRes;

                                if (removeResponse.poalimReferer.Response && removeResponse.poalimReferer.Response.Status.Succeeded === true) {
                                    handleRemoveFromServiceResponse(true);
                                    console.log("isRemoveExecuted 5 success " + $scope.isRemoveExecuted);
                                }
                                else {
                                    handleRemoveFromServiceResponse(false);
                                    console.log("isRemoveExecuted 5 fail " + $scope.isRemoveExecuted);
                                }
                            }, function (err) {
                                    handleRemoveFromServiceResponse(false);
                                    console.log("isRemoveExecuted 5 fail " + $scope.isRemoveExecuted);
                            });

                        }
                        else {
                            handleRemoveFromServiceResponse(false);
                            console.log("isRemoveExecuted 5 fail " + $scope.isRemoveExecuted);
                        }
                    }, function (err) {
                            handleRemoveFromServiceResponse(false);
                            console.log("isRemoveExecuted 5 fail " + $scope.isRemoveExecuted);
                    });
                }
                else {
                    var serviceReferer = $scope.selectedGroup.id === 1 ? calServiceReferer :
                        $scope.selectedGroup.id === 2 ? poalimServiceReferer : 0;

                    removeCalMailOrSmsForCalOrPoalim(serviceReferer);
                }
            }

            var removeCalMailOrSmsForCalOrPoalim = function (serviceReferer) {
                digitalServices.removeCalMailOrSms(serviceReferer).then(function (res) {
                    $scope.isRemoveExecuted = true;
                    $('body').addClass('finish');
                    parent.postMessage({ call: "dwProcessEnd" }, '*');
                    if (res.Response && res.Response.Status.Succeeded === true) {
                        handleRemoveFromServiceResponse(true);
                        console.log("isRemoveExecuted 5 success " + $scope.isRemoveExecuted);
                    }
                    else {
                        handleRemoveFromServiceResponse(false);
                        console.log("isRemoveExecuted 5 fail " + $scope.isRemoveExecuted);
                    }
                }, function (err) {
                        handleRemoveFromServiceResponse(false);
                        console.log("isRemoveExecuted 5 fail " + $scope.isRemoveExecuted);
                });
            }

            var handleRemoveFromServiceResponse = function (isSuccess) {
                $scope.showErrMsg = !isSuccess;
                $scope.isSuccess = isSuccess;
                $scope.isRemoveExecuted = true;
                $('body').addClass('finish');
                parent.postMessage({ call: "dwProcessEnd" }, '*');
                digitalServices.setIsRegistered(!isSuccess);
                lobbyUiService.loader.hide();
            }

            $scope.updateMail = function () {
                commService.updateEmailAddress({return:true});
            }

            $scope.openPdf = function (item) {
                console.log("item", item);
                calMailSrv.currentCard(item.last4Digits);
                calMailSrv.debitDate(item.DebitDate);
                $timeout(function () {
                    $state.go('dw.calmail-pdf');
                })
             
               // return;
            }
            $scope.go2search = function () {
                $state.go('dw.calmail-search');
            }

            $scope.go2register = function () {
                commService.updateEmailAddress({ return:true});
            }
            function init() {
                $scope.isRemoveCalMail = false;
               // appData.backOverrideFN = $scope.backToLobby;

                var list = calMailSrv.getList();
                commService.showBackButton(false);
                if (list != null && list.length > 0) {
                    if (list) {
                        $scope.isSearch = true;
                        $scope.header = 'תוצאות חיפוש';
                        $scope.list = list;
                        console.log("Search Results");
                        $timeout(function () {
                            console.log("ThisTimeout GetList");
                            var realHeight = document.getElementById("view-cal-mail").scrollHeight;
                            console.log("realHeight", realHeight);
                            commService.sendHeight(realHeight + 200);
                            commService.showBackButton(true);
                        })
                    }
                    else {
                        $scope.isSearch = true;
                        $scope.header = 'לא נמצאו דפי פירוט';
                    }
                }
                else {
                    $scope.isSearch = false;
                    $scope.header = 'צפייה בדפי פירוט דיגיטליים';
                    lobbyUiService.loader.show();
                    var req = buildRequest();

                    digitalServices.getReportList(req).then(function (res) {
                        console.log("line388 GerreportList", res);
                        lobbyUiService.loader.hide();
                        handleServiceStatus(res);
                        ga('send', 'pageview', '/vp/calmail_details/step1/welcome/');
                        $timeout(function () {
                            commService.showBackButton(false);
                            var realHeight = document.getElementById("view-cal-mail").scrollHeight;
                            commService.sendHeight(realHeight + 400);
                        })
                    }, function (error) {
                        //retry
                        digitalServices.getReportList(req).then(function (res) {
                            console.log("retry line 395 GetreportList", res);
                            lobbyUiService.loader.hide();
                            handleServiceStatus(res);
                            $timeout(function () {
                                var realHeight = document.getElementById("view-cal-mail").scrollHeight;
                                commService.sendHeight(realHeight + 400);
                            })
                        }, function (error) {
                            lobbyUiService.loader.hide();
                            if (error[0].response && error[0].response.RegisteredServicesList && error[0].response.RegisteredServicesList.length > 0) {
                                var err = handleServiceStatus(error[0].response, true);
                                if (err) {
                                    errorService.handleError(error);
                                }
                            }
                            else {
                                errorService.handleError(error);
                            }
                        });
                    });

                }
            }

            $scope.getDigitalServicesAndGoToRegister = function () {
                // go to register if digitalType === 4
                getDigitalServices();
            }

            function getDigitalServices() {
                console.log("GetDigitalServices does it run");
                lobbyUiService.loader.show();
                digitalServices.getDigitalServices().then(function (data) {
                    $scope.customerType = digitalServices.getCustomerType();
                    $scope.digitalType = digitalServices.getDigitalType();
                    // 1 - Cal , 2 - poalim , 3 -Dual, 4- Not Registered
                    if ($scope.digitalType === 4) {
                        console.log("digitalType4");
                        $timeout(function () {
                            lobbyUiService.go('dw.calmail-register');

                        });
                    }
                    else {
                        console.log("else INIT");
                        init();
                    }
                    lobbyUiService.loader.hide();

                }, function (err) {
                    if (!lobbyUiService.connection.isLoggedIn()) {
                        $timeout(function () {
                            lobbyUiService.go('dw.login', { nextPage: 'dw.calmail-list' });
                        });
                    }
                    else {
                        errorService.handleError(err);
                        lobbyUiService.go('dw.login', { nextPage: 'dw.lobby' });
                    }

                    lobbyUiService.loader.hide();

                });

            }



            function buildRequest() {
                var dateTo = new Date();
                var dateFrom = new Date().setDate(dateTo.getDate() - 30);
                var dateToMoment = moment(dateTo).format('DD-MM-YYYY');
                var dateFromMoment = moment(dateFrom).format('DD-MM-YYYY');
                var request = {
                    dateFrom: dateFromMoment,
                    dateTo: dateToMoment,
                    custId: appData.CustomerInfo.Id,
                    cardUniqueId: null,
                    accountNum: null,
                    calMailInd: 1,
                    updateCalMailView: 1,
                    isLeumi: 0
                };
                return request;
            }
            function handleServiceStatus(res, fromError) {
                if (res.ReportsList && res.ReportsList.length > 0) {
                    res.ReportsList.forEach(function (element) {
                        element.DebitDate = element.DebitDate.slice(3, element.DebitDate.length);
                    });
                }
                $scope.list = res.ReportsList;
                if (res.AttachmentsList && res.AttachmentsList.length > 0) {
                    res.AttachmentsList.unshift({ Description: 'להטבות והנחות המועדון' });
                    $scope.attachments = res.AttachmentsList;
                    $scope.coupon = $scope.attachments[0];
                }


            }



            $scope.goToCoupon = function () {
                if ($scope.coupon && $scope.coupon.Url) {
                    window.location.href = $scope.coupon.Url;
                }
            }

            if (!!lobbyUiService.connection.isLoggedIn()) {
                console.log("isLoggedIn yes and getdigitalSErvices");
                getDigitalServices();
            }
            else {
                $timeout(function () {
                    lobbyUiService.go('dw.login', { nextPage: 'dw.calmail-list' });
                });
            }

            $scope.backToLobby = function () {
               // lobbyUiService.go('dw.lobby');
                console.log("bakTolobby");
                commService.backToHomePage();
                $scope.isRemoveExecuted = false;
            }
        })
        .controller('successController', function ($scope, calMailSrv, lobbyUiService, digitalServices,$timeout,commService,$rootScope) {

            $scope.hideNavBar;
            function inIframe() {
                try {

                    var a = window.self !== window.top;
                    console.log("a", a);
                    return a;
                } catch (e) {
                    return false;
                }
            }

            parent.postMessage({ call: "dwProcessEnd" }, '*');
            $('body').addClass('finish');
            $scope.hideNavBar = inIframe();
            $scope.backToHomePage = function () {
                commService.backToHomePage();
            };

            $scope.calEmail = digitalServices.getCalEmail();
            $scope.poalimEmail = digitalServices.getPoalimEmail();

            $rootScope.$on("mailFromHost", function (evt, email) {
                console.log("mailFromHost rootscope on", email)
                $scope.calEmail = email;
                $scope.poalimEmail = email;
            })



            $timeout(function () {
               commService.getEmailFromParent();
           
            },100)
            $scope.go2home = function () {
                console.log("go2home");
                commService.backToHomePage();
               // lobbyUiService.go('dw.lobby');
            }
            $scope.calCards = [];
            $scope.poalimCards = [];
            var init = function () {
                //UpdateDigitalServices;
                digitalServices.getDigitalServices();
                var cards = digitalServices.getSuccessCards();
                if (cards != undefined && cards.cal && cards.cal.length > 0) {
                    $scope.calCards = cards.cal;
                }
                if (cards != undefined && cards.poalim && cards.poalim.length > 0) {
                    $scope.poalimCards = cards.poalim;
                }

            }

            init();

        })
        .controller('registerController', function ($scope, $state, connection, lobbyUiService, errorService, digitalServices, $q, $timeout, commService,$rootScope) {
            $scope.hideNavBar;
            function inIframe() {
                try {

                    var a = window.self !== window.top;
                    console.log("a", a);
                    return a;
                } catch (e) {
                    return false;
                }
            }
            $scope.hideNavBar = inIframe();
            $scope.calCheckBox;
            $scope.poalimCheckBox;
            $scope.customerType;
            $scope.digitalType;
            $scope.showPoalim;
            $scope.showCal;
            $scope.checkBoxObject =
                {
                    cal: {
                        selected: false,
                        show: false,
                        serviceReferer: 1,
                        email: digitalServices.getCalEmail()

                    },
                    poalim:
                    {
                        selected: false,
                        show: false,
                        serviceReferer: 76,
                        email: digitalServices.getPoalimEmail()
                    }
            }
            $timeout(function () {
              commService.getEmailFromParent();
             
            }, 100)

            $rootScope.$on("mailFromHost", function (evt, email) {
                console.log("mailFromHost rootscope on", email)

                $scope.checkBoxObject.cal.email = email;
                $scope.checkBoxObject.poalim.email = email;
            })

            $scope.openTakanon = function () {
                lobbyUiService.popup.message('app/calmail/templates/takanon.html', null, 'תקנון', 'calmail-popup');
            }
            $scope.ansAndQues = function () {
                lobbyUiService.popup.message('app/calmail/templates/ansAndQus.html', null, 'שאלות ותשובות', 'calmail-popup');
            }
            $scope.toggleCheckBox = function (obj) {
                obj.selected = !obj.selected;

            }
            $scope.updateMail = function () {
                commService.updateEmailAddress({return:false});
            }
            var joinCalMailOrSms = function (serviceReferer) {
                var deferred = $q.defer();
                digitalServices.joinCalMailOrSms(serviceReferer).then(function (res) {
                    if (res.Response.Status.Succeeded || (res.Response.Status.SeverityCode.toLowerCase() === "i" && res.Cards && res.Cards.length > 0)) {
                        deferred.resolve(res);
                    }
                    else {
                        deferred.reject(err);
                    }

                }, function (err) {
                    deferred.reject(err);
                });
                return deferred.promise;
            }
            var validateSubmit = function (isCal, isPoalim) {
                if (isCal || isPoalim) {
                    return true;
                }
                return false;

            }
            // Need Only 1 success
            $scope.submit = function () {
                lobbyUiService.loader.show();
                var countUpdateCalMailOrSms = 0;
                var succeeded = false;
                var cards = {};
                var updateCalMailOrSmsCal = $scope.checkBoxObject.cal.selected && $scope.checkBoxObject.cal.show;
                var updateCalMailOrSmsPoalim = $scope.checkBoxObject.poalim.selected && $scope.checkBoxObject.poalim.show;
                if (validateSubmit(updateCalMailOrSmsCal, updateCalMailOrSmsPoalim)) {


                    if (updateCalMailOrSmsCal) {
                        countUpdateCalMailOrSms = countUpdateCalMailOrSms + 1;
                        joinCalMailOrSms($scope.checkBoxObject.cal.serviceReferer).then(function (res) {
                            countUpdateCalMailOrSms = countUpdateCalMailOrSms - 1;
                            succeeded = true;
                            cards.cal = res.Cards;
                            if (countUpdateCalMailOrSms === 0) {
                                //GoToSuccesPage
                                digitalServices.setSuccessCards(cards);
                                lobbyUiService.go('dw.calmail-success');
                                lobbyUiService.loader.hide();
                            }
                        }, function (err) {
                            countUpdateCalMailOrSms = countUpdateCalMailOrSms - 1;
                            if (countUpdateCalMailOrSms === 0 && !succeeded) {
                                errorService.handleError(err);
                                lobbyUiService.loader.hide();
                            }
                            else if (countUpdateCalMailOrSms === 0 && succeeded) {
                                //GoToSuccesPage
                                digitalServices.setSuccessCards(cards);
                                lobbyUiService.go('dw.calmail-success');
                                lobbyUiService.loader.hide();
                            }
                        });
                    }
                    if (updateCalMailOrSmsPoalim) {
                        countUpdateCalMailOrSms = countUpdateCalMailOrSms + 1;
                        joinCalMailOrSms($scope.checkBoxObject.poalim.serviceReferer).then(function (res) {
                            countUpdateCalMailOrSms = countUpdateCalMailOrSms - 1;
                            succeeded = true;
                            cards.poalim = res.Cards;
                            if (countUpdateCalMailOrSms === 0) {
                                //GoToSuccesPage
                                digitalServices.setSuccessCards(cards);
                                lobbyUiService.go('dw.calmail-success');
                                lobbyUiService.loader.hide();
                            }
                        }, function (err) {
                            countUpdateCalMailOrSms = countUpdateCalMailOrSms - 1;
                            if (countUpdateCalMailOrSms === 0 && !succeeded) {
                                errorService.handleError(err);
                                lobbyUiService.loader.hide();
                            }
                            else if (countUpdateCalMailOrSms === 0 && succeeded) {
                                //GoToSuccesPage
                                digitalServices.setSuccessCards(cards);
                                lobbyUiService.go('dw.calmail-success');
                                lobbyUiService.loader.hide();
                            }
                        });
                    }
                }
                else {
                    //ToDo -> Show Validation Message
                    var popup = {};

                    popup.title = "הצטרפות לשירות דפי פירוט דיגיטליים";

                    popup.text = "כדי להצטרף לשירות צריך לבחור כרטיסים :)";

                    popup.btns = [];
                    popup.btns.push(
                        {
                            text: "סגור",
                            type: 'button-positive',
                            onTap: function () {
                                return;
                            }
                        }
                    );
                    lobbyUiService.popup.messageText(null, popup.text, popup.title, null, null, null, popup.btns, false);
                    lobbyUiService.loader.hide();
                }
            }

            var noCardsToAdd = function () {
                var popup = {
                };

                popup.title = "הצטרפות לשירות דפי פירוט דיגיטליים";

                popup.text = "איזה כיף! כל הכרטיסים שלך כבר מצורפים לשירות";

                popup.btns = [];
                popup.btns.push(
                    {
                        text: "סגור",
                        type: 'button-positive',
                        onTap: function () {
                            lobbyUiService.go('dw.calmail-list');
                        }
                    }
                );
                lobbyUiService.popup.messageText(null, popup.text, popup.title, null, null, null, popup.btns, false);
            }
            var init = function () {
                digitalServices.setSuccessCards({});
                $scope.customerType = digitalServices.getCustomerType();// 1 - calOnly , 2 - poalimOnly, 3 - dual
                $scope.digitalType = digitalServices.getDigitalType(); // 1 - registerToCalOnly, 2 - registerToPoalimOnly, 3 - registerDual , 4- notRegister 
                $scope.checkBoxObject.cal.selected = ($scope.digitalType === 1 || $scope.digitalType === 3) ? true : false;
                $scope.checkBoxObject.poalim.selected = ($scope.digitalType === 2 || $scope.digitalType === 3) ? true : false;
                if (!$scope.checkBoxObject.poalim.selected && ($scope.customerType === 2 || $scope.customerType === 3)) {
                    $scope.checkBoxObject.poalim.show = true;
                    //By demand if not registered do selected
                    $scope.checkBoxObject.poalim.selected = true;
                }


                if (!$scope.checkBoxObject.cal.selected && ($scope.customerType === 1 || $scope.customerType === 3)) {
                    $scope.checkBoxObject.cal.show = true;
                    //By demand if not registered do selected
                    $scope.checkBoxObject.cal.selected = true;
                }
                if (!$scope.checkBoxObject.cal.show && !$scope.checkBoxObject.poalim.show && digitalServices.isRegistered()) {
                    noCardsToAdd();
                }

            }

            init();



        })
        .controller('searchController', function ($scope, connection, calMailSrv, lobbyUiService, $state, errorService, digitalServices, appData,commService,$timeout) {
            //appData.backOverrideFN = function () {
            //    console.log("getsFunc");
            //    calMailSrv.setList(null);
            //    $state.go('dw.calmail');
            //}
            $scope.cards = ['כל הכרטיסים'];
            commService.showBackButton(true);
            var cardDesc;
            var getCardDesc = function () {
                cardDesc = digitalServices.getCardList();
                cardDesc = cardDesc.map(function (card) {
                    return card.cardDesc + " " + card.last4Digits;
                });
                $scope.cards = $scope.cards.concat(cardDesc);
                $scope.chosseCard = $scope.cards[0];
            }
            if (digitalServices.getCardList().length > 0) {
                getCardDesc();
            }
            else {
                digitalServices.getDigitalServices().then(function (res) {
                    getCardDesc();
                }, function (err) {
                    errorService.handleError(err);
                });
            }

            $scope.hideNavBar;

            function inIframe() {
                try {

                    var a = window.self !== window.top;
                    console.log("a", a);
                    return a;
                } catch (e) {
                    return false;
                }
            }
            $scope.hideNavBar = inIframe();

            calMailSrv.setList([]);

            var datesData = [];
            $scope.dates = [];
            var today = new Date();
            var tempMoment = moment(today, "YYYY/MM/DD");
            var tempMonth = tempMoment.format("MM");
            var tempYear = tempMoment.format("YYYY");
            var string = tempMonth + "-" + tempYear;
            datesData.push({
                id: 0,
                display: string,
                date: tempMoment.toDate()
            });

            for (var i = 1; i < 6; i++) {
                today.setFullYear(today.getFullYear(), today.getMonth() - 1);
                var tempMoment = moment(today, "YYYY/MM/DD");
                var tempMonth = tempMoment.format("MM");
                var tempYear = tempMoment.format("YYYY");
                var string = tempMonth + "-" + tempYear;
                datesData.push({
                    id: i,
                    display: string,
                    date: tempMoment.toDate()
                });
            }

            $scope.dates = datesData.map(function (item) {
                return {
                    id: item.id,
                    display: item.display
                }
            });

            $scope.updateDateArray = function () {
                console.log($scope.minDate);
                var index = $scope.dates.indexOf($scope.minDate);
                $scope.fromDateArr = $scope.dates.slice();
                $scope.fromDateArr = $scope.fromDateArr.splice(0, index + 1);
                console.log($scope.fromDateArr);
            }

            $scope.errorDate = false;

            $scope.search = function (searchFrm) {
                if (searchFrm.$valid) {
                    lobbyUiService.loader.show();
                    var card;
                    var cardUniqueId = "";
                    if ($scope.chosseCard !== 'כל הכרטיסים') {
                        card = $scope.chosseCard.substr($scope.chosseCard.length - 4, $scope.chosseCard.length - 1);
                        appData.BankAccounts.forEach(function (bank) {
                            bank.Cards.forEach(function (cardObj) {
                                if (cardObj.LastFourDigits.trim() === card.trim()) {
                                    return cardUniqueId = cardObj.Id;
                                }
                            })
                        })
                    } else {
                        card = null;
                        ga('send', 'pageview', '/vp/calmail_details/step2/popup_select_card/');
                    }

                    var indexFrom = $scope.dates.indexOf($scope.minDate);
                    var indexTo = $scope.dates.indexOf($scope.maxDate);
                    var fromDate = datesData[indexFrom].date;
                    var dateTo = datesData[indexTo].date;

                    //set from 1st to last day in month
                    fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), 1);
                    dateTo = new Date(dateTo.getFullYear(), dateTo.getMonth() + 1, 0);

                    //fix time zone for toJSON
                    fromDate.setHours(fromDate.getHours() - fromDate.getTimezoneOffset() / 60);
                    dateTo.setHours(dateTo.getHours() - dateTo.getTimezoneOffset() / 60);

                    var request = {
                        dateFrom: moment(fromDate).format('DD-MM-YYYY'),
                        dateTo: moment(dateTo).format('DD-MM-YYYY'),
                        custId: (cardUniqueId && cardUniqueId != "") ? "" : appData.CustomerInfo.Id,
                        cardUniqueId: (cardUniqueId && cardUniqueId != "") ? cardUniqueId : null,
                        accountNum: null,
                        calMailInd: 1,
                        updateCalMailView: 0,
                        isLeumi: 0
                    };
                    digitalServices.getReportList(request).then(function (res) {
                        console.log("line913 getReportList", res);
                        if (res.ReportsList && res.ReportsList.length > 0) {
                            res.ReportsList.forEach(function (element) {
                                element.DebitDate = element.DebitDate.slice(3, element.DebitDate.length);
                            });
                        }

                    
                        calMailSrv.setList(res.ReportsList);
                        
                        lobbyUiService.loader.hide();
                        $state.go('dw.calmail-list');
                        //$timeout(function () {
                        //    console.log("the timeout after setlist");
                        //    var realHeight = document.getElementById("view-cal-mail").scrollHeight;
                        //    console.log("realHeight", realHeight);
                        //    commService.sendHeight(realHeight + 400);
                        //})


                    }, function (error) {
                        lobbyUiService.loader.hide();
                        console.log(error);
                        errorService.handleError(error);
                    });
                } else {
                    $scope.errorDate = true;
                }
            }
            ga('send', 'pageview', '/vp/calmail_details/step2/select_card/');
        });



})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('blockCard', [])
    .run(function () {
        //TODO
    })
})(window, window.angular);
﻿(function (window, angular) {
  "use strict";
  angular.module("blockCard").config(blockCardRoute);

  function blockCardRoute($stateProvider) {
    //TODO http://localhost/DigitalWallet.UI/#!/digital/lobby

    $stateProvider
      .state("dw.block", {
        url: "/blockcard",
        abstract: true,
        views: {
          contentBody: {
            templateUrl: "app/blockCard/shared/templates/blockcard.html"
            //controller: "blockcardCtrl as vm"
          }
        }
      })
      .state("dw.defectiveCard", {
        url: "/defective-card/:updateAddressRedirect",
        analyticsUrl: "/vp/block-card/step2/show-brands/",
        cache: false,
        checkState: function ($q, $timeout, blockCardService, lobbyUiService) { },
        resolve: {
          checkState: function ($q, $timeout, blockCardService, lobbyUiService) {
            var defer = $q.defer();

            $timeout(function () {
              defer.resolve();
            });

            return defer.promise;
          }
        },

        views: {
          contentBody: {
            templateUrl: "app/blockCard/defective/defective.html",
            controller: "defectiveCtrl as vm"
          }
        }
      })
      .state("dw.blockCard", {
        url: "/block-card",
        analyticsUrl: "/vp/managecard/step1/blockcard-options/",
        cache: false,
        views: {
          contentBody: {
            templateUrl: "app/blockCard/block/block.html",
            controller: "blockCtrl as vm"
          }
        }
      })

      .state("dw.activateCardEnd", {
        url: "/activate-card-end",
        cache: false,
        resolve: {
          checkState: function ($q, $timeout, blockCardService, lobbyUiService) {
            var defer = $q.defer();
            $timeout(function () {
              var userDeatils = blockCardService.GetSetUserDeatils();
              if (userDeatils != null) {
                defer.resolve();
              } else {
                defer.reject();
                lobbyUiService.go("dw.activateCard");
              }
            });

            return defer.promise;
          }
        },
        views: {
          contentBody: {
            templateUrl: "app/blockCard/activate/activate-card-end.html",
            controller: "activateCardEndCtrl as vm"
          }
        }
      })

      .state("dw.activateCard", {
        url: "/activate-card",
        cache: false,
        analyticsUrl: "/vp/managecard/step1/restore-card/",
        views: {
          contentBody: {
            templateUrl: "app/blockCard/activate/activate-card.html",
            controller: "activateCtrl as vm"
          }
        }
      })

      .state("dw.defectiveCardEnd", {
        url: "/defective-card-end",
        cache: false,
        resolve: {
          checkState: function ($q, $timeout, blockCardService, lobbyUiService) {
            var defer = $q.defer();

            $timeout(function () {
              var userDeatils = blockCardService.GetSetUserDeatils();
              if (userDeatils != null) {
                defer.resolve();
              } else {
                defer.reject();
                lobbyUiService.go("dw.defectiveCard");
              }
            });

            return defer.promise;
          }
        },
        views: {
          contentBody: {
            templateUrl: "app/blockCard/defective/defective-card-end.html",
            controller: "defectiveCardEndCtrl as vm"
          }
        }
      })
      .state("dw.blockCardConfirm", {
        url: "/block-card-confirm:updateAddressRedirect",
        cache: false,
        resolve: {
          checkState: function ($q, $timeout, blockCardService, lobbyUiService) {
            var defer = $q.defer();

            $timeout(function () {
              var userDeatils = blockCardService.GetSetUserDeatils();
              if (userDeatils != null) {
                defer.resolve();
              } else {
                defer.reject();
                lobbyUiService.go("dw.blockCard");
              }
            });

            return defer.promise;
          }
        },
        views: {
          contentBody: {
            templateUrl: "app/blockCard/block/block-confirm.html",
            controller: "blockConfirmCtrl as vm"
          }
        }
      })




        .state("dw.blockCardContactUs", {
            url: "/block-card-contact-us",
            cache: false,
            //resolve: {
            //    checkState: function ($q, $timeout, blockCardService, lobbyUiService) {
            //        var defer = $q.defer();

            //        $timeout(function () {
            //            var userDeatils = blockCardService.GetSetUserDeatils();
            //            if (userDeatils != null) {
            //                defer.resolve();
            //            } else {
            //                defer.reject();
            //                lobbyUiService.go("dw.blockCard");
            //            }
            //        });

            //        return defer.promise;
            //    }
            //},
            views: {
                contentBody: {
                    templateUrl: "app/blockCard/block/block-contact-us.html",
                    controller: "blockContactUsCtrl as vm"
                }
            }
        })





      .state("dw.blockCardEnd", {
        url: "/block-card-end",
        cache: false,
        resolve: {
          checkState: function ($q, $timeout, blockCardService, lobbyUiService) {
            var defer = $q.defer();

            $timeout(function () {
              var userDeatils = blockCardService.GetSetUserDeatils();
              if (userDeatils != null) {
                defer.resolve();
              } else {
                defer.reject();
                lobbyUiService.go("dw.blockCard");
              }
            });

            return defer.promise;
          }
        },
        views: {
          contentBody: {
            templateUrl: "app/blockCard/block/block-card-end.html",
            controller: "blockCardEndCtrl as vm"
          }
        }
      })

      .state("dw.contactless", {
        url: "/contactless:updateAddressRedirect",
        cache: false,
        // resolve: {
        //     checkState: function ($q, $timeout, blockCardService, lobbyUiService) {
        //         var defer = $q.defer();

        //         $timeout(function () {
        //             var userDeatils = blockCardService.GetSetUserDeatils();
        //             if (userDeatils != null) {
        //                 defer.resolve();
        //             }
        //             else {
        //                 defer.reject();
        //                 lobbyUiService.go('dw.login', { nextPage: 'dw.contactless' }, { location: 'replace' });
        //             }
        //         })

        //         return defer.promise;
        //     }
        // },
        views: {
          contentBody: {
            templateUrl: "app/blockCard/contactless/contactless.html",
            controller: "contactlessCtrl as vm"
          }
        }
      })

      .state("dw.contactlessCardEnd", {
        url: "/contactless-card-end/:clCardEndState/:uniqueID",
        cache: false,
        // resolve: {
        //   checkState: function($q, $timeout, blockCardService, lobbyUiService) {
        //     var defer = $q.defer();

        //     $timeout(function() {
        //       var userDeatils = blockCardService.GetSetUserDeatils();
        //       if (userDeatils != null) {
        //         defer.resolve();
        //       } else {
        //         defer.reject();
        //         lobbyUiService.go("dw.contactless");
        //       }
        //     });

        //     return defer.promise;
        //   }
        // },
        views: {
          contentBody: {
            templateUrl: "app/blockCard/contactless/contactless-card-end.html",
            controller: "contactlessCardEndCtrl as vm"
          }
        }
      });
  }
})(window, window.angular);

﻿(function (window, angular) {
    'use strict';
    angular.module('blockCard')
    .factory('blockCardService', blockCardService);

    blockCardService.$inject = [
        'connection', 'appData', '$q', '$timeout', 'lobbyUiService', 'errorService', '$parse', '$location', '$ionicScrollDelegate', 'googleAnalyticsService'
    ];


    function blockCardService(connection, appData, $q, $timeout, lobbyUiService, errorService, $parse, $location, $ionicScrollDelegate, googleAnalyticsService) {
        var _errorText = {
            dateInvaid: "צריך לבחור תאריך",
            country: "יש להקליד שם מדינה בה הכרטיס אבד/נגנב",
            blockReason: "יש לבחור האם הכרטיס אבד/נגנב",
            blockReasonVirtualCard:  "יש לבחור את הסיבה לחסימת הכרטיס"
        }

        var _analyticsBlockTypeReason = "";
        var _analyticsBlockTypeTempConstant = "";

        var _lastUpdate = {};

        var _operationEnum = {
            DEF: 'defective',
            ACTIVE: 'activate',
            BLOCK: 'block',
            BlockConfirm: 'blockConfirm',
            Contactless:'contactless'
        }
        var _operation = {
            defective: { name: 'defective', number: 3, cardProcessTypeEnum: 'Defective', title: 'החלפת כרטיס פגום' },
            activate: { name: 'activate', number: 2, cardProcessTypeEnum: 'Activate', title: 'החזרת כרטיס לפעילות' },
            block: { name: 'block', number: 1, cardProcessTypeEnum: 'Block', title: 'חסימת כרטיס' },
            blockConfirm: { name: 'block-confirm', number: 1, cardProcessTypeEnum: 'Block', title: 'חסימת כרטיס' },
            contactless: { name: 'contactless', number: 4, cardProcessTypeEnum: 'Contactless', title: 'החלפת כרטיס ללא מגע' },

        };

        function getSetLastUpdate(request) {
            if (request != undefined && request != "") {
                _lastUpdate = request;
            }
            return _lastUpdate;
        }

        function getOperation(operation) {
            return _operation[operation];
        }
        //not this one.
        var _blockReasonType = [{ caption: 'אבד', active: false, name: "Lost" }, { caption: 'נגנב', active: false, name: "Stolen" }];
        var _blockReasonTypeVirtualCard = [{ caption: 'הטלפון שלי אבד או נגנב', active: false, name: "Device Lost", text: "הטלפון שלי אבד או נגנב", image: "virtual-stolen.svg" }, { caption: 'ייתכן שמישהו נחשף לפרטי הכרטיס', active: false, name: "Card Details Exposed", text: "ייתכן שמישהו נחשף לפרטי הכרטיס", image: "virtual-exposed.svg" }];


        var _steps = {
            block: [{ caption: 'פרטי חסימה', active: false }, { caption: 'אישור', active: false }, { caption: 'סיכום', active: false }],
            defective: [{ caption: 'בוחרים כרטיס ומאשרים', active: false }, { caption: 'סיכום', active: false }],
            activate: [{ caption: 'בוחרים כרטיס ומאשרים', active: false }, { caption: 'סיכום', active: false }],
            contactless: [{ caption: 'בוחרים כרטיס ומאשרים', active: false }, { caption: 'סיכום', active: false }]
        };

        var _blockTypeEnum = {
            temp: { name: "Temp", isChosen: true },
            constant: { name: "Constant", isChosen: false }
        };



        var _userBlockCardDeatils = [];
        var _blockedCardDetails = [];
        var _userDeatils = null;
        var _currentCard = "";
        var _mobilePhone;
        var _datePickerValue = "";
        var _blockType = 0;
        var _countryCardDisappeared;
        var _cvv = "";
        var _responseBlockCardItems;
        var _isFromConfirm = false;
        var _isVirtualCard;


        function getSetIsVirtualCard(value) {
            if (value != undefined) {
                _isVirtualCard = value;
            }
            return _isVirtualCard;
        }


        function getSetUserDeatils(value) {
            if (value != undefined) {
                _userDeatils = value;
            }
            return _userDeatils;
        }

        function setGetCvv(value) {
            if (value != undefined) {
                _cvv = value;
            }
            return _cvv;
        }


        function getSteps(process, page) {


            switch (process.toLowerCase()) {
                case _operation.block.name.toLowerCase():
                    return getActivePage(_steps.block, page);
                    break;
                case _operation.defective.name.toLowerCase():
                case _operation.activate.name.toLowerCase():
                    return getActivePage(_steps.defective, page);
                    break;
                 case _operation.contactless.name.toLowerCase():   
                 return getActivePage(_steps.contactless, page);
            }
        }

        function getActivePage(stepToSend, page) {

            for (var i = 0; i < stepToSend.length; i++) {
                stepToSend[i].active = false;
            }

            stepToSend[page].active = true;
            return stepToSend;

        }


        function getSetMobilePhone() {
            return _mobilePhone;
        }

        function getCountryList(country) {
            var defer = $.Deferred();
            var url = 'app/blockCard/shared/country-picker.component/country-list.json';
            $.getJSON(url, function (d) {
                defer.resolve(d);
            })
            return defer.promise();
        }


        function setStatusCheckBox(index) {
            _checkBox[1] = index;
        }

        function setGetblockedCardDetails(blockCards) {
            if (blockCards != undefined) {
                _blockedCardDetails = blockCards;
            }
            return _blockedCardDetails
        }


        function isMatch(card) {
            //return response.BlockCardItems.indexOf(card.Id) > -1;
            return _responseBlockCardItems.BlockCardItems.indexOf(card.Id) > -1;
        }

        function getBlockedCardDetails(request) {
            var deferred = $q.defer();


            lobbyUiService.loader.show();
            connection.getBlockedCardDetails(request).then(function (response) {

                if (response.Response.Status.Succeeded) {
                    _mobilePhone = response.MobilePhone;
                    var creditArray = [];
                    var cardsDictionary = {};

                    creditArray = [];
                    _responseBlockCardItems = response;

                    for (var i = 0; i < appData.BankAccounts.length; i++) {
                        var cardFilter = appData.BankAccounts[i].Cards.filter(isMatch);

                        if (cardFilter.length > 0) {
                            cardFilter.forEach(function (card) {
                                cardsDictionary[card.Id] = card;
                            })

                        }
                    }

                    response.BlockCardItems.forEach(function (cardItem) {

                        if (cardsDictionary[cardItem]) {
                            creditArray.push(cardsDictionary[cardItem]);

                        }
                    })
                    setGetblockedCardDetails(creditArray);
                    //_blockedCardDetails.push(creditArray);
                    deferred.resolve(creditArray);


                }
                else {

                    //throw error
                }

                lobbyUiService.loader.hide();

            }, function (error) {
                //throw error
                googleAnalyticsService.trackPage('/vp/managecard/step3/no-cards-to-restore/');
                errorService.handleError(error, null, null, true);
                lobbyUiService.loader.hide();
                deferred.reject(error);

            });

            return deferred.promise;

        }



        function getLast4Digit(uniqId) {
            var blockCards = _blockedCardDetails;
            if (blockCards != undefined) {
                for (var i = 0; i < blockCards.length; i++) {

                    if (blockCards[i].Id === uniqId) {
                        return blockCards[i].LastFourDigits;
                    }
                }
            }

            return false;

        }

        function getCustomerDetails(request) {


            var deferred = $q.defer();

            _currentCard = request.UniqueID;
            var result = getCustomerDeatilsFromCache(request.UniqueID);
            if (!result) {
                lobbyUiService.loader.show();
                connection.getCustomerDetails(request).then(function (response) {

                    if (response.Response.Status.Succeeded) {
                        deferred.resolve(response);
                        response.uniqueID = request.UniqueID;

                        _userBlockCardDeatils.push(response);
                    }
                    else {
                        deferred.reject(response);
                        //thorw error
                    }

                    lobbyUiService.loader.hide();

                }, function (error) {
                    lobbyUiService.loader.hide();
                    errorService.handleError(error, null, null, true);
                    deferred.reject(error);

                });
            }
            else {
                deferred.resolve(result);
            }

            return deferred.promise;
        }


        function getCustomerDeatilsFromCache(uniqueID) {

            for (var i = 0; i < _userBlockCardDeatils.length; i++) {
                if (_userBlockCardDeatils[i].uniqueID === uniqueID) {
                    return _userBlockCardDeatils[i];
                }
            }
            return false;
        }

        function updateCardStatus(request) {


            var deferred = $q.defer();

            lobbyUiService.loader.show();
            getSetLastUpdate(request);

            connection.updateCardStatus(request).then(function (response) {


                if (response.Response.Status.Succeeded) {

                    switch (request.CardProcessType.toLowerCase()) {
                        case _operation.block.name.toLowerCase():
                            lobbyUiService.go('dw.blockCardEnd', {});
                            break;
                        case _operation.defective.name.toLowerCase():
                            lobbyUiService.go('dw.defectiveCardEnd', {});
                            break;
                        case _operation.activate.name.toLowerCase():
                            lobbyUiService.go('dw.activateCardEnd', {});
                            break;
                    }




                    deferred.resolve(response);
                }
                else {
                    deferred.reject(false);
                    //throw error!
                }

                lobbyUiService.loader.hide();

            }, function (error) {
                    let currentCard = appData.BankAccounts.find(ba => ba.Cards.find(c => c.Id == request.UniqueID)).Cards.find(c => c.Id == request.UniqueID);
                    if (!currentCard.IsVirtualCard) {
                        errorService.handleError(error, null, null, true);
                    }
                lobbyUiService.loader.hide();
                deferred.reject(error);

            });



            return deferred.promise;



        }

        function getCurrentCard() {
            return _currentCard;
        }

        function setCurrentCard(currentCard) {
            _currentCard = currentCard
        }

        function resetBlockType() {
            _blockTypeEnum = {
                temp: { name: "Temp", isChosen: true },
                constant: { name: "Constant", isChosen: false }
            };
            return _blockTypeEnum;
        }

        function setGetBlockType(value, isGetName) {
            if (value != undefined) {
                if (value === 1) {
                    _analyticsBlockTypeTempConstant = "Yes";
                    _blockTypeEnum.temp.isChosen = true;
                    _blockTypeEnum.constant.isChosen = false;
                } else {
                    _analyticsBlockTypeTempConstant = "No";
                    _blockTypeEnum.temp.isChosen = false;
                    _blockTypeEnum.constant.isChosen = true;
                }
            }

            if (isGetName) {
                if (_blockTypeEnum.temp.isChosen) {
                    _analyticsBlockTypeTempConstant = "Yes";
                    return _blockTypeEnum.temp.name;
                }
                else {
                    _analyticsBlockTypeTempConstant = "No";
                    return _blockTypeEnum.constant.name;
                }
            }

            return _blockTypeEnum;
        }

        function isFromConfirm(value) {
            if (value != undefined) {
                _isFromConfirm = value;
            }
            return _isFromConfirm;
        }

        function setGetDatePickerValue(value) {
            if (value != undefined) {
                _datePickerValue = value;
                try {
                    var blockReason = _analyticsBlockTypeReason;
                    googleAnalyticsService.trackPage('/vp/managecard/blockcard/step3/choose-date/?type=' + blockReason.name);
                }
                catch (ex) {
                    console.log('googleAnalyticsService setGetDatePickerValue ex: ' + ex)
                }
            }
            return _datePickerValue;
        }

        function setGetContryPickerValue(value) {
            if (value != undefined) {
                _countryCardDisappeared = value;
                try {
                    var blockReason = _analyticsBlockTypeReason;
                    googleAnalyticsService.trackPage('/vp/managecard/blockcard/step2/choose-country/?type=' + blockReason.name);
                }
                catch (ex) {
                    console.log('googleAnalyticsService setGetContryPickerValue ex: ' + ex)
                }
            }
            return _countryCardDisappeared;
        }

        function getSetBlockReasonType(value, isGetName) {
            if (value != undefined) {
                _analyticsBlockTypeReason = _blockReasonType[value];
                _blockReasonType[value].active = true;
                if (value > 0) {
                    _blockReasonType[value - 1].active = false;
                } else {
                    _blockReasonType[value + 1].active = false;
                }
            }
            if (isGetName) {
                if (_blockReasonType[0].active) {
                    _analyticsBlockTypeReason = _blockReasonType[0];
                    return _blockReasonType[0].name;
                }
                else {
                    _analyticsBlockTypeReason = _blockReasonType[1];
                    return _blockReasonType[1].name;
                }

            }


            return _blockReasonType;
        }

        function resetBlockReasonType() {
            _blockReasonType = [{ caption: 'אבד', active: false, name: "Lost",image: "virtual-stolen.svg"}, { caption: 'נגנב', active: false, name: "Stolen",image: "virtual-exposed.svg"}];
            return _blockReasonType;
        }





        function resetBlockReasonTypeForVistualCard() {
            _blockReasonTypeVirtualCard = [{ caption: 'הטלפון שלי אבד או נגנב', active: false, name: "Device Lost", text: "הטלפון שלי אבד או נגנב", image: "virtual-stolen.svg" }, { caption: 'ייתכן שמישהו נחשף לפרטי הכרטיס', active: false, name: "Card Details Exposed",text: "ייתכן שמישהו נחשף לפרטי הכרטיס", image: "virtual-exposed.svg"  }];
            return _blockReasonTypeVirtualCard;
        }

        function getSetBlockReasonTypeForVistualCard(index) {
            if (index != undefined) {
                _blockReasonTypeVirtualCard[index].active = true;
                if (index > 0) {
                    _blockReasonTypeVirtualCard[index - 1].active = false;
                } else {
                    _blockReasonTypeVirtualCard[index + 1].active = false;
                }
            }

            return _blockReasonTypeVirtualCard;
        }

        function updateAgain() {
            updateCardStatus(getSetLastUpdate());
        }

        function isLogin(state) {

            if (!lobbyUiService.connection.isLoggedIn()) {
                lobbyUiService.go('dw.login', { nextPage: state });
                return false;
            }

            return true;


        }

        function setAnchor(id) {

            $location.hash(id);
            $ionicScrollDelegate.anchorScroll();
        }

        function clearAnchor() {

            $location.hash("");
            $ionicScrollDelegate.anchorScroll();
        }



        function getAnalyticsBlockTypeReason() {
            return _analyticsBlockTypeReason;
        }

        function getAnalyticsBlockTypeTempConstant() {
            return _analyticsBlockTypeTempConstant;
        }

       

        function checkCardCVV(request) {

            var deferred = $q.defer();
            setCurrentCard(request.UniqueID);




            lobbyUiService.loader.show();

            connection.checkCardCVV(request).then(function (response) {

                if (response.Response.Status.Succeeded) {
                    deferred.resolve(response);
                    response.uniqueID = request.UniqueID;

                    _userBlockCardDeatils.push(response);
                }
                else {
                    deferred.reject(response);
                    //thorw error
                }

                lobbyUiService.loader.hide();

            }, function (error) {
                lobbyUiService.loader.hide();
                errorService.handleError(error, null, null, true);
                deferred.reject(error);

            });



            return deferred.promise;


        }

        function getCustomerDetailsWithoutServiceCache(request) {
            var deferred = $q.defer();
            _currentCard = request.UniqueID;
                lobbyUiService.loader.show();
                connection.getCustomerDetails(request).then(function (response) {

                    if (response.Response.Status.Succeeded) {
                        deferred.resolve(response);
                        response.uniqueID = request.UniqueID;

                    }
                    else {
                        deferred.reject(response);
                        //thorw error
                    }

                    lobbyUiService.loader.hide();

                }, function (error) {
                    lobbyUiService.loader.hide();
                    errorService.handleError(error, null, null, true);
                    deferred.reject(error);

                });
            
            
            return deferred.promise;
        }
        


        return {
            GetCustomerDetails: getCustomerDetails,
            GetBlockedCardDetails: getBlockedCardDetails,
            UserBlockCardDeatils: _userBlockCardDeatils,
            UpdateCardStatus: updateCardStatus,
            GetCurrentCard: getCurrentCard,
            GetLast4Digit: getLast4Digit,
            MobilePhone: _mobilePhone,
            GetSetMobilePhone: getSetMobilePhone,
            BlockReasonType: _blockReasonType,
            SetGetBlockType: setGetBlockType,
            SetStatusCheckBox: setStatusCheckBox,
            DatePickerValue: _datePickerValue,
            SetGetDatePickerValue: setGetDatePickerValue,
            GetCountryList: getCountryList,
            CountryCardDisappeared: _countryCardDisappeared,
            SetGetContryPickerValue: setGetContryPickerValue,
            GetSteps: getSteps,
            BlockType: _blockType,
            GetSetBlockReasonType: getSetBlockReasonType,
            OperationEnum: _operationEnum,
            GetOperation: getOperation,
            GetSetUserDeatils: getSetUserDeatils,
            ErrorText: _errorText,
            CheckCardCVV: checkCardCVV,
            UpdateAgain: updateAgain,
            GetSetLastUpdate: getSetLastUpdate,
            SetGetblockedCardDetails: setGetblockedCardDetails,
            IsLogin: isLogin,
            SetGetCvv: setGetCvv,
            IsFromConfirm: isFromConfirm,
            SetAnchor: setAnchor,
            AnalyticsBlockTypeReason: getAnalyticsBlockTypeReason,
            AnalyticsBlockTypeTempConstant: getAnalyticsBlockTypeTempConstant,
            ClearAnchor: clearAnchor,
            ResetBlockReasonType: resetBlockReasonType,
            ResetBlockReasonTypeForVistualCard: resetBlockReasonTypeForVistualCard,
            ResetBlockType: resetBlockType,
            getCustomerDetailsWithoutServiceCache: getCustomerDetailsWithoutServiceCache,
            getSetBlockReasonTypeForVistualCard: getSetBlockReasonTypeForVistualCard,
            getSetIsVirtualCard: getSetIsVirtualCard
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('blockCard')
    .controller('blockcardCtrl', blockcardCtrl);

    blockcardCtrl.$inject = [
        'connection', 'appData'
    ];

    function blockcardCtrl(connection, appData) {
     


    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('blockCard')
        .controller('defectiveCtrl', defectiveCtrl);

    defectiveCtrl.$inject = [
        '$rootScope', 'commService','lobbyUiService', 'blockCardService', '$timeout', 'appData', 'lobbyCommService', '$sce', 'errorService', 'googleAnalyticsService', '$interval', '$stateParams', 'connection', 'dataService'
    ];

    function defectiveCtrl($rootScope,commService,lobbyUiService, blockCardService, $timeout, appData, lobbyCommService, $sce, errorService, googleAnalyticsService, $interval, $stateParams, connection, dataService) {

        var vm = this;
        vm.isDisable = true;
        var connectAuthRes = null;

        initLoginType();


        vm.hideNavBar;


        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();


    $rootScope.$on("cardFromHost", function (evt, cardId) {
        console.log("selectedcard on DFECTIVE", cardId)
        vm.change(cardId);
        vm.uniqueId = cardId;
    })

        if (blockCardService.IsLogin('dw.defectiveCard')) {
            vm.operation = blockCardService.GetOperation(blockCardService.OperationEnum.DEF);
            vm.title = vm.operation.title;
            vm.isShowRegulation = false;
            vm.isConfimRegulation = false;
            vm.isProceesEnd = false;
            vm.isConfimRegulation = true;
            vm.uniqueIDChosen = 0;
            vm.fullName = appData.CustomerInfo.FirstName + " " + appData.CustomerInfo.LastName;
            vm.operation = blockCardService.GetOperation(blockCardService.OperationEnum.DEF);
            vm.steps = blockCardService.GetSteps(blockCardService.OperationEnum.DEF, 0);//defective, page 1
            googleAnalyticsService.trackPage('/vp/managecard/damagecard/step1/select_card/');
            getCards();
        }

        vm.change = function (uniqueIDChosen) {
            console.log("uniqueID", uniqueIDChosen);
            var req = {};
            req.UniqueID = uniqueIDChosen;

            req.CardProcessType = blockCardService.OperationEnum.DEF;
            //vm.uniqueIDChosen = uniqueIDChosen;
            blockCardService.GetCustomerDetails(req).then(function (response) {
                vm.userDeatils = response;
                vm.isDisable = false;

                if (vm.cardsAddressUpdated && vm.cardsAddressUpdated.includes(response.uniqueID)) {
                    vm.userDeatils.Address = vm.newAddressUpdated;
                }
                blockCardService.GetSetUserDeatils(vm.userDeatils);

            });
        };

        vm.confirm = function () {
            updateCard();
        };

        vm.updateAddress = function () {
            const idNumType = appData.CustomerInfo.IdNumType;

            if (idNumType === "51") {
                passportPopup();
            } else {
                checkLoginType();
            }
        }

        function updateCard() {

            var req = {};
            req.UniqueID = blockCardService.GetCurrentCard();
            req.PhoneNum = appData.CustomerInfo.Phone;
            req.CardProcessType = vm.operation.name; //Defective
            //req.IsProcessCompleted = true;

            blockCardService.UpdateCardStatus(req).then(function (response) {
                googleAnalyticsService.trackPage('/vp/managecard/damagecard/step2/success/');

            }, function (error) {
                //throw erorr;
                // errorService.handleError(error, vm.confirm);
            });

        }

        function getCards() {
            /*getCards*/
            var req = {};
            req.CardProcessType = vm.operation.name;
            vm.cards = [];
            blockCardService.GetBlockedCardDetails(req).then(function (response) {
                vm.cards = response;
                var isConfirm = blockCardService.IsFromConfirm();

                if (isConfirm) {
                    vm.uniqueId = blockCardService.GetSetUserDeatils().uniqueID;
                }
                else if ($stateParams.updateAddressRedirect && $stateParams.updateAddressRedirect!="standalone") {
                    console.log("inisde the if updateAddressRedirect");
                    var updateAddressRedirect = angular.fromJson($stateParams.updateAddressRedirect);
                    vm.uniqueId = updateAddressRedirect.currentCardUid;
                    vm.newAddressUpdated = updateAddressRedirect.newAddressUpdated;
                    vm.cardsAddressUpdated = updateAddressRedirect.cardsAddressUpdated;
                }
                else {
                    vm.uniqueId = vm.cards[0].Id;
                    console.log("standalone for some reason");
                    //also... standalone. > remove header..
                   // $('#page-wrapper').addClass('standalone');
                }

                var obj = {};
                obj.uniqueIDChosen = vm.uniqueId;
                vm.change(vm.uniqueId);
                var realHeight = document.getElementById("realHeightDefective").scrollHeight;
                commService.trigReady();
                commService.sendHeight(realHeight)
             
              
            }, function (error) {

            });


        }

        function checkLoginType() {
            lobbyUiService.loader.show();
            if (connectAuthRes !== null) {
                lobbyUiService.loader.hide();
                var loginType = connectAuthRes.loginType;

                if (loginType == 0) {
                    otpPopup();
                } else if (loginType == 1) {
                    newDesignPopup();
                }

            } else {
                setTimeout(() => {
                    vm.checkLoginType();
                }, 100);
            }
        }

        function otpPopup() {
            var popup = {};
            popup.template = 'app/blockCard/shared/templates/otp-popup.html';
            popup.btns = [];
            popup.btns.push(
                {
                    text: "להזדהות מחדש",
                    type: "button-positive",
                    onTap: function () {
                        connection.setToken(null);
                        dataService.sessionManager.clear("authToken");
                        lobbyUiService.go("dw.login", { nextPage: "dw.defectiveCard", type: 2 }, { location: "replace" });
                    }
                }
            );
            lobbyUiService.popup.messageText(popup.template, null, null, null, null, null, popup.btns, true);
        };

        function newDesignPopup() {
            var popup = {};
            popup.template = 'app/blockCard/shared/templates/new-design-popup.html';
            popup.btns = [];
            popup.btns.push(
                {
                    text: "לעדכון הכתובת",
                    type: 'button-positive',
                    onTap: function () {
                        lobbyUiService.go("dw.update-address", { updateAddressRedirect: '{ "redirectedFrom": "dw.defectiveCard", "currentCardUid": "' + blockCardService.GetCurrentCard() + '" }' });
                    }
                });
            lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, true);
        }

        function passportPopup() {
            var popup = {};
            popup.template = 'app/blockCard/shared/templates/passport-popup.html';
            popup.btns = [];
            popup.btns.push(
                {
                    text: "חזרה להחלפת הכרטיס",
                    type: "button-positive",
                    onTap: function () {
                    }
                }
            );
            lobbyUiService.popup.messageText(popup.template, null, null, null, null, null, popup.btns, true);
        }

        function initLoginType() {
            connection.getConnectAuth().then(function (res) {
                connectAuthRes = res;
            },
                function (err) {
                    connectAuthRes = err;
                }
            )
        }
    }

})(window, window.angular);
﻿
(function () {
    'use strict'

    /*
    confirmConditionsController.$inject = [
        'blockCardService', 'lobbyUiService', 'appData', 'googleAnalyticsService'
    ];*/

    function confirmConditionsController(blockCardService, lobbyUiService, appData, googleAnalyticsService) {

        var vmConfirmController = this;
        vmConfirmController.defective = false;
        vmConfirmController.activate = false;
        vmConfirmController.block = false;
        vmConfirmController.isConfirmCheckBox = true;
        vmConfirmController.blockType = blockCardService.SetGetBlockType();
        vmConfirmController.blockType.temp.src = "content/images/cal2020/radio-selected.svg";
        vmConfirmController.blockType.constant.src = "content/images/cal2020/radio-empty.svg";
        //content/images/cal2020/radio-selected.svg
        vmConfirmController.isVirtualCard = blockCardService.getSetIsVirtualCard();
        if (vmConfirmController.operation &&vmConfirmController.operation.name != "") {
            vmConfirmController.operationSrc = "app/blockCard/shared/confirm-conditions.component/confirm-conditions-" + vmConfirmController.operation.name + ".html";
        }

        vmConfirmController.ShowRegulationToUser = function () {

            vmConfirmController.showRegulation(true);
        }
        vmConfirmController.cardChange = function () {
            var obj = {};
            obj.uniqueIDChosen = vmChooseTicket.uniqueIDChosen;
            vmChooseTicket.onChangeCard(obj);
        };




        var typeOfBlock = blockCardService.SetGetBlockType();

        if (typeOfBlock.temp.isChosen) {
            changeTypeOfBlock(1);
        }
        else {
            changeTypeOfBlock(2);
        }





        vmConfirmController.markAnswer = function (markItem) {




            if (markItem === 1) {
                changeTypeOfBlock(1);

            } else {
                changeTypeOfBlock(2);

            }



        };


        function changeTypeOfBlock(markItem) {

            if (markItem === 1) {
                vmConfirmController.blockType.temp.src = "content/images/cal2020/radio-selected.svg";
                vmConfirmController.blockType.constant.src = "content/images/cal2020/radio-empty.svg";
            } else {

                vmConfirmController.blockType.temp.src = "content/images/cal2020/radio-empty.svg";
                vmConfirmController.blockType.constant.src = "content/images/cal2020/radio-selected.svg";
            }

            blockCardService.SetGetBlockType(markItem);
        }




        vmConfirmController.test = function () {
            vmConfirmController.userDeatils.MobilePhone = vmConfirmController.isS;
        };




        vmConfirmController.openPopUpUpdatePhone = function () {
            ga('send', 'event', { eventCategory: 'חסימת כרטיס', eventAction: 'תנאי חסימה', eventLabel: 'עדכון טלפון' })
            googleAnalyticsService.trackPage('/vp/managecard/popup/missing-phone/');
            var popup = {};
            //popup.text = ' <div>  <div class="ico-phone" style="font-size:2em;text-align: center;"></div></div><div style="margin-top: 24%;text-align: center;">עדכון מספר טלפון בו ניתן ליצור עמך קשר:</div><div><input id="newMobilePhoneText" type="text" placeholder="מספר טלפון"/></div><div><span>מספר הטלפון ישמש ליצירת קשר במידה ונדרש, ולא יעודכן ב-cal.</span>';
            popup.template = 'app/blockCard/shared/templates/edit-phone-popup.html';

            popup.btns = [];


            popup.btns.push(
                {
                    text: "עדכון",
                    type: 'button-positive',
                    onTap: function (e) {
                        //ng model didnt work
                        angular.element("#error-phone-text").hide();
                        var text = angular.element("#newMobilePhoneText").val().trim();

                        if (text.length < 8 ) {
                            angular.element("#error-phone-text").show();
                            e.preventDefault();
                            return false;
                        }
                        else {
                            vmConfirmController.userDeatils.MobilePhone = text;
                            vmConfirmController.mobilePhone = text;
                            googleAnalyticsService.trackPage('/vp/managecard/popup/missing-phone/phone-updated/');
                        }

                    }
                });
            popup.btns.push(
                {
                    text: "חזרה למסך",
                    type: '',
                    onTap: function () {
                        googleAnalyticsService.trackPage('/vp/managecard/popup/missing-phone/goback/');
                    }
                });

            //lobbyUiService.popup.alert(popup.text, null, null, null, popup.btns);

            lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, true);
        };

    }


    angular.module('blockCard')
        .directive('confirmConditions', function () {
            return {
                //require: ['^^myTabs', 'ngModel'],
                restrict: 'E',
                controllerAs: 'vmConfirmController',
                controller: confirmConditionsController,
                bindToController: true,
                transclude: true,
                scope: {
                    operation: '=',
                    userDeatils: '=',
                    isConfimRegulation: '=isConfimRegulation',
                    onMoveToNextStep: '&onMoveToNextStep',
                    showRegulation: '&showRegulation',
                    mobilePhone: '=mobilePhone'
                    //blockType: '=blockType'

                },
                link: function (scope, element, attrs, controllers) {
                    /*var tabsCtrl = controllers[0],
                        modelCtrl = controllers[1];
                        de
                    tabsCtrl.addPane(scope);*/

                },
                templateUrl: 'app/blockCard/shared/confirm-conditions.component/confirm-conditions.html'
            };
        });
})(window, window.angular);



﻿(function (window, angular) {
    'use strict';
    angular.module('blockCard')
    .controller('defectiveCardEndCtrl', defectiveCardEndCtrl);

    defectiveCardEndCtrl.$inject =[
       '$scope', 'lobbyUiService', 'blockCardService', '$rootScope','commService'
    ];

    function defectiveCardEndCtrl($scope, lobbyUiService, blockCardService, $rootScope,commService) {

        var vm = this;

        $('body').addClass('finish');
        parent.postMessage({ call: "dwProcessEnd" }, '*');

        vm.backToHomePage = function () {
            commService.backToHomePage();
         //   lobbyUiService.go('dw.lobby');
        };

        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();
        /*
        if (!lobbyUiService.connection.isLoggedIn()) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.defective' });
            return false;
        }*/
       
        if (blockCardService.IsLogin('dw.defective')) {
            var userDeatils = blockCardService.GetSetUserDeatils();
            vm.operation = blockCardService.GetOperation(blockCardService.OperationEnum.DEF);
            vm.title = vm.operation.title;
            vm.steps = blockCardService.GetSteps(blockCardService.OperationEnum.DEF, 1);

            vm.params = [blockCardService.GetLast4Digit(userDeatils.uniqueID), userDeatils.DaysOfDelivery];
        }
       
     

       
      
        
        $rootScope.$on('$stateChangeStart', function (event, next, toParams, fromState, fromParams) {
            if (next.name === "dw.defectiveCard" && fromState.name == "dw.defectiveCardEnd") {
                event.preventDefault();
                lobbyUiService.go('dw.block-card-home');
            }
        });

    

        $scope.$on('$ionicView.beforeEnter', function (e, viewData) {
            viewData.enableBack = true;
        });


    }

})(window, window.angular);
﻿


(function () {
    'use strict'

    blockCardEndCompController.$inject = [
        'connection', 'appData', 'blockCardService', '$scope', 'lobbyUiService','commService'
    ];

    function blockCardEndCompController(connection, appData, blockCardService, $scope, lobbyUiService,commService) {
        ga('set', 'page', '/vp/managecard/block-virtual-card/success');
        ga('send', 'pageview');

        var vmblockCardEnd = this;
        vmblockCardEnd.operationSrc = "app/blockCard/shared/block-card-end.component/block-card-end.component-" + vmblockCardEnd.operation.name + ".html";
        vmblockCardEnd.isNotIsrael = false;
        vmblockCardEnd.isVirtualCard = blockCardService.getSetIsVirtualCard();
        
        if (blockCardService.SetGetContryPickerValue() !="ישראל") {
            vmblockCardEnd.isNotIsrael = true;
        }

        vmblockCardEnd.backToHomePage = function () {
            commService.backToHomePage();
            //lobbyUiService.go('dw.lobby');
        };

        vmblockCardEnd.goToExplainationPage = function () {
            ga('send', 'event', { eventCategory: 'חסימת כרטיס', eventAction: 'הצלחה', eventLabel: 'דף הסבר' });
            window.location.href = 'https://www.cal-online.co.il/about/calservices/lost-or-stolen/';
        }
        
        // blockCardService.SetGetBlockType().constant.isChosen
        vmblockCardEnd.isConstant = blockCardService.SetGetBlockType().constant.isChosen;

        // blockCardService.SetGetContryPickerValue
    }


    angular.module('blockCard')
    .directive('blockCardEndComp', function () {
        return {
            restrict: 'E',
            controllerAs: 'vmblockCardEnd',
            controller: blockCardEndCompController,
            bindToController: true,
            transclude: true,
            scope: {
                operation: '=',
                params: '=',
                isVirtualCard: '=',
            },
            link: function (scope, element, attrs, controllers) {
       
            },
            templateUrl: 'app/blockCard/shared/block-card-end.component/block-card-end.component.html'
        };
    });
})(window, window.angular);




﻿(function (window, angular) {
    'use strict';
    angular.module('blockCard')
        .controller('blockCtrl', blockCtrl);

    blockCtrl.$inject = [
        'commService','lobbyUiService', 'blockCardService', '$timeout',  'appData', 'lobbyCommService', 'errorService', '$scope', '$rootScope', '$ionicScrollDelegate', '$location', '$state', '$stateParams'
    ];


    function blockCtrl(commService,lobbyUiService, blockCardService, $timeout, appData, lobbyCommService, errorService, $scope, $rootScope, $ionicScrollDelegate, $location, $state, $stateParams) {

        commService.showBackButton(false);
       
        //$rootScope.$on("bankFromHost", function (evt, bankId) {
        //    console.log("selectedBank on blockCard", bankId)
        //});
        $rootScope.$on("cardFromHost", function (evt, cardId) {
            console.log("selectedcard on blockCard", cardId)
            vm.change(cardId);
            vm.uniqueId = cardId;
        })


        window.mobileAndTabletCheck = function () {
            let check = false;
            (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        };


        var vm = this;
        vm.countryPickerValue = "";
        vm.blockReasonEmpty = "";
        vm.countryEmpty = "";
        vm.dateEmpty = "";
        vm.mobilePhone = "";
        vm.uniqueId = "";
        vm.isDisable = true;
        console.log("HAPPENS");
        vm.datePickerValue = null;
        vm.textDateError = "";
        vm.hideNavBar;


        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();


        vm.isMobileDatePicker = mobileAndTabletCheck();
        console.log("vm.isMobileDatePicker?", vm.isMobileDatePicker);


        $scope.$on('$ionicView.beforeEnter', function () {
            console.log("beforeEnter1")
            vm.datePickerValue = "";
            //$timeout(function () {
          // .. vm.hideNavBar = lobbyUiService.hideNavBar();
       //   ..  console.log("vm.hideNavBarBeforeEnter1", vm.hideNavBar);
            //},3000)

        });
        
        var formatDesktopDateAndSiteHeight = function () {

        
        //$scope.$on('$ionicView.loaded', function () {
            console.log('loaded in lockCardl2');
            // vm.hideNavBar = lobbyUiService.hideNavBar();
            console.log("loaded2", vm.hideNavBar);
            $timeout(function () {
                console.log("Inside Timeout");
                vm.datePickerValue = "";
                var realHeight = document.getElementById("realHeightBlock").scrollHeight;
                commService.trigReady();
                commService.sendHeight(realHeight);
                var options = {
                    placeholder: "_ _ _ _ / _ _ / _ _",
                    clearIfNotMatch: false,
                    onComplete: function () {
                        var v = $('.full-date').val();
                        if (checkDate(v)) {
                            vm.textDateError = "";
                            console.log("Good Date"); //filled inside.
                            // do stuff
                        } else {
                            vm.datePickerValue = "";
                            console.log("bad Date");

                            //TODO ERROR
                            // do other stuff
                        }
                        $scope.$apply();
                    },
                    onChange: function (cep) {
                        console.log("cap", cep);
                        if (cep.length != 10) {
                            vm.textDateError = "";
                        }
                        $scope.$apply();
                    }
                };
                $('.full-date').mask('00/00/0000', options);
            }, 500);
       // });
        }



        $(document).ready(function () {
            console.log("QWE DOcument Ready")
           
        });


        function checkDate(val) {
            console.log("val", val)
            var er = /^(((0[1-9]|[12][0-9]|3[01])([-.\/])(0[13578]|10|12)([-.\/])(\d{4}))|(([0][1-9]|[12][0-9]|30)([-.\/])(0[469]|11)([-.\/])(\d{4}))|((0[1-9]|1[0-9]|2[0-8])([-.\/])(02)([-.\/])(\d{4}))|((29)(\.|-|\/)(02)([-.\/])([02468][048]00))|((29)([-.\/])(02)([-.\/])([13579][26]00))|((29)([-.\/])(02)([-.\/])([0-9][0-9][0][48]))|((29)([-.\/])(02)([-.\/])([0-9][0-9][2468][048]))|((29)([-.\/])(02)([-.\/])([0-9][0-9][13579][26])))$/;
            if (!er.test(val)) {
                vm.textDateError = "התאריך שמילאת לא תקין, צריך להזין תאריך מלא ותקין בפורמט dd/mm/yyyy"
                vm.datePickerValue = "";
                return false;
            }
            else {
                return checkIfInThePast(val);
            }
        }

        function checkIfInThePast(dateString) {

            var dateParts = dateString.split("/");

            // month is 0-based, that's why we need dataParts[1] - 1
            var selectedDate = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], 12); //I TOOK 2 YEARS OFF

            var now = new Date();
            now.setHours(12, 0, 0, 0);
            var selectedDate2YearsBefore = new Date(now.getFullYear() - 2, now.getMonth(), now.getDate())
            console.log("now", now);
            console.log("sel", selectedDate);
            console.log("s2y", selectedDate2YearsBefore);
            if (selectedDate <= now) {
                if (selectedDate <= selectedDate2YearsBefore) {
                    vm.textDateError = "אפשר לבחור תאריך עד שנתיים אחורה"
                    vm.datePickerValue = "";
                    return false;
                }
                else {
                    //GOOD
                    console.log("Selected date is in the past GOOD");
                    vm.textDateError = "";
                    vm.datePickerValue = selectedDate; //SET THE DATE HERE.
                    return true;
                }

            } else {
                vm.textDateError = "התאריך שמילאת לא תקין, יש למלא תאריך לא עתידי"
                vm.datePickerValue = "";
                console.log("Selected date is NOT in the past");
                return false;
            }
        };

        $rootScope.$on('$stateChangeStart', function (event, next, toParams, fromState, fromParams) {
            if (fromState.name == "dw.blockCardConfirm" && next.name === "dw.blockCard") {
                //var userDeatils = blockCardService.GetSetUserDeatils();
                blockCardService.IsFromConfirm(true);
            }
            else if (next.name === "dw.blockCard" || next.name === "dw.defectiveCard" || next.name === "dw.activateCard") {
                blockCardService.IsFromConfirm(false);
            }
        });


        //google analytics
        //ga('send', 'pageview', "/vp/managecard/step1/blockcard-options/");

        /*
        if (!lobbyUiService.connection.isLoggedIn()) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.blockCard' });
            return false;
        }*/
        if (blockCardService.IsLogin('dw.blockCard')) {
            getCards();
            vm.operation = blockCardService.GetOperation(blockCardService.OperationEnum.BLOCK);
            vm.title = vm.operation.title;
            vm.steps = blockCardService.GetSteps(vm.operation.name, 0);//block, page 1
            vm.firstName = appData.CustomerInfo.FirstName;
            blockCardService.ResetBlockReasonTypeForVistualCard();
        }


        vm.onSelectedCountry = function (country) {
            if (country === undefined) {
                blockCardService.SetGetContryPickerValue("");
            }
            else {
                blockCardService.SetGetContryPickerValue(country);
            }
        }


        /*continue to next page block-confirm*/
        vm.continue = function () {
            console.log("Continue", vm.datePickerValue);
            vm.blockReasonEmpty = "";
            vm.countryEmpty = "";
            vm.dateEmpty = "";
            var countryText = blockCardService.SetGetContryPickerValue();
            var blockReason = vm.isVirtualCard ? blockCardService.getSetBlockReasonTypeForVistualCard() : blockCardService.GetSetBlockReasonType();
            var isOk = true;

            if (!blockReason[0].active && !blockReason[1].active) {
                vm.blockReasonEmpty = vm.isVirtualCard ? blockCardService.ErrorText.blockReasonVirtualCard : blockCardService.ErrorText.blockReason;
                isOk = false;
                blockCardService.SetAnchor('cardReasontype');
            }

            if (!vm.isVirtualCard) {
                console.log("NOT VIRTUAL");
                if (countryText === undefined || countryText === "") {
                    vm.countryEmpty = blockCardService.ErrorText.country;
                    isOk = false;
                    blockCardService.SetAnchor('countryAutoComplete');
                }
                //TODO
                if (!vm.datePickerValue || vm.datePickerValue == "") {
                    vm.textDateError = "יש להקליד תאריך";
                    console.log("ADD CALASS ERROR");
                    $("#dateDesktopBlock").addClass("error-date");
                    isOk = false;
                }
                if (!angular.isDate(vm.datePickerValue)) {
                    if (vm.isMobileDatePicker) {
                        vm.dateEmpty = blockCardService.ErrorText.dateInvaid;
                        isOk = false;
                        blockCardService.SetAnchor('datePicker');
                    }
                    else { //new here..
                        console.log("vm.datePickerrval", vm.datePickerValue);
                        if (vm.datePickerValue == "") {
                            vm.textDateError = "יש להקליד תאריך";
                            console.log("ADD CALASS ERROR");
                            $("#dateDesktopBlock").addClass("error-date");
                            isOk = false;
                        }
                    }

                }
                else {
                    console.log("REOMOVE CLAS ERORR");
                    $("#dateDesktopBlock").removeClass("error-date");
                }
                if (isOk) {
                    console.log("77 is oj");
                    blockCardService.SetGetDatePickerValue(vm.datePickerValue);
                    blockCardService.ClearAnchor();
                    lobbyUiService.go('dw.blockCardConfirm', {});

                }
            }

            else if (blockReason[0].active + blockReason[1].active == 1) {
                if (blockReason[1].active) {
                    ga('send', 'event', { eventCategory: 'חסימת כרטיס', eventAction: 'בחירת כרטיס', eventLabel: 'כרטיס וירטואלי – פרטים' });
                    lobbyUiService.go('dw.blockCardConfirm', {});
                }
                else {
                    ga('send', 'event', { eventCategory: 'חסימת כרטיס', eventAction: 'בחירת כרטיס', eventLabel: 'כרטיס וירטואלי – מכשיר' });
                    lobbyUiService.go('dw.blockCardContactUs', {});
                }
            }



        };
        var FormatDesktopDateAndSiteHeightFlag = true;
        /* call from directive checkbox-designed when user change the chosen */
        vm.onChangeCheckBox = function (index) {
            index = index++;

            if (vm.isVirtualCard) {
                blockCardService.getSetBlockReasonTypeForVistualCard(index);
            }
            else {
                blockCardService.GetSetBlockReasonType(index);
            }
        };

        /* call from directvie choose-ticket as deafult take the first card */
        vm.change = function (uniqueIDChosen) {
            console.log("uniq", uniqueIDChosen);
            var req = {
            };
            req.UniqueID = uniqueIDChosen;
            req.CardProcessType = blockCardService.OperationEnum.BLOCK;
            //vm.uniqueIDChosen = uniqueIDChosen;
            blockCardService.GetCustomerDetails(req).then(function (response) {
                vm.userDeatils = response;
                vm.isDisable = false;
                //vm.userDeatils.uniqueIDChosen = uniqueIDChosen;
                blockCardService.GetSetUserDeatils(vm.userDeatils);
                vm.selectedCard = vm.cards.filter(c => c.Id == response.uniqueID)[0];
                vm.isVirtualCard = vm.selectedCard.IsVirtualCard;
                blockCardService.getSetIsVirtualCard(vm.isVirtualCard);
                if (vm.isVirtualCard) {
                    vm.checkboxItems = blockCardService.getSetBlockReasonTypeForVistualCard();//
                    blockCardService.SetGetBlockType(0); // constant block
                }
                else if (blockCardService.IsFromConfirm()) {
                    vm.checkboxItems = blockCardService.GetSetBlockReasonType();
                    vm.countryPickerValue = blockCardService.SetGetContryPickerValue();
                    //vm.datePickerValue = blockCardService.SetGetDatePickerValue();
                }
                else {
                    vm.checkboxItems = blockCardService.ResetBlockReasonType();
                    vm.countryPickerValue = "";
                    blockCardService.ResetBlockType();
                }
             
                if (FormatDesktopDateAndSiteHeightFlag) {
                    formatDesktopDateAndSiteHeight();
                    FormatDesktopDateAndSiteHeightFlag = false;
                }

            }, function (error) {

            });


        };


        function getCards() {
            /*getCards*/
            var req = {};

            req.CardProcessType = blockCardService.OperationEnum.BLOCK;
            vm.cards = [];
            blockCardService.GetBlockedCardDetails(req).then(function (response) {
                vm.cards = response;
                var isConfirm = blockCardService.IsFromConfirm();

                if (isConfirm) {
                    vm.uniqueId = blockCardService.GetSetUserDeatils().uniqueID;
                }
                else {
                    vm.uniqueId = vm.cards[0].Id;
                }

                var obj = {};
                obj.uniqueIDChosen = vm.uniqueId;
                console.log("vm.uniqueId", vm.uniqueId);
                vm.change(vm.uniqueId);

            
            }, function (error) {

            });


        }


        function showPopUp(text) {

            var popup = {
            };
            popup.text = text;
            popup.btns = [];
            popup.btns.push(
                {
                    text: "יציאה",
                    type: 'button-positive',
                    onTap: function () {
                    }
                });


            lobbyUiService.popup.alert(popup.text, null, null, null, popup.btns);
        };


    }//lobbyUiService.message

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('blockCard')
        .controller('blockConfirmCtrl', blockConfirmCtrl);

    blockConfirmCtrl.$inject = [
        'commService','lobbyUiService', 'blockCardService', '$timeout', 'appData', 'lobbyCommService', '$sce', 'errorService', 'googleAnalyticsService', '$stateParams', 'connection', 'dataService'
    ];

    function blockConfirmCtrl(commService,lobbyUiService, blockCardService, $timeout, appData, lobbyCommService, $sce, errorService, googleAnalyticsService, $stateParams, connection, dataService) {
        ga('set', 'page', '/vp/managecard/block-virtual-card/terms');
        ga('send', 'pageview');
        commService.showBackButton(true);
        var userDeatils = blockCardService.GetSetUserDeatils();
        var vm = this;
        vm.mobilePhone = "";

        var connectAuthRes = null;

        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();
        initLoginType();

        if (blockCardService.IsLogin('dw.blockCard')) {
            var userDeatils = blockCardService.GetSetUserDeatils();
            vm.operation = blockCardService.GetOperation(blockCardService.OperationEnum.BlockConfirm);
            vm.title = vm.operation.title;
            vm.steps = blockCardService.GetSteps(vm.operation.cardProcessTypeEnum, 1);//block, page 2
            vm.firstName = appData.CustomerInfo.FirstName;
            vm.userDeatils = blockCardService.GetSetUserDeatils();
            vm.userDeatils.MobilePhone = blockCardService.GetSetMobilePhone();
            vm.uniqueID = blockCardService.GetLast4Digit(userDeatils.uniqueID);
            vm.blockType = blockCardService.SetGetBlockType();
            vm.isVirtualCard = blockCardService.getSetIsVirtualCard();

            if (!vm.isVirtualCard) {
                googleAnalyticsService.trackPage('/vp/managecard/blockcard/step4/Summary/?type=' + blockCardService.AnalyticsBlockTypeReason + '&possible-recover=' + blockCardService.AnalyticsBlockTypeTempConstant);
            }

            if ($stateParams.updateAddressRedirect) {
                var updateAddressRedirect = angular.fromJson($stateParams.updateAddressRedirect);
                vm.cardUniqueID = updateAddressRedirect.currentCardUid;
                vm.uniqueID = blockCardService.GetLast4Digit(vm.cardUniqueID);
                vm.newAddressUpdated = updateAddressRedirect.newAddressUpdated;
                vm.cardsAddressUpdated = updateAddressRedirect.cardsAddressUpdated;

                if (vm.cardsAddressUpdated && vm.cardsAddressUpdated.includes(vm.cardUniqueID)) {
                    vm.userDeatils.Address = vm.newAddressUpdated;
                }
            }

            $timeout(function () {
                var realHeight = document.getElementById("blockConfirmRealHeight").scrollHeight;
                //console.log("sendRealHeight")
                commService.sendHeight(900);
            })
         
        }



        vm.confirm = function (isConfirm) {
            ga('send', 'event', { eventCategory: 'חסימת כרטיס', eventAction: 'תנאי חסימה', eventLabel: 'אישור חסימה' });

            if (isConfirm) {

                var req = {};
                req.UniqueID = blockCardService.GetCurrentCard();
                if (vm.mobilePhone != "") {
                    req.PhoneNum = vm.mobilePhone;
                }
                else {
                    req.PhoneNum = appData.CustomerInfo.Phone;
                }
                req.CardProcessType = vm.operation.cardProcessTypeEnum; //Block
                req.BlockType = vm.isVirtualCard ? blockCardService.SetGetBlockType(2, true) : blockCardService.SetGetBlockType(undefined, true);//temp or constant
                req.BlockReasonType = blockCardService.GetSetBlockReasonType(undefined, true);
                req.DateCardDisappeared = blockCardService.SetGetDatePickerValue();
                //req.DateCardDisappeared = req.DateCardDisappeared.getDate() + "/" + req.DateCardDisappeared.getMonth() + "/" + req.DateCardDisappeared.getFullYear();
                var countryPickerValue = blockCardService.SetGetContryPickerValue();
                req.CountryCardDisappeared = countryPickerValue ? countryPickerValue : "N/A";
                //req.IsProcessCompleted = true;

                updateCard(req);

            }

            else {
                showPopUp();
            }

        };

        function updateCard(req) {

            blockCardService.UpdateCardStatus(req).then(function (response) {

                if (response.Response.Status.Succeeded) {
                    vm.isProceesEnd = true;
                    console.log("block success");
                    console.log("req", req, "res", response);

                    //BlockReasonType: "Lost" /Stolen
                    //BlockType: "Temp" / Constant
                    //CardProcessType: "Block"
                    //CountryCardDisappeared: "ישראל"
                    //DateCardDisappeared: "2023-01-18T10:00:00.000Z"
                    //PhoneNum: "......."
                    //UniqueID: "......"


                    commService.updateParentBlockedCard(req.UniqueID, req.BlockType);
                    if (!vm.isVirtualCard) {
                        googleAnalyticsService.trackPage('/vp/managecard/blockcard/step5/success/?type=' + blockCardService.AnalyticsBlockTypeReason + '&possible-recover=' + blockCardService.AnalyticsBlockTypeTempConstant);
                    }        

                } else {

                    //throw error
                }


            }, function (error) {

                    showUpdateCardFailedPopup();
                //errorService.handleError(error, vm.confirm);
            });
        }

        function showPopUp() {
            googleAnalyticsService.trackPage('pageview', '/vp/managecard/popup/missing-address-error/');
            var popup = {};
            popup.template = 'app/blockCard/shared/templates/address-wrong-block-popup.html';
            popup.btns = [];
            popup.btns.push(
                {
                    text: "חזרה למסך",
                    type: '',
                    onTap: function () {

                    }
                });

            popup.btns.push(
                {
                    text: "יציאה",
                    type: 'button-positive',
                    onTap: function () {

                        lobbyUiService.go('dw.block-card-home');

                    }
                });
            lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, true);
        };

        vm.goToChangeAddress = function () {
            ga('send', 'event', { eventCategory: 'חסימת כרטיס', eventAction: 'תנאי חסימה', eventLabel: 'עדכון כתובת' });
            const idNumType = appData.CustomerInfo.IdNumType;

            if (idNumType === "51") {
                passportPopup();
            } else {
                checkLoginType();
            }
        }

        function passportPopup() {
            var popup = {};
            popup.template = 'app/blockCard/shared/templates/passport-popup.html';
            popup.btns = [];
            popup.btns.push(
                {
                    text: "חזרה להחלפת הכרטיס",
                    type: "button-positive",
                    onTap: function () {
                    }
                }
            );
            lobbyUiService.popup.messageText(popup.template, null, null, null, null, null, popup.btns, true);
        }

        function checkLoginType() {
            lobbyUiService.loader.show();
            if (connectAuthRes !== null) {
                lobbyUiService.loader.hide();
                var loginType = connectAuthRes.loginType;

                if (loginType == 0) {
                    otpPopup();
                } else if (loginType == 1) {
                    newDesignPopup();
                }

            } else {
                setTimeout(() => {
                    vm.checkLoginType();
                }, 100);
            }
        }

        function otpPopup() {
            var popup = {};
            popup.template = 'app/blockCard/shared/templates/otp-popup.html';
            popup.btns = [];
            popup.btns.push(
                {
                    text: "להזדהות מחדש",
                    type: "button-positive",
                    onTap: function () {
                        connection.setToken(null);
                        dataService.sessionManager.clear("authToken");
                        lobbyUiService.go("dw.login", { nextPage: "dw.blockCardConfirm", type: 2 }, { location: "replace" });
                    }
                }
            );
            lobbyUiService.popup.messageText(popup.template, null, null, null, null, null, popup.btns, true);
        };

        function newDesignPopup() {
            var selectedCardUid = blockCardService.GetCurrentCard();

            var popup = {};
            popup.template = 'app/blockCard/shared/templates/new-design-popup.html';
            popup.btns = [];
            popup.btns.push(
                {
                    text: "לעדכון הכתובת",
                    type: 'button-positive',
                    onTap: function () {
                        lobbyUiService.go("dw.update-address", { updateAddressRedirect: '{ "redirectedFrom": "dw.blockCardConfirm", "currentCardUid": "' + selectedCardUid + '" }' });
                    }
                });
            lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, true);
        };

        function showUpdateCardFailedPopup() {
            var popup = {};
            popup.template = 'app/blockCard/shared/templates/update-card-status-block-popup.html';
            popup.btns = [];
            popup.btns.push(
                {
                    text: "אני רוצה לנסות שוב",
                    type: 'button-positive',
                    onTap: function () {
                        lobbyUiService.go('dw.blockCard');
                    }
                });
            popup.btns.push(
                {
                    text: "אנסה אחר כך",
                    type: 'button-link',
                    onTap: function () {
                        lobbyUiService.go("dw.lobby");
                    }
                });
            lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, true);
        }

        function initLoginType() {
            connection.getConnectAuth().then(function (res) {
                connectAuthRes = res;
            },
                function (err) {
                    connectAuthRes = err;
                }
            )
        }
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('blockCard')
    .controller('blockCardEndCtrl', blockCardEndCtrl);

    blockCardEndCtrl.$inject = [
      'lobbyUiService', 'blockCardService', '$scope', '$rootScope','commService'
    ];

    function blockCardEndCtrl(lobbyUiService, blockCardService, $scope, $rootScope,commService) {
        

        $('body').addClass('finish');
        parent.postMessage({ call: "dwProcessEnd" }, '*');


        var vm = this;
        
        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();
        vm.backToHomePage = function () {
            commService.backToHomePage();
           // lobbyUiService.go('dw.lobby');
        };

        if (blockCardService.IsLogin('dw.blockCard')) {
            vm.operation = blockCardService.GetOperation(blockCardService.OperationEnum.BLOCK);
            var userDeatils = blockCardService.GetSetUserDeatils();
            vm.title = vm.operation.title;
            vm.steps = blockCardService.GetSteps(blockCardService.OperationEnum.BLOCK, 2);//block, page 3
            vm.params = [blockCardService.GetLast4Digit(userDeatils.uniqueID), userDeatils.DaysOfDelivery];
            commService.sendHeight(700);
        }

        $scope.$on('$ionicView.beforeEnter', function (e, viewData) {
            viewData.enableBack = true;
        });

        $rootScope.$on('$stateChangeStart', function (event, next, toParams, fromState, fromParams) {
            if (next.name === "dw.blockCardConfirm" && fromState.name == "dw.blockCardEnd") {
                event.preventDefault(); 
          

                lobbyUiService.go('dw.block-card-home');
            }
        });


    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('blockCard')
        .controller('blockContactUsCtrl', blockContactUsCtrl);

    blockContactUsCtrl.$inject = [];

    function blockContactUsCtrl() {
        var vm = this;

        ga('set', 'page', '/vp/managecard/block-virtual-card/service-required');
        ga('send', 'pageview');


        vm.phoneCustomerService = function () {

            ga('send', 'event', { eventCategory: 'חסימת כרטיס', eventAction: 'נדרש נציג', eventLabel: 'חיוג לנציג' });

            document.location.href = 'tel:035723666';
        }

    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('blockCard')
    .controller('activateCtrl', activateCtrl);

    activateCtrl.$inject = [
        'commService','$rootScope','lobbyUiService', 'blockCardService', '$timeout', 'appData', 'lobbyCommService', '$sce', 'errorService', 'googleAnalyticsService'
    ];

    function activateCtrl(commService,$rootScope,lobbyUiService, blockCardService, $timeout, appData, lobbyCommService, $sce, errorService, googleAnalyticsService) {

        var vm = this;
        //lobbyUiService.go('dw.activateCardEnd', {});
        vm.cvv = "";
        vm.uniqueIDChosen = "";
        vm.onInvalid = "";
        vm.cvvInput = "";
     


        $rootScope.$on("cardFromHost", function (evt, cardId) {
            console.log("selectedcard on blockCard", cardId)
            vm.change(cardId);
            vm.uniqueId = cardId;
        })
   


        vm.hideNavBar;
        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();

        //$scope.$on('$ionicView.beforeEnter', function () {
        //    vm.hideNavBar = lobbyUiService.hideNavBar();
        //});

        /*
        if (!lobbyUiService.connection.isLoggedIn()) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.activateCard' });
            return false;
        }*/

        if (blockCardService.IsLogin('dw.activateCard')) {
            vm.operation = blockCardService.GetOperation(blockCardService.OperationEnum.ACTIVE);
            vm.title = vm.operation.title;
            vm.isShowRegulation = false;
            vm.isConfimRegulation = false;
            vm.isProceesEnd = false;
            vm.isConfimRegulation = true;
            vm.uniqueIDChosen = 0;
            vm.fullName = appData.CustomerInfo.FirstName + " " + appData.CustomerInfo.LastName;
            vm.operation = blockCardService.GetOperation(blockCardService.OperationEnum.ACTIVE);
            vm.steps = blockCardService.GetSteps(blockCardService.OperationEnum.ACTIVE, 0);//ACTIVE, page 1
            getCards();
            
        }

        vm.setWindowHeight = function () {

            var pageHeight = angular.element(".view-container")[0].offsetHeight;
            var smallBtn = angular.element(".activate-buttons")[0];
            if (smallBtn) {
                var buttonHeight = smallBtn.offsetHeight;
                var contentHeight = parseInt(pageHeight - buttonHeight);
                if (parseInt(contentHeight) < 528)
                    contentHeight = 528;
                angular.element(".scroll").css('min-height', contentHeight + "px");
            }
            else {
                var contentHeight = parseInt(screen.height - 32);
                if (parseInt(contentHeight) < 528)
                    contentHeight = 528;
                angular.element(".scroll").css('min-height', screen.height - 32 + "px");
            }

        }
        vm.setWindowHeight();


        /*
        lobbyCommService.getDocument("BlockCard.html").then(function (response) {
            vm.regulation = response;
            vm.regulation = $sce.trustAsHtml(response);

        }, function (error) {
        });*/


        vm.change = function (uniqueIDChosen) {
            var userDeatils = {};
            vm.uniqueIDChosen = uniqueIDChosen;

            //vm.uniqueIDChosen = uniqueIDChosen;
            /*blockCardService.GetCustomerDetails(req).then(function (response) {
                vm.userDeatils = response;
                //vm.userDeatils.uniqueIDChosen = uniqueIDChosen;

                blockCardService.GetSetUserDeatils(vm.userDeatils);

            });*/


        };

        vm.openPopUp = function () {
            var popup = {};
            popup.template = 'app/blockCard/shared/templates/cvv-popup.html';
            popup.btns = [];

        


            popup.btns.push(
                               {
                                   text: "חזרה למסך",
                                   type: 'button-positive',
                                   onTap: function () {

                                   }
                               });

            lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, true);
        };


        /* call from directvie  */
        //vm.changeCvv = function (uniqueIDChosen) {

        //    var req = {};
        //    req.UniqueID = uniqueIDChosen;
        //    blockCardService.GetSetUserDeatils(req);


        //};



        vm.confirm = function () {
            //lobbyUiService.go('dw.activateCardEnd', {});

            if (vm.cvvInput != undefined && vm.cvvInput.toString().length === 3) {
                checkCardCVV();

                //lobbyUiService.go('dw.activateCardEnd', {});



            }
            else {
                vm.onInvalid = "יש להזין 3 ספרות בגב הכרטיס";
                /*var popup = {};
                popup.text = ' <div><p> יש להזין 3 ספרות בגב הכרטיס</p> </div>';
                popup.btns = [];
                popup.btns.push(
                                   {
                                       text: "חזור למסך",
                                       type: '',
                                       onTap: function () {

                                       }
                                   });
             
                showPopUp(popup);*/
            }

        };


        function getCards() {
            /*getCards*/
            var req = {};
            
            req.CardProcessType = vm.operation.name;
            vm.cards = [];
            blockCardService.GetBlockedCardDetails(req).then(function (response) {
                vm.cards = response;
                var isConfirm = blockCardService.IsFromConfirm();

                if (isConfirm) {
                    vm.uniqueId = blockCardService.GetSetUserDeatils().uniqueID;
                }
                else {
                    vm.uniqueId = vm.cards[0].Id;
                }

                var obj = {};
                obj.uniqueIDChosen = vm.uniqueId;
                vm.change(vm.uniqueId);
                commService.trigReady();
                commService.sendHeight(500)
            }, function (error) {

            });


        }


        function checkCardCVV() {

            var req = {};
            req.UniqueID = vm.uniqueIDChosen;
            req.CardCVV = vm.cvvInput.toString();

            blockCardService.CheckCardCVV(req).then(function (response) {
                updateCard();
            });
        }


        function showPopUp(popup) {
            lobbyUiService.popup.alert(popup.text, null, null, null, popup.btns);
        };

        function updateCard() {

            var req = {};
            req.UniqueID = vm.uniqueIDChosen;
            //req.UniqueID = blockCardService.GetSetUserDeatils().UniqueID;
            req.PhoneNum = appData.CustomerInfo.Phone;
            req.CardProcessType = vm.operation.name;
            //req.IsProcessCompleted = true;
            blockCardService.GetSetUserDeatils(req);

            blockCardService.UpdateCardStatus(req).then(function (response) {

                if (response.Response.Status.Succeeded) {
                    console.log("activated Card");
                    console.log("req", req, "response", response);
                    commService.updateParentActivatedCard(req.UniqueID);
                    vm.isProceesEnd = true;
                  //  $('body').addClass('finish');
                    googleAnalyticsService.trackPage('/vp/managecard/step2/restore-card-success/');
                } else {
                    //throw erorr;
                }
            }, function (error) {
                //throw erorr;
               // errorService.handleError(error, vm.confirm);
            });

        }




    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('blockCard')
    .controller('activateCardEndCtrl', activateCardEndCtrl);

    activateCardEndCtrl.$inject = [
       '$scope', 'lobbyUiService', 'blockCardService', '$rootScope','commService'
    ];

    function activateCardEndCtrl($scope, lobbyUiService, blockCardService, $rootScope,commService) {
        var vm = this;
        blockCardService.IsLogin('dw.activateCard');

        $('body').addClass('finish');
        parent.postMessage({ call: "dwProcessEnd" }, '*');

        /*
        if (!lobbyUiService.connection.isLoggedIn()) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.defective.end' });
            return false;
        }*/


        vm.hideNavBar;
        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();
        vm.operation = blockCardService.GetOperation(blockCardService.OperationEnum.ACTIVE);
        vm.title = vm.operation.title;
        vm.steps = blockCardService.GetSteps(blockCardService.OperationEnum.ACTIVE, 1);
        vm.params = [blockCardService.GetLast4Digit(blockCardService.GetSetUserDeatils().UniqueID)];

       
        vm.backToHomePage = function () {
            commService.backToHomePage();
           // lobbyUiService.go('dw.lobby');
        };

        $rootScope.$on('$stateChangeStart', function (event, next, toParams, fromState, fromParams) {
            if (next.name === "dw.activateCard" && fromState.name == "dw.activateCardEnd") {
                event.preventDefault();
                lobbyUiService.go('dw.block-card-home');
            }
        });

    

        $scope.$on('$ionicView.beforeEnter', function (e, viewData) {
            viewData.enableBack = true;
        });


    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('transferOrders', []);
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('transferOrders').config(transferOrdersRoute);

    transferOrdersRoute.$inject = ['$stateProvider'];

    function transferOrdersRoute($stateProvider) {
        $stateProvider
            .state('dw.successTransferOrders', {
                url: "/transferOrders/successTransferOrders/:fromFirstCard/:fromSecondCard/:fromThirdCard/:toCard",
                views: {
                    'contentBody': {
                        templateUrl: "app/transferOrders/templates/successTranferOrders.html",
                        controller: "successTransferOrders as vm"
                    }
                }
            })
            .state('dw.transferStandingOrders', {
                cache: false,
                url: "/transferOrders/transferStandingOrders",
                paramsService: 'transferOrdersService',
                views: {
                    'contentBody': {
                        templateUrl: "app/transferOrders/templates/transferStandingOrders.html",
                        controller: "transferStandingOrders as vm",
                        //resolve: {
                        //    approval: function (transferOrdersService) {
                        //        return transferOrdersService.handleAuthentication();
                        //    }
                        //}
                    }
                }
            });
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('transferOrders')
        .controller('transferStandingOrders', transferStandingOrders);

    transferStandingOrders.$inject = [
        'commService','$scope', 'connection', '$window', 'appData', 'lobbyUiService', '$rootScope', '$q', 'utilService', 'errorService',
        '$ionicScrollDelegate', 'googleAnalyticsService', '$timeout', '$ionicLoading', '$ionicPopup', '$location', 'lobbyDataService'
    ];

    function transferStandingOrders(commService,$scope, connection, $window, appData, lobbyUiService, $rootScope, $q, utilService, errorService,
        $ionicScrollDelegate, googleAnalyticsService, $timeout, $ionicLoading, $ionicPopup, $location, lobbyDataService) {

        var vm = this;
        vm.title = "העברת הוראות קבע";
        vm.cards = [];
        vm.generalCards = [];
        vm.input = "";
        vm.uniqueId = "";
        vm.inputCardOne = "";
        vm.inputCardTwo = "";
        vm.inputCardThree = "";
        vm.isCardOne = true;
        vm.isCardTwo = true;
        vm.isCardThree = true;
        vm.showAddCard = true;
        vm.showFirstCardInput = true;
        vm.showSecondCardInput = false;
        vm.showThirdCardInput = false;
        vm.showLegalError = false;
        vm.showLegalErrorStyle = "transfer-no-opacity";
        vm.LegalConfirmed = false;
        vm.confirmedTakanon = 'transfer-not-confirmed';
        vm.isLoggedIn = connection.isLoggedIn();
        vm.validCards = [];
        vm.isChooseTicketDisabled = true;
        vm.confirmButtonDisabled = true;
        vm.showInputSuccess = false;
        vm.showSelectCardSuccess = false;
        vm.showConfirmSuccess = false;
   
        vm.secondHeadline = "div-headline";
        vm.thirdHeadline = "div-headline";
        vm.errorFirstCard = "";
        vm.errorSecondCard = "";
        vm.errorThirdCard = "";
        vm.buttonDisabled = "transfer-button-disabled";
        var _template = '<div class="animation ion-loading-c"></div><div class="msg">טוען נתונים...</div>';
        vm.takanonLabelClicked = false;
        vm.opacityClass = "opacity-zero";

        vm.hideNavBar;


        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();


        if (!vm.isLoggedIn) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.transferStandingOrders' }, { location: 'replace' });
            return;
        }


  

        $scope.$on('$ionicView.beforeEnter', function (e, viewData) {
            if (!vm.isLoggedIn) {
                lobbyUiService.go('dw.login', { nextPage: 'dw.transferStandingOrders' });
                return;
            }
          
        });

        function showLoader() {
            $ionicLoading.show({
                template: _template
            });
        }

        function hideLoader() {
            $timeout(function () {
                $ionicLoading.hide();
            }, 500);
        }

        fillCards();

        vm.operation = function () {
            console.log('vm.operation');
        }

        vm.onChangeCallback = function () {
            console.log("vm.onChangeCallback");
            vm.isChooseTicketDisabled = false;
            vm.secondHeadline = "div-blue-headline";
        }

        vm.addAnotherCardInput = function () {
            if (vm.showSecondCardInput && vm.showThirdCardInput)
                return;

            if (!vm.showSecondCardInput) {
                if (vm.inputCardOne.trim() != "") {
                    vm.showSecondCardInput = true;
                    googleAnalyticsService.insertEvent({ page: 'מותאם', action: 'העברת הוראת קבע', eventName: 'כרטיס אשראי נוסף' });
                }
            }
            else if (!vm.showThirdCardInput) {
                if (vm.inputCardTwo.trim() != "") {
                    vm.showThirdCardInput = true;
                    vm.showAddCard = false;
                    googleAnalyticsService.insertEvent({ page: 'מותאם', action: 'העברת הוראת קבע', eventName: 'כרטיס אשראי נוסף' });
                }
            }
        }

        vm.change = function (uniqueId) {
            vm.uniqueId = uniqueId;
            vm.thirdHeadline = "div-blue-headline";
            vm.showSelectCardSuccess = true;
            vm.confirmButtonDisabled = false;
            vm.buttonDisabled = "";
        }

        function getValidCards() {
            connection.transferStandingOrdersGetValidCards()
                .then(function (response) {
                    console.log("**********GetValidCards = ", JSON.stringify(response));
                    vm.validCards = response.UniqueId;
                    var cards = [];
                    var tmpCards = vm.cards;
                    vm.cards = [];
                    for (var i = 0; i < tmpCards.length; i++) {
                        if (vm.validCards.indexOf(tmpCards[i].Id) != -1) {
                            cards.push(tmpCards[i]);
                            vm.cards.push(tmpCards[i]);
                        }
                    }

                    for (var i = 0; i < vm.cards.length; i++) {
                        vm.generalCards.push(vm.cards[i]);
                    }

                    checkIfSourceCardsAreValid();
                }, function (error) {
                    hideLoader();
                    var message = error[0].response.Response.Status.Message;
                    if (message == undefined) {
                        errorService.handleError(error);
                    }
                    else {
                        showPopUp(message, "");
                    }
                    console.log("**********GetValidCards error = ", error);
                });

            var realHeight = document.getElementById("realHeightTrasOrders").scrollHeight;
            commService.sendHeight(realHeight+100);
        }

        function fillCards() {
            var bankAccountsArray = appData.BankAccounts;
            if (bankAccountsArray != undefined) {
                for (var i = 0; i < bankAccountsArray.length; i++) {
                    vm.cards = vm.cards.concat(bankAccountsArray[i].Cards);
                }
                //vm.uniqueId = vm.cards[0].Id;

                var countNonValidCards = 0;
                var cards = vm.cards;
                for (var i = 0; i < cards.length; i++) {
                    if (!cards[i].IsIssuedByCalInd) {
                        countNonValidCards += 1;
                    }
                }

                if (countNonValidCards > 0 && countNonValidCards == cards.length) {
                    showPopUpNonValidCards("כדי להעביר הוראות קבע לכרטיס אשראי בנקאי צריך לפנות לסניף הבנק", 'הודעת שגיאה - כרטיס בנקאי');
                }
                else {

                    if (countNonValidCards > 0) {
                        vm.opacityClass = "opacity-one";
                    }
                    getValidCards();
                }
            }
            else {
                lobbyUiService.go('dw.login', { nextPage: 'dw.transferStandingOrders' });
            }
        }

        function validation_check() {
            if (!vm.LegalConfirmed) {
                vm.showLegalError = true;
                vm.showLegalErrorStyle = "";
                return false;
            }

            if (vm.inputCardOne == undefined)
                vm.inputCardOne = "";

            if (vm.inputCardTwo == undefined)
                vm.inputCardTwo = "";

            if (vm.inputCardThree == undefined)
                vm.inputCardThree = "";

            if (vm.inputCardOne.trim() == "" && vm.inputCardTwo.trim() == "" && vm.inputCardThree.trim() == "") {
                vm.isCardOne = false;
                vm.errorFirstCard = "נא להזין כרטיס אשראי שממנו יש להעביר הוראות קבע";
                return false;
            }
            var firstCardCheck = checkCard(vm.inputCardOne);
            var secondCardCheck = checkCard(vm.inputCardTwo);
            var thirdCardCheck = checkCard(vm.inputCardThree);

            if (firstCardCheck)
                vm.isCardOne = true;

            if (secondCardCheck)
                vm.isCardTwo = true;

            if (thirdCardCheck)
                vm.isCardThree = true;

            if (!firstCardCheck
                || !secondCardCheck
                || !thirdCardCheck) {
                return false;
            }

            return true;
        }

        function transferStansingOrders(request) {
            googleAnalyticsService.insertEvent({ page: 'מותאם', action: 'העברת הוראת קבע', eventName: 'להעברת הוראת קבע' });
            connection.transferStandingOrders(request)
                .then(function (response) {
                    console.log("**********transferStandingOrders = ", JSON.stringify(response));
                    var bankAccountsArray = appData.BankAccounts;
                    for (var i = 0; i < bankAccountsArray.length; i++) {
                        var cardsArray = bankAccountsArray[i].Cards;
                        for (var j = 0; j < cardsArray.length; j++) {
                            if (vm.uniqueId == cardsArray[j].Id) {
                                var card = cardsArray[j];
                            }
                        }
                    }
                    var cards = response.SuccededCards;
                    var firstCard = vm.inputCardOne.substr(vm.inputCardOne.length - 4);
                    var secondCard = vm.inputCardTwo.substr(vm.inputCardTwo.length - 4);
                    var thirdCard = vm.inputCardThree.substr(vm.inputCardThree.length - 4);

                    cards = JSON.stringify(cards);

                    if (cards.indexOf(firstCard) == -1)
                        firstCard = "";
                    if (cards.indexOf(secondCard) == -1)
                        secondCard = "";
                    if (cards.indexOf(thirdCard) == -1)
                        thirdCard = "";

                    var failedCards = response.FailedCards;

                    $rootScope.transferOrdersFailedCards = failedCards;

                    $rootScope.cameFromTransferOrders = true;

                    hideLoader();
                    if (JSON.stringify({}) === JSON.stringify(response.SuccededCards)) {
                        handleCardsErrors(failedCards);
                    }
                    else {
                        lobbyUiService.go('dw.successTransferOrders', { fromFirstCard: firstCard, fromSecondCard: secondCard, fromThirdCard: thirdCard, toCard: card.LastFourDigits });
                    }

                }, function (error) {
                    hideLoader();
                    var message = error[0].response.Response.Status.Message;
                    if (message == undefined) {
                        errorService.handleError(error);
                    }
                    else {
                        showPopUp(message, "");
                    }
                    console.log("**********transferStandingOrders error = ", error);
                });
        }

        vm.transferStansingOrders = function () {
            if (!validation_check())
                return;

            showLoader();

            var request = {};

            request.uniqueId = vm.uniqueId;
            request.Origin = [];

            if (vm.inputCardOne.trim() != "") {
                var firstcard = vm.inputCardOne.replace(new RegExp("-", 'g'), "");
                request.Origin.push(firstcard);
            }

            if (vm.inputCardTwo.trim() != "") {
                var secondcard = vm.inputCardTwo.replace(new RegExp("-", 'g'), "");
                request.Origin.push(secondcard);
            }

            if (vm.inputCardThree.trim() != "") {
                var thirdcard = vm.inputCardThree.replace(new RegExp("-", 'g'), "");
                request.Origin.push(thirdcard);
            }

            transferStansingOrders(request);
        }

        vm.takanonLabelClick = function () {
            vm.takanonLabelClicked = true;
            lobbyUiService.popup.message('app/transferOrders/templates/takanon.html', null, null, 'transfers-orders-popup', 'סגירה', function () {
                vm.showTakanon = false;
                vm.takanonLabelClicked = false;
                googleAnalyticsService.insertEvent({ page: 'מותאם', action: 'העברת הוראת קבע', eventName: 'צפייה בתנאים משפטיים' });
            }, null, true).then(function (args) {

            });
            $timeout(function () {
                vm.takanonLabelClicked = false;
            }, 200);
        }

        vm.confirmTakanon = function () {
            if (vm.confirmButtonDisabled)
                return;

            if (vm.takanonLabelClicked)
                return;
            vm.LegalConfirmed = !vm.LegalConfirmed;
            if (vm.LegalConfirmed) {
                vm.confirmedTakanon = 'transfer-confirmed';
                vm.showLegalError = false;
                vm.showLegalErrorStyle = "transfer-no-opacity";
                vm.showConfirmSuccess = true;
            }
            else {
                vm.confirmedTakanon = 'transfer-not-confirmed';
                vm.showConfirmSuccess = false;
            }
        }

        vm.OnBlurCard = function () {
            if (vm.inputCardOne === undefined)
                vm.inputCardOne = "";
            if (vm.inputCardTwo === undefined)
                vm.inputCardTwo = "";
            if (vm.inputCardThree === undefined)
                vm.inputCardThree = "";
            var firstCardCheck = checkCard(vm.inputCardOne);
            var secondCardCheck = checkCard(vm.inputCardTwo);
            var thirdCardCheck = checkCard(vm.inputCardThree);

            if (firstCardCheck && secondCardCheck && thirdCardCheck) {

                if (vm.inputCardOne.trim() == "" && vm.inputCardTwo.trim() == "" && vm.inputCardThree.trim() == "") {
                    vm.showInputSuccess = false;
                }
                else {
                    vm.showInputSuccess = true;
                }
            }
            else {
                vm.showInputSuccess = false;
            }
        }

        vm.checkCard = function (p_cardNum) {
            if (p_cardNum === undefined)
                p_cardNum = "";
            p_cardNum = p_cardNum.replace(new RegExp("-", 'g'), "");
            return checkCard(p_cardNum);
        }


        function showPopUp(text, erroId) {
            if (text.indexOf("<a [href=]=\"'tel:") > -1) {
                showPopUpTel(text, erroId);
            }
            else {
                showPopUpRegular(text, erroId);
            }
        }

        function showPopUpRegular(text, erroId) {

            var popup = {
            };
            popup.title = "משהו השתבש";
            popup.text = text;
            popup.btns = [];
            if (erroId != "" && (erroId == "ErrorBpm559_240" || erroId == "ErrorBpm518_403")) {
                popup.btns.push(
                    {
                        text: "סגור",
                        type: 'button-positive',
                        onTap: function () {
                            googleAnalyticsService.insertEvent({ page: 'מותאם', action: 'העברת הוראת קבע', eventName: 'הודעת סגירה' });
                        }
                    }
                );
            }
            else {
                popup.btns.push(
                    {
                        text: "נסה שנית",
                        type: 'button-positive',
                        onTap: function () {
                            googleAnalyticsService.insertEvent({ page: 'מותאם', action: 'העברת הוראת קבע', eventName: 'הודעת שגיאה' });
                            vm.transferStansingOrders();
                        }
                    },
                    {
                        text: "סגור",
                        type: 'button-grey',
                        onTap: function () {
                            googleAnalyticsService.insertEvent({ page: 'מותאם', action: 'העברת הוראת קבע', eventName: 'הודעת שגיאה' });
                        }
                    }

                );
            }

            lobbyUiService.popup.messageText(null, popup.text, popup.title, null, null, null, popup.btns, true);
        };

        function showPopUpTel(text, erroId) {

            var popup = {
            };
            popup.title = "משהו השתבש";
            popup.text = text;
            popup.btns = [];
            popup.btns.push(
                {
                    text: "סגור",
                    type: 'button-positive',
                    onTap: function () {
                        if (erroId == "ErrorBpm518_General") {
                            googleAnalyticsService.insertEvent({ page: 'מותאם', action: 'העברת הוראת קבע', eventName: 'הודעת שגיאה – לא ניתן לבצע את הפעולה' });
                        }
                        else {
                            googleAnalyticsService.insertEvent({ page: 'מותאם', action: 'העברת הוראת קבע', eventName: 'הודעת שגיאה' });
                        }
                    }
                }
            );
            lobbyUiService.popup.messageText(null, popup.text, popup.title, null, null, null, popup.btns, true);
        };

        function showPopUpNonValidCards(text, analyticsEvent) {

            var popup = {
            };
            popup.title = "משהו השתבש";
            popup.text = text;
            popup.btns = [];
            popup.btns.push(
                {
                    text: "סגור",
                    type: 'button-positive',
                    onTap: function () {
                        googleAnalyticsService.insertEvent({ page: 'מותאם', action: 'העברת הוראת קבע', eventName: analyticsEvent });
                        lobbyUiService.go('dw.lobby');
                    }
                }
            );


            lobbyUiService.popup.messageText(null, popup.text, popup.title, null, null, null, popup.btns, false);
        };

        vm.goToPageBottom = function () {
            $ionicScrollDelegate.scrollBottom();
        }

        function checkIfSourceCardsAreValid() {
            var cards = vm.cards;
            var countNonValidCards = 0;

            if (cards.length == 0) {
                showPopUpNonValidCards("נראה שאין בחשבונך כרטיסים שאפשר להעביר אליהם הוראות קבע", 'הודעת שגיאה - אין כרטיסים להעביר אליהם הוראות קבע');
            }
            else {
                for (var i = 0; i < cards.length; i++) {
                    if (!cards[i].IsIssuedByCalInd) {
                        countNonValidCards += 1;
                    }
                }

                if (countNonValidCards == cards.length) {
                    showPopUpNonValidCards("כדי להעביר הוראות קבע לכרטיס אשראי בנקאי צריך לפנות לסניף הבנק", 'הודעת שגיאה - כרטיס בנקאי');
                }
            }
        }

        function checkCard(p_cardNum) {
            if (p_cardNum === undefined)
                p_cardNum = "";
            if (p_cardNum.length < 8 && p_cardNum.length > 0) {
                return false;
            }
            if (p_cardNum.length == 8 || p_cardNum.length == 9) //IsraCard
            {
                var module = 11;
                var mishkolet = 1;
                var sum = 0;
                for (var i = p_cardNum.length - 1; i > -1; i--) {
                    if (checkIfDigit(p_cardNum.charAt(i)))
                        sum = (p_cardNum.charAt(i) * mishkolet++) + sum;
                    else
                        return false;
                }
                if ((sum % module) == 0)
                    return true;
                else
                    return false;
            }

            else if (p_cardNum.length < 20) //other cards
            {
                var module = 10;
                var mishkolet = 1;
                var sum = 0;
                for (var i = p_cardNum.length - 1; i > -1; i--) {
                    if (checkIfDigit(p_cardNum.charAt(i)))
                        sum = (sumDigits(p_cardNum.charAt(i) * mishkolet)) + sum;
                    else
                        return false;
                    //fix mishkolet
                    if (mishkolet == 2)
                        mishkolet = 1;
                    else
                        mishkolet++;
                }
                if ((sum % module) == 0)
                    return true;
                else
                    return false;

            }
            else //less then 8 and more then 20 not legit card
                return false;
        }

        function handleCardsErrors(errorCards) {
            if (errorCards.length == 1) {
                showPopUp(errorCards[0].message, errorCards[0].errorId);
            }
            else {
                for (var i = 0; i < errorCards.length; i++) {
                    if (errorCards[i].Fullcard.indexOf(vm.inputCardOne) > -1) {
                        vm.errorFirstCard = errorCards[i].message;
                        vm.isCardOne = false;
                    }
                    else if (errorCards[i].Fullcard.indexOf(vm.inputCardTwo) > -1) {
                        vm.errorSecondCard = errorCards[i].message;
                        vm.isCardTwo = false;
                    }
                    else if (errorCards[i].Fullcard.indexOf(vm.inputCardThree) > -1) {
                        vm.errorThirdCard = errorCards[i].message;
                        vm.isCardThree = false;
                    }
                }
            }
        }

        function checkIfDigit(p_d) {
            if (p_d < 10 && p_d > -1)
                return true;
            else
                return false;
        }

        //if 18 will return  9
        function sumDigits(p_tosum) {
            //Max 18
            if (p_tosum / 10 < 1)
                return p_tosum;
            else
                return parseInt(p_tosum.toString().charAt(0)) + parseInt(p_tosum.toString().charAt(1));
        }

    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('transferOrders')
        .controller('successTransferOrders', successTransferOrders);

    successTransferOrders.$inject = [
        '$scope', 'connection', '$window', 'appData', 'lobbyUiService', '$rootScope', '$q', 'utilService', 'errorService',
        '$ionicScrollDelegate', 'googleAnalyticsService', '$timeout', '$ionicLoading', '$ionicPopup', '$location', 'lobbyDataService'
        ,'$sce','commService'
    ];

    function successTransferOrders($scope, connection, $window, appData, lobbyUiService, $rootScope, $q, utilService, errorService,
        $ionicScrollDelegate, googleAnalyticsService, $timeout, $ionicLoading, $ionicPopup, $location, lobbyDataService, $sce,commService) {

        var vm = this;
        vm.title = "העברת הוראות קבע";
        vm.fromFirstCard = "";
        vm.fromSecondCard = "";
        vm.fromThirdCard = "";
        vm.toCard = "";
        vm.countCards = 0;
        vm.manyCardsLabel = false;
        vm.errorCards = [];
        vm.showErrors = false;
        vm.cardsError = "";
        vm.cardsErrorReason = "";
        vm.errorMessages = [];
        $('body').addClass('finish');
        parent.postMessage({ call: "dwProcessEnd" }, '*');
        vm.returnToTransferOrders = function () {
            lobbyUiService.go('dw.transferStandingOrders', {});
        }


        vm.hideNavBar;


        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();


        vm.returnToLobby = function () {
            googleAnalyticsService.insertEvent({ page: 'מותאם', action: 'העברת הוראת קבע', eventName: 'חזרה לדף הבית' });
            $rootScope.cameFromTransferOrders = false;
            commService.backToHomePage();
           // lobbyUiService.go('dw.lobby');
        }

        vm.backToHomePage = function () {
            $('body').removeClass('finish');
            commService.backToHomePage();
           // lobbyUiService.go('dw.lobby');
         
        }

        vm.sanitizeMe = function (text) {
            return $sce.trustAsHtml(text);
        }

        $scope.$on('$ionicView.afterEnter', function (e, viewData) {

            vm.fromFirstCard = lobbyUiService.getParams('fromFirstCard');
            console.log("fromFirstCard: ", vm.fromFirstCard);

            vm.fromSecondCard = lobbyUiService.getParams('fromSecondCard');
            console.log("fromSecondCard: ", vm.fromSecondCard);

            vm.fromThirdCard = lobbyUiService.getParams('fromThirdCard');
            console.log("fromThirdCard: ", vm.fromThirdCard);

            vm.toCard = lobbyUiService.getParams('toCard');
            console.log("toCard: ", vm.toCard);

            if ($rootScope.cameFromTransferOrders != true) {
                vm.returnToTransferOrders();
            }

            googleAnalyticsService.insertEvent({ page: 'מותאם', action: 'העברת הוראת קבע', eventName: 'קיבלנו את בקשתך' });

            if (vm.fromFirstCard != "")
                vm.countCards += 1;
            if (vm.fromSecondCard != "")
                vm.countCards += 1;
            if (vm.fromThirdCard != "")
                vm.countCards += 1;

            if (vm.countCards > 1)
                vm.manyCardsLabel = true;

            vm.errorCards = $rootScope.transferOrdersFailedCards;
            if (vm.errorCards.length > 0) {
                var errorMessages = [];
                if (vm.errorCards.length == 1) {
                    vm.cardsError = "הוראות קבע מכרטיס אשראי המסתיים בספרות " + vm.errorCards[0].card + " לא יועברו.";
                    errorMessages.push(vm.errorCards[0].message);
                }
                else {
                    var cardsText = "";                    
                    for (var i = 0; i < vm.errorCards.length; i++)
                    {
                        cardsText = cardsText + vm.errorCards[i].card + ", ";
                        errorMessages.push(vm.errorCards[i].card + " - " + vm.errorCards[i].message);
                    }                   
                    cardsText = cardsText.substring("", cardsText.length - 2);
                    vm.cardsError = "הוראות קבע מכרטיסי אשראי המסתיימים בספרות " + cardsText + " לא יועברו.";                    
                }
                vm.errorMessages = errorMessages;
                vm.showErrors = true;
            }
            else
                vm.showErrors = false;
        });
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('transferOrders')
        .factory('transferOrdersService', transferOrdersService);
    function transferOrdersService($q, connection, $rootScope, lobbyUiService, errorService, $timeout) {
        var handleAuthentication = function () {
            var deferred = $q.defer();
            if (!lobbyUiService.connection.isLoggedIn()) {
                $timeout(function () {
                    lobbyUiService.go('dw.login', { nextPage: 'dw.transferStandingOrders' });
                    deferred.reject();
                    return;
                });
            }
            deferred.resolve(true);
        }

        return {
            handleAuthentication: handleAuthentication,
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('onlineForms', [])
    .run(function () {
        //TODO
    })
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('onlineForms').config(onlineFormsRoute);

    function onlineFormsRoute($stateProvider) {
        //TODO http://localhost/DigitalWallet.UI/#!/digital/lobby

        $stateProvider

        .state('dw.onlineforms', {
            url: "/onlineforms/:formId",
            cache: false,
            params: {
                /*  formId: {
                    
                  }
  */
                params: {
                    formId: null
                }
            },
            checkState: function ($q, $timeout) {

            },
            resolve: {
                checkState: function ($q, $timeout) {

                }
            },

            views: {
                'contentBody': {
                    templateUrl: "app/onlineForms/online-forms.html",
                    controller: "onlineFormsCtrl as vm"
                }
            }
        })


    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('onlineForms')
    .controller('onlineFormsCtrl', onlineFormsCtrl);

    onlineFormsCtrl.$inject = [
       '$scope', 'connection', 'lobbyUiService', '$sce', '$stateParams', 'appSettings'
    ];

    function onlineFormsCtrl($scope, connection, lobbyUiService, $sce, $stateParams, appSettings) {
        var vm = this;
        vm.query = '';
        var request = {};
        vm.link = '';
        vm.calculate = screen.height;

    
        if (!lobbyUiService.connection.isLoggedIn()) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.onlineforms' }, { location: 'replace' });
        }
        else {
            connection.setAuthenticData(request).then(function (response) {
          
                if (response.Response.Status.Succeeded) {
                   
                    vm.link = $sce.trustAsResourceUrl(String.format(appSettings.linkOnlineFormsIframe, appSettings.systemId, response.Token, $stateParams.formId));
                    //vm.link = $sce.trustAsResourceUrl(appSettings.linkOnlineFormsIframe + appSettings.systemId + "?token=" + response.Token + "&formId=" + $stateParams.formId);
                   
                }
                else {
                    deferred.reject(response);
                    //thorw error
                }

                lobbyUiService.loader.hide();

            }, function (error) {
             

            });
        }








    }

})(window, window.angular);
/*
function AppCtrl($scope, $sce) {
    // ...
    $scope.setProject = function (id) {
        $scope.currentProject = $scope.projects[id];
        $scope.currentProjectUrl = $sce.trustAsResourceUrl($scope.currentProject.url);
    }
}
In the Template:
    <iframe ng-src="{{currentProjectUrl}}"> <!--content--> </iframe>*/


﻿
(function () {
    'use strict'
    function wizardHeaderController() {
        var vm = this;
    }


    angular.module('digitalWallet')
    .directive('wizardHeader', function () {
        return {
            //require: ['^^myTabs', 'ngModel'],
            restrict: 'E',
            controllerAs: 'vm',
            controller: wizardHeaderController,
            bindToController: true,
            transclude: true,
            scope: {
                steps: '=steps'
            },
            link: function (scope, element, attrs, controllers) {
                /*var tabsCtrl = controllers[0],
                    modelCtrl = controllers[1];
                    de
                tabsCtrl.addPane(scope);*/

            },
            templateUrl: 'app/shared/wizard-header.component/wizard-header.html'
        };
    });
})(window, window.angular);



﻿(function () {
    'use strict'
    
    chooseTicketController.$inject = [
      'connection', 'appData',  '$scope'
    ];

    function chooseTicketController(connection, appData, $scope) {
        var vmChooseTicket = this;

        if (vmChooseTicket.operation && vmChooseTicket.operation.name) {
            vmChooseTicket.operationSrc = "app/shared/choose-ticket.component/choose-ticket-" + vmChooseTicket.operation.name + ".html";
        }

        if (vmChooseTicket.isDisabled == undefined)
        {
            vmChooseTicket.isDisabled = false;
        }

        var req = {};

        req.CardProcessType = vmChooseTicket.operation.name;

        vmChooseTicket.isFromBlockConfirm = false;
     
        //#fix 103993
        //vmChooseTicket.creditArray = vmChooseTicket.cards;


        if (!vmChooseTicket.isDisabled) {
            vmChooseTicket.uniqueIDChosen = vmChooseTicket.uniqueId;
        }
    
  
        vmChooseTicket.cardChange = function () {
            console.log("cardChanged", vmChooseTicket.uniqueId);
            var obj = {};
            obj.uniqueIDChosen = vmChooseTicket.uniqueId;
            vmChooseTicket.onChangeCard(obj);
        };
   

    }


    angular.module('digitalWallet')
    .directive('chooseTicket', function () {
        return {
            restrict: 'E',
            controllerAs: 'vmChooseTicket',
            controller: chooseTicketController,
            bindToController: true,
            transclude: true,
            scope: {
                operation: '=',
                onChangeCard: '&onChangeCard',
                close: '&onClose',
                uniqueId: '=uniqueId',
                cards: '=cards',
                isDisabled: '=isDisabled',
            },
            link: function (scope, element, attrs, controllers) {

            },
            templateUrl: 'app/shared/choose-ticket.component/choose-ticket.html'
        };
    });
})(window, window.angular);




﻿(function () {
    'use strict'
    
    chooseTicketController.$inject = [
      'connection', 'appData',  '$scope'
    ];

    function chooseTicketController(connection, appData, $scope) {
        var vmChooseTicket = this;

        if (vmChooseTicket.operation && vmChooseTicket.operation.name) {
            vmChooseTicket.operationSrc = "app/shared/choose-ticket-filtered-by-card-owner.component/choose-ticket-filtered-by-card-owner-" + vmChooseTicket.operation.name + ".html";
        }

        if (vmChooseTicket.isDisabled == undefined)
        {
            vmChooseTicket.isDisabled = false;
        }

        var req = {};

        req.CardProcessType = vmChooseTicket.operation.name;

        vmChooseTicket.isFromBlockConfirm = false;
     
        //#fix 103993
        //vmChooseTicket.creditArray = vmChooseTicket.cards;


        if (!vmChooseTicket.isDisabled) {
            vmChooseTicket.uniqueIDChosen = vmChooseTicket.uniqueId;
        }
    
  
        vmChooseTicket.cardChange = function () {
            var obj = {};
            obj.uniqueIDChosen = vmChooseTicket.uniqueId;
            vmChooseTicket.onChangeCard(obj);
        };
   

    }


    angular.module('digitalWallet')
    .directive('chooseTicketFilteredByCardOwner', function () {
        return {
            restrict: 'E',
            controllerAs: 'vmChooseTicket',
            controller: chooseTicketController,
            bindToController: true,
            transclude: true,
            scope: {
                operation: '=',
                onChangeCard: '&onChangeCard',
                close: '&onClose',
                uniqueId: '=uniqueId',
                cards: '=cards',
                isDisabled: '=isDisabled',
            },
            link: function (scope, element, attrs, controllers) {

            },
            templateUrl: 'app/shared/choose-ticket-filtered-by-card-owner.component/choose-ticket-filtered-by-card-owner.html'
        };
    });
})(window, window.angular);




﻿


(function () {
    'use strict'
    
    checkboxDesignedController.$inject = [
      'connection', 'appData', '$scope'
    ];

    function checkboxDesignedController(connection, appData, $scope) {
        var vmCheckboxDesigned = this;
        console.log("vmCheckboxDesigned.checkboxItems", vmCheckboxDesigned.checkboxItems);
        if (vmCheckboxDesigned.operation && vmCheckboxDesigned.operation.name) {
            vmCheckboxDesigned.operationSrc = "app/shared/checkbox-designed.component/checkbox-designed-" + vmCheckboxDesigned.operation.name + ".html";
        }

        if (vmCheckboxDesigned.isVirtualCard) {
            vmCheckboxDesigned.chkbxLabel = 'למה לחסום את הכרטיס?';
        }
        else {
            vmCheckboxDesigned.chkbxLabel = 'מה קרה לכרטיס?';
        }
       

        vmCheckboxDesigned.activeIt = function (index) {
            for (var i = 0; i < vmCheckboxDesigned.checkboxItems.length; i++) {
                vmCheckboxDesigned.checkboxItems[i].active = false;
            }
            vmCheckboxDesigned.checkboxItems[index].active = true;

            var obj = {};
            obj.index = index;
            vmCheckboxDesigned.onChangeCheckBox(obj);

         
            
        }
      

    }


    angular.module('digitalWallet')
    .directive('checkboxDesigned', function () {
        return {
            restrict: 'E',
            controllerAs: 'vmCheckboxDesigned',
            controller: checkboxDesignedController,
            bindToController: true,
            transclude: true,
            scope: {
                operation: '=',
                checkboxItems: '=',
                isVirtualCard: '=',
                onChangeCheckBox: '&onChangeCheckBox',
                onInvalid: '='
            },
            link: function (scope, element, attrs, controllers) {

            },
            templateUrl: 'app/shared/checkbox-designed.component/checkbox-designed.html'
        };
    });
})(window, window.angular);




﻿


(function () {
    'use strict'
    
    checkboxDesignedLongController.$inject = [
      'connection', 'appData', '$scope'
    ];

    function checkboxDesignedLongController(connection, appData, $scope) {
        var vmCheckboxDesignedLong = this;

        if (vmCheckboxDesignedLong.operation && vmCheckboxDesignedLong.operation.name) {
            vmCheckboxDesignedLong.operationSrc = "app/shared/checkbox-designed.component/checkbox-designed-" + vmCheckboxDesignedLong.operation.name + ".html";
        }

        console.log("checkBoxItems", vmCheckboxDesignedLong);

        vmCheckboxDesignedLong.activeIt = function (index) {
            for (var i = 0; i < vmCheckboxDesignedLong.checkboxItems.length; i++) {
                vmCheckboxDesignedLong.checkboxItems[i].active = false;
            }
            vmCheckboxDesignedLong.checkboxItems[index].active = true;

            var obj = {};
            obj.index = index;
            vmCheckboxDesignedLong.onChangeCheckBox(obj);

         
            
        }
      

    }


    angular.module('digitalWallet')
    .directive('checkboxDesignedLong', function () {
        return {
            restrict: 'E',
            controllerAs: 'vmCheckboxDesignedLong',
            controller: checkboxDesignedLongController,
            bindToController: true,
            transclude: true,
            scope: {
                operation: '=',
                checkboxItems: '=',
                onChangeCheckBox: '&onChangeCheckBox',
                onInvalid: '='
            },
            link: function (scope, element, attrs, controllers) {

            },
            templateUrl: 'app/shared/checkbox-designed-long.component/checkbox-designed-long.html'
        };
    });
})(window, window.angular);




﻿


(function () {
    'use strict'
    countryPickerController.$inject = [
       'connection', 'appData', '$scope', 'lobbyUiService'
    ];
    function countryPickerController(connection, appData, $scope, lobbyUiService) {
        var vmcountryPicker = this;

        if (vmcountryPicker.operation  && vmcountryPicker.operation.name) {
            vmcountryPicker.operationSrc = 'app/shared/country-picker.component/country-picker.component-' + vmcountryPicker.operation.name + '.html';
        }
       
        vmcountryPicker.class = "";
       
        if (vmcountryPicker.onInvalid != '') {
            vmcountryPicker.class = "error-border";
        }


        vmcountryPicker.isShowcountries = false;
        getCountryList();
        vmcountryPicker.selectedCountry = function (country) {
           var obj = {};
            if (country) {
                obj.country = country.title;
            }
            vmcountryPicker.onSelectedCountry(obj);


            
        };
        

       
        function getCountryList(country) {
            var url = 'app/shared/country-picker.component/country-list.json';
            $.getJSON(url, function (response) {
                vmcountryPicker.countries = response.countries.country;
            })
        }
   
}


    angular.module('digitalWallet')
.directive('countryPicker', function () {
    return {
        restrict: 'E',
        controllerAs: 'vmcountryPicker',
        controller: countryPickerController,
        bindToController: true,
        transclude: true,
        scope: {
            operation: '=',
            params: '=',
            countryPickerValue: '=',
            onInvalid: '=',
            onSelectedCountry: '&onSelectedCountry'
        },
        link: function (scope, element, attrs, controllers) {

        },
        templateUrl: 'app/shared/country-picker.component/country-picker.component.html'
    };
});
})(window, window.angular);







﻿(function () {
    'use strict'
    datePickerController.$inject = [
        'connection', 'appData', '$scope', 'lobbyUiService', '$element', '$timeout'
    ];
    function datePickerController(connection, appData, $scope, lobbyUiService, $element, $timeout) {
        console.log("****************datePickerController*************");
        var vmDatePicker = this;
        var nowDate = new Date();
        var tomo = new Date();
        var isOs = ionic.Platform.isIOS();
        vmDatePicker.dateDate;
        vmDatePicker.initialDate = new Date();

        var input = $element.find('input');

        if (vmDatePicker.duration == "" || vmDatePicker.duration == undefined) {
            vmDatePicker.duration = 584;
        }

        if (!isOs) {
            vmDatePicker.maxDate = (new Date(tomo.setDate(nowDate.getDate()))).toJSON().split('T')[0];
            vmDatePicker.minDate = (new Date(tomo.setDate(nowDate.getDate() - vmDatePicker.duration))).toJSON().split('T')[0]; // 584
        }
        else {
            vmDatePicker.maxDate = "2525-01-01";
            vmDatePicker.minDate = "1000-01-01";
        }
        if (vmDatePicker.operation && vmDatePicker.operation.name) {
            vmDatePicker.operationSrc = "app/shared/date-picker.component/date-picker.component-" + vmDatePicker.operation.name + ".html";
        }

        if (vmDatePicker.datePickerValue == undefined || Date.parse(vmDatePicker.datePickerValue) === NaN) {
            vmDatePicker.datePickerValue = new Date();
        }

        $timeout(function () {
            var dateTMP = moment(vmDatePicker.datePickerValue).format("DD/MM/YYYY");
            console.log('******dateTMP', dateTMP);
            if(vmDatePicker.operation.name.toLowerCase() === "block")
            {
                input[0].setAttribute('data-date', "");
            }
            else
            {
                vmDatePicker.initialDate = vmDatePicker.datePickerValue;
                input[0].setAttribute('data-date', dateTMP);
            }
        }, 300);

        $scope.$watch('vmDatePicker.datePickerValue', function () {
            $timeout(function () {
                var dateTMP = moment(vmDatePicker.datePickerValue).format("DD/MM/YYYY");
                console.log('******dateTMP', dateTMP);
                input[0].setAttribute('data-date', dateTMP);
                console.log('***********vmDatePicker.initialDate watch*****************');
            });
        }, true);

        vmDatePicker.onChange = function () {
            console.log("****************datePickerController onChange************* ", vmDatePicker.datePickerValue);
            var now = new Date();
            var tomo = new Date();
            var nowDate = new Date();

            var yearAgo = new Date(tomo.setDate(nowDate.getDate() - vmDatePicker.duration)); //584 
            if (vmDatePicker.datePickerValue >= now || vmDatePicker.datePickerValue == '' || vmDatePicker.datePickerValue == null) {
                vmDatePicker.datePickerValue = vmDatePicker.initialDate;
            }

            if (yearAgo > vmDatePicker.datePickerValue) {
                vmDatePicker.datePickerValue = yearAgo;
            }

            var dateTMP = moment(vmDatePicker.datePickerValue).format("DD/MM/YYYY");
            input[0].setAttribute('data-date', dateTMP);
        }

        vmDatePicker.textFieldBlurChanged = function () {
            console.log('vmDropDown.textFieldBlurChanged');
            vmDatePicker.textFieldBlur();
        }

        //$("input").on("change", function () {
        //    this.setAttribute(
        //        "data-date",
        //        moment(vmDatePicker.datePickerValue, "DD/MM/YYYY")
        //            .format(this.getAttribute("data-date-format"))
        //    )
        //}).trigger("change")

    }

    angular.module('digitalWallet')
        .directive('datePicker', function () {
            return {
                restrict: 'E',
                controllerAs: 'vmDatePicker',
                controller: datePickerController,
                bindToController: true,
                transclude: true,
                scope: {
                    operation: '=',
                    params: '=',
                    datePickerValue: '=datePickerValue',
                    duration: '=datePickerDuration',
                    textFieldBlur: '&textFieldBlur',
                    onInvalid: '=',
                },
                link: function (scope, element, attrs, controllers) {

                },
                templateUrl: 'app/shared/date-picker.component/date-picker.component.html'
            };
        });
})(window, window.angular);
﻿


(function () {
    'use strict'
    cvvController.$inject = [
       'connection', 'appData', '$scope', 'lobbyUiService'
    ];
    function cvvController(connection, appData, $scope, lobbyUiService) {
        
        var vmCvv = this;

        vmCvv.openPopUp = function () {
            var popup = {};
            popup.template = 'app/shared/templates/cvv-popup.html';
            popup.btns = [];
            popup.btns.push(
                               {
                                   text: "חזרה למסך",
                                   type: 'button-positive',
                                   onTap: function () {

                                   }
                               });

            lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, true);
        };

    
    }


    angular.module('digitalWallet')
    .directive('cvv', function () {
        return {
            restrict: 'E',
            controllerAs: 'vmCvv',
            controller: cvvController,
            bindToController: true,
            transclude: true,
            scope: {
               /* operation: '=',
                params: '=',
                countryPickerValue: '=',
                onInvalid: '='*/
                onInvalid: '=',
                cvvInput: '=cvvInput'

               
            },
            link: function (scope, element, attrs, controllers) {

            },
            templateUrl: 'app/shared/cvv.component/cvv.component.html'
        };
    });
})(window, window.angular);








﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("gridComponent", gridComponent);

    gridComponent.$inject = ['$timeout'];

    function gridComponent($timeout) {
        return {
            restrict: 'E',
            replace: true,
            bindToController: true,
            controllerAs: 'vm',
            templateUrl: 'app/shared/designedGrid/grid.html',
            scope: {
                gridData: '=',
                gridExpandCallback: '&'
            },
            controller: function () {
                var vm = this;
                vm.expandSymbol = "+";

                vm.onExpand = function (category) {
                    category.isExpand = !category.isExpand;
                    if (!category.isExpand) {
                        category.expandSymbol = "+";
                    }
                    else {
                        category.expandSymbol = "-";
                    }
                }

                vm.onGridClick = function ($event) {
                    console.log("grid");
                   // console.log('**************onGridClick=', $event);
                }
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("rowComponent", rowComponent);

    rowComponent.$inject = ['$rootScope'];

    function rowComponent() {
        return {
            restrict: 'E',
            replace: true,
            bindToController: true,
            controllerAs: 'vm',
            templateUrl: 'app/shared/designedGrid/row.html',
            scope: {
                rowData: '=',
                rowCallback: '&'
            },
            controller: function ($rootScope) {
                var vm = this;

                vm.expand = function (id, locationId) {
                    vm.isExpand = !vm.isExpand;
                    vm.rowCallback()({ id: id });
                    console.log('******id=', locationId);
                    if (vm.isExpand == true) {
                        $rootScope.gridAnchorIdFilter = locationId;
                    }
                    else {
                        $rootScope.gridAnchorIdFilter = 'aaa';
                    }
                }
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("rowDetailsComponent", rowDetailsComponent);

    rowDetailsComponent.$inject = [
        "lobbyUiService", "googleAnalyticsService"
    ];




    function rowDetailsComponent() {
        return {
            restrict: 'E',
            replace: true,
            bindToController: true,
            controllerAs: 'vm',
            templateUrl: 'app/shared/designedGrid/rowDetails.html',
            scope: {
                rowData: '='
            },
            controller: function (lobbyUiService, googleAnalyticsService, leadNavigationService, connection, appSettings, appData, errorService) {
                var vm = this;
                vm.show = function (value) {
                    if (value != '')
                        return true;
                    return false;
                }

                vm.getGoogleQuery = function (suffix) {
                    return encodeURIComponent(suffix.trim());
                }

                vm.searchGoogleAnalytics = function (suffix) {
                    googleAnalyticsService.trackPage('/vp/transaction-search/search-business');
                    googleAnalyticsService.insertEvent({ page: 'transaction-search', action: 'search-business' });
                    googleAnalyticsService.insertEvent({ page: 'transaction-search', action: 'חיפוש גוגל בחיפוש עסקה', eventName: suffix.trim() });
                }

                vm.goToStopStandingOrders = function () {
                    lobbyUiService.navigate('dw.stop-standing-order');
                }

                vm.goToChat = function () {                                        
                    googleAnalyticsService.trackPage('/vp/transaction-search/chat-with-rep');
                    googleAnalyticsService.insertEvent({ page: 'transaction-search', action: 'chat-with-rep' });
                    leadNavigationService.navigate();
                };

                vm.transDenial = function (value) {
                    appData.showSpinner = true;
                    lobbyUiService.loader.show();
                    connection.getTransDenialToken(value.trnId, value.numerator)
                        .then(function (res) {
                            lobbyUiService.loader.hide();
                            if (res.Token) {
                                sessionStorage.setItem("filterTransRequest", JSON.stringify(value.serverRequest));
                                var url = appSettings.transDenialUrl + res.Token;
                                location.href = url;
                            }
                            else {
                                //errorService.handleError(null, res);
                            }
                        }, function (err) {

                        });
                };
            }
        }
    }
})(window, window.angular);
﻿(function () {
    'use strict'
    dropDownController.$inject = [
        'connection', 'appData', '$scope', 'lobbyUiService'
    ];
    function dropDownController(connection, appData, $scope, lobbyUiService) {
        var vmDropDown = this;
        vmDropDown.textFieldBlurChanged = function () {
            console.log('vmDropDown.textFieldBlurChanged');
            vmDropDown.textFieldBlur();
        }
    }

    angular.module('digitalWallet')
        .directive('dropDown', function () {
            return {
                restrict: 'E',
                controllerAs: 'vmDropDown',
                controller: dropDownController,
                bindToController: true,
                transclude: true,
                scope: {
                    operation: '=',
                    params: '=',
                    dropDownDictionary: '=dropDownDictionary',
                    dropDownLabel: '=dropDownLabel',
                    selectModel: '=selectModel',
                    textFieldBlur: '&textFieldBlur',
                    onInvalid: '='
                },
                link: function (scope, element, attrs, controllers) {

                },
                templateUrl: 'app/shared/drop-down.component/drop-down.component.html'
            };
        });
})(window, window.angular);




﻿(function () {
    'use strict'
    textFieldController.$inject = [
        'connection', 'appData', '$scope', 'lobbyUiService'
    ];
    function textFieldController(connection, appData, $scope, lobbyUiService) {
        var vmTextField = this;

        vmTextField.textFieldBlurChanged = function () {
            console.log('vmTextField.textFieldBlurChanged');
            vmTextField.textFieldBlur();
        }

    }

    angular.module('digitalWallet')
        .directive('textField', function () {
            return {
                restrict: 'E',
                controllerAs: 'vmTextField',
                controller: textFieldController,
                bindToController: true,
                transclude: true,
                scope: {
                    operation: '=',
                    params: '=',
                    textFieldLabel: '=textFieldLabel',
                    textFieldModel: '=textFieldModel',
                    textFieldBlur: '&textFieldBlur',
                    onInvalid: '='
                },
                link: function (scope, element, attrs, controllers) {

                },
                templateUrl: 'app/shared/text-field.component/text-field.component.html'
            };
        });
})(window, window.angular);




﻿
(function () {
    'use strict'

    chooseTicketMultipleController.$inject = [
        'connection', 'appData', '$scope', '$timeout'
    ];

    function chooseTicketMultipleController(connection, appData, $scope, $timeout) {
        var vmChooseTicketMultiple = this;

        if (vmChooseTicketMultiple.operation && vmChooseTicketMultiple.operation.name) {
            vmChooseTicketMultiple.operationSrc = "app/shared/choose-ticket.multiple.component/choose-ticket.multiple-" + vmChooseTicketMultiple.operation.name + ".html";
        }

        var cardsArrayLength = 0;

        var req = {};

        req.CardProcessType = vmChooseTicketMultiple.operation.name;

        //vmChooseTicketMultiple.showCheckBoxList = vmChooseTicketMultiple.closeCheckBox;

        vmChooseTicketMultiple.isFromBlockConfirm = false;


        vmChooseTicketMultiple.creditArray = vmChooseTicketMultiple.cards;


        vmChooseTicketMultiple.uniqueIDChosen = vmChooseTicketMultiple.uniqueId;

        vmChooseTicketMultiple.dropwDownText = "כל הכרטיסים";

        $scope.$watch('vmChooseTicketMultiple.cards', function () {
            if (vmChooseTicketMultiple.cards.length == 2) {
                var cardForLabel = vmChooseTicketMultiple.cards[1]
                vmChooseTicketMultiple.dropwDownText = cardForLabel.NumTypeDescription + " " + cardForLabel.CardType + " " + cardForLabel.LastFourDigits;
            }
            else {
                vmChooseTicketMultiple.dropwDownText = "כל הכרטיסים";
            }
        });

        vmChooseTicketMultiple.cardChange = function () {
            var obj = {};
            obj.uniqueIDChosen = vmChooseTicketMultiple.uniqueIDChosen;
            vmChooseTicketMultiple.onChangeCard(obj);
        };

        vmChooseTicketMultiple.clickSelect = function () {
            vmChooseTicketMultiple.isClicked = true;
            vmChooseTicketMultiple.showCheckBoxList = !vmChooseTicketMultiple.showCheckBoxList;
        }


        vmChooseTicketMultiple.checkboxTypeClicked = function (card) {
            let cardsArrayLength = 0;
            console.log("vmChooseTicketMultiple.checkboxTypeClicked= ", vmChooseTicketMultiple.isClicked);
            vmChooseTicketMultiple.isClicked = true;
            if (card.isChecked == undefined)
                card.isChecked = true;
            else
                card.isChecked = !card.isChecked;

            if (vmChooseTicketMultiple.cards[0].isChecked) {
                cardsArrayLength = vmChooseTicketMultiple.cards - 1;
            }
            else {
                for (let i = 1; i < vmChooseTicketMultiple.cards.length; ++i) {
                    if (vmChooseTicketMultiple.cards[i].isChecked) {
                        cardsArrayLength = cardsArrayLength + 1;
                    }
                }
                
            }


            //if (card.isChecked)
            //    cardsArrayLength = cardsArrayLength + 1;
            //else
            //    cardsArrayLength = cardsArrayLength - 1;

            if (vmChooseTicketMultiple.cards.length == 2) {
                var cardForLabel = vmChooseTicketMultiple.cards[1];
                str = cardForLabel.NumTypeDescription + " " + cardForLabel.CardType + " " + cardForLabel.LastFourDigits;
            }
            else if (cardsArrayLength > 0) {
                var str = "חפשו ב-" + cardsArrayLength + " הכרטיסים שברשותי ";
            }
            else {
                str = "כל הכרטיסים";
            }
            vmChooseTicketMultiple.dropwDownText = str;
        }

        vmChooseTicketMultiple.checkboxType = function (card) {
            if (card.isChecked)
                return "content/images/check_on_green.svg";
            return "content/images/check_off.svg";
        }
    }


    angular.module('digitalWallet')
        .directive('chooseTicketMultiple', function () {
            return {
                restrict: 'E',
                controllerAs: 'vmChooseTicketMultiple',
                controller: chooseTicketMultipleController,
                bindToController: true,
                transclude: true,
                scope: {
                    operation: '=',
                    onChangeCard: '&onChangeCard',
                    close: '&onClose',
                    uniqueId: '=uniqueId',
                    cards: '=cards',
                    isClicked: '=isClicked',
                    showCheckBoxList: '=showCheckBoxList'
                },
                link: function (scope, element, attrs, controllers) {

                },
                templateUrl: 'app/shared/choose-ticket.multiple.component/choose-ticket.multiple.html'
            };
        });
})(window, window.angular);




﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("standingOrderGridComponent", standingOrderGridComponent);

    standingOrderGridComponent.$inject = ['$timeout'];

    function standingOrderGridComponent($timeout) {
        return {
            restrict: 'E',
            replace: true,
            bindToController: true,
            controllerAs: 'vm',
            templateUrl: 'app/shared/standingOrderGrid.component/grid.html',
            scope: {
                gridData: '=',
                gridExpandCallback: '&'
            },
            controller: function () {
                var vm = this;
                vm.expandSymbol = "+";

                vm.onExpand = function (category) {
                    category.isExpand = !category.isExpand;
                    if (!category.isExpand) {
                        category.expandSymbol = "+";
                    }
                    else {
                        category.expandSymbol = "-";
                    }
                }

                vm.onGridClick = function ($event) {
                    console.log('**************onGridClick=', $event);
                }
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("standingOrderRowComponent", standingOrderRowComponent);

    standingOrderRowComponent.$inject = ['$rootScope'];

    function standingOrderRowComponent() {
		return {
			restrict: 'E',
			replace: true,
			bindToController: true,
			controllerAs: 'vm',
            templateUrl: 'app/shared/standingOrderGrid.component/row.html',
			scope: {				
			    rowData: '=',
                rowCallback: '&'
			},
            controller: function ($rootScope, lobbyUiService, googleAnalyticsService) {				
			    var vm = this;

                vm.openExternal = function (suffix, pageName) {
                    var url = "https://www.google.com/search?q=" + encodeURIComponent(suffix.trim());
                    console.log("url= ", url);
                    googleAnalyticsService.insertEvent({ page: pageName, action: 'פירוט הוראת קבע', eventName: 'חיפוש בית העסק בגוגל' });
                    lobbyUiService.openExternal(url, '', true);
                }
                vm.rowData.vmReference = vm;

                vm.rowData.expand = function (id, locationId) {
                    vm.isExpand = !vm.isExpand;                  
                    vm.rowCallback()({ id: id });
                    console.log('******id=', locationId);
                    if (vm.isExpand) {
                        $rootScope.gridAnchorIdFilter = locationId;
                    }
                    else {
                        $rootScope.gridAnchorIdFilter = 'aaa';
                    }
                    if (vm.isExpand) {
                        vm.rowData.OnExpandClient(vm.rowData.merchantId, vm.rowData.merchantType, locationId);
                    }
			    }
			}
		}
	}
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("standingOrderRowDetailsComponent", standingOrderRowDetailsComponent);

    standingOrderRowDetailsComponent.$inject = [
        "lobbyUiService", "googleAnalyticsService"
    ];

    function standingOrderRowDetailsComponent() {
        return {
            restrict: 'E',
            replace: true,
            bindToController: true,
            controllerAs: 'vm',
            templateUrl: 'app/shared/standingOrderGrid.component/rowDetails.html',
            scope: {
                rowData: '='                
            },
            controller: function (lobbyUiService, googleAnalyticsService) {
                var vm = this;
                vm.show = function (value) {
                    if (value != '')
                        return true;
                    return false;
                }

                vm.openExternal = function (suffix)
                {                    
                    var url = "https://www.google.com/search?q=" + encodeURIComponent(suffix.trim());
                    console.log("url= ", url);
                    googleAnalyticsService.insertEvent({ page: 'transaction-search', action: 'chat-with-rep' });
                    lobbyUiService.openExternal(url, '', true);
                }

                vm.goToChat = function () {
                    var options = {
                        "abandonBehavior": false,
                        "type": "3",
                        "id": 69,
                        "index": 10,
                        "command": "open-chat",
                        "caption": "צ\"אט עם נציג",
                        "icon": "ico-chat",
                        "url": "https://chat.cal-online.co.il/chattest/iwchat.aspx",
                        "restricted": false,
                        "sso": false,
                        "dependency": null,
                        "state": "https://chat.cal-online.co.il/chattest/iwchat.aspx",
                        "hide": false,
                        "googleAnalyticsKey": null,
                        "devices": null
                    };
                    console.log("goToChat");
                    lobbyUiService.navigate("https://chat.cal-online.co.il/chattest/iwchat.aspx", options);
                };
            }
        }
    }
})(window, window.angular);
﻿(function () {
    'use strict'
    bankAccountDropDownController.$inject = [
        'connection', 'appData', '$scope', 'lobbyUiService'
    ];
    function bankAccountDropDownController(connection, appData, $scope, lobbyUiService) {

        var vmBankAccountDropDown = this;

        vmBankAccountDropDown.showRadioDiv = false;

        vmBankAccountDropDown.Radio = "content/images/cal2020/radio-empty.svg";

        vmBankAccountDropDown.RadioDot = "content/images/cal2020/radio-selected.svg";

        vmBankAccountDropDown.displayImage = "";

        if (vmBankAccountDropDown.bankAccounts != undefined && vmBankAccountDropDown.bankAccounts.length == 1) {
            vmBankAccountDropDown.displayImage = "only-one-account";
        }

        vmBankAccountDropDown.mainDivPressed = function () {
            if (vmBankAccountDropDown.bankAccounts.length > 1) {
                vmBankAccountDropDown.showRadioDiv = !vmBankAccountDropDown.showRadioDiv;
            }
        }

        vmBankAccountDropDown.onLabelClick = function (account) {
            console.log("vmBankAccountDropDown.onLabelClick");
            vmBankAccountDropDown.gridOnClick({ account: account });
            vmBankAccountDropDown.selectedBankAccount = account;
            account.Radio = vmBankAccountDropDown.RadioDot;
            vmBankAccountDropDown.showRadioDiv = false;
        }

        vmBankAccountDropDown.toggleCircle = function (account) {
            if (vmBankAccountDropDown.selectedBankAccount) {
                if (account != vmBankAccountDropDown.selectedBankAccount) {
                    account.Radio = vmBankAccountDropDown.Radio;
                }
                else {
                    account.Radio = vmBankAccountDropDown.RadioDot;
                }
            }
            return account.Radio;
        }
    }

    angular.module('digitalWallet')
        .directive('bankAccountDropDown', function () {
            return {
                restrict: 'E',
                controllerAs: 'vmBankAccountDropDown',
                controller: bankAccountDropDownController,
                bindToController: true,
                transclude: true,
                scope: {
                    bankAccounts: '=',
                    showRadioDiv: '=',
                    gridOnClick: '&',
                    selectedBankAccount: '=',
                },
                link: function (scope, element, attrs, controllers) {

                },
                templateUrl: 'app/shared/bank-account.drop-down.component/bank-account.drop-down.component.html',
            };
        });
})(window, window.angular);
﻿(function () {
    'use strict'
    foreignCardInputController.$inject = [
        'connection', 'appData', '$scope', 'lobbyUiService', '$sce'
    ];
    function foreignCardInputController(connection, appData, $scope, lobbyUiService, $sce) {
        var vmforeignCardInput = this;
        vmforeignCardInput.input = "";
        var noOpacityClass = "foreign-card-error-no-opacity"
        var opacityClass = "foreign-card-error-opacity"
        vmforeignCardInput.opacity = noOpacityClass;        
        var generalError = "יש שגיאה במספר הכרטיס, כדאי לבדוק ולנסות שוב";
        vmforeignCardInput.CardError = generalError;

        function sumDigits(p_tosum) {
            //Max 18
            if (p_tosum / 10 < 1)
                return p_tosum;
            else
                return parseInt(p_tosum.toString().charAt(0)) + parseInt(p_tosum.toString().charAt(1));
        }

        function checkIfDigit(p_d) {
            if (p_d < 10 && p_d > -1)
                return true;
            else
                return false;
        }

        function check_card(p_cardNum) {
            if (p_cardNum.length == 8 || p_cardNum.length == 9) //IsraCard
            {
                var module = 11;
                var mishkolet = 1;
                var sum = 0;
                for (var i = p_cardNum.length - 1; i > -1; i--) {
                    if (checkIfDigit(p_cardNum.charAt(i)))
                        sum = (p_cardNum.charAt(i) * mishkolet++) + sum;
                    else
                        return false;
                }
                if ((sum % module) == 0)
                    return true;
                else
                    return false;
            }

            else if (p_cardNum.length < 20) //other cards
            {
                var module = 10;
                var mishkolet = 1;
                var sum = 0;
                for (var i = p_cardNum.length - 1; i > -1; i--) {
                    if (checkIfDigit(p_cardNum.charAt(i)))
                        sum = (sumDigits(p_cardNum.charAt(i) * mishkolet)) + sum;
                    else
                        return false;
                    //fix mishkolet
                    if (mishkolet == 2)
                        mishkolet = 1;
                    else
                        mishkolet++;
                }
                if ((sum % module) == 0)
                    return true;
                else
                    return false;

            }
            else //less then 8 and more then 20 not legit card
                return false;
        }

        vmforeignCardInput.checkValidCard = function (card_number) {
            return check_card(card_number);
        }

        vmforeignCardInput.onChange = function () {
            vmforeignCardInput.foreignCardInputValue = vmforeignCardInput.input;
            vmforeignCardInput.onChangeCallback();

            if (vmforeignCardInput.input != undefined) {
                var checkInput = vmforeignCardInput.input.replace(new RegExp("-", 'g'), "");

                if (checkInput.length > 4 && checkInput.length < 14) {
                    checkInput = vmforeignCardInput.input.match(new RegExp('.{1,4}', 'g')).join('-');
                    vmforeignCardInput.input = checkInput;
                    return;
                }
                if (checkInput.length == 14) {
                    checkInput = [vmforeignCardInput.input.slice(0, 4), '-', vmforeignCardInput.input.slice(4, 10), '-', vmforeignCardInput.input.slice(10)].join('');
                    vmforeignCardInput.input = checkInput;
                    return;
                }
                if (checkInput.length == 15) {
                    checkInput = [vmforeignCardInput.input.slice(0, 4), '-', vmforeignCardInput.input.slice(4, 10), '-', vmforeignCardInput.input.slice(10)].join('');
                    vmforeignCardInput.input = checkInput;
                    return;
                }
                if (checkInput.length == 16) {
                    checkInput = vmforeignCardInput.input.match(new RegExp('.{1,4}', 'g')).join('-');
                    vmforeignCardInput.input = checkInput;
                    return;
                }
                if (checkInput.length == 19 && checkInput.indexOf("62") == 0) {
                    checkInput = [vmforeignCardInput.input.slice(0, 6), '-', vmforeignCardInput.input.slice(6)].join('');
                    vmforeignCardInput.input = checkInput;
                    return;
                }
                if (checkInput.length > 16) {                    
                    checkInput = vmforeignCardInput.input.match(new RegExp('.{1,4}', 'g')).join('-');
                    vmforeignCardInput.input = checkInput;
                    return;
                }

            }
        }

        vmforeignCardInput.onBlur = function () {
            console.log("onBlur");
            var isCard = vmforeignCardInput.CheckCard(vmforeignCardInput.input);
            vmforeignCardInput.foreignCardIsCard = isCard;
            vmforeignCardInput.cardError = generalError;
            vmforeignCardInput.foreignCardOnBlur();
        }

        vmforeignCardInput.sanitizeMe = function (text) {
            return $sce.trustAsHtml(text);
        }


    }

    angular.module('digitalWallet')
        .directive('foreignCardInput', function () {
            return {
                restrict: 'E',
                controllerAs: 'vmforeignCardInput',
                controller: foreignCardInputController,
                bindToController: true,
                transclude: true,
                scope: {
                    foreignCardInputValue: '=foreignCardInputValue',
                    foreignCardIsCard: '=foreignCardIsCard',
                    foreignCardWatch: '=foreignCardWatch',
                    foreignCardOnBlur: '&foreignCardOnBlur',
                    CheckCard: '&checkCard',
                    onChangeCallback: '&onChangeCallback',
                    cardError: '=cardError',
                },
                templateUrl: 'app/shared/foreign-card-input.component/foreign-card-input.component.html'
            };
        });
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('chatNavigationService', chatNavigationService);

    chatNavigationService.$inject = ['lobbyUiService', 'lobbyCommService', 'appSettings'];

    function chatNavigationService(lobbyUiService, lobbyCommService, appSettings) {
        var pageUrl = '';
        var options = {
            "abandonBehavior": false,
            "type": "3",
            "id": 69,
            "index": 10,
            "command": "open-chat",
            "caption": "צ\"אט עם נציג",
            "icon": "ico-chat",
            "url": appSettings.chatUrl,
            "restricted": false,
            "sso": false,
            "dependency": null,
            "state": appSettings.chatUrl,
            "hide": false,
            "googleAnalyticsKey": null,
            "devices": null
        };

        return {
            navigate: function () {
                lobbyUiService.navigate(appSettings.chatUrl, options);
            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('whatsAppNavigationService', whatsAppNavigationService);

    whatsAppNavigationService.$inject = ['appSettings', 'lobbyUiService', 'connection'];

    function whatsAppNavigationService(appSettings, lobbyUiService, connection) {      
        return {
            navigate: function () {

                if (connection.isLoggedIn()) {
                    connection.identificationServiceRequest().then(function () { }, function () { });
                }
                lobbyUiService.openExternal(appSettings.whatsappLink, null, true);
                //location.href = appSettings.whatsappLink;
            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('leadNavigationService', leadNavigationService);

    leadNavigationService.$inject = ['lobbyUiService', 'chatNavigationService', 'whatsAppNavigationService', 'appData'];

    function leadNavigationService(lobbyUiService, chatNavigationService, whatsAppNavigationService, appData) {
        var navigationService;

        return {
            navigate: function () {
                if (!navigationService) {
                    if (appData.metaData.IsCustomerServiceLead) {
                        navigationService = chatNavigationService;
                    }
                    else if (appData.metaData.IsCustomerServiceLeadByWhatsApp) {
                        navigationService = whatsAppNavigationService;
                    }
                }

                navigationService && navigationService.navigate();
            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';

    angular.module('paymentSpread', [])
    .run(function(){});
})(window, window.angular);
﻿  (function (window, angular) {
      'use strict';
      angular.module('paymentSpread').config(paymentSpreardRoute);
      paymentSpreardRoute.$inject = ['$stateProvider'];
      function paymentSpreardRoute($stateProvider) {
          $stateProvider
          .state('dw.paymentSpreadWelcome',
          {
              url: "/paymentSpread/welcome",
              cache: false,
              views: {
                  'contentBody': {
                      templateUrl: "app/paymentSpread/welcome/paymentSpreadWelcome.html",
                      controller: "paymentSpreadWelcomeCtrl as vm"
                  }
              }
          })
          .state('dw.paymentSpreadBenefitsAndCards',
          {
              url: "/paymentSpread/benefitAndCards",
              cache: false,
              views: {
                  'contentBody': {
                      templateUrl: "app/paymentSpread/benefitsAndCards/benefitAndCards.html",
                      controller: "paymentSpreadBenefitAndCardsCtrl as vm"
                  }
              }
          })
          .state('dw.paymentSpreadSummary',
          {
              url: "/paymentSpread/summary",
              cache: false,
              views: {
                  'contentBody': {
                      templateUrl: "app/paymentSpread/summary/paymentSpreadSummary.html",
                      controller: "paymentSpreadSummaryCtrl as vm"
                  }
              }
          })

      }

  })(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('paymentSpread')
    .factory('paymentSpreadService', paymentSpreadService);

    paymentSpreadService.$inject = ['$q', 'connection', '$rootScope', 'lobbyUiService', 'errorService', '$timeout', 'csPopupService', '$state', 'googleAnalyticsService']

    function paymentSpreadService($q, connection, $rootScope, lobbyUiService, errorService, $timeout, csPopupService, $state, googleAnalyticsService) {


        var isSkipClear = false;
        var service = {
            title: "3 תשלומים ללא ריבית",
            key: 'paymentSpreadData',
            cardArr: [],
            cardFailedsArr: [],
            rangeJoin: {},
            benefitSpreadBelonging: [],
            belongSDate: '',
            name: '',
            isUpdate: false,
            benefitSpreadBelongingArr:
            [
               { id: "308", title: "משיכת מזומן בחו\"ל", desc: "כל משיכת מזומן בחו\"ל תיפרס ל-3 תשלומים ללא ריבית" },
                { id: "309", title: "קניות באינטרנט", desc: "כל רכישה שתבוצע באתרי אינטרנט בינלאומיים תיפרס ל-3 תשלומים ללא ריבית" },

                { id: "310", title: "קניות בחו\"ל", desc: "כל קנייה בחו\"ל תיפרס ל-3 תשלומים ללא ריבית" }

            ],
            getValidForPaymentSpread: function () {
                var that = this;
                var deferred = $q.defer();
                lobbyUiService.loader.show();
                connection.GetValidForPaymentSpread().then(function (data) {
                    var res = data.Response.Status;
                    if (res.Succeeded && data.ValidCards.length > 0) {

                        var resObj = {};
                        //update service
                        resObj.cardArr = that.cardArr = data.ValidCards;
                        resObj.rangeJoin = that.rangeJoin = data.RangeJoin;
                        resObj.belongSDate = that.belongSDate = data.BelongSDate;
                        resObj.benefitSpreadBelonging = that.benefitText(data.BenefitSpreadBelonging);
                        resObj.isUpdate = service.isUpdate;


                        deferred.resolve(resObj);
                    }
                    else {
                    
                        deferred.reject(data);
                    }

                    

                }
                , function (error) {
                    
                    deferred.reject(error);

                }).finally(function () {
                    lobbyUiService.loader.hide();
                });
                
                return deferred.promise;
            },
            upDateRemoveBelongingForCards: function (req) {
                var deffered = $q.defer();
                lobbyUiService.loader.show();
                connection.UpDateRemoveBelongingForCards(req).then(function (response) {
                    var res = response.Response.Status.SeverityCode.toLowerCase();
                    if (res === "s" || res === "i") {
                        service.benefitSpreadBelonging = req.BenefitSpreadBelonging;
                        service.cardFailedsArr = response.attachedCards;
                        deffered.resolve(res);
                    }
                    else {

                        deferred.reject(res);

                    }

                }, function (error) {
                    deffered.reject(error);

                });
                
                return deffered.promise;
            },
                
    
    isLogin: function (state) {
        if (!lobbyUiService.connection.isLoggedIn()) {
            lobbyUiService.go('dw.login', { nextPage: state });
            return false;
        }

        return true;
    },                                                        

            //Asked To Change To Full Name Because a bug that first name give title like Engineer.
    getName: function () {
        if (sessionStorage.getItem("appData") && sessionStorage.getItem("appData") != "" && sessionStorage.getItem("appData").length > 0) {
            var appData = JSON.parse(sessionStorage.getItem("appData"));
            var firstName = (appData.CustomerInfo.FirstName) ? appData.CustomerInfo.FirstName : "";
            var lastName = (appData.CustomerInfo.LastName) ? appData.CustomerInfo.LastName : "";
            service.name = firstName + " " + lastName;
            return service.name;
            
        }
        else {
            return "";
        }
    },
    benefitText: function (arr) {
        if (arr && arr.length > 0) {
            service.isUpdate = false;
            service.benefitSpreadBelonging = [];
            for (var i = 0; i < arr.length; i++) {
                if (service.isUpdate == false && arr[i].IsActive && arr[i].IsActive == true) {
                    service.isUpdate = true;

                }
                var res = _.filter(service.benefitSpreadBelongingArr, { 'id': arr[i].BelongID });
                arr[i].BelongName = res[0].title;
                arr[i].BelongDesc = res[0].desc;
                service.benefitSpreadBelonging.push(arr[i]);

            }
            return service.benefitSpreadBelonging;
        }
    },

    removeClearFlag: function () {
        isSkipClear = false;
    },

    clearData: function () {
        if (!isSkipClear) {
            service.cardArr = [];
            service.cardFailedsArr = [];
            service.rangeJoin = {};
            service.benefitSpreadBelonging =  [];
            service.isUpdate = false;
        }
    },

    goToBenefitsAndCards: function () {
        isSkipClear = true;
        $state.go('dw.paymentSpreadBenefitsAndCards');
    },
    goToSummary: function () {
        isSkipClear = true;
        $state.go('dw.paymentSpreadSummary');
    },
    //PopUps
    showErrorPopUp: function () {
        var popup = {};
        popup.template = 'app/paymentSpread/templates/paymentSpreadErrorPopUp.html'
        popup.btns = [];
        popup.btns.push(
                               {
                                   text: "סגור",
                                   type: 'button-positive',
                                   onTap: function () {



                                   }
                               });
        lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, false);
    },
    
    rangeExpiredPopUp: function () {
        var popup = {};
        popup.template = 'app/paymentSpread/templates/paymentSpreadRangeExpiredPopUp.html';
        popup.btns = [];
        popup.btns.push(
                           {
                               text: "חזרה למסך ראשי",
                               type: 'button-positive',
                               onTap: function () {
                                   lobbyUiService.go('dw.lobby', {});
                               }
                           });


        lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, false);
    },
    noCardsPopUp: function () {
        var popup = {};
        popup.template = 'app/paymentSpread/templates/paymentSpreadNoCardsPopUp.html';
        popup.btns = [];
        popup.btns.push(
                           {
                               text: "חזרה למסך ראשי",
                               type: 'button-positive font-style3',
                               onTap: function () {
                                   lobbyUiService.go('dw.lobby', {});
                               }
                           });


        lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, false);
    },
    errorPopup : function (msg) {
        var msgErr = '<div class="font-style3 ">' + msg
                            '</div>';
        var popup = {};
        popup.btns = [];
        popup.btns.push(
                           {
                               text: "סגור",
                               type: 'button-positive',
                               onTap: function () {
                                   
                               }
                           });

        lobbyUiService.popup.alert(msgErr, "", null, null, popup.btns, true, "payment-spread-popup");
    },
    getLatestDate : function (date1,date2)
    {
       var date2Moment = moment(date2, "DD/MM/YYYY");
       var date1Moment = moment(date1, "DD/MM/YYYY");
       if (date1Moment > date2Moment)
        {
            return date1;

        }
        else
        {
            return date2;
        }
        
    },

    getCurrentDate : function()
    {
        var today= new Date();
        var dd= today.getDate();
        var mm= today.getMonth() + 1;
        var yyyy= today.getFullYear();

        if(dd<10)
        {
            dd= '0'+dd;
        }

        if(mm<10)
        {
            mm='0'+mm;
        }
        var currentDate = dd + '/' + mm + '/' + yyyy;
        return currentDate
    }


    
        }
        return service;
    }



})(window, window.angular);
﻿(function () {
    'use strict';

    angular
        .module('paymentSpread')
        .controller('paymentSpreadWelcomeCtrl', paymentSpreadWelcomeCtrl);

    paymentSpreadWelcomeCtrl.$inject = [
        'connection', 'lobbyUiService', '$scope', '$location', '$ionicScrollDelegate', '$q', 'paymentSpreadService', '$state', 'errorService', '$stateParams', 'commService'
    ];

    function paymentSpreadWelcomeCtrl(connection, lobbyUiService, $scope, $location, $ionicScrollDelegate, $q, paymentSpreadService, $state, errorService, $stateParams, commService) {

        var vm = this;
        console.log("paymentSpreadWelcomeGao");

        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();

        vm.CardArr = [];
        vm.RangeJoin = {};
        vm.BenefitSpreadBelonging = [];
        vm.BelongSDate = "";
        vm.name = "";
        vm.isUpdate;
        vm.title = paymentSpreadService.title;
        if (paymentSpreadService.isLogin('dw.paymentSpreadWelcome')) {
            vm.name = paymentSpreadService.getName();
            paymentSpreadService.getValidForPaymentSpread().then(function (data) {
                vm.CardArr = data.cardArr;
                vm.RangeJoin = data.rangeJoin;
                vm.BelongSDate = data.belongSDate;
                vm.BenefitSpreadBelonging = data.benefitSpreadBelonging;
                vm.isUpdate = data.isUpdate;
                if (!vm.isUpdate) {
                    ga('send', 'pageview', '/vp/transaction-layout/step1/join/');
                }
                else {
                    ga('send', 'pageview', '/vp/transaction-layout-update/step1/welcome/');
                }

            }
                 , function (err) {
                     errorService.handleError(err, null, "payment-spread-popup");
                 });


        }

        $scope.$on("$destroy", function (event) {

            paymentSpreadService.clearData();
        });

        vm.goToBenefitsAndCards = function () {
            paymentSpreadService.goToBenefitsAndCards();
        }


        vm.showRemovePopUp = function () {
            var popup = {
            };
            popup.template = 'app/paymentSpread/templates/paymentSpreadRemovePopUp.html';
            popup.btns = [];
            popup.btns.push(
                {
                    text: "כן, תודה",
                    type: 'button-positive font-style3',
                    onTap: function () {

                        vm.removeAllBenefitsAndCards(paymentSpreadService.upDateRemoveBelongingForCards)



                    }
                });
            popup.btns.push(
                               {
                                   text: "בעצם לא",
                                   type: 'button-grey font-style3',
                                   onTap: function () {

                                   }
                               });

    
            lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, false);
            ga('send', 'pageview', '/vp/transaction-layout-update/step-4/remove-service-popup');
        }

        vm.showErrorPopUp = function () {
            paymentSpreadService.showErrorPopUp();
        }
        vm.rangeExpiredPopUp = function () {
            paymentSpreadService.rangeExpiredPopUp();
        }
        vm.noCardsPopUp = function () {
            paymentSpreadService.noCardsPopUp();
        }
        vm.popUpSuccessRemove = function () {
            var successRemove = '<div class="font-style3 ">' +
                                'המבצע הוסר בהצלחה מכל הכרטיסים. <br />' +
                                'מעתה, ההוצאות יחויבו בהתאם לתנאי הכרטיס.' +
                                 '</div>' +
                                '<div class="font-style3 ">' +
                                'חשוב לדעת - כל ההוצאות מיום ההצטרפות ועד עכשיו  <br />' +
                                'נפרסו ל-3 תשלומים ללא ריבית בהתאם לבקשתך.' +
                                '<br />' +
                                '</div>' +
                                '<div class="font-style3 ">' +
                                'באפשרותך להצטרף שוב בתקופת המבצע.' +
                                '</div>' +
                                '</div>';
            var popup = {
            };
            popup.btns = [];
            popup.btns.push(
                               {
                                   text: "חזרה לדף הבית",
                                   type: 'button-positive font-style3',
                                   onTap: function () {
                                       vm.backToHomePage();
                                   }
                               });

            lobbyUiService.popup.alert(successRemove, "", null, null, popup.btns, true);
            ga('send', 'pageview', '/vp/transaction-layout-update/step-5/popup-remove-success/');
        }

        vm.backToHomePage = function () {
            commService.backToHomePage();
        };

        vm.popupErrorRemove = function (arr) {
            var errorRemove = '<div class="msg-wrapper font-style3" style="color:red;">' + vm.name + ',' +
                                 ' לצערנו לא הצלחנו להסיר מהמבצע את הכרטיסים שמסתיימים ב- ' + arr.join(', ') +
                                 '.</div>' +
                                 '<div class="msg-wrapper font-style3 ">' +
                                 'יתר הכרטיסים הוסרו מהמבצע בהצלחה. מעתה, ההוצאות בכרטיסים אלו יחויבו בהתאם לתנאי הכרטיס.' +
                                 '</div>' +
                                 '<div class="msg-wrapper font-style3 ">' +
                                 'חשוב לדעת - כל ההוצאות מיום ההצטרפות ועד עכשיו  <br />' +
                                 'נפרסו ל-3 תשלומים ללא ריבית בהתאם לבקשתך.' +
                                 '<br />' +
                                 '</div>' +
                                 '</div>';
            var popup = {
            };
            popup.btns = [];
            popup.btns.push(
                               {
                                   text: "חזרה למסך ראשי",
                                   type: 'button-positive font-style3',
                                   onTap: function () {
                                       lobbyUiService.go('dw.lobby', {
                                       });
                                   }
                               });

            lobbyUiService.popup.alert(errorRemove, "", null, null, popup.btns, true);
            ga('send', 'pageview', '/vp/transaction-layout-update/step-5/popup-remove-success/');
        }
        vm.removeAllBenefitsAndCards = function (callback) {
            vm.CardArr.forEach(function (card) {
                card.IsBenefit = false;
            });
            vm.BenefitSpreadBelonging.forEach(function (ben) {
                ben.IsActive = false;
            });
            var req = {
            };
            req.CardArr = vm.CardArr;
            req.BenefitSpreadBelonging = vm.BenefitSpreadBelonging;
            callback(req).then(function (data) {
                paymentSpreadService.getValidForPaymentSpread().then(function (response) {
                    vm.CardArr = response.cardArr;
                    vm.RangeJoin = response.rangeJoin;
                    vm.BelongSDate = response.belongSDate;
                    vm.BenefitSpreadBelonging = response.benefitSpreadBelonging;
                    vm.isUpdate = response.isUpdate;
                    var cardRemovedFailed = [];
                    vm.CardArr.forEach(function (card) {
                        if (card.IsBenefit) {
                            cardRemovedFailed.push(card.Card4LastDig);
                        }
                    });

                    if (cardRemovedFailed && cardRemovedFailed.length > 0) {
                        vm.popupErrorRemove(cardRemovedFailed);
                    }
                    else {
                        vm.popUpSuccessRemove();
                    }
                }
                    , function (err) {
                        errorService.handleError(err, null, "payment-spread-popup");
                    });
            }
            , function (err) {
                errorService.handleError(err, null, "payment-spread-popup");
            });
        }
        vm.setWindowHeight = function () {

            var pageHeight = angular.element(".view-container")[0].offsetHeight;
            var smallBtn = angular.element(".small-button")[0];
            if (smallBtn) {
                var buttonHeight = smallBtn.offsetHeight;
                var contentHeight = parseInt(pageHeight - buttonHeight);
                if (parseInt(contentHeight) < 528)
                    contentHeight = 528;
                angular.element(".scroll").css('min-height', contentHeight + "px");
            }
            else {
                var contentHeight = parseInt(screen.height - 32);
                if (parseInt(contentHeight) < 528)
                    contentHeight = 528;
                angular.element(".scroll").css('min-height', screen.height - 32 + "px");
            }

        }

        angular.element(document).ready(function () {

            vm.setWindowHeight();

        });

        $scope.standalone = $stateParams.standalone


        if ($scope.standalone) {
            $('#page-wrapper').addClass('standaloneBackBtn');
        }

    }

})();


﻿(function () {
    'use strict';

    angular
        .module('paymentSpread')
        .controller('paymentSpreadBenefitAndCardsCtrl', paymentSpreadBenefitAndCardsCtrl);

    paymentSpreadBenefitAndCardsCtrl.$inject = [
       'commService','connection', 'lobbyUiService', '$scope', '$location', '$ionicScrollDelegate', '$q', 'paymentSpreadService', '$state', '$timeout', 'errorService'
    ];

    function paymentSpreadBenefitAndCardsCtrl(commService,connection, lobbyUiService, $scope, $location, $ionicScrollDelegate, $q, paymentSpreadService, $state, $timeout, errorService) {

        var vm = this;
        vm.title = paymentSpreadService.title;
        vm.name = paymentSpreadService.getName();
        vm.isEdited = false;
        $scope.$on('$ionicView.afterEnter', function (e, viewData) {
            $timeout(function () {
                paymentSpreadService.removeClearFlag();
            });

        }),

        $scope.$on("$destroy", function (event) {

            paymentSpreadService.clearData();
        });

        vm.hideNavBar;


        function inIframe() {
            try {

                $timeout(function () {
                    var realHeight = document.getElementById("realHeightBenefitAndCards").scrollHeight;
                    commService.sendHeight(realHeight);
                }, 100)

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();


        if ((paymentSpreadService.cardArr && paymentSpreadService.cardArr.length < 1) || (paymentSpreadService.benefitSpreadBelonging && paymentSpreadService.benefitSpreadBelonging.length < 1)) {
            if (paymentSpreadService.isLogin('dw.paymentSpreadBenefitsAndCards')) {
                paymentSpreadService.getValidForPaymentSpread().then(function (data) {
                    console.log("does Happen");
                    vm.CardArr = data.cardArr;
                    vm.RangeJoin = data.rangeJoin;
                    vm.BelongSDate = data.belongSDate;
                    vm.BenefitSpreadBelonging = data.benefitSpreadBelonging;
                    vm.isUpdate = data.isUpdate;
                    vm.startBenefit = paymentSpreadService.getLatestDate(vm.RangeJoin.StratTimeForBenefit, paymentSpreadService.getCurrentDate());
                    if (!vm.isUpdate) {
                        ga('send', 'pageview', '/vp/transaction-layout/step2/options/');
                    }
                    else {
                        ga('send', 'pageview', '/vp/transaction-layout-update/step2/options/');
                    }

                    $timeout(function () {
                        var realHeight = document.getElementById("realHeightBenefitAndCards").scrollHeight;
                        commService.sendHeight(realHeight+250);
                    },500)
                   

                }
                     , function (err) {
                         errorService.handleError(err, null, "payment-spread-popup");
                     });



            }
        }
        else {
            vm.isUpdate = paymentSpreadService.isUpdate;
            vm.CardArr = paymentSpreadService.cardArr;
            vm.RangeJoin = paymentSpreadService.rangeJoin;
            vm.BelongSDate = paymentSpreadService.belongSDate;
            vm.BenefitSpreadBelonging = paymentSpreadService.benefitSpreadBelonging;
            vm.todayDate = paymentSpreadService.getCurrentDate();
            
        }
        vm.moreInfo = function () {
            vm.showInfo = !vm.showInfo;
            if (vm.showInfo) {
                lobbyUiService.loader.show();
                document.querySelector("a.showInfo").innerHTML = 'הבנתי, תודה<img src="content/images/up_arr.svg" alt="הבנתי, תודה" /></a>';
                $timeout(function () {
                    lobbyUiService.loader.hide();
                    var realHeight = document.getElementById("realHeightBenefitAndCards").scrollHeight;
                    commService.sendHeight(realHeight+250);
                }, 500);

            }
            else {
                lobbyUiService.loader.show();
                document.querySelector("a.showInfo").innerHTML = 'מידע נוסף<img src="content/images/down_arr.svg" alt="מידע נוסף" /></a>';
                vm.setAnchor("smallLettersScroll");
                $timeout(function () {
                    lobbyUiService.loader.hide();
                    var realHeight = document.getElementById("realHeightBenefitAndCards").scrollHeight;
                    commService.sendHeight(realHeight+250);
                }, 500);
            }

        }

        vm.isActive = function (benefit) {
            if (benefit.IsActive)
                benefit.IsActive = false;
            else
                benefit.IsActive = true;
        };

        vm.isBenefit = function (card) {
            if (card.IsBenefit)
                card.IsBenefit = false;
            else
                card.IsBenefit = true;
        };

        vm.getValidForPaymentSpread = function () {
            console.log("idontthinkThisHappens;");
            //Save isUpdate because after get isUpdate always true;
            var isUpdateBeforeGet = vm.isUpdate;
            paymentSpreadService.getValidForPaymentSpread().then(function (data) {
                paymentSpreadService.isUpdate = isUpdateBeforeGet;
                $state.go('dw.paymentSpreadSummary');
            }, function (err) {
                errorService.handleError(err, null, "payment-spread-popup");
            });

        }

        vm.upDateRemoveBelongingForCards = function () {
            if (!vm.isUpdate || vm.isEdited) {
                if (vm.validateBeforeSave()) {
                    var req = {};
                    req.CardArr = vm.CardArr;
                    req.BenefitSpreadBelonging = vm.BenefitSpreadBelonging;
                    paymentSpreadService.upDateRemoveBelongingForCards(req).then(function (data) {

                        vm.getValidForPaymentSpread();
                    }, function (err) {
                        errorService.handleError(err, null, "payment-spread-popup");
                    }).finally(function () {
                        lobbyUiService.loader.hide();
                    });
                }
                else {
                    if (!vm.benefitValid) {
                        vm.setAnchor("benefitValid");
                    }
                    else {
                        vm.setAnchor("cardValid");
                    }
                }
            }
            else
            {
                vm.noChangesPopup();
            }

        };

        vm.validateBeforeSave = function () {
            vm.benefitValid = false;
            vm.cardValid = false;
            for (var i = 0; i < vm.CardArr.length; i++) {
                if (vm.CardArr[i].IsBenefit && vm.CardArr[i].IsBenefit == true) {
                    vm.cardValid = true;
                    break;
                }
            }
            for (var i = 0; i < vm.BenefitSpreadBelonging.length; i++) {
                if (vm.BenefitSpreadBelonging[i].IsActive && vm.BenefitSpreadBelonging[i].IsActive == true) {
                    vm.benefitValid = true;
                    break;
                }
            }

            if (vm.benefitValid == true && vm.cardValid == true) {
                return true;
            }
            else {

                return false;
            }

        }
        vm.setAnchor = function (id) {

            $location.hash(id);
            $ionicScrollDelegate.anchorScroll();
        }

        vm.clearAnchor = function () {

            $location.hash("");
            $ionicScrollDelegate.anchorScroll();
        }
        vm.showErrorPopUp = function () {
            paymentSpreadService.showErrorPopUp();
        }
        vm.rangeExpiredPopUp = function () {
            paymentSpreadService.rangeExpiredPopUp();
        }
        vm.noCardsPopUp = function () {
            paymentSpreadService.noCardsPopUp();
        }
        vm.noChangesPopup = function () {
            var popup = {};
            popup.template = 'app/paymentSpread/templates/paymentSpreadNoChanges.html'
            popup.btns = [];
            popup.btns.push(
                                   {
                                       text: "סגור",
                                       type: 'button-positive',
                                       onTap: function () {
                                       }
                                   });
            lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, false);
        }
        vm.setWindowHeight = function () {
            var pageHeight = angular.element(".scroll-design")[0].offsetHeight;
            var smallBtn = angular.element(".green-button")[0];
            if (smallBtn) {
                var buttonHeight = smallBtn.offsetHeight;
                var contentHeight = parseInt(pageHeight - buttonHeight);
                angular.element(".scroll").css('min-height', contentHeight + "px");
            }
            else {
                angular.element(".scroll").css('min-height', screen.height - 32 + "px");
            }

        }

        vm.editCheckBox = function () {
            if (!vm.isEdited) {
                vm.isEdited = true;
            }
        }

        angular.element(document).ready(function () {

            vm.setWindowHeight();
        });

    }
})();
﻿(function () {
    'use strict';

    angular
        .module('paymentSpread')
        .controller('paymentSpreadSummaryCtrl', paymentSpreadSummaryCtrl);

    paymentSpreadSummaryCtrl.$inject = [
       'commService','connection', 'lobbyUiService', '$scope', '$location', '$ionicScrollDelegate', '$q', 'paymentSpreadService', '$state', '$timeout'
    ];

    function paymentSpreadSummaryCtrl(commService,connection, lobbyUiService, $scope, $location, $ionicScrollDelegate, $q, paymentSpreadService, $state, $timeout) {

        var vm = this;
        vm.cardFailedsArr = paymentSpreadService.cardFailedsArr;
        vm.name = paymentSpreadService.getName();
        vm.title = paymentSpreadService.title;
        vm.isUpdate = paymentSpreadService.isUpdate;
        vm.CardArr = paymentSpreadService.cardArr;
        vm.RangeJoin = paymentSpreadService.rangeJoin;
        vm.BenefitSpreadBelonging = paymentSpreadService.benefitSpreadBelonging;
        vm.startBenefit = paymentSpreadService.getCurrentDate();
         
        $('body').addClass('finish');
        parent.postMessage({ call: "dwProcessEnd" }, '*');
        vm.hideNavBar;
        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();


        $scope.$on('$ionicView.afterEnter', function (e, viewData) {
            $timeout(function () {
                paymentSpreadService.removeClearFlag();
            });

        });

        $scope.$on("$destroy", function (event) {
            paymentSpreadService.clearData();
        });

        vm.goToLobby = function () {
            commService.backToHomePage();
        }
        vm.showErrorPopUp = function () {
            paymentSpreadService.showErrorPopUp();
        }
        vm.rangeExpiredPopUp = function () {
            paymentSpreadService.rangeExpiredPopUp();
        }
        vm.noCardsPopUp = function () {
            paymentSpreadService.noCardsPopUp();
        }

        vm.cardsError = function () {
            for (var i; i < vm.cardFailedsArr.length; i++) {
                //if (!vm.cardFailedsArr[i].IsBenefit)
                // {
                vm.showErrCard.push(vm.cardFailedsArr[i].Card4LastDig)

                //}
            }
        }


        vm.setHeight = function () {
            var realHeight = document.getElementById("realHeight3PaymentsHul").scrollHeight;
            //console.log("RealHeight", realHeight);
            realHeight = realHeight + 150;
            if (realHeight + 80 < 500) realHeight = 1000;
            console.log("realHeihgt", realHeight);
            commService.sendHeight(realHeight);
        }


        vm.cardsError();
        vm.setWindowHeight = function () {
            var pageHeight = angular.element(".scroll-design")[0].offsetHeight;
            var smallBtn = angular.element(".green-button")[0];
            if (smallBtn) {
                var buttonHeight = smallBtn.offsetHeight;
                var contentHeight = parseInt(pageHeight - buttonHeight);
                angular.element(".scroll").css('min-height', contentHeight + "px");
            }
            else {
                angular.element(".scroll").css('min-height', screen.height - 32 + "px");
            }

        }

        vm.sendGa = function () {
            var onlineShopping = false;
            var abroadShopping = false;
            var cashWithdrawl = false;

            vm.BenefitSpreadBelonging.forEach(function (ben) {
                if (ben.IsActive) {
                    if (ben.BelongID == "308") {
                        cashWithdrawl = true;
                    }
                    if (ben.BelongID == "309") {
                        onlineShopping = true;
                    }
                    else {
                        abroadShopping = true;
                    }
                }

            });

            if (!vm.isUpdate) {
                ga('send', 'pageview', '/vp/transaction-layout/step3/thank-you/?online-shopping=' + onlineShopping + '&abroad-shopping=' + abroadShopping + '&cash-withdrawl=' + cashWithdrawl);
            }
            else {
                ga('send', 'pageview', '/vp/transaction-layout-update/step3/thank-you/?online-shopping=' + onlineShopping + '&abroad-shopping=' + abroadShopping + '&cash-withdrawl=' + cashWithdrawl);
            }

        }
        vm.sendGa();
        angular.element(document).ready(function () {
            vm.setHeight();
           // vm.setWindowHeight();
        })

    }



})();
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U', []);
})(window, window.angular);

﻿(function(window, angular) {
  "use strict";

  angular.module("Cal4U").config(accountRoute);

  accountRoute.$inject = ["$stateProvider"];

  function accountRoute($stateProvider) {
    $stateProvider
      .state("dw.wantLoan", {
        url: "/account/wantLoan",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/wantLoan.html",
            controller: "wantLoanController"
          }
        }
      })
      .state("dw.myaccount", {
        url: "/account/myaccount",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/myaccount.html",
            controller: "myAccountController"
          }
        }
      })
      .state("dw.mychat", {
        url: "/account/mychat",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/mychat.html",
            controller: "myChatController"
          }
        }
      })
      .state("dw.pieSummary", {
        url: "/account/pieSummary",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/pieSummary.html",
            controller: "pieSummaryController"
          }
        }
      })
      .state("dw.info", {
        url: "/account/info",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/info.html",
            controller: "infoController"
          }
        }
      })
      .state("dw.bankCharges", {
        url: "/account/bankCharges",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/bankCharges.html",
            controller: "bankChargesController"
          }
        }
      })
      .state("dw.contactMe", {
        url: "/account/contactMe",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/contactMe.html",
            controller: "contactMeController"
          }
        }
      })

      .state("dw.myReferrals", {
        url: "/account/myReferrals/:standalone",
        cache: false,
        views: {
          contentBody: {
            templateUrl: "app/account/templates/myReferrals.html",
            controller: "myReferralsController"
          }
        }
      })

      .state("dw.wantCard", {
        url: "/account/wantCard/:code",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/wantCard.html",
            controller: "wantCardController"
          }
        }
      })
      .state("dw.expressLoan", {
        url: "/account/expressLoan",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/expressLoan.html",
            controller: "expressLoanController"
          }
        }
      })
      .state("dw.fixedPayout", {
        url: "/account/fixedPayout",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/fixedPayout.html",
            controller: "fixedPayoutController"
          }
        }
      })
      .state("dw.bankChargesTransactionsDetails", {
        url: "/account/bankChargesTransactionsDetails/:accountIndex",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/bankChargesTransactionsDetails.html",
            controller: "bankChargesTransactionsDetailsController"
          }
        }
      })
      .state("dw.transactionDetails", {
        url: "/account/transactionDetails/:accountIndex/:cardIndex/:transactionIndex",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/transactionDetails.html",
            controller: "transactionDetailsController"
          }
        }
      })
      .state("dw.calchoiceStatus", {
        url: "/account/calchoiceStatus/:accountIndex/:cardIndex",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/calchoiceStatus.html",
            controller: "calChoiceStatusController"
          }
        }
      })
      .state("dw.calchoicePayoutnoparams", {
        url: "/account/calchoicePayout",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/calchoicePayout.html",
            controller: "calchoicePayoutController"
          }
        }
      })
      .state("dw.calchoicePayout", {
        url: "/account/calchoicePayout/:accountIndex/:cardIndex/:stageFlag",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/calchoicePayout.html",
            controller: "calchoicePayoutController"
          }
        }
      })
      .state("dw.pieCommitments", {
        url: "/account/pieCommitments/:selectedBankAccountIndex",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/pieCommitments.html",
            controller: "commitmentsController"
          }
        }
      })
      .state("dw.termsPage", {
        url: "/account/termsPage/:url/:title",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/termsPage.html",
            controller: "termsPageController"
          }
        }
      })
      .state("dw.enlarge-credit-frame", {
        url: "/account/enlargecreditframe",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/enlargeCreditFrame2.html",
            controller: "enlargeCreditFrameController"
          }
        }
      })
      .state("dw.debit-spread", {
          url: "/account/debitSpread/:standalone",
        //url: "/account/debitSpread/{step}",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/debitSpread.html",
            controller: "debitSpreadController"
          },
          params: {
            standalone: null
          }
        }
      })
      .state("dw.margarita", {
        url: "/account/margarita/:confirmationId",
        //url: "/account/debitSpread/{step}",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/margarita.html",
            controller: "margaritaController"
          },
          params: {
            step: null
          }
        }
      })
      .state("dw.trans-filter", {
        url: "/account/transFilter",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/transFilter.html",
            controller: "transFilterController as vm"
          }
        }
      })
      .state("dw.stop-standing-order", {
        url: "/account/stopStandingOrder/:standalone",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/stopStandingOrder.html",
            controller: "stopStandingOrderController as vmStopStandingOrder",
            //resolve: {
            //  approval: function(stopStandingOrderService) {
            //    return stopStandingOrderService.handleAuthentication();
            //  }
            //}
          }
        }
      })
      .state("dw.standing-orders-main", {
        url: "/account/StandingOrdersMain/:standalone",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/StandingOrdersMain.html",
            controller: "StandingOrdersMainController as vmStandingOrdersMain"
          }
        }
      })
      .state("dw.update-address", {
        url: "/account/updateAddress/:updateAddressRedirect",
        views: {
          contentBody: {
            templateUrl: "app/account/templates/updateAddress.html",
            controller: "updateAddressController"
          }
        }
      });
  }
})(window, window.angular);

﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('bankChargesController', bankChargesController);

    bankChargesController.$inject = [
        '$scope', 'connection', 'appData', 'lobbyUiService', '$q', 'utilService', 'errorService', '$ionicScrollDelegate', 'googleAnalyticsService', '$timeout', '$ionicSlideBoxDelegate'
    ];
    //
    function bankChargesController($scope, connection, appData, lobbyUiService, $q, utilService, errorService, $ionicScrollDelegate, googleAnalyticsService, $timeout, $ionicSlideBoxDelegate) {

        $scope.appData = appData;//
        $scope.lobbyUiService = lobbyUiService;
        $scope.appData.isLoggedIn = connection.isLoggedIn();
        $scope.gClass = "details-grid";
        $scope.title = "חיובים בבנק";
        $scope.members = {
            selectedFromIndex: 0,
            selectedToIndex: 0
        };

        $scope.init = function () {

            if (!$scope.appData.isLoggedIn) {
                lobbyUiService.go('dw.login', { nextPage: 'dw.bankCharges' }, { location: 'replace' });
                return;
            }

            $timeout(function () {
                $ionicScrollDelegate.$getByHandle('bankChargeScroll').scrollTop();
            }, 0);

            googleAnalyticsService.insertEvent({ page: 'Bank charges', eventName: 'Bank charges', action: 'Enter' });

            $scope.selectedBankAccount = ($scope.appData.selectedBankAccountIndex) ? $scope.appData.BankAccounts[$scope.appData.selectedBankAccountIndex] : $scope.appData.BankAccounts[0];



            var d = new Date(),
                currentMonth = d.getMonth(),
                currentYear = d.getFullYear(),
                d = new Date(currentYear, currentMonth),
                dates = [];

            d.setMonth(d.getMonth() - 18);
            var realMonth;
            for (var i = 0; i < 21; i++) {

                realMonth = d.getMonth() + 1;
                realMonth = realMonth < 10 ? '0' + realMonth : realMonth;
                dates.push('' + realMonth + '/' + d.getFullYear());
                d.setMonth(d.getMonth() + 1);
            }

            $scope.dateList = dates;
            setDefaultToAndFromDates();
            $scope.checkAndSetDebitsByDates();
        };

        function setDefaultToAndFromDates() {

            $scope.selectedFromDate = ($scope.appData.selectedFromDate) ? $scope.appData.selectedFromDate : $scope.appData.metaData.DefaultFromMonth + '/' + $scope.appData.metaData.DefaultFromYear;
            $scope.selectedToDate = ($scope.appData.selectedToDate) ? $scope.appData.selectedToDate : $scope.appData.metaData.DefaultToMonth + '/' + $scope.appData.metaData.DefaultToYear;
            $scope.members.selectedFromIndex = checkSelectedIndex($scope.selectedFromDate);
            $scope.members.selectedToIndex = checkSelectedIndex($scope.selectedToDate);

            function checkSelectedIndex(selectedDate) {
                for (var i = 0; i < $scope.dateList.length; i++) {
                    if ($scope.dateList[i].localeCompare(selectedDate) == 0) {
                        return i;
                    }
                }

                return -1;
            }
        }

        $scope.accountNext = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').next();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });
        }

        $scope.accountPrev = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').previous();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

        }

        $scope.accountChanged = function (index) {
            setDefaultToAndFromDates();
            $scope.gridDebitsData = null;
            $scope.appData.selectedBankAccountIndex = index;
            $scope.selectedBankAccount = $scope.appData.BankAccounts[index];
            $scope.checkAndSetDebitsByDates();
        };

        $scope.checkAndSetDebitsByDates = function () {
            getCreditFrameSummary();

            $scope.getDebitsByDates();

        };

        $scope.getTransactions = function (index) {
            $scope.appData.selectedToDate = $scope.selectedToDate;
            $scope.appData.selectedFromDate = $scope.selectedFromDate;
            $scope.appData.Transactions = $scope.selectedBankAccount.bankChargesDebits[index];
            lobbyUiService.go('dw.bankChargesTransactionsDetails', { accountIndex: $scope.selectedBankAccountIndex });
        };

        function debitsToGrid(array) {

            var data = [], rowConfig = [];
            var headers = ['תאריך', 'כרטיס', '# עסקות', 'סכום חיוב'];
            var obj = [];


            array.forEach(function (line) {
                obj.push(utilService.splitDate(line.Date));
                obj.push(line.CardLast4Digits);
                obj.push(line.TransactionsCount);
                obj.push(line.Amount.ReversedFormattedValue);
                data.push(obj);
                obj = [];
                rowConfig.push({ clickable: true, cls: '' });
            });

            return { headers: headers, rows: data, rowConfig: rowConfig };
        }

        function getCreditFrameSummary() {
            $scope.selectedBankAccount.creditError = false;
            if (!$scope.selectedBankAccount.HasCreditFrames == true) {
                $scope.appData.showSpinner = true;
                lobbyUiService.loader.show();
                connection.getCreditFrame($scope.selectedBankAccount.AccountID)
                    .then(function (response) {
                        $scope.selectedBankAccount.CreditFrame = {};
                        $scope.selectedBankAccount.CreditFrame.MaxLimitAmount = response.MaxLimitAmount.ReversedFormattedValue;
                        $scope.selectedBankAccount.CreditFrame.ObligationsAmount = response.ObligationsAmount.ReversedFormattedValue;
                        $scope.selectedBankAccount.CreditFrame.ObligationsAmountFrameB = response.ObligationsAmountFrameB.ReversedFormattedValue;
                        $scope.selectedBankAccount.CreditFrame.DisplayObligationsAmountFrameB = response.ObligationsAmountFrameB.Value > 0;
                        $scope.selectedBankAccount.CreditFrame.ManagementLevel = response.ManagementLevel;
                        $scope.selectedBankAccount.CreditFrame.ObligationsPercent = response.ObligationsPercent.ReversedFormattedValue;
                        $scope.selectedBankAccount.CreditFrame.Text = response.Comments[0].Text;
                        $scope.selectedBankAccount.HasCreditFrames = true;
                        $scope.appData.showSpinner = false;
                        lobbyUiService.loader.hide();
                    }, function (error) {
                        $scope.selectedBankAccount.creditError = true;
                        errorService.handleError(error, getCreditFrameSummary);

                    });
            }

        }

        $scope.getDebitsByDates = function () {

            $scope.selectedFromDate = $scope.dateList[$scope.members.selectedFromIndex];
            $scope.selectedToDate = $scope.dateList[$scope.members.selectedToIndex];
            var fromDateArray = $scope.selectedFromDate.split("/"),
                toDateArray = $scope.selectedToDate.split("/");
            if (new Date(fromDateArray[1], fromDateArray[0]).getTime() > new Date(toDateArray[1], toDateArray[0]).getTime()) {
                if (navigator.notification)
                    navigator.notification.alert(
                        'טווח התאריכים שהוזן אינו תקין.',
                        function () { /*Do Nothing*/ },
                        ' ',
                        'סגור'
                    );
                else {
                    lobbyUiService.popup.alert('טווח התאריכים שהוזן אינו תקין', 'נא לשים לב');
                }
                return;
            }
            getBankDebits();

            function getBankDebits() {

                $scope.appData.showSpinner = true;
                lobbyUiService.loader.show();

                var selectedBankAccount = $scope.appData.selectedBankAccountIndex || 0;
                var promise = connection.getBankDebits($scope.appData.BankAccounts[selectedBankAccount].AccountID, 'A', 2, fromDateArray[0], toDateArray[0], fromDateArray[1], toDateArray[1], '');
                promise.then(function (response) {

                    $scope.appData.BankAccounts[$scope.appData.selectedBankAccountIndex].bankChargesDebits = response.Debits;
                    $scope.appData.BankAccounts[$scope.appData.selectedBankAccountIndex].TotalAmount = response.TotalAmount;
                    $scope.appData.BankAccounts[$scope.appData.selectedBankAccountIndex].TotalTransactionsCount = response.TotalTransactionsCount;
                    $scope.gridDebitsData = debitsToGrid($scope.selectedBankAccount.bankChargesDebits);
                    $scope.appData.showSpinner = false;
                    lobbyUiService.loader.hide();
                }, function (error) {
                    $scope.gridDebitsData = null;
                    errorService.handleError(error, getBankDebits);
                });
            }
        }

        $scope.goToCommitments = function () {
            $scope.appData.selectedToDate = $scope.selectedToDate;
            $scope.appData.selectedFromDate = $scope.selectedFromDate;
            lobbyUiService.go('dw.pieCommitments', { selectedBankAccountIndex: $scope.appData.selectedBankAccountIndex });
        };

        $scope.init();
    }

})(window, window.angular);
﻿(function(window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('bankChargesTransactionsDetailsController', bankChargesTransactionsDetailsController);

    bankChargesTransactionsDetailsController.$inject = [
        '$scope', 'connection', 'appData', 'lobbyUiService', 'utilService', 'errorService', '$ionicScrollDelegate', 'googleAnalyticsService', '$q', '$timeout'
    ];

    function bankChargesTransactionsDetailsController($scope, connection, appData, lobbyUiService, utilService, errorService, $ionicScrollDelegate, googleAnalyticsService, $q, $timeout) {

        $scope.appData = appData;
        $scope.lobbyUiService = lobbyUiService;
        $scope.gClass = "details-grid";
        $scope.title = "פירוט עסקות";
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.transactionsShowing = {
            isShowing: false,
            showLastTransactions: false,
            showNextTransactions: false,
            showTransactions: '',
            loadMore: false
        };

        $scope.init = function () {

            if (!$scope.appData.isLoggedIn) {
                lobbyUiService.go('dw.login');
                return;
            }
            $timeout(function () {
                $ionicScrollDelegate.$getByHandle('resultsHandler').scrollTop();
            }, 0);

            googleAnalyticsService.insertEvent({ page: 'Bank Charges transactions details', eventName: 'Bank Charges transactions details', action: 'Enter' });


            $scope.selectedBankAccountIndex = $scope.appData.selectedBankAccountIndex;
            $scope.selectedBankAccount = $scope.appData.BankAccounts[$scope.selectedBankAccountIndex];

            $scope.transactionsGridData = {};
            getCurrentCardIndex();
            getTransactionsByDate();
        };

        function getCurrentCardIndex() {
            if ($scope.appData.Transactions) {

                for (var i = 0; i < $scope.selectedBankAccount.Cards.length; i++) {
                    if ($scope.appData.Transactions.CardId == $scope.selectedBankAccount.Cards[i].Id) {

                        $scope.selectedCard = $scope.selectedBankAccount.Cards[i];
                        $scope.appData.shownCardIndex = i;
                        if (!$scope.selectedCard.CardsSpecs && $scope.selectedCard.IsInternetPermitted) {
                            getCardSpec();
                        }
                        return;
                    }
                }

            }

            function getCardSpec() {
                if (!$scope.selectedCard.IsInternetPermitted) {
                    return false;
                }
                connection.getCardData($scope.selectedCard.Id).then(function (response) {
                    $scope.selectedCard.CardsSpecs = response.CardSpecs;
                }, function (error) {
                    errorService.handleError(error, getCardSpec);
                });
            }
        }

        function getTransactionsByDate() {
            if (!$scope.selectedCard.IsInternetPermitted) {
                return;
            }
            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();

            var promise = connection.getTransactionsFromDateToDate($scope.appData.Transactions.CardId, $scope.appData.Transactions.Date, $scope.appData.Transactions.Date);
            promise.then(function (response) {
                $scope.appData.TransactionsDetails = response.Transactions;
                $scope.transactionGridData = transactionsToGrid($scope.appData.TransactionsDetails);
                $scope.HasNextPage = response.HasNextPage;
                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
            }, function (error) {
                errorService.handleError(error, getTransactionsByDate);
            });
        }

        $scope.loadNextTransactions = function () {

            //console.log("load next trans");

            var deferred = $q.defer();

            if ($scope.HasNextPage) {
                $scope.HasNextPage = false;
                $scope.transactionsShowing.loadMore = true;

                connection.getTransNextPage().then(function (response) {
                    $scope.comments = response.Comments;
                    $scope.HasNextPage = response.HasNextPage;
                    $scope.appData.TransactionsDetails = $scope.appData.TransactionsDetails.concat(response.Transactions);
                    $scope.transactionGridData = transactionsToGrid($scope.appData.TransactionsDetails);
                    $scope.transactionsShowing.loadMore = false;
                    deferred.resolve();
                }, function () {
                    $scope.transactionsShowing.loadMore = false;
                    deferred.reject();
                });

            } else {
                deferred.resolve();
            }

            return deferred.promise;
        };

        $scope.goToPie = function () {
            $scope.appData.fromDate = $scope.appData.Transactions.Date;
            $scope.appData.toDate = $scope.appData.Transactions.Date;
            getSectorsData();

            function getSectorsData() {
                $scope.appData.showSpinner = true;
                lobbyUiService.loader.show();
                connection.getSectorSummary($scope.selectedCard.Id, $scope.appData.fromDate, $scope.appData.toDate).then(function (response) {
                    $scope.appData.pieData = response;
                    lobbyUiService.go('dw.pieSummary');
                    $scope.appData.showSpinner = false;
                    lobbyUiService.loader.hide();
                }, function (error) {
                    errorService.handleError(error, getSectorsData);
                });
            }
        };

        $scope.getTransaction = function (index) {
            lobbyUiService.go('dw.transactionDetails', { accountIndex: $scope.selectedBankAccountIndex, cardIndex: '-1', transactionIndex: index });
        };

        function transactionsToGrid(array) {

            var data = [], rowCofig = [];
            var headers = ['תאריך', 'שם עסק', 'סכום עסקה', 'סכום חיוב'];
            var obj = [];

            array.forEach(function (line) {
                obj.push(utilService.splitDate(line.Date));
                obj.push(line.MerchantDetails.Name);
                obj.push(line.Amount.ReversedFormattedValue);
                obj.push(line.DebitAmount.ReversedFormattedValue);
                data.push(obj);
                obj = [];
                rowCofig.push({ clickable: true, cls: '' });
            });

            return { headers: headers, rows: data, rowConfig: rowCofig };
        }

        $scope.init();
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('calchoicePayoutController', calchoicePayoutController);

    calchoicePayoutController.$inject = [
        'commService','$rootScope','$scope', 'connection', 'appData', 'lobbyUiService', 'errorService', 'utilService', '$timeout', '$interval', '$ionicScrollDelegate', 'googleAnalyticsService', '$ionicSlideBoxDelegate', '$state'
    ];

    function calchoicePayoutController(commService,$rootScope,$scope, connection, appData, lobbyUiService, errorService, utilService, $timeout, $interval, $ionicScrollDelegate, googleAnalyticsService, $ionicSlideBoxDelegate, $state) {
        $scope.appData = appData;
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.title = "פירעון CalChoice";
        $scope.utils = utilService;
        $scope.lobbyUiService = lobbyUiService;
        $scope.steps = [{ caption: 'סוג פרעון', active: true }, { caption: 'סכום', active: false }, { caption: 'סיכום', active: false }, { caption: 'אישור', active: false }];//, ['סוג פרעון', 'סכום לפירעון', 'סיכום עסקה', 'אישור'];
        $scope.currentStage = 1;
        commService.showBackButton(false);
        $('body').removeClass('finish');
        $scope.gClass = "details-grid";
        //$scope.selectedBankAccountIndex = lobbyUiService.getParams('accountIndex') ? parseInt(lobbyUiService.getParams('accountIndex')) : 0;
        $scope.shownCardIndex = lobbyUiService.getParams('cardIndex');
        //$scope.goToStage2Flag = lobbyUiService.getParams('stageFlag');
        $scope.years = [(new Date().getFullYear()), (new Date().getFullYear()) + 1, (new Date().getFullYear()) + 2, (new Date().getFullYear()) + 3, (new Date().getFullYear()) + 4, (new Date().getFullYear()) + 5];
        $scope.months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
        $scope.isLogin = true;
        $scope.hideNavBar;


        function backNew(howManySteps) {
            window.history.back();
        }
        $rootScope.$on("bankFromHost", function (evt, bankId) {
            console.log("[DW][Listener]", bankId)
            var banks = $scope.accountsToDisplay.map(function (b) { return commService.cutExistingBankIdWorkAround(b) });
            var idx = banks.indexOf(bankId);
            console.log("[DW] index", idx);
            if (idx == -1) idx = 0;
            $scope.accountChanged(idx)
        })

        function inIframe() {
            try {

                var a = window.self !== window.top;
 
                return a;
            } catch (e) {
                return false;
            }
        }
        $scope.hideNavBar = inIframe();

        $scope.members = {
            selectedPayoutAmountType: 0
        };

        $scope.selectedPayoutType =
        {
            type: 1
        };
        $scope.backToHomePage = function () {
            commService.backToHomePage();
          //  lobbyUiService.go('dw.lobby');
        };



        $scope.requestedAmount = {
            amount: 0,
            formated: ''
        }

        Number.prototype.formatMoney = function (c, d, t) {
            var n = this,
                c = isNaN(c = Math.abs(c)) ? 2 : c,
                d = d == undefined ? "." : d,
                t = t == undefined ? "," : t,
                s = n < 0 ? "-" : "",
                i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
                j = i.length,
                j = j > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
        };

        var moveNext = function (elem, next) {
            if (angular.element(elem).val().length == 3) {
                angular.element('#' + next).focus();
            }
            return true;

        }

        $scope.init = function () {

            $scope.appData.backOverrideFN = null;

            if (!$scope.appData.isLoggedIn) {
                lobbyUiService.go('dw.login', { nextPage: 'dw.calchoicePayout' }, { location: 'replace' });
                return;
            }

            //$timeout(function () {
            //    $ionicScrollDelegate.$getByHandle('calchoiceScroll').scrollTop();
            //}, 0);

            googleAnalyticsService.insertEvent({ page: 'CalChoice payment', eventName: 'CalChoice Payment', action: 'Enter' });

            $scope.backBtn = "back";

            angular.element('#cvv1').bind('keyup', function (event) {
                moveNext(this, 'expMonth1');
            });

            angular.element('#cvv2').bind('keyup', function (event) {
                moveNext(this, 'expMonth2');

            });

            angular.element('#cvv3').bind('keyup', function (event) {
                moveNext(this, 'expMonth3');
            });

            var calchoiceAccounts = [];

            for (var i = 0; i < $scope.appData.BankAccounts.length; i++) {
                var cardsToDisplay = [];
                for (var j = 0; j < $scope.appData.BankAccounts[i].Cards.length; j++) {
                    if ($scope.appData.BankAccounts[i].Cards[j].IsCalChoiceCard) {
                        $scope.appData.BankAccounts[i].Cards[j].CardIndex = j;
                        cardsToDisplay.push($scope.appData.BankAccounts[i].Cards[j]);
                    }
                }
                if (cardsToDisplay.length > 0) {
                    $scope.appData.BankAccounts[i].calChoiceCards = cardsToDisplay;
                    $scope.appData.BankAccounts[i].AccountIndex = i;
                    $scope.appData.BankAccounts[i].CalChoiceAccountIndex = calchoiceAccounts.length;
                    calchoiceAccounts.push($scope.appData.BankAccounts[i]);
                }
            }

            $scope.accountsToDisplay = calchoiceAccounts;

            if ($scope.accountsToDisplay.length == 0) //TODO What to display when no calchoice cards are available?
            {
                lobbyUiService.popup.calchoiceLead();
                return;
            }

            if ($scope.appData.BankAccounts != null) {
                if ($scope.appData.BankAccounts[$scope.appData.selectedBankAccountIndex] != null) {
                    $scope.selectedBankAccountIndex = $scope.appData.BankAccounts[$scope.appData.selectedBankAccountIndex].CalChoiceAccountIndex;
                }
            }


            if (!$scope.selectedBankAccountIndex || $scope.selectedBankAccountIndex == 'undefined') {

                $scope.selectedBankAccountIndex = 0;
            }

            $scope.selectedBankAccount = $scope.accountsToDisplay[$scope.selectedBankAccountIndex];

            if (isNaN($scope.shownCardIndex) || !$scope.shownCardIndex)
                $scope.shownCardIndex = 0;

            $scope.selectedCard = $scope.selectedBankAccount.calChoiceCards[$scope.shownCardIndex];

            $scope.accountChanged($scope.selectedBankAccountIndex, $scope.shownCardIndex);
            $scope.prev = function () {

                $ionicSlideBoxDelegate.$getByHandle('c4uCardsHandler').previous();
            }
            $scope.nxt = function () {

                $ionicSlideBoxDelegate.$getByHandle('c4uCardsHandler').next();
            }

            $scope.cardAuth = {
                cvv: '',
                expMonth: '',
                expYear: ''
            }

            $scope.getPayoutOptions();

            commService.trigReady();
        };

        $scope.accountNext = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').next();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });
        }

        $scope.accountPrev = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').previous();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

        }

        $scope.accountChanged = function (index, cardIndex) {
            
            $scope.selectedBankAccountIndex = parseInt(index);
            console.log(" $scope.accountsToDisplay", $scope.accountsToDisplay);
            $scope.selectedBankAccount = $scope.accountsToDisplay[index];
            $scope.appData.selectedBankAccountIndex = parseInt($scope.selectedBankAccount.AccountIndex);


            $timeout(function(){
                $scope.updateAccountSlider(index);
                $timeout(function () {
                    if (!$scope.uniqueId) {
                        if (cardIndex) {
                            //$scope.cardChanged(cardIndex);
                            updateCurrentCard(cardIndex);
                            $scope.updateCardSlider(cardIndex);

                        }
                        else {
                            console.log("$scope.selectedBankAccount.calChoiceCards[index]", $scope.selectedBankAccount.calChoiceCards)

                            if ($scope.selectedBankAccount.calChoiceCards.length == 1 && $scope.selectedBankAccount.calChoiceCards[index] != undefined) {
                                for (var i = 0; i < $scope.selectedBankAccount.Cards.length; i++) {
                                    //console.log("$scope.selectedBankAccount.calChoiceCards[index] i", i);
                                    //console.log("$scope.selectedBankAccount.calChoiceCards[index] index", index);

                                    //console.log("$scope.selectedBankAccount.calChoiceCicoecards", $scope.selectedBankAccount.calChoiceCards);
                                    //console.log("$scope.selectedBankAccount.calChoiceCards[index] i", $scope.selectedBankAccount.calChoiceCards[index]);
                                    //console.log("$scope.selectedBankAccount.calChoiceCards[i] i", $scope.selectedBankAccount.calChoiceCards[i]);
                                    if ($scope.selectedBankAccount.Cards[i].Id == $scope.selectedBankAccount.calChoiceCards[index].Id) {
                                        index = i;
                                        break;
                                    }
                                }
                                updateCurrentCard(index);
                            }
                            else {
                                //$scope.cardChanged(0);
                                updateCurrentCard(0);
                            }

                            $scope.updateCardSlider(0);
                        }
                    }
                })
            })
           
        };


        $rootScope.$on("cardFromHost", function (evt, cardId) {
            console.log("selectedcard on blockCard", cardId)
            const cardIndex = $scope.selectedBankAccount.calChoiceCards.findIndex(card => card.Id == cardId);
            $scope.cardChanged(cardIndex);
            $scope.uniqueId = cardId;
        })

        $scope.cardChanged = function (index) {
            if ($scope.selectedBankAccount.calChoiceCards.length > 1) {
                for (var i = 0; i <= $scope.selectedBankAccount.Cards.length; i++) {
                    if ($scope.selectedBankAccount.Cards[i].Id == $scope.selectedBankAccount.calChoiceCards[index].Id) {
                        index = i;
                        break;
                    }
                }
                updateCurrentCard(index);
                $scope.updateCardSlider(index);
            }
        };

        function updateCurrentCard(index) {
            if ($scope.accountsToDisplay) {
                $scope.shownCardIndex = index;
                $scope.selectedCard = $scope.selectedBankAccount.Cards[$scope.shownCardIndex];
                //$scope.appData.shownCardIndex = $scope.selectedCard.CardIndex;
                $scope.appData.shownCardIndex = index;
                $scope.getPayoutOptions();
            }
        }

        $scope.updateAccountSlider = function (index) {
            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').update();
            }, 200).then(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').slide(index);
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

            return _promise;
        }

        $scope.updateCardSlider = function (index) {

            $scope.members.slideBoxReady = false;

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('c4uCardsHandler').update();
            }, 600).then(function () {
                $ionicSlideBoxDelegate.$getByHandle('c4uCardsHandler').slide(index);
            }).finally(function () {
                $scope.members.slideBoxReady = true;
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

            return _promise;
        }

        $scope.to = function (index) {
            $ionicSlideBoxDelegate.$getByHandle('c4uCardsHandler').slide(index);
        }

        $scope.getPayoutOptions = function () {

            if (!$scope.selectedCard.EligibilityStatus) {
                $scope.appData.showSpinner = true;
                lobbyUiService.loader.show();
                connection.getPaymentsOptions($scope.selectedCard.Id).then(function (response) {
                    var PayoutOptions = response.PaymentsOptions;
                    $scope.selectedCard.PayoutOptions = PayoutOptions;
                    setLoanParams();
                    $scope.appData.showSpinner = false;
                    lobbyUiService.loader.hide();
                }, function (error) {
                    errorService.handleError(error, $scope.getPayoutOptions);
                });
            } else
                setLoanParams();

            function setLoanParams() {
                for (var i = 0; i < $scope.selectedCard.PayoutOptions.length; i++)
                    if ($scope.selectedCard.PayoutOptions[i].IsDefault)
                        $scope.selectedPayoutType.type = $scope.selectedCard.PayoutOptions[i].Code;
            };
        };

        $scope.goToStage2 = function () {

            $scope.appData.showSpinner = true;

            lobbyUiService.loader.show();

            $scope.appData.backOverrideFN = $scope.goBack;

            switch ($scope.selectedPayoutType.type) {
                case 1:
                    googleAnalyticsService.insertEvent({ page: 'Calchoice payment', eventName: 'Choose Monthly Payment - Continue', action: 'Click' });
                    break;
                case 2:
                    googleAnalyticsService.insertEvent({ page: 'Calchoice payment', eventName: 'Pay Now - Continue', action: 'Click' });
                    break;
                case 3:
                    googleAnalyticsService.insertEvent({ page: 'Calchoice payment', eventName: 'CalChoice+ - Continue', action: 'Click' });
                    break;

                default:
            }

            connection.getPaymentsRange($scope.selectedCard.Id, $scope.selectedPayoutType.type).then(function (response) {
                $scope.accountsToDisplay = [$scope.selectedBankAccount];

                $scope.selectedCard.PaymentRange = {};
                $scope.selectedCard.PaymentRange.RepaimentInformationText = response.RepaimentInformationText;
                $scope.selectedCard.PaymentRange.IsCVVAndExpiration = response.IsCVVAndExpiration;
                $scope.selectedCard.PaymentRange.NextDebitAmount = response.NextDebitAmount;
                $scope.selectedCard.PaymentRange.NextDebitSumAmountB = response.NextDebitAmountB;
                $scope.selectedCard.PaymentRange.PrevPrintDate = response.PrevPrintDate;
                $scope.selectedCard.PaymentRange.Comments = response.Comments;
                $scope.selectedCard.PaymentRange.AmountSettings = response.AmountSettings;
                $scope.MaximalAmount = Math.floor($scope.selectedCard.PaymentRange.AmountSettings.MaximalAmount.Value - ($scope.selectedCard.PaymentRange.AmountSettings.MaximalAmount.Value % $scope.selectedCard.PaymentRange.AmountSettings.AmountRangeInterval));
                $scope.MinimalAmount = Math.ceil($scope.selectedCard.PaymentRange.AmountSettings.MinimalAmount.Value);


                $scope.selectedCard.PaymentRange.AmountSettings.MaximalAmount.ReversedFormattedValueClean = $scope.MaximalAmount.formatMoney(0);
                $scope.selectedCard.PaymentRange.AmountSettings.MinimalAmount.ReversedFormattedValueClean = $scope.MinimalAmount.formatMoney(0);




                $scope.loanGridData = getStage2GridData();
             
                $scope.currentStage = 2;
                commService.showBackButton(true);
                $('body').removeClass('finish');
                $scope.setActivePage(2);
                if ($scope.selectedPayoutType.type == 3)
                    $scope.requestedAmount.amount = Math.floor($scope.selectedCard.PaymentRange.AmountSettings.CurrentAmount.Value);
                else
                    $scope.requestedAmount.amount = $scope.MinimalAmount;
                $scope.appData.inProcess = true;
                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
                $scope.members.selectedPayoutAmountType = 2;

                $timeout(function () {
                    $ionicScrollDelegate.$getByHandle('calchoiceScroll').scrollTop();
                }, 0);

            }, function (error) {
                errorService.handleError(error, $scope.goToStage2).then(function (response) {
                    if (response == true || response == 'PFC') {
                        if ($scope.selectedPayoutType.type != 2) {
                            $scope.selectedPayoutType.type = 2;
                            $scope.goToStage2();
                        }
                    }
                });
            });




            function getStage2GridData() {
                var data = [], rowConfig = [];
                var headers = [];
                data = [
                    ['דף פירוט אחרון', $scope.selectedCard.PaymentRange.PrevPrintDate],
                    ['סכום חיוב במועד הבא', ($scope.selectedCard.PaymentRange.NextDebitAmount) ? $scope.selectedCard.PaymentRange.NextDebitAmount.ReversedFormattedValue : '']
                ];
                rowConfig = [{ clickable: false, cls: '' }, { clickable: false, cls: '' }];
                return { headers: headers, rows: data, rowConfig: rowConfig };
            };

        };

        $scope.setActivePage = function (page) {
            page--;
            for (var i = 0; i < $scope.steps.length; i++) {
                $scope.steps[i].active = false;
            }
            $scope.steps[page].active = true;
        }
        $scope.goToStage3 = function () {

            $scope.appData.backOverrideFN = $scope.goBack;

            var cvv = $scope.cardAuth.cvv ? $scope.cardAuth.cvv : '';
            var expMonth = $scope.cardAuth.expMonth ? $scope.cardAuth.expMonth : '';
            var expYear = $scope.cardAuth.expYear ? $scope.cardAuth.expYear : '';
            var expDate = '';
            if (expYear != '' && expMonth != '')
                expDate = expMonth + "/" + expYear;
            var requestVal = null;
            if ($scope.members.selectedPayoutAmountType == 1) {
                googleAnalyticsService.insertEvent({ page: 'Calchoice payment', eventName: 'Pay All - Continue', action: 'Click' });
                requestVal = $scope.selectedCard.PaymentRange.AmountSettings.MaximalAmount.Value;
                $scope.requestedAmount.amount = requestVal;
            } else {
                googleAnalyticsService.insertEvent({ page: 'Calchoice payment', eventName: 'Choose Partialy Payment - Continue', action: 'Click' });
                requestVal = $scope.checkValue($scope.requestedAmount.amount);
            }
            var cvvAndDate = true;
            if (requestVal)
                cvvAndDate = $scope.checkCvv(cvv, expDate);

            if (cvvAndDate && requestVal) {
                $scope.appData.showSpinner = true;
                lobbyUiService.loader.show();
                connection.getSimulation($scope.selectedCard.Id, $scope.requestedAmount.amount, cvv, expDate).then(function (response) {
                    $scope.setActivePage(3);
           
                    $scope.currentStage = 3;
                    commService.showBackButton(true);
                    $('body').removeClass('finish');
                    $scope.SimulatedLoanRequest = {};
                    $scope.SimulatedLoanRequest.RepaimentInformationTitle = response.RepaimentInformationTitle;
                    $scope.SimulatedLoanRequest.Comments = response.Comments; //Text, Index
                    $scope.SimulatedLoanRequest.RepaimentInformationDetails = response.RepaimentInformationDetails; // Value, ReversedFormattedValue
                    $scope.appData.showSpinner = false;
                    lobbyUiService.loader.hide();
                    $scope.appData.inProcess = true;

                    //$timeout(function () {
                    //    $ionicScrollDelegate.$getByHandle('calchoiceScroll').scrollTop();
                    //}, 0);

                }, function (error) {
                    errorService.handleError(error, $scope.goToStage3);
                });
            }
        };
        $scope.goToStage4 = function () {
     
            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();
            connection.postPaymentsOptions($scope.selectedCard.Id).then(function (response) {
                $scope.currentStage = 4;
     
                commService.showBackButton(false);
                $('body').addClass('finish');
                parent.postMessage({ call: "dwProcessEnd" }, '*');

                $scope.setActivePage(4);
                $scope.appData.backOverrideFN = null;

                $scope.stage4RepaimentInformationTitle = response.RepaimentInformationTitle;
                $scope.stage4RepaimentInformationDetails = response.RepaimentInformationDetails;

                googleAnalyticsService.insertEvent({ page: 'CalChoice Payment', eventName: 'Confirm Request', action: 'Confirm' });

                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
                $scope.members.selectedPayoutAmountType = 2;

                //$timeout(function () {
                //    $ionicScrollDelegate.$getByHandle('calchoiceScroll').scrollTop();
                //}, 0);

            }, function (error) {
                errorService.handleError(error, $scope.goToStage4);
            }).finally(function () {
                $scope.appData.inProcess = false;
            });
        };

        $scope.checkCvv = function (cvv, expDate) {
            if (!$scope.selectedCard.PaymentRange.IsCVVAndExpiration)
                return true;

            var cvvOk = (cvv == '' || cvv === null || cvv === undefined) ? false : true;
            var dateOk = (expDate.length < 5) ? false : true;
            var msgCvv = 'נא למלא את שלוש הספרות האחרונות מגב הכרטיס';
            var msgDate = 'נא למלא את תוקף הכרטיס';

            if (cvvOk && dateOk)
                return true;
            else {
                if (navigator.notification) {
                    navigator.notification.alert(
                        (cvvOk) ? msgDate : msgCvv,
                        function () {
                            return false;
                        },
                        ' ',
                        'אשר'
                    );
                } else {
                    lobbyUiService.popup.alert((cvvOk) ? msgDate : msgCvv, 'נא לשים לב');
                }
                return false;
            }
        };
        $scope.temp = 1000;
        $scope.checkValue = function (value) {
            var maxMsg = 'הסכום המבוקש גבוה מסכום המקסימום';
            var minMsg = 'הסכום המבוקש קטן מסכום המינמום';
            var msgMult = 'יש לבחור סכום בכפולות של' + $scope.selectedCard.PaymentRange.AmountSettings.AmountMultiple;
            var msg = '';
            var valid = true;

            if (value > $scope.MaximalAmount) {
                msg = maxMsg;
                valid = false;
            } else if (value < $scope.MinimalAmount) {
                msg = minMsg;
                valid = false;
            } else if (value % $scope.selectedCard.PaymentRange.AmountSettings.AmountMultiple != 0) {
                msg = msgMult;
                valid = false;
            }

            if (!valid) {
                if (navigator.notification) {
                    navigator.notification.alert(
                        msg,
                        function () {
                            return false;
                        },
                        ' ',
                        'אשר'
                    );
                } else {
                    lobbyUiService.popup.alert(msg, 'נא לשים לב');
                }
                return false;
            } else
                return true;
        }

        $scope.goBackToStage = function (stage) {
            if (stage < 1) {
                $scope.goToStage2Flag = "false";
                $scope.appData.inProcess = false;
                $scope.appData.backOverrideFN = null;
                $scope.$parent.goBack();
            }
            else if (stage == 1) {
                $scope.currentStage = stage;
                $('body').removeClass('finish');
                commService.showBackButton(false);
                $scope.setActivePage(stage)
                $scope.goToStage2Flag = "false";
                $scope.appData.inProcess = false;
                $scope.appData.backOverrideFN = null;

                googleAnalyticsService.insertEvent({ page: 'Calchoice payment', eventName: 'Cancel Payment choice', action: 'Click' });

                $scope.init();
            } else {
             
                $scope.currentStage = stage;
                $scope.setActivePage(stage);
            }

        }

        $scope.$on("$destroy", function () {
            $scope.appData.backOverrideFN = null;
            $scope.appData.inProcess = false;
        });

        $scope.backEventHandler = function (event) {
            $timeout($scope.goBack, 0, true);
            return true;
        };

        $scope.goBack = function () {
     
            $scope.goBackToStage($scope.currentStage - 1);
        }

        $scope.init();
    }

})(window, window.angular);
﻿(function(window, angular) {
    'use strict';

    angular.module('Cal4U')
        .controller('calChoiceStatusController', calChoiceStatusController);

    calChoiceStatusController.$inject = [
        '$scope', 'connection', '$window', 'appData', 'lobbyUiService', '$rootScope', '$q', 'errorService', '$ionicScrollDelegate', 'googleAnalyticsService', '$timeout'
    ];

    function calChoiceStatusController($scope, connection, $window, appData, lobbyUiService, $rootScope, $q, errorService, $ionicScrollDelegate, googleAnalyticsService, $timeout) {

        $scope.appData = appData;
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.title = "תמונת מצב";
        $scope.selectedBankAccountIndex = lobbyUiService.getParams('accountIndex');
        $scope.cardIndex = lobbyUiService.getParams('cardIndex');
        $scope.gClass = "details-grid cal-choice-grid";

        function calChoiceStatusToGrid(response) {
            var data = [], rowConfig = [];
            var Types = {
                0: { clickable: false, cls: '' },
                1: { clickable: false, cls: '' },
                2: { clickable: true, cls: '' },
                3: { clickable: false, cls: 'header' },
                4: { clickable: false, cls: '' },
                5: { clickable: false, cls: 'header' }
            }
            var headers = ['תמונת מצב בכרטיס', ''];
            for (var i = 0; i < response.StatusDetails.length; i++) {
                var obj = [response.StatusDetails[i].Text, response.StatusDetails[i].Value.ReversedFormattedValue];
                data.push(obj);
                rowConfig.push(Types[response.StatusDetails[i].Type]);
                if (response.StatusDetails[i].TransDrillParams == null)
                    rowConfig[i].clickable = false;
            }
            return { headers: headers, rows: data, rowConfig: rowConfig };
        };

        $scope.init = function () {

            if (!$scope.appData.isLoggedIn) {
                lobbyUiService.go('dw.login');
                return;
            }

            $timeout(function () {
                $ionicScrollDelegate.$getByHandle('calchoiceStatusScroll').scrollTop();
            }, 0);

            googleAnalyticsService.insertEvent({ page: 'Calchoice status', eventName: 'Situation Report', action: 'Enter' });

            $scope.appData.inProcess = false;

            var calchoiceAccounts = [];

            for (var i = 0; i < $scope.appData.BankAccounts.length; i++) {
                var cardsToDisplay = [];
                for (var j = 0; j < $scope.appData.BankAccounts[i].Cards.length; j++) {
                    if ($scope.appData.BankAccounts[i].Cards[j].IsCalChoiceCard) {
                        $scope.appData.BankAccounts[i].Cards[j].CardIndex = j;
                        cardsToDisplay.push($scope.appData.BankAccounts[i].Cards[j]);
                    }
                }
                if (cardsToDisplay.length > 0) {
                    $scope.appData.BankAccounts[i].calChoiceCards = cardsToDisplay;
                    $scope.appData.BankAccounts[i].AccountIndex = i;
                    $scope.appData.BankAccounts[i].CalChoiceAccountIndex = calchoiceAccounts.length;
                    calchoiceAccounts.push($scope.appData.BankAccounts[i]);
                }
            }

            $scope.accountsToDisplay = calchoiceAccounts;





            if (!$scope.selectedBankAccountIndex)
                $scope.selectedBankAccountIndex = 0;
            if (!$scope.cardIndex)
                $scope.cardIndex = 0;
            $scope.selectedBankAccount = $scope.accountsToDisplay[$scope.selectedBankAccountIndex];
            $scope.selectedCard = $scope.selectedBankAccount.calChoiceCards[$scope.cardIndex];
            getStatus();

            function getStatus() {
                $scope.appData.showSpinner = true;
                lobbyUiService.loader.show();
                var promise = connection.getStatus($scope.selectedCard.Id);
                promise.then(function (response) {
                    $scope.statusGridData = calChoiceStatusToGrid(response);
                    $scope.Comments = response.Comments;
                    $scope.PlusPlanText = response.PlusPlanText;
                    $scope.StatusDetails = response.StatusDetails;
                    $scope.appData.showSpinner = false;
                    lobbyUiService.loader.hide();
                }, function (error) {
                    errorService.handleError(error, getStatus);
                });

            }
        };

        $scope.rowClicked = function (index) {
            var params = $scope.StatusDetails[index].TransDrillParams;
            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();
            connection.getTransactionsFromDateToDate($scope.selectedCard.Id, params.FromDate, params.ToDate, params.Mahut, params.TransType, params.TransBasketAccumInd, params.DateRangeType).then(function (response) {
                $scope.appData.TransactionsDetails = response.Transactions;
                lobbyUiService.go('dw.bankChargesTransactionsDetails', { accountIndex: $scope.selectedBankAccountIndex });
                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
            }, function (error) {
                errorService.handleError(error, $scope.rowClicked);
            });

        };

        $scope.goToPayout = function () {
            googleAnalyticsService.insertEvent({ page: 'Situation report', eventName: 'CalChoice Payment', action: 'Click' });
            lobbyUiService.go('dw.calchoicePayout', { accountIndex: $scope.selectedBankAccountIndex, cardIndex: $scope.cardIndex });
        }

        $scope.init();
    }

})(window, window.angular);

﻿(function(window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('commitmentsController', commitmentsController);

    commitmentsController.$inject = [
        '$scope', 'connection', 'appData', 'lobbyUiService'
    ];

    function commitmentsController($scope, connection, appData, lobbyUiService) {

        $scope.appData = appData;
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.title = "סך התחייבויות";
        $scope.selectedBankAccountIndex = lobbyUiService.getParams('selectedBankAccountIndex');
        $scope.init = function () {
            if (!$scope.appData.isLoggedIn) {
                lobbyUiService.go('dw.login');
                return;
            }

            $scope.selectedBankAccount = appData.BankAccounts[$scope.selectedBankAccountIndex];
            $scope.commitments = $scope.selectedBankAccount.CreditFrame;
            setPieData();
        };


        $scope.goToCreditFrame = function () {
            lobbyUiService.go('dw.enlarge-credit-frame');
        }

        function setPieData() {

            if (!$scope.commitments)
                return;

            var commitmentsAmount = $scope.commitments.ObligationsAmount,
                commitmentsCreditFrame = $scope.commitments.MaxLimitAmount,
                commitmentsPercent = $scope.commitments.ObligationsPercent,
                data = {};

            // Removing un needed char - % $ etc.
            commitmentsPercent = commitmentsPercent.substring(0, commitmentsPercent.length - 1);
            commitmentsAmount = parseFloat(commitmentsAmount.substring(0, commitmentsAmount.length - 2).replace(',', ''));
            commitmentsCreditFrame = parseFloat(commitmentsCreditFrame.substring(0, commitmentsCreditFrame.length - 2).replace(',', ''));

            data.Sectors = [];
            data.Sectors.push({ 'Amount': { 'Value': commitmentsAmount }, 'Name': 'Obligations Amount', 'FromColor': '#9CD036' });


            if (commitmentsPercent < 100) {
                var commitmentsDifference = commitmentsCreditFrame - commitmentsAmount;
                data.Sectors.push({ 'Amount': { 'Value': commitmentsDifference }, 'Name': 'Max Limit Amount', 'FromColor': '#175994' });
            }

            $scope.pieData = data;
        }

        $scope.init();
    }

})(window, window.angular);
﻿(function(window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('contactMeController', contactMeController);

    contactMeController.$inject = [
        '$scope', 'connection', 'appData', 'lobbyUiService', 'errorService', '$timeout', 'googleAnalyticsService'
    ];

    function contactMeController($scope, connection, appData, lobbyUiService, errorService, $timeout, googleAnalyticsService) {

        $scope.appData = appData;
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.title = "צרו עמי קשר";
        $scope.lobbyUiService = lobbyUiService;
        $scope.hebRegEx = /^[\u05CF-\u05EB\- ]+$/;

        $scope.init = function () {

            if ($scope.appData.isLoggedIn) {
                $scope.backBtn = "logout";
                $scope.CustomerInfo = angular.copy($scope.appData.CustomerInfo);

            } else {
                $scope.backBtn = "back";
            }

            googleAnalyticsService.insertEvent({ page: 'Contact me', eventName: 'Enter Contact me', action: 'Enter' });
        }

        $scope.goBack = function () {

            $timeout(function () {
                $scope.$parent.back();
            }, 600);
        }

        $scope.openLead = function () {
            // add code for checks
            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();
            var data = {
                FirstName: $scope.CustomerInfo.FirstName, LastName: $scope.CustomerInfo.LastName, IdNum: $scope.CustomerInfo.Id, PhoneArea: $scope.CustomerInfo.PhoneArea, PhoneNumber: $scope.CustomerInfo.PhoneNumber, ResolutionCode: '1653' , RequestType: '03' }
            connection.postOpenLead(data).then(function (response) {
                var dialogBox = response.Response.DialogBox;
                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
                if (navigator.notification)
                    navigator.notification.alert(
                        dialogBox.Content,
                        $scope.$parent.back(),
                        dialogBox.Title,
                        dialogBox.OKButtonText
                    );
                else {
                    lobbyUiService.popup.alert(dialogBox.Content, dialogBox.Title, null, function () {
                        $scope.$parent.back();
                    });
                }
            }, function (error) {
                error[0].response.Response.DialogBox.Title = "אופס!";
                error[0].response.Response.DialogBox.Content = "אנו מתנצלים,<br> עקב תקלה טכנית<br> הפרטים שלך לא התקבלו";
                error[0].response.Response.DialogBox.OKButtonText = "נסה שוב";
                error[0].response.Response.DialogBox.CancelButtonText = "סגור";
                errorService.handleError(error, $scope.openLead);
            });
        }

        $scope.validateForm = function () {
            //padding for phone number
            var errMsg = '';
            if (!$scope.CustomerInfo) {
                errMsg = 'יש למלא ערכים בכל אחד מהשדות';
            } else {
                //padding for id
                //                if ($scope.CustomerInfo.Id && $scope.CustomerInfo.Id.length) {
                //                    var padding = '';
                //                    for (var i = 9 - $scope.CustomerInfo.Id.length; i > 0; i--) {
                //                        padding += '0';
                //                    }
                //                    $scope.CustomerInfo.Id = padding + $scope.CustomerInfo.Id;
                //                }

                if ($scope.contactMeForm.$valid && $('#idNum').val().length == 9 && $('#phoneNum').val().length == 7) {
                    return true;
                } else {
                    if ($scope.contactMeForm.$error.required && $scope.contactMeForm.$error.required.length > 1) {
                        errMsg = 'יש למלא ערכים בכל אחד מהשדות';
                    } else if ($('#fName').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ערך בשדה שם פרטי.';
                    else if ($('#lName').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ערך בשדה שם משפחה.';
                    else if ($('#idNum').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ערך בשדה מספר ת.ז.';
                    else if ($('#phoneNum').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ערך בשדה מספר טלפון';
                    else if ($('#areaNum').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ערך בשדה מספר טלפון';
                    else if ($('#fName').hasClass('ng-invalid-pattern'))
                        errMsg = 'השם הפרטי שהוזן אינו תקין. יש למלא אותיות בעברית בלבד.';
                    else if ($('#lName').hasClass('ng-invalid-pattern'))
                        errMsg = 'שם המשפחה שהוזן אינו תקין. יש למלא אותיות בעברית בלבד.';
                    else if ($('#idNum').hasClass('ng-invalid-pattern') || $('#idNum').val().length != 9)
                        errMsg = 'מספר ת.ז. שהוזן אינו תקין. יש למלא מספר בן 9 ספרות בדיוק כולל ספרת ביקורת.';
                    else if ($('#phoneNum').hasClass('ng-invalid-pattern'))
                        errMsg = 'מספר הטלפון שהוזן אינו תקין. יש למלא ספרות בלבד.';
                    else if ($('#phoneNum').val().length < 7)
                        errMsg = 'מספר הטלפון שהוזן אינו תקין. יש למלא מספר בן 7 ספרות בדיוק.';
                }
            }

            if (navigator.notification) {
                navigator.notification.alert(
                    errMsg,
                    function () {
                        /*Do Nothing*/
                    },
                    ' ',
                    'סגור'
                );
            }
            else {
                lobbyUiService.popup.alert(errMsg, 'נא לשים לב');
            }

            return false;
        }

        $scope.init();
    }

})(window, window.angular);
﻿(function (window, angular) {
    "use strict";
    angular.module("Cal4U").controller("updateAddressController", updateAddressController);

    updateAddressController.$inject = [
        "commService",
        "$scope",
        "$http",
        "connection",
        "appData",
        "lobbyUiService",
        "errorService",
        "$timeout",
        "$interval",
        "appSettings",
        "dataService",
        "$rootScope",
        "$stateParams",
        "$location"
    ];

    function updateAddressController(
        commService,
        $scope,
        $http,
        connection,
        appData,
        lobbyUiService,
        errorService,
        $timeout,
        $interval,
        appSettings,
        dataService,
        $rootScope,
        $stateParams,
        $location
    ) {
        var goToLogin = function () {
            lobbyUiService.go("dw.login", { nextPage: "dw.update-address", type: 2 }, { location: "replace" });
        };
        commService.trigReady();
        commService.sendHeight(700);
        var returnUrl = $location.search().returnAppUrl;
        if (returnUrl) {
            localStorage.setItem("UpdateAddressReturnUrl", returnUrl);
        }
        $scope.returnAppUrl = $location.search().returnAppUrl;
        $timeout(function () {
            connection.getConnectAuth().then(
                function (res) {
                        init();
                },
                function (err) {
                    if (lobbyUiService.connection.isLoggedIn()) {
                        connection.setToken(null);
                    }
                    goToLogin();
                }
            );
        }, 0);

        var showLoginPopup = function () {
            var popup = {};
            popup.title = "התחברות למערכת";
            popup.text = "על מנת שנוכל להציג לך את הפרטים, יש לבצע התחברות למערכת בעזרת תעודת זהות ו-4 ספרות אחרונות של הכרטיס בלבד.";
            popup.btns = [];
            popup.btns.push(
                {
                    text: "להתחברות מחדש",
                    type: "button-positive",
                    onTap: function () {
                        connection.setToken(null);
                        dataService.sessionManager.clear("authToken");
                        goToLogin();
                    }
                },
                {
                    text: "לא תודה",
                    type: "button-negative",
                    onTap: function () {
                        lobbyUiService.go("dw.lobby");
                    }
                }
            );
            lobbyUiService.popup.messageText(null, popup.text, popup.title, null, null, null, popup.btns, false);
           
        };

        var errorsDataOfUpdateState = [
            {
                updateState: 8,
                title: "חיפשנו...",
                message: "אבל לא מצאנו כרטיסים שאפשר לעדכן עבורם כתובת \n כדי לשנות את הכתובת צריך לפנות לבנק" 
            },
            {
                updateState: 9,
                title: "אופס, משהו השתבש...",
                message: "לצערנו, לא הצלחנו לעדכן את הכתובת שלך. ממליצים לך לנסות שוב מאוחר יותר"
            }
        ];

        var getErrorData = function () {
            var data = errorsDataOfUpdateState.find(err => err.updateState == $scope.updateState);

            return data;
        };

        var init = function () {
            $scope.currentErrorData = {};
            getCardsForAddressUpdate();
            initSuccessText();
        };

        var getCardsForAddressUpdate = function () {
            var httpReq = {
                method: "POST",
                url: appSettings.updateAddressBase + "Account/GetCardsForAddressUpdate",
                headers: {
                    Authorization: "CALAuthScheme " + dataService.sessionManager.read("authToken"),
                    "X-Site-Id": appSettings.siteId
                }
            };

            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();

            $http(httpReq)
                .success(function (response) {
                    if (response) {
                        if (response.result) {
                            $scope.user = {
                                firstName: response.result.firstName,
                                lastName: response.result.lastName
                            };
                            $scope.cardsToUpdate = response.result.eligibleCards;
                            $scope.cardsToUpdate.forEach(card => (card.selected = true));

              if (response.result.eligibleCards && response.result.eligibleCards.length == 1) {
                $scope.state = "normal";
                $scope.updateState = 1; // one eligible card: 2.1
                $scope.bullets = response.result.comments;
              } else if (response.result.eligibleCards && response.result.eligibleCards.length > 1) {
                $scope.state = "normal";
                $scope.updateState = 2; // +3; more than one eligible cards: 2.2
                $scope.bullets = response.result.comments;
              } else if (!response.result.eligibleCards || response.result.eligibleCards.length == 0) {
                $scope.state = "error";
                $scope.updateState = 8; // only non eligible cards: 2.3
                $scope.currentErrorData = getErrorData();
              } else {
                $scope.state = "error";
                $scope.updateState = 9; // general error: 6
                $scope.currentErrorData = getErrorData();
              }
            } else if (response.statusCode == 214) {
                $scope.state = "error";
                $scope.updateState = 8; // only non eligible cards: 2.3
                $scope.currentErrorData = getErrorData();
            } else if (response.statusCode == 213) {
              $scope.state = "error";
              $scope.updateState = 5; // changed phone number: 4
              $scope.currentErrorData.title = response.statusTitle;
              $scope.currentErrorData.message = response.statusDescription;
            } else {
              $scope.state = "error";
              $scope.updateState = 9; // general error: 6
              $scope.currentErrorData = getErrorData();
            }
          } else {
            $scope.state = "error";
            $scope.updateState = 9; // general error: 6
            $scope.currentErrorData = getErrorData();
          }
        })
        .error(function (error) {
            $scope.state = "error";
            if (error.statusCode == 401) {
                showLoginPopup();
                return;
            }
          $scope.updateState = 9; // general error: 6
          $scope.currentErrorData = getErrorData();
        })
        .finally(function () {
          lobbyUiService.loader.hide();
          $scope.appData.showSpinner = false;
            if ($scope.state == "normal") {
            sendGtmEvent({ event: 'funnel_step', err: 'NA', step: 1,stepTitle:'כתובת חדשה' });
           
            } else if ($scope.state == "error") {
                sendGtmEvent({ event: 'funnel_step', err: getErrorData().message, step: 1, stepTitle: 'כתובת חדשה' });
                if ($scope.updateState == 9) {
                    getErrorData
             
            } 
           
          }
        });
    };

        var updateCardAddress = function () {
            $scope.cardsRequestedToUpdate = [];
            $scope.cardsRequestedToUpdate = $scope.cardsToUpdate.filter(card => card.selected).map(selected => selected.cardUniqueId); //.forEach(uid => cardsRequestedToUpdate.push({ cardUniqueId: uid }));

            var requestData = {
                cardUniqueIds: $scope.cardsRequestedToUpdate,
                addrCity: $scope.selectedCityName,
                addrStreet: $scope.selectedStreetName,
                addrHouse: $scope.houseNumber.value,
                addrApp: $scope.appartmentNumber.value,
                addrPOBNum: $scope.mailBox.value,
                addrZip: $scope.zipCode.value ? $scope.zipCode.value.toString() : null
            };

            var httpReq = {
                method: "POST",
                url: appSettings.updateAddressBase + "Update/UpdateCardAddress",
                headers: {
                    Authorization: "CALAuthScheme " + dataService.sessionManager.read("authToken"),
                    "X-Site-Id": appSettings.siteId
                },
                data: requestData
            };

            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();

            $http(httpReq)
                .success(function (response) {
                    if (response && response.result) {
                        
                        if (response.statusCode == 1) {
                            $scope.updateState = 6; // success for all cards: 1.a
                            $scope.state = "success";
                            $scope.addressUpdated = response.result.fullAddress;

                            if (response.result.notEligibleCards && response.result.notEligibleCards.length > 0) {
                                $scope.updateState = 7; // success with not eligible cards: 1.b
                                $scope.errorOnSuccess = true;
                                $scope.isNotEligibleCards = true;
                                $scope.notEligibleCards = response.result.notEligibleCards;
                            }
                        } else if (response.statusCode == 215) {
                            $scope.state = "success";
                            $scope.addressUpdated = response.result.fullAddress;
                            if (response.result.notUpdateCards && response.result.notUpdateCards.length > 0) {
                                $scope.updateState = 10; // partial success (some cards not updated): 2
                                $scope.isCardsNotUpdated = true;
                                $scope.cardsNotUpdated = response.result.notUpdateCards;
                            }
                            if (response.result.notEligibleCards && response.result.notEligibleCards.length > 0) {
                                $scope.updateState = 4; // partial success (some cards not updated) + not eligible cards: 3
                                $scope.isNotEligibleCards = true;
                                $scope.notEligibleCards = response.result.notEligibleCards;
                            } else {
                                $scope.state = "error";
                                $scope.updateState = 9; // general error: 5
                                $scope.currentErrorData = getErrorData();
                            }
                        } else {
                            $scope.state = "error";
                            $scope.updateState = 9; // general error: 5
                            $scope.currentErrorData = getErrorData();
                        }
                    } else {
                        $scope.state = "error";
                        $scope.updateState = 9; // general error: 5
                        $scope.currentErrorData = getErrorData();
                    }
                })
                .error(function (error) {
                    $scope.state = "error";
                    $scope.updateState = 9; // general error: 5
                    $scope.currentErrorData = getErrorData();
                })
                .finally(function () {
                    lobbyUiService.loader.hide();
                    $scope.appData.showSpinner = false;
                    if ($scope.state == "success") {
                      
                        sendGtmEvent({ event: 'funnel_step', err: 'NA', step: 2, stepTitle: 'סיום' });
                        sendGtmEvent({ event: 'end_funnel', step: 2, stepTitle: 'סיום' });
  
                    } else if ($scope.state == "error") {
                        sendGtmEvent({ event: 'funnel_step', err: getErrorData().message, step: 1.1, tilte: 'כישלון' });
                      
                    }
                });
        };

        var choices = [
            { index: 1, id: "ABC1", label: "אור עקיבא" },
            { index: 2, id: "ABC2", label: "תל אביב" },
            { index: 3, id: "ABC3", label: "תל חי" },
            { index: 4, id: "ABC4", label: "תל זיבי" },
            { index: 5, id: "ABC5", label: "רעננה" },
            { index: 6, id: "ABC6", label: "גבעתיים" },
            { index: 7, id: "ABC7", label: "דור זילכה" }
        ];

        var choices2 = [
            { index: 1, id: "ABC1", label: "הנדיב" },
            { index: 2, id: "ABC2", label: "הנשיא" },
            { index: 3, id: "ABC3", label: "השממה" },
            { index: 4, id: "ABC4", label: "הכאל" },
            { index: 5, id: "ABC5", label: "השפרחים" }
        ];

        $scope.sendCheckBoxGtmEvent = function (card) {

            var title = '';
            if (card.companyDescription !== '') {
                title = card.companyDescription;
            }
            if (card.cardType !== '') {
                title = title !== '' ? title + ' ' + card.cardType : card.cardType;
            }
            if (card.last4Digits !== '') {
                title = title !== '' ? title + ' ' + card.last4Digits : card.last4Digits;
            }

            sendGtmEvent({ event: 'funnel_click', title: title, component: 'checkbox', 'question_text': 'NA' });


        }

        $scope.openCards = function () {

          
            sendGtmEvent({ event: 'funnel_click', title: 'עדכנו כתובת זו לכל הכרטיסים שלי', component: 'checkbox', 'question_text': 'NA' });
            $scope.cardsOpened = true;

            $scope.cardsToUpdate.forEach(card => (card.selected = false));

            // blur all inputs
            if ("activeElement" in document) {
                document.activeElement.blur();
            }
        };

      

        $scope.cardsOpened = false;
        $scope.items = choices;
        $scope.streetItems = choices2;
        $scope.cityText = { value: "" };
        $scope.streetText = { value: "" };

        $scope.houseNumber = { value: null };
        $scope.appartmentNumber = { value: "" };
        $scope.mailBox = { value: null };
        $scope.minlength = 2;
        $scope.selectedCity;
        $scope.selectedStreet;
        $scope.placeholder = "יישוב";
        $scope.updateAll = true;
        $scope.submitted = false;
        $scope.successButtonText = "הבנתי, תודה";
        $scope.successTitle = "זהו סיימנו פה...";

        $scope.changeHouseNumber = function (houseNumber) {
            $scope.houseNumber.value = houseNumber.value;
            console.log("houseNumber", houseNumber);

            if ($scope.selectedCity) {
                $scope.getZipCode($scope.selectedCity, $scope.selectedStreet, $scope.houseNumber.value);
            }
        };

        $scope.submitForm = function () {
            $scope.submitted = true;

            setTimeout(() => {
                sendGtmEvent({ event: 'funnel_click', title: 'אישור ועידכון', component: 'button', 'question_text':'מה הכתובת החדשה שלך?' });
              
                if (isFormValid()) {
                    updateCardAddress();
                    sendGtmEvent({ event: 'form_sent', errList: 'none' });
                                   } else {
                    $timeout(function () {
                        sendGtmEvent({ event: 'form_sent', errList: getFormErrorList() });
                        focusOnFirstInvalid();
                    });
                }
            });
        };

        $scope.zipCodeDisabled = true;
        $scope.zipCode = { value: null };
        $scope.send = function () {
            console.log("selectedCity", $scope.selectedCity.va);
        };
        $scope.hasStreets = true;

        $scope.$on("selectedCity", function (evt, data) {
            // if a city was emited
            if (data.settlementCode) {
                $scope.selectedCity = data.settlementCode;
                $scope.selectedCityName = data.settlementName;
                $scope.hasStreets = data.isStreetsEnabled;

                // if there are less than four streetes call getZipCode
                if (!data.isStreetsEnabled) {
                    $scope.getZipCode($scope.selectedCity, $scope.selectedStreet, $scope.houseNumber.value);
                }
            } else {
                $scope.selectedCity = null;
                $scope.selectedCityName = null;
                $scope.hasStreets = true;
            }
        });

        $scope.$on("selectedStreet", function (evt, data) {
            if (data.streetId) {
                $scope.selectedStreet = data.streetId;
                $scope.selectedStreetName = data.streetName;

                if (($scope.selectedCity, $scope.selectedStreet, $scope.houseNumber.value)) {
                    $scope.getZipCode($scope.selectedCity, $scope.selectedStreet, $scope.houseNumber.value);
                }
            } else {
                $scope.selectedStreet = null;
                $scope.selectedStreetName = null;
            }
        });

        $scope.getZipCode = function (city, street, home) {
            var data = {
                settlementCode: city,
                streetCode: street,
                houseNumber: home
            };
            console.log("getZip", data);

            $http.post(appSettings.updateAddressBase + "Address/GetZipCode", data).then(
                function (res) {
                    console.log("resZip", res);
                    if (res && res.data && res.data.result && res.data.result.zipCode7) {
                        $scope.zipCode.value = parseInt(res.data.result.zipCode7);
                        console.log("$scope.zipcode", $scope.zipCode7);
                        $scope.zipCodeDisabled = true;
                    } else {
                        $scope.zipCode7 = null;
                        $scope.zipCodeDisabled = false;
                    }
                },
                function (err) {
                    $scope.zipCode.value = null;
                    $scope.zipCodeDisabled = false;
                    console.log("err", err);
                }
            );
        };

        $scope.cityDataSource = appSettings.updateAddressBase + "Address/GetSettlements";
        $scope.streetDataSource = appSettings.updateAddressBase + "Address/GetStreetst";

        $scope.redirect = function () {
            sendGtmEvent({ event: 'funnel_click', title: $scope.successButtonText, component: 'button', 'question_text': 'זהו סיימנו פה' });
            var redirectUrl = localStorage.getItem("UpdateAddressReturnUrl");
            if ($stateParams.contactless) {
                lobbyUiService.go("dw.contactless", { contactless: true });
            } else if (redirectUrl) {
                window.location.href = redirectUrl;
            } else {
                console.log("no redirect so didnt arrive from block etc..");
                if (window != window.top) {

                    console.log("gotohomepage parent site");
                    parent.postMessage({ call: "dwupdateAddressComplete", value: { address: $scope.addressUpdated } }, '*')
                    commService.backToHomePage();
                }
           
                else {
                    console.log("general site");
                    window.location.href = "https://www.cal-online.co.il";
                }
                //
            }
            //if ($stateParams.contactless) {
            //  lobbyUiService.go("dw.contactless", { contactless: true });
            //} else {
            //  window.location.href = "https://www.cal-online.co.il";
            //}
        };

        $scope.onChangeMailBox = function (mailBox) {
            // if length is zero enable the fields
            // else reset fields and disable
            if (mailBox) {
                resetStreetName();
                resetHouseNumber();
                resetAppartmentNumber();

                disableStreetName();
                disableHouseNumber();
                disableAppartmentNumber();
                enableZipCode();
            } else {
                enableStreetName();
                enableHouseNumber();
                enableAppartmentNumber();
                disableZipCode();
            }
        };

        function sendGtmEvent(eventData) { 
            if (window != window.top) {
                parent.postMessage({ call: "dwupdateAddressGtm", value: eventData }, '*');
            }
        }

        function resetStreetName() {
            // reset on directive
            $scope.streetText.value = "";

            // reset on controller
            $scope.selectedStreet = "";
            $scope.selectedStreetName = "";
        }

        function resetHouseNumber() {
            $scope.houseNumber.value = "";
        }

        function resetAppartmentNumber() {
            $scope.appartmentNumber.value = "";
        }

        function disableStreetName() {
            $scope.hasStreets = false;
        }

        function disableHouseNumber() {
            $scope.isDisabledHouseNumber = true;
        }

        function disableAppartmentNumber() {
            $scope.isDisabledAppartmentNumber = true;
        }

        function disableZipCode() {
            $scope.zipCodeDisabled = true;
        }

        function enableStreetName() {
            $scope.hasStreets = true;
        }

        function enableHouseNumber() {
            $scope.isDisabledHouseNumber = false;
        }

        function enableAppartmentNumber() {
            $scope.isDisabledAppartmentNumber = false;
        }

        function enableZipCode() {
            $scope.zipCodeDisabled = false;
        }

        function isFormValid() {
            if (!$scope.selectedCity) {
                return false;
            }

            if ($scope.selectedCity && !$scope.mailBox.value) {
                if ($scope.hasStreets) {
                    if (!$scope.selectedStreet || !$scope.houseNumber.value || !$scope.isZipCodeValid()) {
                        return false;
                    }
                }
            }

            if ($scope.cardsOpened && !$scope.isCardSelected()) {
                return false;
            }

            if (!$scope.isZipCodeValid()) {
                return false;
            }

            return true;
        }

        $scope.isCardSelected = function () {
            let isCardSelected = false;

            $scope.cardsToUpdate.forEach(card => {
                if (card.selected) {
                    isCardSelected = true;
                }
            });

            return isCardSelected;
        };

        $scope.isZipCodeValid = function () {
            let zipCodeValid = false;
            let stringZipCode = "";

            stringZipCode = $scope.zipCode.value ? $scope.zipCode.value.toString() : "";

            if (stringZipCode.length === 7 || stringZipCode.length === 0) {
                zipCodeValid = true;
            }

            return zipCodeValid;
        };

        function getFormErrorList() {

            let cal2020ErrClasses = $(".cal2020-err");
            var gtmErrList = [];
            cal2020ErrClasses.each(function (index, value) {
                if (!$(value).hasClass("ng-hide")) {
                    gtmErrList.push($(value).find('span').text().trim());
                }
            });
            return gtmErrList.join(',');
        }

        function focusOnFirstInvalid() {
            let cal2020ErrClasses = $(".cal2020-err");
          
            cal2020ErrClasses.each(function (index, value) {
                if (!$(value).hasClass("ng-hide")) {

                    // set focus
                    let input = findFirstInput($(value).prev());

                    if (input) {
                        input.focus();
                    }
                    // finish each
                    return false;
                }
            });

           
        }

        function findFirstInput(element) {
            if (element.is("input")) {
                return element;
            }

            if (element.find("input").length > 0) {
                return element.find("input");
            }
        }

        function initSuccessText() {
            var updateAddressRedirect = angular.fromJson($stateParams.updateAddressRedirect);
            if (updateAddressRedirect) {
                switch (updateAddressRedirect.redirectedFrom) {
                    case "dw.contactless": {
                        $scope.successButtonText = "בחזרה לשדרוג לטאצ'";
                        $scope.successTitle = "מצוין, אפשר לחזור לשדרוג";
                        break;
                    }
                    case "dw.defectiveCard": {
                        $scope.successButtonText = "בחזרה להחלפת כרטיס פגום";
                        $scope.successTitle = "מצוין, אפשר לחזור להחלפת כרטיס";
                        break;
                    }
                    case "dw.blockCardConfirm": {
                        $scope.successButtonText = "בחזרה לחסימת כרטיס";
                        $scope.successTitle = "מצוין, אפשר לחזור לחסימת כרטיס";
                        break;
                    }
                }
            }
        }
    }
})(window, window.angular);

﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
    .factory('referralsRestService', referralsRestService);

    referralsRestService.$inject = ['connection', '$q', 'appSettings', 'appData'];

    function referralsRestService(connection, $q, appSettings, appData) {

        var _getMetaData = function () {
            return connection.genericConnection('POST', 'CalReferrals/GetReferrals?', connection.versionAndOSParams);
        };

        return {
            getMetaData: _getMetaData,
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
    .controller('myReferralsController', myReferralsController);

    myReferralsController.$inject = [
        '$scope', 'connection', 'lobbyUiService', '$timeout', 'errorService', 'referralsRestService', '$stateParams', 'googleAnalyticsService', 'lobbyDataService', '$state'
    ];

    function myReferralsController($scope, connection, lobbyUiService, $timeout, errorService, referralsRestService, $stateParams, googleAnalyticsService, lobbyDataService, $state) {

        if (!connection.isLoggedIn()) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.myReferrals' }, { location: 'replace' });
            return;
        }
        
        $scope.standalone = $stateParams.standalone

        if ($scope.standalone) {
            $('#page-wrapper').addClass('standalone');
        }

        $scope.chatItem;
        
        var isChatAvailable = function () {
            lobbyDataService.loadMetaData().then(function (metaData) {
                if (metaData) {
                    metaData.menu.filter(function (module) {
                        if (module.caption === "Cal לשירותך") {
                            module.items.filter(function (item) {
                                if (item.command == 'open-chat') {
                                    $scope.chatItem = item;
                                    $scope.isChatAvailable = !item.hide;
                                }
                            });
                        }                        
                    })
                }
            });
        }();
        $scope.disclaimer = "<b>חשוב לדעת</b>: יכול להיות שיש לך פניה פתוחה אצלנו, אבל היא לא מופיעה בסטטוס הפניות. לא צריך לדאוג, אנו מטפלים בכל הפניות וכמובן שנעדכן אותך כשהטיפול יושלם.";
        $scope.title = "סטטוס הפניות שלי";
        $scope.Chat = "צ'אט עם נציג";
        $scope.WheresMyCard = "היכן הכרטיס שלי?";
        $scope.showBtn = false;

        $scope.dictSubAreaCode = {
            6030: 'בקשה לפרעון מיידי ',
            6012: 'בקשה לפרעון למועד החיוב',
            6018: 'בקשה להעברת התחייבויות',
            6206: 'בקשה לשינוי חשבון',
            6088: 'בקשה לעדכון חשבון מט"ח',
            6010: 'בקשה לעצירת הוראת קבע',
            7204: 'בקשה להפשרת הוראת קבע',
            6207: 'בקשה לשחזור קוד סודי',
            6209: 'בקשה לשינוי מועד חיוב',
            6257: 'בקשה למשלוח כרטיס ליעד שונה',
            6222: 'בקשה לשינוי שיטת אשראי בכרטיס',
            7214: 'בקשה לביטול כרטיס',
            1184: 'בקשה להגדלת מסגרת אשראי'
        };

        $scope.init = function () {
            lobbyUiService.loader.show();
            referralsRestService.getMetaData().then(function (response) {
                lobbyUiService.loader.hide();

                if (response.ReferralsDetails) {
                    $scope.showBtn = true;
                    $scope.ReferralsDetails = response.ReferralsDetails;

                    $scope.NumOfItems = response.ReferralsDetails.length;

                    if ($scope.NumOfItems > 0) {
                        $scope.ReferralsDetails.forEach(
                        function (item) {
                            var ArrDate = item.CreateDate.split('/');
                            item.DotsCreateDate = ArrDate[1] + '.' + ArrDate[0] + '.' + ArrDate[2].slice(2, 4);

                            item.CalculatedStatus = item.StatusDescription;
                            if (item.StatusDescription != 'הסתיים הטיפול') {
                                item.CalculatedSLA = item.SLA < 1 ? 'פנייתך בטיפול' : item.SLA === 1 ?
                                    'הטיפול בבקשתך צפוי להסתיים תוך יום עסקים אחד' : ' הטיפול בבקשתך צפוי להסתיים עד ' + item.SLA + ' ימי עסקים מהיום ';
                            }

                        });
                    }

                    $scope.SubArea = "נושא הפניה:";
                    $scope.SRNumber = "מס' פניה";
                    $scope.CreateDate = "ת.פתיחה";
                    $scope.CardNum = "מס' כרטיס";
                    $scope.Status = "סטטוס";                    

                }
                else {
                    $scope.showBtn = false;
                    $scope.NumOfItems = 0;
                }
            },
                function (error) {
                    var status = error[0].response && error[0].response.Response.Status;
                    if (status.SeverityCode === 'W' && status.SeverityNumber == '004') {
                        lobbyUiService.loader.hide();
                        $scope.NotFound = "לא נמצאו פניות";
                        $scope.showBtn = false;
                        $scope.NumOfItems = 0;
                    }
                    else {
                        errorService.handleError(error);
                    }
                });
        }

        $scope.trackMyCard = function () {
            googleAnalyticsService.insertEvent({ page: 'chat application status', eventName: 'status', action: 'Click' });
        }

        $scope.goToChat = function () {
            googleAnalyticsService.insertEvent({ page: 'mycard application status', eventName: 'status', action: 'Click' });            
            lobbyUiService.navigate($scope.chatItem.url, $scope.chatItem);
        };

        $scope.init();
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
        .factory('stopStandingOrderService', stopStandingOrderService);
    function stopStandingOrderService($q, connection, $rootScope, lobbyUiService, errorService, $timeout) {
        var handleAuthentication = function () {
            var deferred = $q.defer();
            if (!lobbyUiService.connection.isLoggedIn()) {
                $timeout(function () {
                    lobbyUiService.go('dw.login', { nextPage: 'dw.stop-standing-order' });
                    deferred.reject();
                    return;
                });
            }
            deferred.resolve(true);
        }

        return {
            handleAuthentication: handleAuthentication,
        }
    }
})(window, window.angular);
﻿(function(window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('expressLoanController', expressLoanController);

    expressLoanController.$inject = [
        '$scope', 'connection', 'appData', 'lobbyUiService', 'errorService', '$ionicScrollDelegate', 'googleAnalyticsService',  '$timeout', '$ionicSlideBoxDelegate'
    ];

    function expressLoanController($scope, connection, appData, lobbyUiService, errorService, $ionicScrollDelegate, googleAnalyticsService, $timeout, $ionicSlideBoxDelegate) {

        $scope.appData = appData;
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.lobbyUiService = lobbyUiService;
        $scope.steps3 = ['1. בחירת סכום', '2. אישור נתוני הלוואה', '3. אישור ביצוע'];;
        $scope.steps4 = ['1. בחירת סכום', '2. בחירת מספר תשלומים', '3. אישור נתוני הלוואה', '4. אישור ביצוע'];
        $scope.requestedAmount = {
            amount: 0,
            formated: ''
        }

        $scope.members =
        {
            agreeToTerms: false,
            numOfPayments: 0,
            showTerms: false,
            title: 'הלוואת אקספרס'
        };

        $scope.doc = {
            url: '/CalDocs?id=ExpressLoanTerms.html'
        }

        $scope.gClass = "details-grid";

        $scope.init = function () {

            if (!$scope.appData.isLoggedIn) {
                lobbyUiService.go('dw.login', { nextPage: 'dw.expressLoan' }, { location: 'replace' });
                return;
            }

            googleAnalyticsService.insertEvent({ page: 'Credit Solutions', eventName: 'Express Loans', action: 'Enter' });

            $scope.currentStage = 1;

            $scope.appData.inProcess = false;

            $scope.appData.backOverrideFN = null;

            $timeout(function () {
                $ionicScrollDelegate.$getByHandle('expressScroll').scrollTop();
            }, 0);

            if (!$scope.appData.selectedBankAccountIndex) {
                $scope.appData.selectedBankAccountIndex = 0;
            }
            $scope.selectedBankAccountIndex = $scope.appData.selectedBankAccountIndex;

            if (!$scope.appData.shownCardIndex) {
                $scope.appData.shownCardIndex = 0;
            }

            $scope.members.numOfPayments = '';

            $scope.backBtn = "logout";

            //fbConversionService.fireRemarketingTag();
            //googleConversionService.fireRemarketingTag();

            for (var i = 0; i < $scope.appData.BankAccounts.length; i++) {
                $scope.appData.BankAccounts[i].allCreditProductsInd = false;
                var cardsToDisplay = [];
                for (var j = 0; j < $scope.appData.BankAccounts[i].Cards.length; j++) {
                    if ($scope.appData.BankAccounts[i].Cards[j].CreditProductsInd) {
                        $scope.appData.BankAccounts[i].Cards[j].CardIndex = j;
                        cardsToDisplay.push($scope.appData.BankAccounts[i].Cards[j]);
                    }
                }
                if (cardsToDisplay.length > 0) {
                    $scope.appData.BankAccounts[i].creditProductsCards = cardsToDisplay;
                    $scope.appData.BankAccounts[i].allCreditProductsInd = true;
                }
            }
            $scope.accountsToDisplay = $scope.appData.BankAccounts;

            $scope.stage = 1;

            if (!$scope.members.shownCardIndex) {
                $scope.members.shownCardIndex = 0;

                if ($scope.appData.BankAccounts[$scope.selectedBankAccountIndex].allCreditProductsInd) {
                    for (var k = 0; k < $scope.appData.BankAccounts[$scope.selectedBankAccountIndex].creditProductsCards.length; k++) {
                        if ($scope.appData.BankAccounts[$scope.selectedBankAccountIndex].creditProductsCards[k].CardIndex == $scope.appData.shownCardIndex) {
                            $scope.members.shownCardIndex = k;
                        }
                    }
                }
            }

            $scope.accountChanged($scope.selectedBankAccountIndex, $scope.members.shownCardIndex);
        };

        $scope.accountNext = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').next();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });
        }

        $scope.accountPrev = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').previous();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

        }

        $scope.accountChanged = function (index, cardIndex) {

            $scope.appData.selectedBankAccountIndex = index;

            $scope.selectedBankAccountIndex = index;

            $scope.selectedBankAccount = $scope.accountsToDisplay[index];

            if (cardIndex) {
                $scope.cardChanged(cardIndex);
                $scope.updateCardSlider(cardIndex);
            } else {
                $scope.cardChanged(0);
                $scope.updateCardSlider(0);
            }


        };

        $scope.cardChanged = function (index) {
            $scope.members.shownCardIndex = index;
            if ($scope.selectedBankAccount.allCreditProductsInd) {
                $scope.selectedCard = $scope.selectedBankAccount.creditProductsCards[$scope.members.shownCardIndex];
                $scope.noCardError = true;
                $scope.appData.shownCardIndex = $scope.selectedCard.CardIndex;

                if (!$scope.selectedCard.NewLoan)
                    $scope.selectedCard.NewLoan = false;

                $scope.getShownCardEligibility();
            } else {
                $scope.selectedCard = {};
                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
            }
        };

        $scope.updateAccountSlider = function (index) {
            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').update();
            }, 200).then(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').slide(index);
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

            return _promise;
        }

        $scope.updateCardSlider = function (index) {

            $scope.members.slideBoxReady = false;

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('c4uCardsHandler').update();
            }, 600).then(function () {
                $ionicSlideBoxDelegate.$getByHandle('c4uCardsHandler').slide(index);
            }).finally(function () {
                $scope.members.slideBoxReady = true;
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

            return _promise;
        }


        $scope.to = function (index) {
            $ionicSlideBoxDelegate.$getByHandle('c4uCardsHandler').slide(index);
        }

        $scope.getShownCardEligibility = function () {
            if (!$scope.selectedCard.EligibilityStatus || $scope.selectedCard.NewLoan) {
                getCardEligiblityStatus();
                $scope.selectedCard.NewLoan = false;
            } else
                setLoanParams();

            function setLoanParams() {
                $scope.requestedAmount.amount = Math.ceil($scope.selectedCard.EligibilityStatus.MinimalAmount.Value);
            }

            function getCardEligiblityStatus() {
                $scope.appData.showSpinner = true;
                lobbyUiService.loader.show();
                connection.getCardEligiblityStatus($scope.selectedCard.Id).then(function (response) {
                    var EligibilityStatus = {};

                    EligibilityStatus.AmountMultiple = response.AmountMultiple;
                    EligibilityStatus.AmountRangeInterval = response.AmountRangeInterval;

                    EligibilityStatus.CardCalIssuerInd = response.CardCalIssuerInd;
                    EligibilityStatus.MaximalAmount = response.MaximalAmount;
                    EligibilityStatus.MinimalAmount = response.MinimalAmount;
                    EligibilityStatus.NumberOfPaymentsInd = response.NumberOfPaymentsInd;
                    $scope.selectedCard.EligibilityStatus = EligibilityStatus;
                    if (!$scope.selectedCard.EligibilityStatus.NumberOfPaymentsInd) {
                        $scope.selectedCard.shownSteps = $scope.steps3;
                    } else {
                        $scope.selectedCard.shownSteps = $scope.steps4;
                    }
                    $scope.noCardError = true;
                    $scope.CardCalIssuerInd = $scope.selectedCard.EligibilityStatus.CardCalIssuerInd;
                    setLoanParams();

                    $scope.appData.showSpinner = false;
                    lobbyUiService.loader.hide();
                }, function (error) {
                    $scope.selectedCard.shownSteps = null;
                    $scope.noCardError = errorService.handleError(error, getCardEligiblityStatus);
                });
            }
        };

        $scope.goToStage2 = function () {
            //document.removeEventListener("backbutton", appData.onBackKeyDown, true);
            //document.addEventListener("backbutton", $scope.backEventHandler, true);

            $scope.appData.backOverrideFN = $scope.cancelLoan;

            if ($scope.selectedCard.EligibilityStatus.NumberOfPaymentsInd) {

                getLoanPaymentsRange();
            } else {
                $scope.goToStage3();
            }

            function getLoanPaymentsRange() {
                $scope.appData.showSpinner = true;
                lobbyUiService.loader.show();
                connection.getLoanPaymentsRange($scope.selectedCard.Id, $scope.requestedAmount.amount).then(function (response) {
                    $scope.currentStage = 2;
                    $scope.stage = 2;
                    $scope.accountsToDisplay = [$scope.selectedBankAccount];
                    $scope.selectedCard.EligibilityStatus.MaximalNumOfPayments = response.MaximalNumOfPayments;
                    $scope.selectedCard.EligibilityStatus.MinimalNumOfPayments = response.MinimalNumOfPayments;
                    $scope.members.numOfPayments = $scope.selectedCard.EligibilityStatus.MinimalNumOfPayments;

                    $scope.selectedCard.EligibilityStatus.payments = [];
                    for (var i = response.MinimalNumOfPayments; i < response.MaximalNumOfPayments + 1; i++)
                        $scope.selectedCard.EligibilityStatus.payments.push(i);
                    formatRequestAmount();

                    googleAnalyticsService.insertEvent({ page: 'Express loan', eventName: 'Express Loan Request - Continue', action: 'Continue' });
                    //googleConversionService.fireRemarketingTag();

                    $scope.appData.inProcess = true;
                    $scope.appData.showSpinner = false;
                    lobbyUiService.loader.hide();
                }, function (error) {
                    errorService.handleError(error, getLoanPaymentsRange);
                }).finally(function () {
                    $timeout(function () {
                        $ionicScrollDelegate.$getByHandle('expressScroll').scrollTop();
                    }, 0);
                });
            }

        };

        function formatRequestAmount() {

            var wantedAmount = $scope.requestedAmount.amount;
            $scope.requestedAmount.formated = '';
            for (var i = 1; i < ($scope.requestedAmount.amount + '').length + 1; i++) {
                if (i % 3 == 1 && i != 1) {
                    $scope.requestedAmount.formated = ',' + $scope.requestedAmount.formated;
                }
                $scope.requestedAmount.formated = wantedAmount % 10 + '' + $scope.requestedAmount.formated;
                wantedAmount = Math.floor(wantedAmount / 10);

            }
        }

        $scope.goToStage3 = function () {

            setTimeout(function () {
                getSimulateLoanRequest();
                $scope.appData.backOverrideFN = $scope.cancelLoan;
            });

            function getSimulateLoanRequest() {
                var payments = '';
                if ($scope.members.numOfPayments != '')
                    payments = parseInt($scope.members.numOfPayments);
                $scope.appData.showSpinner = true;
                lobbyUiService.loader.show();
                connection.getSimulateLoanRequest($scope.selectedCard.Id, $scope.requestedAmount.amount, payments).then(function (response) {
                    $scope.appData.showSpinner = false;
                    lobbyUiService.loader.hide();
                    $scope.accountsToDisplay = [$scope.selectedBankAccount];
                    $scope.currentStage = 3;

                    var eventName = 'Express Loan Payments  - Continue';

                    if (!$scope.selectedCard.EligibilityStatus.NumberOfPaymentsInd) {
                        $scope.stage = 2;
                        eventName = 'Cal Choice Express Loan Payments  - Continue';
                    } else
                        $scope.stage = 3;

                    $scope.SimulatedLoanRequest = {};
                    $scope.SimulatedLoanRequest.Comments = response.Comments;
                    $scope.SimulatedLoanRequest.AnnualNominalInterest = response.AnnualNominalInterest;
                    $scope.SimulatedLoanRequest.AnnualAdaptedInterest = response.AnnualAdaptedInterest;
                    $scope.SimulatedLoanRequest.MonthlyPaymentAmount = response.MonthlyPaymentAmount;
                    $scope.SimulatedLoanRequest.TermsDocumentURL = response.TermsDocumentURL;
                    $scope.SimulatedLoanRequest.TotalArbitrageIntrestPaymentAmount = response.TotalArbitrageIntrestPaymentAmount;
                    $scope.SimulatedLoanRequest.RequestedAmount = response.RequestedAmount;
                    $scope.SimulatedLoanRequest.NumberOfPayments = response.NumberOfPayments;
                    $scope.stage3GridData = getStage3GridData();

                    googleAnalyticsService.insertEvent({ page: 'Express loan', eventName: eventName, action: 'Continue' });
                    //googleConversionService.fireRemarketingTag();

                    $scope.appData.inProcess = true;
                    $scope.appData.showSpinner = false;
                    lobbyUiService.loader.hide();
                }, function (error) {
                    errorService.handleError(error, getSimulateLoanRequest);
                }).finally(function () {
                    $timeout(function () {
                        $ionicScrollDelegate.$getByHandle('expressScroll').scrollTop();
                    }, 0);
                });
            }

            function getStage3GridData() {
                var headers = [];
                var data = !$scope.selectedCard.EligibilityStatus.NumberOfPaymentsInd ?
                    [
                        ['סכום הלוואה ', $scope.SimulatedLoanRequest.RequestedAmount.ReversedFormattedValue],
                        ['הריבית הנומינלית השנתית היא', $scope.SimulatedLoanRequest.AnnualNominalInterest.ReversedFormattedValue]
                    ]
                    :
                    [
                        ['סכום הלוואה ', $scope.SimulatedLoanRequest.RequestedAmount.ReversedFormattedValue],
                        ['אופן פריסה', $scope.SimulatedLoanRequest.NumberOfPayments + ' תשלומים'],
                        ['סכום החזר חודשי', $scope.SimulatedLoanRequest.MonthlyPaymentAmount.ReversedFormattedValue],
                        ['הריבית הנומינלית השנתית היא', $scope.SimulatedLoanRequest.AnnualNominalInterest.ReversedFormattedValue]
                    ];
                var rowConfig = [{ clickable: false, cls: '' }, { clickable: false, cls: '' }, { clickable: false, cls: '' }, { clickable: false, cls: '' }];
                return { headers: headers, rows: data, rowConfig: rowConfig };
            };
        };

        $scope.goToStage4 = function () {
            if (!$scope.members.agreeToTerms) {
                var errMsg = 'יש לאשר את התקנון';
                if (navigator.notification)
                    navigator.notification.alert(
                        errMsg,
                        function () {
                        },
                        ' ',
                        'סגור'
                    );
                else {
                    lobbyUiService.popup.alert(errMsg, 'נא לשים לב');
                }
                return;
            }
            $scope.appData.backOverrideFN = null;
            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();
            connection.getApproveLoanRequest($scope.selectedCard.Id).then(function (response) {

                $scope.currentStage = 4;

                var eventName = 'Express Loan Approval - Confirm';

                if (!$scope.selectedCard.EligibilityStatus.NumberOfPaymentsInd) {
                    $scope.stage = 3;
                    eventName = 'Cal Choice Express Loan Approval - Confirm';
                } else
                    $scope.stage = 4;


                $scope.ApprovedLoan = response;
                

                googleAnalyticsService.insertEvent({ page: 'Express loan', eventName: eventName, action: 'Confirm' });

                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
                if ($scope.members.agreeToTerms)
                    delete $scope.members.agreeToTerms;
            }, function (error) {
                errorService.handleError(error, $scope.goToStage4);
            }).finally(function () {
                $timeout(function () {
                    $ionicScrollDelegate.$getByHandle('expressScroll').scrollTop();
                }, 0);
                $scope.appData.inProcess = false;
            });
        };

        $scope.newLoan = function () {
            googleAnalyticsService.insertEvent({ page: 'Express Loans', eventName: 'Express Loan Approved - Another Request', action: 'Approval' });
            $scope.selectedCard.NewLoan = true;
            $scope.init();
        };

        $scope.cancelLoan = function () {

            var buttonLabels = { ok: 'אישור', cancel: 'ביטול' };
            var msg = 'נתוני הבקשה לא ישמרו';
            var title = 'האם ברצונך לעזוב את בקשת ההלוואה?';
            var ua = navigator.userAgent.toLowerCase();

            var buttonLableText = '';

            if (navigator.notification) {
                if (ua.indexOf("android") > -1)
                    buttonLableText = buttonLabels.ok + (buttonLabels.cancel ? (',' + buttonLabels.cancel) : '');
                else
                    buttonLableText = (buttonLabels.cancel ? (buttonLabels.cancel + ',') : '') + buttonLabels.ok;

                navigator.notification.confirm(
                    msg,
                    callback,
                    title,
                    buttonLableText
                );

            } else {
                callback(confirm(title + "\n" + msg));
            }

            function callback(button) {
                if (ua.indexOf("iphone") > -1 && buttonLableText.indexOf(',') > -1)
                    if (button == 1)
                        button = 2;
                    else
                        button = 1;
                if (button == 1 || button == true) {
                    if ($scope.members.agreeToTerms)
                        delete $scope.members.agreeToTerms;
                    $scope.goBackToStage();

                } else {
                    return;
                }
            }
        }

        $scope.goBackToStage = function () {

            if ($scope.members.showTerms) {

                $timeout(function () {
                    $scope.members.title = 'הלוואת אקספרס';
                    $scope.members.showTerms = false;
                }, 0);
                $scope.appData.backOverrideFN = $scope.cancelLoan;
                return;
            }

            googleAnalyticsService.insertEvent({ page: 'Express Loans', eventName: 'Express Loan Request - Back', action: 'Back' });

            $scope.appData.inProcess = false;

            $scope.appData.backOverrideFN = null;

            $scope.selectedCard.NewLoan = true;

            $scope.init();
        }

        $scope.$on("$destroy", function () {
            $scope.appData.backOverrideFN = null;
            $scope.appData.inProcess = false;

            if ($scope.selectedCard)
                $scope.selectedCard.NewLoan = true;
        });

        $scope.goToInfo = function () {
            $scope.title = 'תקנון התכנית';
            $scope.members.showTerms = true;
            $scope.appData.backOverrideFN = $scope.goBackToStage;
        };

        $scope.backEventHandler = function () {
            $timeout($scope.goBackToStage, 0, true);
            return true;
        };

        $scope.init();
    }

})(window, window.angular);










﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('fixedPayoutController', fixedPayoutController);

    fixedPayoutController.$inject = [
        '$rootScope', 'commService', '$scope', 'connection', 'appData', 'lobbyUiService', 'errorService', '$ionicScrollDelegate', 'googleAnalyticsService', '$timeout', '$interval', '$ionicSlideBoxDelegate', 'customerIndication'
    ];

    function fixedPayoutController($rootScope,commService,$scope, connection, appData, lobbyUiService, errorService, $ionicScrollDelegate, googleAnalyticsService, $timeout, $interval, $ionicSlideBoxDelegate, customerIndication) {
        $scope.appData = appData;
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.lobbyUiService = lobbyUiService;
        $scope.requestedAmount;
        $scope.progress = 20;
        $scope.currCards;
        $scope.uniqueId;
        $scope.uniqueIDChosen;
        $scope.members = {
            title: 'חיוב חודשי קבוע',
            showTerms: false
        }
        
        
        $rootScope.$on("bankFromHost", function (evt, bankId) {
            console.log("[DW][Listener]", bankId)
            var banks = $scope.appData.BankAccounts.map(function (b) { return commService.cutExistingBankIdWorkAround(b) });
            var idx = banks.indexOf(bankId);
            console.log("[DW] index", idx);
            if (idx == -1) idx = 0;
            $scope.accountChanged(idx)
        })



        $rootScope.$on("cardFromHost", function (evt, cardId) {
            console.log("selectedcard on blockCard", cardId)
            $scope.cardChanged(cardId);
            $scope.uniqueId = cardId;
        })

        $scope.doc = {
            url: '/CalDocs?id=fixedDebitTerms.html'
        }

        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        $scope.hideNavBar = inIframe();


        $scope.init = function () {
            $scope.currCards = [];
            $scope.uniqueId = null;
            $scope.uniqueIDChosen = 0;
            $scope.requestedAmount = {
                amount: 0,
                formated: ''
            }
            $scope.steps = [{ caption: 'סכום', active: true }, { caption: 'פרטים', active: false }, { caption: 'סיום', active: false }];
            $scope.noCardError = false;
            $scope.appData.showSpinner = true;
            $scope.appData.backOverrideFN = null;
            $scope.appData.inProcess = false;
            $scope.appData.CustomerInfo.Phone = modifyPhone($scope.appData.CustomerInfo.Phone);

            if (!$scope.appData.isLoggedIn) {
                lobbyUiService.go('dw.login', { nextPage: 'dw.fixedPayout' }, { location: 'replace' });
                return;
            }
            $scope.hideNavBar;


            googleAnalyticsService.insertEvent({ page: 'Credit Solutions', eventName: 'Enter Monthly Payments Rerquest', action: 'Enter' });

            //$timeout(function () {
            //    $ionicScrollDelegate.$getByHandle('fixedpayoutScroll').scrollTop();
            //}, 0);

            if (!$scope.appData.selectedBankAccountIndex) {
                $scope.appData.selectedBankAccountIndex = 0;
            }
            $scope.selectedBankAccountIndex = $scope.appData.selectedBankAccountIndex;
            

            $scope.backBtn = "logout";
            for (var i = 0; i < $scope.appData.BankAccounts.length; i++) {
                $scope.appData.BankAccounts[i].allCreditProductsInd = false;
                var cardsToDisplay = [];
                for (var j = 0; j < $scope.appData.BankAccounts[i].Cards.length; j++) {
                    if ($scope.appData.BankAccounts[i].Cards[j].CreditProductsInd) {
                        $scope.appData.BankAccounts[i].Cards[j].CardIndex = j;
                        cardsToDisplay.push($scope.appData.BankAccounts[i].Cards[j]);
                    }
                }
                if (cardsToDisplay.length > 0) {
                    $scope.appData.BankAccounts[i].creditProductsCards = cardsToDisplay;
                    $scope.appData.BankAccounts[i].allCreditProductsInd = true;
                }
            }
            $scope.accountsToDisplay = $scope.appData.BankAccounts;
            $scope.selectedBankAccount = $scope.appData.BankAccounts[$scope.selectedBankAccountIndex];
            if (!$scope.currCards || $scope.currCards.length == 0) {
                $scope.fillCards();
            }

            if ($scope.currentStage && $scope.currentStage > 1) {
                $scope.accountChanged($scope.selectedBankAccountIndex, $scope.uniqueId);
            }
            if ($scope.selectedCard != null) {
                $scope.cardChanged($scope.selectedCard.Id);
            }
            else {
                $scope.cardChanged($scope.selectedBankAccount.creditProductsCards[0].Id);
            }
            $('body').removeClass('finish');
            $scope.currentStage = 1;
            commService.showBackButton(false);
            $scope.appData.showSpinner = false;
            //var realHeight = document.getElementById("realHeightFixedPayout").scrollHeight;
            //console.log("relaHeight", realHeight)
            commService.trigReady();
        };

        $scope.getActivePage = function (page) {
            if ($scope.steps == null || $scope.steps == undefined) {
                $scope.steps = [{ caption: 'סכום', active: false }, { caption: 'פרטים', active: false }, { caption: 'סיום', active: false }];
            }
            else {
                for (var i = 0; i < $scope.steps.length; i++) {
                    $scope.steps[i].active = false;
                }
            }
            $scope.steps[page].active = true;
        }
        $scope.accountNext = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').next();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });
        }

        $scope.accountPrev = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').previous();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

        }

        $scope.accountChanged = function (index, cardIndex) {

            $scope.appData.selectedBankAccountIndex = index;

            $scope.selectedBankAccountIndex = index;

            $scope.selectedBankAccount = $scope.accountsToDisplay[index];
            //fix on change #103993
           // $scope.fillCards();
            $scope.requestedAmount = { amount: 0 };

            if ($scope.selectedBankAccount.allCreditProductsInd) {
                if (cardIndex) {
                    $scope.cardChanged(cardIndex);
                } else {
                    $scope.cardChanged($scope.selectedBankAccount.creditProductsCards[0].Id);
                }

            } else {
                lobbyUiService.loader.hide();
                $scope.appData.showSpinner = false;
            }
            $timeout(function () {
                $scope.updateAccountSlider(index);
                $scope.fillCards();
            })
        };

        $scope.cardChanged = function (uniqueIDChosen) {

            $scope.uniqueId = uniqueIDChosen;

            for (var j = 0; j < $scope.selectedBankAccount.creditProductsCards.length; j++) {
                if (uniqueIDChosen == $scope.selectedBankAccount.creditProductsCards[j].Id) {
                    $scope.selectedCard = $scope.selectedBankAccount.creditProductsCards[j];
                }
            }

            $scope.getFixedDebitStatus();
        };

        $scope.fillCards = function () {
            $scope.currCards = $scope.appData.BankAccounts[$scope.selectedBankAccountIndex].creditProductsCards;
        };

        $scope.operation = function () {
            console.log('vm.operation');
        };

        $scope.updateAccountSlider = function (index) {
            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').update();
            }, 200).then(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').slide(index);
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

            return _promise;
        }

        $scope.fixedDebitStatusForCreditPopup = 0;

        $scope.getFixedDebitStatus = function () {

            if (!$scope.selectedCard.FixedDebitStatus) {

                $scope.appData.showSpinner = true;

                lobbyUiService.loader.show();

                connection.getFixedDebitStatus($scope.selectedCard.Id).then(function (response) {

                    var FixedDebitStatus = {};
                    FixedDebitStatus.AmountMultiple = response.AmountMultiple;
                    FixedDebitStatus.AmountRangeInterval = response.AmountRangeInterval;
                    FixedDebitStatus.FixedDebitStatus = response.FixedDebitStatus;
                    $scope.fixedDebitStatusForCreditPopup = response.FixedDebitStatus;
                    FixedDebitStatus.MaximalAmount = response.MaximalAmount;
                    FixedDebitStatus.MinimalAmount = response.MinimalAmount;
                    FixedDebitStatus.CurrentFixedDebit = response.CurrentFixedDebit;
                    FixedDebitStatus.isNextDebitAmountB = response.isNextDebitAmountB;
                    $scope.selectedCard.fixedDebit = FixedDebitStatus;


                    $scope.noCardError = true;
                    setLoanParams();
                    lobbyUiService.loader.hide();

                }, function (error) {
                    $scope.noCardError = errorService.handleError(error, $scope.getFixedDebitStatus);
                });
            } else
                setLoanParams();
            $scope.appData.showSpinner = false;
            function setLoanParams() {

                $scope.requestedAmount.amount = "";

            };
        };

        $scope.goToStage2 = function () {




            //disable submit with tab
            if (event.keyCode == 9 || event.keyCode == 13) {
                console.log("9 13");
                return;

            }

            console.log("requestaetAmount", $scope.requestedAmount.amount);
            console.log("scope", $scope.selectedCard.fixedDebit);

            if ($scope.requestedAmount.amount == "" || !Number.isInteger(parseInt($scope.requestedAmount.amount))) {
                lobbyUiService.popup.alert('יש להגדיר סכום לחיוב חודשי');
                return;
            }
            
            if (parseInt($scope.requestedAmount.amount) % parseInt($scope.selectedCard.fixedDebit.AmountMultiple) != 0) {
                lobbyUiService.popup.alert("יש לבחור סכום החיוב החודשי בכפולות של " + $scope.selectedCard.fixedDebit.AmountMultiple)
                return;
            }

            if (parseInt($scope.requestedAmount.amount) < parseInt($scope.selectedCard.fixedDebit.MinimalAmount.Value)) {
                lobbyUiService.popup.alert("סכום החיוב החודשי המבוקש נמוך מהסכום המינימלי האפשרי")
                return;
            }

            if (parseInt($scope.requestedAmount.amount) > parseInt($scope.selectedCard.fixedDebit.MaximalAmount.Value)) {
                lobbyUiService.popup.alert("סכום החיוב החודשי המבוקש גבוה מהסכום המקסימלי האפשרי")
                return;
            }


            if (parseInt($scope.requestedAmount.amount) == parseInt($scope.selectedCard.fixedDebit.CurrentFixedDebit.Value)) {
                lobbyUiService.popup.alert("סכום החיוב שבחרת הינו זהה לסכום החיוב הנוכחי. יש לבחור סכום שונה")
                return;
            }
            console.log("arrived");


            $scope.appData.backOverrideFN = function () {
                console.log("backOVerrideFN??");
                $scope.init();
                $scope.getActivePage(0);
                return;
            }

            //if it's new Hahak..
            if ($scope.fixedDebitStatusForCreditPopup == 1) {
                console.log("custindpopups");
                commService.sendHeight(900);
                $scope.customerIndicationsPopUp();

            }
            else {
                console.log("really go to stage 2");
                $scope.reallyGoToStage2();
            }


        };



        function showErrorPopup() {
            var popup = {};
            popup.btns = [];
            popup.btns.push(
                {
                    text: "אישור",
                    type: 'button-positive',
                    onTap: function () {
                        return;
                    }
                });
            lobbyUiService.popup.alert("לא ניתן להשלים את הפעולה כרגע, אנא נסה שנית מאוחר יותר.", null, null, null, popup.btns, true, null);
        }

        $scope.reallyGoToStage2 = function () {
            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();
            angular.element("ion-content").removeClass("has-sub-header");
            angular.element("ion-content").addClass("has-step-wizard");
            $scope.getActivePage(1);
            //$timeout(function () {
            //    $ionicScrollDelegate.$getByHandle('fixedpayoutScroll').scrollTop();
            //}, 0);

            connection.getFixedDebitDiscloser($scope.selectedCard.Id, $scope.requestedAmount.amount).then(function (response) {
                $scope.SimulatedLoanRequest = {};
                $scope.accountsToDisplay = [$scope.selectedBankAccount];
                $scope.SimulatedLoanRequest.Comments = response.Comments;
                $scope.SimulatedLoanRequest.AnnualAdaptedInterest = response.AnnualAdaptedInterest;
                $scope.SimulatedLoanRequest.NominalEffectiveInterestRatePercent = response.NominalEffectiveInterestRatePercent;
                $scope.SimulatedLoanRequest.TermsDocumentURL = response.TermsDocumentURL;
                $scope.SimulatedLoanRequest.TotalArbitrageIntrestPaymentAmount = response.TotalArbitrageIntrestPaymentAmount;
                $scope.SimulatedLoanRequest.RequestedAmount = response.RequestedAmount;
                $scope.SimulatedLoanRequest.TotalArbitrageIntrestPaymentAmount = response.TotalArbitrageIntrestPaymentAmount;
                $scope.SimulatedLoanRequest.TransComissionSumAmount = response.TransComissionSumAmount;
                $scope.SimulatedLoanRequest.ActualInterestRate = response.ActualInterestRate;
                $scope.SimulatedLoanRequest.ArrearInterest = response.ArrearInterest;

                var fixedInterest = response.FixInterestWithoutPrime.Value;
                $scope.SimulatedLoanRequest.AnnualNominalInterest = "(P" + (fixedInterest >= 0 ? " + " : " - ") + Math.abs(fixedInterest) + "%) " + response.AnnualNominalInterest.ReversedFormattedValue;

                $scope.DisclosureKey = response.StoredDiscloserKey;
                $('body').removeClass('finish');
                $scope.currentStage = 2;
                commService.showBackButton(true);
                $scope.appData.inProcess = true;
                
                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();




                if ($scope.selectedCard.fixedDebit.CurrentFixedDebit && $scope.selectedCard.fixedDebit.CurrentFixedDebit.Value > 0) {
                    googleAnalyticsService.insertEvent({ page: 'Monthly Payments', eventName: 'Update Payment - Continue', action: 'Update' });
                } else {
                    googleAnalyticsService.insertEvent({ page: 'Monthly Payments', eventName: 'Set New Payment - Continue', action: 'Continue' });
                }

                $scope.lblCangeIntoEffectComment = response.WhenCangeIntoEffectComment;


            }, function (error) {
                errorService.handleError(error, $scope.goToStage2);
            });
        }


        $scope.$on("$destroy", function () {
            $scope.appData.backOverrideFN = null;
            $scope.appData.inProcess = false;
        });

        $scope.goToStage3 = function () {
            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();
            $scope.getActivePage(2);
            $scope.appData.backOverrideFN = null;

            //$timeout(function () {
            //    $ionicScrollDelegate.$getByHandle('fixedpayoutScroll').scrollTop();
            //}, 0);

            connection.putFixedDebitStatus($scope.selectedCard.Id).then(function (response) {

                $('body').addClass('finish');
                parent.postMessage({ call: "dwProcessEnd" }, '*');
                $scope.currentStage = 3;
                commService.showBackButton(false);
                $scope.selectedCard.CardsSpecs = null;
                $scope.appData.inProcess = false;
                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
                commService.getBigNumberAndDetails();

                googleAnalyticsService.insertEvent({ page: 'Monthly Payments', eventName: 'Set New Payment - Confirm', action: 'Confirm' });

            }, function (error) {
                errorService.handleError(error, $scope.goToStage3);
            });
        };

        $scope.toggleInfoPopup = function () {
            $('body').removeClass('finish');
            $scope.currentStage = $scope.currentStage === 0 ? 1 : 0;
            //$timeout(function () {
            //    $ionicScrollDelegate.$getByHandle('fixedpayoutScroll').scrollTop();
            //}, 0);
        };

        $scope.backToHomePage = function () {
            commService.backToHomePage();
        }

        $scope.showMoreInfo = function () {
            var popup = {};
            popup.template = 'app/account/templates/fixedPayoutMoreInfo.html'
            popup.btns = [];
            popup.btns.push(
                {
                    text: "סגור",
                    type: 'button-positive',
                    onTap: function () {



                    }
                });
            lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, true);
        }
        $scope.$on('$ionicView.beforeLeave', function (e, viewData) {
            console.log('******************fixPayout*******************');
            $('body').removeClass('finish');

        });
        $scope.$on('$ionicView.beforeEnter', function (e, viewData) {
            console.log('******************fixPayout before enter*******************');
            $scope.init();

        });
        $scope.customerIndicationsPopUp = function () {

            var request = {
                processType: 1,
                cardUniqueId: $scope.selectedCard.Id,
                CustExtTypeCode: appData.CustomerInfo.IdNumType,
                CustExtId: appData.CustomerInfo.Id
            }
            connection.getCreditInfoConsentIndication(request).then(getCreditInfoConsentIndicationOnSuccess, getCreditInfoConsentIndicationOnError);
        }

        function getCreditInfoConsentIndicationOnSuccess(res) {
            console.log("res", res);
            if (res.IsCollectAgreement && res.AccountsForAgreement != null && res.AccountsForAgreement.length > 0) {
                angular.extend($scope, {
                    selectedCardForApprove: $scope.selectedCard.Id,
                    BankName: res.AccountsForAgreement[0].BankName,
                    typeInd: "הצטרפות לחיוב חודשי קבוע",

                    typeIndHeader: `
כדי להצטרף לתכנית חיוב חודשי קבוע,
אנחנו צריכים לקבל את אישורך לפנות למאגר האשראי של בנק ישראל.
אם לא נקבל את אישורך, לא יהיה ניתן להצטרף לתכנית.
`,
                    disagreeError: "להסכמתך לפנייה למאגר אשראי ישנה חשיבות והשפעה על תהליך ההצטרפות לתכנית, וללא הסכמתך לא נוכל להמשיך בתהליך",


                    Account4LastDigits: res.AccountsForAgreement[0].Account4LastDigits,
                    languages: res.Languages//[{ 'languageId': '1', 'languageName': 'עברית' }, { 'languageId': '2', 'languageName': 'אנגלית' }, { 'languageId': '3', 'languageName': 'רוסית' }],
                });

                customerIndication.creditCustomerIndication($scope, userAgreedCreditConsentCallBack, res.AgreementId);

                ga('send', 'event', { eventCategory: 'איסוף הסכמות למאגר אשראי בתהליך הצטרפות לחיוב חודשי קבוע', eventAction: 'הופעת מסך הסכמה', eventLabel: '', nonInteraction: true })

            }
            else {
                console.log("gotoStage2");
                $scope.reallyGoToStage2();
            }

        }
        function userAgreedCreditConsentCallBack() {
            console.log("gotoStage2");
            $scope.reallyGoToStage2();
        }

        function getCreditInfoConsentIndicationOnError(res) {
            showErrorPopup();
        }

        function modifyPhone(phoneNumber) {
            var modifiedPhone = '';
            if (phoneNumber != null) {
                modifiedPhone = phoneNumber.replace(/(\d{3})(\d)/, "$1-$2");
            }

            return modifiedPhone;
        }
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('infoController', infoController);

    infoController.$inject = [
        '$scope', 'connection', 'appData', 'lobbyUiService'
    ];

    function infoController($scope, connection, appData, lobbyUiService) {

        $scope.appData = appData;

        $scope.title = "מידע נוסף";

        $scope.cashAccountTag = "cash account";

        $scope.init = function () {

            if (!$scope.appData.comments) {
                lobbyUiService.go('dw.login');
                return;
            }
            var cashAccountCommentElement = $scope.appData.comments.find(comment => comment.Tag == $scope.cashAccountTag);
            if (cashAccountCommentElement != null) {
                $scope.cashAccountComment = cashAccountCommentElement.Text;
            }
            

        };

        $scope.init();
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('myAccountController', myAccountController);

    myAccountController.$inject = [
        '$scope', 'connection', '$window', 'appData', 'lobbyUiService', '$rootScope', '$q', '$timeout', 'utilService', 'errorService', 'ssoService',
        '$ionicScrollDelegate', 'googleAnalyticsService', '$sce', '$ionicSlideBoxDelegate', 'dataService'
    ];

    function myAccountController($scope, connection, $window, appData, lobbyUiService, $rootScope, $q, $timeout, utilService, errorService, ssoService,
        $ionicScrollDelegate, googleAnalyticsService, $sce, $ionicSlideBoxDelegate, dataService) {

        //#region members declaration
        $scope.appData = appData;

        $scope.title = "עסקות וחיובים";

        $scope.appData.isLoggedIn = connection.isLoggedIn();


        $timeout(function () {
            $ionicScrollDelegate.$getByHandle('transInnerScroll').scrollTo(0, $scope.appData.position, true);
        }, 1000);


        if (!$scope.appData.metaData) {
            // cal4u
            connection.getMetaData().then(function (response) {
                $scope.appData.metaData = response;
            }, function (error) {
                errorService.handleError(error, $scope.init);
            });
        }

        $scope.lobbyUiService = lobbyUiService;

        $scope.appData.myAccount = $scope.appData.myAccount || {};

        $scope.members =
            {
                gClass: "details-grid",
                cardDataReady: false,
                slideBoxReady: false
            };

        $scope.transactionsShowing = {
            isShowing: false,
            showLastTransactions: false,
            showNextTransactions: false,
            showTransactions: '',
            loadMore: false
        };

        //#endregion

        $scope.init = function () {

            $scope.accountDataIsMissing = false;
            if (!$scope.appData.isLoggedIn) {
                lobbyUiService.go('dw.login', { nextPage: 'dw.myaccount' }, { location: 'replace' });
                return;
            }

            $scope.members.cardDataReady = false;

            $timeout(function () {
                $ionicScrollDelegate.$getByHandle('myaccountScroll').scrollTop();
            }, 0);

            googleAnalyticsService.insertEvent({ page: 'My account', eventName: 'My account', action: 'Enter' });

            if (!$scope.appData.selectedBankAccountIndex)
                $scope.appData.selectedBankAccountIndex = 0;
            if (!$scope.appData.shownCardIndex)
                $scope.appData.shownCardIndex = 0;

            $scope.selectedBankAccount = $scope.appData.BankAccounts[$scope.appData.selectedBankAccountIndex];

            if (!$scope.selectedBankAccount) {
                return;
            }

            if ($scope.selectedBankAccount.BankAllCardsAddedInd)
                $scope.selectTab('bankAccount');
            else
                $scope.selectTab('shownCard');

            $scope.selectedCard = $scope.selectedBankAccount.Cards[$scope.appData.shownCardIndex];

            if ($scope.selectedCard) {
                $scope.updateCardSlider($scope.appData.shownCardIndex);
            }
            var loginEnum = { userName: 0, otp: 1 }
            var loginTypeObject = dataService.sessionManager.read('loginType') || { description: 'otp', value: loginEnum.otp };
            if (loginTypeObject.value == loginEnum.userName) {
                $scope.getAllBankDebits();
            }

            if ($scope.appData.myAccount.lastCard == $scope.selectedCard.LastFourDigits) {

                if ($scope.appData.myAccount.status == 1) { // past Charges
                    $scope.title = 'חיובים קודמים';
                    $scope.transactionsShowing.showLastTransactions = true;
                    $scope.transactionsShowing.showNextTransactions = false;
                    $scope.transactionsShowing.showTransactions = 'last';

                    $scope.setTransactionGrigHeight('last', $scope.appData.myAccount.transGridTopLast);

                } else if ($scope.appData.myAccount.status == 2) { // future charges
                    $scope.title = 'חיובים קרובים';
                    $scope.transactionsShowing.showLastTransactions = false;
                    $scope.transactionsShowing.showNextTransactions = true;
                    $scope.transactionsShowing.showTransactions = 'next';

                    $scope.setTransactionGrigHeight('next', $scope.appData.myAccount.transGridTopNext);
                }
            }

            lobbyUiService.loader.show();

            $scope.getBankCard($scope.appData.selectedBankAccountIndex, $scope.appData.shownCardIndex);

            $scope.getUserBenefitsBalance();
        };


        $scope.getUserBenefitsBalance = function () {
            $scope.bnftsError = false;
            var date = new Date();
            var month = date.getMonth() + 1;
            if (month < 10)
                month = "0" + month;
            else
                month.toString();
            var year = date.getFullYear().toString();
            var currentMonth = month + '/' + year;

            var request = {
                EligibilityMonth: currentMonth
            };

            connection.getUserBenefitsBalance(request).then(function (response) {
                if (response.UserBenefits != null) {
                    $scope.userBenefits = response.UserBenefits;
                    if ($scope.selectedCard.NumType != 36) {
                        $scope.bnftsShared = response.BenefitsErrorCal;
                        if (response.UserBenefits["0"].StoreUrl.toLowerCase().indexOf("cal") > 0) {
                            $scope.bnftsBrand = response.UserBenefits["0"].StoreUrl;
                            $scope.linkToStoreApp = response.UserBenefits["0"].LinkToStoreApp;

                        }
                        else {
                            $scope.bnftsBrand = response.UserBenefits["1"].StoreUrl;
                            $scope.linkToStoreApp = response.UserBenefits["1"].LinkToStoreApp;
                        }
                    }
                    else {
                        $scope.bnftsShared = response.BenefitsErrorDiners;
                        if (response.UserBenefits["0"].StoreUrl.toLowerCase().indexOf("diners") > 0) {
                            $scope.bnftsBrand = response.UserBenefits["0"].StoreUrl;
                            $scope.linkToStoreApp = response.UserBenefits["0"].LinkToStoreApp;
                        }
                        else {
                            $scope.bnftsBrand = response.UserBenefits["1"].StoreUrl;
                            $scope.linkToStoreApp = response.UserBenefits["1"].LinkToStoreApp;
                        }
                    }
                }
                else {
                    $scope.bnftsError = true;
                    //$scope.bnftsError = response.Response.Status.Message;
                    $scope.bnftsErrorTxt = response.BenefitsErrorCal;
                    $scope.bnftsErrorUrlTxt = "לחנות החוויות >";
                }
                $scope.bnftsComment = response.CommentApp;
            }, function (error) {
                errorService.handleError(error);
            });
        };

        $scope.goToBnftsStore = function (url) {
            if (typeof (url) == 'undefined')
                url = "https://www.cal-store.co.il";
            var options = {
                "sso": true,
                "type": "2"
            };
            lobbyUiService.navigate(url, options);
        };

        $scope.isPageReady = function () {
            return $scope.members.slideBoxReady;
        };

        //#region sliders

        $scope.accountNext = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').next();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });
        }

        $scope.accountPrev = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').previous();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

        }

        $scope.accountSlideChange = function (index) {

            $scope.members.cardDataReady = false;

            lobbyUiService.loader.show();

            $scope.appData.selectedBankAccountIndex = index;

            $scope.selectedBankAccount = $scope.appData.BankAccounts[index];

            if ($scope.selectedBankAccount.BankAllCardsAddedInd)
                $scope.selectTab('bankAccount');
            else
                $scope.selectTab('shownCard');

            $scope.getBankDebit(index);

            $scope.onCardSlider(0);

            $scope.updateCardSlider(0);

            $scope.transactionsShowing.showLastTransactions = false;

            $scope.transactionsShowing.showNextTransactions = false;

            $timeout(function () {
                $ionicScrollDelegate.$getByHandle('transInnerScroll').scrollTop();
            }, 0);


        }

        $scope.updateAccountSlider = function (index) {
            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').update();
            }, 200).then(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').slide(index);
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

            return _promise;
        }

        $scope.updateCardSlider = function (index) {

            $scope.members.slideBoxReady = false;

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('c4uCardsHandler').update();
            }, 600).then(function () {
                $ionicSlideBoxDelegate.$getByHandle('c4uCardsHandler').slide(index);
            }).finally(function () {
                $scope.members.slideBoxReady = true;
                lobbyUiService.loader.hide();
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

            return _promise;
        }

        $scope.to = function (index) {
            $ionicSlideBoxDelegate.$getByHandle('c4uCardsHandler').slide(index);
        }

        $scope.onCardSlider = function (index) {
            $scope.appData.myAccount.status = 0;
            $scope.title = "עסקות וחיובים";
            if ($scope.appData.BankAccounts) {
                $scope.appData.shownCardIndex = index;
                $scope.getBankCard($scope.appData.selectedBankAccountIndex, $scope.appData.shownCardIndex)
                $scope.selectedCard = $scope.selectedBankAccount.Cards[$scope.appData.shownCardIndex];
                $scope.fillChartData();
                $scope.transactionsShowing.showLastTransactions = false;
                $scope.transactionsShowing.showNextTransactions = false;
            }
        }

        $scope.getBankCards = function (index) {

            if (!index) {
                index = 0;
            }

            for (var i = 0; i < $scope.appData.BankAccounts[index].Cards.length; i++) {

                if (!$scope.appData.BankAccounts[index].Cards[i].CardsSpecs) {
                    getBackCardData(index, i);
                }

                if (!$scope.appData.BankAccounts[index].Cards[i].Debits) {
                    getBankCardDebits(index, i);
                } else
                    $scope.fillChartData();

                if ($scope.appData.BankAccounts[index].Cards[i].CardType.includes("מיידי")) {
                    $scope.appData.BankAccounts[index].Cards[i].IsMiyadiCard = true;
                }
            }

            function getBackCardData(bankIndex, cardIndex) {
                if (!$scope.appData.BankAccounts[bankIndex].Cards[cardIndex].IsInternetPermitted) {
                    return;
                }
                return connection.getCardData($scope.appData.BankAccounts[bankIndex].Cards[cardIndex].Id).then(function (response) {

                    if (response.CardSpecs) {
                        response.CardSpecs.cardTitle = $scope.appData.BankAccounts[bankIndex].Cards[cardIndex].IsCalChoiceCard ? "CalChoice" : "כרטיס";
                        response.CardSpecs.cardNextDebitTitle = response.CardSpecs.HHKFixedDebitAmount ? "סך עסקות" : "חיוב קרוב";

                        if (response.CardSpecs.HHKFixedDebitAmount) {


                            var strNextDebitAmount = '<a id="hhkCommentLink" style="font-weight:bold;color:#ffffff;">' + response.CardSpecs.HHKFixedDebitAmount.ReversedFormattedValue.replace("₪", "") + '</a>';

                            var comment = utilService.stringFormat(response.CardSpecs.HHKNextDebitComment, strNextDebitAmount, response.CardSpecs.HHKNextDebitAmount.ReversedFormattedValue.replace("₪", ""));

                            response.CardSpecs.fixedDebitsComment = $sce.trustAsHtml(comment);

                            $timeout(function () {
                                $('#hhkCommentLink').ready(function () {
                                    $('#hhkCommentLink').on('click', function () {
                                        lobbyUiService.go('dw.fixedPayout');
                                    });
                                });
                            }, 0);
                        }

                        if (response.CardSpecs.isDinersExtra) {
                            response.CardSpecs.AccumulationExeText = $sce.trustAsHtml(response.CardSpecs.AccumulationExeText);
                        }
                    }
                    $scope.appData.BankAccounts[bankIndex].Cards[cardIndex].CardsSpecs = response.CardSpecs;
                }, function (error) {
                    if (cardIndex == $scope.appData.shownCardIndex && bankIndex == $scope.appData.selectedBankAccountIndex) {
                        errorService.handleError(error, $scope.getBankCards);
                    }
                });
            };

            function getBankCardDebits(bankIndex, cardIndex) {
                if (!$scope.appData.BankAccounts[bankIndex].Cards[cardIndex].IsInternetPermitted) {
                    return;
                }
                connection.getBankDebits($scope.appData.BankAccounts[bankIndex].AccountID, 'C', 1, '', '', '', '', $scope.appData.BankAccounts[bankIndex].Cards[cardIndex].Id).then(function (response) {

                    $scope.appData.BankAccounts[bankIndex].Cards[cardIndex].Debits = response.Debits;
                    $scope.appData.BankAccounts[bankIndex].Cards[cardIndex].lastMonthDebit = response.Debits[response.Debits.length - 1];
                    $scope.appData.BankAccounts[bankIndex].Cards[cardIndex].TotalAmount = response.TotalAmount;
                    if (cardIndex == $scope.appData.shownCardIndex && bankIndex == $scope.appData.selectedBankAccountIndex) {
                        $scope.fillChartData();
                    }
                }, function (error) {
                    if (cardIndex == $scope.appData.shownCardIndex && bankIndex == $scope.appData.selectedBankAccountIndex) {
                        $scope.accountDataIsMissing = true;
                        errorService.handleError(error, getBankCardDebits);
                    }
                });
            };
        };

        //#endregion

        $scope.getBankCard = function (bankIndex, cardIndex) {

            if (!bankIndex) {
                bankIndex = 0;
            }
            if (!cardIndex) {
                cardIndex = 0;
            }
            if (!$scope.appData.BankAccounts[bankIndex].Cards[cardIndex].CardsSpecs) {
                getBackCardData(bankIndex, cardIndex);
            }

            if (!$scope.appData.BankAccounts[bankIndex].Cards[cardIndex].Debits) {
                getBankCardDebits(bankIndex, cardIndex);
            } else
                $scope.fillChartData();

            if ($scope.appData.BankAccounts[bankIndex].Cards[cardIndex].CardType.includes("מיידי")) {
                $scope.appData.BankAccounts[bankIndex].Cards[cardIndex].IsMiyadiCard = true;
            }


            function getBackCardData(bankIndex, cardIndex) {
                if (!$scope.appData.BankAccounts[bankIndex].Cards[cardIndex].IsInternetPermitted) {
                    return;
                }
                
                return connection.getCardData($scope.appData.BankAccounts[bankIndex].Cards[cardIndex].Id).then(function (response) {

                    if (response.CardSpecs) {
                        response.CardSpecs.cardTitle = $scope.appData.BankAccounts[bankIndex].Cards[cardIndex].IsCalChoiceCard ? "CalChoice" : "כרטיס";
                        response.CardSpecs.cardNextDebitTitle = response.CardSpecs.HHKFixedDebitAmount ? "סך עסקות" : "חיוב קרוב";

                        if (response.CardSpecs.HHKFixedDebitAmount) {


                            var strNextDebitAmount = '<a id="hhkCommentLink" style="font-weight:bold;color:#ffffff;">' + response.CardSpecs.HHKFixedDebitAmount.ReversedFormattedValue.replace("₪", "") + '</a>';

                            var comment = utilService.stringFormat(response.CardSpecs.HHKNextDebitComment, strNextDebitAmount, response.CardSpecs.HHKNextDebitAmount.ReversedFormattedValue.replace("₪", ""));

                            response.CardSpecs.fixedDebitsComment = $sce.trustAsHtml(comment);

                            $timeout(function () {
                                $('#hhkCommentLink').ready(function () {
                                    $('#hhkCommentLink').on('click', function () {
                                        lobbyUiService.go('dw.fixedPayout');
                                    });
                                });
                            }, 0);
                        }

                        if (response.CardSpecs.isDinersExtra) {
                            response.CardSpecs.AccumulationExeText = $sce.trustAsHtml(response.CardSpecs.AccumulationExeText);
                        }
                    }
                    $scope.appData.BankAccounts[bankIndex].Cards[cardIndex].CardsSpecs = response.CardSpecs;
                }, function (error) {
                    if (cardIndex == $scope.appData.shownCardIndex && bankIndex == $scope.appData.selectedBankAccountIndex) {
                        errorService.handleError(error, $scope.getBankCards);
                    }
                });
            };

            function getBankCardDebits(bankIndex, cardIndex) {
                if (!$scope.appData.BankAccounts[bankIndex].Cards[cardIndex].IsInternetPermitted) {
                    return;
                }
                lobbyUiService.loader.show();
                connection.getBankDebits($scope.appData.BankAccounts[bankIndex].AccountID, 'C', 1, '', '', '', '', $scope.appData.BankAccounts[bankIndex].Cards[cardIndex].Id).then(function (response) {

                    $scope.appData.BankAccounts[bankIndex].Cards[cardIndex].Debits = response.Debits;
                    $scope.appData.BankAccounts[bankIndex].Cards[cardIndex].lastMonthDebit = response.Debits[response.Debits.length - 1];
                    $scope.appData.BankAccounts[bankIndex].Cards[cardIndex].TotalAmount = response.TotalAmount;
                    if (cardIndex == $scope.appData.shownCardIndex && bankIndex == $scope.appData.selectedBankAccountIndex) {
                        $scope.fillChartData();
                    }
                }, function (error) {
                    if (cardIndex == $scope.appData.shownCardIndex && bankIndex == $scope.appData.selectedBankAccountIndex) {
                        $scope.accountDataIsMissing = true;
                        errorService.handleError(error, getBankCardDebits);
                    }
                    }).finally(function () {
                        lobbyUiService.loader.hide();
                    });;
            };
        };

        $scope.goToBuyMe = function (url) {
            //dinersextra
            googleAnalyticsService.insertEvent({ page: 'My account', eventName: 'Diners Extra', action: 'Click' });
            ssoService.insertSsoDetails().then(function (res) {
                var query = 'sid=' + res.Token;
                lobbyUiService.openExternal(url + "?" + query);

            }, function (err) {
                lobbyUiService.openExternal(url);
            });
        };


        //#region debits

        $scope.getAllBankDebits = function () {

            for (var i = 0; i < $scope.appData.BankAccounts.length; i++) {
                if (!$scope.appData.BankAccounts[i].HasBankDebits)
                    $scope.getBankDebit(i);
            };
        };

        $scope.getBankDebit = function (BankAccountIndex) {
            var i = BankAccountIndex;
            if (!$scope.appData.BankAccounts[i].HasBankDebits) {
                if (i == $scope.appData.selectedBankAccountIndex)
                    getBankDebit();

            } else {
                if (i == $scope.appData.selectedBankAccountIndex)
                    $scope.fillChartData();
            }

            function getBankDebit() {

                connection.getBankDebits($scope.appData.BankAccounts[i].AccountID, 'A', 1, '', '', '', '', '').then(function (response) {

                    $scope.appData.BankAccounts[i].Debits = response.Debits;
                    $scope.appData.BankAccounts[i].lastMonthDebit = response.Debits[response.Debits.length - 1];
                    $scope.appData.BankAccounts[i].TotalAmount = response.TotalAmount;
                    $scope.appData.BankAccounts[i].HasBankDebits = true;
                    if (i == $scope.appData.selectedBankAccountIndex) {
                        $scope.accountDataIsMissing = false;
                        $scope.chartData = $scope.selectedBankAccount.Debits;
                        $scope.fillChartData();
                    }
                }, function () {

                    if (i == $scope.appData.selectedBankAccountIndex) {
                        $scope.accountDataIsMissing = !($scope.selectedBankAccount.TotalAmount && $scope.selectedTab == 'bankAccount') || !($scope.selectedTab == 'shownCard' && $scope.selectedBankAccount.Cards[$scope.appData.shownCardIndex].TotalAmount);
                        //                    errorService.handleError(error, getBankDebit);
                    }
                });
            }

        };

        $scope.selectTab = function (val) {
            $scope.selectedTab = val;
        };

        $scope.fillChartData = function () {
            if ($scope.selectedTab == 'bankAccount') {
                $scope.accountDataIsMissing = false;

                $scope.chartData = $scope.selectedBankAccount.Debits;
            } else if ($scope.selectedCard) {
                $scope.accountDataIsMissing = false;

                $scope.chartData = $scope.selectedCard.Debits;
            }
        };

        $scope.$watch('selectedTab', function (newVal, oldVal) {

            if (newVal != oldVal)
                $scope.fillChartData();
        });

        //#endregion

        //#region transaction grid

        $scope.loadNextTransactions = function () {

            var deferred = $q.defer();

            if ($scope.selectedCard &&
                $scope.selectedCard.HasNextPage) {
                $scope.selectedCard.HasNextPage = false;

                $scope.transactionsShowing.loadMore = true;

                connection.getTransNextPage().then(function (response) {
                    $scope.selectedCard.comments = response.Comments;
                    $scope.selectedCard.HasNextPage = response.HasNextPage;
                    $scope.selectedCard.transactions = $scope.selectedCard.transactions.concat(response.Transactions);
                    $scope.selectedCard.transactionsGridData = $scope.transactionsToGrid($scope.selectedCard.transactions);
                    deferred.resolve();
                }, function () {
                    deferred.reject();
                }).finally(function () {
                    $timeout(function () {
                        $scope.transactionsShowing.loadMore = false;
                    }, 500);
                });
            }
            return deferred.promise;
        };

        $scope.showTransactionDetails = function (index) {
            $scope.appData.position = $ionicScrollDelegate.$getByHandle('transInnerScroll').getScrollPosition().top;
            lobbyUiService.go('dw.transactionDetails', { accountIndex: $scope.appData.selectedBankAccountIndex, cardIndex: $scope.appData.shownCardIndex, transactionIndex: index });
        }


        $scope.dummyToggleCardTransactions = function () {
            $scope.dummyToggle = !$scope.dummyToggle;
        }

        $scope.toggleCardTransactions = function (who) {

            if (who == 'next') {

                if ($scope.selectedCard.IsCalChoiceCard)
                    return;

                if (!$scope.transactionsShowing.showNextTransactions) { // get transactions for next month

                    $scope.appData.fromDate = $scope.selectedCard.CardsSpecs.NextDebitDate.split('-').join('/');
                    $scope.appData.toDate = $scope.appData.fromDate;

                    $scope.transactionsShowing.showLastTransactions = false;
                    lobbyUiService.loader.show();
                    $scope.getTransactions($scope.selectedCard, $scope.appData.fromDate, $scope.appData.toDate).then(function () {
                        $scope.transactionsShowing.showNextTransactions = true;
                        $scope.title = 'חיובים קרובים';
                        $scope.appData.myAccount.status = 2;
                        $scope.appData.myAccount.lastCard = $scope.selectedCard.LastFourDigits;
                    }, function () {
                        $scope.transactionsShowing.isShowing = false;
                    }).finally(function () {
                        lobbyUiService.loader.hide();
                    });
                } else {
                    $scope.transactionsShowing.showNextTransactions = !$scope.transactionsShowing.showNextTransactions;
                    $scope.title = 'עסקות וחיובים';
                    $scope.appData.myAccount.status = 0;
                    $scope.transactionsShowing.isShowing = false;
                }
            } else {

                $scope.appData.fromDate = $scope.selectedCard.CardsSpecs.LastDebitDate.split('-').join('/');

                $scope.appData.toDate = $scope.appData.fromDate;

                if (!$scope.transactionsShowing.showLastTransactions) { // get transactions for next month
                    $scope.transactionsShowing.showNextTransactions = false;
                    lobbyUiService.loader.show();
                    $scope.getTransactions($scope.selectedCard, $scope.appData.fromDate, $scope.appData.toDate).then(function () {
                        $scope.transactionsShowing.showLastTransactions = true;
                        $scope.appData.myAccount.status = 1;
                        $scope.appData.myAccount.lastCard = $scope.selectedCard.LastFourDigits;
                        $scope.title = 'חיובים קודמים';
                    }, function () {
                        $scope.transactionsShowing.isShowing = false;
                    }).finally(function () {
                        lobbyUiService.loader.hide();
                    });
                } else {
                    $scope.transactionsShowing.showLastTransactions = !$scope.transactionsShowing.showLastTransactions;
                    $scope.title = 'עסקות וחיובים';
                    $scope.appData.myAccount.status = 0;
                    $scope.transactionsShowing.isShowing = false;
                }
            }

            $scope.setTransactionGrigHeight(who);


            $timeout(function () {
                $ionicScrollDelegate.$getByHandle('transInnerScroll').scrollTop();
                $scope.$apply();
            }, 0);
        };

        $scope.setTransactionGrigHeight = function (who, top) {

            if (top) {
                $("#transactionsGrid").css('top', top + 'px');
            } else {

                var lastChargesRowHeight = angular.element('.last-charge-row').height();

                var lastChargeRowPos = angular.element('.last-charge-row').position().top + lastChargesRowHeight;

                if (lastChargeRowPos > 0) {

                    lastChargeRowPos = Math.round(lastChargeRowPos) + 13;

                    $("#transactionsGrid").css('top', lastChargeRowPos + 'px');

                    if (who == 'next') {
                        $scope.appData.myAccount.transGridTopNext = lastChargeRowPos;
                    } else {
                        $scope.appData.myAccount.transGridTopLast = lastChargeRowPos;
                    }
                }
            }
        };

        $scope.getTransactions = function (card, fromDate, toDate) {
            var deferred = $q.defer();
            lobbyUiService.loader.show();

            var promise = connection.getTransactionsFromDateToDate(card.Id, fromDate, toDate);
            promise.then(function (response) {
                card.transactions = response.Transactions;
                card.HasNextPage = response.HasNextPage;
                card.monthTotals = response.TotalAmounts.DebitAmount.ReversedFormattedValue;
                card.comments = response.Comments;
                card.transactionsGridData = $scope.transactionsToGrid(card.transactions);
                deferred.resolve();
            }, function (error) {
                deferred.reject(error);
                errorService.handleError(error);
            }).finally(function () {
                lobbyUiService.loader.hide();
            });

            return deferred.promise;
        };

        $scope.transactionsToGrid = function (array) {
            var data = [], rowConfig = [];
            var headers = ['תאריך', 'שם העסק', 'סכום עסקה', 'סכום חיוב'];


            array.forEach(function (line) {
                var obj = [];

                obj.push(utilService.splitDate(line.Date));
                obj.push(line.MerchantDetails.Name);
                obj.push(line.Amount.ReversedFormattedValue);
                obj.push(line.DebitAmount.ReversedFormattedValue);
                data.push(obj);
                rowConfig.push({ clickable: true, cls: '' });
            });

            return { headers: headers, rows: data, rowConfig: rowConfig };
        };

        $scope.$watch('dummyToggle', function (newVal, oldVal) {

            if (newVal || oldVal) {
                $scope.toggleCardTransactions('next');
            }
        });

        //#endregion

        //#region navigation

        //$scope.goToPie = function () {
        //    lobbyUiService.loader.show();
        //    connection.getSectorSummary($scope.selectedCard.Id, $scope.appData.fromDate, $scope.appData.toDate).then(function (response) {
        //        $scope.appData.pieData = response;
        //        lobbyUiService.go('dw.pieSummary');
        //    }, function (error) {
        //        errorService.handleError(error, $scope.goToPie);
        //    });
        //};

        $scope.goToStatus = function () {
            googleAnalyticsService.insertEvent({ page: 'My account', eventName: 'Situation Report', action: 'Click' });
            lobbyUiService.navigate('dw.calchoiceStatus', { accountIndex: $scope.appData.selectedBankAccountIndex, cardIndex: $scope.appData.shownCardIndex });
        };

        $scope.goToComments = function () {

            googleAnalyticsService.insertEvent({ page: 'My account', eventName: 'More info', action: 'Click' });

            $scope.appData.comments = $scope.selectedCard.comments;

            lobbyUiService.go('dw.info');
        };

        $scope.goToCalChoice = function () {

            googleAnalyticsService.insertEvent({ page: 'My account', eventName: 'CalChoice Payment', action: 'Click' });

            lobbyUiService.go('dw.calchoicePayout', { accountIndex: $scope.appData.selectedBankAccountIndex, cardIndex: $scope.appData.shownCardIndex });
        };

        $scope.goToBankCharges = function () {

            googleAnalyticsService.insertEvent({ page: 'My account', eventName: 'Bank charges', action: 'Click' });

            lobbyUiService.go('dw.bankCharges');
        };

        $scope.goToFixedPayout = function () {

            googleAnalyticsService.insertEvent({ page: 'My account', eventName: 'Fixed payout', action: 'Click' });

            lobbyUiService.go('dw.fixedPayout');
        };

        //#endregion

        $scope.$on("$destroy", function () {
            lobbyUiService.loader.hide();
        });

        $scope.init();
    }
})(window, window.angular);
﻿(function(window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('myChatController', myChatController); 

    myChatController.$inject = [
        '$scope', 'connection', '$window', 'appData', 'lobbyUiService', '$rootScope', '$q', '$timeout', 'utilService', 'errorService','ssoService',
        '$ionicScrollDelegate', 'googleAnalyticsService', '$sce', '$ionicSlideBoxDelegate','appSettings'
    ];

    function myChatController($scope, connection, $window, appData, lobbyUiService, $rootScope, $q, $timeout, utilService, errorService, ssoService,
        $ionicScrollDelegate, googleAnalyticsService, $sce, $ionicSlideBoxDelegate, appSettings) {
        //debugger;
        //#region members declaration
        $scope.appData = appData;

        $scope.title = "צ'אט עם נציג";

        $scope.appData.isLoggedIn = connection.isLoggedIn();
        if (!$scope.appData.isLoggedIn) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.mychat' }, { location: 'replace' });
            return;
        }else{
            var options = {
                "abandonBehavior": false,
                "type": "3",
                "id": 69,
                "index": 10,
                "command": "open-chat-bot",
                "caption": "צ\"אט עם נציג",
                "icon": "ico-chat",
                "url": appSettings.chatUrl,
                "restricted": false,
                "sso": false,
                "dependency": null,
                "state": "dw.lobby",
                "hide": false,
                "googleAnalyticsKey": null,
                "devices": null
            }
                
            lobbyUiService.navigate(appSettings.chatUrl, options);
        }
        


    }
})(window, window.angular);
﻿(function(window, angular) {
    'use strict';

    angular.module('Cal4U')
        .controller('pieSummaryController', pieSummaryController);

    pieSummaryController.$inject = [
        '$scope', 'connection', 'appData', 'lobbyUiService', 'googleAnalyticsService'
    ];

    function pieSummaryController($scope, connection, appData, lobbyUiService, googleAnalyticsService) {

        $scope.appData = appData;
        $scope.title = 'פירוט עסקות';
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.init = function () {

            if (!$scope.appData.isLoggedIn) {
                lobbyUiService.go('dw.login');
                return;
            }

            googleAnalyticsService.insertEvent({ page: 'Pie Summary', eventName: 'Pie Summary', action: 'Enter' });

            $scope.selectedBankAccount = $scope.appData.BankAccounts[$scope.appData.selectedBankAccountIndex];
            $scope.selectedCard = $scope.selectedBankAccount.Cards[$scope.appData.shownCardIndex];
            $scope.pieData = $scope.appData.pieData;
            $scope.appData.showSpinner = false;
            lobbyUiService.loader.hide();
        };

        $scope.init();
    }

})(window, window.angular);
﻿(function(window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('termsPageController', termsPageController);

    termsPageController.$inject = [
        '$scope', 'connection', 'appData', '$sce', 'lobbyUiService'
    ];

    function termsPageController($scope, connection, appData, $sce, lobbyUiService) {

        $scope.appData = appData;
        $scope.title = 'תקנון התוכנית';

        $scope.init = function() {

            $scope.appData = appData;

            $scope.doc = {
                title: 'תקנון התכנית',
                url: ''
            }

            var titleParam = lobbyUiService.getParams('title');

            var url = lobbyUiService.getParams('url');

            if (!url) {
                //show error
            }

            $scope.doc.url = url;

            if (titleParam) {
                $scope.doc.title = titleParam;
            }


            switch (url) {
            case 'loan':
            {
                $scope.doc.url = "/CalDocs?id=ExpressLoanTerms.html";
                break;
            }
            case 'fixed':
            {
                $scope.doc.url = "/CalDocs?id=fixedDebitTerms.html";
                break;
            }
            default:
            }
        };
    }
})(window, window.angular);
﻿(function(window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('transactionDetailsController', transactionDetailsController);

    transactionDetailsController.$inject = [
        '$scope', 'connection', '$window', 'appData', 'lobbyUiService', '$rootScope', '$q', 'utilService', 'errorService',
        '$ionicScrollDelegate', 'googleAnalyticsService', '$timeout', 'leadNavigationService', 'appSettings'
    ];

    function transactionDetailsController($scope, connection, $window, appData, lobbyUiService, $rootScope, $q, utilService, errorService,
        $ionicScrollDelegate, googleAnalyticsService, $timeout, leadNavigationService, appSettings) {

        $scope.appData = appData;
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.selectedBankAccountIndex = lobbyUiService.getParams('accountIndex');
        $scope.cardIndex = lobbyUiService.getParams('cardIndex');
        $scope.transactionIndex = lobbyUiService.getParams('transactionIndex');
        $scope.gClass = "details-grid-transaction";
        $scope.lobbyUiService = lobbyUiService;
        $scope.title = 'פרטי העסקה';

        function transactionToGrid(transactionData) {
            var data = [], rowConfig = [];
            // Headers are empty due to diffrent style of header on this view
            var headers = [];
            var dataFiledsNoName = [];
            for (i = 0; i < transactionData.DataFields.length; i++) {
                var dataFieldVal = modifyComment(transactionData.DataFields[i].Value);
                if (transactionData.DataFields[i].Name != null && transactionData.DataFields[i].Name.trim() != '') {
                    data.push([transactionData.DataFields[i].Name, dataFieldVal]);
                    rowConfig.push({ clickable: false, cls: transactionData.DataFields[i].IsMoney ? 'money' : '' });
                }
                else {
                    dataFiledsNoName.push(['', dataFieldVal]);
                    rowConfig.push({ clickable: false, cls: transactionData.DataFields[i].IsMoney ? 'money' : '' });
                }
            }

            if (transactionData.MerchantDetails.Name) {
                data.push(['שם בית העסק', transactionData.MerchantDetails.Name]);
                rowConfig.push({ clickable: false, cls: '' });
            }
            if (transactionData.MerchantDetails.SectorName) {
                data.push(['ענף', transactionData.MerchantDetails.SectorName]);
                rowConfig.push({ clickable: false, cls: '' });
            }
            if (transactionData.MerchantDetails.Address) {
                data.push(['כתובת', transactionData.MerchantDetails.Address]);
                rowConfig.push({ clickable: false, cls: '' });
            }
            if (transactionData.MerchantDetails.FaxNumber) {
                data.push(['פקס', transactionData.MerchantDetails.FaxNumber]);
                rowConfig.push({ clickable: false, cls: '' });
            }

           // dataFiledsNoName.forEach(x => data.push(x));

            //TODO add sort to Comments by Index
            var additionalData = '';
            for (var i = 0; i < transactionData.Comments.length; i++) {
                var comment = transactionData.Comments[i].Text;
                if (comment == '' || comment == null)
                    comment = ' ';
                else {
                    comment = modifyComment(comment);
                    if (comment[0] == '*') {
                        comment = comment.split('*')[1];
                    }
                    additionalData = additionalData + comment + '. ';
                }
            }

            for (var i = 0; i < dataFiledsNoName.length; i++) {
                var comment = dataFiledsNoName[i][1];
                if (comment == '' || comment == null)
                    comment = ' ';
                else {
                    comment = modifyComment(comment);
                    if (comment[0] == '*') {
                        comment = comment.split('*')[1];
                    }
                    if (!additionalData.includes(comment)) {
                        additionalData = additionalData + comment + '. ';
                    }
                }
            }

            if (additionalData != '') {

                data.push(['פירוט נוסף', additionalData]);
                rowConfig.push({ clickable: false, cls: '' });
            }

            return { headers: headers, rows: data, rowConfig: rowConfig };
        };

        function modifyComment(comment) {
            if (comment.split("<a").length > 1) {
                comment = comment.split("<a")[0];
            }
            var splitted = comment.trim().split(",");
            if (splitted.length > 1 && splitted[splitted.length - 1] == "") { //comma is last char
                comment = splitted.join(""); //remove last comma
            }
            return comment;
        }

        $scope.init = function () {

            if (!$scope.appData.isLoggedIn) {
                lobbyUiService.go('dw.login');
                return;
            }

            /* display trans denial button if query param td=1:
            let queryString = new URLSearchParams(window.location.search);
            let queryParams = Object.fromEntries(queryString.entries());
            let transDenialQueryParam = queryParams.td;
            */

            $timeout(function () {
                $ionicScrollDelegate.$getByHandle('transDetailsScroll').scrollTop();
            }, 0);

            googleAnalyticsService.insertEvent({ page: 'Transaction details', eventName: 'Transaction details', action: 'Enter' });

            $scope.selectedBankAccount = $scope.appData.BankAccounts[$scope.selectedBankAccountIndex];


            if ($scope.cardIndex == -1) {
                $scope.selectedTransaction = $scope.appData.TransactionsDetails[$scope.transactionIndex];
                $scope.selectedCard = $scope.selectedBankAccount.Cards[$scope.appData.shownCardIndex];
            } else {
                $scope.selectedCard = $scope.selectedBankAccount.Cards[$scope.cardIndex];
                $scope.selectedTransaction = ($scope.selectedCard.transactions && $scope.selectedCard.transactions[$scope.transactionIndex]) || { };
            }

            var hasCardOneBankAccount = appData != null && appData.BankAccounts != null;
            if (hasCardOneBankAccount) {
                var bankAccountsPerSelectedCard = 0
                appData.BankAccounts.forEach(bankAccount => {
                    if (bankAccount.Cards.contains($scope.selectedCard)) {
                        ++bankAccountsPerSelectedCard;
                    }
                });
                hasCardOneBankAccount = bankAccountsPerSelectedCard == 1;
            }

            $scope.supportTransDenial = appSettings.transDenialUrl && appSettings.transDenialUrl.length > 0 && /*transDenialQueryParam == 1 &&*/ hasCardOneBankAccount;

            getTransDetails();


            function getTransDetails() {
                if (!$scope.selectedTransaction.Id) {
                    lobbyUiService.go('dw.myaccount');
                    return;
                }

                $scope.appData.showSpinner = true;
                lobbyUiService.loader.show();
                var promise = connection.getTransactionDetails($scope.selectedTransaction.Id, $scope.selectedTransaction.Numerator);
                promise.then(function (response) {

                    $scope.query = response.Data.MerchantDetails.Name + ' ' + response.Data.MerchantDetails.Address;
                    $scope.phoneNumber = response.Data.MerchantDetails.PhoneNumber;
                    $scope.isView = response.IsViewed;

                    $scope.transactionGridData = transactionToGrid(response.Data);
                    $scope.appData.showSpinner = false;
                    setTimeout(function () {
                        lobbyUiService.loader.hide();
                    }, 500);
                }, function (error) {
                    errorService.handleError(error, getTransDetails);
                });
            }
        };

        $scope.goToContactMe = function () {
            googleAnalyticsService.insertEvent({ page: 'Transaction details', eventName: 'Inquiry transaction versus a representative - Call customer service' });
            lobbyUiService.go('dw.contactMe');
        }

        $scope.goToServiceLead = function () {
            googleAnalyticsService.insertEvent({ page: 'transaction-details', action: 'chat-with-rep' });            
            leadNavigationService.navigate();
        }
        
        /*function goToChat() {
           var options = {
                "abandonBehavior": false,
                "type": "3",
                "id": 69,
                "index": 10,
                "command": "open-chat",
                "caption": "צ\"אט עם נציג",
                "icon": "ico-chat",
                "url": "https://chat.cal-online.co.il/chat/iwchat.aspx",
                "restricted": false,
                "sso": false,
                "dependency": null,
                "state": "https://chat.cal-online.co.il/chat/iwchat.aspx",
                "hide": false,
                "googleAnalyticsKey": null,
                "devices": null
            };
            lobbyUiService.navigate("https://chat.cal-online.co.il/chat/iwchat.aspx",options);
        };*/

        $scope.call = function () {
            googleAnalyticsService.insertEvent({ page: 'Transaction details', eventName: 'Inquiry transaction versus a business - Call business' });
        }

        $scope.searchGoogleAnalytics = function (query) {                     
            googleAnalyticsService.insertEvent({ page: 'פרטי עסקה', action: 'חיפוש גוגל בפרטי עסקה', eventName: query.trim() });            
            console.log('searchGoogleAnalytics ' + query.trim());
        }

        $scope.transDenial = function () {
            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();
            connection.getTransDenialToken($scope.selectedTransaction.Id, $scope.selectedTransaction.Numerator)
                .then(function (res) {
                    $scope.appData.showSpinner = false;
                    if (res.Token) {
                        var url = appSettings.transDenialUrl + res.Token;
                        location.href = url;
                    }
                    else {
                        errorService.handleError(error, res);
                    }
                }, function (err) {

                });
            
            //googleAnalyticsService.insertEvent({ page: 'Transaction details', eventName: 'Inquiry transaction versus a business - Call business' });
        }

        $scope.init();
    }

})(window, window.angular);
﻿(function(window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('wantCardController', wantCardController);

    wantCardController.$inject = [
        '$scope', 'connection', 'appData', 'lobbyUiService', 'errorService', 'googleAnalyticsService'
    ];

    function wantCardController($scope, connection, appData, lobbyUiService, errorService, googleAnalyticsService) {

        $scope.appData = appData;
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.lobbyUiService = lobbyUiService;
        $scope.title = "רוצה כרטיס Cal?";

        $scope.members = {
            cardChecked: false,
            selectedOption: null,
            memberNum: '',
            resolutionCode: ''
        };

        $scope.CustomerInfo = {};

        $scope.init = function () {

            if ($scope.appData.isLoggedIn) {
                $scope.CustomerInfo = angular.copy($scope.appData.CustomerInfo);
                $scope.backBtn = "logout";
            } else
                $scope.backBtn = "back";

            $scope.members.resolutionCode = lobbyUiService.getParams('code');

            if (!$scope.appData.metaData) {
                $scope.appData.showSpinner = true;
                lobbyUiService.loader.show();
                var promise = connection.getMetaData();
                promise.then(function (response) {
                    $scope.appData.metaData = response;
                    $scope.appData.showSpinner = false;
                    lobbyUiService.loader.hide();
                    $scope.options = $scope.appData.metaData.Cards;
                    $scope.members.selectedOption = $scope.getSelectedOption();

                    if ($scope.members.selectedOption) {
                        if ($scope.members.selectedOption.ResolutionCode == '2204') {
                            googleAnalyticsService.insertEvent({ page: 'Cal Card request', eventName: 'Calchoice Card', action: 'Enter' });
                        } else {
                            googleAnalyticsService.insertEvent({ page: 'Cal Card request', eventName: 'Other Card (Resolution Code: ' + $scope.members.selectedOption.ResolutionCode + ')', action: 'Enter' });
                        }
                    }
                },
                    function (error) {
                        errorService.handleError(error, $scope.init);
                    });
            } else {
                $scope.options = $scope.appData.metaData.Cards;
                $scope.members.selectedOption = $scope.getSelectedOption();

            }


            $scope.members.cardChecked = false;
            $scope.hebRegEx = /^[\u05CF-\u05EB\- ]+$/;

        };

        $scope.getSelectedOption = function () {
            var o = null;

            if ($scope.members.resolutionCode && $scope.members.resolutionCode != '') {
                $scope.options.forEach(function (option) {
                    if (option.ResolutionCode == $scope.members.resolutionCode) {
                        o = option;
                    }
                });
            }

            return o;
        };

        $scope.openLead = function () {
            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();

            var data = { FirstName: $scope.CustomerInfo.FirstName, LastName: $scope.CustomerInfo.LastName, IdNum: $scope.CustomerInfo.Id, PhoneArea: $scope.CustomerInfo.PhoneArea, PhoneNumber: $scope.CustomerInfo.PhoneNumber, ResolutionCode: $scope.appData.metaData.Cards[$scope.options.indexOf($scope.members.selectedOption)].ResolutionCode, MemberNum: $scope.members.memberNum, RequestType: '02' }

            connection.postOpenLead(data).then(function (response) {
                var dialogBox = response.Response.DialogBox;

                lobbyUiService.loader.hide();
                $scope.appData.showSpinner = false;

                if (data.ResolutionCode == '2204') {
                    googleAnalyticsService.insertEvent({ page: 'Cal Card request', eventName: 'Order CalChoice card', action: 'Click' });
                } else {
                    googleAnalyticsService.insertEvent({ page: 'Cal Card request', eventName: 'Send Details (ResolutionCode: ' + data.ResolutionCode + ')', action: 'Click' });
                }

                if (navigator.notification)
                    navigator.notification.alert(
                        dialogBox.Content,
                        $scope.$parent.back(),
                        ' ',
                        dialogBox.OKButtonText
                    );
                else {
                    lobbyUiService.popup.alert(dialogBox.Content, 'נא לשים לב', null, function () {
                        $scope.$parent.back();
                    });
                }
                return true;
            }, function (error) {
                errorService.handleError(error, $scope.openLead);
                return false;
            });
        }

        $scope.checkMemberNum = function () {
            $scope.isMemberNum = $scope.appData.metaData.Cards[$scope.options.indexOf($scope.members.selectedOption)].IsMemberNum;
        }

        $scope.validateForm = function () {
            //padding for phone number
            var errMsg = '';
            if (!$scope.CustomerInfo) {
                errMsg = 'יש למלא את כל השדות';
            } else {

                if ($scope.openLeadForm.$valid && $scope.members.cardChecked && $('#idNum').val().length == 9 && $('#phoneNum').val().length == 7) {
                    return true;
                } else {
                    if ($scope.openLeadForm.$error.required && $scope.openLeadForm.$error.required.length > 1) {
                        errMsg = 'יש למלא את כל השדות';
                    } else if ($('#cardSelect').hasClass('ng-invalid-required'))
                        errMsg = 'יש לבחור סוג כרטיס.';
                    else if ($('#fName').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ערך בשדה שם פרטי.';
                    else if ($('#fName').hasClass('ng-invalid-pattern'))
                        errMsg = 'השם הפרטי שהוזן אינו תקין. יש למלא אותיות בעברית בלבד.';
                    else if ($('#lName').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ערך בשדה שם משפחה';
                    else if ($('#lName').hasClass('ng-invalid-pattern'))
                        errMsg = 'שם המשפחה שהוזן אינו תקין. יש למלא אותיות בעברית בלבד.';
                    else if ($('#idNum').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ערך בשדה מספר ת.ז.';
                    else if ($('#idNum').hasClass('ng-invalid-pattern') || $('#idNum').val().length != 9)
                        errMsg = 'מספר ת.ז. שהוזן אינו תקין. יש למלא מספר בן 9 ספרות בדיוק כולל ספרת ביקורת.';
                    else if ($('#memberNum').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא מספר חבר';
                    else if ($('#phoneNum').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ערך בשדה מספר טלפון';
                    else if ($('#phoneNum').hasClass('ng-invalid-pattern'))
                        errMsg = 'מספר הטלפון שהוזן אינו תקין. יש למלא ספרות בלבד.';
                    else if ($('#phoneNum').val().length < 7)
                        errMsg = 'מספר הטלפון שהוזן אינו תקין. יש למלא מספר בן 7 ספרות בדיוק.';
                    else if ($('#areaNum').hasClass('ng-invalid-required'))
                        errMsg = 'קידומת הטלפון שנבחרה אינה תקינה. יש לבחור קידומת טלפון.';
                    else if (!$scope.members.cardChecked)
                        errMsg = 'יש לציין אם יש ברשותך כרטיס אשראי בתוקף של אחת מחברות האשראי';
                }
            }

            if (navigator.notification)
                navigator.notification.alert(
                    errMsg,
                    function () {
                        /*Do Nothing*/
                    },
                    ' ',
                    'סגור'
                );
            else {
                lobbyUiService.popup.alert(errMsg, 'נא לשים לב');
            }

            return false;
        }

        $scope.init();
    }

})(window, window.angular);
﻿(function(window, angular) {
    'use strict';

    angular.module('Cal4U')
        .controller('wantLoanController', wantLoanController);

    wantLoanController.$inject = [
        '$scope', 'connection', 'appData', 'lobbyUiService', 'errorService', 'googleAnalyticsService'
    ];

    function wantLoanController($scope, connection, appData, lobbyUiService, errorService, googleAnalyticsService) {

        $scope.appData = appData;
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.title = 'רוצה הלוואה?';
        $scope.lobbyUiService = lobbyUiService;

        $scope.CustomerInfo = {};

        $scope.init = function () {
            if ($scope.appData.isLoggedIn) {
                $scope.CustomerInfo = angular.copy($scope.appData.CustomerInfo);
                $scope.backBtn = "logout";
            } else
                $scope.backBtn = "back";

            googleAnalyticsService.insertEvent({ page: 'Lead', eventName: 'Express Loan - Lead', action: 'Enter' });

            if (!$scope.appData.metaData) {
                $scope.appData.showSpinner = true;
                lobbyUiService.loader.show();
                var promise = connection.getMetaData();
                promise.then(function (response) {
                    $scope.appData.metaData = response;
                    $scope.appData.showSpinner = false;
                    lobbyUiService.loader.hide();
                },
                    function (error) {
                        errorService.handleError(error, $scope.init);
                    });
            }

            $scope.hebRegEx = /^[\u05CF-\u05EB\- ]+$/;

        };

        $scope.openLead = function () {
            $scope.appData.showSpinner = true;
            lobbyUiService.loader.show();

            var data = { FirstName: $scope.CustomerInfo.FirstName, LastName: $scope.CustomerInfo.LastName, IdNum: $scope.CustomerInfo.Id, PhoneArea: $scope.CustomerInfo.PhoneArea, PhoneNumber: $scope.CustomerInfo.PhoneNumber, ResolutionCode: $scope.appData.metaData.ExpressLoanResolutionCode, RequestType: '02' }

            connection.postOpenLead(data).then(function (response) {
                var dialogBox = response.Response.DialogBox;

                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
                if (navigator.notification)
                    navigator.notification.alert(
                        dialogBox.Content,
                        $scope.$parent.back(),
                        ' ',
                        dialogBox.OKButtonText
                    );
                else {
                    lobbyUiService.popup.alert(dialogBox.Content, 'נא לשים לב', null, function () {
                        $scope.$parent.back();
                    });
                }
                return true;
            }, function (error) {
                errorService.handleError(error, $scope.openLead);
                return false;
            });
        }

        $scope.checkMemberNum = function () {
            $scope.isMemberNum = $scope.appData.metaData.Cards[$scope.options.indexOf($scope.selectedOption)].IsMemberNum;
        }

        $scope.validateForm = function () {
            //padding for phone number
            var errMsg = '';
            if (!$scope.CustomerInfo) {
                errMsg = 'יש למלא את כל השדות';
            } else {
                //padding for id
                if ($scope.openLeadForm.$valid && $('#idNum').val().length == 9 && $('#phoneNum').val().length == 7) {
                    return true;

                } else {

                    if ($scope.openLeadForm.$error.required && $scope.openLeadForm.$error.required.length > 1) {
                        errMsg = 'יש למלא את כל השדות';
                    }

                    if ($('#fName').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ערך בשדה שם פרטי.';
                    else if ($('#fName').hasClass('ng-invalid-pattern'))
                        errMsg = 'השם הפרטי שהוזן אינו תקין. יש למלא אותיות בעברית בלבד.';
                    else if ($('#lName').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ערך בשדה שם משפחה';
                    else if ($('#lName').hasClass('ng-invalid-pattern'))
                        errMsg = 'שם המשפחה שהוזן אינו תקין. יש למלא אותיות בעברית בלבד.';
                    else if ($('#idNum').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ערך בשדה מספר ת.ז.';
                    else if ($('#idNum').hasClass('ng-invalid-pattern') || $('#idNum').val().length != 9)
                        errMsg = 'מספר ת.ז. שהוזן אינו תקין. יש למלא מספר בן 9 ספרות בדיוק כולל ספרת ביקורת.';
                    else if ($('#phoneNum').hasClass('ng-invalid-required'))
                        errMsg = 'יש למלא ערך בשדה מספר טלפון';
                    else if ($('#phoneNum').hasClass('ng-invalid-pattern'))
                        errMsg = 'מספר הטלפון שהוזן אינו תקין. יש למלא ספרות בלבד.';
                    else if ($('#phoneNum').val().length < 7)
                        errMsg = 'מספר הטלפון שהוזן אינו תקין. יש למלא מספר בן 7 ספרות בדיוק.';
                    else if ($('#areaNum').hasClass('ng-invalid-required'))
                        errMsg = 'קידומת הטלפון שנבחרה אינה תקינה. יש לבחור קידומת טלפון.';

                }
            }

            if (navigator.notification)
                navigator.notification.alert(
                    errMsg,
                    function () {
                        /*Do Nothing*/
                    },
                    ' ',
                    'סגור'
                );
            else {
                lobbyUiService.popup.alert(errMsg, 'נא לשים לב');
            }

            return false;
        }

        $scope.init();
    }

})(window, window.angular);

﻿/// <reference path="../../../scripts/ionic-v1.0.0/js/angular/angular.js" />
(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('enlargeCreditFrameController', enlargeCreditFrameController);

    enlargeCreditFrameController.$inject = [
        '$scope', 'connection', 'appData', 'lobbyUiService', 'errorService', 'googleAnalyticsService',
        '_', '$timeout', 'lobbyCommService', 'appSettings','customerIndication'
    ];

    function enlargeCreditFrameController($scope, connection, appData, lobbyUiService, errorService, googleAnalyticsService,
        _, $timeout, lobbyCommService, appSettings,customerIndication) {

        $scope.appData = appData;

        $scope.account = {
            bankAccounts: [],
            currentAccountIndex: 0,
            currentCardIndex: 0,
            showSlider: true,
        }

        $scope.members = {
            cardSliderTitle: 'בחר/י כרטיס להגדלת מסגרת האשראי',
            finished: false,
            showCrediteFrame: false,
            isCardIssueByCal: true,
            statuses: {
                1: {
                    text: 'לקוח יקר,<br/>מסגרת האשראי שלך הוגדלה<br/>לסכום של ?<br/><span class="small">במידה ומסגרת האשראי שניתנה לך אינה מספקת, ניתן להגיש בקשה על ידי הקלקה על כפתור "הגדלה נוספת".</span>',
                    buttons: [{
                        'class': 'button-cancel',
                        text: 'מספיק לי, תודה',
                        callback: function () {
                            lobbyUiService.go('dw.account-home');
                        }
                    },
                    {
                        'class': 'button-ok',
                        text: 'הגדלה נוספת',
                        callback: function () {
                            //to do: go to online-forms
                            $scope.openOnlineForms();
                        }
                    }]
                },
                2: {
                    text: 'לקוח יקר,<br/>כדי שנוכל לבחון הגדלה נוספת של מסגרת האשראי לכרטיסך, יש למלא טופס בקשה להגדלת מסגרת.',
                    buttons: [{
                        'class': 'button-cancel',
                        text: 'חזרה',
                        callback: function () {
                            $scope.goBack();
                        }
                    },
                    {
                        'class': 'button-ok',
                        text: 'בקשה להגדלת מסגרת',
                        callback: function () {
                            $scope.openOnlineForms();
                        }
                    }]
                },
                3: {
                    text: 'בדקנו, <br/>' +
                        'וראינו שהגעת למסגרת המקסימלית שיכולנו לתת לך. כרגע אין דרך להגדיל את המסגרת (לא בדיגיטל ולא דרך נציג). <br/>' +
                        'כדאי לנסות שוב בעוד 4 חודשים.',
                    buttons: [{
                        'class': 'button-cancel',
                        text: 'תודה בכל מקרה',
                        callback: function () {
                            $scope.goBack();
                        }
                    }]
                }
            },
            selectedStatus: 0,
            creditFrame: {}
        };

        $scope.init = function () {

            if (!lobbyUiService.connection.isLoggedIn()) {
                lobbyUiService.go('dw.login', { nextPage: "dw.enlarge-credit-frame" }, { location: 'replace' });
                return;
            }

            if (!$scope.appData.selectedBankAccountIndex) {
                $scope.appData.selectedBankAccountIndex = 0;
            }
            $scope.account.currentAccountIndex = $scope.appData.selectedBankAccountIndex;

            if (!$scope.appData.shownCardIndex) {
                $scope.appData.shownCardIndex = 0;
            }

            var copyAccounts = angular.copy($scope.appData.BankAccounts);

            var filterAccounts = [];

            _.each(copyAccounts, function (account, i) {
                var filterCards = _.filter(account.Cards, function (card) {
                    return card.CreditProductsInd == true;
                });

                if (filterCards.length > 0) {
                    account.Cards = filterCards;
                    filterAccounts.push(account);
                }
            });

            $scope.account.bankAccounts = filterAccounts;

            if (!$scope.account.bankAccounts[$scope.account.currentAccountIndex])
            {
                $scope.account.currentAccountIndex = 0;
            }

            $scope.GetCreditFrame();
        }

        $scope.openOnlineForms = function () {
            lobbyCommService.insertOnlineFormsDetails().then(function (res) {

                var _target = appSettings.OnlineFormsServer + '&token=' + res.Token;

                window.open(_target, '_system', 'location=yes');
            })
        }

        $scope.onAccountChange = function (arg1) {

            $scope.account.currentAccountIndex = arg1;

            $scope.GetCreditFrame();
        }

        $scope.IsIssueByCal = function () {

            if (!$scope.hasAccount())
            {
                return true;
            }

            try {
                var issueByCal = $scope.account.bankAccounts[$scope.account.currentAccountIndex].Cards[$scope.account.currentCardIndex].IsIssuedByCalInd;

                return issueByCal;

            } catch (e) {
                return false;
            }
        }

        $scope.hasAccount = function () {
            return $scope.account.bankAccounts && $scope.account.bankAccounts.length > 0;
        }

        $scope.GetCreditFrame = function () {

            lobbyUiService.loader.show();

            try {
                var _cardId = $scope.account.bankAccounts[$scope.account.currentAccountIndex].Cards[$scope.account.currentCardIndex].Id;

                $scope.members.isCardIssueByCal = $scope.IsIssueByCal();

                return connection.GetCreditFrameInfoForCard(_cardId).then(function (response) {
                    $scope.members.creditFrame = response.CreditFrameInfo;
                }, function (error) {
                    $scope.members.creditFrame = '';
                }).finally(function () {
                    lobbyUiService.loader.hide();
                });
            } catch (e) {

            }
        }

        $scope.reload = function () {
            
            $scope.GetCreditFrame();

            $scope.members.finished = false;

            $scope.appData.backOverrideFN = null;
        }

        $scope.onCardChange = function (arg1) {

            $timeout(function () {
                $scope.account.currentCardIndex = arg1;
            }, 0);

            $scope.GetCreditFrame();

        }

        function showErrorPopup() {
            var popup = {};
            popup.btns = [];
            popup.btns.push(
                {
                    text: "אישור",
                    type: 'button-positive',
                    onTap: function () {
                        return;
                    }
                });
            lobbyUiService.popup.alert("לא ניתן להשלים את הפעולה כרגע, אנא נסה שנית מאוחר יותר.", null, null, null, popup.btns, true, null);
        }

        $scope.customerIndicationsPopUp = function () {
            var request = {
                processType: 1,
                cardUniqueId: $scope.account.bankAccounts[$scope.account.currentAccountIndex].Cards[$scope.account.currentCardIndex].Id,
                CustExtTypeCode: appData.CustomerInfo.IdNumType,
                CustExtId: appData.CustomerInfo.Id
            }
            connection.getCreditInfoConsentIndication(request).then(getCreditInfoConsentIndicationOnSuccess, getCreditInfoConsentIndicationOnError);
        }



        function getCreditInfoConsentIndicationOnSuccess(res) {
            console.log("res", res);
            if (res.IsCollectAgreement && res.AccountsForAgreement != null && res.AccountsForAgreement.length > 0) {
                lobbyUiService.loader.hide();
                angular.extend($scope, {
                    selectedCardForApprove: $scope.account.bankAccounts[$scope.account.currentAccountIndex].Cards[$scope.account.currentCardIndex].Id,
                    BankName: res.AccountsForAgreement[0].BankName,
                    typeIndHeader: `
כדי לבחון את בקשתך להגדלת מסגרת, אנחנו צריכים לקבל את אישורך לפנות למאגר האשראי של בנק ישראל,
אם לא נקבל את אישורך, לא יהיה ניתן להגיש בקשה להגדלת מסגרת.
`,
                    typeInd: "הגדלת מסגרת",
                    disagreeError: "ללא הסכמתך, קשה לנו לגבש את הערכה לגבי גודל מסגרת האשראי המתאימה לך, ולכן לא נוכל לאשר את ההגדלה",



                    Account4LastDigits: res.AccountsForAgreement[0].Account4LastDigits,
                    languages: res.Languages//[{ 'languageId': '1', 'languageName': 'עברית' }, { 'languageId': '2', 'languageName': 'אנגלית' }, { 'languageId': '3', 'languageName': 'רוסית' }],
                });

               
                customerIndication.creditCustomerIndication($scope, userAgreedCreditConsentCallBack, res.AgreementId);
                ga('send', 'event', { eventCategory: 'איסוף הסכמות למאגר אשראי בתהליך הגדלת מסגרת', eventAction: 'הופעת מסך הסכמה', eventLabel: '', nonInteraction: true })
            }
            else {

                console.log("gotoStage2");
                $scope.reallyGoToStage2();
            }
        }
        function getCreditInfoConsentIndicationOnError(res) {
            lobbyUiService.loader.hide();
            showErrorPopup();
        }
        function userAgreedCreditConsentCallBack() {
            console.log("gotoStage2");
            $scope.reallyGoToStage2();
        }





        $scope.doEnlargeCreditFrame = function () {
            lobbyUiService.loader.show();
            $scope.appData.backOverrideFN = $scope.reload;
            lobbyUiService.loader.show();
            
            $scope.customerIndicationsPopUp();

        }


        $scope.reallyGoToStage2 = function () {
            //the call.
            var _cardId = $scope.account.bankAccounts[$scope.account.currentAccountIndex].Cards[$scope.account.currentCardIndex].Id;
            connection.IncreaseFrameForCard(_cardId).then(function (response) {

                $scope.members.selectedStatus = response.ChangedFrameStatus;

                $scope.members.NewCreditFrameAmount = response.NewFrameAmount;

                if ($scope.members.selectedStatus == 1) {
                    $scope.members.statuses[$scope.members.selectedStatus].text = $scope.members.statuses[$scope.members.selectedStatus].text.replace('?', $scope.members.NewCreditFrameAmount.ReversedFormattedValue);
                }

                $scope.members.finished = true;

                $scope.appData.backOverrideFN = $scope.reload;

            }, function (error) {
                errorService.handleError(error);
            }).finally(function () {
                lobbyUiService.loader.hide();
            });
        }



        $scope.doAction = function(btn)
        {
            btn.callback();
        }

        $scope.$on("$destroy", function () {
            $scope.appData.backOverrideFN = null;
            $scope.appData.inProcess = false;
        });

        $scope.init();
    }

})(window, window.angular);
﻿(function (window, anjular) {
    'use strict';

    angular.module('Cal4U').controller('debitSpreadController', debitSpreadController);

    debitSpreadController.$inject = ['commService', '$scope', '$timeout', '$ionicScrollDelegate', '$ionicSlideBoxDelegate', '$ionicNavBarDelegate',
        '$state', 'lobbyUiService', 'errorService', 'appData', 'connection', '$stateParams', '$rootScope'];

    function debitSpreadController(commService, $scope, $timeout, $ionicScrollDelegate, $ionicSlideBoxDelegate,
        $ionicNavBarDelegate, $state, lobbyUiService, errorService, appData, connection, $stateParams, $rootScope) {
        $scope.appData = appData;
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.currCards = [];
        $scope.uniqueId = null;
        $scope.uniqueIDChosen = 0;
        $scope.steps = [{ caption: 'סכום', active: true }, { caption: 'תשלומים', active: false }, { caption: 'פרטים', active: false }, { caption: 'סיום', active: false }];

        $scope.$on('$ionicView.beforeLeave', function (e, viewData) {

            $('body').removeClass('finish');

        });

        //$timeout(function () {
        //commService.trigReady();
        //},4000)

        $rootScope.$on("bankFromHost", function (evt, bankId) {
            console.log("[DW][Listener]", bankId)
            var banks = $scope.appData.BankAccounts.map(function (b) { return commService.cutExistingBankIdWorkAround(b) });
            var idx = banks.indexOf(bankId);
            console.log("[DW] index", idx);
            if (idx == -1) idx = 0;
            $scope.accountChanged(idx)
        })

        $rootScope.$on("cardFromHost", function (evt, cardId) {
       
            $scope.cardChanged(cardId);
            $scope.uniqueId = cardId;
        })

        //$scope.$on('$ionicView.loaded', function () {
        //    console.log('loaded in debitsp');
        //    // vm.hideNavBar = lobbyUiService.hideNavBar();
        //    $timeout(function () {
        //        console.log("QWE timeout");
        //        commService.trigReady();
        //    })
        //})

        function inIframe() {
            try {

                var a = window.self !== window.top;
             
                return a;
            } catch (e) {
                return false;
            }
        }
        $scope.hideNavBar = inIframe();


        $scope.standalone = $stateParams.standalone

        if ($scope.standalone == "standalone") {
            $('#page-wrapper').addClass('standalone');
        }

        $scope.members =
        {
            showTerms: false,
            isReturnFromTerms: false,
            title: "פריסת חיוב",
            initStage2Data: null,
            initStage3Data: null,
            isClearSpreadRequest: false,
            DEBIT_SPREAD_AMOUNT_KEY: "DEBIT_SPREAD_AMOUNT_KEY",
            DEBIT_SPREAD_HELPPAGE_IND: "DEBIT_SPREAD_HELPPAGE_IND"
        };

        $scope.title = "פריסת חיוב";

        $scope.doc = {
            url: "CalDocs?id=DebitSpreadTerms.html"
        }

        $scope.getActivePage = function (page) {
            if ($scope.steps == null || $scope.steps == undefined) {
                $scope.steps = [{ caption: 'סכום', active: false }, { caption: 'תשלומים', active: false }, { caption: 'פרטים', active: false }, { caption: 'סיום', active: false }];;
            }
            else {
                for (var i = 0; i < $scope.steps.length; i++) {
                    $scope.steps[i].active = false;
                }
            }
            $scope.steps[page].active = true;
        }
        var firstPageHeight;
        // #region init
        $scope.init = function () {
            //$scope.appData.backOverrideFN = $scope.goToLobby;

            if (!$scope.appData.isLoggedIn) {
                lobbyUiService.go('dw.login', { nextPage: 'dw.debit-spread' }, { location: 'replace' });
                return;
            }

            $scope.stage = 0;
            $scope.currentStage = 0;
            commService.showBackButton(false);

            $scope.appData.inProcess = false;
            //$scope.appData.backOverrideFN = $scope.goToLobby;

            $timeout(function () {
                $ionicScrollDelegate.$getByHandle('expressScroll').scrollTop();
            }, 0);
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })

            if (!$scope.appData.selectedBankAccountIndex) {
           
                $scope.appData.selectedBankAccountIndex = 0;
            }


            console.log("$scope.appData", $scope.appData);
            $scope.selectedBankAccountIndex = $scope.appData.selectedBankAccountIndex;
            console.log("$scope.selectedBankAccountIndex", $scope.selectedBankAccountIndex);
            $scope.accountsToDisplay = $scope.appData.BankAccounts;
            $scope.selectedBankAccount = $scope.accountsToDisplay[$scope.selectedBankAccountIndex];
            //var realHeight = document.getElementById("realHeightDebitSpread").scrollHeight;

            //commService.trigReady();
            commService.sendHeight(800);
            for (var i = 0; i < $scope.appData.BankAccounts.length; i++) {
                $scope.appData.BankAccounts[i].allCreditProductsInd = false;
                var cardsToDisplay = [];
                for (var j = 0; j < $scope.appData.BankAccounts[i].Cards.length; j++) {
                    if ($scope.appData.BankAccounts[i].Cards[j].CreditProductsInd) {
                        $scope.appData.BankAccounts[i].Cards[j].CardIndex = j;
                        cardsToDisplay.push($scope.appData.BankAccounts[i].Cards[j]);
                    }
                }
                if (cardsToDisplay.length > 0) {
                    $scope.appData.BankAccounts[i].creditProductsCards = cardsToDisplay;
                    $scope.appData.BankAccounts[i].allCreditProductsInd = true;
                }
            }


            if (!$scope.selectedCard) {
                $scope.selectedCard = $scope.selectedBankAccount.creditProductsCards[0];
            }
            $scope.accountChanged($scope.selectedBankAccountIndex, $scope.selectedCard.Id);
            $scope.goToStage1();
            $timeout(function () {
                commService.trigReady();
            })
         
        };

        $scope.fillCards = function () {
            $scope.currCards = $scope.appData.BankAccounts[$scope.selectedBankAccountIndex].creditProductsCards;
        };
        $scope.accountNext = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').next();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });
        }

        $scope.accountPrev = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').previous();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

        }

        $scope.accountChanged = function (index, cardIndex) {
            console.log("[Debitpread]-accountChanged", index, cardIndex);
            $scope.appData.selectedBankAccountIndex = index;
            $scope.selectedBankAccountIndex = index;
            $scope.selectedBankAccount = $scope.accountsToDisplay[index];
            console.log("$scope.selectedBankAccountIndex", $scope.selectedBankAccountIndex);
            console.log("accountsToDisplay[index]", $scope.accountsToDisplay[index])
            console.log(" $scope.selectedBankAccount", $scope.selectedBankAccount);
    
   
            if ($scope.selectedBankAccount.allCreditProductsInd) {
                if (cardIndex) {
                    console.log("if..")
                    $scope.cardChanged(cardIndex);
                } else {
                    console.log("else..")
                    $scope.cardChanged($scope.selectedBankAccount.creditProductsCards[0].Id);
                }
            }
            $timeout(function () {
                $scope.updateAccountSlider(index);
                $scope.fillCards();
            })
           // $scope.selectedBankAccountIndex = index;
            console.log("$scope.selectedBankAccountIndex", $scope.selectedBankAccountIndex);
        };

        $scope.cardChanged = function (index) {
            console.log("[Debitpread]-cardChanged", index);
            if ($scope.selectedBankAccount.allCreditProductsInd) {
                $scope.selectedCard = $scope.selectedBankAccount.creditProductsCards[index];
                $scope.selectedCard.shownSteps = $scope.steps;
                $scope.noCardError = true;
                $scope.uniqueId = uniqueIDChosen;
                var obj = {};
                obj.uniqueIDChosen = uniqueIDChosen;
            } else {
                $scope.selectedCard = {};
                $scope.selectedCard.shownSteps = $scope.steps;
                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
            }
        }


        $scope.cardChanged = function (uniqueIDChosen) {
            $scope.uniqueId = uniqueIDChosen;
            //var obj = {};
            //obj.uniqueIDChosen = uniqueIDChosen;
            //$scope.selectedCard = $scope.selectedBankAccount.creditProductsCards[$scope.shownCardIndex];
            if ($scope.selectedBankAccount.allCreditProductsInd) {
                for (var j = 0; j < $scope.selectedBankAccount.creditProductsCards.length; j++) {
                    var uId = $scope.selectedBankAccount.creditProductsCards[j].Id;
                    if (uniqueIDChosen == uId) {
                        $scope.selectedCard = $scope.selectedBankAccount.creditProductsCards[j];
                    }
                }
                if (!$scope.selectedCard || $scope.selectedCard === undefined || typeof ($scope.selectedCard) !== "object") {
                    $scope.selectedCard = {};
                }

                $scope.selectedCard.shownSteps = $scope.steps;
                $scope.noCardError = true;
            }
            else {
                $scope.selectedCard = {};
                $scope.selectedCard.shownSteps = $scope.steps;
                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
            }
        };

        $scope.updateAccountSlider = function (index) {
            console.log("<<<<<<<<<<<<<<UPDATE ACCOUNT SLIDER >>>>>>>>>>>>>>>>>")
            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').update();
            }, 200).then(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').slide(index);
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

            return _promise;
        }
        // #endregion

        $scope.goToStage1 = function () {
            $scope.stage = 1;
            $('body').removeClass('finish');
            $scope.currentStage = 1;
            commService.showBackButton(false);
            $scope.members.showTerms = false;
            $scope.selectedCard.shownSteps = $scope.steps;
            $scope.title = "פריסת חיוב";
            $scope.appData.backOverrideFN = null;
            $scope.getActivePage(0);
            $ionicScrollDelegate.$getByHandle('debitSpreadScroll').scrollTop();
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })
          
        }


        $scope.goToStage2 = function (data) {
            $scope.members.initStage2Data = data;
            $scope.members.initStage3Data = null;
            $('body').removeClass('finish');
            $scope.stage = 2;
            $scope.currentStage = 2;
            commService.showBackButton(true);
            commService.sendHeight(800);
            $scope.appData.backOverrideFN = $scope.goToStage1;
            $scope.getActivePage(1);
            function handleDebitSpreadSubmit2Directive(response) {
                $scope.$broadcast("initStage2", { data: response });
                $scope.$broadcast("initStage3", { data: null });
            }
            handleDebitSpreadSubmit2Directive(data);
            $ionicScrollDelegate.$getByHandle('debitSpreadScroll').scrollTop();
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })
        };

        $scope.goToStage3 = function (data) {
            $scope.members.initStage3Data = data;
            $('body').removeClass('finish');
            $scope.stage = 3;
            $scope.currentStage = 3;
            commService.showBackButton(true);
            commService.sendHeight(850);
            $scope.appData.backOverrideFN = $scope.goToStage2;
            $scope.getActivePage(2);
            function handleDebitSpreadSubmit3Directive(response) {
                $scope.$broadcast("initStage3", { data: response });
            }
            handleDebitSpreadSubmit3Directive(data);
            $ionicScrollDelegate.$getByHandle('debitSpreadScroll').scrollTop();
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })
        };

        $scope.goToStage4 = function (data) {
            $scope.stage = 4;
            commService.showBackButton(false);
            $('body').addClass('finish');
            parent.postMessage({ call: "dwProcessEnd" }, '*');
            $scope.currentStage = 4;
            commService.sendHeight(600);
            $scope.getActivePage(3);
            $scope.appData.backOverrideFN = $scope.goToLobby;

            function handleDebitSpreadSubmitDirective(response) {
                $scope.$broadcast("initStage4", { data: response });
            }

            handleDebitSpreadSubmitDirective(data);

            $ionicScrollDelegate.$getByHandle('debitSpreadScroll').scrollTop();
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })
        };

        $scope.backToHomePage = function () {
            commService.backToHomePage();
        };


        $scope.goBack = function () {
            console.log("goBack");
            $scope.goBackToStage($scope.currentStage - 1);
            $('body').removeClass('finish');
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })
        }

        var goToStage = function (stage) {
            console.log("gotoStage", stage);
            $scope.stage = stage;
            $scope.currentStage = stage;
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })
        }

        $scope.goToLobby = function () {
            commService.backToHomePage();
            // lobbyUiService.go('dw.lobby');
        };

        $scope.$watch("stage", function (stageNew, stageOld) {

            if ((stageNew !== stageOld) && $scope.members.isClearSpreadRequest) {
                connection.debitSpreadClearSpreadRequest($scope.selectedCard.Id);

                $scope.members.isClearSpreadRequest = false;
                console.log("card " + $scope.selectedCard.Id + "is cleared");
            }
        });

        $scope.$on("$destroy", function () {
            //$scope.appData.backOverrideFN = null;
            $scope.appData.inProcess = false;
            window.sessionStorage.removeItem($scope.members.DEBIT_SPREAD_AMOUNT_KEY);

            if ($scope.members.isClearSpreadRequest) {
                connection.debitSpreadClearSpreadRequest($scope.selectedCard.Id);

                $scope.members.isClearSpreadRequest = false;
                console.log("card " + $scope.selectedCard.Id + "is cleared");
            }

            lobbyUiService.loader.hide();
        });

        $scope.goBackToStage = function () {
            console.log("goBackToStage");
            if ($scope.members.showTerms) {
                $scope.title = 'פריסת חיוב';
                $scope.members.showTerms = false;
                $scope.members.isReturnFromTerms = true;
                $scope.stage = 2;
                //$scope.goToStage2(null);
                
                $timeout(function () {
                    $scope.appData.backOverrideFN = $scope.goToStage1;
                }, 100);
            }

            return;
        }

        $scope.goToInfo = function () {
            $scope.title = 'תקנון התכנית';
            $scope.members.showTerms = true;
            $scope.members.isReturnFromTerms = false;
            $scope.appData.backOverrideFN = $scope.goBackToStage;
        };

        $scope.showPopup = function (text) {
            lobbyUiService.popup.alert(text);
        }
        $scope.showMoreInfo = function () {
            var popup = {};
            popup.template = 'app/account/templates/debit-spread/popup/moreInfo.html'
            popup.btns = [];
            popup.btns.push(
                {
                    text: "סגור",
                    type: 'button-positive',
                    onTap: function () {



                    }
                });
            lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, true);
        }
        $scope.init();

    };
})(window, window.anjular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('transFilterController', transFilterController);

    transFilterController.$inject = [
        '$scope', 'connection', '$window', 'appData', 'lobbyUiService', '$rootScope', '$q', 'utilService', 'errorService', 'appSettings',
        '$ionicScrollDelegate', 'googleAnalyticsService', '$timeout', '$ionicLoading', '$ionicPopup', '$location', 'lobbyDataService', '$state', '$stateParams'
    ];

    function transFilterController($scope, connection, $window, appData, lobbyUiService, $rootScope, $q, utilService, errorService, appSettings,
        $ionicScrollDelegate, googleAnalyticsService, $timeout, $ionicLoading, $ionicPopup, $location, lobbyDataService, $state, $stateParams) {

        var vm = this;
        vm.scrollPosition = 0;
        vm.filteredTransactionscrollClass = "trans-filter-no-scroll";
        vm.filteredTransactionscrollStyle = { 'margin-bottom': '8rem', 'height': 'initial' };
        vm.title = "חיפוש עסקה";
        vm.showAdvanced = false;
        vm.cards = [{ "Id": "כל הכרטיסים", "NumTypeDescription": "כל הכרטיסים", "CardType": "", "LastFourDigits": "" }];
        vm.advancedSign = "+";
        vm.advancedText = "חיפוש מתקדם";
        vm.paymentTypeSelect = { key: "0", value: "הכל" };
        vm.transCardPresentSelect = { key: "0", value: "כל סוגי העסקאות" };
        vm.transOriginSelect = { key: "0", value: "הכל" };
        vm.transByPayWalletSelect = { key: "0", value: "כל העסקאות" };
        vm.screenHeight = window.outerHeight > 0 ? (window.outerHeight / 100) * 90 : (window.innerHeight / 100) * 90;
        vm.transTypeValues = [{ key: "0", value: "הכל" }];
        //{ key: "5", value: "רגיל" },
        //{ key: "8", value: "תשלומים" },
        //{ key: "44", value: "הוראת קבע" },
        //{ key: "7", value: "משיכת מזומן" },
        //{ key: "6", value: "זיכויים" },
        //{ key: "59", value: "קרדיט" },
        //{ key: "60", value: "סופר קרדיט" },
        //{ key: "1", value: "עדיף" }];

        vm.cardsArrayLength = 0;

        vm.onloadMoreClicked = false;

        vm.offsetCalc = (vm.screenHeight / 100) * 25;;

        vm.transCardPresent = [{ key: "0", value: "הכל" }, { key: "2", value: "באינטרנט/בטלפון" }, { key: "1", value: "בחנות" }];

        vm.transOrigin = [{ key: "0", value: "הכל" }, { key: "2", value: "בארץ" }, { key: "1", value: "בחו\"ל" }];

        vm.transOriginLabel = "בארץ או בחו\"ל?";

        vm.transCardPresentLabel = "באינטרנט, בטלפון או בחנות?";

        vm.transByPayWalletLabel = "עסקאות בארנק דיגיטלי";

        vm.transByPayWallet = [{ key: "0", value: "כל העסקאות" }, { key: "1", value: "רק עסקאות בארנק דיגיטלי" }, { key: "2", value: "בלי עסקאות בארנק דיגיטלי" }];

        vm.transTypeValuesLabel = "סוג העסקה";

        vm.MerchantHebNameLabel = "שם העסק בו קנית";

        vm.CardSearchResults = [];

        vm.showResults = false;

        vm.isLoggedIn = connection.isLoggedIn();

        //vm.cards.key = "כל הכרטיסים";

        vm.closeCheckBox = false;

        vm.isMultipleClicked = false;

        vm.validateTrnAmtDisplay = false;

        vm.validateDatesDisplay = false;

        vm.countIndex = 75;

        vm.duration = 584;

        vm.metadata = [];

        vm.serverRequest = null;

        vm.analyticsUsedAdvancedSearch = "regular-search";

        vm.scrollerElement = angular.element('#trans-filter-scroll');

        /* display trans denial button if query param td=1:
        let queryString = new URLSearchParams(window.location.search);
        let queryParams = Object.fromEntries(queryString.entries());
        let transDenialQueryParam = queryParams.td;
        */

        vm.scrollerElement.css('margin-bottom', '8rem');
        vm.scrollerElement.css('height', 'initial');
        if (!vm.isLoggedIn) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.trans-filter' }, { location: 'replace' });
            return;
        }

        var serverRequest = sessionStorage.getItem("filterTransRequest");
        if (serverRequest) {
            sessionStorage.removeItem("filterTransRequest");
            getFilteredTransDetails(serverRequest);
        }

        lobbyDataService.loadMetaData().then(function (metadata) {
            vm.metadata = metadata;
            angular.forEach(metadata.menu, function (menu) {
                angular.forEach(menu.items, function (item) {
                    if (item.state == "dw.trans-filter") {
                        console.log("**********item=", item);
                        var transactions = item.transactions;
                        vm.duration = item.duration;
                        transactions.forEach(function (transaction) {
                            var splitData = transaction.split(',');
                            vm.transTypeValues.push({
                                key: splitData[0].trim(),
                                value: splitData[1].trim()
                            });
                        });
                    }
                });
            });
        });

        vm.change = function (uniqueId) {
            vm.cards.key = uniqueId;
            console.log("*************uniqueId= " + uniqueId);
        }

        vm.init = function () {
            $timeout(function () {
                console.log("****************trans filter init111*************");
                vm.showResults = false;
                vm.filteredTransactionscrollClass = "trans-filter-no-scroll";
                vm.filteredTransactionscrollStyle = { 'margin-bottom': '8rem', 'height': 'initial' };
                vm.scrollerElement.css('margin-bottom', '8rem');
                vm.scrollerElement.css('height', 'initial');
                vm.MerchantHebName = "";
                vm.FromTrnAmt = "";
                vm.ToTrnAmt = "";
                vm.numberOfResults = 0;
                vm.showAdvanced = false;
                if (vm.showAdvanced) {
                    vm.advancedSign = "-";
                }
                else {
                    vm.advancedSign = "+";
                }
                var today = moment().toDate();
                //today = moment(today).format('DD/MM/YYYY');
                var newDate = moment().subtract(30, "days").toDate();
                //newDate = moment(newDate).format('DD/MM/YYYY');
                vm.datePickerValueFrom = newDate;
                vm.datePickerValueTo = today;
                vm.paymentTypeSelect = { key: "0", value: "הכל" };
                vm.transCardPresentSelect = { key: "0", value: "כל סוגי העסקאות" };
                vm.transOriginSelect = { key: "0", value: "הכל" };
                vm.transByPayWalletSelect = { key: "0", value: "כל העסקאות" };
                for (var i = 0; i < vm.cards.length; i++) {
                    vm.cards[i].isChecked = false;
                }
                vm.cardsArrayLength = 0;

            }, 0);
        }

        function showLoader() {
            $ionicLoading.show({
                template: _template
            });
        }

        function hideLoader() {
            $ionicLoading.hide();
        }

        vm.operation = function () {
            console.log('vm.operation');
        }

        vm.clickAdvanced = function () {
            vm.showAdvanced = !vm.showAdvanced;
            if (vm.showAdvanced) {
                vm.advancedSign = "-";
                vm.analyticsUsedAdvancedSearch = "advanced-search";
            }
            else {
                vm.advancedSign = "+";
                vm.paymentTypeSelect = { key: "0", value: "הכל" };
                vm.transCardPresentSelect = { key: "0", value: "כל סוגי העסקאות" };
                vm.transOriginSelect = { key: "0", value: "הכל" };
                vm.transByPayWalletSelect = { key: "0", value: "כל העסקאות" };
                vm.MerchantHebName = "";
                vm.analyticsUsedAdvancedSearch = "regular-search";
            }
        }

        vm.backToSearch = function () {
            googleAnalyticsService.trackPage('/vp/transaction-search/return-search');
            googleAnalyticsService.insertEvent({ page: 'transaction-search', action: 'return-search' });
            vm.showResults = false;
            $rootScope.filteredTransactionResultsVisible = false;
            $timeout(function () {
                vm.filteredTransactionscrollClass = "trans-filter-no-scroll";
                vm.filteredTransactionscrollStyle = { 'margin-bottom': '8rem', 'height': 'initial' };
                vm.scrollerElement.css('margin-bottom', '8rem');
                vm.scrollerElement.css('height', 'initial');
                vm.scrollerElement.css('overflow', 'none');
            }, 500);
        }

        vm.searchFilteredTransactions = function () {
            googleAnalyticsService.trackPage('/vp/transaction-search/search/' + vm.analyticsUsedAdvancedSearch);
            googleAnalyticsService.insertEvent({ page: 'transaction-search', eventName: vm.analyticsUsedAdvancedSearch, action: 'search' });
            if (!vm.validateTrnAmt() || !vm.validateDates()) {
                return;
            }

            try {
                $ionicScrollDelegate.scrollTop();
                showLoader();
                getFilteredTransDetails();
            }
            catch (ex) {
                console.log("ex= " + ex);
            }
            console.log("datePickerValue= " + vm.datePickerValueFrom);
        }

        vm.MainDivPressed = function () {
            $timeout(function () {
                console.log("MainDivPressed, isMultipleClicked= ", vm.isMultipleClicked);
                if (!vm.isMultipleClicked) {
                    vm.closeCheckBox = false;
                }
                vm.isMultipleClicked = false;
                //vm.scrollerElement.css('height', '8rem');
            }, 200);
        }

        vm.FieldBlur = function () {
            $timeout(function () {
                if (!vm.showResults) {
                    vm.scrollerElement.css('margin-bottom', '8rem');
                    vm.scrollerElement.css('height', 'initial');
                    vm.scrollerElement.css('overflow', 'none');
                }
            }, 2600);

            console.log('FieldBlur');
        }

        var _template = '<div class="animation ion-loading-c"></div><div class="msg">מבצע חיפוש...</div>';

        var selectedBankAccountIndex = 0;
        var cardIndex = 0;
        function loadCards() {
            $rootScope.$on('getAccountFinished')
            {
                fillCards();
            }
        }

        function fillCards() {
            if (appData.BankAccounts && vm.cards.length == 1) {
                var selectedBankAccount = appData.BankAccounts[selectedBankAccountIndex];
                var bankAccountsArray = appData.BankAccounts;
                var selectedCard = selectedBankAccount.Cards[cardIndex];
                $timeout(function () {
                    for (var i = 0; i < bankAccountsArray.length; i++) {
                        vm.cards = vm.cards.concat(bankAccountsArray[i].Cards);
                    }
                });
            }
        }



        function getFilteredTransDetails(serverRequest) {

            vm.closeCheckBox = false;
            var request = {};

            if (!serverRequest) {                
                var cardarray = [];

                if (vm.cards.key != "כל הכרטיסים" && typeof vm.cards.key != "undefined") {
                    cardarray.push(vm.cards.key);
                }
                else {
                    vm.cards.forEach(function (card) {
                        if (!isNaN(card.Id) && card.isChecked) {
                            cardarray.push(card.Id);
                        }
                    });
                }
                request.UniqueID = cardarray;

                request.FromTransDate = vm.datePickerValueFrom;
                request.ToTransDate = vm.datePickerValueTo;
                request.TransCardPresentInd = vm.transCardPresentSelect.key;
                request.TransactionsOrigin = vm.transOriginSelect.key;
                request.MerchantHebName = vm.MerchantHebName;
                request.MerchantHebCity = vm.MerchantHebCity;
                request.TrnExecWay = vm.paymentTypeSelect.key;
                request.TrnType = vm.paymentTypeSelect.key;
                request.FromTrnAmt = vm.FromTrnAmt;
                request.ToTrnAmt = vm.ToTrnAmt;
                request.WalletTranInd = vm.transByPayWalletSelect.key;
                request.CashAccountRecInd = "1";
            }
            else {
                request = serverRequest;
            }

            //**************mock*************//
            //vm.gridData = [];
            //vm.gridData.categories = [];
            //var category = {};
            //var data = [];
            //category.isExpand = true;
            //category.expandSymbol = "-";
            //category.title = '1111';
            //category.fullResults = false;

            //for (var k = 0; k < 10; k++) {
            //    var trans = {};
            //    trans.sideTitle = '10/12/82';
            //    trans.sideIcon = '';
            //    trans.additionalAction = { label: 'פריסה', callback: function () { alert('פריסה'); } }
            //    trans.params = [];
            //    trans.title = 'cal';
            //    trans.amount = 100;
            //    trans.clickable = true;
            //    trans.generalComment = '';
            //    trans.locationId = 1;
            //    trans.details = {
            //        mark: true,
            //        params: [
            //            { title: "צ'אט עם נציג", value: "", type: 3 },
            //            { title: 'חיפוש בגוגל', value: "", type: 4 },
            //        ],
            //        dataArray: [],//DataResult,
            //        comments: [],//result.Comments,
            //    };
            //    data.push(trans);
            //}
            //category.rows = data;
            //vm.gridData.categories.push(category);
            //vm.showResults = true;
            //$rootScope.filteredTransactionResultsVisible = true;
            //hideLoader();
            //vm.gridData.numberOfResults = 1;
            //**************mock*************//

            ///*
            
            connection.getFilteredTransDetails(request)
                .then(function (response) {
                    vm.serverRequest = request;
                    var CardsArray = response.CardsArray;
                    vm.CardSearchResults = CardsArray;

                    var cardsLast4digitsCount = [];
                    appData.BankAccounts.forEach(bankAccount => {
                        bankAccount.Cards.forEach(card => {
                            cardsLast4digitsCount.push(card.LastFourDigits);
                        });
                    });

                    if (CardsArray) {
                        vm.numberOfResults = 0;
                        vm.gridData = [];
                        vm.gridData.onLoadMore = vm.onLoadMore;
                        vm.gridData.categories = [];
                        var categoryCounter = 0;
                        angular.forEach(CardsArray, function (value, key) {
                            categoryCounter += 1;
                            var category = {};
                            category.title = key;
                            category.fullResults = false;
                            var data = [];
                            vm.numberOfResults = vm.numberOfResults + value.length;
                            //if (categoryCounter == 1) {
                            //    category.isExpand = true;
                            //    category.expandSymbol = "-";
                            //}
                            //else {
                            //    category.isExpand = false;
                            //    category.expandSymbol = "+";
                            //}

                            category.isExpand = true;
                            category.expandSymbol = "-";

                            value.isSupportTransDenial = isCardSupportTransDenial(key, cardsLast4digitsCount);

                            var lastIndex = 0;
                            vm.loadData(value, category, 0, lastIndex, 0, false, data);
                            category.rows = data;
                            vm.gridData.categories.push(category);

                        });

                        $timeout(function () {
                            vm.filteredTransactionscrollClass = "trans-filter-scroll";
                            vm.filteredTransactionscrollStyle = { 'height': '100%' };
                            vm.scrollerElement.css('height', '100%');
                            vm.showResults = true;
                            hideLoader();
                        }, 200);
                        $rootScope.filteredTransactionResultsVisible = true;
                        vm.gridData.numberOfResults = vm.numberOfResults;
                    }
                    else {
                        //errorService.handleError(, "");
                    }
                }, function (error) {
                    hideLoader();

                    var title = error[0].response.Response.Status.Message;

                    var settings = {
                        title: '',
                        template: '<p></p>',
                        cssClass: null,
                    };

                    var extOptions = angular.extend(settings,
                        {
                            cssClass: null,
                            title: '',
                            template: '<header><p>' + title + '</header>',
                            buttons: [
                                {
                                    text: 'סגור',
                                    type: 'button-positive',
                                    onTap: function () {

                                    }
                                }
                            ],
                        });

                    if (title) {
                        var popup = {};
                        popup.template = 'app/blockCard/shared/templates/cvv-popup.html';
                        popup.btns = [];
                        popup.text = title;
                        popup.btns.push(
                            {
                                text: "סגור",
                                type: 'button-positive',
                                onTap: function () {

                                }
                            });

                        lobbyUiService.popup.alert(title, "", null, null, popup.btns, false, "transaction-filter-popup");
                    }
                    else {
                        errorService.handleError(error, "");
                    }
                });//*/
        }

        var isCardSupportTransDenial = function (key, cardsLast4digitsCount) {
            for (var lastFourDigits of cardsLast4digitsCount) {
                if (key.includes(lastFourDigits)) {
                    return cardsLast4digitsCount.indexOf(lastFourDigits) == cardsLast4digitsCount.lastIndexOf(lastFourDigits);
                }
            }
            return false;
        }

        vm.loadData = function (results, category, startIndex, lastIndex, additionalIndex, pushLoadResult, data) {
            for (var j = startIndex; j < results.length + additionalIndex; j++) {
                if (pushLoadResult) {
                    if (j == results.length) {
                        category.fullResults = true;
                    }
                    if (j > lastIndex) {
                        category.lastIndex = j;
                        break;
                    }
                }
                else {
                    if (results.length <= vm.countIndex) {
                        category.fullResults = true;
                    }

                    if (j > vm.countIndex - 1) {
                        category.lastIndex = j;
                        break;
                    }
                }
                var result = results[j];

                var trans = {};
                trans.id = result.TrnIntId;
                trans.title = result.MerchantName;
                trans.amount = result.TrnAmt;
                trans.color = "";
                if ((trans.amount.indexOf("-") > -1 && result.IsDisplayAsCashAccountCharge == null)  || result.IsDisplayAsCashAccountCharge == false) {
                    trans.color = "{color: 'rgb(62, 121, 0)'}";
                }
                trans.sideTitle = result.TrnPurchaseDate;
                trans.sideIcon = '';
                trans.additionalAction = { label: 'פריסה', callback: function () { alert('פריסה'); } }
                trans.params = [];
                trans.clickable = true;
                trans.generalComment = result.CreditPaymentsComment;
                trans.locationId = trans.id + j;
                trans.isSupportTransDenial = results.isSupportTransDenial;

                var DataResult = [];

                if (JSON.stringify(result.Data) !== JSON.stringify({})) {
                    var keys = Object.keys(result.Data);
                    for (var i = 0; i < keys.length; i++) {
                        var dataComment = keys[i] + ": " + result.Data[keys[i]];
                        DataResult.push(dataComment);
                    }
                }

                var cardPresentIcon = "";
                var cardPresentText = "";
                var cardPresentShow = false;
                if (result.TransCardPresentInd == 1) {
                    //cardPresentIcon = "ico-touch";
                    //cardPresentText = "כרטיס הוצג";                    
                }
                else if (result.TransCardPresentInd == 2) {
                    cardPresentIcon = "ico-eyeline";
                    cardPresentText = "כרטיס לא הוצג";
                    cardPresentShow = true;
                    result.Comments.remove("כרטיס לא הוצג");
                }

                var chatTitle = '';

                if (appData.metaData.IsCustomerServiceLead) {
                    chatTitle = "צ'אט עם נציג Cal";
                }

                if (appData.metaData.IsCustomerServiceLeadByWhatsApp) {
                    chatTitle = 'בירור מול נציג Cal';
                }

                trans.details = {
                    mark: true,
                    params: [
                        { label: 'ענף', value: result.BranchCodeDesc, type: 1, isSingle: true },
                        { label: 'כתובת', value: result.MerchantAddress, type: 1, isSingle: true },
                        { label: 'טלפון', value: result.MerchantPhoneNo, type: 2, isSingle: true },
                        //{ label: 'פקס', value: result., type: 2, isSingle: true },

                        //{ title: chatTitle, value: result.MerchantName, type: 3 },

                        { title: 'חיפוש בגוגל', value: result.MerchantName, type: 4 }                        

                    ],
                    isStandingOrder: result.IsStandingOrder,
                    dataArray: DataResult,                    
                    comments: result.Comments,
                    cardPresent: { value: cardPresentText, showImage: true, ico: cardPresentIcon, show: cardPresentShow }

                };

                if (trans.isSupportTransDenial) {
                    trans.details.params.push({ title: 'לבירור נוסף', value: { trnId: result.TrnIntId, numerator: result.TrnNumerator, serverRequest: vm.serverRequest }, type: 5 });
                }

                if (result.BranchCodeDesc == null || result.BranchCodeDesc == "") {
                    trans.details.params.splice(0, 1);
                }

                if (pushLoadResult) {
                    category.rows.push(trans);
                }
                else {
                    data.push(trans);
                }
            }
        }

        $rootScope.$on("filteredTransactionResultsVisibleChanged", function () {
            $timeout(function () {
                vm.showResults = false;
                vm.filteredTransactionscrollClass = "trans-filter-no-scroll";
                vm.filteredTransactionscrollStyle = { 'margin-bottom': '8rem', 'height': 'initial' };
                vm.scrollerElement.css('margin-bottom', '8rem');
                vm.scrollerElement.css('height', 'initial');
                vm.scrollerElement.css('overflow', 'none');
            });
        });        

        vm.onLoadMore = function (category) {
            vm.onloadMoreClicked = true;
            var results = vm.CardSearchResults[category.title]
            var startIndex = category.lastIndex;
            var lastIndex = startIndex + vm.countIndex;
            if (lastIndex > results.length)
                lastIndex = results.length - 1;

            vm.loadData(results, category, startIndex, lastIndex, 1, true);
            console.log("**********category = " + category);
        }

        vm.validateTrnAmt = function () {
            if (vm.ToTrnAmt != "" && parseInt(vm.FromTrnAmt) > parseInt(vm.ToTrnAmt)) {
                vm.validateTrnAmtDisplay = true;
                return false;
            }
            else {
                vm.validateTrnAmtDisplay = false;
                return true;
            }
        }

        vm.validateDates = function () {
            if (vm.datePickerValueFrom > vm.datePickerValueTo) {
                vm.validateDatesDisplay = true;
                return false;
            }
            else {
                vm.validateDatesDisplay = false;
                return true;
            }
        }

        vm.onClickShowResults = function ($event) {
            if (!vm.onloadMoreClicked) {
                if ($event.pageY > (vm.screenHeight - 100)) {
                    if ($rootScope.gridAnchorIdFilter != 'aaa') {
                        var locationId = $rootScope.gridAnchorIdFilter;
                        var element = angular.element('#' + locationId)[0];
                        //console.log('*****$element = ', element);
                        var height = element.offsetHeight;
                        //console.log('*****height = ', height);
                        var offest = element.offsetTop;
                        //console.log('*****offest = ', offest);
                        //console.log('*****vm.screenHeight = ', vm.screenHeight);
                        //console.log('*****vm.offsetCalc = ', vm.offsetCalc);
                        $ionicScrollDelegate.$getByHandle('TransFilterScrollDelegate').scrollTo(0, offest - vm.screenHeight + vm.offsetCalc + height + 10, true);
                        //console.log('*****$rootScope.gridAnchorIdFilter222 = ', $rootScope.gridAnchorIdFilter);
                        $rootScope.gridAnchorIdFilter == 'aaa';
                    }
                }
            }
            vm.onloadMoreClicked = false;
        }

        $scope.$on('$ionicView.beforeEnter', function (e, viewData) {
            console.log('******************trans filter before enter*******************');
            viewData.enableBack = true;
            googleAnalyticsService.trackPage('/vp/transaction-search/welcome');
            googleAnalyticsService.insertEvent({ page: 'transaction-search', action: 'welcome' });
            loadCards();
            vm.init();
        });

        $scope.$on('$ionicView.beforeLeave', function (e, viewData) {
            console.log('******************trans filter before leave*******************');
            vm.closeCheckBox = false;
            vm.cards.splice(1, vm.cards.length - 1);
            $rootScope.filteredTransactionResultsVisible = false;
        });
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('stopStandingOrderController', stopStandingOrderController);

    stopStandingOrderController.$inject = [
        'commService','$scope', 'connection', 'appData', 'lobbyUiService', '$rootScope','errorService',
        '$ionicScrollDelegate', 'googleAnalyticsService', '$timeout', '$ionicLoading', '$stateParams',
        '$sce'];

    function stopStandingOrderController(commService,$scope, connection,appData, lobbyUiService, $rootScope,errorService,
        $ionicScrollDelegate, googleAnalyticsService, $timeout, $ionicLoading,  $stateParams,
        $sce) {

        var vmStopStandingOrder = this;

        vmStopStandingOrder.isLoggedIn = connection.isLoggedIn();

        if (!vmStopStandingOrder.isLoggedIn) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.stop-standing-order' }, { location: 'replace' });
            return;
        }
     

        $rootScope.$on("bankFromHost", function (evt, bankId) {
            console.log("[DW][Listener]",bankId)
            var banks = $scope.appData.BankAccounts.map(function (b) { return commService.cutExistingBankIdWorkAround(b) });
            var idx = banks.indexOf(bankId);
            console.log("[DW] index",idx);
            if (idx == -1) idx = 0;
            var bankAccount = $scope.appData.BankAccounts[idx];
            console.log("[DW] fullbankAccount", bankAccount);
            vmStopStandingOrder.onBankAccountChange(bankAccount);//.accountChanged(idx)
        })

        $rootScope.$on("cardFromHost", function (evt, cardId) {
            console.log("selectedcard on blockCard", cardId)
            vmStopStandingOrder.change(cardId);
            vmStopStandingOrder.uniqueId = cardId;
        })

        vmStopStandingOrder.isMultipleClicked = false;

        vmStopStandingOrder.closeCheckBox = false;

        vmStopStandingOrder.title = "הוראות קבע";

        vmStopStandingOrder.cards = [];

        vmStopStandingOrder.displayMore = false;

        vmStopStandingOrder.showstopStandingOrder = false;

        vmStopStandingOrder.showSuccess = false;

        vmStopStandingOrder.noResults = false;

        vmStopStandingOrder.screenHeight = window.outerHeight > 0 ? (window.outerHeight / 100) * 90 : (window.innerHeight / 100) * 90;

        vmStopStandingOrder.offsetCalc = (vmStopStandingOrder.screenHeight / 100) * 25;;

        vmStopStandingOrder.gridData = [];

        vmStopStandingOrder.uniqueId;

        vmStopStandingOrder.responseArray = {};

        vmStopStandingOrder.title = "";

        vmStopStandingOrder.cancelOrderData = {};

        vmStopStandingOrder.FailedResultList = [];

        vmStopStandingOrder.previousExpandedRow = undefined;

        vmStopStandingOrder.CurrentExpandedRow = undefined;

        vmStopStandingOrder.pageName = 'הוראות קבע';

        vmStopStandingOrder.analyticsAction = 'פירוט הוראות קבע';

        vmStopStandingOrder.showBackToStandingOrder = true;

        $rootScope.stopStandingOrder = false;

        console.log('url= ', window.location);

        var _template = '<div class="animation ion-loading-c"></div><div class="msg">טוען נתונים...</div>';

        vmStopStandingOrder.standalone = $stateParams.standalone

        if (vmStopStandingOrder.standalone) {
            $('#page-wrapper').addClass('standalone');
        }

        function showLoader() {
            $ionicLoading.show({
                template: _template
            });
        }

        function hideLoader() {
            $timeout(function () {
                $ionicLoading.hide();
            }, 500);
        }

        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vmStopStandingOrder.hideNavBar = inIframe();


        function init() {
            $("body").removeClass("finish");
            vmStopStandingOrder.showstopStandingOrder = false;
            vmStopStandingOrder.showSuccess = false;
            commService.showBackButton(false);
   
            
        }

        vmStopStandingOrder.operation = function () {
            console.log('vm.operation');
        }

        vmStopStandingOrder.selectedBankAccountIndex = 0;

        var cardIndex = 0;
        
        vmStopStandingOrder.change = function (uniqueId) {
            vmStopStandingOrder.errorResults = false;
            vmStopStandingOrder.noResults = false;
            vmStopStandingOrder.DisplayResults = true;
            commService.showBackButton(false);
            vmStopStandingOrder.uniqueId = uniqueId;
            console.log("*************uniqueId= " + vmStopStandingOrder.uniqueId);
            getStandingOrders();
            
        }

        var cardIndex = 0;
        function loadCards() {
            $rootScope.$on('getAccountFinished')
            {
                fillCards();

            }
        }

        function fillCards() {
            console.log("****fillCards*****");
            if (appData.BankAccounts) {
                var selectedBankAccount = appData.BankAccounts[vmStopStandingOrder.selectedBankAccountIndex];
                var bankAccountsArray = appData.BankAccounts;
                var selectedCard = selectedBankAccount.Cards[cardIndex];
                vmStopStandingOrder.selectedBankAccount = selectedBankAccount;
                $timeout(function () {
                    var account = vmStopStandingOrder.selectedBankAccount
                    var cards = [];
                    var cardsLength = account.Cards.length;
                    var i = 0;
                    for (i = 0; i < cardsLength; i++) {
                        if (account.Cards[i].GoodCardHolderOwnerInd) {
                            cards.push(account.Cards[i]);
                        }
                    }
                    vmStopStandingOrder.cards = cards;
                    getStandingOrders();
                    if (vmStopStandingOrder.cards.length > 0)
                        vmStopStandingOrder.uniqueId = vmStopStandingOrder.cards[0].Id;
                });
            }
            setTimeout(function () {
                commService.trigReady();
            })
        }

        vmStopStandingOrder.MainDivPressed = function () {
            vmStopStandingOrder.showRadioDiv = false;
        }

        vmStopStandingOrder.backToHomePage = function () {
            $('body').removeClass('finish');
            commService.backToHomePage();
            //lobbyUiService.go('dw.lobby');
        }

        function fillData(standingOrderData, category, data, locationid) {
            var trans = {};
            trans.id = locationid;
            trans.sideTitle = standingOrderData.LastDebitDate;
            trans.sideIcon = '';
            trans.additionalAction = { label: 'פריסה', callback: function () { alert('פריסה'); } }
            trans.params = [];
            trans.title = standingOrderData.MerchantName;
            trans.amount = standingOrderData.LastDebitAmount;
            trans.clickable = true;
            trans.generalComment = '';
            trans.locationId = "stopStandingOrder" + locationid;
            trans.onClickAction = vmStopStandingOrder.stopStandingOrderPressed;
            trans.merchantId = standingOrderData.MerchantId;
            trans.merchantType = standingOrderData.MerchantType;
            trans.OnExpandClient = vmStopStandingOrder.getMoreDetails;
            trans.TrnCurrencyCode = standingOrderData.TrnCurrencyCode;
            trans.TrnExacWay = standingOrderData.TrnExacWay;
            trans.TrnIntId = standingOrderData.TrnIntId;
            trans.TrnPurchaseDate = standingOrderData.TrnPurchaseDate;
            trans.TransTypeDesc = standingOrderData.TransTypeDesc;
            trans.TransSource = standingOrderData.TransSource;
            trans.TrnType = standingOrderData.TrnType;
            trans.IsCancelled = standingOrderData.isCancelled;
            trans.stoppedComment = standingOrderData.comment;
            trans.page = vmStopStandingOrder.pageName;

            trans.details = {
                mark: true,
                params: [
                    { title: "עצירת הוראת קבע", value: "", type: 3 },
                    { title: 'חיפוש בית העסק בגוגל', value: "", type: 4 },
                ],
                dataArray: [],//DataResult,
                comments: [
                    //["10/12/82", "100"],
                    //["10/12/83", "200"],
                    //["10/12/85", "300"]
                ],//result.Comments,
            };
            data.push(trans);
            category.rows = data;
            vmStopStandingOrder.showResults = true;
            vmStopStandingOrder.gridData.numberOfResults = 1;
        }

        function populateResults() {
            if (vmStopStandingOrder.uniqueId == undefined) {
                vmStopStandingOrder.uniqueId = vmStopStandingOrder.selectedBankAccount.Cards[0].uniqueId;
            }
            var array = vmStopStandingOrder.responseArray[vmStopStandingOrder.uniqueId];
            if (array != undefined && array.ErrorMessage == undefined) {
                vmStopStandingOrder.gridData.categories = [];
                var category = {};
                var data = [];
                category.isExpand = true;
                category.expandSymbol = "-";
                category.fullResults = false;
                vmStopStandingOrder.noResults = false;
                vmStopStandingOrder.DisplayResults = true;
                commService.showBackButton(false);
                var merchantArray = array.MerchantsArray;
                for (var i = 0; i < merchantArray.length; i++) {
                    fillData(merchantArray[i], category, data, i);
                }
                vmStopStandingOrder.gridData.categories.push(category);
            }
            else {

                if (JSON.stringify(vmStopStandingOrder.FailedResultList) !== JSON.stringify([])) {
                    if (vmStopStandingOrder.FailedResultList.indexOf(vmStopStandingOrder.uniqueId) > -1) {
                        vmStopStandingOrder.DisplayResults = false;
                        vmStopStandingOrder.errorResults = true;
                        vmStopStandingOrder.getOrdersError = $sce.trustAsHtml(array.ErrorMessage);
                    }
                }
                else {
                    vmStopStandingOrder.noResults = true;
                    vmStopStandingOrder.DisplayResults = false;
                    vmStopStandingOrder.getOrdersError = "";
                }
            }
            hideLoader();
            $timeout(function () {
                vmStopStandingOrder.setHeight();
            })
        }

        function getStandingOrders(uniqueId) {
            showLoader();
            console.log('*******getStandingOrders*******');
            var request = {};
            var cardarray = [];

            if (JSON.stringify(vmStopStandingOrder.responseArray) === JSON.stringify({}) || uniqueId != undefined) {

                if (uniqueId != undefined) {
                    cardarray.push(uniqueId);
                }
                else {
                    vmStopStandingOrder.cards.forEach(function (card) {
                        cardarray.push(card.Id);
                    });
                }

                request.UniqueID = cardarray;

                connection.getStandingOrders(request)
                    .then(function (response) {
                        console.log('*******response', response);
                        vmStopStandingOrder.responseArray = response.CreditCardsArray;
                        vmStopStandingOrder.FailedResultList = response.FailedResultList;
                        populateResults();
                    },
                    function (error) {
                        console.log('*******error', error);
                        errorService.handleError(error, "");
                        hideLoader();
                    });
            }
            else {
                populateResults();
            }
            $timeout(function () {
                vmStopStandingOrder.setHeight();
            })
        

        }

    

        vmStopStandingOrder.toggleMore = function () {
            console.log("TOGGLE");
            vmStopStandingOrder.displayMore = !vmStopStandingOrder.displayMore;
            if (vmStopStandingOrder.displayMore == true) {
                googleAnalyticsService.insertEvent({ page: vmStopStandingOrder.pageName, action: vmStopStandingOrder.analyticsAction, eventName: 'בתוך 60 יום - מה זה אומר?' });
            }

        }
        vmStopStandingOrder.setHeight = function () {
            var realHeight = document.getElementById("realHeightStopStandingOrders").scrollHeight;
            //console.log("RealHeight", realHeight);
            realHeight = realHeight + 150;
            if (realHeight + 80 < 500) realHeight = 700;
            commService.sendHeight(realHeight);
        }

        vmStopStandingOrder.onClickShowResults = function ($event) {
            setTimeout(function () {
                setTimeout(function () {
                    vmStopStandingOrder.setHeight();
                })
            }, 2000)
            console.log("SHOW RESULTS");
            if (!vmStopStandingOrder.onloadMoreClicked) {
                if ($event.pageY > (vmStopStandingOrder.screenHeight - 100)) {
                    if ($rootScope.gridAnchorIdFilter != 'aaa') {
                        var locationId = $rootScope.gridAnchorIdFilter;
                        var element = angular.element('#' + locationId)[0];
                        var height = element.offsetHeight;
                        var offest = element.offsetTop;
                        $ionicScrollDelegate.scrollTo(0, offest - vmStopStandingOrder.screenHeight + vmStopStandingOrder.offsetCalc + height + 10, true);
                        $rootScope.gridAnchorIdFilter == 'aaa';
                    }
                }
            }
            vmStopStandingOrder.onloadMoreClicked = false;
        }

        vmStopStandingOrder.stopStandingOrderPressed = function (data) {
            console.log("******data******= ", data);
            googleAnalyticsService.insertEvent({ page: vmStopStandingOrder.pageName, action: vmStopStandingOrder.analyticsAction, eventName: 'עצירת הוראת קבע' });
            vmStopStandingOrder.title = data.title;
            vmStopStandingOrder.cancelOrderData = data;
            vmStopStandingOrder.showstopStandingOrder = true;
            commService.showBackButton(true);
            $rootScope.stopStandingOrder = true;
        }

        vmStopStandingOrder.tryAgainError = function () {
            getStandingOrders(vmStopStandingOrder.uniqueId);
        }

        vmStopStandingOrder.executeStopStandingOrder = function (delayCancellation) {
            showLoader();
            console.log("***vmStopStandingOrder.executeStopStandingOrder*** ", vmStopStandingOrder.cancelOrderData);
            googleAnalyticsService.insertEvent({ page: vmStopStandingOrder.pageName, action: 'עצירת הוראת קבע', eventName: 'כפתור ירוק-לעצירת הוראת הקבע' });
            var data = vmStopStandingOrder.cancelOrderData;
            var request = {};

            var popup = {};
            popup.template = 'app/blockCard/shared/templates/address-wrong-defective-popup.html';
            popup.text = 'אנו מתנצלים, אך בגלל תקלה לא ניתן לעצור את הוראת הקבע כרגע. ניתן לנסות שוב מאוחר יותר או לפנות למוקד הצ\'אט שלנו.';
            popup.btns = [];
            popup.btns.push(
                {
                    text: "נסה שנית",
                    type: 'button-positive',
                    onTap: function () {
                        googleAnalyticsService.insertEvent({ page: vmStopStandingOrder.pageName, action: 'עצירת הוראת קבע', eventName: 'הודעת שגיאה-נסה שנית' });
                        vmStopStandingOrder.executeStopStandingOrder(delayCancellation);
                    }
                });

            popup.btns.push(
                {
                    text: "סגור",
                    type: 'button-grey',
                    onTap: function () {
                        googleAnalyticsService.insertEvent({ page: vmStopStandingOrder.pageName, action: 'עצירת הוראת קבע', eventName: 'הודעת שגיאה-סגור' });
                        vmStopStandingOrder.showstopStandingOrder = false;
                    }
                });

            request.UniqueId = vmStopStandingOrder.uniqueId;
            request.MerchantId = data.merchantId;
            request.MerchantType = data.merchantType;
            request.DelayCancellation = delayCancellation;
            request.MerchantName = data.title;
            request.TrnType = data.TrnType;
            request.TrnExacWay = data.TrnExacWay;
            request.AmtBeforeConvAndIndex = data.AmtBeforeConvAndIndex;
            request.TrnCurrencyCode = data.TrnCurrencyCode;
            request.TrnPurchaseDate = data.TrnPurchaseDate;
            request.TransTypeDesc = data.TransTypeDesc;
            request.TransSource = data.TransSource;
            request.DebCrdDate = data.FullDebCrdDate;
            request.TrnIntId = data.TrnIntId;
            request.AmtBeforeConvAndIndex = data.AmtBeforeConvAndIndex;

            connection.CancelStandingOrder(request)
                .then(function (response) {
                    console.log('*******response CancelStandingOrder', response);
                    googleAnalyticsService.insertEvent({ page: vmStopStandingOrder.pageName, action: 'עצירת הוראת קבע', eventName: 'עצירת הוראת הקבע בוצעה בהצלחה' });
                    vmStopStandingOrder.showstopStandingOrder = false;
                    commService.showBackButton(false);
                    vmStopStandingOrder.showSuccess = true;
                    $("body").addClass("finish");
                    parent.postMessage({ call: "dwProcessEnd" }, '*');
                    $rootScope.stopStandingOrder = true;
                    vmStopStandingOrder.delayCancellation = delayCancellation;
                    hideLoader();
                },
                function (error) {
                    console.log('*******CancelStandingOrder error', error);
                    //lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, true);
                    var message = error[0].response.Response.Status.Message;
                    if (message == undefined) {
                        errorService.handleError(error);
                    }
                    else {
                        lobbyUiService.popup.alert(popup.text, null, null, null, popup.btns);
                    }
                    hideLoader();
                });
        }

        vmStopStandingOrder.backToStandingOrder = function () {
            googleAnalyticsService.insertEvent({ page: vmStopStandingOrder.pageName, action: 'עצירת הוראת קבע', eventName: 'בחזרה להוראות הקבע שלי' });
            vmStopStandingOrder.showstopStandingOrder = false;
            commService.showBackButton(false);
            vmStopStandingOrder.showSuccess = false;
            $("body").removeClass("finish");
            if (vmStopStandingOrder.CurrentExpandedRow != undefined) {
                vmStopStandingOrder.CurrentExpandedRow.vmReference.isExpand = false;
            }
        }

        vmStopStandingOrder.goToLobby = function () {
            commService.backToHomePage();
        }

        vmStopStandingOrder.getMoreDetails = function (merchantId, merchantType, locationId) {
            showLoader();
            console.log('****vmStopStandingOrder.getMoreDetails***= ', merchantId, merchantType);
            var request = {};

            request.UniqueId = vmStopStandingOrder.uniqueId;
            request.MerchantId = merchantId;
            request.MerchantIdType = merchantType;

            var rows = vmStopStandingOrder.gridData.categories[0].rows;
            var row = [];

            for (var i = 0; i < rows.length; i++) {
                if (rows[i].locationId == locationId) {

                    row = rows[i];
                    i = rows.length + 1;
                }
            }

            vmStopStandingOrder.CurrentExpandedRow = row;

            if (vmStopStandingOrder.previousExpandedRow == undefined) {
                vmStopStandingOrder.previousExpandedRow = row;
            }
            else if (vmStopStandingOrder.previousExpandedRow != row) {
                vmStopStandingOrder.previousExpandedRow.vmReference.isExpand = false;
                vmStopStandingOrder.previousExpandedRow = row;
            }

            //var request = {};

            var popup = {};
            popup.template = 'app/blockCard/shared/templates/address-wrong-defective-popup.html';
            popup.text = 'אנו מתנצלים, בגלל תקלה לא נוכל להציג פירוט עבור הוראת קבע זאת.<br />כדאי לנסות שוב מאוחר יותר';
            popup.btns = [];
            popup.btns.push(
                {
                    text: "נסה שנית",
                    type: 'button-positive',
                    onTap: function () {
                        vmStopStandingOrder.getMoreDetails(merchantId, merchantType, locationId);
                    }
                });

            popup.btns.push(
                {
                    text: "סגור",
                    type: 'button-grey',
                    onTap: function () {
                        //vmStopStandingOrder.showstopStandingOrder = false;
                    }
                });

            if (row.details.comments.length == 0) {
                connection.getStandingOrdersDetails(request)
                    .then(function (response) {
                        console.log('*******response getStandingOrdersDetails', response);
                        var length = response.StandingOrdersArray.length;
                        var result = response.StandingOrdersArray[length - 1]

                        //row.OnExpandClient = result.getMoreDetails;
                        row.TrnCurrencyCode = result.AdditionalParameters.TrnCurrencyCode;
                        row.TrnExacWay = result.AdditionalParameters.TrnExacWay;
                        row.TrnIntId = result.AdditionalParameters.TrnIntId;
                        row.TrnPurchaseDate = result.AdditionalParameters.TrnPurchaseDate;
                        row.TransTypeDesc = result.AdditionalParameters.TransTypeDesc;
                        row.TransSource = result.AdditionalParameters.TransSource;
                        row.TrnType = result.AdditionalParameters.TrnType;
                        row.DebCrdDate = result.DebitDate;
                        row.FullDebCrdDate = result.DebitFullDate;
                        row.AmtBeforeConvAndIndex = result.AmtBeforeConvAndIndex;

                        for (var j = 0; j < length; j++) {
                            var comment;
                            var standingOrdersParam = response.StandingOrdersArray[j];
                            if (standingOrdersParam.Comment != null) {
                                comment = [response.StandingOrdersArray[j].DebitDate, response.StandingOrdersArray[j].Comment, response.StandingOrdersArray[j].DebitAmount];
                            }
                            else {
                                comment = [response.StandingOrdersArray[j].DebitDate, "", response.StandingOrdersArray[j].DebitAmount];
                            }
                            row.details.comments.push(comment);
                        }
                        hideLoader();
                    },
                    function (error) {
                        console.log('*******getStandingOrdersDetails error', error);
                        //errorService.handleError(error);
                        var message = error[0].response.Response.Status.Message;
                        if (message == undefined) {
                            errorService.handleError(error);
                        }
                        else {
                            lobbyUiService.popup.alert(popup.text, null, null, null, popup.btns);
                        }
                        hideLoader();
                    });
            }
            else {
                hideLoader();
            }
        }

        vmStopStandingOrder.onBankAccountChange = function (account) {
            console.log("account", account);
            vmStopStandingOrder.errorResults = false;
            vmStopStandingOrder.noResults = false;
            vmStopStandingOrder.DisplayResults = true;
            commService.showBackButton(false);
            var length = appData.BankAccounts.length;
            var previous = vmStopStandingOrder.selectedBankAccountIndex;
            for (var i = 0; i < length; i++) {
                if (appData.BankAccounts[i].AccountNumber == account.AccountNumber
                    && appData.BankAccounts[i].BankName == account.BankName
                    && appData.BankAccounts[i].BankBranchNumber == account.BankBranchNumber) {
                    vmStopStandingOrder.selectedBankAccountIndex = i;
                    i = length + 1;
                }
            }
            if (previous != vmStopStandingOrder.selectedBankAccountIndex) {
                vmStopStandingOrder.cards = [];
                loadCards();
                vmStopStandingOrder.responseArray = {};
                getStandingOrders();
            }
            console.log("vmStopStandingOrder.onBankAccountChange");
        }

        vmStopStandingOrder.callParentDivClick = function (show) {
            show = false;
        }

        $rootScope.$on("stopStandingOrderVisibleChanged", function () {
            vmStopStandingOrder.showstopStandingOrder = false;
            vmStopStandingOrder.showSuccess = false;
            $("body").removeClass("finish");
            vmStopStandingOrder.DisplayResults = true;
            commService.showBackButton(false)
            $rootScope.stopStandingOrder = false;
            vmStopStandingOrder.CurrentExpandedRow.vmReference.isExpand = false;
        });

        $scope.$on('$ionicView.beforeEnter', function (e, viewData) {
            console.log('******************stop standing order before enter*******************');
            viewData.enableBack = true;
            $rootScope.stopStandingOrder = false;
            //googleAnalyticsService.trackPage('/vp/transaction-search/welcome');
            //googleAnalyticsService.insertEvent({ page: 'transaction-search', action: 'welcome' });           
            fillCards();
            init();
            //vmStopStandingOrder.init();
        });

        $scope.$on('$ionicView.beforeLeave', function (e, viewData) {
            console.log('******************stop standing order after enter*******************');

            //for back service!!!!!!
            $rootScope.stopStandingOrder = false;


            //if (!connection.isLoggedIn()) {
            //   lobbyUiService.go('dw.login', { nextPage: 'dw.stop-standing-order' });
            //return;
            //}
        });

    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
        .controller('StandingOrdersMainController', StandingOrdersMainController);

    StandingOrdersMainController.$inject = [
        '$scope', 'connection', '$window', 'appData', 'lobbyUiService', '$rootScope', '$q', 'utilService', 'errorService',
        '$ionicScrollDelegate', 'googleAnalyticsService', '$timeout', '$ionicLoading', '$ionicPopup', '$location', 'lobbyDataService', '$stateParams',
        '$sce'];

    function StandingOrdersMainController($scope, connection, $window, appData, lobbyUiService, $rootScope, $q, utilService, errorService,
        $ionicScrollDelegate, googleAnalyticsService, $timeout, $ionicLoading, $ionicPopup, $location, lobbyDataService, $stateParams, $sce) {
        var vmStandingOrdersMain = this;

        vmStandingOrdersMain.standalone = $stateParams.standalone

        console.log('url= ', window.location);        

        vmStandingOrdersMain.pageNameAnalytics = 'הוראות קבע';

        if (vmStandingOrdersMain.standalone) {
            $('#page-wrapper').addClass('standalone');
        }

        vmStandingOrdersMain.navigateToPage = function(pageName, analyticsName)
        {
            googleAnalyticsService.insertEvent({ page: vmStandingOrdersMain.pageNameAnalytics, action: 'לובי הוראת קבע', eventName: analyticsName });
            lobbyUiService.navigate(pageName);
        }
    }    
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
    .directive("cal4uHtmlContent", cal4uHtmlContent);

    cal4uHtmlContent.$inject = ['$http', 'connection'];

    function cal4uHtmlContent($http, connection) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                source: '@'
            },
            controller: [
                '$scope', function ($scope) {
                    connection.getHtml($scope.source).then(
                        function (data) {
                            $scope.content = $.parseHTML(data);
                        },
                        function () {
                        }
                    );
                }
            ],
            template: '<div class="terms" ng-bind-html="content | trusted"></div>',
            link: function ($scope, element) {
                $scope.$watch('content', function (newvalue) {
                    if (newvalue) {
                        var current;
                        for (var i = 0; i < newvalue.length; i++) {
                            current = $(newvalue[i]).html();
                            if (current && current.length > 0) {
                                element.append($.trim($(newvalue[i]).html()));
                            }
                        }
                        setTimeout(function () {
                            element.addClass('active');
                        }, 2000);
                    }
                });
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
    .directive('chartDraw', chartDraw);

    function chartDraw() {
        'use strict';
        return {
            restrict: 'A',
            scope: {
                chartData: '='
            },
            link: function postLink(scope, element) {
                scope.$watch('chartData', function (newVal) {
                    if (newVal)
                        scope.updateView();
                }, true);

                scope.updateView = function () {
                    var dates = [];
                    var amounts = [];
                    var currentMonth;
                    var data = scope.chartData;
                    for (var i = data.length - 1; i > -1; i--) {
                        amounts.push(data[i].Amount.Value);
                        currentMonth = data[i].Month;
                        if (!(currentMonth == 'מרץ' || currentMonth == 'מאי'))
                            currentMonth = currentMonth.substring(0, 3) + ' \'';

                        dates.push(currentMonth + ' ' + data[i].Date.split('/')[2].substring(2));
                    }
                    $(element).highcharts({
                        chart: {
                            type: 'column',
                            backgroundColor: '#171717',
                            height: (5.5 * 16),
                            width: $(window).width()
                        },
                        title: {
                            text: ''
                        },
                        subtitle: {
                            text: ''
                        },
                        xAxis: {
                            labels: {
                                style: {
                                    color: '#FFFFFF',
                                    whiteSpace: 'nowrap',
                                    fontSize: 9,
                                    fontWeight: 'normal'
                                }

                            },
                            categories: dates,
                            tickLength: 0,
                            lineColor: '#FFFFFF',
                            lineWidth: 2
                        },
                        yAxis: {
                            title: {
                                text: ''
                            },
                            gridLineColor: '#00000000',
                            labels: {
                                enabled: false
                            }
                        },
                        tooltip: {
                            enabled: false
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0,
                                borderWidth: 0,
                                color: '#9CD036',
                                borderRadius: 5
                            },
                            series: {
                                dataLabels: {
                                    color: '#FFFFFF',
                                    enabled: true,
                                    format: "{point.y:.1f}",
                                    crop: false,
                                    overflow: 'none',
                                    x: 28,
                                    style: {
                                        fontSize: 9,
                                        textAlign: 'right',
                                        fontWeight: 'normal'
                                    }
                                },
                                states: {
                                    hover: {
                                        enabled: false
                                    }
                                }
                            }
                        },
                        credits: {
                            enabled: false
                        },

                        legend: {
                            enabled: false
                        },
                        series: [
                            {
                                data: amounts

                            }
                        ]
                    });
                };
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
    .directive('genericGrid', genericGrid);

    function genericGrid() {
        // usage:   gridData = {headers: ['header1', 'header2'...], rows: [['c11','c12','c13'],['c21','c22','c23']...]}, 
        //          gClass = class to apply on entire grid, hasArrow: show arrow in last cell
        'use strict';
        return {
            restrict: 'A',
            templateUrl: 'app/account/templates/gridData.html',
            scope: {
                gridData: '=',
                gClass: '=',
                rowClickFunction: '&',
                selectedCard: '='
            },
            link: function postLink(scope) {

                scope.buildGrid = function () {
                };

                scope.$watch('gridData', function () {
                    scope.buildGrid();
                }, true);
            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
    .directive('iconBoxes', iconBoxes);

    function iconBoxes() {
        'use strict';
        return {
            restrict: 'A',
            template:
                '<div class="icon-box" ng-repeat="sector in chargesData.Sectors">' +
                    '<div class="icon-box-text">' +
                    '<div class="c4u-F4">{{sector.Name}}</div>' +
                    '<div class="c4u-F4">{{sector.Percent.FormattedValue}}</div>' +
                    '</div>' +
                    '<div class="icon">' +
                    '<img src="{{sector.Icon20x20}}"/>' +
                    '</div>' +
                    '</div>',
            scope: {
                chargesData: '='
            },
            link: function postLink() {
            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
    .directive('keySubmit', keySubmit);

    function keySubmit() {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.keyCode == 13 || event.keyCode == 9 || event.which === 13) {
                    
                    event.preventDefault();
                    if (attrs.keySubmit == 'next') {
                        $(':input:eq(' + ($(':input').index(this) + 1) + ')').focus();
                    }
                    scope.$apply(function () {
                        scope.$eval(attrs.keySubmit);
                    });
                    this.blur();
                }
            });
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
    .directive('numberOnlyInput', numberOnlyInput);

    function numberOnlyInput() {
        return {
            require: '?ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }

                ngModelCtrl.$parsers.push(function (val) {
                    if (!val)
                        return;
                    val = val.toString();

                    var clean = val.replace(/[^0-9]+/g, '');
                    if (val !== clean) {
                        ngModelCtrl.$setViewValue(clean);
                        ngModelCtrl.$render();
                    }
                    return clean;
                });

                element.bind('keypress', function (event) {
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }
                });
            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
    .directive('pieDraw', pieDraw);

    pieDraw.$inject = ['utilService'];

    function pieDraw(utilService) {
        'use strict';
        return {
            restrict: 'A',
            scope: {
                pieData: '='
            },
            link: function postLink(scope, element) {
                scope.$watch('pieData', function (newVal) {
                    if (newVal)
                        scope.updateView();
                }, true);

                scope.updateView = function () {

                    if (scope.pieData)
                        scope.chargeData = utilService.getChargesDataByAmount(scope.pieData);

                    var sectors = [];


                    for (var index = 0; index < scope.chargeData.length; ++index) {
                        sectors.push({ y: scope.chargeData[index]['Amount']['Value'], name: scope.chargeData[index]['Name'], color: scope.chargeData[index]['FromColor'] });
                    }

                    $(element).highcharts({
                        chart: {
                            type: 'pie',
                            spactingTop: 0,
                            spacingBottom: 0,
                            margin: [0, 0, 0, 0],
                            padding: [0, 0, 0, 0],
                            height: $(window).width() * 0.54,
                            width: $(window).width() * 0.50
                        },
                        credits: {
                            enabled: false
                        },
                        title: false,
                        plotOptions: {
                            pie: {
                                borderWidth: 0,
                                startAngle: 90,
                                innerSize: '72%',
                                size: '100%',
                                shadow: false,
                                dataLabels: false,
                                stickyTracking: false,
                                states: {
                                    hover: {
                                        enabled: false
                                    }
                                }
                            }
                        },
                        tooltip: {
                            enabled: false
                        },
                        series: [
                            {
                                data: sectors
                            }
                        ]
                    });
                };
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
    .directive('processProgress', processProgress);

    function processProgress() {
        //usage: steps: ['stage1','stage2',...], currentStage:  index - starts from 1
        'use strict';
        return {
            restrict: 'A',
            template: '<div class="loans-progress" ng-class="{three: steps.length == 3}">' +
                '<div ng-repeat="s in steps" ng-class="{future: $index + 1 > current, past: $index + 1 <= current}">' +
                '<img ng-src="{{getAssetName($index)}}" ng-hide="($index + 1) == current">' +
                '<div ng-hide="($index + 1) != current">{{s}}</div>' +
                '</div>' +
                '</div>',
            scope: {
                steps: "=",
                current: "="
            },
            link: function postLink(scope) {
                scope.getAssetName = function (index) {
                    var name = 'content/images/step_' + (index + 1);
                    if (index == scope.steps.length - 1)
                        name = name + '_last';
                    name = name + '.svg';
                    return name;
                }
            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
    .directive('seekBar', seekBar);

    function seekBar() {
        'use strict';
        return {
            restrict: 'A',
            require: '?ngModel',
            template: '<div style="position: relative">' +
                '<div class="seek-bar-empty"></div>' +
                '<div class="seek-bar-full"></div>' +
                '<div class="seek-bar-knob"></div>' +
                '</div>',
            link: function postLink(scope, element, attrs, ngModel) {

                var dragging, newWidth, min, max, step;
                var sliderElement = element.find('.seek-bar-full');
                var sliderWidth = sliderElement.width();
                //var sliderStart = sliderElement.offset().left;
                var knob = element.find('.seek-bar-knob');
                initBar();

                function initBar() {
                    dragging = false;
                    min = (attrs.min) ? parseFloat(attrs.min) : 0;
                    max = (attrs.max) ? parseFloat(attrs.max) : 100;
                    step = (attrs.step) ? parseFloat(attrs.step) : 10;
                    newWidth = getWidthFromVal();
                    sliderElement.css({ width: 100 * newWidth + '%' });
                    knob.css({ left: 100 * newWidth + '%' });
                }


                element.bind('touchstart touchmove touchend touchcancel click', function (event) {
                    var touch = null;
                    try {
                        touch = event.originalEvent.changedTouches[0];
                    } catch (e) {
                    }

                    if (touch) {
                        var simulatedEvent = document.createEvent("MouseEvent");
                        simulatedEvent.initMouseEvent({
                            touchstart: "mousedown",
                            touchmove: "mousemove",
                            touchend: "mouseup",
                            touchcancel: "mouseup",
                            click: "mouseup"
                        }[event.type], true, true, window, 1,
                            touch.screenX, touch.screenY,
                            touch.clientX, touch.clientY, false,
                            false, false, false, 0, null);
                        touch.target.dispatchEvent(simulatedEvent);
                        event.originalEvent.preventDefault();
                    }
                });

                element.on('mousedown', function (event) { //if knob start drag emulation
                    if (event.toElement == knob[0]) {
                        dragging = true;
                    }
                });

                element.on('mousemove', function (event) {
                    if (dragging) {
                        newWidth = (event.pageX - sliderElement.offset().left) / sliderWidth;
                        if (newWidth <= 1 && newWidth >= 0) {
                            sliderElement.css({ width: 100 * newWidth + '%' });
                            knob.css({ left: 100 * newWidth + '%' });
                        } else if (newWidth > 1)
                            newWidth = 1;
                        else if (newWidth < 0)
                            newWidth = 0;
                        ngModel.$setViewValue(calcNewVal());
                        scope.$apply();
                    }
                });

                element.on('mouseup', function (event) { //if knob finish drag, else update to position
                    if (dragging)
                        dragging = false;
                    else {
                        newWidth = (event.pageX - sliderElement.offset().left) / sliderWidth;
                        if (newWidth > 1)
                            newWidth = 1;
                        else if (newWidth < 0)
                            newWidth = 0;
                        sliderElement.css({ width: 100 * newWidth + '%' });
                        knob.css({ left: 100 * newWidth + '%' });
                    }
                    ngModel.$setViewValue(calcNewVal());
                    scope.$apply();
                });

                element.on('mouseleave', function () { //if knob finish drag, else update to position
                    dragging = false;
                });

                function calcNewVal() {
                    var newVal = min + newWidth * (max - min);
                    if ((newVal - min) % step != 0) {
                        if ((newVal - min) % step > step / 2)
                            newVal = newVal + step - (newVal - min) % step;
                        else {
                            newVal = newVal - (newVal - min) % step;
                        }
                    }
                    newVal = Math.ceil(newVal);

                    if (newVal > max || newWidth > 0.98) {
                        newVal = Math.floor(max);
                    }

                    return newVal;
                }

                function getWidthFromVal() {
                    var w = (ngModel.$viewValue - min) / (max - min);
                    if (w <= 0)
                        w = 0.01;
                    if (w > 1)
                        w = 1;
                    return w;
                };

                scope.$watch(attrs.ngModel, function () {
                    newWidth = getWidthFromVal();
                    sliderElement.css({ width: 100 * newWidth + '%' });
                    knob.css({ left: 100 * newWidth + '%' });
                });
                scope.$watch(function () { return element.attr('min'); }, function () {
                    initBar();
                });
                scope.$watch(function () { return element.attr('max'); }, function () {
                    initBar();
                });
                scope.$watch(function () { return element.attr('step'); }, function () {
                    initBar();
                });

            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
    .directive('spinner', spinner);

    function spinner() {
        'use strict';
        return {
            restrict: 'A',
            template: '<div class="spinner">' +
                '<div ng-repeat="i in [1,2,3]" class="spinner-container">' +
                '<div ng-repeat="j in [1,2,3,4]" class="circle"></div>' +
                '</div>' +
                '</div>'
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';

    let isSelectedItem = false;

    // Create an AngularJS service called debounce
    angular.module('Cal4U').factory('debounce', ['$timeout', '$q', function ($timeout, $q) {
        // The service is actually this function, which we call with the func
        // that should be debounced and how long to wait in between calls
        return function debounce(func, wait, immediate) {
            console.log("debouncing');");
            var timeout;
            // Create a deferred object that will be resolved when we need to
            // actually call the func
            var deferred = $q.defer();
            return function () {
                console.log("not immidiate");
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) {

                        deferred.resolve(func.apply(context, args));
                        deferred = $q.defer();
                    }
                };
                var callNow = immediate && !timeout;
                if (timeout) {
                    $timeout.cancel(timeout);
                }
                timeout = $timeout(later, wait);
                if (callNow) {
                    deferred.resolve(func.apply(context, args));
                    deferred = $q.defer();
                }
                return deferred.promise;
            };
        };
    }]);


    angular.module('Cal4U')
        .directive('autocomplete', function ($timeout) {
            return {
                controller: 'autocompleteController',
                restrict: 'E',
                require: "?ngModel",
                replace: true,
                scope: {
                    choices: '=',
                    enteredtext: '=',
                    minlength: '=',
                    selected: '=',
                    placeholder: '=',
                    datasource: '=',
                    cityData: '=',
                    filterVariable: '=',
                    isDisabled: '=',
                    displayVariable: '='
                },
                templateUrl: 'app/account/directives/autocomplete.html'
            }
        }).
        controller('autocompleteController', function ($scope, debounce, $http, $timeout, $q) {

            $scope.filteredChoices = [];
            $scope.isVisible = { suggestions: false };
            $scope.filterItems = function () {
                // console.log("enteredtext", $scope.enteredtext);
                // console.log("moreDAta", $scope.cityData);
                // console.log("scope.minlegnt", $scope.minlength);
                if ($scope.enteredtext && ($scope.enteredtext.value.length >= $scope.minlength)) {
                    querySearch($scope.enteredtext.value);
                }
                else {
                    $scope.isVisible.suggestions = false;

                    if ($scope.canceler) {
                        // cancel the previous http call
                        $scope.canceler.resolve();
                    }
                }
            };
            $scope.filterItemsWrap = debounce($scope.filterItems, 300, false)


            /**
             * Takes one based index to save selected choice object
             */
            $scope.selectItem = function (index) {
                console.log('index', index);
                console.log("$scope.seleec", $scope.selected);
                $scope.enteredtext.value = $scope.filteredChoices[index][$scope.displayVariable + 'Name'];
                $scope.isVisible.suggestions = false;

                $scope.$emit($scope.selected, $scope.filteredChoices[index]);

                isSelectedItem = true;
            };

            /**
             * Search for states... use $timeout to simulate
             * remote dataservice call.
             */
            function querySearch(query) {
                if ($scope.canceler) {
                    // cancel the previous http call
                    $scope.canceler.resolve();
                }

                $scope.canceler = $q.defer();

                console.log("QuerySearch", query);
                var data = {
                    value: query
                };
                //add cityData when sending to get Street..
                if ($scope.cityData) {
                    data.settlementCode = $scope.cityData;
                }
                $http.post($scope.datasource, data, { timeout: $scope.canceler.promise }).then(function (res) {
                    $scope.filteredChoices = query ? res.data.result[$scope.filterVariable] : [];
                    $scope.isVisible.suggestions = $scope.filteredChoices.length > 0 ? true : false;
                }, function (err) {
                    console.log("err", err);
                });
            }

            $scope.onBlur = function () {

                // prevent emit it item was selected
                if (!isSelectedItem) {

                    // city
                    if ($scope.filteredChoices &&
                        $scope.filteredChoices.length > 0 &&
                        $scope.filteredChoices[0]['settlementName'] &&
                        $scope.filteredChoices[0]['settlementName'] == $scope.enteredtext.value) {

                        $scope.$emit($scope.selected, $scope.filteredChoices[0]);

                    }
                    else if ($scope.filteredChoices &&
                        $scope.filteredChoices.length > 0 &&
                        $scope.filteredChoices[0]['streetName'] &&
                        $scope.filteredChoices[0]['streetName'] == $scope.enteredtext.value) {

                        $scope.$emit($scope.selected, $scope.filteredChoices[0]);

                    }
                    else {
                        $scope.$emit($scope.selected, {});
                    }

                    setTimeout(function () { $scope.isVisible.suggestions = false; });
                }
            }

            $scope.onfocus = function () {
                isSelectedItem = false;
            }
        })
})(window, window.angular);


﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
    .directive('validNumber', ['lobbyUiService', validNumber]);

    function validNumber(lobbyUiService) {
        return {
            require: '?ngModel',
            link: function (scope, element) {


                element.bind('keypress', function (event) {

                    event = (event) ? event : window.event;
                    var charCode = (event.which) ? event.which : event.keyCode;

                    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46 && charCode != 110) {
                        return false;
                    } else {
                        return true;
                    }
                });

                element.bind('blur', function (event) {
                    var maxMsg = event.currentTarget.attributes.msg.value + ' המבוקש גבוה מהסכום המקסימלי האפשרי';
                    var minMsg = event.currentTarget.attributes.msg.value + ' המבוקש נמוך מהסכום המינימלי האפשרי';
                    var msgMult = 'יש לבחור  ' + event.currentTarget.attributes.msg.value + ' בכפולות של ' + event.currentTarget.attributes.interval.value;
                    var msgCurrentAmount = 'סכום החיוב שבחרת הינו זהה לסכום החיוב הנוכחי. \n יש לבחור סכום שונה';
                    var msg = '';
                    var valid = true;
                    var msgNew = event.currentTarget.attributes.msgNew && event.currentTarget.attributes.msgNew.value? event.currentTarget.attributes.msgNew.value: "";

                    if (parseInt(event.currentTarget.value) < parseInt(event.currentTarget.attributes.min.value)) {
                        msg = minMsg;
                        valid = false;
                    } else if (parseInt(event.currentTarget.value) > parseInt(event.currentTarget.attributes.max.value)) {
                        msg = maxMsg;
                        valid = false;
                    } else if (parseInt(event.currentTarget.value) % parseInt(event.currentTarget.attributes.interval.value) != 0) {
                        if (msgNew && msgNew != "") {
                            msg = msgNew;
                        }
                        else {
                            msg = msgMult;
                        }
                        valid = false;
                    } else if (event.currentTarget.attributes.current)
                        if (parseInt(event.currentTarget.value) == parseInt(event.currentTarget.attributes.current.value)) {
                            
                            msg = msgCurrentAmount;
                            valid = false;
                        }

                    if (!valid) {

                        element.removeClass("ng-valid");

                        element.addClass("ng-invalid");

                        if (navigator.notification) {
                            navigator.notification.alert(
                                msg,
                                function () {
                                },
                                ' ',
                                'סגור'
                            );
                        } else {
                            lobbyUiService.popup.alert(msg, 'נא לשים לב');
                        }

                    }
                });
            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';

    angular.module('Cal4U').factory('utilService', utilService);

    function utilService() {
        return {
            getChargesDataByAmount: function (charges) {
                //this.unOrderedSectors = charges;
                return charges.Sectors.sort(function (a, b) { return b['Amount']['Value'] - a['Amount']['Value']; });
            },

            splitDate: function (date) {
                return (date.substring(0, 5) + ' ' + date.substring(6));
            },

            stringFormat: function () {
                var s = arguments[0];
                for (var i = 0; i < arguments.length - 1; i++) {
                    var reg = new RegExp("\\{" + i + "\\}", "gm");
                    s = s.replace(reg, arguments[i + 1]);
                }

                return s;
            },


            // Sample Data
            unOrderedSectors: [
                {
                    "Name": "variance",
                    "Code": "994",
                    "Icon20x20": "https://stage-restservices.cal-online.co.il/CAL4U-Test/Content/Images/Icons/20X20/ICO994_20X20.png",
                    "ToColor": "#7253be",
                    "FromColor": "#8b6ad6",
                    "Amount": {
                        "Value": 8.08,
                        "FormattedValue": "8.08",
                        "ReversedFormattedValue": "8.08"
                    },
                    "Currency": null,
                    "Percent": {
                        "Value": 50.0,
                        "FormattedValue": "50%",
                        "ReversedFormattedValue": "50%"
                    }
                },
                {
                    "Name": "food",
                    "Code": "994",
                    "Icon20x20": "https://stage-restservices.cal-online.co.il/CAL4U-Test/Content/Images/Icons/20X20/ICO994_20X20.png",
                    "ToColor": "#7253be",
                    "FromColor": "#FA3C80",
                    "Amount": {
                        "Value": 1.01,
                        "FormattedValue": "1.01",
                        "ReversedFormattedValue": "1.01"
                    },
                    "Currency": null,
                    "Percent": {
                        "Value": 12.5,
                        "FormattedValue": "12.5%",
                        "ReversedFormattedValue": "12.5%"
                    }
                },
                {
                    "Name": "clothing",
                    "Code": "994",
                    "Icon20x20": "https://stage-restservices.cal-online.co.il/CAL4U-Test/Content/Images/Icons/20X20/ICO994_20X20.png",
                    "ToColor": "#7253be",
                    "FromColor": "#02CD4E",
                    "Amount": {
                        "Value": 2.02,
                        "FormattedValue": "2.02",
                        "ReversedFormattedValue": "2.02"
                    },
                    "Currency": null,
                    "Percent": {
                        "Value": 25.0,
                        "FormattedValue": "25%",
                        "ReversedFormattedValue": "25%"
                    }
                },
                {
                    "Name": "fuel",
                    "Code": "994",
                    "Icon20x20": "https://stage-restservices.cal-online.co.il/CAL4U-Test/Content/Images/Icons/20X20/ICO994_20X20.png",
                    "ToColor": "#7253be",
                    "FromColor": "#646464",
                    "Amount": {
                        "Value": 1.01,
                        "FormattedValue": "1.01",
                        "ReversedFormattedValue": "1.01"
                    },
                    "Currency": null,
                    "Percent": {
                        "Value": 12.5,
                        "FormattedValue": "12.5%",
                        "ReversedFormattedValue": "12.5%"
                    }
                }
            ],

            // Check If Need
            colorAndImagesDictionary: {

                // Keys are not yet set
                '001': { Color: '#1C85C6', Icon: 'furniture_and_home.svg' },
                '002': { Color: '#8B6AD6', Icon: 'variance.svg' },
                '003': { Color: '#D5DE00', Icon: 'direct_marketing.svg' },
                'food': { Color: '#FA3C80', Icon: 'food.svg' },
                '005': { Color: '#E18A06', Icon: 'tourism.svg' },
                '006': { Color: '#2EBBBF', Icon: 'telecommunications.svg' },
                'fuel': { Color: '#646464', Icon: 'fuel.svg' },
                'clothing': { Color: '#02CD4E', Icon: 'clothing.svg' },
                '009': { Color: '#ADADAD', Icon: 'stores.svg' },
                '010': { Color: '#DB0303', Icon: 'institues.svg' },
                '011': { Color: '#D8A100', Icon: 'jewelry.svg' },
                '012': { Color: '#4898DB', Icon: 'medicine.svg' },
                '013': { Color: '#60A6BE', Icon: 'institues.svg' },
                '014': { Color: '#C2D00E', Icon: 'office_equipment.svg' },
                '015': { Color: '#2EBBBF', Icon: 'electricity.svg' },
                '016': { Color: '#C56731', Icon: 'finance.svg' },
                '017': { Color: '#453949', Icon: 'hotels.svg' },
                '018': { Color: '#DF306E', Icon: 'cosmetics.svg' },
                '019': { Color: '#917600', Icon: 'car.svg' },
                '020': { Color: '#ED8D49', Icon: 'resturants.svg' },
                '021': { Color: '#A6B211', Icon: 'other_industries.svg' },
                '022': { Color: '#313131', Icon: 'tires.svg' },
                '023': { Color: '#679063', Icon: 'boks.svg' },
                '024': { Color: '#F83500', Icon: 'gas.svg' },
                '025': { Color: '#72A72A', Icon: 'repairs.svg' },
                '026': { Color: '#85401A', Icon: 'auto_parts.svg' },
                '027': { Color: '#8DAD57', Icon: 'security.svg' },
                '028': { Color: '#B76C91', Icon: 'donations.svg' },
                '029': { Color: '#4067A7', Icon: 'tools.svg' },
                '030': { Color: '#80D51F', Icon: 'digital_wallet.svg' },
                '031': { Color: '#CC7232', Icon: 'consulting_services.svg' },
                '032': { Color: '#458977', Icon: 'hosting.svg' },
                '033': { Color: '#C33C38', Icon: 'transport.svg' },
                '034': { Color: '#49579F', Icon: 'computers.svg' },
                '035': { Color: '#4837AB', Icon: 'entertainment.svg' },
                '036': { Color: '#A8C618', Icon: 'stores.svg' }


            }
        }
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('Cal4U')
        .factory('commService', commService);

    commService.$inject = ['$rootScope', 'appSettings', 'appData', '$timeout', 'backService'];

    function commService($rootScope, appSettings, appData, $timeout, backService) {



        var selectedBank;
        var selectedCard;

        window.addEventListener('message', function (event) {
            console.log("[DW] event From Parent:", event.data);



            if (typeof event.data == 'object' && event.data.call == 'passBankToIframe') {
                console.log("[DW] BANK incoming RAW", event.data.value);
                var cutBank = event.data.value;//branch+account //// :::++++>>>>>>>>>>>>>>>>>>> GARBAGE// cutIncomingBankIdWorkAround(event.data.value)
                console.log("[DW] BANK incoming Cut", cutBank);
                selectedBank = cutBank;
                $rootScope.$emit("bankFromHost", selectedBank);
            }

            if (typeof event.data == 'object' && event.data.call == 'passCardToIframe') {
                console.log("[DW] CARD incoming", event.data.value);
                selectedCard = event.data.value;
                if (!selectedCard) {
                    console.log("[DW] No Card => getting default card from current bank: current bank => ", selectedBank);
                    var banks = appData.BankAccounts.map(function (b) { return cutExistingBankIdWorkAround(b) });
                    //it will fall
                    console.log("[DW] banks here:", banks);
                    console.log("[DW] Our Bank:", selectedBank);
                    var idx = banks.indexOf(selectedBank);
                    console.log("[DW]bank index:", idx);
                    if (idx == -1) idx = 0;
                    selectedCard = appData.BankAccounts[idx].Cards[0].Id;
                }
                console.log("[DW] selected Card:", selectedCard);
                $rootScope.$emit("cardFromHost", selectedCard);
            }


            if (typeof event.data == 'object' && event.data.call == 'goBack') {
                backService.back();
                $timeout(function () {
                    document.body.click();
                }, 300)
            }

            if (typeof event.data == 'object' && event.data.call == 'passMailToIframe') {
                console.log("[DW] incoming mail", event.data.value);
                $rootScope.$emit("mailFromHost", event.data.value);
            }


        }, false);

        //var _getSelectedCardFromHost = function () {
        //    return selectedCard;
        //};

        //var _getSelectedBankFromHost = function () {
        //    return selectedBank;
        //};


        //test only..
        var _trigReady = function () {
            console.log("trig");
            parent.postMessage({ call: "dwReady" }, '*');
        }

        var showBackButton = function (isShowBackButton) {
            console.log("showButton");
            parent.postMessage({ call: "dwBackButton", value: { showButton: isShowBackButton } }, '*');
        }

        var sendHeight = function (height) {
            // console.log("Height?", height);
            if (height < 550) height = 550;
            //console.log("height npw", height);
            parent.postMessage({ call: "dwHeight", value: { height: height } }, '*')
        }

        var backToHomePage = function () {
            console.log("backToHomepage");
            parent.postMessage({ call: "dwBackToDashboard" }, '*');

        }

        var getBigNumberAndDetails = function () {
            console.log("getBigNumberAndDetails");
            parent.postMessage({ call: "dwGetBigNumbers" }, '*');

        }

        var parentGoTop = function () {
            console.log("parentGoTop");
            parent.postMessage({ call: "dwGoTop" }, '*');
        }

        var updateEmailAddress = function (dataToParent) {
            console.log("updateEmailAddress");
            parent.postMessage({ call: "dwUpdateEmail", value: dataToParent }, '*');
        }


        var cutIncomingBankIdWorkAround = function (fullBankId) {
            var branch = fullBankId.substr(fullBankId.length - 3);
            var acc = fullBankId.substr(2, 6);
            var ans = acc + branch
            console.log("[DW][Incoming Bank] Cut: " + ans + " [Explained]:" + branch + " - " + acc);
            return ans;
        }

        var cutExistingBankIdWorkAround = function (bankObject) {
            console.log("bankObject", bankObject);
            var branch = bankObject.BankBranchNumber.padStart(3, '0');
            var acc = bankObject.AccountNumber;
            var ans = branch + acc;
            console.log("[DW][EXISTING Bank] Cut: " + ans + " [Explained]:" + branch + " - " + acc);
            return ans;
        }

        var updateParentBlockedCard = function (uniqueId, blockType) {
            console.log("updateParentBlockCard", uniqueId);
            //card process type will always be here "Block" uppercase b
            parent.postMessage({ call: "dwCardBlocked", value: {cardUniqueId: uniqueId, blockType: blockType }}, '*');
        }

        var getEmailFromParent = function () {
            console.log("getmailfronparent commservice");

            parent.postMessage({ call: "dwGetEmail" }, '*');
        }

        var updateParentActivatedCard = function (uniqueId) {
            console.log("updateParentActivatedCard", uniqueId);
            //cardprocess type wil lalways be here "activate" lowercase a
            parent.postMessage({ call: "dwCardActivated", value: { cardUniqueId: uniqueId } }, '*');
        }

        return {
            //dFromHost: _getSelectedCardFromHost,
            //  getSelectedBankFromHost: _getSelectedBankFromHost,
            trigReady: _trigReady,
            cutExistingBankIdWorkAround: cutExistingBankIdWorkAround,
            sendHeight: sendHeight,
            showBackButton: showBackButton,
            backToHomePage: backToHomePage,
            parentGoTop: parentGoTop,
            getBigNumberAndDetails: getBigNumberAndDetails,
            updateParentBlockedCard: updateParentBlockedCard,
            updateParentActivatedCard: updateParentActivatedCard,
            updateEmailAddress: updateEmailAddress,
            getEmailFromParent: getEmailFromParent
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';

    angular.module('Cal4U')
        .filter('trusted', trusted);

    trusted.$inject = ['$sce'];

    function trusted($sce) {
        return function (val) {
            if (typeof val === 'string' && val.length > 0) {
                return $sce.trustAsHtml(val);
            }
            return undefined;
        }
    }

})(window, window.angular);

﻿(function (window, anjular) {
    'use strict';

    angular.module('Cal4U').controller('debitSpreadController', debitSpreadController);

    debitSpreadController.$inject = ['commService', '$scope', '$timeout', '$ionicScrollDelegate', '$ionicSlideBoxDelegate', '$ionicNavBarDelegate',
        '$state', 'lobbyUiService', 'errorService', 'appData', 'connection', '$stateParams', '$rootScope'];

    function debitSpreadController(commService, $scope, $timeout, $ionicScrollDelegate, $ionicSlideBoxDelegate,
        $ionicNavBarDelegate, $state, lobbyUiService, errorService, appData, connection, $stateParams, $rootScope) {
        $scope.appData = appData;
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.currCards = [];
        $scope.uniqueId = null;
        $scope.uniqueIDChosen = 0;
        $scope.steps = [{ caption: 'סכום', active: true }, { caption: 'תשלומים', active: false }, { caption: 'פרטים', active: false }, { caption: 'סיום', active: false }];

        $scope.$on('$ionicView.beforeLeave', function (e, viewData) {

            $('body').removeClass('finish');

        });

        //$timeout(function () {
        //commService.trigReady();
        //},4000)

        $rootScope.$on("bankFromHost", function (evt, bankId) {
            console.log("[DW][Listener]", bankId)
            var banks = $scope.appData.BankAccounts.map(function (b) { return commService.cutExistingBankIdWorkAround(b) });
            var idx = banks.indexOf(bankId);
            console.log("[DW] index", idx);
            if (idx == -1) idx = 0;
            $scope.accountChanged(idx)
        })

        $rootScope.$on("cardFromHost", function (evt, cardId) {
       
            $scope.cardChanged(cardId);
            $scope.uniqueId = cardId;
        })

        //$scope.$on('$ionicView.loaded', function () {
        //    console.log('loaded in debitsp');
        //    // vm.hideNavBar = lobbyUiService.hideNavBar();
        //    $timeout(function () {
        //        console.log("QWE timeout");
        //        commService.trigReady();
        //    })
        //})

        function inIframe() {
            try {

                var a = window.self !== window.top;
             
                return a;
            } catch (e) {
                return false;
            }
        }
        $scope.hideNavBar = inIframe();


        $scope.standalone = $stateParams.standalone

        if ($scope.standalone == "standalone") {
            $('#page-wrapper').addClass('standalone');
        }

        $scope.members =
        {
            showTerms: false,
            isReturnFromTerms: false,
            title: "פריסת חיוב",
            initStage2Data: null,
            initStage3Data: null,
            isClearSpreadRequest: false,
            DEBIT_SPREAD_AMOUNT_KEY: "DEBIT_SPREAD_AMOUNT_KEY",
            DEBIT_SPREAD_HELPPAGE_IND: "DEBIT_SPREAD_HELPPAGE_IND"
        };

        $scope.title = "פריסת חיוב";

        $scope.doc = {
            url: "CalDocs?id=DebitSpreadTerms.html"
        }

        $scope.getActivePage = function (page) {
            if ($scope.steps == null || $scope.steps == undefined) {
                $scope.steps = [{ caption: 'סכום', active: false }, { caption: 'תשלומים', active: false }, { caption: 'פרטים', active: false }, { caption: 'סיום', active: false }];;
            }
            else {
                for (var i = 0; i < $scope.steps.length; i++) {
                    $scope.steps[i].active = false;
                }
            }
            $scope.steps[page].active = true;
        }
        var firstPageHeight;
        // #region init
        $scope.init = function () {
            //$scope.appData.backOverrideFN = $scope.goToLobby;

            if (!$scope.appData.isLoggedIn) {
                lobbyUiService.go('dw.login', { nextPage: 'dw.debit-spread' }, { location: 'replace' });
                return;
            }

            $scope.stage = 0;
            $scope.currentStage = 0;
            commService.showBackButton(false);

            $scope.appData.inProcess = false;
            //$scope.appData.backOverrideFN = $scope.goToLobby;

            $timeout(function () {
                $ionicScrollDelegate.$getByHandle('expressScroll').scrollTop();
            }, 0);
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })

            if (!$scope.appData.selectedBankAccountIndex) {
           
                $scope.appData.selectedBankAccountIndex = 0;
            }


            console.log("$scope.appData", $scope.appData);
            $scope.selectedBankAccountIndex = $scope.appData.selectedBankAccountIndex;
            console.log("$scope.selectedBankAccountIndex", $scope.selectedBankAccountIndex);
            $scope.accountsToDisplay = $scope.appData.BankAccounts;
            $scope.selectedBankAccount = $scope.accountsToDisplay[$scope.selectedBankAccountIndex];
            //var realHeight = document.getElementById("realHeightDebitSpread").scrollHeight;

            //commService.trigReady();
            commService.sendHeight(800);
            for (var i = 0; i < $scope.appData.BankAccounts.length; i++) {
                $scope.appData.BankAccounts[i].allCreditProductsInd = false;
                var cardsToDisplay = [];
                for (var j = 0; j < $scope.appData.BankAccounts[i].Cards.length; j++) {
                    if ($scope.appData.BankAccounts[i].Cards[j].CreditProductsInd) {
                        $scope.appData.BankAccounts[i].Cards[j].CardIndex = j;
                        cardsToDisplay.push($scope.appData.BankAccounts[i].Cards[j]);
                    }
                }
                if (cardsToDisplay.length > 0) {
                    $scope.appData.BankAccounts[i].creditProductsCards = cardsToDisplay;
                    $scope.appData.BankAccounts[i].allCreditProductsInd = true;
                }
            }


            if (!$scope.selectedCard) {
                $scope.selectedCard = $scope.selectedBankAccount.creditProductsCards[0];
            }
            $scope.accountChanged($scope.selectedBankAccountIndex, $scope.selectedCard.Id);
            $scope.goToStage1();
            $timeout(function () {
                commService.trigReady();
            })
         
        };

        $scope.fillCards = function () {
            $scope.currCards = $scope.appData.BankAccounts[$scope.selectedBankAccountIndex].creditProductsCards;
        };
        $scope.accountNext = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').next();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });
        }

        $scope.accountPrev = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').previous();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

        }

        $scope.accountChanged = function (index, cardIndex) {
            console.log("[Debitpread]-accountChanged", index, cardIndex);
            $scope.appData.selectedBankAccountIndex = index;
            $scope.selectedBankAccountIndex = index;
            $scope.selectedBankAccount = $scope.accountsToDisplay[index];
            console.log("$scope.selectedBankAccountIndex", $scope.selectedBankAccountIndex);
            console.log("accountsToDisplay[index]", $scope.accountsToDisplay[index])
            console.log(" $scope.selectedBankAccount", $scope.selectedBankAccount);
    
   
            if ($scope.selectedBankAccount.allCreditProductsInd) {
                if (cardIndex) {
                    console.log("if..")
                    $scope.cardChanged(cardIndex);
                } else {
                    console.log("else..")
                    $scope.cardChanged($scope.selectedBankAccount.creditProductsCards[0].Id);
                }
            }
            $timeout(function () {
                $scope.updateAccountSlider(index);
                $scope.fillCards();
            })
           // $scope.selectedBankAccountIndex = index;
            console.log("$scope.selectedBankAccountIndex", $scope.selectedBankAccountIndex);
        };

        $scope.cardChanged = function (index) {
            console.log("[Debitpread]-cardChanged", index);
            if ($scope.selectedBankAccount.allCreditProductsInd) {
                $scope.selectedCard = $scope.selectedBankAccount.creditProductsCards[index];
                $scope.selectedCard.shownSteps = $scope.steps;
                $scope.noCardError = true;
                $scope.uniqueId = uniqueIDChosen;
                var obj = {};
                obj.uniqueIDChosen = uniqueIDChosen;
            } else {
                $scope.selectedCard = {};
                $scope.selectedCard.shownSteps = $scope.steps;
                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
            }
        }


        $scope.cardChanged = function (uniqueIDChosen) {
            $scope.uniqueId = uniqueIDChosen;
            //var obj = {};
            //obj.uniqueIDChosen = uniqueIDChosen;
            //$scope.selectedCard = $scope.selectedBankAccount.creditProductsCards[$scope.shownCardIndex];
            if ($scope.selectedBankAccount.allCreditProductsInd) {
                for (var j = 0; j < $scope.selectedBankAccount.creditProductsCards.length; j++) {
                    var uId = $scope.selectedBankAccount.creditProductsCards[j].Id;
                    if (uniqueIDChosen == uId) {
                        $scope.selectedCard = $scope.selectedBankAccount.creditProductsCards[j];
                    }
                }
                if (!$scope.selectedCard || $scope.selectedCard === undefined || typeof ($scope.selectedCard) !== "object") {
                    $scope.selectedCard = {};
                }

                $scope.selectedCard.shownSteps = $scope.steps;
                $scope.noCardError = true;
            }
            else {
                $scope.selectedCard = {};
                $scope.selectedCard.shownSteps = $scope.steps;
                $scope.appData.showSpinner = false;
                lobbyUiService.loader.hide();
            }
        };

        $scope.updateAccountSlider = function (index) {
            console.log("<<<<<<<<<<<<<<UPDATE ACCOUNT SLIDER >>>>>>>>>>>>>>>>>")
            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').update();
            }, 200).then(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').slide(index);
            });

            $scope.$on("$destroy", function (event) {
                $timeout.cancel(_promise);
            });

            return _promise;
        }
        // #endregion

        $scope.goToStage1 = function () {
            $scope.stage = 1;
            $('body').removeClass('finish');
            $scope.currentStage = 1;
            commService.showBackButton(false);
            $scope.members.showTerms = false;
            $scope.selectedCard.shownSteps = $scope.steps;
            $scope.title = "פריסת חיוב";
            $scope.appData.backOverrideFN = null;
            $scope.getActivePage(0);
            $ionicScrollDelegate.$getByHandle('debitSpreadScroll').scrollTop();
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })
          
        }


        $scope.goToStage2 = function (data) {
            $scope.members.initStage2Data = data;
            $scope.members.initStage3Data = null;
            $('body').removeClass('finish');
            $scope.stage = 2;
            $scope.currentStage = 2;
            commService.showBackButton(true);
            commService.sendHeight(800);
            $scope.appData.backOverrideFN = $scope.goToStage1;
            $scope.getActivePage(1);
            function handleDebitSpreadSubmit2Directive(response) {
                $scope.$broadcast("initStage2", { data: response });
                $scope.$broadcast("initStage3", { data: null });
            }
            handleDebitSpreadSubmit2Directive(data);
            $ionicScrollDelegate.$getByHandle('debitSpreadScroll').scrollTop();
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })
        };

        $scope.goToStage3 = function (data) {
            $scope.members.initStage3Data = data;
            $('body').removeClass('finish');
            $scope.stage = 3;
            $scope.currentStage = 3;
            commService.showBackButton(true);
            commService.sendHeight(850);
            $scope.appData.backOverrideFN = $scope.goToStage2;
            $scope.getActivePage(2);
            function handleDebitSpreadSubmit3Directive(response) {
                $scope.$broadcast("initStage3", { data: response });
            }
            handleDebitSpreadSubmit3Directive(data);
            $ionicScrollDelegate.$getByHandle('debitSpreadScroll').scrollTop();
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })
        };

        $scope.goToStage4 = function (data) {
            $scope.stage = 4;
            commService.showBackButton(false);
            $('body').addClass('finish');
            parent.postMessage({ call: "dwProcessEnd" }, '*');
            $scope.currentStage = 4;
            commService.sendHeight(600);
            $scope.getActivePage(3);
            $scope.appData.backOverrideFN = $scope.goToLobby;

            function handleDebitSpreadSubmitDirective(response) {
                $scope.$broadcast("initStage4", { data: response });
            }

            handleDebitSpreadSubmitDirective(data);

            $ionicScrollDelegate.$getByHandle('debitSpreadScroll').scrollTop();
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })
        };

        $scope.backToHomePage = function () {
            commService.backToHomePage();
        };


        $scope.goBack = function () {
            console.log("goBack");
            $scope.goBackToStage($scope.currentStage - 1);
            $('body').removeClass('finish');
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })
        }

        var goToStage = function (stage) {
            console.log("gotoStage", stage);
            $scope.stage = stage;
            $scope.currentStage = stage;
            $timeout(function () {
                window.scrollTo(0, 0);
                commService.parentGoTop();
            })
        }

        $scope.goToLobby = function () {
            commService.backToHomePage();
            // lobbyUiService.go('dw.lobby');
        };

        $scope.$watch("stage", function (stageNew, stageOld) {

            if ((stageNew !== stageOld) && $scope.members.isClearSpreadRequest) {
                connection.debitSpreadClearSpreadRequest($scope.selectedCard.Id);

                $scope.members.isClearSpreadRequest = false;
                console.log("card " + $scope.selectedCard.Id + "is cleared");
            }
        });

        $scope.$on("$destroy", function () {
            //$scope.appData.backOverrideFN = null;
            $scope.appData.inProcess = false;
            window.sessionStorage.removeItem($scope.members.DEBIT_SPREAD_AMOUNT_KEY);

            if ($scope.members.isClearSpreadRequest) {
                connection.debitSpreadClearSpreadRequest($scope.selectedCard.Id);

                $scope.members.isClearSpreadRequest = false;
                console.log("card " + $scope.selectedCard.Id + "is cleared");
            }

            lobbyUiService.loader.hide();
        });

        $scope.goBackToStage = function () {
            console.log("goBackToStage");
            if ($scope.members.showTerms) {
                $scope.title = 'פריסת חיוב';
                $scope.members.showTerms = false;
                $scope.members.isReturnFromTerms = true;
                $scope.stage = 2;
                //$scope.goToStage2(null);
                
                $timeout(function () {
                    $scope.appData.backOverrideFN = $scope.goToStage1;
                }, 100);
            }

            return;
        }

        $scope.goToInfo = function () {
            $scope.title = 'תקנון התכנית';
            $scope.members.showTerms = true;
            $scope.members.isReturnFromTerms = false;
            $scope.appData.backOverrideFN = $scope.goBackToStage;
        };

        $scope.showPopup = function (text) {
            lobbyUiService.popup.alert(text);
        }
        $scope.showMoreInfo = function () {
            var popup = {};
            popup.template = 'app/account/templates/debit-spread/popup/moreInfo.html'
            popup.btns = [];
            popup.btns.push(
                {
                    text: "סגור",
                    type: 'button-positive',
                    onTap: function () {



                    }
                });
            lobbyUiService.popup.message(popup.template, null, null, null, null, null, popup.btns, true);
        }
        $scope.init();

    };
})(window, window.anjular);
﻿(function (window, angular) {
    "use strict";
    angular.module("Cal4U").directive("howThisWork", howThisWork);

    howThisWork.$inject = ['lobbyUiService', 'appData', 'connection', '$state','$stateParams'];

    function howThisWork(lobbyUiService, appData, connection, $state, stateParams) {
        return {
            restrict: "E",
            replace: true,
            scope: true,            
            templateUrl: "app/account/templates/debit-spread/howThisWork.html",
            link: function (scope) {
                var STORAGE_IS_AGREE_KEY = scope.$parent.members.DEBIT_SPREAD_HELPPAGE_IND;
                scope.appData = appData;
                scope.appData.isLoggedIn = connection.isLoggedIn();
                
                scope.form = {};
                scope.form.isVisible = false;
                scope.form.isAgree = window.localStorage.getItem(STORAGE_IS_AGREE_KEY) !== null
                    ? Boolean(window.localStorage.getItem(STORAGE_IS_AGREE_KEY))
                    : false;

                // remove cached value
                //window.localStorage.removeItem(STORAGE_IS_AGREE_KEY);

                if (scope.form.isAgree || stateParams.step) {
                    if (!scope.appData.isLoggedIn) {
                       lobbyUiService.go('dw.login', { nextPage: 'dw.debit-spread' });
                       
                    } else {
                        scope.$parent.goToStage1();
                    }                    

                    return;
                }

                //scope.$parent.title = "פריסת החיוב או חלקו";
                scope.form.isVisible = true;
                scope.$parent.currentStage = 0;
                scope.$parent.members.showTerms = true;

                scope.validateForm = function () {
                    if (scope.form.isAgree) {
                        window.localStorage.setItem(STORAGE_IS_AGREE_KEY, scope.form.isAgree);
                    }

                    if (!scope.appData.isLoggedIn) {
                        lobbyUiService.go('dw.login', { nextPage: 'dw.debit-spread', query: '{"step": "1"}'});
                      
                        
                        return;
                    }

                    scope.form.isVisible = false;
                    scope.$parent.goToStage1();
                };
            }
        }
    };
})(window, window.angular);
﻿(function (window, angular) {
    "use strict";

    angular.module("Cal4U").directive("debitSpreadSum", debitSpreadSum);

    debitSpreadSum.$inject = ['$stateParams', '$timeout', '$ionicSlideBoxDelegate', '$dialogService', 'errorService', 'connection', 'appData', 'lobbyUiService'];

    function debitSpreadSum($stateParams, $timeout, $ionicSlideBoxDelegate, $dialogService, errorService, connection, appData, lobbyUiService) {
        return {
            restrict: "E",
            replace: true,
            scope: true,
            templateUrl: "app/account/templates/debit-spread/debitSpreadSum.html",
            link: function (scope) {
                scope.form = {};
                scope.appData = appData;
                var lockGetCardEligiblityStatus;

                if (!scope.appData.isLoggedIn) {
                    return;
                }

                var PREV_DEBIT_AMOUNT_TYPE = 63;
                var NEXT_DEBIT_AMOUNT_TYPE = 61;
                var DEBIT_SPREAD_AMOUNT_KEY = scope.$parent.DEBIT_SPREAD_AMOUNT_KEY;
                                
                //cancelCallback
                function loadData(selectedCardId, isCallGetCardEligiblityStatus) {
                    if (!!lockGetCardEligiblityStatus) return;

                    var selectedCardId = !selectedCardId ? scope.$parent.selectedCard.Id : selectedCardId;
                    scope.form.errorMessage = "";
                    scope.form.stage = scope.$parent.currentStage;

                    if (!selectedCardId) {                        
                        scope.noCardError = true;
                        scope.form.errorMessage = "לא ניתן לבצע פריסת חיוב בחשבון זה. לבירור יש לפנות ל<a class='error-message-link' href='#/digital/service'>שירות לקוחות</a>.";
                        return;
                    }
                    
                    if (isCallGetCardEligiblityStatus) {
                        getCardEligiblityStatus(selectedCardId);
                    }
                    else {
                        var form = !!window.sessionStorage.getItem(DEBIT_SPREAD_AMOUNT_KEY) ? window.sessionStorage.getItem(DEBIT_SPREAD_AMOUNT_KEY) : scope.form;                        
                        angular.copy(JSON.parse(form), scope.form);
                        scope.form.stage = scope.$parent.currentStage;
                        scope.form.requestedAmount = parseInt(scope.form.requestedAmount);
                    }                    
                }

             
                function getCardEligiblityStatus(selectedCardId) {
                    scope.isShowMainContent = false;
                    scope.appData.showSpinner = true;
                    lobbyUiService.loader.show();
                    lockGetCardEligiblityStatus = true;

                    connection.debitSpreadGetCardEligiblityStatus(selectedCardId).then(function (data) {

                        if (data.Response.Status.Succeeded === true) {
                            scope.form.errorMessage = "";

                            mapResponseData(data);
                        } else {
                            scope.$parent.showPopup("לא ניתן להשלים כרגע את הפעולה. אנא נסה שנית במועד מאוחר יותר.");
                        }

                        scope.isShowMainContent = true;
                        scope.appData.showSpinner = false;
                        lobbyUiService.loader.hide();
                        lockGetCardEligiblityStatus = false;
                        //console.log("token :" + scope.appData.isLoggedIn)
                        //console.log('selectedCardId : ' + JSON.stringify(selectedCardId));
                        //console.log('debitSpreadGetCardEligiblityStatus : ' + JSON.stringify(data));
                    }, function (errorResult) {
                        getCardEligiblityStatusShowErrorMessage(errorResult[0].response.Response.Status, errorResult, errorResult[0].response.Response.DialogBox.Title);
                        scope.appData.showSpinner = false;
                        lobbyUiService.loader.hide();
                        lockGetCardEligiblityStatus = false;
                        //console.log(errorResult[0].response.Response.Status.Message);
                        //console.log("SeverityCode:" + errorResult[0].response.Response.Status.SeverityCode + " " + "SeverityNumber:" + errorResult[0].response.Response.Status.SeverityNumber);
                    });
                }

                function mapResponseData(data) {
                    scope.form.isPrev = !!data.IsPrev;
                    scope.form.isNext = !!data.IsNext;

                    if (data.IsNext) {
                        scope.form.nextDebitDate = data.NextDebitDate.replace(/-/g, "/");
                        scope.form.nextDebitAmount = data.NextDebitAmount.MajorUnits;
                        scope.form.nextDebitMaxSpreadAmount = data.NextDebitMaxSpreadAmount.MajorUnits;
                        scope.form.debitSpreadMaxAmount = data.NextDebitMaxSpreadAmount.MajorUnits;
                        scope.form.checkedDebit = "nextDebitAmount";
                    }

                    if (data.IsPrev) {
                        scope.form.prevDebitDate = data.PrevDebitDate.replace(/-/g, "/");
                        scope.form.prevDebitAmount = data.PrevDebitAmount.MajorUnits;
                        scope.form.prevDebitMaxSpreadAmount = data.PrevDebitMaxSpreadAmount.MajorUnits;
                        scope.form.debitSpreadMaxAmount = data.PrevDebitMaxSpreadAmount.MajorUnits;
                        scope.form.checkedDebit = "prevDebitAmount";
                    }

                    scope.form.nextDebitAmountB = data.NextDebitAmountB;
                    scope.form.requestedAmount = 250;
                    scope.form.minSpreadAmount = data.MinSpreadAmount.MajorUnits;
                    scope.form.debitSpreadAmountRangeInterval = data.DebitSpreadAmountRangeInterval;
                    scope.form.spreadTimingComment = data.SpreadTimingComment;
                    scope.form.debitSpreadAmountMultiple = data.DebitSpreadAmountMultiple;
                }

                function getCardEligiblityStatusShowErrorMessage(errorStatus, errorResponse, title) {
                    var genericErrorMessage = "לא ניתן להשלים כרגע את הפעולה. אנא נסה שנית במועד מאוחר יותר.";

                    if (errorStatus.SeverityCode === "W") {
                        if (errorStatus.SeverityNumber === "001" ||
                            errorStatus.SeverityNumber === "002" ||
                            errorStatus.SeverityNumber === "011" ||
                            errorStatus.SeverityNumber === "012") {
                            //$dialogService.showGenericPopup({ scope: scope, text: genericErrorMessage, actionText: 'נסה שנית', cancelText: 'סגור', cssClass: "debit-spread-popup", actionCallback: loadDataCallBack, cancelCallback: scope.goToLobby });
                            errorService.handleError(errorResponse, loadDataCallBack);
                        }
                        else if (errorStatus.SeverityNumber === "003") {
                            var errorMessage = "עליך לאשר קבלת מידע בערוץ אינטרנט";
                            //$dialogService.showGenericPopup({ scope: scope, text: errorMessage, actionText: 'לעדכון לחץ כאן', cancelText: 'סגור', cssClass: "debit-spread-popup", actionCallback: loadDataCallBack, cancelCallback: scope.goToLobby });
                            errorService.handleError(errorResponse, loadDataCallBack);
                        }
                        else {
                            scope.form.title = title;
                            scope.form.errorMessage = errorStatus.Message;
                            errorService.handleError(errorResponse, loadDataCallBack);
                        }
                    } else if (errorStatus.SeverityCode === "E" && errorStatus.SeverityNumber === "001") {
                        
                        //$dialogService.showGenericPopup({ scope: scope, text: genericErrorMessage, actionText: 'נסה שנית', cancelText: 'סגור', cssClass: "debit-spread-popup", actionCallback: loadDataCallBack, cancelCallback: scope.goToLobby });
                        errorService.handleError(errorResponse, loadDataCallBack);
                        } else {
                        if (errorStatus && errorStatus.Message) {
                            scope.form.errorMessage = errorStatus.Message;
                        } else {
                            errorService.handleError(errorResponse, loadDataCallBack);    
                        }
                         
                        
                    }
           
                }

                function getDebitType(){
                    return (scope.form.checkedDebit === "prevDebitAmount") ? PREV_DEBIT_AMOUNT_TYPE : NEXT_DEBIT_AMOUNT_TYPE;
                }

                scope.checkAmountMultiple = function () {
                    if (scope.form.requestedAmount % scope.form.debitSpreadAmountMultiple != 0) {
                        
                        angular.element("#amount").addClass("ng-invalid");
                    }
                    else {
                       
                        angular.element("#amount").removeClass("ng-invalid");
                    }
                }

                function goToStage2(data) {
                    if (isAmountValid()) { return; }
                    
                    scope.form.stage = 2;
                    window.sessionStorage.setItem(DEBIT_SPREAD_AMOUNT_KEY, JSON.stringify(scope.form));
                    scope.$parent.goToStage2(data);                                        
                }

                var loadDataCallBack = function () {
                    loadData(null, true);
                };

                scope.setDebitData = function (maxSpreadAmount) {
                    scope.form.requestedAmount = scope.form.minSpreadAmount;
                    scope.form.debitSpreadMaxAmount = maxSpreadAmount;
                }
                scope.operation = function () {
                    console.log('vm.operation');
                };
                                
                scope.spreadPaymentRange = function () {
                    if (isAmountValid()) return false;
                    
                    var request = {
                        "cardId": scope.$parent.selectedCard.Id,
                        "requestedAmount": scope.form.requestedAmount.toString(),
                        "debitType": getDebitType().toString()
                    };

                    scope.isShowMainContent = false;
                    scope.appData.showSpinner = true;
                    lobbyUiService.loader.show();

                    connection.debitSpreadGetSpreadPaymentsRange(request).then(function (data) {
                        scope.appData.showSpinner = false;
                        
                        if (data.Response.Status.Succeeded === true) {
                            data.isNext = scope.form.checkedDebit === "nextDebitAmount" ? true : false;

                            goToStage2(data);
                        } else {
                            scope.$parent.showPopup("לא ניתן להשלים כרגע את הפעולה. אנא נסה שנית במועד מאוחר יותר.");
                            scope.isShowMainContent = true;
                        }                        
                    }, function (errorResult) {
                        scope.isShowMainContent = true;
                        scope.appData.showSpinner = false;
                        lobbyUiService.loader.hide();
                        scope.$parent.showPopup(errorResult[0].response.Response.Status.Message);                        
                        //console.log(errorResult[0].response.Response.Status.Message);
                        //console.log("SeverityCode:" + errorResult[0].response.Response.Status.SeverityCode + " " + "SeverityNumber:" + errorResult[0].response.Response.Status.SeverityNumber);
                    });                    
                }                

                var isAmountValid = function () {
                    return angular.element("#amount").hasClass("ng-invalid");
                }

                function init() {
                    scope.form.requestedAmount = 0;
                    
                    scope.$parent.$watch("selectedCard", function (selectedCardNew, selectedCardOld) {
                        if (selectedCardNew.Id !== selectedCardOld.Id) {
                            loadData(selectedCardNew.Id, true);
                        }

                        //console.log("selectedCard.CardIndex:" + selectedCardNew.id);
                    });

                    scope.$parent.$watch("stage", function (stageNew, stageOld) {                        
                        
                        if (stageNew !== stageOld && stageNew === 1) {
                            scope.isShowMainContent = true;

                            loadData(null, false);
                        } else if (stageNew === 1) {
                            scope.isShowMainContent = true;

                            loadData(null, true);
                        }
                    });

                    scope.$parent.$watch("selectedBankAccountIndex", function (bankAccountIndexNew, bankAccountIndexOld) {
                        if (bankAccountIndexNew !== bankAccountIndexOld) {
                            scope.isShowMainContent = true;

                            loadData(null, true);
                        }
                    });
                    
                    scope.goToMyAccount = function () {
                        lobbyUiService.go('dw.account-home');
                    }
                }

                init(); 
               
            }
        };
    };
})(window, window.angular);
﻿(function (window,angular) {
    "use strict";

    angular.module("Cal4U").directive("debitSpreadSubmitData", debitSpreadSubmitData);

    debitSpreadSubmitData.$inject = ['$dialogService', 'lobbyUiService', 'connection', 'appData'];

    function debitSpreadSubmitData($dialogService, lobbyUiService, connection, appData) {
        return {
            restrict: "E",
            replace: true,
            templateUrl: "app/account/templates/debit-spread/debitSpreadSubmitData.html",
            link: function (scope) {
                scope.form = {};
                scope.appData = appData;
                scope.form.stage = scope.$parent.stage;
                var initData = null;
                var isApproveFired = false;
                function loadData(data) {
                    if (!data) return;

                    initData = data;
                    scope.form.payments = [];
                    scope.form.stage = scope.$parent.stage;
                    scope.form.cardLast4Digits = data.CardLast4Digits;
                    scope.form.requestedAmount = data.RequestedAmount.MajorUnits
                    scope.form.checkedDebitMethod = data.isNext ? "קרוב" : "אחרון";

                    for (var i = data.MinNumOfPayments, length = data.MaxNumOfPayments ; i <= length; i++) {
                        scope.form.payments.push(i);
                    }

                    scope.form.selectedPayment = 3; //!scope.$parent.members.initStage2Data.selectedPayment ? (data.MaxNumOfPayments - 1) : scope.$parent.members.initStage2Data.selectedPayment;
                    lobbyUiService.loader.hide();
                    scope.appData.showSpinner = false;
                }

                scope.debitSpreadSimulateSpreadRequest = function (maxNumOfPayments) {
                    var maxNumOfPayments = !!maxNumOfPayments ? maxNumOfPayments : scope.form.selectedPayment;

                    var request = {
                        "cardId": scope.$parent.selectedCard.Id,
                        "numberOfPayments": maxNumOfPayments
                    };                    
                    
                    lobbyUiService.loader.show();
                    scope.appData.showSpinner = true;

                    connection.debitSpreadSimulateSpreadRequest(request).then(function (data) {
                        lobbyUiService.loader.hide();
                        scope.appData.showSpinner = false;
                        if (data.Response.Status.Succeeded) {
                            scope.form.monthlyPaymentAmount = data.MonthlyPaymentAmount.MajorUnits;
                            scope.form.annualNominalInterest = data.AnnualNominalInterest;
                            scope.form.annualEffectiveInterest = data.AnnualEffectiveInterest;

                            //scope.form.ReturnSum = data.Comments[0];
                            //scope.form.TheInterestRate = data.Comments[1];
                            scope.form.TheAnnualNominalInterestRate = data.Comments[2];
                            scope.form.TheAnnualEffectiveNominalInterestRate = data.Comments[3];

                            scope.form.comments = data.Comments.slice(4, data.Comments.length);
                            scope.form.approvalDeploymentLink = data.CommentsEntity.ApprovalDeploymentLink;
                            scope.form.approvalDeploymentText = data.CommentsEntity.ApprovalDeploymentText;
                            //Deleted With Anna S. - #103814
                            //scope.$parent.members.isClearSpreadRequest = true;
                            scope.$parent.goToStage3(data);
                            
                        }

                        //console.log("debitSpreadSimulateSpreadRequest: " + JSON.stringify(data));
                    }, function (errorResult) {
                        //getCardEligiblityStatusShowErrorMessage(errorResult[0].response.Response.Status);
                        var genericErrorMessage = 'לא ניתן להשלים כרגע את הפעולה. אנא נסה שנית במועד מאוחר יותר.';

                        scope.appData.showSpinner = false;
                        lobbyUiService.loader.hide();

                        var loadDebitSpreadSimulateSpreadRequestCallBack = function () {
                            scope.debitSpreadSimulateSpreadRequest(maxNumOfPayments);
                        }

                        $dialogService.showGenericPopup({ scope: scope, text: genericErrorMessage, actionText: 'נסה שנית', cancelText: 'סגור', cssClass: "debit-spread-popup", actionCallback: loadDebitSpreadSimulateSpreadRequestCallBack, cancelCallback: scope.goToLobby });
                    });
                }

                scope.goToStage3 = function () {
                    lobbyUiService.loader.show();
                    scope.appData.showSpinner = true;
                    scope.debitSpreadSimulateSpreadRequest(scope.form.selectedPayment);
                }

                scope.goToInfo = function () {
                    scope.$parent.members.initStage2Data.selectedPayment = scope.form.selectedPayment;
                    scope.$parent.goToInfo();
                };

                scope.$on("initStage2", function (event, response) {

                    loadData(response.data);
                });
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    "use strict";

    angular.module("Cal4U").directive("debitSpreadSubmitDisclosure", debitSpreadSubmitDisclosure);

    debitSpreadSubmitDisclosure.$inject = ['$dialogService', 'lobbyUiService', 'connection', 'appData','commService'];

    function debitSpreadSubmitDisclosure($dialogService, lobbyUiService, connection, appData,commService) {
        return {
            restrict: "E",
            replace: true,
            templateUrl: "app/account/templates/debit-spread/debitSpreadSubmitDisclosure.html",
            link: function (scope) {
                scope.form = {};
                scope.appData = appData;
                scope.form.stage = scope.$parent.stage;
                var initData = null;
                var isApproveFired = false;
                function loadData(data) {
                    if (!data) {
                        scope.form.stage = -1;
                        return;
                    } 

                    initData = data;
                    scope.form.stage = scope.$parent.stage;
                    scope.form.monthlyPaymentAmount = data.MonthlyPaymentAmount.MajorUnits;
                    scope.form.annualNominalInterest = data.AnnualNominalInterest;
                    scope.form.annualAdaptedInterest = data.AnnualAdaptedInterest;
                    scope.form.actualInterestRate = data.ActualInterestRate;
                    scope.form.arrearInterest = data.ArrearInterest;
                    scope.form.showComments = false;
                    scope.form.ReturnSum = data.Comments[0];
                    scope.form.TheInterestRate = data.Comments[1];
                    scope.form.TheAnnualNominalInterestRate = data.Comments[2];
                    scope.form.TheAnnualEffectiveNominalInterestRate = data.Comments[3];

                    scope.form.comments = data.Comments;
                    scope.form.approvalDeploymentLink = data.CommentsEntity.ApprovalDeploymentLink;
                    scope.form.approvalDeploymentText = data.CommentsEntity.ApprovalDeploymentText;
                    scope.form.storedPaymentSpreadSimulationKey = data.StoredPaymentSpreadSimulationKey;
                    lobbyUiService.loader.hide();
                    scope.form.coronaComment = data.CoronaComment;
                    scope.appData.showSpinner = false;
                }

                scope.goToStage4 = function () {
                        isApproveFired = true;
                        //scope.form.stage = 3;
                        var cardId = scope.$parent.selectedCard.Id;
                        lobbyUiService.loader.show();
                        scope.appData.showSpinner = true;
                        connection.debitSpreadApproveSpreadRequest(cardId).then(function (data) {
                            lobbyUiService.loader.hide();
                            scope.appData.showSpinner = false;
                            if (data.Response.Status.Succeeded) {
                                scope.$parent.members.isClearSpreadRequest = false;

                                scope.form.isVisible = false;
                                scope.$parent.goToStage4(data);
                            } else {
                                scope.$parent.showPopup("לא ניתן להשלים כרגע את הפעולה. אנא נסה שנית במועד מאוחר יותר.");
                            }
                        }, function () {
                            lobbyUiService.loader.hide();
                            scope.appData.showSpinner = false;
                            scope.$parent.showPopup("לא ניתן להשלים כרגע את הפעולה. אנא נסה שנית במועד מאוחר יותר.");
                        });

                    scope.goToInfo = function () {
                        scope.$parent.members.initStage2Data.selectedPayment = scope.form.selectedPayment;
                        scope.$parent.goToInfo();
                    };
                    
                }

                scope.$on("initStage3", function (event, response) {

                    loadData(response.data);
                });
                scope.toggleShowComments = function () {
                    console.log("showCommets");
                    scope.form.showComments = !scope.form.showComments;
                    if (scope.form.showComments) {
                        commService.sendHeight(1350);
                        event.srcElement.innerText = "פחות פרטים -";
                    }
                    else {
                        commService.sendHeight(850);
                        event.srcElement.innerText = "עוד פרטים +";
                    }
                }
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    "use strict";

   

    angular.module("Cal4U").directive("debitSpreadSubmitRequest", debitSpreadSubmitRequest);

    debitSpreadSubmitRequest.$inject = ['lobbyUiService', 'connection'];
    var s = null;
    function debitSpreadSubmitRequest(lobbyUiService, connection) {
        return {
            restrict: "E",
            replace: true,
            templateUrl: "app/account/templates/debit-spread/debitSpreadSubmitRequest.html",
            link: function (scope) {
                scope.form = {};
       
                //scope.form.isVisible = false;
                scope.form.stage = scope.$parent.stage;

                function loadData(data) {                    
                    scope.form.stage = scope.$parent.stage;

                    scope.form.approvalId = data.ApprovalId;
                    scope.form.cardLast4Digits = data.CardLast4Digits;
                    scope.form.requestedAmount = data.RequestedAmount.MajorUnits;
                    scope.form.monthlyPaymentAmount = data.MonthlyPaymentAmount.MajorUnits;
                    scope.form.numberOfPayments = data.NumberOfPayments;
                    scope.form.comments = data.Comments;
                }
                
                scope.$on("initStage4", function (event, response) {
                    
                    loadData(response.data);
                });
            }
        }
    }
})(window, window.angular);
﻿(function (window, anjular) {
    'use strict';

    angular.module('Cal4U').controller('margaritaController', margaritaController);

    margaritaController.$inject = ['$scope', '$timeout', '$ionicSlideBoxDelegate', 'lobbyUiService', 'appData', 'connection', '$location','commService'];
    
    function margaritaController($scope, $timeout, $ionicScrollDelegate, lobbyUiService, appData, connection, $location,commService) {
        $scope.pageTitle = "פרטי העסקה שנחלק";
        $scope.appData = appData;
        $scope.appData.isLoggedIn = connection.isLoggedIn();

        $scope.getActivePage = function (page) {
            if ($scope.steps == null || $scope.steps == undefined) {
                $scope.steps = [{ caption: 'תשלומים', active: false }, { caption: 'סיכום', active: false }, { caption: 'אישור', active: false }];;
            }
            else {
                for (var i = 0; i < $scope.steps.length; i++) {
                    $scope.steps[i].active = false;
                }
            }
            $scope.steps[page].active = true;
        }

        $scope.init = function () {
            
            var confirmationId = $location.path().substring($location.path().lastIndexOf('/') + 1);
            if (confirmationId != "") {
                localStorage.setItem('confirmationId', confirmationId);
            }

            var srcParam = $location.search().src;
            if (srcParam) {
                localStorage.setItem('requestSrc', srcParam);
            }

            if (!$scope.appData.isLoggedIn) {
                lobbyUiService.go('dw.login', { nextPage: 'dw.margarita', type: 2 }, { location: 'replace' });
                return;
            }

            $scope.stage = 0;
            $scope.currentStage = 0;

            $scope.goToLobby = function () {
                ga('send', 'event', { eventCategory: 'אתר הפעולות', eventAction: 'פריסת עסקה', eventLabel: 'יציאה מהתהליך' });
                commService.backToHomePage();
            };//2

            $scope.appData.backOverrideFN = function () {
                if ($scope.currentStage == 1 || $scope.currentStage == 3) {
                    $scope.goToLobby();
                }
                else {
                    var goToStage = $scope.currentStage - 1;
                    $scope.stage = goToStage;
                    $scope.currentStage = goToStage;
                    $scope.getActivePage(goToStage - 1);
                }
            }

            //$timeout(function () {
            //    $ionicScrollDelegate.$getByHandle('expressScroll').scrollTop();
            //}, 0);

            $scope.goToStage1();
        }

        $scope.goToStage1 = function () {
            $scope.stage = 1;
            $scope.currentStage = 1;
            $scope.getActivePage(0);
        }

        $scope.goToStage2 = function (data) {
            $scope.stage = 2;
            $scope.currentStage = 2;
            $scope.getActivePage(1);
            $scope.cardDetails = data.cardDetails;
            $scope.details = {};
            $scope.details.numOfPaymentsSelection = data.numOfPaymentsSelection;
            $scope.details.transAmountInShekels = data.transAmountInShekels;
            $scope.details.MaxNumOfPayments = data.maxNumOfPayments;
            $scope.details.MinNumOfPayments = data.minNumOfPayments;
        }

        $scope.goToStage3 = function (simulation) {
            console.log("gotostage3", simulation);
            $scope.stage = 3;
            $scope.currentStage = 3;
            $scope.getActivePage(2);
            $scope.simulation = simulation;

        };

        $scope.formatNumber = function (number) {
            var numStr = number.toString();
            var splitted = numStr.split('.');

            var padded;
            if (splitted.length == 1) {
                padded = numStr + ".00"
            }
            else if (splitted.length == 2 && splitted[1].length == 1) {
                padded = numStr + '0';
            }
            else {
                padded = numStr;
            }

            var formatted = padded.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return formatted;
        }


        $scope.init();
    };
})(window, window.anjular);
﻿(function (window, angular) {
    "use strict";

    angular.module("Cal4U").directive("margaritaPayments", margaritaPayments);

    margaritaPayments.$inject = ['errorService', 'connection', 'appData', 'lobbyUiService', '$q', '$location', 'googleAnalyticsService'];

    function margaritaPayments(errorService, connection, appData, lobbyUiService, $q, $location, googleAnalyticsService) {
        return {
            restrict: "E",
            replace: true,
            scope: true,
            templateUrl: "app/account/templates/margaritaPayments.html",
            link: function (scope) {
                scope.appData = appData;
                scope.transactionTypes = {
                    Regular: 5,
                    CashWidrawal: 7
                };

                function init() {
                    lobbyUiService.loader.show();
                    scope.appData.showSpinner = true;
                    var confirmationId = localStorage.getItem('confirmationId');
                    getTransactionDetails(confirmationId).then(function () {
                        scope.paymentsOptions = [];
                        for (var i = scope.paymentsDetails.minPayment; i <= scope.paymentsDetails.maxPayment; i++) {
                            scope.paymentsOptions.push(i);
                            //scope.numOfPayments = scope.paymentsOptions[scope.paymentsOptions.length - 1] + " תשלומי קרדיט";
                            scope.numOfPayments = scope.paymentsOptions[0] + " תשלומים";
                        }

                        //googleAnalyticsService.trackPage('/vp/margarita/step1/no-of-payments');
                        ga('set', 'page', '/vp/online_actions/credit-payment-spread/');
                        ga('send', 'pageview');

                    }, function () {
                        
                    });
                }

                function getTransactionDetails(ConfirmationId) {
                    // FOR DEV:
                    //scope.paymentsDetails = {
                    //    originalTransAmount: "100",
                    //    currencyDesc: "$",
                    //    currencyCode: "376",
                    //    transAmountInShekels: "350",
                    //    merchantName: "Best Shop",
                    //    transDate: "09/03/2019",
                    //    minPayment: 3,
                    //    maxPayment: 6,
                    //    cardNum: "0000000004490",
                    //    cardNumType: "33",
                    //    transactionType: 5
                    //}
                    //scope.cardDetails = {
                    //    fullName: appData.CustomerInfo.FirstName + " " + appData.CustomerInfo.LastName,
                    //    last4digits: "2143",
                    //    cardType: "ויזה כלשהו",
                    //    cardUID: "1172143511201858"
                    //};
                    //scope.paymentsOptions = [];
                    //for (var i = scope.paymentsDetails.minPayment; i <= scope.paymentsDetails.maxPayment; i++) {
                    //    scope.paymentsOptions.push(i);
                    //    scope.numOfPayments = scope.paymentsOptions[scope.paymentsOptions.length - 1] + " תשלומי קרדיט";
                    //}
                    ///////////////////////////////////////////////////////

                    var req = { ConfirmationId: ConfirmationId };
                    var deferred = $q.defer();
                    connection.getPaymentsDeatails(req).then(function (data) {
                        if (data.Response.Status.Succeeded === true) {
                            scope.paymentsDetails = {
                                originalTransAmount: data.OriginalTransAmount,
                                currencyDesc: data.CurrencyDesc,
                                currencyCode: data.TransCode,
                                transAmountInShekels: data.TransAmountInShekels,
                                merchantName: data.MerchantName,
                                transDate: data.TransDate,
                                minPayment: data.MinPayment,
                                maxPayment: data.MaxPayment,
                                cardNum: data.CardNum,
                                cardNumType: data.CardNumType,
                                transactionType: data.TrnType
                            }
                            var cardUniqueID = "";
                            scope.appData.BankAccounts.forEach(account => account.Cards.forEach(
                                card => cardUniqueID = card.LastFourDigits == data.CardLast4Digits ? card.Id : cardUniqueID));

                            scope.cardDetails = {
                                fullName: appData.CustomerInfo.FirstName + " " + appData.CustomerInfo.LastName,
                                last4digits: data.CardLast4Digits,
                                cardType: data.CardType,
                                cardUID: cardUniqueID
                            };
                            deferred.resolve();
                        }
                        scope.appData.showSpinner = false;
                        lobbyUiService.loader.hide();
                    }, function (error) {
                        //FOR DEV:
                        //scope.appData.showSpinner = false;
                        //lobbyUiService.loader.hide();
                        //var deferred = $q.defer();
                        //deferred.resolve();

                        scope.isError = true;
                        handleGetTransactionDetailsError(error[0].response.Response.Status, error);
                        lobbyUiService.loader.hide();
                        deferred.reject();
                        });
                    return deferred.promise;
                }

                scope.onContinueBtnClick = function () {
                    var data = {};
                    data.numOfPaymentsSelection = Number(scope.numOfPayments.substring(0, 2).trim());
                    data.transAmountInShekels = scope.paymentsDetails.transAmountInShekels;
                    data.cardDetails = scope.cardDetails;
                    data.maxNumOfPayments = scope.paymentsDetails.maxPayment;
                    data.minNumOfPayments = scope.paymentsDetails.minPayment;

                    ga('send', 'event', { eventCategory: 'אתר הפעולות', eventAction: 'פריסת עסקה', eventLabel: 'בחירת כמות תשלומים' });
                    scope.goToStage2(data);
                }

                scope.onPaymentSelect = function (selection) {
                    scope.numOfPayments = selection;
                }

                function handleGetTransactionDetailsError(status, errorResponse) {
                    var severityNum = Number.parseInt(status.SeverityNumber);
                    var severityOptionsMsgsFromDB = [2, 3, 4, 6, 7];

                    if (status.SeverityCode.toLowerCase() == 'w' && severityNum == 5) { // the time of payment spread for this transaction is expired
                        var temp = $location.$$absUrl.substring(0, $location.$$absUrl.indexOf("#!"));
                        errorResponse[0].response.Response.DialogBox.Content = "<div style='font-size: 28px;margin-bottom: 18px;font-weight: 600;height: 32px;padding-top: 11px;'>לא נוכל להמשיך</div><div style='margin-bottom:40px;'>משך הזמן לביצוע הפעולה חלף</div> <a href='" + temp + "#!/digital/account/debitSpread/' style='text-decoration:none;color:#1b5ece;font-weight:600;' onclick='ga('send', 'event', { eventCategory: 'אתר הפעולות', eventAction: 'פריסת עסקה', eventLabel: 'פופ אפ- לפתרונות אשראי נוספים' });angular.element(\".popup-button\").click()'>לפתרונות אשראי נוספים > </a>";
                       
                        //errorResponse[0].response.Response.DialogBox.Content = String.format(errorResponse[0].response.Response.DialogBox.Content, $location.$$absUrl.substring(0, $location.$$absUrl.indexOf("#!")));
                    
                        //googleAnalyticsService.trackPage('/vp/margarita/deal-timed-out');
                        ga('send', 'event', { eventCategory: 'אתר הפעולות', eventAction: 'פריסת עסקה', eventLabel: 'לא ניתן להמשיך' });
                    }

                    else if (status.SeverityCode.toLowerCase() == 'w' && severityNum == 7) { //was already split to payments
                        ga('send', 'event', { eventCategory: 'אתר הפעולות', eventAction: 'פריסת עסקה', eventLabel: 'העסקה חולקה לתשלומים בעבר' });
                        errorResponse[0].response.Response.DialogBox.Content = "<div style='font-size: 28px;margin-bottom: 18px;font-weight: 600;height: 32px;padding-top: 11px;'>כבר חילקת את העסקה לתשלומים</div><div style='margin-bottom:40px;'>לא נוכל לחלק אותה שוב</div>";

                    }
                    else if ((status.SeverityCode.toLowerCase() == 'w' && !severityOptionsMsgsFromDB.includes(severityNum)) || status.SeverityCode.toLowerCase() != 'w') {
                        errorResponse[0].response.Response.Status.SeverityCode = "W";
                        errorResponse[0].response.Response.Status.SeverityNumber = "000";
                        errorResponse[0].response.Response.DialogBox.Content = "משהו השתבש, אבל לא צריך לדאוג - אנחנו מתקנים את התקלה. ממליצים לך לנסות שוב מאוחר יותר";

                        googleAnalyticsService.trackPage('/vp/margarita/technical-error');
                    }

                    errorService.handleError(errorResponse, scope.goToLobby);
                }


                init();

                
            }
        }
    }
})(window, window.angular);

﻿(function (window, angular) {
    "use strict";

    angular.module("Cal4U").directive("margaritaDetails", margaritaDetails);

    margaritaDetails.$inject = ['errorService', 'connection', 'appData', 'lobbyUiService', '$q', 'googleAnalyticsService', '$timeout', '$dialogService'];

    function margaritaDetails(errorService, connection, appData, lobbyUiService, $q, googleAnalyticsService, $timeout, $dialogService) {
        return {
            restrict: "E",
            replace: true,
            scope: true,
            templateUrl: "app/account/templates/margaritaDetails.html",
            link: function (scope) {
                scope.appData = appData;

                function init() {
                    lobbyUiService.loader.show();
                    scope.appData.showSpinner = true;

                    scope.details.showComments = false;
                    var req = {
                        CardId: scope.cardDetails.cardUID,
                        NumberOfPayments: scope.details.numOfPaymentsSelection,
                        MaxNumOfPayments: scope.details.MaxNumOfPayments,
                        MinNumOfPayments: scope.details.MinNumOfPayments,
                        RequestedAmount: scope.details.transAmountInShekels
                    };
                    scope.simulateCreditPaymentSpread(req).then(function (data) {
                        hidePageUntilElementRendered("#fair-credit-component");

                        //googleAnalyticsService.trackPage('/vp/margarita/step2/detail-review');
                        ga('set', 'page', '/vp/online_actions/credit-payment-spread/payment-spread-details/');
                        ga('send', 'pageview');

                    }, function () {

                    });
                }

                scope.simulateCreditPaymentSpread = function (req) {
                    var deferred = $q.defer();
                    connection.SimulateCreditPaymentsRequest(req).then(function (data) {
                        if (data.Response.Status.Succeeded) {
                            scope.simulation = {
                                monthlyPaymentAmount: scope.formatNumber(data.MonthlyPaymentAmount.MajorUnits),
                                annualAdaptedInterest: data.AnnualAdaptedInterest,
                                totalArbitrageIntrestAmount: data.TotalArbitrageIntrestAmount,
                                actualInterestRate: data.ActualInterestRate,
                                numberOfPayments: data.NumberOfPayments,
                                requestedAmount: scope.formatNumber(data.RequestedAmount.MajorUnits),
                                annualNominalInterest: data.AnnualNominalInterest,
                                arrearInterest: data.ArrearInterest,
                                storedPaymentSpreadSimulationKey: data.StoredPaymentSpreadSimulationKey,
                                //comments: data.Comments
                            };
                            deferred.resolve();
                        }
                    }, function (error) {

                        scope.isError = true;
                        handleSimulateCreditPaymentSpreadError(error, req);
                        scope.appData.showSpinner = false;
                        lobbyUiService.loader.hide();
                        deferred.reject();
                    });

                    return deferred.promise;
                }

                function handleSimulateCreditPaymentSpreadError(errorResponse, request) {
                    if (errorResponse[0].response.Response.Status.SeverityCode.toLowerCase() == 'w') {
                        var onTryAgain = function () {
                            scope.simulateCreditPaymentSpread(request);
                        }
                        var genericErrorMessage = "לא ניתן להשלים כרגע את הפעולה. אנא נסה שנית במועד מאוחר יותר.";
                        $dialogService.showGenericPopup({ scope: scope, text: genericErrorMessage, actionText: 'נסה שנית', cancelText: 'סגור', cssClass: "error-popup", actionCallback: onTryAgain, cancelCallback: scope.goToLobby });
                    }
                    else {
                        errorResponse[0].response.Response.Status.SeverityCode = 'E';
                        errorResponse[0].response.Response.Status.SeverityNumber = '001';
                        errorResponse[0].response.Response.DialogBox.Content = "משהו השתבש, אבל לא צריך לדאוג - אנחנו מתקנים את התקלה. ממליצים לך לנסות שוב מאוחר יותר";
                        errorService.handleError(errorResponse, scope.goToLobby);
                    }
                }


                scope.fairCreditAgreedBtnClick = function () {
                    console.log("callback in here");
                    $timeout(function () {
                        scope.goToStage3(scope.simulation);
                    }, 0);
                
                }

                scope.toggleShowComments = function () {
                    scope.details.showComments = !scope.details.showComments;
                    if (scope.details.showComments) {
                        angular.element("#toggle-comments-btn")[0].innerText = "פחות פרטים -";
                    }
                    else {
                        angular.element("#toggle-comments-btn")[0].innerText = "עוד פרטים +";
                    }
                }

                var hidePageUntilElementRendered = function (selector) {
                    var element = angular.element(selector);
                    if (!element.length) {
                        setTimeout(hidePageUntilElementRendered, 1000, selector);
                    }
                    else {
                        scope.appData.showSpinner = false;
                        lobbyUiService.loader.hide();
                    }
                }

                init();
                
            }
        }
    }
})(window, window.angular);

﻿(function (window, angular) {
    "use strict";

    angular.module("Cal4U").directive("margaritaConfirmation", margaritaConfirmation);

    margaritaConfirmation.$inject = ['connection', 'lobbyUiService', '$q', 'googleAnalyticsService', '$location'];

    function margaritaConfirmation(connection, lobbyUiService, $q, googleAnalyticsService, $location) {
        return {
            restrict: "E",
            replace: true,
            scope: true,
            templateUrl: "app/account/templates/margaritaConfirmation.html",
            link: function (scope) {

                scope.appData.showSpinner = true;
                lobbyUiService.loader.show();
                $('body').addClass('finish');
                function UpdateTransactionPayments() {
                    var srcParam = $location.search().src || localStorage.getItem('requestSrc');
                    var request = {
                        ConfirmationId: localStorage.getItem('confirmationId'),
                        NumOfPayments: scope.simulation.numberOfPayments,
                        TransactionAmount: scope.simulation.requestedAmount,
                        NominalInterest: scope.simulation.annualNominalInterest.toString(),
                        RequestSrc: srcParam ? parseInt(srcParam) : 1
                    };
                    var deferred = $q.defer();
                    connection.UpdateTransactionPayments(request).then(function (data) {
                        if (data.Response.Status.Succeeded === true) {
                            //googleAnalyticsService.trackPage('/vp/margarita/step3/process_complete');
                            ga('set', 'page', '/vp/online_actions/credit-payment-spread/approve-spread/');
                            ga('send', 'pageview');

                            deferred.resolve();
                        }
                        else {
                            handleUpdateTransactionPaymentsError(data[0].response.Response.Status);
                            deferred.reject();
                        }
                    }, function (error) {
                        //COMMENT OUT FOR DEV:
                        handleUpdateTransactionPaymentsError(error[0].response.Response.Status);
                        deferred.reject();
                    });
                    return deferred.promise;
                }

                function handleUpdateTransactionPaymentsError(status) {
                    scope.errorMessage = "";
                    if (status.SeverityCode.toLowerCase() == 'w') {
                        scope.errorMessage = "לצערנו, לא נוכל לפרוס לך את העסקה";
                    }
                    else {
                        scope.errorMessage = "לא ניתן להשלים כרגע את הפעולה. ממליצים לך לנסות שוב מאוחר יותר";
                    }
                }

                scope.creditSolutionsAnalytics = function () {
                    //var options = {
                    //    page: 'מרגריטה',
                    //    action: 'מסך תודה',
                    //    eventName: 'לפתרונות אשראי נוספים'
                    //};
                    //googleAnalyticsService.insertEvent(options);
                    ga('send', 'event', { eventCategory: 'אתר הפעולות', eventAction: 'פריסת עסקה', eventLabel : 'לפתרונות אשראי נוספים' });
                }

                UpdateTransactionPayments().then(function () {
                    scope.appData.showSpinner = false;
                    lobbyUiService.loader.hide();
                }, function () {
                    scope.appData.showSpinner = false;
                    lobbyUiService.loader.hide();
                });

            }
        }
    }
}) (window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat', []);
})(window, window.angular);
﻿(function (window, angular) {
	'use strict';
	angular.module('calshtifomat').config(carwashRoute);

	carwashRoute.$inject = ['$stateProvider'];

	function carwashRoute($stateProvider) {
	    $stateProvider
            .state('dw.carwash', {
                url: "/wallet/carwash",
                views: {
                    'contentBody': {
                        templateUrl: "app/carwash/templates/welcome.html",
                        controller: "stWelcomeCtrl"
                    }
                }
            })
            .state('dw.carwash-home', {
                url: "/wallet/carwash/home/:cardId",
                views: {
                    'contentBody': {
                        templateUrl: "app/carwash/templates/home.html",
                        controller: "stHomeCtrl"
                    }
                }
            })
            .state('dw.carwash-subscribe', {
                url: "/wallet/carwash/subscribe/",
                views: {
                    'contentBody': {
                        templateUrl: "app/carwash/templates/subscribe.html",
                        controller: "stSubscribeCtrl"
                    }
                }
            })
            .state('dw.carwash-unsubscribe', {
                url: "/wallet/carwash/unsubscribe/",
                views: {
                    'contentBody': {
                        templateUrl: "app/carwash/templates/unsubscribe.html",
                        controller: "stUnsubscribeCtrl"
                    }
                }
            })
            .state('dw.carwash-exist', {
                url: "/wallet/carwash/exist/",
                views: {
                    'contentBody': {
                        templateUrl: "app/carwash/templates/exist.html",
                        controller: "stExistCtrl"
                    }
                }
            })
            .state('dw.carwash-approve', {
                url: "/wallet/carwash/approve/",
                views: {
                    'contentBody': {
                        templateUrl: "app/carwash/templates/approve.html",
                        controller: "stApproveCtrl"
                    }
                }
            })
            .state('dw.carwash-terms', {
                url: "/wallet/carwash/shtifomatTerms/",
                views: {
                    'contentBody': {
                        templateUrl: "app/carwash/templates/shtifomatTerms.html",
                        controller: "stTerms"
                    }
                }
            });
	}
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .controller('stApproveCtrl', stApproveCtrl);

    stApproveCtrl.$inject = [
        '$scope', 'stMetaDataService', 'stSubscribService', 'errorService', 'stCacheService', 'lobbyUiService', 'stUtilsService', 'appData', 'googleAnalyticsService'
    ];

    function stApproveCtrl($scope, stMetaDataService, stSubscribService, errorService, stCacheService, lobbyUiService, stUtilsService, appData, googleAnalyticsService) {

        $scope.account = appData.BankAccounts;

        $scope.appData = appData;


        $scope.init = function () {

            $scope.memberData = stCacheService.get('subscribeData');

            if (!lobbyUiService.connection.isLoggedIn() || !$scope.memberData) {
                lobbyUiService.go('dw.login', { nextPage: "dw.carwash" });
                return;
            }

            $scope.metaData = stMetaDataService.metaData();

            var obj = stUtilsService.getTextById($scope.metaData.FixTexts, 2);

            $scope.content = {
                title: obj.TextContent,
                ok: 'תיקון',
                cancel: 'אישור'
            };

            $scope.appData.inProcess = true;
        }

        $scope.continue = function () {

            lobbyUiService.loader.show();

            googleAnalyticsService.insertEvent({ page: 'shtifomat', id: 4 });

            var subscribData =
            {
                carNumber: $scope.memberData.BelongMemNum.toString(),
                depDesc: $scope.memberData.DepNum,
                agreement: true,
                cardId: $scope.memberData.CardID
            };

            stSubscribService.clubSubscribe(subscribData).then(function () {
                lobbyUiService.go('dw.carwash-subscribe');

            }, function (error) {
                errorService.handleError(error);
            }).finally(function () {
                lobbyUiService.loader.hide();
            });

            //console.log($scope.subscribData);
        };

        $scope.update = function () {
            googleAnalyticsService.insertEvent({ page: 'shtifomat', id: 3 });

            lobbyUiService.go('dw.carwash-home', { cardId: $scope.memberData.CardID });
        };

        $scope.init();
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
       .controller('stHomeCtrl', stHomeCtrl);

    stHomeCtrl.$inject = [
        '$scope', 'stUtilsService', 'stSubscribService', 'stMetaDataService', 'stBankAccountService', 'errorService', '$timeout', '$ionicSlideBoxDelegate',
        'lobbyUiService', '$ionicPopup', 'stCacheService', 'appData', 'googleAnalyticsService'
    ];

    function stHomeCtrl($scope, stUtilsService, stSubscribService, stMetaDataService, stBankAccountService, errorService, $timeout, $ionicSlideBoxDelegate, lobbyUiService,
        $ionicPopup, stCacheService, appData, googleAnalyticsService) {

        $scope.slideBoxReady = false;

        $scope.appData = appData;

        $scope.init = function () {

            $scope.bankAccounts = stCacheService.get('stBankAccounts');

            if (!lobbyUiService.connection.isLoggedIn() || !$scope.bankAccounts) {
                lobbyUiService.go('dw.login', { nextPage: "dw.carwash" });
                return;
            }

            lobbyUiService.loader.show();

            $scope.metaData = stMetaDataService.metaData();

            $scope.cardSliderTitle = stUtilsService.getTextById($scope.metaData.FixTexts, 7).TextContent;

            $scope.carBoxText = stUtilsService.getTextById($scope.metaData.FixTexts, 8);

            $scope.carHelpInfo = stUtilsService.getTextById($scope.metaData.FixTexts, 13);

            $scope.carHelpInfo.title = 'סוג רכב';

            $scope.currentAccountCards = {};

            $scope.currentAccountCards.slides = [];

            $scope.currentCardIndex = 0;

            $scope.currentAccountIndex = 0;

            $scope.subscribData =
            {
                carNumber: '',
                depDesc: 0,
                agreement: false,
                cardID: 0
            };

            $scope.showSlider = true;

            $scope.checkAgreement = false;

            var memberData = stCacheService.get('subscribeData');

            if (memberData) {

                $scope.subscribData.carNumber = memberData.BelongMemNum.toString();
                $scope.subscribData.depDesc = memberData.DepNum;
                $scope.updateSelectedCard(memberData.CardID);
            }

            var cardIdFromRoute = lobbyUiService.getParams('cardId');

            if (cardIdFromRoute) {
                $scope.updateSelectedCard(cardIdFromRoute);

                stSubscribService.checkSubscribe().then(function (data) {
                    if (data.CardArray && data.CardArray.length > 0) {
                        $scope.subscribData.carNumber = data.CardArray[0].BelongMemNum.toString();
                        $scope.subscribData.depDesc = data.CardArray[0].DepNum;
                    }
                });

            } else if (!memberData) {
                $scope.updateAccountSlider(0);
                $scope.currentAccountCards.slides = $scope.bankAccounts[$scope.currentAccountIndex].Cards;
                $scope.updateCardSlider(0);

            }

            $scope.appData.inProcess = true;

        };

        $scope.updateSelectedCard = function (cardId) {

            $scope.subscribData.CardID = cardId;

            stBankAccountService.getCardById(cardId).then(function (indexes) {
                $scope.currentCardIndex = indexes.cardIndex;

                $scope.currentAccountIndex = indexes.accountIndex;

                $scope.updateAccountSlider(indexes.accountIndex).then(function () {
                    $scope.currentAccountCards.slides = $scope.bankAccounts[indexes.accountIndex].Cards;

                    $scope.updateCardSlider(indexes.cardIndex);
                });
            });
        }

        $scope.dataReady = function () {
            return $scope.metaData && $scope.bankAccounts && $scope.slideBoxReady;
        }

        $scope.showTerms = function () {

            var memData = {
                Last4Digits: $scope.bankAccounts[$scope.currentAccountIndex].Cards[$scope.currentCardIndex].LastFourDigits,
                BelongMemNum: $scope.subscribData.carNumber.toString(),
                DepDesc: $scope.subscribData.depDesc == 1 ? 'פרטי' : $scope.subscribData.depDesc == 2 ? 'מסחרי' : '',
                DepNum: $scope.subscribData.depDesc,
                CardID: $scope.bankAccounts[$scope.currentAccountIndex].Cards[$scope.currentCardIndex].Id
            }

            stCacheService.set('subscribeData', memData);

            lobbyUiService.go('dw.carwash-terms');
        }

        $scope.submitAgreement = function () {

            if ($scope.subscribData.agreement) {

                if ($scope.subscribData.depDesc == 0) {
                    $scope.showPopup("יש להזין סוג רכב");
                    return;
                } else if ($scope.subscribData.carNumber == '') {
                    $scope.showPopup("יש להזין מספר רכב");
                    return;
                } else if ($scope.subscribData.carNumber.length < 7) {
                    $scope.showPopup("יש להזין מספר רכב בן 7-8 ספרות");
                    return;
                }

                var needToUnsubscribe = stCacheService.get('subscribed');

                lobbyUiService.loader.show();

                if (needToUnsubscribe) {

                    googleAnalyticsService.insertEvent({ page: 'shtifomat', id: 2 });

                    stSubscribService.clubUnSubscribe($scope.subscribData.CardID).then(function () {
                        $scope.checkExistSubscribtion();
                    }, function (error) {
                        errorService.handleError(error);
                    });
                } else {
                    $scope.checkExistSubscribtion();
                }

            } else {
                $scope.showPopup("יש לאשר את התקנון וקבלת הודעות SMS");
            }
        }

        $scope.checkExistSubscribtion = function () {
            stSubscribService.checkSubscribeNumMem($scope.subscribData.carNumber.toString(), true).then(function (response) {
                var memData = {
                    Last4Digits: $scope.bankAccounts[$scope.currentAccountIndex].Cards[$scope.currentCardIndex].LastFourDigits,
                    BelongMemNum: $scope.subscribData.carNumber.toString(),
                    DepDesc: $scope.subscribData.depDesc == 1 ? 'פרטי' : 'מסחרי',
                    DepNum: $scope.subscribData.depDesc,
                    CardID: $scope.bankAccounts[$scope.currentAccountIndex].Cards[$scope.currentCardIndex].Id
                }

                stCacheService.set('subscribeData', memData);

                if (response.Response.Status.SeverityNumber == "0002") {
                    lobbyUiService.go('dw.carwash-exist');
                } else {
                    lobbyUiService.go('dw.carwash-approve');
                }

            }, function (error) {
                errorService.handleError(error);
            }).finally(function () {
                lobbyUiService.loader.hide();
            });
        }

        $scope.showPopup = function (text) {

            lobbyUiService.popup.alert(text);
        }

        $scope.cardSlideChange = function (index) {
            $scope.currentCardIndex = index;
        }

        $scope.accountNext = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').next();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function () {
                $timeout.cancel(_promise);
            });
        }

        $scope.accountPrev = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').previous();

            }, 500).then(function () {
            });

            $scope.$on("$destroy", function () {
                $timeout.cancel(_promise);
            });

        }

        $scope.accountSlideChange = function (index) {

            $scope.showSlider = false;

            $scope.currentAccountIndex = index;

            $scope.currentAccountCards.slides = $scope.bankAccounts[index].Cards;

            $scope.updateCardSlider(0);
        }

        $scope.updateAccountSlider = function (index) {
            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').update();
            }, 200).then(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').slide(index);
                $scope.showSlider = true;
            });

            $scope.$on("$destroy", function () {
                $timeout.cancel(_promise);
            });

            return _promise;
        }

        $scope.updateCardSlider = function (index) {
            var _promise = $timeout(function () {

                $ionicSlideBoxDelegate.$getByHandle('cardsHandler').update();

            }, 500).then(function () {
                $ionicSlideBoxDelegate.$getByHandle('cardsHandler').slide(index);
                $scope.showSlider = true;
            }).finally(function () {
                $scope.slideBoxReady = true;
                lobbyUiService.loader.hide();
            });

            $scope.$on("$destroy", function () {
                $timeout.cancel(_promise);
            });

            return _promise;
        }

        $scope.to = function (index) {
            $ionicSlideBoxDelegate.$getByHandle('cardsHandler').slide(index);
        }

        $scope.$watch('subscribData.depDesc', function (newVal, oldVal) {

            if (newVal != oldVal) {
                googleAnalyticsService.insertEvent({ page: 'shtifomat', id: 1 });
            }
        });

        $scope.init();
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .controller('stExistCtrl', stExistCtrl);

    stExistCtrl.$inject = [
        '$scope', 'stMetaDataService', 'stSubscribService', 'errorService', 'lobbyUiService', 'stCacheService', 'stUtilsService', 'appData'
    ];

    function stExistCtrl($scope, stMetaDataService, stSubscribService, errorService, lobbyUiService, stCacheService, stUtilsService, appData) {

        $scope.account = appData.BankAccounts;

        $scope.appData = appData;

        $scope.init = function () {

            $scope.memberData = stCacheService.get('subscribeData');

            if (!lobbyUiService.connection.isLoggedIn() || !$scope.memberData) {
                lobbyUiService.go('dw.login', { nextPage: "dw.carwash" });
                return;
            }

            $scope.metaData = stMetaDataService.metaData();

            var obj = stUtilsService.getTextById($scope.metaData.FixTexts, 6);

            $scope.content = {
                title: obj.TextContent,
                ok: 'תיקון',
                cancel: 'המשך'
            };

            $scope.appData.inProcess = true;
        }

        $scope.update = function () {
            lobbyUiService.go('dw.carwash-home', { cardId: $scope.memberData.CardID });
        };

        $scope.continue = function () {

            lobbyUiService.loader.show();

            var subscribData =
            {
                carNumber: $scope.memberData.BelongMemNum.toString(),
                depDesc: $scope.memberData.DepNum,
                agreement: true,
                cardId: $scope.memberData.CardID
            };

            stSubscribService.clubSubscribe(subscribData).then(function () {
                lobbyUiService.go('dw.carwash-subscribe');
            }, function (error) {
                errorService.handleError(error);
            }).finally(function () {
                lobbyUiService.loader.hide();
            });
        };

        $scope.init();
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .controller('stSubscribeCtrl', stSubscribeCtrl);

    stSubscribeCtrl.$inject = [
        '$scope', 'stMetaDataService', 'stUtilsService', 'lobbyUiService', 'appData', 'googleAnalyticsService'
    ];

    function stSubscribeCtrl($scope, stMetaDataService, stUtilsService, lobbyUiService, appData, googleAnalyticsService) {

        $scope.account = appData.BankAccounts;

        $scope.appData = appData;

        $scope.init = function () {

            if (!lobbyUiService.connection.isLoggedIn()) {
                lobbyUiService.go('dw.login', { nextPage: "dw.carwash" });
                return;
            }

            googleAnalyticsService.insertEvent({ page: 'shtifomat', id: 6 });

            $scope.metaData = stMetaDataService.metaData();

            var obj = stUtilsService.getTextById($scope.metaData.FixTexts, 4);

            $scope.content = obj;
            $scope.content.buttonText = "סגור";

            $scope.appData.inProcess = false;
        }

        $scope.close = function () {
            lobbyUiService.go('dw.wallet-home');
        };

        $scope.init();
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .controller('stTerms', [stTerms]);

    function stTerms() {
        //do nothing
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
       .controller('stUnsubscribeCtrl', stUnsubscribeCtrl);

    stUnsubscribeCtrl.$inject = [
        '$scope', 'stMetaDataService', 'stSubscribService', 'errorService', 'lobbyUiService', 'stUtilsService', 'appData', 'googleAnalyticsService'
    ];

    function stUnsubscribeCtrl($scope, stMetaDataService, stSubscribService, errorService, lobbyUiService, stUtilsService, appData, googleAnalyticsService) {

        $scope.account = appData.BankAccounts;

        $scope.appData = appData;

        $scope.init = function () {

            $scope.appData.inProcess = false;

            if (!lobbyUiService.connection.isLoggedIn()) {
                lobbyUiService.go('dw.login', { nextPage: "dw.carwash" });
                return;
            }

            googleAnalyticsService.insertEvent({ page: 'shtifomat', id: 6 });

            $scope.metaData = stMetaDataService.metaData();

            var obj = stUtilsService.getTextById($scope.metaData.FixTexts, 3);

            $scope.content = obj;
            $scope.content.buttonText = "סגור";
        }

        $scope.close = function () {
            lobbyUiService.go('dw.wallet-home');
        };

        $scope.init();
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
       .controller('stWelcomeCtrl', stWelcomeCtrl);

    stWelcomeCtrl.$inject = [
        '$scope', 'stMetaDataService', 'stUtilsService', 'stSubscribService', 'errorService', 'stCacheService', 'stBankAccountService', 'lobbyUiService',
        'appData', 'googleAnalyticsService', '$timeout'
    ];

    function stWelcomeCtrl($scope, stMetaDataService, stUtilsService, stSubscribService, errorService, stCacheService, stBankAccountService, lobbyUiService, appData, googleAnalyticsService, $timeout) {

        lobbyUiService.loader.hide();

        $scope.appData = appData;

        $scope.appData.inProcess = false;

        $scope.members = {
            contentReady: false,
            stage: 0
        };

        $scope.init = function () {
            stMetaDataService.getMetaData(true).then(function (metaData) {
                $scope.metaData = metaData;
                $scope.initPage();
            });
        }

        $scope.initPage = function () {

            lobbyUiService.loader.show();

            $scope.members.stage = 0;

            $scope.account = stBankAccountService.filteredBankAccounts(appData.BankAccounts);

            stCacheService.remove('subscribed');

            stCacheService.remove('subscribeData');


            if (!lobbyUiService.connection.isLoggedIn()) {
                lobbyUiService.go('dw.login', { nextPage: "dw.carwash" });
                return;

            } else {

                if (!$scope.checkAccount()) {
                    $scope.initNoCards();
                } else {

                    stBankAccountService.setBankAccounts($scope.account);

                    stSubscribService.checkSubscribe(true).then(function (response) {

                        if (response.Response.Status.SeverityNumber == '0002') {
                            stCacheService.set('subscribed', true);
                            $scope.initConfirm();
                            //lobbyUiService.go('dw.carwash-confirm');
                        } else {

                            $scope.content = stUtilsService.getTextById($scope.metaData.FixTexts, 1);

                            $scope.content.buttonText = "המשך";
                        }


                        $scope.setPageReady();

                    }, function (error) {
                        lobbyUiService.loader.hide();
                        errorService.handleError(error);
                    });
                };

            }
        }

        $scope.setPageReady = function () {
            $timeout(function () {
                $scope.members.contentReady = true;
                lobbyUiService.loader.hide();
            }, 500);
        };

        $scope.checkAccount = function () {
            return ($scope.account && $scope.account.length > 0);
        };

        $scope.close = function () {

            if (!$scope.checkAccount()) {
                lobbyUiService.go('dw.wallet-home');
            } else {
                lobbyUiService.go('dw.carwash-home');
            }
        }

        $scope.initNoCards = function () {

            $scope.members.stage = 2;

            var obj = stUtilsService.getTextById($scope.metaData.FixTexts, 11);

            $scope.contentNoCard = obj;

            $scope.contentNoCard.buttonText = "סגור";

            $scope.setPageReady();
        }

        $scope.initConfirm = function () {

            $scope.members.stage = 1;

            var obj = stUtilsService.getTextById($scope.metaData.FixTexts, 5);

            $scope.contentConfirm = {
                title: obj.TextContent,
                ok: 'עדכון',
                cancel: 'הסרה'
            };

            $scope.infoText = {
                text: 'מידע על תחנות שטיפה',
                link: $scope.metaData.ShtifomatSite
            }

            stSubscribService.checkSubscribe().then(function (response) {
                $scope.memberData = response.CardArray[0];

                $scope.memberData.BelongMemNum = stUtilsService.padZeros($scope.memberData.BelongMemNum, 7);

            }).finally(function () {
                lobbyUiService.loader.hide();
            });
        }

        $scope.update = function () {
            lobbyUiService.go('dw.carwash-home', { cardId: $scope.memberData.CardID });
        };

        $scope.remove = function () {
            lobbyUiService.loader.show();
            stSubscribService.clubUnSubscribe($scope.memberData.CardID).then(function () {

                googleAnalyticsService.insertEvent({ page: 'shtifomat', id: 5 });

                lobbyUiService.go('dw.carwash-unsubscribe');

            }, function (error) {
                errorService.handleError(error);
            }).finally(function () {
                lobbyUiService.loader.hide();
            });
        };

        $scope.init();

    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .directive("stAccountSlider", stAccountSlider);

    function stAccountSlider() {
        return {
            templateUrl: 'app/carwash/templates/stAccountSlider.html',
            restrict: 'A',
            replace: true
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .directive("stCardSlider", stCardSlider);

    function stCardSlider() {
        return {
            templateUrl: 'app/carwash/templates/stCardSlider.html',
            restrict: 'A',
            replace: true,
            link: function postLink(scope, iElement, iAttrs) {
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .directive("stContentBox", stContentBox);

    stContentBox.$inject = ['$timeout'];

    function stContentBox($timeout) {
        return {
            templateUrl: 'app/carwash/templates/stContentBox.html',
            restrict: 'A',
            replace: true,
            scope:
            {
                title: '=stTitle',
                content: '=stContent',
                btn: '=stBtn',
                close: '&stClose'
            },
            link: function (scope) {

                $timeout(function () {
                    scope.dataReady = true;
                }, 200);
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat').
    directive("stDialogBox", stDialogBox);

    stDialogBox.$inject = ['lobbyUiService'];

    function stDialogBox(lobbyUiService) {
        return {
            templateUrl: 'app/carwash/templates/stDialogBox.html',
            restrict: 'A',
            replace: true,
            scope:
            {
                content: '=stContent',
                card: '=stCard',
                info: '=stInfo',
                ok: '&stOk',
                cancel: '&stCancel'
            },
            link: function (scope, element, attr, ctrls) {
                scope.openLink = function () {
                    lobbyUiService.openExternal(scope.info.link);
                };

                scope.dataReady = function () {
                    return scope.card && scope.content;
                }
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .directive("stHelpInfo", stHelpInfo);

    function stHelpInfo() {
        return {
            template: '<a href="javascript:void(0)" class="st-vehicle-radio-help" data-ng-click="showPopupModal()"></a>',
            restrict: 'EA',
            replace: true,
            scope:
            {
                content: '=stContent',
                title: '=stTitle'
            },
            controller: function ($element, $scope, $attrs, $ionicPopup, $timeout, lobbyUiService) {
                $scope.showPopupModal = function () {
                    $scope.data = {}


                    lobbyUiService.popup.alert($scope.content, $scope.title);
                }
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
.directive("stHtmlContent", stHtmlContent);

    stHtmlContent.$inject = ['stRestService', 'lobbyUiService'];

    function stHtmlContent(stRestService, lobbyUiService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                source: '@'
            },
            controller: ['$scope', function ($scope) {

                $scope.$id = 'terms';
                lobbyUiService.loader.show();
                stRestService.getDocument($scope.source + '.html').then(
                    function (response) {
                        $scope.content = $.parseHTML(response);
                    },
                    function (error) {
                    }
                ).finally(function () {
                    lobbyUiService.loader.hide();
                });

                $scope.openLink = function (url) {
                    lobbyUiService.openExternal(url);
                };
            }
            ],
            template: '<div class="st-terms" ng-bind-html="content | trusted"></div>',
            link: function (scope, element, attrs) {

                //element('.shtifomat-link').on(function() {
                //    lobbyUiService.openExternal('');
                //});

                scope.$watch('content', function (newvalue) {
                    if (newvalue) {
                        var current = "";
                        var text = "";

                        for (var i = 0; i < newvalue.length; i++) {
                            current = $(newvalue[i]).html();
                            if (current && current.length > 0) {

                                text += $.trim($(newvalue[i]).html());

                            }
                        }

                        element.append(text);

                        setTimeout(function () {
                            element.addClass('active');
                            //angular.element('.shtifomat-link').on('click',function() {
                            //    lobbyUiService.openExternal($(this).text());
                            //});
                        }, 0);
                    }
                });
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .directive('stNumber', stNumber);

    function stNumber() {
        return {
            require: '?ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }

                ngModelCtrl.$parsers.push(function (val) {
                    var clean = val.replace(/[^0-9]+/g, '');
                    if (val !== clean) {
                        ngModelCtrl.$setViewValue(clean);
                        ngModelCtrl.$render();
                    }
                    return clean;
                });

                element.bind('keypress', function (event) {
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }
                });
            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .factory('stBankAccountService', stBankAccountService);

    stBankAccountService.$inject = ['stRestService', 'errorService', 'stCacheService', '$q', '_'];

    function stBankAccountService(stRestService, errorService, stCacheService, $q, _) {

        var _fromCache = function () {
            return stCacheService.get('stBankAccounts');
        }

        var _setBankAccounts = function (value) {
            var filterdAccounts = value;

            stCacheService.set('stBankAccounts', filterdAccounts);
        };

        var _filteredBankAccounts = function (accounts) {

            var copyAccounts = angular.copy(accounts);

            var filterAccounts = [];

            _.each(copyAccounts, function (account, i) {
                var filterCards = _.filter(account.Cards, function (card) {
                    return card.CreditProductsInd == true;
                });

                if (filterCards.length > 0) {
                    account.Cards = filterCards;
                    filterAccounts.push(account);
                }
            });

            return filterAccounts;
        }

        var _getBankAccounts = function (fromServer) {
            var _defer = $q.defer();

            var _cache = _fromCache();

            if (_cache && !fromServer) {
                _defer.resolve(_cache);
            } else {

                stRestService.getBankAccounts().then(
                    function (response) {

                        var filterdAccounts = _filteredBankAccounts(response.BankAccounts);

                        stCacheService.set('stBankAccounts', filterdAccounts);

                        _defer.resolve(filterdAccounts);

                    }, function (error) {
                        _defer.reject(error);
                    });
            }

            return _defer.promise;
        };

        var _getCardById = function (id) {
            return _getBankAccounts().then(function (account) {
                var ai = 0;
                var ci = 0;
                
                _.each(account, function (a, i) {
                    _.each(a.Cards, function (rw, j) {

                        if (rw.Id == id) {
                            ci = j;
                            ai = i;
                            return;
                        }
                    });
                });

                return {
                    cardIndex: ci,
                    accountIndex: ai
                };
            });
        }

        return {
            fromCache: _fromCache,
            getBankAccounts: _getBankAccounts,
            getCardById: _getCardById,
            setBankAccounts: _setBankAccounts,
            filteredBankAccounts: _filteredBankAccounts
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .factory('stCacheService', stCacheService);

    stCacheService.$inject = ['$angularCacheFactory'];

    function stCacheService($angularCacheFactory) {

        var _cache = $angularCacheFactory('carwashCache');

        return {
            get: function (key) {
                return _cache.get(key);
            },
            set: function (key, value) {
                _cache.put(key, value);
            },
            remove: function (key) {
                _cache.remove(key);
            },
            clear: function () {
                $angularCacheFactory.clearAll();
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .factory('stMetaDataService', stMetaDataService);

    stMetaDataService.$inject = ['$rootScope', 'stRestService', 'errorService', 'stCacheService', '_', '$q', '$timeout'];

    function stMetaDataService($rootScope, stRestService, errorService, stCacheService, _, $q, $timeout) {
        var _metaData = function () {

            return stCacheService.get('stMetaData');
        };

        var _notify = function (track) {
            $timeout(function () { $rootScope.$broadcast('shtifomatMetaDataComplete', track); });
        }

        var _getMetaData = function (fromServer) {

            var _defer = $q.defer();

            var _cache = _metaData();

            if (_cache && !fromServer) {
                //console.log('meta data from cache');
                _defer.resolve(_cache);
            } else {
                //console.log('meta data from server');
                stRestService.getMetaData().then(
                    function (response) {

                        stCacheService.set('stMetaData', response);

                        _defer.resolve(response);

                    }, function (error) {

                        _defer.reject(error);
                    });
            }

            return _defer.promise;
        };

        var _getFixedText = function (id, fromServer) {

            return _getMetaData(fromServer).then(function (response) {
                var row = _.find(response.FixTexts, function (rw) {
                    return rw.TextCode == id;
                });

                //console.log(row);

                return row;
            });
        };

        var _metaDataService = {
            metaData: _metaData,
            getMetaData: _getMetaData,
            getFixedText: _getFixedText,
            notify: _notify
        };

        return _metaDataService;

    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .factory('stRestService', stRestService);

    stRestService.$inject = ['connection'];

    function stRestService(connection) {
        return {
            getBankAccounts: function () {
                return connection.getAccount();
            },
            getMetaData: function () {
                return connection.genericConnection('GET', 'CalShtifomatGetMetaData?', connection.versionAndOSParams);
            },
            checkSubscribe: function (data) {
                return connection.genericConnection('POST', 'CalShtifomatCheckSubscribeCust?', connection.versionAndOSParams, data);
            },
            checkSubscribeNumMem: function (data) {
                return connection.genericConnection('POST', 'CalShtifomatCheckSubscribeNumMem?', connection.versionAndOSParams, data);
            },
            clubSubscribe: function (data) {
                return connection.genericConnection('POST', 'CalShtifomatClubSubscribe?', connection.versionAndOSParams, data);
            },
            clubUnSubscribe: function (data) {
                return connection.genericConnection('POST', 'CalShtifomatClubUnSubscribe?', connection.versionAndOSParams, data);
            },
            getDocument: function (data) {
                return connection.genericConnection('GET', 'caldocs?', connection.versionAndOSParams + "&id=" + data);
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .factory('stSubscribService', stSubscribService);

    stSubscribService.$inject = ['stRestService', 'errorService', 'stCacheService', '$q'];

    function stSubscribService(stRestService, errorService, stCacheService, $q) {

        var _subscribedCards = function () {
            return stCacheService.get('stSubscribedCards');
        };

        var _memNumCards = function () {
            return stCacheService.get('stMemNumCards');
        };

        var _checkSubscribe = function (fromServer) {

            var _defer = $q.defer();

            var _cache = _subscribedCards();
            if (_cache && !fromServer) {
                _defer.resolve(_cache);
            } else {

                var data = {
                    ClubFilter: 0,
                    ValidationIndication: 1,
                    BelongKillingIndication: 0,
                    BelongID: '800822',
                    BelongTypeCode: 1
                };

                stRestService.checkSubscribe(data).then(function (response) {

                    stCacheService.set('stSubscribedCards', response);

                    _defer.resolve(response);

                }, function (error) {

                    _defer.reject(error);
                });
            }
            return _defer.promise;

        };
        var _checkSubscribeNumMem = function (belongMemNum, fromServer) {
            var _defer = $q.defer();

            var _cache = _subscribedCards();

            if (_cache && !fromServer) {
                _defer.resolve(_cache);
            } else {
                var data = {
                    BelongID: '800822',
                    BelongMemNum: belongMemNum
                };

                var promise = stRestService.checkSubscribeNumMem(data);

                promise.then(function (response) {

                    stCacheService.set('stMemNumCards', response);

                    _defer.resolve(response);

                }, function (error) {
                    _defer.reject(error);
                });
            }
            return _defer.promise;

        };
        var _clubSubscribe = function (subscribData) {

            var data = {
                BelongID: '800822',
                BelongMemNum: subscribData.carNumber,
                BelongTypeCode: 1,
                CardID: subscribData.cardId,
                DepNum: subscribData.depDesc,
                MainTemplate: 648,
                BelongKillingIssue: 'ל',
                NeedToRemoveSubscription: subscribData.update
            };

            return stRestService.clubSubscribe(data);
        };
        var _clubUnSubscribe = function (cardId) {
            var data = {
                BelongExtGroupId: '800822',
                BelongTypeCode: 1,
                CardID: cardId,
                MainTemplate: 648
            };

            return stRestService.clubUnSubscribe(data);
        };

        var subscribService = {
            subscribedCards: _subscribedCards,
            memNumCards: _memNumCards,
            checkSubscribe: _checkSubscribe,
            checkSubscribeNumMem: _checkSubscribeNumMem,
            clubSubscribe: _clubSubscribe,
            clubUnSubscribe: _clubUnSubscribe,
        };

        return subscribService;
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calshtifomat')
    .factory('stUtilsService', stUtilsService);

    stUtilsService.$inject = ['_'];

    function stUtilsService(_) {
        return {
            getTextById: function (obj, id) {
                var row = _.find(obj, function (rw) {
                    return rw.TextCode == id;
                });

                return row;
            },
            padZeros: function (num, len) {

                var padding = len - num.toString().length;

                var ret = '';

                for (var i = 0; i < padding; i++) {
                    ret += '0';
                }

                return ret + num;
            }
        };
    }
})(window, window.angular);
﻿(function (angular) {
    "use strict";
    angular.module("calshtifomat")
        .filter('trusted', ['$sce', function ($sce) {
            return function (val) {
                if (typeof val === 'string' && val.length > 0) {
                    return $sce.trustAsHtml(val);
                }
                return undefined;
            }
        }]);
})(angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp', ['jmdobry.angular-cache']);
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
        .config(followappRoute)
        .run(followappConfig);

    followappRoute.$inject = ['$provide', '$angularCacheFactoryProvider', '$stateProvider', '$compileProvider'];

    followappConfig.$inject = ['$rootScope', 'lobbyUiService', '$state', 'followAppStorage'];

    function followappRoute($provide, $angularCacheFactoryProvider, $stateProvider, $compileProvider) {
        $stateProvider
            .state('dw.followApp', {
                url: "/wallet/followApp",
                views: {
                    'contentBody': {
                        templateUrl: "app/followapp/templates/home.html",
                        controller: "faHomeCtrl"
                    }
                }
            })
            .state('dw.followApp-category', {
                url: "/wallet/followApp/category/:CategoryId",
                views: {
                    'contentBody': {
                        templateUrl: "app/followapp/templates/catagoria.html",
                        controller: "faCatagoriaCtrl"
                    }
                }
            })
            .state('dw.followApp-createDoc', {
                url: "/wallet/followApp/category/createDoc/:CategoryId",
                views: {
                    'contentBody': {
                        templateUrl: "app/followapp/templates/createDoc.html",
                        controller: "faCreateDocCtrl"
                    }
                }
            })
            .state('dw.followApp-viewDoc', {
                url: "/wallet/followApp/category/:CategoryId/:DocumentId",
                views: {
                    'contentBody': {
                        templateUrl: "app/followapp/templates/viewDoc.html",
                        controller: "faViewDocCtrl"
                    }
                }
            })
            .state('dw.followApp-searchDoc', {
                url: "/wallet/followApp/searchDoc/:CategoryId",
                views: {
                    'contentBody': {
                        templateUrl: "app/followapp/templates/searchDoc.html",
                        controller: "faSearchDocCtrl"
                    }
                }
            })
            .state('dw.followApp-searchResult', {
                url: "/wallet/followApp/searchResult",
                views: {
                    'contentBody': {
                        templateUrl: "app/followapp/templates/catagoria.html",
                        controller: "faSearchResultCtrl"
                    }
                }
            });

        $angularCacheFactoryProvider.setCacheDefaults({
            capacity: 1000,
            storageMode: 'sessionStorage'
        });

        $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|file|blob|cdvfile|content):|data:image\//);

    }

    function followappConfig($rootScope, lobbyUiService, $state, followAppStorage) {
        $rootScope.$on('$stateChangeStart', function (event, next) {
            // check on route change if it followApp. if ture check for login token
            if (_.contains(next.name, 'dw.followApp')) {

                //console.log('followApp route change');

                if (!lobbyUiService.connection.isLoggedIn()) {
                    followAppStorage.DestroyCache();
                    lobbyUiService.go('dw.login', { nextPage: "dw.followApp" });
                    event.preventDefault();
                }

            }

        });
        //FastClick.attach(document.body);
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .controller('faCatagoriaCtrl', faCatagoriaCtrl);

    faCatagoriaCtrl.$inject = [
        '$scope', 'googleAnalyticsService', 'appData', '$state', 'followAppStorage', '$headerService', 'documentService', 'lobbyUiService'
    ];

    function faCatagoriaCtrl($scope, googleAnalyticsService, appData, $state, followAppStorage, $headerService, documentService, lobbyUiService) {

        $scope.followAppGoBack = function () {
            if ($state.current.name == 'dw.followApp-category') {
                lobbyUiService.navigate('dw.followApp', { location: 'replace' }, {});
            }
        }
        //appData.backOverrideFN = $scope.followAppGoBack;

        $headerService.changeHeader('default');
        $scope.routeId = $state.params.CategoryId;
        $scope.displaySearch = true;

        $scope.docs = followAppStorage.GetAllDocuments();

        var docsInCatArray = $scope.docs.filter(function (d) {
            googleAnalyticsService.insertEvent({ page: 'followApp catagoria page in ' + d.CategoryName, eventName: 'FollowApp catagoria page in ' + d.CategoryName, action: 'Enter' });
            return d.CategoryId == $state.params.CategoryId;
        });

        var catSummary = followAppStorage.GetSummary();
        var selectedCategory = catSummary.filter(function (d) {
            return d.CategoryId == $state.params.CategoryId;
        });

        documentService.CurrentCategory(selectedCategory[0]);

        $scope.docs = docsInCatArray;

        //if there are no docs in this category...
        if (!docsInCatArray.length) {
            $scope.CategoryName = selectedCategory[0].CategoryName;
        }

        $scope.data = {};

        $scope.clearSearch = function () {
            $scope.data.searchInCatagory = '';
        }

        $scope.$on("$destroy", function () {
            appData.backOverrideFN = null;
        });

    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .controller('faCreateDocCtrl', faCreateDocCtrl);

    faCreateDocCtrl.$inject = [
        '$scope', 'googleAnalyticsService', '$state', '$ionicActionSheet', '$cameraService', '$log', '$headerService',
        '$ionicSlideBoxDelegate', '$dialogService', '$followAppConnection', 'lobbyUiService', '$location', 'followAppStorage', '$ionicModal',
        'serverResponseService', '$timeout', 'calenderService', 'parseTodayService', '$stateParams', 'errorService', 'dateChangeFormatService'
    ];

    function faCreateDocCtrl($scope, googleAnalyticsService, $state, $ionicActionSheet, $cameraService, $log, $headerService,
        $ionicSlideBoxDelegate, $dialogService, $followAppConnection, lobbyUiService, $location, followAppStorage, $ionicModal,
        serverResponseService, $timeout, calenderService, parseTodayService, $stateParams, errorService, dateChangeFormatService) {

        googleAnalyticsService.insertEvent({ page: 'followApp create page', eventName: 'FollowApp create page', action: 'Enter' });

        $cameraService.clearPhotos();
        // config flags
        $headerService.changeHeader('add');
        $scope.$id = 'CreateDocScope';
        var now = moment();
        $scope.images = [];
        var validityDate, reminderDate;
        $scope.document = {};

        followAppStorage.SetNumPicToDoc(0);

        $scope.today = parseTodayService + "T00:00:00";
        // get the dynamic and tags fields that relavent only for the spacific categoryId
        var getDynamicInCategories = _.find(followAppStorage.GetCatagories(), { 'CategoryId': parseInt($state.params.CategoryId) });
        var clonedCategoriesObject = $.extend(true, {}, getDynamicInCategories);
        $log.debug(clonedCategoriesObject);
        $scope.dynamicFields = clonedCategoriesObject.DynamicFields;
        $scope.tagsFields = clonedCategoriesObject.Tags;
        $scope.branches = followAppStorage.GetBranches();
        $scope.currencies = followAppStorage.GetCurerncies();
        $scope.document.BranchName = "בחר ענף";

        $scope.newDoc = {};
        //$scope.newDoc.ReminderDate = moment().hours(12).minute(0);
        var month = now.month() + 1;
        $scope.CreationDate = '' + now.date() + '-' + month + '-' + now.year() + '';
        $scope.CategoryName = clonedCategoriesObject.CategoryName;

        if (clonedCategoriesObject.IsShowAmountField)
            $scope.showAmount = true;


        $scope.$on('saveNewDocument', function () {

            var doc = null;
            if (($scope.documentForm.currencySelect.$viewValue != undefined || $scope.documentForm.currencySelect.$viewValue != null)
                && ($scope.documentForm.amount.$viewValue == undefined || $scope.documentForm.amount.$viewValue == null)) {
                $scope.documentForm.amount.$setValidity('required', false);
            } else {
                $scope.documentForm.amount.$setValidity('required', true);
            }

            if (
                (($scope.documentForm.amount.$viewValue != undefined || $scope.documentForm.amount.$viewValue != null) &&
                    ($scope.documentForm.amount.$viewValue != ''))
                    && ($scope.documentForm.currencySelect.$viewValue == undefined || $scope.documentForm.currencySelect.$viewValue == null)
            ) {
                $scope.documentForm.currencySelect.$setValidity('required', false);

            } else {
                $scope.documentForm.currencySelect.$setValidity('required', true);
            }

            if ($scope.documentForm.reminderDate != undefined && $scope.documentForm.reminderDate.$viewValue != null) {
                if (moment($scope.documentForm.reminderDate.$viewValue).isBefore(moment()._d)) {
                    if (moment().format('YYYY-MM-DD') > moment($scope.documentForm.reminderDate.$viewValue).format('YYYY-MM-DD')) {
                        $scope.documentForm.reminderDate.$setValidity('mindate', false);
                    } else if (moment().format('hh:mm:ss') > moment($scope.documentForm.reminderDate.$viewValue).format('hh:mm:ss')) {
                        $scope.documentForm.reminderDate.$setValidity('mindate', true);
                        $scope.documentForm.reminderDate.$setValidity('minTime', false);
                    } else {
                        $scope.documentForm.reminderDate.$setValidity('minTime', true);
                    }
                } else {
                    $scope.documentForm.reminderDate.$setValidity('minTime', true);
                    $scope.documentForm.reminderDate.$setValidity('mindate', true);
                }
            }


            if ($scope.documentForm.$valid) {

                var tagsIdArray = [];
                if ($scope.documentForm.tagsSelect.$viewValue) {
                    for (var i = 0; i < $scope.documentForm.tagsSelect.$viewValue.length; i++) {
                        tagsIdArray.push($scope.documentForm.tagsSelect.$viewValue[i].TagId);
                    }
                }
                var imageDataUrls = $cameraService.getPhotos();

                var dynamicFieldArray = [];
                for (var k = 0; k < $scope.dynamicFields.length; k++) {
                    if ($scope.dynamicFields[k].DynamicFieldContent != undefined) {
                        var obj = {};
                        obj.DynamicFieldId = $scope.dynamicFields[k].DynamicFieldId;
                        obj.DynamicFieldContent = $scope.dynamicFields[k].DynamicFieldContent;
                        dynamicFieldArray.push(obj);
                    }

                }


                if ($scope.documentForm.validityDate != undefined && $scope.documentForm.validityDate.$viewValue != null) {
                    validityDate = dateChangeFormatService.fixDateForValidity($scope.documentForm.validityDate.$viewValue);
                }
                if ($scope.documentForm.reminderDate != undefined && $scope.documentForm.reminderDate.$viewValue != null) {
                    //reminderDate = FixDate($scope.documentForm.reminderDate.$viewValue);

                    var rd = $scope.documentForm.reminderDate.$viewValue;

                    if (rd.length == 16) {
                        reminderDate = rd + ":00";
                    } else {
                        reminderDate = rd;
                    }
                }

                //var reminderDateTime = new Date(reminderDate + " " + $scope.documentForm.reminderTime.$viewValue);

                doc = {
                    DocumentName: $scope.documentForm.documentName.$viewValue,
                    CategoryId: $state.params.CategoryId,
                    BranchId: $scope.documentForm.branchesSelect.$viewValue.BranchId,
                    CreationDate: moment().format('DD-MM-YYYY'),
                    ValidityDate: validityDate,
                    ReminderDate: reminderDate,
                    DynamicFieldsInDocument: dynamicFieldArray,
                    //ReminderComment: $scope.documentForm.reminderComment.$viewValue,
                    Comment: $scope.documentForm.comment.$viewValue,
                    CurrencyId: $scope.documentForm.currencySelect.$viewValue == undefined ? null : $scope.documentForm.currencySelect.$viewValue.CurrencyId,
                    Amount: $scope.documentForm.amount.$viewValue == undefined ? null : $scope.documentForm.amount.$viewValue,
                    Tags: tagsIdArray,
                    Photos: imageDataUrls
                }

                // $loadingService.show();
                lobbyUiService.loader.show();

                $scope.saveNewDocument(doc);


            } else {

                //iterate through form controls to show the input error color  
                for (var prop in $scope.documentForm) {
                    if ($scope.documentForm.hasOwnProperty(prop) && prop.indexOf('$') < 0) {
                        if ($scope.documentForm[prop].$invalid)
                            $scope.documentForm[prop].$dirty = true;
                    }
                }

                $dialogService.showValidationPopup({ scope: $scope, actionText: 'סגור', actionCallback: function () { } });

            }

        });

        $scope.saveNewDocument = function (doc) {

            googleAnalyticsService.insertEvent({ page: 'followApp save new doc', eventName: 'FollowApp save new doc', action: 'Enter' });

            var saveNewDocPromise = $followAppConnection.SaveNewDocument(doc);

            saveNewDocPromise.then(function (response) {
                var remiderDate = doc.ReminderDate;

                if (remiderDate) {
                    var fromDate = moment($scope.documentForm.reminderDate.$viewValue)._d;

                    var toDate = new Date(fromDate.getTime());
                    toDate.setHours(fromDate.getHours() + 1);
                    var calEvents = [];
                    calEvents.push({
                        title: doc.DocumentName,
                        reminder: 120, //notes: doc.ReminderComment,
                        fromDate: fromDate,
                        toDate: toDate
                    });

                    var eventsPromise = calenderService.CreateEvents(calEvents);

                    if (eventsPromise) {
                        eventsPromise.then(function (data) {
                            $log.debug('success calender create event - ' + JSON.stringify(data));
                        },
                            function (error) { $log.debug('error calender create event - ' + JSON.stringify(error)); });
                    }
                }

                //$loadingService.hide();
                lobbyUiService.loader.hide();

                var okText = response.DialogBox.OkButtonText ? response.DialogBox.OkButtonText : 'מסמך נוסף';
                var cancelText = response.DialogBox.CancelButtonText ? response.DialogBox.CancelButtonText : 'חזרה לקטגוריה';

                var popupOptions = {
                    scope: $scope,
                    actionText: okText,
                    cancelText: cancelText,
                    actionCallback: function () {
                        $state.go($state.current, $stateParams, { reload: true });
                    },
                    cancelCallback: function () {
                        $state.go('dw.followApp-category', { CategoryId: clonedCategoriesObject.CategoryId });
                    },
                    text: response.DialogBox.Content
                };

                $followAppConnection.GetDocumentInfo().then(function (response2) {

                    followAppStorage.SetAllDocuments(response2.DocumentsInfo);
                    followAppStorage.SetSummary(response2.CategoriesSummary);
                    // $loadingService.hide();
                    lobbyUiService.loader.hide();

                    $dialogService.showGenericPopup(popupOptions);
                }, function (error2) {
                    lobbyUiService.loader.hide();
                    errorService.handleError(error2, $scope.saveNewDocument);
                });
            }, function (error) {
                lobbyUiService.loader.hide();
                errorService.handleError(error, $scope.saveNewDocument);
            });
        }

        //open actionsheet for add picture from camera or gallery
        $scope.showActionsheet = function () {
            $ionicActionSheet.show({
                buttons: [
                    { text: 'מצלמה' },
                    { text: 'גלריה' }
                ],
                destructiveText: 'ביטול',
                destructiveButtonClicked: function () {
                    return true;
                },
                buttonClicked: function (index) {
                    if (index === 0) {
                        $log.debug('camera');
                        $cameraService.openCamera().then(function (image) {
                            $scope.images.push(image);
                            $timeout(function () {
                                $ionicSlideBoxDelegate.update();
                                $ionicSlideBoxDelegate.next();
                            }, 1000);

                        },
                            function (error) {
                                $log.debug('error ' + error);
                                if (error.display)
                                    serverResponseService.GenricError(error.desc);
                            });
                        return true;
                    }
                    if (index === 1) {
                        $log.debug('gallery');
                        $cameraService.openGallery().then(function (image) {
                            $scope.images.push(image);
                            $timeout(function () {
                                $ionicSlideBoxDelegate.update();
                                $ionicSlideBoxDelegate.next();
                            }, 1000);

                        },
                            function (error) {
                                $log.debug('error ' + error);
                                if (error.display)
                                    serverResponseService.GenricError(error.desc);
                            });
                        return true;
                    }
                }
            });
        };

        $scope.openModal = function (index) {
            followAppStorage.SetPictureToSee($scope.images[index].fileUrl);

            $ionicModal.fromTemplateUrl('app/followapp/templates/imageGallery.html', function (modal) {
                $scope.modal = modal.show();
                $('.modal').addClass('clearModal');
            }, {
                animation: 'slide-in-up'
            });
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
       .controller('faHomeCtrl', faHomeCtrl);

    faHomeCtrl.$inject = [
        '$scope', 'googleAnalyticsService', 'appData', '$dialogService', '$followAppConnection', 'followAppStorage', '$state', '$window', 'lobbyUiService',
        'errorService', 'serverResponseService', 'calenderService', 'documentService', '$log'
    ];

    function faHomeCtrl($scope, googleAnalyticsService, appData, $dialogService, $followAppConnection, followAppStorage, $state, $window, lobbyUiService, errorService, serverResponseService, calenderService, documentService, $log) {

        googleAnalyticsService.insertEvent({ page: 'followApp home page', eventName: 'FollowApp home page', action: 'Enter' });

        $scope.init = function () {

            $scope.getDocumentInfo();

            $scope.getMetaData();

            documentService.CurrentCategory({});
        };

        // function for getting all document information.
        $scope.getDocumentInfo = function () {
            if (!followAppStorage.GetAllDocuments() || !followAppStorage.GetSummary()) {
                // call server for all document.
                $followAppConnection.GetDocumentInfo().then(function (response) {
                    //var response = serverResponseService.Translator.GetDocumentInfo.response(data);                    

                    $scope.options = response;
                    followAppStorage.SetSummary(response.CategoriesSummary);
                    followAppStorage.SetAllDocuments(response.DocumentsInfo);

                    lobbyUiService.loader.hide();

                }, function (error) {
                    lobbyUiService.loader.hide();
                    errorService.handleError(error, $scope.getDocumentInfo);

                });
            } else {
                var data = { DocumentsInfo: followAppStorage.GetAllDocuments(), CategoriesSummary: followAppStorage.GetSummary() };
                $scope.options = data;
                lobbyUiService.loader.hide();
            }
        }

        $scope.getMetaData = function () {
            if (!followAppStorage.GetBranches() ||
                !followAppStorage.GetCurerncies()) {
                $followAppConnection.MetaData().then(function (response) {

                    followAppStorage.SetBranches(response.Branches);
                    followAppStorage.SetCurerncies(response.Currencies);
                    followAppStorage.SetCatagories(response.Categories);
                    followAppStorage.SetMaxVolumePerPhoto(response.MaxVolumePerPhoto);
                    followAppStorage.SetMaxPhotosPerDocument(response.MaxPhotosPerDocument);
                    followAppStorage.SetMaxDocumentsPerCustomer(response.MaxDocumentsPerCustomer);

                }, function (error) {
                    errorService.handleError(error, $scope.getMetaData);
                });
            }
        }

        $scope.sync_calendar = function () {

            var arrayOfNotes = _.filter($scope.options.DocumentsInfo, function (obj) {
                return obj != null;
            });


            var createCalenderEvent = function (doc) {
                if (doc.ReminderDate) {
                    var fromDate = moment(doc.ReminderDate, 'DD-MM-YYYYThh:mm')._d;

                    var toDate = new Date(fromDate.getTime());

                    toDate.setHours(fromDate.getHours() + 1);

                    var calEvents = [];
                    calEvents.push({
                        title: doc.DocumentName,
                        reminder: 120, //notes: doc.ReminderComment,
                        fromDate: fromDate,
                        toDate: toDate
                    });

                    var eventsPromise = calenderService.CreateEvents(calEvents);

                    if (eventsPromise) {
                        eventsPromise.then(function (data) {
                            $log.debug('success calender create event - ' + JSON.stringify(data));
                        },
                            function (error) {
                                $log.debug('error calender create event - ' + JSON.stringify(error));
                            });
                    }
                }
            }

            var updateDocument = function () {

                //$loadingService.show();
                lobbyUiService.loader.show();

                angular.forEach(arrayOfNotes, function (value, key) {
                    var oldDoc = value;

                    if (oldDoc.ReminderDate) {

                        var oldFromDate = moment(oldDoc.ReminderDate, 'DD-MM-YYYYThh:mm')._d;

                        var oldToDate = new Date(oldFromDate.getTime());

                        oldToDate.setHours(oldFromDate.getHours() + 1);

                        var oldEvent = { title: oldDoc.DocumentName, fromDate: oldFromDate, toDate: oldToDate }

                        calenderService.DeleteEvent(oldEvent).then(function () {
                            createCalenderEvent(value);
                        }, function () {
                            //error
                            createCalenderEvent(value);
                        });
                    } else {
                        createCalenderEvent(value);
                    }
                });

                lobbyUiService.loader.hide();
                //$loadingService.hide();

                $dialogService.showGenericPopup({
                    scope: $scope,
                    actionText: 'סגור',
                    text: 'היומן סונכנן בהצלחה'
                });
            };

            updateDocument();
        }

        $scope.init();

    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .controller('faSearchDocCtrl', faSearchDocCtrl);

    faSearchDocCtrl.$inject = [
        '$scope', '$headerService', 'followAppStorage', 'documentService', '$state', '$stateParams', 'dateChangeFormatService', 'googleAnalyticsService'
    ];

    function faSearchDocCtrl($scope, $headerService, followAppStorage, documentService, $state, $stateParams, dateChangeFormatService, googleAnalyticsService) {

        googleAnalyticsService.insertEvent({ page: 'followApp search page', eventName: 'FollowApp search page', action: 'Enter' });

        $headerService.changeHeader('search');
        $scope.groups = [];

        $scope.Currency = followAppStorage.GetCurerncies();


        //categories
        var fullCategories = followAppStorage.GetSummary();

        if (!fullCategories) {
            $state.go('dw.followApp');
            //$location.path('FollowApp/home');
        }
        /* add yanir */
        var docs = [];
        $scope.searchDoc = {};

        var categoryId = $stateParams.CategoryId;

        if (categoryId)
            docs = documentService.GetCategoryDocuments(categoryId);
        else
            docs = followAppStorage.GetAllDocuments();

        if (categoryId) {
            $scope.categoryShow = false;
            $scope.searchDoc.categorie = categoryId;
        } else {
            $scope.categoryShow = true;
        }

        $scope.findInDocuments = function () {
            var searchFields = new Object();
            var amountSearchFields = new Object();
            var searchDate = new Object();

            if ($scope.model.freeSearch) {
                documentService.setFreeSearch($scope.model.freeSearch);

                if (categoryId)
                    docs = documentService.GetCategoryDocuments(categoryId);
                else
                    docs = followAppStorage.GetAllDocuments();

                setSearchResultView(docs);
            } else {

                angular.forEach($scope.faSearchForm, function (value, key) {
                    if (value.hasOwnProperty('$modelValue')) {
                        //if ($scope.faSearchForm[key].$dirty && $scope.faSearchForm[key].$modelValue != "" && $scope.faSearchForm[key].$modelValue != null)
                        if ($scope.faSearchForm[key].$modelValue != "" && $scope.faSearchForm[key].$modelValue != null) {
                            //console.log("model " + value.$modelValue);

                            switch (key) {
                                case 'Amount':
                                    searchFields[key] = parseInt(value.$modelValue);
                                    break;
                                case 'BranchId':
                                    searchFields[key] = parseInt(value.$modelValue.id);
                                    break;
                                case 'CategoryId':
                                    if ($scope.categoryShow)
                                        searchFields[key] = typeof value.$modelValue.value === 'undefined' ? parseInt(value.$modelValue) : parseInt(value.$modelValue.id);
                                    break;
                                case 'CreationDateStart':
                                    searchDate[key] = dateChangeFormatService.fixDate4Search(value.$modelValue);
                                    break;
                                case 'CreationDateEnd':
                                    searchDate[key] = dateChangeFormatService.fixDate4Search(value.$modelValue);
                                    break;
                                case 'ValidityDateStart':
                                    searchDate[key] = dateChangeFormatService.fixDate4Search(value.$modelValue);
                                    break;
                                case 'ValidityDateEnd':
                                    searchDate[key] = dateChangeFormatService.fixDate4Search(value.$modelValue);
                                    break;
                                case 'minAmount':
                                    amountSearchFields[key] = dateChangeFormatService.fixDate4Search(value.$modelValue);
                                    break;
                                case 'maxAmount':
                                    amountSearchFields[key] = dateChangeFormatService.fixDate4Search(value.$modelValue);
                                    break;
                                default:
                                    searchFields[key] = value.$modelValue;
                                    break;
                            }
                        }

                    }
                });

                //console.log(searchFields);
                var result = _.filter(docs, searchFields);

                var searchCreationDate = _.filter(docs, function (d) {
                    return d.CreationDate >= searchDate.CreationDateStart && d.CreationDate <= searchDate.CreationDateEnd;
                });

                var searchValidityDate = _.filter(docs, function (d) {
                    return d.ValidityDate >= searchDate.ValidityDateStart && d.ValidityDate <= searchDate.ValidityDateEnd;
                });

                var resultAmount = _.filter(docs, function (d) {
                    return d.Amount >= amountSearchFields.minAmount && d.Amount <= amountSearchFields.maxAmount;
                });

                result = _.union(result, resultAmount);
                result = _.union(result, searchCreationDate);
                result = _.union(result, searchValidityDate);

                //console.log(result);
                setSearchResultView(result);

            }

        }

        // bring all categories
        var categories = [];
        for (var i = 0; i < fullCategories.length; i++) {
            categories.push({ id: fullCategories[i].CategoryId, value: fullCategories[i].CategoryName });
            $scope.categories = categories;
        }

        // bring all branches
        var fullBranches = followAppStorage.GetBranches(); //GetFollowAppMetaData.Branches;
        var branches = [];
        for (var i = 0; i < fullBranches.length; i++) {
            branches.push({ id: fullBranches[i].BranchId, value: fullBranches[i].BranchName });
            $scope.branches = branches;
        }

        $scope.model = { minAmount: '', maxAmount: '', fromCreateDate: '', toCreateDate: '', fromValidityDate: '', toValidityDate: '', text: '' };

        var searchByCategory = function (categoryId) {
            var docs = documentService.GetCategoryDocuments(categoryId);
            setSearchResultView(docs);
        }

        var searchByDocName = function (group, form) {
            if (isValidForm(group, form)) {
                var docName = $scope.model.text;
                var docs = documentService.GetDocumentsByName(docName, categoryId);
                setSearchResultView(docs);
            }
        }

        $scope.clearSearch = function () {
            $scope.model.freeSearch = '';
        }

        var searchByCreateDate = function (group, form) {
            searchByDateRange(group, form, documentService.GetDocumentsByCreationDateRange);
        }

        var searchByValidityDate = function (group, form) {
            searchByDateRange(group, form, documentService.GetDocumentsByValidityDateRange);
        }

        var searchByDateRange = function (group, form, searchDelegate) {
            if (isValidForm(group, form)) {
                var fromDate = $('#fromDate:visible', '#advanceSearch').val();
                var toDate = $('#toDate:visible', '#advanceSearch').val();
                var docs = searchDelegate(fromDate, toDate, categoryId);
                setSearchResultView(docs);
            }
        }

        var searchByBranch = function (branchId) {
            var docs = documentService.GetBranchDocuments(branchId);
            setSearchResultView(docs);
        }

        var searchByAmount = function (group, form) {
            if (isValidForm(group, form)) {
                var minAmount = $scope.model.minAmount;
                var maxAmount = $scope.model.maxAmount;
                var docs = documentService.GetDocumentsByAmountRange(minAmount, maxAmount, categoryId);
                setSearchResultView(docs);
            }
        }

        var setSearchResultView = function (docs) {
            documentService.CurrentDocuments(docs);
            $state.go('dw.followApp-searchResult');
            //$location.path('FollowApp/searchResult');
        }

        var isValidForm = function (group, form) {
            group.isSubmit = true;
            return form.$valid;
        }

        if (!categoryId) {
            $scope.groups.push({
                name: 'לפי קטגוריה',
                type: 'list',
                items: categories,
                callback: searchByCategory
            });
        }

        $scope.groups.push({
            name: 'לפי שם המסמך',
            type: 'text',
            placeHolder: 'הקלד את שם המסמך',
            callback: searchByDocName,
            emptyError: 'יש למלא את שם המסמך.'
        });

        $scope.groups.push({
            name: 'לפי תאריך יצירת המסמך',
            type: 'date',
            callback: searchByCreateDate,
            emptyError: 'יש למלא טווח תאריכי יצירת המסמך.',
            fromDate: $scope.model.fromCreateDate,
            toDate: $scope.model.toCreateDate
        });

        $scope.groups.push({
            name: 'לפי תאריך תפוגת המסמך',
            type: 'date',
            callback: searchByValidityDate,
            emptyError: 'יש למלא טווח תאריכי תפוגת המסמך.',
            fromDate: $scope.model.fromValidityDate,
            toDate: $scope.model.toValidityDate
        });

        $scope.groups.push({
            name: 'לפי ענף',
            type: 'list',
            items: branches,
            callback: searchByBranch
        });

        $scope.groups.push({
            name: 'לפי סכום',
            type: 'range',
            callback: searchByAmount
        });

        $scope.toggleGroup = function (group) {
            if ($scope.isGroupShown(group)) {
                $scope.shownGroup = null;
            } else {
                $scope.shownGroup = group;
            }
        };
        $scope.isGroupShown = function (group) {
            return $scope.shownGroup === group;
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .controller('faSearchResultCtrl', faSearchResultCtrl);

    faSearchResultCtrl.$inject = [
        '$scope', '$headerService', 'documentService'
    ];

    function faSearchResultCtrl($scope, $headerService, documentService) {
        $headerService.changeHeader('searchResult');

        var category = documentService.CurrentCategory();
        if (category)
            $scope.CategoryName = category.CategoryName;

        $scope.docs = documentService.CurrentDocuments();

        $scope.data = {};

        var freeSearch = documentService.getFreeSearch();

        if (freeSearch && freeSearch.length > 0) {
            $scope.displaySearch = true;
            $scope.data.searchInCatagory = freeSearch;
            documentService.setFreeSearch(null);
        } else {
            $scope.displaySearch = false;
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .controller('faViewDocCtrl', faViewDocCtrl);

    faViewDocCtrl.$inject = [
        '$scope', 'googleAnalyticsService', '$state', '$ionicPlatform', '$ionicModal', '$dialogService', 'followAppStorage', '$headerService',
        '$ionicSlideBoxDelegate', '$timeout', '$followAppConnection', 'lobbyUiService', '$location', '$log', '$ionicActionSheet',
        '$cameraService', 'serverResponseService', 'calenderService', 'parseTodayService', 'dateChangeFormatService', 'errorService', 'backService', '$q'
    ];

    function faViewDocCtrl($scope, googleAnalyticsService, $state, $ionicPlatform, $ionicModal, $dialogService, followAppStorage, $headerService,
        $ionicSlideBoxDelegate, $timeout, $followAppConnection, lobbyUiService, $location, $log, $ionicActionSheet,
        $cameraService, serverResponseService, calenderService, parseTodayService, dateChangeFormatService, errorService, backService, $q) {

        googleAnalyticsService.insertEvent({ page: 'followApp view page', eventName: 'FollowApp view page', action: 'Enter' });

        if (!$state.params.DocumentId) {
            $state.go('dw.followApp');
        }

        var getDynamicInCategories;
        var clonedCategoriesObject;
        var validityDate, reminderDate;
        var currentDocArray;
        var barCodeString;
        $scope.showSlider = false;

        $scope.init = function () {

            $cameraService.clearPhotos();

            getDynamicInCategories = _.find(followAppStorage.GetCatagories(), { 'CategoryId': parseInt($state.params.CategoryId) });

            clonedCategoriesObject = $.extend(true, {}, getDynamicInCategories);

            $scope.today = parseTodayService;
            // config flags for view document
            $scope.doc = followAppStorage.GetAllDocuments();
            $scope.CategoriesSummary = followAppStorage.GetSummary();
            $scope.dynamicFields = clonedCategoriesObject.DynamicFields;
            $scope.tagsFields = clonedCategoriesObject.Tags;
            $scope.branches = followAppStorage.GetBranches();
            $scope.currencies = followAppStorage.GetCurerncies();
            $scope.isEdit = false;
            $scope.imagePreloader = false;

            $headerService.changeHeader('blankCaption');

            if (clonedCategoriesObject.IsShowAmountField)
                $scope.showAmount = true;

            currentDocArray = $scope.doc.filter(function (d) {
                return d.DocumentId == $state.params.DocumentId;
            });

            if (currentDocArray.length) {

                $scope.currentDoc = currentDocArray[0];

                $log.debug($scope.currentDoc);

                $scope.currentDoc.ReminderDate = moment($scope.currentDoc.ReminderDate, 'DD-MM-YYYYThh:mm').format('YYYY-MM-DDThh:mm');

                $scope.currentDoc.currentBranch = $scope.branches[$scope.currentDoc.BranchId - 1];
                $scope.currentDoc.selectedCurrency = $scope.currencies[$scope.currentDoc.CurrencyId - 1];
                $scope.currentDocBeforeChanges = $.extend(true, {}, $scope.currentDoc);

                //$scope.currentDoc.ReminderDateInput = dateChangeFormatService.fixDate($scope.currentDoc.ReminderDate);
                //$scope.currentDoc.ValidityDateInput = dateChangeFormatService.fixDate($scope.currentDoc.ValidityDate);
                $log.debug('2' + $scope.currentDoc);
            }

            $scope.images = [];

            $scope.showSlider = false || $scope.currentDoc.DocumentPhotosList.length == 0;

            followAppStorage.SetNumPicToDoc($scope.currentDoc.DocumentPhotosList.length);

            var _proms = [];

            angular.forEach($scope.currentDoc.DocumentPhotosList, function (value, key) {
                var self = this;
                $scope.imagePreloader = true;
                _proms.push($followAppConnection.GetDocumentPhoto($scope.currentDoc.DocumentId, value).then(function (data) {
                    $scope.imagePreloader = false;
                    self.push({ fileUrl: "data:image/jpeg;base64," + data, photoId: value });
                }));
            }, $scope.images);

            $q.all(_proms).then(function () {
                $timeout(function () {
                    $ionicSlideBoxDelegate.$getByHandle("followappHandler").update();
                }, 1000).then(function () {
                    $scope.showSlider = true;
                });
            });

            if ($scope.currentDoc.TagsInDocumentList && $scope.currentDoc.TagsInDocumentList.length) {
                $scope.showTags = true;
                $scope.currentDoc.tags = [];
                for (var i = 0; i < $scope.currentDoc.TagsInDocumentList.length; i++) {
                    $scope.currentDoc.tags.push($scope.currentDoc.TagsInDocumentList[i].TagName);
                }
            }

            $scope.barcodePreview = function (field) {
                if (!$scope.isEdit) {
                    barCodeString = 'data:image/png;base64,' + field.Barcode;
                    followAppStorage.SetPictureToSee(barCodeString);

                    $ionicModal.fromTemplateUrl('app/followapp/templates/barcodePreview.html', function (modal) {
                        $scope.modal = modal.show();
                    }, {
                        animation: 'slide-in-up'
                    });
                }
            }

        };

        $scope.openModal = function (index) {

            followAppStorage.SetPictureToSee($scope.images[index].fileUrl);

            $ionicModal.fromTemplateUrl('app/followapp/templates/imageGallery.html', function (modal) {
                $scope.modal = modal.show();
                $('.modal').addClass('clearModal');
            }, {
                animation: 'slide-in-up'
            });
        }

        $scope.enableEdit = function () {
            googleAnalyticsService.insertEvent({ page: 'followApp edit doc', eventName: 'FollowApp edit doc', action: 'Enter' });
            $location.search('edit');
            if (!$scope.isEdit) {
                $headerService.changeHeader('edit');
                $scope.isEdit = true;
                if ($scope.currentDoc.ReminderDate != null && $scope.currentDoc.ReminderDate != "") {
                    $scope.currentDoc.ReminderDateInput = moment($scope.currentDoc.ReminderDate).format('YYYY-MM-DDThh:mm');
                }
                $scope.currentDoc.ValidityDateInput = dateChangeFormatService.fixDate($scope.currentDoc.ValidityDate);
                $scope.currentDoc.currentBranch = $scope.branches[$scope.currentDoc.BranchId - 1];
                $scope.currentDoc.selectedCurrency = $scope.currencies[$scope.currentDoc.CurrencyId - 1];
                //$scope.currentDoc.ReminderDateInput = dateChangeFormatService.fixDate($scope.currentDoc.ReminderDate);
                //$scope.currentDoc.ValidityDateInput = dateChangeFormatService.fixDate($scope.currentDoc.ValidityDate);
            } else {
                $headerService.changeHeader('blankCaption');
                $scope.isEdit = false;
            }
        };

        $scope.emailCallback = function () {
            googleAnalyticsService.insertEvent({ page: 'followApp send mail', eventName: 'followApp send mail', action: 'Enter' });
            $scope.showError = false;

            if ($('#txtEmail').val())
                $scope.mail = $('#txtEmail').val();
            if ($scope.emailForm.$valid) {
                var dataItems = { 'MailAddress': $scope.mail, 'DocumentId': $state.params.DocumentId }
                $followAppConnection.SendEmail(dataItems).then(function (data) {
                    lobbyUiService.loader.hide();
                    $dialogService.showGenericPopup({
                        scope: $scope,
                        actionText: 'סגור',
                        text: 'המייל נשלח בהצלחה'
                    });
                }, function (error) {
                    //$loadingService.hide();
                    lobbyUiService.loader.hide();
                    errorService.handleError(error, $scope.emailCallback);
                });
            } else {
                $scope.showError = true;
                return false;
            }
            return true;
        };

        $scope.trashCallback = function () {

            googleAnalyticsService.insertEvent({ page: 'followApp delete doc', eventName: 'followApp delete doc', action: 'Enter' });

            var dataItems = { DocumentId: $state.params.DocumentId }

            lobbyUiService.loader.show();

            $followAppConnection.DeleteDocument(dataItems).then(function (response) {

                lobbyUiService.loader.hide();

                var oldDoc = $scope.currentDocBeforeChanges;

                if (oldDoc.ReminderDate) {

                    var oldFromDate = moment(oldDoc.ReminderDate, 'DD-MM-YYYYThh:mm');

                    oldFromDate = new Date(oldFromDate);

                    var oldToDate = new Date(oldFromDate.getTime());

                    oldToDate.setHours(oldFromDate.getHours() + 1);

                    var oldEvent = { title: oldDoc.DocumentName, fromDate: oldFromDate, toDate: oldToDate }

                    calenderService.DeleteEvent(oldEvent);
                }

                $scope.GetDocumentInfo();

            }, function (error) {
                lobbyUiService.loader.hide();
                errorService.handleError(error, $scope.trashCallback);
            });
        }

        $scope.GetDocumentInfo = function () {
            $followAppConnection.GetDocumentInfo().then(function (response) {

                followAppStorage.SetAllDocuments(response.DocumentsInfo);

                followAppStorage.SetSummary(response.CategoriesSummary);

                lobbyUiService.loader.hide();

                $state.go('dw.followApp-category', { CategoryId: $state.params.CategoryId });

            }, function (error) {
                lobbyUiService.loader.hide();
                errorService.handleError(error, $scope.GetDocumentInfo);
            });
        }

        $scope.sendToMail = function () {
            $dialogService.showEmailPopup({ scope: $scope, actionText: 'שלח', cancelText: 'ביטול', actionCallback: $scope.emailCallback });
        }

        $scope.removeDoc = function () {
            $dialogService.showTrashPopup({ scope: $scope, actionText: 'אישור', cancelText: 'ביטול', actionCallback: $scope.trashCallback });
        }

        //open actionsheet for add picture from camera or gallery
        $scope.showActionsheet = function () {
            if ($scope.isEdit) {
                $ionicActionSheet.show({
                    buttons: [
                        { text: 'מצלמה' },
                        { text: 'גלריה' }
                    ],
                    destructiveText: 'ביטול',
                    destructiveButtonClicked: function () {
                        return true;
                    },
                    buttonClicked: function (index) {
                        if (index === 0) {
                            $log.debug('camera');
                            $cameraService.openCamera().then(function (image) {
                                $scope.images.push(image);
                                $timeout(function () {
                                    $ionicSlideBoxDelegate.update();
                                    $ionicSlideBoxDelegate.next();
                                }, 1000);

                            },
                                function (error) {
                                    $log.debug('error');
                                    if (error.display)
                                        serverResponseService.GenricError(error.desc);
                                });
                            return true;
                        }
                        if (index === 1) {
                            $log.debug('gallery');
                            $cameraService.openGallery().then(function (image) {
                                $scope.images.push(image);
                                $timeout(function () {
                                    $ionicSlideBoxDelegate.update();
                                    $ionicSlideBoxDelegate.next();
                                }, 1000);

                            },
                                function (error) {
                                    $log.debug('error');
                                    if (error.display)
                                        serverResponseService.GenricError(error.desc);
                                });
                            return true;
                        }
                    }
                });
            }
        };

        $scope.deleteImage = function () {
            //get current photo
            var currentIndex = $ionicSlideBoxDelegate.currentIndex();

            var imageId = $scope.images[currentIndex].photoId;

            if (imageId) {

                lobbyUiService.loader.show();

                //build data object
                var deletePhotoData = {
                    PhotoId: imageId
                }
                //activate server request
                $followAppConnection.DeletePhoto(deletePhotoData).then(function (response) {
                    //clear the array
                    $scope.images.splice(currentIndex, 1);

                    followAppStorage.SetNumPicToDoc($scope.images.length);

                    //update all the docs
                    $followAppConnection.GetDocumentInfo().then(function (response2) {
                        followAppStorage.SetAllDocuments(response2.DocumentsInfo);
                        lobbyUiService.loader.hide();
                    }, function (error2) {
                        lobbyUiService.loader.hide();
                        errorService.handleError(error2, $scope.deleteImage);
                    });
                    $timeout(function () {
                        $ionicSlideBoxDelegate.update();
                    }, 600);
                    if (currentIndex > 0) {
                        $ionicSlideBoxDelegate.slide(currentIndex - 1);
                    }

                }, function (error) {
                    lobbyUiService.loader.hide();
                    errorService.handleError(error, $scope.deleteImage);
                });
            } else {
                $scope.images.splice(currentIndex, 1);
                followAppStorage.SetNumPicToDoc($scope.images.length);

                $timeout(function () {
                    $ionicSlideBoxDelegate.update();
                }, 600);
                if (currentIndex > 0) {
                    $ionicSlideBoxDelegate.slide(currentIndex - 1);
                }
            }
        }

        $scope.removeImage = function () {
            $dialogService.showTrashPopup({
                scope: $scope,
                actionText: 'אישור',
                cancelText: 'ביטול',
                actionCallback: function () {
                    $scope.deleteImage();
                }
            });

        }

        $scope.$on('editDocument', function () {

            if (($scope.documentForm.currencySelect.$viewValue != undefined || $scope.documentForm.currencySelect.$viewValue != null)
                && ($scope.documentForm.amount.$viewValue == undefined || $scope.documentForm.amount.$viewValue == null)) {
                $scope.documentForm.amount.$setValidity('required', false);
            } else {
                $scope.documentForm.amount.$setValidity('required', true);
            }

            if (
                (($scope.documentForm.amount.$viewValue != undefined || $scope.documentForm.amount.$viewValue != null) &&
                    ($scope.documentForm.amount.$viewValue != ''))
                    && ($scope.documentForm.currencySelect.$viewValue == undefined || $scope.documentForm.currencySelect.$viewValue == null)
            ) {
                $scope.documentForm.currencySelect.$setValidity('required', false);

            } else {
                $scope.documentForm.currencySelect.$setValidity('required', true);
            }


            if ($scope.documentForm.reminderDate != undefined && $scope.documentForm.reminderDate.$viewValue != null) {
                if (moment($scope.documentForm.reminderDate.$viewValue).isBefore(moment()._d)) {
                    if (moment().format('YYYY-MM-DD') > moment($scope.documentForm.reminderDate.$viewValue).format('YYYY-MM-DD')) {
                        $scope.documentForm.reminderDate.$setValidity('mindate', false);
                    } else if (moment().format('hh:mm:ss') > moment($scope.documentForm.reminderDate.$viewValue).format('hh:mm:ss')) {
                        $scope.documentForm.reminderDate.$setValidity('mindate', true);
                        $scope.documentForm.reminderDate.$setValidity('minTime', false);
                    } else {
                        $scope.documentForm.reminderDate.$setValidity('minTime', true);
                    }
                } else {
                    $scope.documentForm.reminderDate.$setValidity('minTime', true);
                    $scope.documentForm.reminderDate.$setValidity('mindate', true);
                }
            }

            if ($scope.documentForm.$valid) {

                var tagsIdArray = [];
                if ($scope.documentForm.tagsSelect &&
                    $scope.documentForm.tagsSelect.$viewValue) {
                    for (var j = 0; j < $scope.documentForm.tagsSelect.$viewValue.length; j++) {
                        tagsIdArray.push($scope.documentForm.tagsSelect.$viewValue[j].TagId);
                    }
                }

                var dynamicFieldArray = [];
                for (var k = 0; k < $scope.currentDoc.DynamicFieldsInDocumentList.length; k++) {
                    var obj = {};
                    obj.DynamicFieldId = $scope.currentDoc.DynamicFieldsInDocumentList[k].DynamicFieldId;
                    obj.DynamicFieldContent = $scope.currentDoc.DynamicFieldsInDocumentList[k].DynamicFieldContent;
                    //obj.Barcode = $scope.currentDoc.DynamicFieldsInDocumentList[k].Barcode;
                    dynamicFieldArray.push(obj);
                }

                if ($scope.documentForm.validityDate != undefined && $scope.documentForm.validityDate.$viewValue != null) {
                    validityDate = dateChangeFormatService.fixDateForValidity($scope.documentForm.validityDate.$viewValue);
                }
                if ($scope.documentForm.reminderDate != undefined && $scope.documentForm.reminderDate.$viewValue != null) {
                    //reminderDate = FixDate($scope.documentForm.reminderDate.$viewValue);
                    var rd = $scope.documentForm.reminderDate.$viewValue;

                    if (rd.length == 16) {
                        reminderDate = rd + ":00";
                    } else {
                        reminderDate = rd;
                    }
                }

                var imageDataUrls = $cameraService.getPhotos();

                var doc = {
                    DocumentId: $state.params.DocumentId,
                    DocumentName: $scope.currentDoc.DocumentName,
                    CategoryId: $scope.currentDoc.CategoryId,
                    BranchId: $scope.documentForm.branchesSelect.$viewValue.BranchId,
                    CreationDate: $scope.currentDoc.CreationDate,
                    ValidityDate: validityDate,
                    ReminderDate: reminderDate,
                    //ReminderComment: $scope.currentDoc.ReminderComment,
                    Comment: $scope.currentDoc.Comment,
                    DynamicFieldsInDocument: dynamicFieldArray,
                    Tags: tagsIdArray,
                    CurrencyId: ($scope.documentForm.currencySelect && $scope.documentForm.currencySelect.$viewValue)
                        ? $scope.documentForm.currencySelect.$viewValue.CurrencyId : null,
                    Amount: $scope.documentForm.amount.$viewValue == undefined ? null : $scope.documentForm.amount.$viewValue,
                    Photos: imageDataUrls
                }

                var createCalenderEvent = function () {
                    if (doc.ReminderDate) {
                        var fromDate = moment($scope.documentForm.reminderDate.$viewValue)._d;

                        var toDate = new Date(fromDate.getTime());

                        toDate.setHours(fromDate.getHours() + 1);

                        var calEvents = [];
                        calEvents.push({
                            title: doc.DocumentName,
                            reminder: 120, //notes: doc.ReminderComment,
                            fromDate: fromDate,
                            toDate: toDate
                        });

                        var eventsPromise = calenderService.CreateEvents(calEvents);

                        if (eventsPromise) {
                            eventsPromise.then(function (data) {
                                $log.debug('success calender create event - ' + JSON.stringify(data));
                            },
                                function (error) { $log.debug('error calender create event - ' + JSON.stringify(error)); });
                        }
                    }
                }


                $scope.updateDocument = function () {

                    lobbyUiService.loader.show();

                    $followAppConnection.UpdateDocument(doc).then(function (response) {

                        $headerService.changeHeader('blankCaption');

                        lobbyUiService.loader.hide();

                        var oldDoc = $scope.currentDocBeforeChanges;
                        
                        if (oldDoc.ReminderDate) {
                            var oldFromDate = new Date(moment(oldDoc.ReminderDate, 'YYYY-MM-DDThh:mm'));

                            var oldToDate = new Date(oldFromDate.getTime());

                            oldToDate.setHours(oldFromDate.getHours() + 1);

                            var oldEvent = { title: oldDoc.DocumentName, fromDate: oldFromDate, toDate: oldToDate }

                            calenderService.DeleteEvent(oldEvent).finally(function () {
                                createCalenderEvent();
                            });
                        } else {
                            createCalenderEvent();
                        }

                        $followAppConnection.GetDocumentInfo().then(function (response2) {

                            followAppStorage.SetAllDocuments(response2.DocumentsInfo);

                            var currentDocArray2 = response2.DocumentsInfo.filter(function (d) {
                                return d.DocumentId == $state.params.DocumentId;
                            });
                            $scope.currentDoc = currentDocArray2[0];

                            lobbyUiService.loader.hide();

                            $scope.isEdit = false;

                            //$state.go($state.current, {}, { reload: true });
                            backService.back();
                            $scope.init();

                        }, function (error2) {
                            lobbyUiService.loader.hide();
                            errorService.handleError(error2, $scope.updateDocument);
                        });

                    }, function (error) {
                        //error
                        $headerService.changeHeader('blankCaption');
                        //serverResponseService.GeneralError();
                        errorService.handleError(error, $scope.updateDocument);
                    });
                }

                $scope.updateDocument();

            } else {

                //iterate through form controls to show the input error color  
                for (var prop in $scope.documentForm) {
                    if ($scope.documentForm.hasOwnProperty(prop) && prop.indexOf('$') < 0) {
                        if ($scope.documentForm[prop].$invalid)
                            $scope.documentForm[prop].$dirty = true;
                    }
                }

                $dialogService.showValidationPopup({ scope: $scope, actionText: 'סגור', actionCallback: function () { } });
            }
        });

        $scope.$on('$locationChangeSuccess', function (event, next, original) {
            if (next + '?edit' == original) {
                $headerService.changeHeader('blankCaption');
                $scope.currentDoc = $scope.currentDocBeforeChanges;
                $scope.isEdit = false;
                //$loadingService.hide();
                lobbyUiService.loader.hide();
            }
        });

        $scope.init();

    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .controller('imageGalleryCtrl', imageGalleryCtrl);

    imageGalleryCtrl.$inject = [
        '$scope', 'followAppStorage'
    ];

    function imageGalleryCtrl($scope, followAppStorage) {
        $scope.image = followAppStorage.GetPictureToSee();
        $scope.closeModal = function () {
            $('.modal').removeClass('clearModal');
            $scope.modal.hide();
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .controller('ValidationModalCtrl', ValidationModalCtrl);

    ValidationModalCtrl.$inject = [
        '$scope'
    ];

    function ValidationModalCtrl($scope) {
        $scope.currentForm = $scope.$parent.$parent.documentForm;
        $scope.showAmountError = false;
        $scope.showCurrencyError = false;

        if (($scope.currentForm.currencySelect.$viewValue != undefined || $scope.currentForm.currencySelect.$viewValue != null)
            && ($scope.currentForm.amount.$viewValue == undefined || $scope.currentForm.amount.$viewValue == null)) {
            $scope.showAmountError = true;
        }

        if ((($scope.currentForm.amount.$viewValue != undefined || $scope.currentForm.amount.$viewValue != null) && $scope.currentForm.amount.$viewValue != '')
            && ($scope.currentForm.currencySelect.$viewValue == undefined || $scope.currentForm.currencySelect.$viewValue == null)) {
            $scope.showCurrencyError = true;
        }

    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
        .directive("followappHeader", followappHeader);

    function followappHeader() {
        return {
            templateUrl: 'app/followapp/templates/followappHeaderTemplate.html',
            restrict: 'E',
            replace: true,
            controller: [
                '$scope', '$stateParams', '$headerService', 'followAppStorage', '$state', 'serverResponseService',
                function (scope, $stateParams, $headerService, followAppStorage, $state, serverResponseService) {
                    var setSettings = function (settings) {
                        scope.headerSettings = settings;
                        scope.Text = settings.text;
                        scope.DisplayButtons = settings.displayButtons;
                        scope.headerClass = settings.headerClass;
                        scope.leftText = settings.leftText;
                        scope.disableLeftButton = settings.disableLeftButton;
                    }

                    scope.CatagoryId = $stateParams.CategoryId;
                    setSettings($headerService.getSettings());

                    scope.goTo = function () {
                        //console.log(path);
                        var catSummary = followAppStorage.GetSummary();
                        var selectedCategory = catSummary.filter(function (d) {
                            return d.CategoryId == parseInt($state.params.CategoryId);
                        });

                        if (followAppStorage.GetMaxDocumentsPerCustomer() < selectedCategory[0].TotalDocsPerCategory) {
                            serverResponseService.alertAction("הגעת למספר המקסימלי");
                        } else {
                            $state.go('dw.followApp-createDoc', { 'CategoryId': $stateParams.CategoryId });
                            //$location.path(path);
                        }
                    }

                    scope.buttonClick = function (args) {
                        scope.headerSettings.buttonsCallback(args);
                    }

                    scope.$on('headerChange', function (event, args) {
                        setSettings(args);
                    });
                }
            ]
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';

    angular.module('calFollowApp')
        .factory('calenderService', calenderService);

    calenderService.$inject = ['$q', '$log'];

    function calenderService($q, $log) {

        var _messages = [];
        var _eventsLength = 0;
        var deferred = $q.defer();
        var createEventSuccess = function (message) {
            _messages.push({ status: message == true || message == 'OK', result: message });

            if (_messages.length == _eventsLength) {
                $log.debug(JSON.stringify(_messages));
                deferred.resolve(_messages);
            }
        }

        var createEventError = function (message) {
            _messages.push({ status: false, result: message });

            if (_messages.length == _eventsLength) {
                alert(JSON.stringify(_messages));
                deferred.resolve(_messages);
            }
            //deferred.reject(message);
        }

        var FindEvent = function (calEvent) {
            if (window.plugins && window.plugins.calendar) {

                window.plugins.calendar.findEvent(calEvent.title, 'Cal', '', calEvent.fromDate, calEvent.toDate,
                    function (data) {
                        deferred.resolve(data);
                    }, function (err) {
                        $log.debug(JSON.stringify(err));
                        deferred.reject(err);
                    });

                return deferred.promise;
            }

            return null;
        }

        var UpdateEvent = function (calEvent) {
            DeleteEvent(calEvent).finally(function () {
                return CreateEvents(calEvent);
            });
        }

        var DeleteEvent = function (calEvent) {
            if (window.plugins && window.plugins.calendar) {

                window.plugins.calendar.deleteEvent(calEvent.title, 'Cal', '', calEvent.fromDate, calEvent.toDate,
                    function (data) {
                        deferred.resolve(data);
                    }, function (err) {
                        $log.debug(JSON.stringify(err));
                        deferred.reject(err);
                    });

                return deferred.promise;
            }

            return null;
        }

        var CreateEvents = function (events) {
            if (events && events.length > 0) {

                var calEvent;
                _eventsLength = events.length;
                for (var i = 0; i < events.length; i++) {
                    calEvent = events[i];
                    if (window.plugins && window.plugins.calendar) {
                        var calOptions = window.plugins.calendar.getCalendarOptions(); // grab the defaults
                        calOptions.firstReminderMinutes = calEvent.reminder; // default is 60, pass in null for no reminder (alarm)

                        window.plugins.calendar.createEventWithOptions(calEvent.title, 'Cal', calEvent.notes, calEvent.fromDate, calEvent.toDate,
                            calOptions, createEventSuccess, createEventError);
                    }
                }

                return deferred.promise;
            }

            return null;
        }

        var _api = {
            CreateEvents: CreateEvents,
            DeleteEvent: DeleteEvent
        }

        return _api;
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .factory('$cameraService', cameraService);

    cameraService.$inject = ['$q', '$ionicPlatform', '$log', 'serverResponseService', 'followAppStorage'];

    function cameraService($q, $ionicPlatform, $log, serverResponseService, followAppStorage) {

        var _photos = [];

        //private methods
        var getPicture = function (args) {
            var q = $q.defer();
            $ionicPlatform.ready(function () {
                var baseCameraOptions = {
                    quality: 50,
                    //destinationType: Camera.DestinationType.DATA_URL,
                    destinationType: Camera.DestinationType.FILE_URI,
                    encodingType: Camera.EncodingType.JPEG,
                    targetWidth: 1500

                }
                if (device.platform != "Android") {
                    baseCameraOptions["targetWidth"] = 2448;
                    baseCameraOptions["targetHeight"] = 3264;
                }
                angular.extend(args.options, baseCameraOptions);

                navigator.camera.getPicture(function (imageURI) {
                    //if (device.platform != undefined && device.platform == 'Android') {
                    if (imageURI.substring(0, 21) == "content://com.android") {
                        var photoSplit = imageURI.split("%3A");
                        imageURI = "content://media/external/images/media/" + photoSplit[1];
                    }

                    convertToBase64(imageURI).then(function () {
                        q.resolve({ fileUrl: imageURI });
                        navigator.camera.cleanup();
                    }, function (errorDesc) {
                        q.reject({ display: true, desc: errorDesc });
                        navigator.camera.cleanup();
                    }).finally(function () {
                        deleteFile(imageURI);
                    });
                }, function (error) {
                    q.reject({ display: false, desc: error });
                }, args.options);
            });
            return q.promise;
        }

        var deleteFile = function (fileName) {

            var that = this;

            if (!fileName) {
                console.error("No fileName specified. File could not be deleted.");
                return false;
            }

            window.requestFileSystem(LocalFileSystem.TEMPORARY, 0, function (fileSystem) { // this returns the tmp folder 

                // File found
                fileSystem.root.getFile(fileName, { create: false }, function (fileEntry) {
                    fileEntry.remove(function (success) {
                        //console.log(success);
                    }, function (error) {
                        console.error("deletion failed: " + error);
                    });
                }, that.get('fail'));
            }, this.get('fail'));

        };


        var getPhotos = function () {
            var imageDataUrls = [];
            angular.forEach(_photos, function (value, key) {
                this.push(value.dataUrl);
            }, imageDataUrls);

            return imageDataUrls;
        }

        var clearPhotos = function () {
            _photos = [];
        }


        var convertToBase64 = function (imageURI) {

            var q = $q.defer();

            //window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, function (s) { }, function (e) { });
            window.requestFileSystem(LocalFileSystem.TEMPORARY, 0, function (s) { }, function (e) { });
            window.resolveLocalFileSystemURL(imageURI,
                // success callback; generates the FileEntry object needed to convert to Base64 string
                function (fileEntry) {

                    // convert to Base64 string
                    function win(file) {
                        var reader = new FileReader();
                        reader.onloadend = function (evt) {
                            var obj = evt.target.result; // this is your Base64 string
                            var img = obj.substring(obj.indexOf('base64,') + 7);
                            var numOfPic = followAppStorage.GetNumPicToDoc() + _photos.length;
                            if (numOfPic < followAppStorage.GetMaxPhotosPerDocument()) {
                                _photos.push({ dataUrl: img });
                                q.resolve();
                            } else {
                                errorDesc = "הגעת למספר תמונות מקסימלי שביכולתך לעלות";
                                q.reject(errorDesc);
                                //serverResponseService.GenricError("הגעת למספר תמונות מקסימלי שביכולתך לעלות");
                            }

                        };
                        reader.readAsDataURL(file);
                    };

                    var fail = function (evt) { };

                    fileEntry.file(function (fileObj) {
                        var fileSizeInMB = fileObj.size / 1000000;
                        if (fileSizeInMB < parseInt(followAppStorage.GetMaxVolumePerPhoto())) {
                            fileEntry.file(win, fail);
                        } else {
                            errorDesc = "גודל התמונה עולה על הגודל המקסימלי לצילום תמונה";
                            q.reject(errorDesc);
                            //serverResponseService.GenricError("גודל התמונה עולה על הגודל המקסימלי לצילום תמונה");
                        }
                    });

                },
                // error callback
                function () { }
            );
            return q.promise;
        }

        //public methods
        var openCamera = function () {
            //Camera - phonegap enum
            if (typeof (Camera) != 'undefined') {
                // setup device option for using device camera api
                var cameraOptions = {
                    sourceType: Camera.PictureSourceType.CAMERA,
                };

                var args = { options: cameraOptions };
                return getPicture(args);
            } else {
                $log.error('openCamera can`t find Phonegap Camera enum');
            }
        }

        var openGallery = function () {
            //Camera - phonegap enum
            if (typeof (Camera) != 'undefined') {
                // setup device option for using device gallery api
                var cameraOptions = {
                    sourceType: Camera.PictureSourceType.SAVEDPHOTOALBUM,
                    mediaType: Camera.MediaType.PICTURE
                };

                var args = { options: cameraOptions };
                return getPicture(args);
            } else {
                $log.debug('openGallery can`t find Phonegap Camera enum');
            }
        }

        var _api = {
            openGallery: openGallery,
            openCamera: openCamera,
            getPhotos: getPhotos,
            clearPhotos: clearPhotos
        }

        return _api;
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .factory('dateChangeFormatService', dateChangeFormatService);

    function dateChangeFormatService() {
        var regex_date_yyyy_mm_dd = /^\d{4}\-\d{1,2}\-\d{1,2}$/;
        var regex_date_mm_dd_yyyy = /(0[1-9]|1[012])[- \/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\d\d/;
        var regex_date_dd_mm_yyyy = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;

        function _fixDateForValidity(dateToFix) {
            var fixedDate;
            if (!dateToFix || dateToFix == '')
                return dateToFix;

            fixedDate = dateToFix.split('-');
            var temp = fixedDate[0];
            fixedDate[0] = fixedDate[2];
            fixedDate[2] = temp;
            return fixedDate.join('-');
        }

        return {
            fixDateForValidity: _fixDateForValidity,
            fixDate: function (value) {
                //console.log("before " + value);

                if (regex_date_dd_mm_yyyy.test(value)) {
                    value = moment(value, 'DD-MM-YYYY').format('YYYY-MM-DD');
                    return value;
                } else if (regex_date_mm_dd_yyyy.test(value)) {
                    value = moment(value, 'MM-DD-YYYY').format('YYYY-MM-DD');
                    return value;
                } else {
                    return value;
                }
            },
            fixDate4Search: function (value) {

                if (regex_date_dd_mm_yyyy.test(value)) {
                    value = moment(value, 'DD-MM-YYYY').format('DD-MM-YYYY');
                    return value;
                } else if (regex_date_mm_dd_yyyy.test(value)) {
                    value = moment(value, 'MM-DD-YYYY').format('DD-MM-YYYY');
                    return value;
                } else if (regex_date_yyyy_mm_dd.test(value)) {
                    value = moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY');
                    return value;
                } else {
                    return value;
                }
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .factory('$dialogService', dialogService);

    dialogService.$inject = ['$ionicPopup'];

    function dialogService($ionicPopup) {

        var modalArray = [];

        var showPopup = function (args) {
            //var deferred = $q.defer();
            args.buttons = [];
            args.buttons.push({
                text: args.actionText,
                type: 'followapp-button-left',
                onTap: function (e) {
                    if (angular.isFunction(args.actionCallback)) {
                        {
                            if (args.actionCallback() == false) {
                                e.preventDefault();
                            }
                            return true;
                        }
                    }

                    return true;
                }
            });

            if (args.cancelText) {
                args.buttons.push({
                    text: args.cancelText,
                    type: 'followapp-button-right',
                    onTap: function (e) {
                        if (angular.isFunction(args.cancelCallback)) {
                            args.cancelCallback();
                        }
                        return true;
                    }
                });
            }

            var popupOption = {
                cssClass: !args.cssClass ? 'followapp-popup' : args.cssClass,
                buttons: args.buttons,
                scope: args.scope
            };

            if (args.buttons.length == 1) {
                popupOption.cssClass = 'followapp-popup one-button';
            }

            if (args.templateText) {
                popupOption.template = args.templateText;

            } else {
                popupOption.templateUrl = args.template;
            }

            var popup = $ionicPopup.show(popupOption);

            modalArray.push(popup);
            return modalArray.length - 1;
            //return deferred.promise;
        }

        var showGenericPopup = function (args) {
            args.templateText = '<div class="followapp-dialog followapp-trash-dialog"><div>' +
                '<div class="followapp-popup-header"><span></span></div>' +
                '<div class="followapp-popup-subheader"><span>' + args.text + '</span></div></div>';
            return showPopup(args);
        }

        var showEmailPopup = function (args) {
            args.template = 'app/followapp/templates/DialogEMailTemplate.html';
            return showPopup(args);
        }

        var showTrashPopup = function (args) {
            args.template = 'app/followapp/templates/DialogDeleteTemplate.html';

            return showPopup(args);
        }
        var showValidationPopup = function (args) {
            args.template = 'app/followapp/templates/DialogValidationTemplate.html';

            return showPopup(args);
        }

        var _api = {
            showEmailPopup: showEmailPopup,
            showTrashPopup: showTrashPopup,
            showValidationPopup: showValidationPopup,
            showGenericPopup: showGenericPopup
        }

        return _api;
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .factory('documentService', documentService);

    documentService.$inject = ['followAppStorage', '$state'];

    function documentService(followAppStorage, $state) {
        var _currentDocs = [];
        var _currentDocument;
        var _freeSearch = null;
        var _currentCategory;

        var getDocs = function (categoryId) {

            var docs = [];
            if (categoryId)
                docs = getCategoryDocuments(categoryId);
            else
                docs = followAppStorage.GetAllDocuments();

            return docs;
        }

        var getCategoryDocuments = function (id) {
            var categoryId;

            if (id)
                categoryId = id;
            else
                categoryId = $state.current.params.CategoryId;

            var docs = followAppStorage.GetAllDocuments();
            var result = null;
            if (docs) {
                result = docs.filter(function (d) {
                    return d.CategoryId == categoryId;
                });
            }

            return result;
        }

        return {
            CurrentCategory: function (category) {
                if (category || angular.isDefined(category))
                    _currentCategory = category;

                return _currentCategory;
            },
            GetCategoryDocuments: function (id) {
                return getCategoryDocuments(id);
            },
            GetCategoryById: function (id) {
                var result = followAppStorage.GetSummary().filter(function (d) {
                    return d.CategoryId == id;
                });

                if (result && result.length === 1)
                    return result[0];

                return null;
            },
            GetDocumentsByCreationDateRange: function (fromDate, toDate, categoryId) {

                var docs = getDocs(categoryId);
                var result = docs.filter(function (d) {
                    var creationDate = moment(d.CreationDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
                    return creationDate >= fromDate && creationDate <= toDate;
                });

                return result;
            },
            GetDocumentsByValidityDateRange: function (fromDate, toDate, categoryId) {

                var docs = getDocs(categoryId);
                var result = docs.filter(function (d) {
                    var ValidityDate = moment(d.ValidityDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
                    return ValidityDate >= fromDate && ValidityDate <= toDate;
                });

                return result;
            },
            GetBranchDocuments: function (branchId) {

                var docs = getDocs(null);
                var result = docs.filter(function (d) {
                    return d.BranchId == branchId;
                });

                return result;
            },
            GetDocumentsByAmountRange: function (minAmount, maxAmount, categoryId) {

                var docs = getDocs(categoryId);
                var result = docs.filter(function (d) {
                    return d.Amount >= minAmount && d.Amount <= maxAmount;
                });

                return result;
            },
            GetDocumentsByName: function (name, categoryId) {

                var docs = getDocs(categoryId);
                var result = docs.filter(function (d) {
                    return d.DocumentName.indexOf(name) > -1;
                });

                return result;
            },
            CurrentDocument: function (document) {
                if (document)
                    _currentDocument = document;

                return _currentDocument;
            },
            CurrentDocuments: function (docs) {
                if (docs)
                    _currentDocs = docs;

                return _currentDocs;
            },
            setFreeSearch: function (value) {
                return _freeSearch = value;
            },
            getFreeSearch: function () {
                return _freeSearch;
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .factory('$followAppConnection', followAppConnection);

    followAppConnection.$inject = ['connection'];

    function followAppConnection(connection) {

        var urlPrefix = 'api/calFollowApp/';

        return {
            GetDocumentInfo: function () {

                return connection.genericConnection('GET', urlPrefix + 'GetDocumentInfo?', connection.versionAndOSParams);
            },
            UpdateDocument: function (data) {

                return connection.genericConnection('POST', urlPrefix + 'SetDocumentChanges?', connection.versionAndOSParams, data);
            },
            SaveNewDocument: function (data) {

                return connection.genericConnection('POST', urlPrefix + 'SaveNewDocument?', connection.versionAndOSParams, data);
            },
            DeleteDocument: function (data) {

                return connection.genericConnection('POST', urlPrefix + 'DeleteDocument?', connection.versionAndOSParams, data);
            },
            MetaData: function () {
                return connection.genericConnection('GET', urlPrefix + 'GetMetaData?', connection.versionAndOSParams);
            },
            GetDocumentPhoto: function (docId, photoId) {

                return connection.genericConnection('GET', urlPrefix + 'GetDocumentPhoto?docId=' + docId + '&photoId=' + photoId + '&', connection.versionAndOSParams);
            },
            DeletePhoto: function (data) {

                return connection.genericConnection('POST', urlPrefix + 'DeletePhoto?', connection.versionAndOSParams, data);
            },
            SendEmail: function (data) {

                return connection.genericConnection('POST', urlPrefix + 'SendEmail?', connection.versionAndOSParams, data);
            }
        }

    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .factory('followAppStorage', followAppStorage);

    followAppStorage.$inject = ['$angularCacheFactory'];

    function followAppStorage($angularCacheFactory) {

        var cache = $angularCacheFactory('followAppCache');
        return {
            GetSummary: function () {
                return cache.get('CatagorySummary');
            },
            SetSummary: function (value) {
                cache.put('CatagorySummary', value);
            },
            SetAllDocuments: function (value) {
                cache.put('Documents', value);
            },
            GetAllDocuments: function () {
                return cache.get('Documents');
            },
            SetPictureToSee: function (value) {
                cache.put('BigPicture', value);
            },
            GetPictureToSee: function () {
                return cache.get('BigPicture');
            },
            SetBranches: function (value) {
                cache.put('Branches', value);
            },
            GetBranches: function () {
                return cache.get('Branches');
            },
            SetCatagories: function (value) {
                cache.put('Catagories', value);
            },
            GetCatagories: function () {
                return cache.get('Catagories');
            },
            SetCurerncies: function (value) {
                cache.put('Curerncies', value);
            },
            GetCurerncies: function () {
                return cache.get('Curerncies');
            },
            GetReminderDate: function () {
                return cache.get('ReminderDate');
            },
            SetReminderDate: function (value) {
                cache.put('ReminderDate', value);
            },
            GetValidityDate: function () {
                return cache.get('ValidityDate');
            },
            SetValidityDate: function (value) {
                cache.put('ValidityDate', value);
            },
            GetNumPicToDoc: function () {
                return cache.get('NumPicToDoc');
            },
            SetNumPicToDoc: function (value) {
                cache.put('NumPicToDoc', value);
            },
            SetMaxVolumePerPhoto: function (value) {
                cache.put('MaxVolumePerPhoto', value);
            },
            GetMaxVolumePerPhoto: function (value) {
                return cache.get('MaxVolumePerPhoto');
            },
            SetMaxPhotosPerDocument: function (value) {
                cache.put('MaxPhotosPerDocument', value);
            },
            GetMaxPhotosPerDocument: function (value) {
                return cache.get('MaxPhotosPerDocument');
            },
            SetMaxDocumentsPerCustomer: function (value) {
                cache.put('MaxDocumentsPerCustomer', value);
            },
            GetMaxDocumentsPerCustomer: function (value) {
                return cache.get('MaxDocumentsPerCustomer');
            },
            DestroyCache: function () {
                $angularCacheFactory.clearAll();
            }

        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .factory('$headerService', headerService);

    headerService.$inject = ['$rootScope', '$log', '$timeout', '$location', 'documentService', '$stateParams', '$state'];

    function headerService($rootScope, $log, $timeout, $location, documentService, $stateParams, $state) {

        var defaultCallback = function (args) {
            var view = 'dw.followApp-searchDoc';
            if (args.button == 'left') { //switch to search view

            }

            $state.go(view, { CategoryId: $stateParams.CategoryId });
        }

        var editCallback = function (args) {
            if (args.button == 'left') { //save                
                $rootScope.$broadcast('editDocument', null);
            }
        }

        var addCallback = function (args) {
            if (args.button == 'left') { //save                
                $rootScope.$broadcast('saveNewDocument', null);


            }
        }

        var searchCallback = function (args) {
            if (args.button == 'left') { //search redirect         
                if (args.categoryId)
                    $state.go('dw.followApp-searchDoc-CategoryId/' + args.categoryId);
                else
                    $state.go('dw.followApp-searchDoc');
            }
        }

        var docs;
        // var docs = documentService.GetCategoryDocuments();
        if (!$stateParams.CategoryId || $stateParams.CategoryId == "") {
            docs = null;
        } else {
            docs = documentService.GetCategoryDocuments($stateParams.CategoryId);
        }
        var numOfDocs = 0;
        if (docs != null)
            numOfDocs = docs.length;

        var settings = [];
        settings['default'] = { text: numOfDocs + ' מסמכים', headerClass: 'default-header', buttonsCallback: defaultCallback, disableLeftButton: false, displayButtons: true };
        settings['blankCaption'] = { text: '', buttonsCallback: defaultCallback, headerClass: 'default-header', disableLeftButton: false, displayButtons: true };
        settings['add'] = { text: 'הוספת מסמך', headerClass: 'followapp-add-header', leftText: 'שמור', disableLeftButton: false, buttonsCallback: addCallback, displayButtons: true };
        settings['edit'] = { text: 'עריכת מסמך', headerClass: 'followapp-edit-header', leftText: 'שמור', disableLeftButton: false, buttonsCallback: editCallback, displayButtons: true };
        settings['search'] = { text: 'חיפוש מתקדם', headerClass: 'followapp-search-header', buttonsCallback: searchCallback, displayButtons: false };
        settings['searchResult'] = { text: 'תוצאות חיפוש', headerClass: 'followapp-searchresult-header', displayButtons: true, buttonsCallback: defaultCallback };
        var currentSettings = settings['default'];

        var changeHeader = function (args) {
            $timeout(function () {
                if (typeof (args) === 'string') {
                    currentSettings = settings[args];
                    if (args === 'default') {
                        //var docs = documentService.GetCategoryDocuments();
                        var docs = documentService.GetCategoryDocuments($stateParams.CategoryId);
                        var numOfDocs = 0;
                        if (docs != null)
                            numOfDocs = docs.length;

                        currentSettings.disableLeftButton = numOfDocs === 0;

                        currentSettings.text = numOfDocs + ' מסמכים';
                    } else if (args === 'search') {
                        if ($stateParams.CategoryId) {
                            var category = documentService.GetCategoryById($stateParams.CategoryId);
                            currentSettings.text = 'חיפוש מתקדם - ' + category.CategoryName;
                        } else {
                            currentSettings.text = 'חיפוש מתקדם';
                        }
                    }
                } else
                    currentSettings = args;
                $rootScope.$broadcast('headerChange', currentSettings);
            }, 100);
        }

        var getSettings = function () {
            return currentSettings;
        }

        var _api = {
            changeHeader: changeHeader,
            getSettings: getSettings
        }

        return _api;
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .factory('$loadingService', loadingService);

    loadingService.$inject = ['$rootScope', '$ionicLoading'];

    function loadingService($rootScope, $ionicLoading) {
        var _instance;
        var _startTime;

        var show = function () {
            _instance = $ionicLoading.show({
                content: 'אנא המתן <i class="icon ion-loading-b"></i>',
                animation: 'fade-in',
                showBackdrop: true,
                maxwidth: 200
            });

            _startTime = new Date();
        }

        var hide = function () {
            var timeoutDelay = new Date() - _startTime;
            if (timeoutDelay < 300)
                timeoutDelay = 300;
            else
                timeoutDelay = 0;

            setTimeout(function () {
                $ionicLoading.hide();
            }, timeoutDelay);
        }

        var _api = {
            show: show,
            hide: hide
        }

        return _api;
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calFollowApp')
    .factory('parseTodayService', parseTodayService);

    function parseTodayService() {
        var now = new Date();
        var month = (now.getMonth() + 1);
        var day = now.getDate();
        if (month < 10)
            month = "0" + month;
        if (day < 10) day = "0" + day;
        var today = now.getFullYear() + '-' + month + '-' + day;
        return today;
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';

    angular.module('calFollowApp')
        .factory('serverResponseService', serverResponseService);

    serverResponseService.$inject = ['$q'];

    function serverResponseService($q) {
        var severity = {
            isSuccess: function (code) {
                return code.toUpperCase() === "S";
            },
            isInfo: function (code) {
                return code.toUpperCase() === "I";
            },
            isWarning: function (code) {
                return code.toUpperCase() === "W";
            },
            isError: function (code) {
                return code.toUpperCase() === "E";
            }
        }

        var GenricError = function (msg) {
            alertAction(msg);
        }

        var GeneralError = function () {
            alertAction('לא ניתן להשלים כרגע את הפעולה. אנא נסה שנית במועד מאוחר יותר');
        }

        var alertAction = function (message, dialogBox) {
            if (navigator.notification) {
                var deferred = $q.defer();

                var buttonName;
                if (dialogBox)
                    buttonName = dialogBox.OkButtonText;

                if (!buttonName) {
                    buttonName = 'סגור';
                }

                navigator.notification.alert(message, function () { deferred.resolve(); }, '', buttonName);
                return deferred.promise;
            } else {
                alert(message);
            }
        }

        var confirmAction = function (message, dialogBox) {
            if (navigator.notification) {
                var deferred = $q.defer();
                var buttons = [dialogBox.OkButtonText, dialogBox.CancelButtonText];
                navigator.notification.confirm(message, function (button) { deferred.resolve(button); }, '', buttons);
                return deferred.promise;
            } else {
                return confirm(message);
            }
        }

        var redirectToWallet = function (message, pendingView) {
            alertAction(message, pendingView);
        }

        var Translator = {
            GetDocumentInfo: {
                response: function (response) {
                    var _response = response,
                        _statusSeverity = response.Status.SeverityCode,
                        _statusNumber = parseInt(response.Status.SeverityNumber);


                    response.DialogBox = { Content: 'text', OkButtonText: 'ok text', CancelButtonText: 'cancel text' };

                    if (severity.isSuccess(_statusSeverity)) {
                        return angular.extend(_response, { success: true });
                    } else if (severity.isWarning(_statusSeverity)) {
                        var actionCallBack;
                        var pendingView;
                        if ([1, 2, 3].indexOf(_statusNumber) > -1) {
                            actionCallBack = redirectToWallet;
                            pendingView = 'dw.lobby';
                        } else {
                            actionCallBack = confirmAction;
                            pendingView = 'dw.login';
                        }

                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: actionCallBack, pendingView: pendingView });
                    } else if (severity.isError(_statusSeverity) && _statusNumber == 1) {
                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: confirmAction, pendingView: pendingView });
                    } else {
                        // fallback to default error 
                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: confirmAction, pendingView: pendingView });
                    }
                }
            },
            UpdateDocument: {
                response: function (response) {
                    var _response = response,
                        _statusSeverity = response.Status.SeverityCode,
                        _statusNumber = parseInt(response.Status.SeverityNumber);


                    response.DialogBox = { Content: 'text' };

                    if (severity.isSuccess(_statusSeverity)) {
                        return angular.extend(_response, { success: true });
                    } else if (severity.isWarning(_statusSeverity)) {
                        var actionCallBack;
                        var pendingView;
                        if ([1, 2, 3, 5, 7, 8, 9].indexOf(_statusNumber) > -1) {
                            actionCallBack = alertAction;
                        } else {
                            actionCallBack = confirmAction;
                        }

                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: actionCallBack });
                    } else if (severity.isError(_statusSeverity) && _statusNumber == 1) {
                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: confirmAction });
                    } else {
                        // fallback to default error 
                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: confirmAction });
                    }
                }
            },
            SaveNewDocument: {
                response: function (response) {
                    var _response = response,
                        _statusSeverity = response.Status.SeverityCode,
                        _statusNumber = parseInt(response.Status.SeverityNumber);

                    response.DialogBox = { Content: response.DialogBox.Content, OkButtonText: response.DialogBox.OkButton, CancelButtonText: response.DialogBox.CancelButton };

                    if (severity.isSuccess(_statusSeverity)) {
                        return angular.extend(_response, { success: true, message: response.DialogBox.Content, action: confirmAction });
                    } else if (severity.isWarning(_statusSeverity)) {
                        var actionCallBack;
                        var pendingView;
                        var isRetry = false;
                        if ([1, 2, 3, 4, 5, 7, 8, 12, 13].indexOf(_statusNumber) > -1) {
                            actionCallBack = alertAction;
                        } else {
                            actionCallBack = confirmAction;
                        }

                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: actionCallBack });
                    } else if (severity.isInfo(_statusSeverity) && _statusNumber == 1) {
                        return angular.extend(_response, { success: true, message: response.DialogBox.Content, action: confirmAction });
                    } else if (severity.isError(_statusSeverity) && _statusNumber == 1) {
                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: confirmAction });
                    } else {
                        // fallback to default error 
                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: confirmAction });
                    }
                }
            },
            DeleteDocument: {
                response: function (response) {
                    var _response = response,
                        _statusSeverity = response.Status.SeverityCode,
                        _statusNumber = parseInt(response.Status.SeverityNumber);


                    response.DialogBox = { Content: 'text' };

                    if (severity.isSuccess(_statusSeverity)) {
                        return angular.extend(_response, { success: true });
                    } else if (severity.isWarning(_statusSeverity)) {
                        var actionCallBack;
                        var pendingView;

                        if ([1, 2, 3, 5].indexOf(_statusNumber) > -1) {
                            actionCallBack = alertAction;
                        } else {
                            actionCallBack = confirmAction;
                        }

                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: actionCallBack });
                    } else if (severity.isError(_statusSeverity) && _statusNumber == 1) {
                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: confirmAction });
                    } else {
                        // fallback to default error 
                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: confirmAction });
                    }
                }
            },
            DeletePhoto: {
                response: function (response) {
                    var _response = response,
                        _statusSeverity = response.Status.SeverityCode,
                        _statusNumber = parseInt(response.Status.SeverityNumber);

                    response.DialogBox = { Content: 'text', OkButtonText: 'ok text', CancelButtonText: 'cancel text' };

                    if (severity.isSuccess(_statusSeverity)) {
                        return angular.extend(_response, { success: true });
                    } else if (severity.isWarning(_statusSeverity)) {
                        var actionCallBack;
                        var pendingView;
                        if ([1, 2, 3, 5].indexOf(_statusNumber) > -1) {
                            actionCallBack = alertAction;
                        } else {
                            actionCallBack = confirmAction;
                        }

                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: actionCallBack });
                    } else if (severity.isError(_statusSeverity) && _statusNumber == 1) {
                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: confirmAction });
                    } else {
                        // fallback to default error 
                        return angular.extend(_response, { success: false, message: response.DialogBox.Content, action: confirmAction });
                    }
                }
            }
        }

        var _api = {
            Translator: Translator,
            GeneralError: GeneralError,
            GenricError: GenricError
        }

        return _api;
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb', []);
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb').config(cellebRoute);

    cellebRoute.$inject = ['$stateProvider'];

    function cellebRoute($stateProvider) {
        $stateProvider
            .state('dw.celeb-home', {
                url: "/benefits/celeb/home",
                views: {
                    'contentBody': {
                        templateUrl: "app/celleb/templates/home.html",
                        controller: "clbHomeCtrl"
                    }
                }
            })
            .state('dw.celeb-biz-details', {
                url: "/benefits/celeb/home/:bizId",
                views: {
                    'contentBody': {
                        templateUrl: "app/celleb/templates/bizDetails.html",
                        controller: "clbBizDetailsCtrl"
                    }
                }
            })
            .state('dw.celeb-prepay', {
                url: "/benefits/celeb/prepay/",
                views: {
                    'contentBody': {
                        templateUrl: "app/celleb/templates/prepay.html",
                        controller: "clbPrepayCtrl"
                    }
                }
            })
            .state('dw.celeb-payment', {
                url: "/benefits/celeb/payment",
                views: {
                    'contentBody': {
                        templateUrl: "app/celleb/templates/payment.html",
                        controller: "clbPaymentCtrl"
                    }
                }
            });
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
    .controller('clbBizDetailsCtrl', clbBizDetailsCtrl);

    clbBizDetailsCtrl.$inject = [
        '$scope', 'appData', 'errorService', 'lobbyUiService', 'googleAnalyticsService', 'clbData', 'clbRestService'
    ];

    function clbBizDetailsCtrl($scope, appData, errorService, lobbyUiService, googleAnalyticsService, clbData, clbRestService) {

        $scope.clbData = clbData;

        $scope.data = {
            categories: '',
            promotionsDetails: {}
        }

        $scope.init = function () {

            if (!$scope.clbData.selectedBiz) {
                return;
            }

            googleAnalyticsService.insertEvent({ page: 'restaurant details', eventName: 'restaurant details - enter', action: 'enter' });

            $scope.setCategories();

            if ($scope.clbData.selectedBiz.promo_id && $scope.clbData.selectedBiz.promo_id > $scope.clbData.metaData.CellebNull) {
                $scope.getPromotionsDetails();
            }
        };

        $scope.goToPayment = function () {
            googleAnalyticsService.insertEvent({ page: 'restaurant details', eventName: 'go to code generator', action: 'click' });


            lobbyUiService.navigate('dw.celeb-prepay', { restrictedExplicitly: true });
        }

        $scope.getPromotionsDetails = function () {

            clbRestService.getPromotionsDetails(clbData.selectedBiz.biz_id).then(function (response) {
                $scope.data.promotionsDetails = response.promotionsDetails;
            });
        }

        $scope.setCategories = function () {
            if ($scope.clbData.selectedBiz.tags_list) {
                $scope.clbData.selectedBiz.tags_list.forEach(function (obj) {
                    $scope.data.categories += obj + ', ';
                });

                $scope.data.categories = $scope.data.categories.slice(0, -2);
            }
        }

        $scope.init();
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
    .controller('clbHomeCtrl', clbHomeCtrl);

    clbHomeCtrl.$inject = [
        '$scope', 'appData', 'errorService', 'lobbyUiService', 'googleAnalyticsService', 'clbRestService', '_', 'clbData', 'clbPopUpService', 'clbCacheService',
        'clbGeoService', '$ionicScrollDelegate', '$timeout'
    ];

    function clbHomeCtrl($scope, appData, errorService, lobbyUiService, googleAnalyticsService, clbRestService, _, clbData, clbPopUpService, clbCacheService,
        clbGeoService, $ionicScrollDelegate, $timeout) {
        
        $scope.clbData = clbData;

        var fromCache = clbCacheService.sessionStorage.get('clbSearchState');

        if (fromCache)
            $scope.data = fromCache;
        else {


            $scope.data = {
                filterKey: '',
                totalRows: 0,
                searchResults: {},
                selectedLocation: {},
                currentPageNum: 0,
                searchData: {},
                canLoadMore: false,
                scrollPos: 0,
                remainedMe: false
            }
        }

        // Put any unique ID here.  The point of this is: every time the controller is recreated
        // we want to load the correct remembered scroll values.
        //delegate.rememberScrollPosition('search-scroll-handler');

        var useCache = false;

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {

            useCache = fromState && fromState.name.indexOf('dw.celeb') >= 0;

            if (useCache) {
                //console.log('use cache');
            } else {
                //console.log('clear cache');
                clbCacheService.sessionStorage.remove('clbSearchState');

                $scope.data = {
                    filterKey: '',
                    totalRows: 0,
                    searchResults: {},
                    selectedLocation: {},
                    currentPageNum: 0,
                    searchData: {},
                    canLoadMore: false,
                    scrollPos: 0,
                    remainedMe: false
                }
            }

            if (!$scope.clbData.metaData) {
                clbRestService.getMetaData().then(function (response) {
                    $scope.clbData.metaData = response;
                    $scope.init();
                }, function (error) {
                    errorService.handleError(error);
                }
                );
            } else {
                $scope.init();
            }


        });

        $scope.init = function () {

            lobbyUiService.loader.hide();

            googleAnalyticsService.insertEvent({ page: 'choose restaurant', eventName: 'choose restaurant - enter', action: 'enter' });

            $scope.clbData.metaData.CellebLocations = _.sortBy($scope.clbData.metaData.CellebLocations, function (obj) {
                return obj.idx;
            });

            $scope.data.remainedMe = clbCacheService.localStorage.get('dotNotRemainedMe');

            var initSearchPage = function () {

                if (useCache && clbCacheService.sessionStorage.get('clbSearchState')) {
                    //delegate.scrollToRememberedPosition();

                } else {

                    lobbyUiService.loader.show();

                    clbGeoService.getSelfLocation().then(function (geoData) {
                        $scope.data.searchData.isGpsOn = true;
                        //console.log('GPS ON!');
                        $scope.data.searchData.selfLatitude = geoData.coords.latitude;
                        $scope.data.searchData.selfLongitude = geoData.coords.longitude;
                        $scope.data.selectedLocation = $scope.getNearMeLocation();
                    }, function () {

                        //console.log('GPS OFF!');

                        clbPopUpService.geoServiceInfo();

                        $scope.data.selectedLocation = $scope.getDefaultLocation();
                    });
                }

                angular.element('ion-view.content-view section.clb-home-container .clb-serach-output-container').ready(function () {

                    var navHeight = parseFloat(angular.element('ion-nav-bar.content-header').outerHeight());

                    var searchbarHeight = parseFloat(angular.element('ion-view.content-view section.clb-home-container .clb-search-container').outerHeight());

                    var deviceHeight = parseFloat(angular.element(this).height());

                    var newHeight = parseInt(Math.ceil(deviceHeight - searchbarHeight - navHeight)) + 1;

                    angular.element('ion-view.content-view section.clb-home-container .clb-serach-output-container').css('height', newHeight);
                });
            };

            if (!useCache && (!$scope.data.remainedMe || $scope.data.remainedMe == false)) {
                clbPopUpService.infoPage($scope).then(function (checked) {

                    googleAnalyticsService.insertEvent({ page: 'show help', eventName: 'next - leave help', action: 'click' });

                    if (checked && checked == true) {
                        googleAnalyticsService.insertEvent({ page: 'show help', eventName: 'don’t show help', action: 'click' });
                        clbCacheService.localStorage.set('dotNotRemainedMe', true);
                    }

                    initSearchPage();
                });
            } else {
                initSearchPage();
            }

        };

        $scope.onFocus = function () {
        }

        $scope.onBlur = function () {
            //console.log('search blur!');
        }

        $scope.$watch('data.filterKey', function (newVal, oldVal) {
            if (newVal != oldVal && (newVal == '' || newVal.length >= 3))
                $scope.search(newVal);
        });

        $scope.$watch('data.selectedLocation', function (newVal, oldVal) {
            if (newVal != oldVal && ($scope.data.filterKey == '' || $scope.data.filterKey.length >= 3))
                $scope.search($scope.data.filterKey);
        });


        $scope.getNearMeLocation = function () {
            return _.find($scope.clbData.metaData.CellebLocations, function (x) { return x.location_id === 1; });
        }

        $scope.getDefaultLocation = function () {
            return _.find($scope.clbData.metaData.CellebLocations, function (x) { return x.location_id === 1020; });
        }

        //$scope.doRefresh = function () {
        //    console.log('refresh');
        //    $scope.$broadcast('scroll.refreshComplete');
        //}

        $scope.loadMore = function () {
            var pos = $ionicScrollDelegate.$getByHandle('resultsHandler').getScrollPosition();

            if (!pos)
                return;

            $scope.data.scrollPos = pos.top;

            if ($scope.data.scrollPos == 0)
                return;

            var maxScroll = $ionicScrollDelegate.$getByHandle('resultsHandler').getScrollView().getScrollMax().top;

            if ($scope.data.scrollPos < maxScroll)
                return;

            $scope.data.canLoadMore = true;

            $scope.data.currentPageNum++;

            if ($scope.data.searchData) {
                $scope.data.searchData.currentPageNum = $scope.data.currentPageNum;

                clbRestService.searchRest($scope.data.searchData).then(function (response) {

                    var results = $scope.proccessResults(response);

                    if (results.list && results.count > 0) {
                        $scope.updateResults(results, true);
                    }
                }, function (error) {
                    errorService.handleError(error);
                }).finally(function () {
                    lobbyUiService.loader.hide();
                    $scope.hideLoadMore();
                });
            }
        }

        $scope.hideLoadMore = function () {
            $timeout(function () {
                $scope.data.canLoadMore = false;
            }, 100);
        }

        ionic.on('native.keyboardshow', function (e) {
            //console.log('Keyboard height is: ' + e.keyboardHeight);

            var curHeight = $('.clb-serach-output-container').height();

            if (navigator) {
                if (navigator.userAgent.toLowerCase().indexOf('nexus 5') > 0) {
                    curHeight += 46;
                }
            }

            $('ion-content.scroll-design.ionic-scroll.has-header').height(curHeight - e.keyboardHeight);

        }, window);

        ionic.on('native.keyboardhide', function () {
            $('ion-content.scroll-design.ionic-scroll.has-header').css('height', 'auto');
        }, window);

        $scope.search = function (key) {
            
            $scope.data.searchData.prefix = key;

            $scope.data.currentPageNum = 0;

            $scope.data.searchData.radius = $scope.data.selectedLocation.radius;

            $scope.data.searchData.currentPageNum = $scope.data.currentPageNum;

            if ($scope.data.selectedLocation.location_id == 0 || $scope.data.selectedLocation.location_id == 1) {

                if (!$scope.data.searchData.isGpsOn) {
                    clbPopUpService.geoServiceInfo().then(function () {

                        $scope.data.selectedLocation = $scope.getDefaultLocation();
                    });
                    lobbyUiService.loader.hide();
                    return;
                }

                $scope.data.searchData.latitude = $scope.data.searchData.selfLatitude;

                $scope.data.searchData.longitude = $scope.data.searchData.selfLongitude;

            } else {

                $scope.data.searchData.latitude = $scope.data.selectedLocation.left_coord;

                $scope.data.searchData.longitude = $scope.data.selectedLocation.right_coord;

            }

            clbRestService.searchRest($scope.data.searchData).then(function (response) {

                var results = $scope.proccessResults(response);

                $scope.updateResults(results);

            }, function (error) {
                errorService.handleError(error);
            }).finally(function () {
                lobbyUiService.loader.hide();
                $scope.hideLoadMore();
            });
        }

        $scope.proccessResults = function (response) {

            var retVal = {};

            retVal.list = _.filter(response.ws_result.list, function (obj) {
                return ~obj.name.toLowerCase().indexOf($scope.data.searchData.prefix);
            });

            retVal.count = response.ws_result.head.count;

            if ($scope.data.searchData.isGpsOn) {
                var selfLocation = {
                    latitude: $scope.data.searchData.selfLatitude,
                    longitude: $scope.data.searchData.selfLongitude
                };

                return clbRestService.transform(retVal, selfLocation);

            } else {
                return clbRestService.transform(retVal);
            }
        }

        $scope.updateResults = function (response, append) {

            if (append) {
                $scope.data.searchResults.count += response.count;
                var concatedArray = $scope.data.searchResults.list.concat(response.list);
                $scope.data.searchResults.list = concatedArray;

            } else {
                $scope.data.searchResults = response;

                $timeout(function () {
                    $ionicScrollDelegate.$getByHandle('resultsHandler').scrollTop();
                }, 0);
            }

            clbCacheService.sessionStorage.set('clbSearchState', $scope.data);
        }

        $scope.selectBiz = function (index) {
            $scope.clbData.selectedBiz = $scope.data.searchResults.list[index];

            googleAnalyticsService.insertEvent({ page: 'celleb - search restaurant', eventName: 'choose restaurant Id: ' + $scope.clbData.selectedBiz.biz_id, action: 'click' });

            lobbyUiService.go('dw.celeb-biz-details', { bizId: $scope.clbData.selectedBiz.biz_id });
        }

        $scope.openLocationFilter = function () {
            clbPopUpService.locations($scope.clbData.metaData.CellebLocations).then(function (response) {
                if (response) {

                    lobbyUiService.loader.show();

                    if ($scope.data.searchData.isGpsOn) {
                        $scope.data.selectedLocation = response;
                    } else {
                        clbGeoService.getSelfLocation().then(function (geoData) {
                            $scope.data.searchData.isGpsOn = true;
                            //console.log('GPS ON!');
                            $scope.data.searchData.selfLatitude = geoData.coords.latitude;
                            $scope.data.searchData.selfLongitude = geoData.coords.longitude;
                        }).finally(function () {
                            $scope.data.selectedLocation = response;
                            googleAnalyticsService.insertEvent({ page: 'locations popup', eventName: 'Choose location ' + location_name, action: '' });
                        });
                    }
                }
            });
        }
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
.controller('clbPaymentCtrl', clbPaymentCtrl);

    clbPaymentCtrl.$inject = [
        '$scope', 'clbData', 'googleAnalyticsService', 'lobbyUiService'
    ];

    function clbPaymentCtrl($scope, clbData, googleAnalyticsService, lobbyUiService) {

        $scope.clbData = clbData;

        $scope.data = {
            time: 0,
            bgColor: '#9CD036'
        }

        if (!lobbyUiService.connection.isLoggedIn() || !$scope.clbData.paymentDetails) {
            lobbyUiService.navigate('dw.celeb-home');
            return;
        }

        $scope.init = function () {
            if ($scope.clbData.paymentDetails) {

                googleAnalyticsService.insertEvent({ page: 'display code', eventName: 'display code - enter', action: 'enter' });

                $scope.data.time = $scope.clbData.paymentDetails.CodeSecCountDown;

                $scope.data.circleText = $scope.buildTimeCircleText();
            }
        };

        $scope.buildTimeCircleText = function () {

            var parent = '<div class="time-circles-text">';

            parent += '<h1 class="clb-time-code">' + $scope.clbData.paymentDetails.PaymentCode + '</h1>';

            parent += '<h3 class="clb-start-date"><span class="text">שעת הזמנת הקוד </span><span class="time">' + moment($scope.clbData.paymentDetails.CodeGenTime).format('HH:mm') + '</span></h3>';

            parent += '<div class="clb-spacer"></div>';

            parent += '<h3 class="clb-end-date"><span class="text">תוקף עד לשעה</span><br/><span class="time">' + moment($scope.clbData.paymentDetails.CodeEndTime).format('HH:mm') + '</span></h3>';

            parent += '</div>';

            return parent;
        }

        $scope.init();
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
    .controller('clbPrepayCtrl', clbPrepayCtrl);

    clbPrepayCtrl.$inject = [
        '$scope', 'appData', 'errorService', 'lobbyUiService', 'googleAnalyticsService', '$ionicSlideBoxDelegate', 'clbRestService', '$timeout', 'clbPopUpService',
        'clbCacheService', 'clbData'
    ];

    function clbPrepayCtrl($scope, appData, errorService, lobbyUiService, googleAnalyticsService, $ionicSlideBoxDelegate, clbRestService, $timeout, clbPopUpService,
        clbCacheService, clbData) {

        $scope.appData = appData;

        $scope.clbData = clbData;

        $scope.data = {
            remainedMe: clbCacheService.localStorage.get('dotNotRemainedMe')
        }

        $scope.account = {
            bankAccounts: [],
            currentAccountIndex: 0,
            currentCardIndex: 0,
            showSlider: true
        }

        $scope.init = function () {

            if (!lobbyUiService.connection.isLoggedIn()) {
                lobbyUiService.go('dw.login', { nextPage: "dw.celeb-prepay" });
                return;
            } else {
                googleAnalyticsService.insertEvent({ page: 'generate code', eventName: 'generate code - enter', action: 'enter' });

                if (!$scope.clbData.metaData) {
                    clbRestService.getMetaData().then(function (response) {
                        $scope.clbData.metaData = response;
                        $scope.initPage();
                    }, function (error) {
                        errorService.handleError(error);
                    }
                    );
                } else {
                    $scope.initPage();
                }
            }
        };

        $scope.initPage = function () {
            if (!$scope.appData.BankAccounts) {
                clbRestService.getBankAccounts().then(function (accounts) {

                    $scope.account.bankAccounts = accounts;

                    $scope.updateAccountSlider(0).then(function () {
                        $scope.updateCardSlider(0);
                    });

                }, function (error) {
                    errorService.handleError(error);
                    return;
                });
            } else {
                $scope.account.bankAccounts = clbRestService.filteredBankAccounts($scope.appData.BankAccounts);
                $scope.updateAccountSlider(0).then(function () {
                    $scope.updateCardSlider(0);
                });
            }
        }

        $scope.hasAccount = function () {
            return $scope.account.bankAccounts && $scope.account.bankAccounts.length > 0;
        }

        $scope.accountNext = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').next();

            }, 500);

            $scope.$on("$destroy", function () {
                $timeout.cancel(_promise);
            });
        }

        $scope.accountPrev = function () {

            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').previous();

            }, 500);

            $scope.$on("$destroy", function () {
                $timeout.cancel(_promise);
            });
        }

        $scope.accountSlideChange = function (index) {

            $scope.account.showSlider = false;

            $scope.account.currentAccountIndex = index;

            $scope.updateCardSlider(0);
        }

        $scope.cardSlideChange = function (index) {
            $scope.account.currentCardIndex = index;
        }

        $scope.updateAccountSlider = function (index) {
            var _promise = $timeout(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').update();
            }, 200).then(function () {
                $ionicSlideBoxDelegate.$getByHandle('accountHandler').slide(index);
                $scope.account.showSlider = true;
            });

            $scope.$on("$destroy", function () {
                $timeout.cancel(_promise);
            });

            return _promise;
        }

        $scope.updateCardSlider = function (index) {
            var _promise = $timeout(function () {

                $ionicSlideBoxDelegate.$getByHandle('cardsHandler').update();

            }, 500).then(function () {
                $ionicSlideBoxDelegate.$getByHandle('cardsHandler').slide(index);
                $scope.account.showSlider = true;
            }).finally(function () {
                $scope.slideBoxReady = true;
                lobbyUiService.loader.hide();
            });

            $scope.$on("$destroy", function () {
                $timeout.cancel(_promise);
            });

            return _promise;
        }

        $scope.to = function (index) {
            $ionicSlideBoxDelegate.$getByHandle('cardsHandler').slide(index);
        }

        $scope.goToCustomerService = function () {
            lobbyUiService.go('dw.service-home');
        }

        $scope.openInfoPage = function () {

            $scope.data.remainedMe = clbCacheService.localStorage.get('dotNotRemainedMe');

            clbPopUpService.infoPage($scope).then(function (checked) {

                googleAnalyticsService.insertEvent({ page: 'show help', eventName: 'next - leave help', action: 'click' });

                if (checked && checked == true) {
                    googleAnalyticsService.insertEvent({ page: 'show help', eventName: 'don’t show help', action: 'click' });
                }

                clbCacheService.localStorage.set('dotNotRemainedMe', checked);
            });
        }

        $scope.genratePaymentCode = function () {
            lobbyUiService.loader.show();
            clbRestService.genratePaymentCode({
                SessionId: '11111111',
                UniqueCardNum: $scope.account.bankAccounts[$scope.account.currentAccountIndex].Cards[$scope.account.currentCardIndex].Id
            }).then(function (response) {
                $scope.clbData.paymentDetails = response;
                googleAnalyticsService.insertEvent({ page: 'generate code', eventName: 'generat code - confirm', action: 'click' });
                lobbyUiService.go('dw.celeb-payment');
            }, function (error) {
                errorService.handleError(error);
            }).finally(function () {
                lobbyUiService.loader.hide();
            });
        }

        $scope.init();
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
    .directive("clbAccountSlider", clbAccountSlider);

    function clbAccountSlider() {
        return {
            templateUrl: 'app/celleb/templates/clbAccounts.html',
            restrict: 'A',
            replace: true
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
    .directive("clbCardSlider", clbCardSlider);

    function clbCardSlider() {
        return {
            templateUrl: 'app/celleb/templates/clbCards.html',
            restrict: 'A',
            replace: true,
            link: function postLink(scope, iElement, iAttrs) {
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
.directive("clbFooter", clbFooter);

    clbFooter.$inject = ['$timeout', 'lobbyUiService', 'googleAnalyticsService', '$window'];

    function clbFooter($timeout, lobbyUiService, googleAnalyticsService, $window) {
        return {
            templateUrl: 'app/celleb/templates/clbFooter.html',
            restrict: 'AE',
            replace: true,
            link: function (scope, element, attrs) {

                scope.callBiz = function () {
                    googleAnalyticsService.insertEvent({ page: 'restaurant details', eventName: 'call restaurant', action: 'click' });
                }

                scope.navigateWaze = function () {

                    var lat = scope.clbData.selectedBiz.latitude;

                    var lon = scope.clbData.selectedBiz.longitude;

                    var wazeUrl = 'waze://?ll=' + lat + ',' + lon + '&navigate=yes';

                    googleAnalyticsService.insertEvent({ page: 'restaurant details', eventName: 'navigate to restaurant', action: 'click' });

                    if (device)
                    {
                        if (device.platform == "Android") {
                            navigator.startApp.check("com.waze", function () { /* success */
                                window.open(wazeUrl, '_system', 'location=yes');
                            },
                                function (error) { /* error */
                                    //console.log(error);
                                    lobbyUiService.openExternal("market://details?id=com.waze");
                                });
                        } else {
                            navigator.startApp.check("waze://", function () { /* success */
                                window.open(wazeUrl, '_system', 'location=yes');
                                //lobbyUiService.openExternal(wazeUrl);
                            },
                            function (error) { /* error */
                                //console.log(error);
                                lobbyUiService.openExternal("http://itunes.apple.com/us/app/id323229106");
                            });
                        }
                    }
                    
                }

                scope.setFooterHeight = function () {

                    if (!scope.clbData.selectedBiz)
                        return;

                    var elements = 1;

                    if (scope.clbData.selectedBiz.phone_number) {
                        var phone = scope.clbData.selectedBiz.phone_number.split('/');
                        //get first number
                        phone = phone[0];
                        elements++;
                    }

                    if (scope.clbData.selectedBiz.address) {
                        elements++;
                    }

                    //var currBizDetailsHeight = parseFloat(angular.element('.clb-biz-details').css('height'));
                    //var currFooterHeight = parseFloat(angular.element('.clb-footer-nav-container').css('height'));
                    //var newIconHeight = parseFloat(angular.element('.clb-footer-nav-container .clb-footer-nav > img').css('height'));

                    var currFooterHeight = parseFloat(angular.element($window).height()) * 0.45;

                    var currBizDetailsHeight = parseFloat(angular.element($window).height()) * 0.55;

                    var newFooterHeight = (currFooterHeight * elements / 3);

                    var headerHeight = parseFloat(angular.element('ion-nav-bar.content-header').css('height'));

                    angular.element('.clb-footer-nav').css('height', (100 / elements) + '%');

                    angular.element('.clb-biz-details').css('height', (currBizDetailsHeight + currFooterHeight - newFooterHeight - headerHeight) + 'px');

                    angular.element('.clb-footer-nav-container').css('height', newFooterHeight + headerHeight + 'px');

                    //angular.element('.clb-footer-nav-container .clb-footer-nav > img').css('height', newIconHeight * (1) + headerHeight / 2 + 'px');
                }

                $timeout(function () {
                    scope.setFooterHeight();
                }, 0);
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
    .directive("timeCircle", timeCircle);

    function timeCircle() {
        return {
            template: '<div id="countDownTimer"></div>',
            restrict: 'AE',
            replace: true,
            scope: {
                time: '=duration',
                color: '=color',
                text: '=text'
            },
            link: function postLink(scope, element, attrs) {

                $('#countDownTimer').ready(function () {

                    var timeCirclWeidth = 320;

                    if (window.innerWidth && window.innerWidth > 0) {
                        timeCirclWeidth = window.innerWidth;
                    }

                    $('#countDownTimer').css('width', timeCirclWeidth);

                    $('#countDownTimer').attr('data-timer', scope.time).TimeCircles({
                        "total_duration": scope.time,
                        "count_past_zero": false,
                        "start_angle": 0,
                        "animation": "smooth",
                        "bg_width": 0.02,
                        "fg_width": 0.02,
                        "time": {
                            "Days": {
                                "color": scope.color,
                                "show": false
                            },
                            "Hours": {
                                "color": scope.color,
                                "show": false
                            },
                            "Minutes": {
                                "color": scope.color,
                                "show": false
                            },
                            "Seconds": {
                                "color": scope.color,
                                "show": true
                            }
                        }
                    });

                    /*
                .addListener(function (unit, value, total) {

                    if (total <= 0) {
                        setTimeout(function () {
                            lobbyUiService.go('dw.celeb-prepay');
                        }, 3000);
                    }
                });
                */

                });

                $('.textDiv_Seconds').ready(function () {
                    $('.textDiv_Seconds').html(scope.text);
                });
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
    .factory('clbCacheService', clbCacheService);

    clbCacheService.$inject = ['$angularCacheFactory'];

    function clbCacheService($angularCacheFactory) {

        var clbCache = $angularCacheFactory('clbLocalStorage', {
            storageMode: 'localStorage'
        });

        var clbSessionCache = $angularCacheFactory('cellebCache');

        return {
            localStorage: {
                set: function (key, value) {
                    clbCache.put(key, value);
                },
                get: function (key) {
                    return clbCache.get(key);
                },
                remove: function (key) {
                    clbCache.remove(key);
                }
            },
            sessionStorage: {
                set: function (key, value) {
                    clbSessionCache.put(key, value);
                },
                get: function (key) {
                    return clbSessionCache.get(key);
                },
                remove: function (key) {
                    clbSessionCache.remove(key);
                }
            }
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
    .factory('clbConnectionService', clbConnectionService);

    clbConnectionService.$inject = ['$http', '$q', 'appSettings', '$timeout'];

    function clbConnectionService($http, $q, appSettings, $timeout) {

        var cellebFefaultError = [
            {
                response: {
                    Response: {
                        Status: {
                            SeverityCode: 'E',
                            SeverityNumber: '0001'
                        },
                        DialogBox: {
                            Content: 'בשל תקלה לא ניתן להשלים את הפעולה. יש לנסות מאוחר יותר',
                            Title: ' ',
                            OKButtonText: 'נסה שנית',
                            CancelButtonText: 'סגור'

                        }
                    }
                },
                action: "cellebHttp"
            }
        ];

        var _call = function (data, method, url) {

            var _defer = $q.defer();

            var baseurl = appSettings.cellebServer;

            
            if (appSettings.env === "DEV") {
                var response = { "status": "0", "msg": "OK", "ws_result": { "head": { "count": 15 }, "list": [{ "phone_number": "03-5724219", "synonym": null, "name": "\u05e7\u05e4\u05d4 \u05d2'\u05d5\u05dc\u05d9\u05d9\u05d8 - \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "address": "\u05ea\u05e4\u05d5\u05e6\u05d5\u05ea \u05d9\u05e9\u05e8\u05d0\u05dc 13 \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "chain_id": -1, "longitude": 34.814559000000003, "promo_id": 12125, "discount_type": "0", "biz_type": 311, "tags_list": null, "biz_id": 15885, "latitude": 32.059784000000001, "logo": "Res15885_4.jpg", "discount_val": -1, "description": "\u05e0\u05d9\u05ea\u05df \u05dc\u05e8\u05db\u05d5\u05e9 \u05e1\u05dc\u05d8\u05d9\u05dd, \u05e1\u05e0\u05d3\u05d5\u05d5\u05d9\u05e6\u05d9\u05dd, \u05e9\u05ea\u05d9\u05d4 \u05e7\u05dc\u05d4 \u05d5\u05e9\u05ea\u05d9\u05d4 \u05d7\u05de\u05d4" }, { "phone_number": "03-5714006", "synonym": null, "name": "\u05d0\u05e6\u05dc \u05de\u05dc\u05d9 - \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "address": "\u05d4\u05e8\u05e6\u05d5\u05d2 27 \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "chain_id": -1, "longitude": 34.817233999999999, "promo_id": 8477, "discount_type": "0", "biz_type": 311, "tags_list": "[\"\u05db\u05e9\u05e8\",\"\u05d1\u05e9\u05e8\"]", "biz_id": 8103, "latitude": 32.061281000000001, "logo": "Res8103_1.jpg", "discount_val": -1, "description": "\u05de\u05e1\u05e2\u05d3\u05d4 \u05d1\u05e9\u05e8\u05d9\u05ea \u05d1\u05e2\u05dc\u05ea \u05ea\u05e4\u05e8\u05d9\u05d8 \u05e2\u05e9\u05d9\u05e8 \u05d5\u05de\u05d2\u05d5\u05d5\u05df \r\n\u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1. \r\n\u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1\r\n\r\n" }, { "phone_number": "03-7308811", "synonym": null, "name": "\u05d9\u05d5\u05e1\u05e3 \u05d4\u05d7\u05d5\u05de\u05d5\u05e1\u05d9\u05d4 - \u05e8\u05de\u05ea \u05d2\u05df", "address": "\u05e9\u05dc\u05dd 2 \u05e8\u05de\u05ea \u05d2\u05df", "chain_id": -1, "longitude": 34.812874000000001, "promo_id": 13182, "discount_type": "0", "biz_type": 311, "tags_list": "", "biz_id": 16108, "latitude": 32.053699000000002, "logo": "Res16108_1.jpg", "discount_val": -1, "description": "\u05d7\u05d5\u05de\u05d5\u05e1 \u05d2\u05dc\u05d9\u05dc\u05d9 \u05d7\u05dd \u05d5\u05d8\u05e8\u05d9 \u05d4\u05e0\u05d8\u05d7\u05df \u05d1\u05de\u05e7\u05d5\u05dd. \u05de\u05d9 \u05e9\u05dc\u05d0 \u05e9\u05d1\u05e2 \u05d9\u05e7\u05d1\u05dc \u05de\u05d9\u05dc\u05d5\u05d9 \u05d7\u05d5\u05e4\u05e9\u05d9 \u05e2\u05dc \u05d7\u05e9\u05d1\u05d5\u05df \u05d4\u05d1\u05d9\u05ea.\r\n\u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1.\r\n\u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1" }, { "phone_number": "03-7312088", "synonym": null, "name": "\u05e1\u05d5\u05d6\u05df \u05d1\u05d9\u05ea \u05d0\u05d5\u05db\u05dc \u05d0\u05d7\u05e8-\u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "address": "\u05e2\u05de\u05d9\u05e9\u05d1 45 \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "chain_id": -1, "longitude": 34.806994000000003, "promo_id": 8483, "discount_type": "0", "biz_type": 311, "tags_list": "[\"\u05dc\u05d0 \u05db\u05e9\u05e8\",\"\u05d1\u05e9\u05e8\"]", "biz_id": 8142, "latitude": 32.061107, "logo": "Res8142_1.jpg", "discount_val": -1, "description": "\u05d0\u05d5\u05db\u05dc \u05d1\u05d9\u05ea\u05d9, \u05d7\u05d5\u05de\u05d5\u05e1, \u05ea\u05d1\u05e9\u05d9\u05dc\u05d9\u05dd \u05d5\u05e2\u05dc \u05d4\u05d0\u05e9 \r\n\u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1. \r\n\u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1\r\n\r\n" }, { "phone_number": "035733155", "synonym": null, "name": "\u05e7\u05e4\u05d4 \u05d5\u05e0\u05d9\u05e1-\u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "address": "\u05e2\u05de\u05d9\u05e9\u05d1 45 \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "chain_id": -1, "longitude": 34.806983000000002, "promo_id": 8486, "discount_type": "0", "biz_type": 311, "tags_list": "", "biz_id": 8171, "latitude": 32.061101000000001, "logo": "Res8171_1.jpg", "discount_val": -1, "description": "\u05d1\u05d1\u05d9\u05ea \u05d4\u05e7\u05e4\u05d4 \u05ea\u05d5\u05db\u05dc\u05d5 \u05dc\u05de\u05e6\u05d5\u05d0 \u05ea\u05e4\u05e8\u05d9\u05d8 \u05d9\u05e9\u05e8\u05d0\u05dc\u05d9- \u05d0\u05d9\u05d8\u05dc\u05e7\u05d9, \u05e2\u05e9\u05d9\u05e8 \u05d1\u05db\u05dc \u05d8\u05d5\u05d1. \u05de\u05d2\u05d5\u05d5\u05df \u05d0\u05e8\u05d5\u05d7\u05d5\u05ea \u05d1\u05d5\u05e7\u05e8 \u05de\u05e4\u05e0\u05e7\u05d5\u05ea, \u05db\u05e8\u05d9\u05db\u05d9\u05dd, \u05d8\u05d5\u05e1\u05d8\u05d9\u05dd \u05d5\u05e1\u05dc\u05d8\u05d9\u05dd, \u05d1\u05d9\u05e0\u05d9\u05d4\u05dd \u05e1\u05dc\u05d8 \u05d5\u05e0\u05d9\u05e1 \u05d4\u05de\u05d5\u05e8\u05db\u05d1 \u05de\u05d1\u05e8\u05d5\u05e1\u05e7\u05d8\u05d4 \u05d2\u05d1\u05d9\u05e0\u05ea \u05e2\u05d9\u05d6\u05d9\u05dd \u05d1\u05e8\u05d5\u05d8\u05d1 \u05e4\u05e1\u05d8\u05d5, \u05d0\u05e0\u05d8\u05d9\u05e4\u05e1\u05d8\u05d9 \u05d5\u05de\u05d5\u05d2\u05e9 \u05e2\u05dd \u05e9\u05dc\u05dc \u05d7\u05e1\u05d5\u05ea \u05d5\u05d9\u05e8\u05e7\u05d5\u05ea \u05d8\u05e8\u05d9\u05d9\u05dd. \u05d4\u05e4\u05d9\u05e0\u05d4 \u05d4\u05d0\u05d9\u05d8\u05dc\u05e7\u05d9\u05ea \u05de\u05d4\u05d5\u05d5\u05d4 \u05d0\u05ea \u05d2\u05d5\u05dc\u05ea \u05d4\u05db\u05d5\u05ea\u05e8\u05ea \u05e9\u05dc \u05e7\u05e4\u05d4 \u05d5\u05e0\u05d9\u05e1.\r\n\u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1. \r\n\u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1" }, { "phone_number": "1700700713", "synonym": null, "name": "\u05e6\u05d5\u05e7\u05d4 - \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "address": "\u05e7\u05e0\u05d9\u05d5\u05df \u05e2\u05d6\u05e8\u05d9\u05d0\u05dc\u05d9 \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "chain_id": -1, "longitude": 34.810203000000001, "promo_id": 16575, "discount_type": "0", "biz_type": 311, "tags_list": "", "biz_id": 15979, "latitude": 32.066487000000002, "logo": "Res15979_1.jpg", "discount_val": -1, "description": "\u05de\u05d8\u05d1\u05d7 \u05d0\u05e1\u05d9\u05d9\u05ea\u05d9.\r\n\u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1.\r\n   \u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1" }, { "phone_number": "03-7316826/1700-70-80-23 \u05e9\u05dc\u05d5\u05d7\u05d4 1", "synonym": null, "name": "\u05d0\u05d5\u05e9\u05d9 \u05d0\u05d5\u05e9\u05d9 - \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "address": "\u05d9\u05e6\u05d7\u05e7 \u05e8\u05d1\u05d9\u05df 53 \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "chain_id": 5042, "longitude": 34.810006000000001, "promo_id": 12892, "discount_type": "0", "biz_type": 311, "tags_list": "", "biz_id": 8139, "latitude": 32.066384999999997, "logo": "5042.jpg", "discount_val": -1, "description": "\r\n\u05e8\u05e9\u05ea \u05d4\u05de\u05ea\u05de\u05d7\u05d4 \u05de\u05d6\u05d4 \u05e9\u05e0\u05d9\u05dd \u05e8\u05d1\u05d5\u05ea \u05d1\u05d4\u05db\u05e0\u05ea \u05e1\u05d5\u05e9\u05d9 \u05d0\u05d9\u05db\u05d5\u05ea\u05d9, \u05d0\u05d5\u05ea\u05e0\u05d8\u05d9, \u05de\u05d2\u05d5\u05d5\u05df \u05d5\u05d9\u05e6\u05d9\u05e8\u05ea\u05d9. \r\n\u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1.\r\n\u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1." }, { "phone_number": "052-6407965", "synonym": "\u05e9\u05d5\u05d5\u05d0\u05e8\u05de\u05d4 v \u05e4\u05e8\u05d2\u05d9\u05d5\u05ea - \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "name": "\u05e9\u05d5\u05d5\u05d0\u05e8\u05de\u05d4 v \u05e4\u05e8\u05d2\u05d9\u05d5\u05ea - \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "address": "\u05e7\u05e0\u05d9\u05d5\u05df \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd, \u05d3\u05e8\u05da \u05d9\u05e6\u05d7\u05e7 \u05e8\u05d1\u05d9\u05df 53 \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "chain_id": -1, "longitude": 34.810245000000002, "promo_id": 9174, "discount_type": "0", "biz_type": 311, "tags_list": "", "biz_id": 15166, "latitude": 32.06671, "logo": "Res15166_1.jpg", "discount_val": -1, "description": "\u05e9\u05d5\u05d5\u05d0\u05e8\u05de\u05d4 \u05e4\u05e8\u05d2\u05d9\u05d5\u05ea \u05d4\u05db\u05dc \u05e2\u05dc \u05d4\u05d0\u05e9\r\n\u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1. \u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1" }, { "phone_number": "050-6531158", "synonym": null, "name": "\u05d7\u05d5\u05de\u05d5\u05e1 \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd - \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "address": "\u05d3\u05e8\u05da \u05d9\u05e6\u05d7\u05e7 \u05e8\u05d1\u05d9\u05df 53 \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "chain_id": -1, "longitude": 34.810194000000003, "promo_id": 13077, "discount_type": "0", "biz_type": 311, "tags_list": "", "biz_id": 15801, "latitude": 32.066727, "logo": "Res15801_1.jpg", "discount_val": -1, "description": "\u05d7\u05d5\u05de\u05d5\u05e1\u05d9\u05d4 \u05de\u05e6\u05d5\u05d9\u05e0\u05ea \u05d1\u05e7\u05e0\u05d9\u05d5\u05df \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd \u05d4\u05de\u05d2\u05d9\u05e9\u05d4 \u05d7\u05d5\u05de\u05d5\u05e1 \u05d0\u05d9\u05db\u05d5\u05ea\u05d9, \u05db\u05d3\u05d5\u05e8\u05d9 \u05e4\u05dc\u05d0\u05e4\u05dc \u05d5\u05de\u05d2\u05d5\u05d5\u05df \u05e1\u05dc\u05d8\u05d9\u05dd.\r\n\u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1.\r\n   \u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1" }, { "phone_number": "03-7321465", "synonym": "\u05e7\u05e4\u05d4 \u05dc\u05e0\u05d3\u05d5\u05d5\u05e8 - \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "name": "\u05e7\u05e4\u05d4 \u05dc\u05e0\u05d3\u05d5\u05d5\u05e8 - \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "address": "\u05d0\u05d9\u05dc\u05ea 1 \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "chain_id": -1, "longitude": 34.806666, "promo_id": 9254, "discount_type": "0", "biz_type": 311, "tags_list": "", "biz_id": 15350, "latitude": 32.070042999999998, "logo": "Res14909_1.png", "discount_val": -1, "description": "\u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1. \u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1" }, { "phone_number": "037315770", "synonym": null, "name": "\u05de\u05d9\u05e7\u05e1\u05dc\u05d8 - \u05ea\u05dc \u05d0\u05d1\u05d9\u05d1", "address": "\u05d3\u05e8\u05da \u05d4\u05e9\u05dc\u05d5\u05dd 71 \u05ea\u05dc \u05d0\u05d1\u05d9\u05d1", "chain_id": -1, "longitude": 34.802892, "promo_id": 13258, "discount_type": "0", "biz_type": 311, "tags_list": "", "biz_id": 16003, "latitude": 32.065866, "logo": "Res16003_1.png", "discount_val": -1, "description": "\u05e1\u05dc\u05d8\u05d9\u05dd \u05d1\u05d4\u05e8\u05db\u05d1\u05d4 \u05e2\u05e6\u05de\u05d9\u05ea, \u05e4\u05e1\u05d8\u05d4, \u05db\u05e8\u05d9\u05db\u05d9\u05dd, \u05d8\u05d5\u05e1\u05d8\u05d9\u05dd \u05d5\u05e2\u05d5\u05d3.\r\n\u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1.\r\n   \u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1" }, { "phone_number": "077-2016908", "synonym": null, "name": "\u05e1\u05d9\u05d8\u05d9 \u05d1\u05d5\u05e8\u05d2\u05e8 - \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "address": "\u05d5\u05d9\u05d9\u05e6\u05de\u05df 39 \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "chain_id": -1, "longitude": 34.808646000000003, "promo_id": 13076, "discount_type": "0", "biz_type": 311, "tags_list": "[\"\u05db\u05e9\u05e8\"]", "biz_id": 13595, "latitude": 32.072265999999999, "logo": "Res13595_1.jpg", "discount_val": -1, "description": "\u05de\u05e1\u05e2\u05d3\u05ea \u05d4\u05de\u05d1\u05d5\u05e8\u05d2\u05e8\u05d9\u05dd \u05db\u05e9\u05e8\u05d4. \u05d4\u05e7\u05e6\u05d9\u05e6\u05d5\u05ea \u05d4\u05e0\u05d4\u05d3\u05e8\u05d5\u05ea, \u05d0\u05e9\u05e8 \u05d6\u05de\u05d9\u05e0\u05d5\u05ea \u05e2\u05d1\u05d5\u05e8\u05db\u05dd \u05d1\u05db\u05de\u05d4 \u05d2\u05d3\u05dc\u05d9\u05dd, \u05de\u05d5\u05e0\u05d7\u05d5\u05ea \u05d1\u05d0\u05dc\u05d2\u05e0\u05d8\u05d9\u05d5\u05ea \u05d1\u05ea\u05d5\u05da \u05dc\u05d7\u05de\u05e0\u05d9\u05d9\u05d4 \u05d8\u05e8\u05d9\u05d9\u05d4 \u05d5\u05e2\u05dd \u05d9\u05e8\u05e7\u05d5\u05ea \u05e8\u05e2\u05e0\u05e0\u05d9\u05dd. \r\n\u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1. \r\n\u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1" }, { "phone_number": "035710022", "synonym": null, "name": "\u05e1\u05d5\u05e8\u05d4-\u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "address": "\u05d3\u05e8\u05da \u05d4\u05e9\u05dc\u05d5\u05dd 53 \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "chain_id": -1, "longitude": 34.802700000000002, "promo_id": 8489, "discount_type": "0", "biz_type": 311, "tags_list": "", "biz_id": 8377, "latitude": 32.067822, "logo": "Res8377_1.jpg", "discount_val": -1, "description": "\u05d1\u05e1\u05d5\u05e8\u05d4 \u05e1\u05d5\u05e9\u05d9 \u05d1\u05e8 \u05d9\u05e4\u05e0\u05d9 \u05d0\u05d5\u05ea\u05e0\u05d8\u05d9 \u05d4\u05de\u05e9\u05ea\u05de\u05e9 \u05d1\u05d3\u05d2\u05d9\u05dd \u05d8\u05e8\u05d9\u05d9\u05dd \u05d1\u05dc\u05d1\u05d3 - \u05de\u05e7\u05d5\u05de\u05d9\u05d9\u05dd \u05d5\u05de\u05d9\u05d5\u05d1\u05d0\u05d9\u05dd, \u05d2\u05e8\u05d9\u05dc \u05d9\u05e4\u05e0\u05d9 \u05e2\u05dd \u05e9\u05dc\u05dc \u05de\u05e0\u05d5\u05ea \u05d1\u05e9\u05e8 \u05d9\u05d9\u05d7\u05d5\u05d3\u05d9\u05d5\u05ea \u05de\u05d4\u05de\u05d6\u05e8\u05d7 \u05d4\u05e8\u05d7\u05d5\u05e7 \u05d5\u05de\u05d1\u05d7\u05e8 \u05de\u05e0\u05d5\u05ea \u05d5\u05d5\u05e7 \u05de\u05e7\u05d5\u05e8\u05d9\u05d5\u05ea. \r\n\u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1. \u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1" }, { "phone_number": "03-7311398", "synonym": null, "name": "\u05e1\u05d5\u05d3\u05d5\u05da - \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "address": "\u05d3\u05e8\u05da \u05d4\u05e9\u05dc\u05d5\u05dd 51 \u05d2\u05d1\u05e2\u05ea\u05d9\u05d9\u05dd", "chain_id": -1, "longitude": 34.802686999999999, "promo_id": 12887, "discount_type": "0", "biz_type": 311, "tags_list": "", "biz_id": 8096, "latitude": 32.067957999999997, "logo": "Res13369_1.png", "discount_val": -1, "description": "\u05e8\u05e9\u05ea \u05e1\u05d5\u05d3\u05d5\u05da \u05e0\u05d5\u05e1\u05d3\u05d4 \u05dc\u05e4\u05e0\u05d9 \u05db\u05e2\u05e9\u05d5\u05e8 \u05e2\u05dd \u05e8\u05e2\u05d9\u05d5\u05df \u05d7\u05d3\u05e9 \u05d5\u05de\u05d5\u05e4\u05dc\u05d0: \u05d8\u05d5\u05e1\u05d8 \u05e0\u05e7\u05e0\u05d9\u05e7. \u05db\u05de\u05d4 \u05e4\u05e9\u05d5\u05d8 \u2013 \u05db\u05db\u05d4 \u05de\u05d3\u05dc\u05d9\u05e7. \u05d5\u05de\u05d4 \u05d4\u05de\u05ea\u05db\u05d5\u05df \u05e9\u05dc\u05e0\u05d5 \u05dc\u05d4\u05e6\u05dc\u05d7\u05d4? \u05d0\u05e8\u05d6\u05e0\u05d5 \u05d0\u05ea \u05ea\u05de\u05e6\u05d9\u05ea \u05d4\u05d8\u05e2\u05dd \u05d4\u05d9\u05e9\u05e8\u05d0\u05dc\u05d9 \u05d1\u05dc\u05d7\u05de\u05e0\u05d9\u05d9\u05d4 (\u05d8\u05e8\u05d9\u05d9\u05d4), \u05ea\u05d9\u05d1\u05dc\u05e0\u05d5 \u05e7\u05e6\u05ea \u05d1\u05d0\u05d5\u05d5\u05d9\u05e8\u05d4 \u05e0\u05d9\u05e0\u05d5\u05d7\u05d4, \u05e9\u05d9\u05e8\u05d5\u05ea \u05d1\u05d2\u05d5\u05d1\u05d4 \u05d4\u05e2\u05d9\u05e0\u05d9\u05d9\u05dd \u05d5\u05de\u05ea\u05db\u05d5\u05df \u05de\u05e0\u05e6\u05d7 \u05d4\u05de\u05ea\u05d0\u05d9\u05dd \u05dc\u05db\u05d5\u05dc\u05dd. \r\n\u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1. \r\n\u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1" }, { "phone_number": "1-700-50-60-70", "synonym": null, "name": "\u05e4\u05d9\u05e6\u05d4 \u05d4\u05d0\u05d8 - \u05e8\u05de\u05ea \u05d2\u05df", "address": "\u05dc\u05e0\u05d3\u05d0\u05d5 7 \u05e8\u05de\u05ea \u05d2\u05df", "chain_id": 3009, "longitude": 34.828220999999999, "promo_id": 16718, "discount_type": "0", "biz_type": 311, "tags_list": null, "biz_id": 16272, "latitude": 32.07188, "logo": "3009.jpg", "discount_val": -1, "description": "\u05de\u05d1\u05e6\u05e2 \u05d1\u05dc\u05e2\u05d3\u05d9 \u05dc\u05dc\u05e7\u05d5\u05d7\u05d5\u05ea Cal \u05d4\u05de\u05e9\u05dc\u05de\u05d9\u05dd \u05d1\u05d0\u05e8\u05e0\u05e7 Cal4U. \u05e8\u05e9\u05ea \u05d4\u05e4\u05d9\u05e6\u05e8\u05d9\u05d5\u05ea \u05d4\u05d2\u05d3\u05d5\u05dc\u05d4 \u05d1\u05d9\u05d5\u05ea\u05e8 \u05d1\u05d9\u05e9\u05e8\u05d0\u05dc, \u05d7\u05dc\u05d1\u05d9\u05ea \u05dc\u05d7\u05dc\u05d5\u05d8\u05d9\u05df \u05d5\u05e8\u05d5\u05d1 \u05e1\u05e0\u05d9\u05e4\u05d4 \u05db\u05e9\u05e8\u05d9\u05dd \u05d1\u05db\u05e9\u05e8\u05d5\u05ea \u05de\u05d4\u05d5\u05d3\u05e8\u05ea. \u05e4\u05d9\u05e6\u05ea \u05d4\u05d3\u05d2\u05dc \u05e9\u05dc \u05e4\u05d9\u05e6\u05d4 \u05d4\u05d0\u05d8 \u05d4\u05d9\u05e0\u05d4 \u05d4\"\u05e4\u05d0\u05df\" \u05d4\u05e2\u05e9\u05d5\u05d9\u05d9\u05d4 \u05de\u05d1\u05e6\u05e7 \u05e2\u05d1\u05d4 \u05d5\u05d0\u05d5\u05d5\u05e8\u05d9\u05e8\u05d9. \u05d1\u05e0\u05d5\u05e1\u05e3, \u05d1\u05e8\u05e9\u05ea \u05de\u05d2\u05d5\u05d5\u05df \u05e4\u05d9\u05e6\u05d5\u05ea \u05db\u05d3\u05d5\u05d2\u05de\u05ea \u05d4\u05e4\u05d9\u05e6\u05d4 \u05d4\u05e7\u05dc\u05d0\u05e1\u05d9\u05ea \u05de\u05d1\u05e6\u05e7 \u05d3\u05e7, \u05e4\u05d9\u05e6\u05ea \u05d4\u05e6\u05d9\u05d6\u05d9 \u05e7\u05e8\u05d0\u05e1\u05d8 \u05d5\u05e4\u05d9\u05e6\u05ea \u05d4\u05e7\u05e8\u05d0\u05d5\u05df \u05d4\u05de\u05dc\u05db\u05d5\u05ea\u05d9\u05ea. \u05de\u05dc\u05d1\u05d3 \u05d4\u05e4\u05d9\u05e6\u05d5\u05ea \u05d4\u05e0\u05d4\u05d3\u05e8\u05d5\u05ea, \u05d4\u05ea\u05e4\u05e8\u05d9\u05d8 \u05de\u05d2\u05d5\u05d5\u05df \u05d1\u05de\u05e0\u05d5\u05ea \u05e0\u05e4\u05dc\u05d0\u05d5\u05ea \u05e0\u05d5\u05e1\u05e4\u05d5\u05ea \u05db\u05d2\u05d5\u05df \u05e4\u05e1\u05d8\u05d5\u05ea \u05d1\u05e8\u05d8\u05d1\u05d9\u05dd \u05e9\u05d5\u05e0\u05d9\u05dd, \u05e1\u05dc\u05d8\u05d9\u05dd \u05d8\u05e8\u05d9\u05d9\u05dd, \u05e7\u05d9\u05e9\u05d9\u05dd, \u05e4\u05d5\u05e7\u05e6'\u05d5\u05ea \u05d5\u05db\u05de\u05d5\u05d1\u05df \u05e7\u05d9\u05e0\u05d5\u05d7\u05d9\u05dd. \u05de\u05e1\u05e2\u05d3\u05d4 \u05d6\u05d5 \u05de\u05db\u05d1\u05d3\u05ea \u05e7\u05d5\u05d3 \u05ea\u05e9\u05dc\u05d5\u05dd Celleb \u05e1\u05d9\u05d1\u05d5\u05e1. \u05d1\u05e7\u05e9\u05d5 \u05de\u05d4\u05de\u05e1\u05e2\u05d3\u05d4 \u05dc\u05d4\u05e7\u05dc\u05d9\u05d3 \u05d0\u05ea \u05d4\u05e7\u05d5\u05d3 \u05d9\u05d3\u05e0\u05d9\u05ea \u05d1\u05e7\u05d5\u05e4\u05d4, \u05d1\u05de\u05e7\u05d5\u05dd \u05db\u05e8\u05d8\u05d9\u05e1 \u05e1\u05d9\u05d1\u05d5\u05e1." }] }, "branch": "celleb/celleb" };

                $timeout(function () { _defer.resolve(response); }, 1000);
                
                return _defer.promise;
            }

            //if (false) {
            $http.call(this, { method: method ? method : 'POST', url: (url ? url : baseurl), data: { data: 'req=' + JSON.stringify(data) } })
                    .success.call(this, function (response) {
                        if (response && response.Response && response.Response.Status.Succeeded) {
                            response = JSON.parse(response.Result);
                            _defer.resolve(response);
                        } else {
                            _defer.reject(cellebFefaultError);
                        }
                    })
                    .error(function () {
                        _defer.reject(cellebFefaultError);
                    });
            //}

            return _defer.promise;
        }

        return {
            call: _call
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
    .factory('clbData', clbData);

    function clbData() {
        return {}
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
    .factory('clbGeoService', clbGeoService);

    clbGeoService.$inject = ['$ionicPlatform', '$q'];

    function clbGeoService($ionicPlatform, $q) {

        var _getSelfLocation = function () {

            var defer = $q.defer();

            $ionicPlatform.ready(function () {
                if (navigator && navigator.geolocation) {

                    var onSuccess = function (position) {
                        defer.resolve(position);
                    };

                    var onError = function (error) {
                        defer.reject(error);
                    }

                    navigator.geolocation.getCurrentPosition(
                        onSuccess,
                        onError,
                        { maximumAge: 5000, timeout: 7000 });
                } else {
                    defer.reject(error);
                }
            });

            return defer.promise;
        };

        return {
            getSelfLocation: _getSelfLocation
        }
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
    .factory('clbPopUpService', clbPopUpService);

    clbPopUpService.$inject = ['$ionicPopup', '$timeout', '$interval', 'clbGeoService', 'clbData', 'googleAnalyticsService'];

    function clbPopUpService($ionicPopup, $timeout, $interval, clbGeoService, clbData, googleAnalyticsService) {

        return {
            geoServiceInfo: function () {

                var text = ionic.Platform.isIOS() ? clbData.metaData.LocationPopUpTextIOS : clbData.metaData.LocationPopUpTextAndroid;

                var extOptions =
                {
                    cssClass: 'clb-popup-geo-service-page',
                    title: clbData.metaData.LocationPopUpHeader,
                    template: '<p>' + text + '</p>',
                    buttons: [
                        {
                            text: 'סגור',
                            type: 'button-positive'
                        }
                    ]
                };

                return $timeout(function () {
                    return $ionicPopup.show(extOptions);
                }, 400);
            },
            infoPage: function (scope) {

                var extOptions =
                {
                    cssClass: 'clb-popup-info-page',
                    title: 'איך זה עובד ?',
                    templateUrl: 'app/celleb/templates/clbInfoPage.html',
                    buttons: [
                        {
                            text: 'המשך',
                            type: 'button-positive',
                            onTap: function () {
                                return angular.element('.clb-info-page-checkbox-container input[type=checkbox]').is(":checked");
                            }
                        }
                    ]
                };

                if (scope) {
                    extOptions.scope = scope;
                }

                googleAnalyticsService.insertEvent({ page: 'show help', eventName: 'show help - enter', action: 'enter' });

                return $timeout(function () {
                    return $ionicPopup.show(extOptions);
                }, 400);
            },
            locations: function (loc, scope) {

                var buttonsArr = [];
                var closeImg = angular.element('<img src="content/images/close.svg" />');
                var stop = null;
                var extOptions =
                {
                    cssClass: 'clb-popup-location',
                    title: clbData.metaData.LocationFilterHeader,
                    template: closeImg,
                    scope: scope
                };


                loc.forEach(function (obj) {
                    buttonsArr.push({
                        location_id: obj.location_id,
                        text: obj.location_name,
                        onTap: function () {
                            return obj;
                        }
                    });
                    //template += '<p id="' + obj.location_id + '" >' + obj.location_name + '</p>';
                });

                var cancelInterval = function (event) {
                    $interval.cancel(event);
                }

                extOptions.buttons = buttonsArr;

                angular.element('.clb-popup-location .popup-buttons button').ready(function () {

                    stop = $interval(function () {
                        if (angular.element('.clb-popup-location .popup-buttons') && angular.element('.clb-popup-location .popup-buttons').length > 0) {
                            angular.element('.clb-popup-location .popup-buttons').scrollTop(0);
                            //console.log('ready');
                            cancelInterval(stop);
                        }
                    }, 100);
                });

                return $timeout(function () {
                    var popup = $ionicPopup.show(extOptions);

                    closeImg.on('click', function () {
                        popup.close();
                    });

                    return popup;

                }, 200);
            }
        }
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
    .factory('clbRestService', clbRestService);

    clbRestService.$inject = ['clbConnectionService', '_', 'clbGeoService', 'connection', 'clbData', 'clbUtilsService', '$q', 'appSettings'];

    function clbRestService(clbConnectionService, _, clbGeoService, connection, clbData, clbUtilsService, $q, appSettings) {

        var useStub = appSettings.stub;

        var _genratePaymentCode = function (request) {
            
            if (useStub) {
                return _getPaymentCodeStub();
            }

            return connection.genericConnection('POST', 'CalGenratePaymentCode?', connection.versionAndOSParams, request);
        }

        var _getPaymentCodeStub = function () {
            
            var _defer = $q.defer();

            var currentdate = new Date();

            var enddate = new Date();
            enddate.setMinutes(currentdate.getMinutes() + 20);

            var res = {
                CodeGenTime: currentdate,
                CodeGenAbsTime: 0,
                CodeSecCountDown: 1200,
                CodeEndTime: enddate,
                PaymentCode: _randomIntFromInterval(10000, 99999)
            }

            _defer.resolve(res);

            return _defer.promise;
        }

        var _randomIntFromInterval = function (min, max) {
            return Math.floor(Math.random() * (max - min + 1) + min);
        }

        var _transform = function (src, selfLocation) {
            
            var tranformedObj = {
                list: [],
                count: 0
            };

            var logoBaseUrl = clbData.metaData.CellebPicUrl;

            tranformedObj.count = src.count;

            var _tempLocation;

            _.each(src.list, function (obj) {

                //obj.longitude, latitude, logo, promo_id
                if (obj.logo && obj.logo != 'undefined' && obj.logo != '') {
                    obj.logo = logoBaseUrl + obj.logo;
                } else {
                    obj.logo = 'content/images/no-logo.svg';
                }

                if (obj.tags_list) {
                    obj.tags_list = JSON.parse(obj.tags_list);
                }

                if (selfLocation) {

                    _tempLocation = parseFloat(clbUtilsService.getDistance(selfLocation.latitude, selfLocation.longitude, obj.latitude, obj.longitude));

                    obj.distanceFromBiz = _tempLocation < 1 ? _tempLocation.toFixed(3) : _tempLocation.toFixed(1);
                }
            });

            return src;
        };

        var _searchRest = function (searchData) {
            
            var data = {
                type: 'biz_scan_loc',
                display_promo_flag: 1,
                name_like: searchData.prefix,
                rec_per_page: clbData.metaData.RecordsPerPage,
                longitude: searchData.longitude,
                latitude: searchData.latitude,
                radius: searchData.radius,
                club_id: clbData.metaData.ClubId ? clbData.metaData.ClubId : '2007'
            }
            if (searchData.currentPageNum) {
                data.page_num = searchData.currentPageNum;
            }

            return clbConnectionService.call(data);
        };

        var _filteredBankAccounts = function (accounts) {
            
            var copyAccounts = angular.copy(accounts);

            var filterAccounts = [];

            _.each(copyAccounts, function (account, i) {
                var filterCards = _.filter(account.Cards, function (card) {
                    return card.CreditProductsInd == true;
                });

                if (filterCards.length > 0) {
                    account.Cards = filterCards;
                    filterAccounts.push(account);
                }
            });

            return filterAccounts;
        }

        var _getBankAccounts = function () {
            
            if (useStub) {
                return _getBankAccountsStub();
            }

            var _defer = $q.defer();

            connection.getAccount().then(
                function (response) {

                    var filterdAccounts = _filteredBankAccounts(response.BankAccounts);

                    _defer.resolve(filterdAccounts);

                }, function (error) {
                    _defer.reject(error);
                });

            return _defer.promise;
        };

        var _getBankAccountsStub = function () {
            
            var _defer = $q.defer();

            var filterdAccounts = _filteredBankAccounts(BankAccountsStub);

            _defer.resolve(filterdAccounts);

            return _defer.promise;
        };

        var _getLocationsStub = function () {
            
            var data = {
                type: 'list_locations',
                biz_type: 'cal'
            };
            
            return clbConnectionService.call(data).then(function (response) {
                var ret = {};
                ret.CellebLocations = response.ws_result.list;
                ret.MinLengthOfNameSearch = 3;
                ret.RecordsPerPage = 15;
                ret.HelpPageURL = "/";
                ret.DefaultRadius = 4000;
                ret.LocationPopUpText = 'לחוויית שימוש מיטבית, מומלץ להפעיל שירותי מיקום';
                ret.HelpPageCheckbox = 'הבנתי, תודה.';
                ret.CellebNull = -1;
                ret.MaximumRadius = 1000000;
                ret.ErrorMessageTex = '';
                ret.CellebPicUrl = 'https://rep.celleb.co.il/public_info/biz_logo/icon_big/';

                ret.CellebLocations.push(
                {
                    needGsp: true,
                    idx: 0,
                    is_active: 1,
                    left_coord: -1,
                    location_id: 0,
                    location_name: "כל הארץ",
                    radius: ret.MaximumRadius,
                    right_coord: -1
                });

                ret.CellebLocations.push(
                {
                    needGsp: true,
                    idx: 1,
                    is_active: 1,
                    left_coord: -1,
                    location_id: 1,
                    location_name: "קרובים למיקום שלי",
                    radius: ret.MaximumRadius,
                    right_coord: -1
                });

                return ret;
            });
        };

        var _getMetaData = function () {

            if (useStub) {
                return _getLocationsStub();
            }

            if (clbData.metaData) {
                var _defer = $q.defer();

                _defer.resolve(clbData.metaData);

                return _defer.promise;
            }

            return connection.genericConnection('GET', 'CalCellebGetMetaData?', connection.versionAndOSParams);
        };

        var _getPromo = function (biz_id) {
            var data = {
                "type": "get_biz_promotion",
                "biz_id": biz_id
            }
            
            return clbConnectionService.call(data).then(function (response) {
                var retVal = {};

                retVal.count = response.ws_result.head.count;
                retVal.promotionsDetails = response.ws_result.list;

                return retVal;
            });
        }
        
        return {
            searchRest: _searchRest,
            getLocations: _getLocationsStub,
            getMetaData: _getMetaData,
            getPromotionsDetails: _getPromo,
            transform: _transform,
            getBankAccounts: _getBankAccounts,
            genratePaymentCode: _genratePaymentCode,
            filteredBankAccounts: _filteredBankAccounts
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('calceleb')
    .factory('clbUtilsService', clbUtilsService);

    clbUtilsService.$inject = ['_'];

    function clbUtilsService(_) {
        return {
            getDistance: function (lat1, lon1, lat2, lon2) {
                var R = 6371; // Radius of the earth in km
                var dLat = (lat2 - lat1) * Math.PI / 180; // deg2rad below
                var dLon = (lon2 - lon1) * Math.PI / 180;
                var a =
                    0.5 - Math.cos(dLat) / 2 +
                        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                        (1 - Math.cos(dLon)) / 2;

                return R * 2 * Math.asin(Math.sqrt(a));
            }
        }
    }
})(window, window.angular);
﻿///#source 1 1 /app/p2p/p2p.module.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P", []);
})(window, window.angular);
///#source 1 1 /app/p2p/config.route.js
(function (window, angular) {
    'use strict';

    angular.module("calP2P").config(p2pRoute);

    p2pRoute.$inject = ['$stateProvider'];

    function p2pRoute($stateProvider) {

        $stateProvider
            .state('dw.p2p-home', {
                url: "/p2p/p2pMain",
                views: {
                    'contentBody': {
                        templateUrl: 'app/p2p/templates/p2pMain.html',
                        controller: 'p2pHomeCtrl',
                    }
                }
            })
            .state('dw.p2p-moneyTransfer', {
                url: "/p2p/p2pMoneyTransfer",
                views: {
                    'contentBody': {
                        templateUrl: 'app/p2p/templates/p2pMoneyTransfer.html',
                        controller: 'p2pMoneyTransferCtrl'
                    }
                }
            })
            .state('dw.p2p-history', {
                url: "/p2p/p2pHistory",
                views: {
                    'contentBody': {
                        templateUrl: 'app/p2p/templates/p2pHistory.html',
                        controller: 'p2pHistoryCtrl'
                    }
                }
            })
            .state('dw.p2p-money-receive-details', {
                url: "/p2p/p2pMoneyReceive2",
                views: {
                    'contentBody': {
                        templateUrl: 'app/p2p/templates/p2pMoneyReceive2.html',
                        controller: 'p2pMoneyReceive2Ctrl'
                    }
                }
            })
            .state('dw.p2p-favorites', {
                url: "/p2p/p2pFavorites",
                views: {
                    'contentBody': {
                        templateUrl: 'app/p2p/templates/p2pFavorites.html',
                        controller: 'p2pFavoritesCtrl'
                    }
                }
            })
            .state('dw.p2p-moneyReceive1', {
                url: "/p2p/p2pMoneyReceive1",
                views: {
                    'contentBody': {
                        templateUrl: 'app/p2p/templates/p2pMoneyReceive1.html',
                        controller: 'p2pMoneyReceive1Ctrl'
                    }
                }
            });
    }

})(window, window.angular);
///#source 1 1 /app/p2p/controllers/p2pFavoritesCtrl.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P")
            .controller('p2pFavoritesCtrl', p2pFavoritesCtrl);

    p2pFavoritesCtrl.$inject = [
        '$scope', '$rootScope', '$state', 'lobbyUiService', '$ionicSlideBoxDelegate',
        '$timeout', 'appData', '_', 'csGeneralUtilsService', 'csDataService', 'p2pMetaDataService',
        'errorService', 'csPopupService', 'p2pParamsService', 'p2pInsertNewFavorite', 'p2pFormatPhoneNumber'
    ];

    function p2pFavoritesCtrl($scope, $rootScope, $state, lobbyUiService, $ionicSlideBoxDelegate,
        $timeout, appData, _, csGeneralUtilsService, csDataService, p2pMetaDataService,
        errorService, csPopupService, p2pParamsService, p2pInsertNewFavorite, p2pFormatPhoneNumber) {


        var OperationType =
        {
            Get: 1,
            Insert: 2,
            Delete: 3
        }

        if (!lobbyUiService.connection.isLoggedIn()) {
            lobbyUiService.go('dw.login', { nextPage: "dw.p2p-home" });
            return;
        }

        $scope.getFavorites = function () {

            lobbyUiService.loader.show();

            var req = {
                ReqOperation: OperationType.Get,
                ContactPhoneNum: '',
                ContactName: ''
            }
            return csDataService.manageFavorites(req)
                .then(function (data) {
                    //success;

                    if (data.FavContacts.length > 0) {
                        $scope.favContacts = data.FavContacts;
                    } else {
                        $timeout(function () {
                            csPopupService.error('עדיין לא הוספת מועדפים');
                        }, 500);
                        //$scope.favContacts = p2pContact;
                    }

                    //console.log(JSON.stringify(data));
                },
                    function (error) {
                        //fail;
                        errorService.handleError(error);

                    }).finally(function () {
                        lobbyUiService.loader.hide();
                    });
        }

        $scope.getFavorites();

        $scope.deleteContact = function (contact, indexHtml) {
            var req = {
                ReqOperation: OperationType.Delete,
                ContactPhoneNum: contact.ContactPhoneNum,
                ContactName: contact.ContactName
            }
            return csDataService.manageFavorites(req)
                .then(function (data) {
                    //success;

                    var index = $scope.favContacts.indexOf(contact);

                    //alert('indexHtml: ' + indexHtml + ' - ' + 'index: ' + index);

                    $timeout(function () { angular.element('ion-item.item').eq(indexHtml).hide(600); }, 100);

                    $timeout(function () { $scope.favContacts.splice(index, 1); }, 1000);

                    //csPopupService.success('איש הקשר נמחק.', 'תודה שבחרת Cal');
                    //console.log(JSON.stringify(data));
                },
                    function (error) {
                        //fail;
                        errorService.handleError(error);

                    });
        }


        $scope.addContact = function () {
            var successCallback = function (result) {
                $timeout(function () {
                    //alert(result.name + " " + result.phoneNumber);
                    var _name = result.name.formatted;
                    var _phoneNumbers = result.phoneNumbers;
                    if (_name.length > 15) {
                        _name = _name.substr(0, 15) + '...';
                    }

                    // Show popup for select phone numbers from list of a contact

                    csPopupService.phoneNumberPicker(_phoneNumbers)
                        .then(function (selectedPhoneNum) {
                            if (selectedPhoneNum != null) {
                                return p2pInsertNewFavorite.addFavorite(p2pFormatPhoneNumber.formatPhone(selectedPhoneNum, false), _name)
                                    .then(function (newFavorite) {
                                        //success;
                                        $timeout(function () { $scope.favContacts.push(newFavorite); }, 100);

                                        $timeout(function () {
                                            csPopupService.success('איש הקשר נוסף בהצלחה', '');
                                        }, 200);

                                    },
                                        function (error) {
                                            //fail;
                                            errorService.handleError(error);
                                        });
                            }

                            return null;
                        });
                }, 0);
            };
            var failedCallback = function () {
                //do nothing
            }
            navigator.contacts.pickContact(successCallback, failedCallback);
        }


        $scope.selectFavorite = function (favorite) {
            p2pParamsService.paramMembers.custName = favorite.ContactName;
            p2pParamsService.paramMembers.custPhoneNumber = p2pFormatPhoneNumber.formatPhone(favorite.ContactPhoneNum, true);
            p2pParamsService.paramMembers.cameFromFavorites = true;

            lobbyUiService.go('dw.p2p-moneyTransfer');
        }
    }

})(window, window.angular);
///#source 1 1 /app/p2p/controllers/p2pHistoryCtrl.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P")
        .controller('p2pHistoryCtrl', p2pHistoryCtrl);

    p2pHistoryCtrl.$inject = [
        '$scope', '$rootScope', '$state', 'lobbyUiService', 'csCommService', '$timeout', 'csDataService', 'errorService', 'csPopupService'
    ];

    function p2pHistoryCtrl($scope, $rootScope, $state, lobbyUiService, csCommService, $timeout, csDataService, errorService, csPopupService) {

        if (!lobbyUiService.connection.isLoggedIn()) {
            lobbyUiService.go('dw.login', { nextPage: "dw.p2p-home" });
            return;
        }

        var req = {
            SourceCode: 1
        }

        $scope.members = [];

        $timeout(function () {
            $scope.addToFavoritesClass = '';
            $scope.addToFavoritesLabel = '';
        }, 100);

        $scope.getP2PTransactions = function (reqP2pTrans) {

            lobbyUiService.loader.show();

            return csCommService.getP2PTransactions(reqP2pTrans)
                .then(function (data) {
                    //success;
                    if (data.ArrTransactions.length == 0) {
                        csPopupService.error('עדיין לא ביצעת תשלומים').then(function () {
                            $scope.goBack();
                            //lobbyUiService.go('dw.p2p-home', { location: 'replace' });
                        });
                        //data.ArrTransactions = p2pTransitions;
                    }


                    for (var i = 0; i < data.ArrTransactions.length; i++) {
                        $scope.members[i] =
                        {
                            contactName: !isNullOrEmpty(data.ArrTransactions[i].CustName) ? data.ArrTransactions[i].CustName : 'ת.ז.',
                            custPhoneNumber: !isNullOrEmpty(data.ArrTransactions[i].CustPhoneNumber) ? data.ArrTransactions[i].CustPhoneNumber : data.ArrTransactions[i].CustIdNum,
                            transactionAmount: data.ArrTransactions[i].TransactionAmount.Value,
                            Simbol: data.ArrTransactions[i].TransactionAmount.Simbol ? data.ArrTransactions[i].TransactionAmount.Simbol : '₪',
                            TransactionDate: data.ArrTransactions[i].TransactionDate,
                            comment: data.ArrTransactions[i].Comment,
                            TransactionStatus: data.ArrTransactions[i].TransactionStatus
                        }



                        //if ((data.ArrTransactions[i].CustName == '' ||
                        //    data.ArrTransactions[i].CustName == null) &&
                        //(data.ArrTransactions[i].CustPhoneNumber == '' ||
                        //    data.ArrTransactions[i].CustPhoneNumber == null)) {
                        //    $scope.members[i].contactName = 'ת.ז.';
                        //    $scope.members[i].custPhoneNumber = data.ArrTransactions[i].CustIdNum;
                        //}

                        var status = data.ArrTransactions[i].TransactionStatus + (data.ArrTransactions[i].IsDebit | 0);

                        //console.log(data.ArrTransactions[i].CustName);

                        switch (status) {
                            case "10": // status 1 + isDebit false
                                $scope.members[i].TransactionStatusCssClass = 'wait-received';
                                $scope.members[i].TransactionStatusLabel = 'ממתין לאישור';
                                $scope.members[i].contactNamePrefix = 'מאת';

                                break;
                            case "11": // status 1 + isDebit true
                                $scope.members[i].TransactionStatusCssClass = 'wait-transfer';
                                $scope.members[i].TransactionStatusLabel = 'ממתין לאישור';
                                $scope.members[i].contactNamePrefix = 'אל';
                                break;

                            case "20": // status 2 + isDebit false
                                $scope.members[i].TransactionStatusCssClass = 'move-received';
                                $scope.members[i].TransactionStatusLabel = 'התקבל';
                                $scope.members[i].contactNamePrefix = 'מאת';
                                break;
                            case "21": // status 2 + isDebit true
                                $scope.members[i].TransactionStatusCssClass = 'move-transfer';
                                $scope.members[i].TransactionStatusLabel = 'הועבר';
                                $scope.members[i].contactNamePrefix = 'אל';
                                break;
                            case "30": // status 3 + isDebit false
                                $scope.members[i].TransactionStatusCssClass = 'cancel-received';
                                $scope.members[i].TransactionStatusLabel = 'בוטל';
                                $scope.members[i].contactNamePrefix = 'מאת';
                                break;
                            case "31": // status 3 + isDebit true
                                $scope.members[i].TransactionStatusCssClass = 'cancel-transfer';
                                $scope.members[i].TransactionStatusLabel = 'בוטל';
                                $scope.members[i].contactNamePrefix = 'אל';
                                break;
                            default:
                                $scope.members[i].TransactionStatusCssClass = 'wait-received';
                                $scope.members[i].TransactionStatusLabel = 'ממתין לאישור';
                                $scope.members[i].contactNamePrefix = 'מאת';
                        }
                    }
                },
                    function (error) {
                        //fail;
                        errorService.handleError(error);
                    }).finally(function () {
                        lobbyUiService.loader.hide();
                    });
        }

        $scope.getP2PTransactions(req);

        function isNullOrEmpty(val) {
            return !val || val.length == 0 || !val.trim();
        }
    }

})(window, window.angular);
///#source 1 1 /app/p2p/controllers/p2pHomeCtrl.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P")
        .controller('p2pHomeCtrl', p2pHomeCtrl);

    p2pHomeCtrl.$inject = [
        '$scope', '$rootScope', '$state', 'lobbyUiService', 'csDataService', 'appData', 'p2pMetaDataService', 'errorService', '$window', 'csPopupService'
    ];

    function p2pHomeCtrl($scope, $rootScope, $state, lobbyUiService, csDataService, appData, p2pMetaDataService, errorService, $window, csPopupService) {

        //if (!lobbyUiService.connection.isLoggedIn()) {
        //    lobbyUiService.go('dw.login', { nextPage: "dw.p2p-home" });
        //    return;
        //}

        $scope.init = function () {
            if (!$scope.metaData) {
                p2pMetaDataService.getMetaData().
                    then(function (response) {
                        $scope.metaData = response;
                    }, function (error) {
                        errorService.handleError(error);
                    });
            }

            $scope.setMenuHeight();
        }

        $scope.setMenuHeight = function () {
            
            var navContent = $('ion-nav-view.content-body');

            var targetView = $('> ion-view.module-view:nth-child(2)', navContent);

            var navHeight = parseFloat(angular.element('ion-nav-bar.content-header').outerHeight());

            var deviceHeight = parseFloat(angular.element($window).height());

            if (targetView.length == 0) {
                // animation is done, there is only one instance
                targetView = $('> ion-view.module-view:first-child', navContent);
            }

            var content = targetView.find('ion-content').first();

            if (targetView.hasClass('content-view')) {
                // content is textual, set default height
                content.css('height', '45%');

                angular.element('.modules-list').css('height', deviceHeight - content.height() - navHeight);
            } else {

                var deviceWidth = parseFloat(angular.element($window).width());

                angular.element('.modules-list').css('height', deviceHeight - navHeight - (deviceWidth * 0.625));
            }
        }

        $scope.openInfoPage = function () {
            csPopupService.openInfoPage();
        }

        $scope.mainNavigate = function (url) {
            lobbyUiService.navigate(url, { restrictedExplicitly: true });
        }

        $scope.init();
    }


})(window, window.angular);
///#source 1 1 /app/p2p/controllers/p2pMoneyReceive1Ctrl.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P")
        .controller('p2pMoneyReceive1Ctrl', p2pMoneyReceive1Ctrl);

    p2pMoneyReceive1Ctrl.$inject = [
        '$scope', 'lobbyUiService', 'csCommService', 'errorService', 'csPopupService', 'p2pParamsService'
    ];

    function p2pMoneyReceive1Ctrl($scope, lobbyUiService, csCommService, errorService, csPopupService, p2pParamsService) {

        if (!lobbyUiService.connection.isLoggedIn()) {
            lobbyUiService.go('dw.login', { nextPage: "dw.p2p-home" });
            return;
        }

        $scope.selectWaitingForApproval = function (selectedMember) {
            p2pParamsService.paramMembers.custName = selectedMember.contactName;
            p2pParamsService.paramMembers.custPhoneNumber = selectedMember.custPhoneNumber;
            p2pParamsService.paramMembers.Simbol = selectedMember.Simbol;
            p2pParamsService.paramMembers.comment = selectedMember.comment;
            p2pParamsService.paramMembers.transactionAmount = selectedMember.transactionAmount;
            p2pParamsService.paramMembers.transactionDate = selectedMember.TransactionDate;
            p2pParamsService.paramMembers.TransferId = selectedMember.TransferId;
            lobbyUiService.go('dw.p2p-money-receive-details');
        };
        var req = {
            SourceCode: 2
        }
        $scope.members = [];

        $scope.getP2PTransactions = function (getP2PTransactionsReq) {

            lobbyUiService.loader.show();

            return csCommService.getP2PTransactions(getP2PTransactionsReq)
                .then(function (data) {
                    //success;
                    if (data.ArrTransactions.length == 0) {
                        csPopupService.error('לא נמצאו תשלומים').then(function () {
                            $scope.goBack();
                            //lobbyUiService.navigate('dw.p2p-home', { location: 'replace' });
                        });
                        //data.ArrTransactions = p2pTransitions;
                    }

                    for (var i = 0; i < data.ArrTransactions.length; i++) {
                        $scope.members[i] =
                        {
                            contactName: data.ArrTransactions[i].CustName,
                            custPhoneNumber: data.ArrTransactions[i].CustPhoneNumber,
                            transactionAmount: data.ArrTransactions[i].TransactionAmount.Value,
                            Simbol: data.ArrTransactions[i].TransactionAmount.Simbol ? data.ArrTransactions[i].TransactionAmount.Simbol : '₪',
                            TransactionDate: data.ArrTransactions[i].TransactionDate,
                            comment: data.ArrTransactions[i].Comment,
                            TransactionStatus: data.ArrTransactions[i].TransactionStatus,
                            TransferId: data.ArrTransactions[i].TransferId,
                            TransactionStatusLabel: 'ממתין לאישור'
                        }
                    }
                },
                    function (error) {
                        //fail;
                        errorService.handleError(error);
                    }).finally(function () {
                        lobbyUiService.loader.hide();
                    });
        }

        $scope.getP2PTransactions(req);
    }

})(window, window.angular);
///#source 1 1 /app/p2p/controllers/p2pMoneyReceive2Ctrl.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P")
        .controller('p2pMoneyReceive2Ctrl', p2pMoneyReceive2Ctrl);

    p2pMoneyReceive2Ctrl.$inject = [
        '$scope', '$rootScope', '$state', 'lobbyUiService', 'csCommService', '$timeout', 'appData', '_', 'csGeneralUtilsService',
        'csDataService', 'p2pMetaDataService', 'errorService', 'csPopupService', 'p2pParamsService','googleAnalyticsService'
    ];

    function p2pMoneyReceive2Ctrl($scope, $rootScope, $state, lobbyUiService, csCommService,
        $timeout, appData, _, csGeneralUtilsService, csDataService, p2pMetaDataService,
        errorService, csPopupService, p2pParamsService, googleAnalyticsService) {

        if (!lobbyUiService.connection.isLoggedIn()) {
            lobbyUiService.go('dw.login', { nextPage: "dw.p2p-home" });
            return;
        }

        $scope.member = {
            contactName: p2pParamsService.paramMembers.custName,
            custPhoneNumber: p2pParamsService.paramMembers.custPhoneNumber,
            comment: p2pParamsService.paramMembers.comment,
            Simbol: p2pParamsService.paramMembers.Simbol,
            transactionAmount: p2pParamsService.paramMembers.transactionAmount,
            TransactionDate: p2pParamsService.paramMembers.transactionDate,
            TransferId: p2pParamsService.paramMembers.TransferId,
            cardSelected: '',
            agreedCode: ''
        };

        $timeout(function () {
            $scope.addToFavoritesClass = '';
            $scope.addToFavoritesLabel = '';
        }, 100);

        $scope.openTooltip = function (e, text) {
            e.stopPropagation();

            csPopupService.toolTip(text, '');
        }

        var copyAccounts = angular.copy(appData.BankAccounts);

        var cardsAfterFilter = [];

        _.each(copyAccounts, function (account) {
            var filterCards = _.filter(account.Cards, function (card) {
                return card.GoodCardHolderOwnerInd == true;
            });

            if (filterCards.length > 0) {
                account.Cards = filterCards;
                cardsAfterFilter.push.apply(cardsAfterFilter, account.Cards);
            }
        });

        $scope.cards = angular.copy(cardsAfterFilter);

        if ($scope.cards.length == 0) {
            csPopupService.error('לא נמצא כרטיס אליו ניתן לקבל תשלום')
                .then(function () {
                    $scope.goBack();
                    //lobbyUiService.go('dw.p2p-home');
                });
        } else {
            $scope.member.cardSelected = $scope.cards[0];
        }

        $scope.slideChanged = function (index) {
            $scope.cards[index].isSelected = true;

            $scope.member.cardSelected = $scope.cards[index];

        };
        $scope.approveP2PTransfer = function () {

            if ($scope.formReceive.$valid) {

                lobbyUiService.loader.show();

                var req = {
                    TransferId: $scope.member.TransferId,
                    Card4LastDigits: $scope.member.cardSelected.LastFourDigits,
                    VerificationCode: $scope.member.agreedCode
                };
                return csCommService.approveP2PTransfer(req)
                    .then(function () {
                        //success;
                        csPopupService.success('הכסף יועבר לחשבונך בתוך 2 ימי עסקים', 'בקשתך התקבלה')
                            .then(function () {
                                lobbyUiService.go('dw.p2p-home');
                            });
                    },
                        function (error) {
                            //fail;
                            errorService.handleError(error);

                        }).finally(function () {
                            lobbyUiService.loader.hide();
                        });
            }

            return null;
        }
    }

})(window, window.angular);
///#source 1 1 /app/p2p/controllers/p2pMoneyTransferCtrl.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P")
            .controller('p2pMoneyTransferCtrl', p2pMoneyTransferCtrl);

    p2pMoneyTransferCtrl.$inject = [
        '$scope', '$rootScope', '$state', 'lobbyUiService', '$ionicSlideBoxDelegate',
        '$timeout', 'appData', '_', 'csGeneralUtilsService', 'csDataService', 'p2pMetaDataService',
        'errorService', 'csPopupService', 'p2pParamsService', 'p2pInsertNewFavorite', 'p2pFormatPhoneNumber','googleAnalyticsService'
    ];

    function p2pMoneyTransferCtrl($scope, $rootScope, $state, lobbyUiService, $ionicSlideBoxDelegate,
        $timeout, appData, _, csGeneralUtilsService, csDataService, p2pMetaDataService,
        errorService, csPopupService, p2pParamsService, p2pInsertNewFavorite, p2pFormatPhoneNumber, googleAnalyticsService) {

        //#region data members

        $scope.appData = appData;

        $scope.isCustomerPhoneError = false;

        var contactNameEmpty = '';

        $scope.members =
        {
            custName: contactNameEmpty,
            custPhoneNumber: '',
            amountTransfer: '',
            cardSelected: '',
            numOfPayments: 1,
            agreedCode: '',
            remark: '',
            chkApprove: '',
            isCustomerInCal: false
        };

        $scope.bpm598Request =
        {
            IdNum: '',
            CustCelkTelPrefix: '',
            CustCellTelNum: ''
        };

        $scope.hebRegEx = /^[\u05CF-\u05EB ]+$/;

        //#endregion

        $scope.init = function () {
            if (!lobbyUiService.connection.isLoggedIn()) {
                lobbyUiService.go('dw.login', { nextPage: "dw.p2p-home" });
                return;
            }

            if ($scope.appData.p2p && $scope.appData.p2p.inProcess) {
                $scope.members = $scope.appData.p2p.state;
                $scope.appData.p2p.inProcess = false;
            }

            p2pMetaDataService.getMetaData().then(function (response) {

                $scope.metaData = response;


                $scope.members.minAmount = {
                    value: $scope.metaData.CreditPayments[0].MinAmount.Value,
                    formatted: $scope.metaData.CreditPayments[0].MinAmount.ReversedFormattedValue.replace('.00', '')
                };
                $scope.members.maxAmount = {
                    value: $scope.metaData.CreditPayments[0].MaxAmount.Value,
                    formatted: $scope.metaData.CreditPayments[0].MaxAmount.ReversedFormattedValue.replace('.00', '')
                };

                $scope.minNumPayments = $scope.metaData.CreditPayments[0].MinPayments;

                $scope.maxNumPayments = csGeneralUtilsService.createPaymentsObj($scope.metaData.CreditPayments[0].MaxPayments - $scope.metaData.CreditPayments[0].MinPayments + 1);

                if (p2pParamsService.paramMembers.cameFromFavorites == true) {

                    var _name = p2pParamsService.paramMembers.custName;
                    if (_name.length > 15) {
                        _name = _name.substr(0, 15) + '...';
                    }
                    $scope.members.custName = _name;

                    $scope.members.custPhoneNumber = p2pParamsService.paramMembers.custPhoneNumber;

                    angular.element('#contactIcon').show();

                    $scope.checkCustomerPhoneAndCallBpm598();

                    $timeout(function () {
                        $scope.addToFavoritesClass = '';
                        $scope.addToFavoritesLabel = '';
                    }, 100);

                    p2pParamsService.paramMembers.cameFromFavorites = false;
                }
            });

            $timeout(function () {
                $scope.addToFavoritesClass = '';
                $scope.addToFavoritesLabel = '';
            }, 100);

            angular.element('#contactIcon').hide();

            $scope.filterCards();
        }

        $scope.transferNavigate = function (url, saveState) {

            if (saveState) {
                $scope.appData.p2p = {
                    inProcess: true,
                    state: $scope.members
                }
            }

            lobbyUiService.go(url);
        }

        $scope.checkCustomerInCal = function (req) {
            $timeout(function () {
                var m = csDataService.checkCustomerInCal(req);
                m.then(function () {
                    //success;
                    $scope.members.isCustomerInCal = true;
                },
                    function (error) {
                        //fail;
                        $timeout(function () {
                            $scope.clearRecipient();
                        }, 100);


                        if (error[0].response.Response.Status.SeverityCode == 'W' &&
                            error[0].response.Response.Status.SeverityNumber == '0003') {
                            csPopupService.typeIdWindow($scope).then(function (res) {
                                if (res != null) {
                                    var checkCustReq = {
                                        IdNum: res,
                                        CustCelkTelPrefix: '',
                                        CustCellTelNum: ''
                                    }
                                    var checkCustRes = csDataService.checkCustomerInCal(checkCustReq);
                                    checkCustRes.then(function () {

                                        $scope.members.custName = '';

                                        $scope.members.custPhoneNumber = res;

                                        $scope.members.isCustomerInCal = true;
                                    },
                                        function (erro2) {
                                            errorService.handleError(erro2);
                                            if (error[0].response.Response.Status.SeverityCode != 'S') {
                                                $scope.clearRecipient();
                                            }
                                        });
                                }
                            });
                        } else {
                            errorService.handleError(error);
                            if (error[0].response.Response.Status.SeverityCode != 'S') {
                                $scope.clearRecipient();
                            }
                        }
                    });
            }, 1500);

        }

        $scope.checkCustomerPhoneAndCallBpm598 = function () {

            if ($scope.members.custPhoneNumber == null || $scope.members.custPhoneNumber.length == 0) {
                return;
            }

            var strPhoneNumber = p2pFormatPhoneNumber.formatPhone($scope.members.custPhoneNumber, false);

            $scope.members.isCustomerInCal = false;

            $scope.bpm598Request.IdNum = '';
            $scope.bpm598Request.CustCelkTelPrefix = strPhoneNumber.substr(0, 3);
            $scope.bpm598Request.CustCellTelNum = strPhoneNumber.substr(3, strPhoneNumber.length - 3);

            if (strPhoneNumber.length == 10 &&
                _.contains(_.pluck($scope.metaData.CreditPayments[0].PhonePrefix, "Code"), $scope.bpm598Request.CustCelkTelPrefix)) {
                //Execute Service CheckCustomerInCal : Bpm598 
                $scope.checkCustomerInCal($scope.bpm598Request);
                $scope.isCustomerPhoneError = false;
            } else {
                csPopupService.error('מספר הטלפון שהוזן אינו תקין').then(function (res) {
                    if (res != null) {
                        $scope.clearRecipient();
                    }
                });

                $scope.isCustomerPhoneError = true;
            }

        }

        $scope.clearRecipient = function () {
            $scope.members.custName = '';
            $scope.members.custPhoneNumber = '';
        };

        $scope.updatePhoneNumber = function (e) {
            var strPhoneNumber = $scope.members.custPhoneNumber != undefined ? $scope.members.custPhoneNumber : '';
            if (strPhoneNumber.length == 3 && e.keyCode != 8 && strPhoneNumber.indexOf("-") == -1) {
                $scope.members.custPhoneNumber += "-";
            }
        };

        $scope.openTooltip = function (e, text) {
            e.stopPropagation();

            csPopupService.toolTip(text, '');
        }

        $scope.transferP2PTransaction = function (req) {

            lobbyUiService.loader.show();

            return csDataService.transferP2PTransaction(req)
                .then(function () {
                    //success;
                    googleAnalyticsService.trackPage('/p2p/p2pMoney/confirm_transfer');

                    csPopupService.success('איש הקשר שבחרת נדרש לאשר את קבלת התשלום בתוך 3 ימי עסקים לצורך השלמת הפעולה', 'בקשתך התקבלה')
                        .then(function () {
                            lobbyUiService.go('dw.p2p-home');
                        });

                    //console.log(JSON.stringify(data));
                },
                    function (error) {
                        //fail;
                        errorService.handleError(error);
                    }).finally(function () {
                        lobbyUiService.loader.hide();
                    });
        }

        $scope.formatPhoneDash = function () {

            if ($scope.formTransfer.uPhoneNumber.$error.pattern) {
                csPopupService.error('מספר הטלפון שהוזן אינו תקין').then(function (res) {
                    if (res != null) {
                        $scope.clearRecipient();
                    }
                });
            }

            var strPhoneNumber = $scope.members.custPhoneNumber;

            $scope.members.custPhoneNumber = p2pFormatPhoneNumber.formatPhone(strPhoneNumber, true);

            $scope.checkCustomerPhoneAndCallBpm598();

        };

        $scope.approveTrans = function () {

            if ($scope.formTransfer.uPhoneNumber.$error.required) {
                csPopupService.error("יש להקליד מס&apos; טלפון נייד של מקבל התשלום ");
                return;
            }

            if (!$scope.members.isCustomerInCal) {
                return;
            }

            if ($scope.validateAmount() && $scope.validateNumberOfPayments() && $scope.formTransfer.$valid) {

                csPopupService.areYouSure('אני מאשר את ביצוע התשלום', 'אישור הפעולה')
                    .then(function (res) {

                        if (res != null && res == true) {

                            var req = {
                                TransactionAmount: $scope.members.amountTransfer,
                                Card4LastDigits: $scope.members.cardSelected.LastFourDigits,
                                VerificationCode: $scope.members.agreedCode,
                                Comment: $scope.members.remark,
                                NumOfPayments: $scope.members.numOfPayments,
                                ContactName: $scope.members.custName,
                                ConfirmCheckbox: $scope.members.chkApprove
                            }

                            $scope.transferP2PTransaction(req);
                        }
                    });
            }
        };

        $scope.numPaymentsSelected = function () {
            //alert($scope.members.numOfPayments);
        };

        $scope.contacts = function () {

            $scope.clearRecipient();

            // Show Contact Picker
            var successCallback = function (result) {
                $timeout(function () {
                    var _name = result.name.formatted;
                    var _phoneNumbers = result.phoneNumbers;

                    if (!_name || !_phoneNumbers) {
                        csPopupService.error('לא ניתן להוסיף איש קשר זה');
                    }

                    if (_name.length > 15) {
                        _name = _name.substr(0, 15) + '...';
                    }
                    $scope.members.custName = _name;

                    // Show popup for select phone numbers from list of a contact
                    csPopupService.phoneNumberPicker(_phoneNumbers)
                        .then(function (selectedPhoneNum) {
                            if (selectedPhoneNum != null) {
                                $scope.members.custPhoneNumber = selectedPhoneNum;
                            }

                            $scope.addToFavoritesClass = 'favorite-empty-star-icon';

                            $scope.addToFavoritesLabel = 'הוסף איש קשר למועדפים';

                            $scope.checkCustomerPhoneAndCallBpm598();
                        });


                }, 0);
            };
            var failedCallback = function () {
                csPopupService.error('לא ניתן להוסיף איש קשר זה');
            }
            navigator.contacts.pickContact(successCallback, failedCallback);

        };

        $scope.favorites = function () {
            lobbyUiService.go('dw.p2p-favorites');
        }

        $scope.addFavorite = function () {
            return p2pInsertNewFavorite.addFavorite(p2pFormatPhoneNumber.formatPhone($scope.members.custPhoneNumber, false), $scope.members.custName)
                .then(function () {
                    //success;
                    $scope.addToFavoritesClass = 'favorite-full-star-icon';
                    $scope.addToFavoritesLabel = 'נוסף למועדפים';
                },
                    function (error) {
                        //fail;
                        errorService.handleError(error);
                    });
        }

        $scope.filterCards = function () {
            var copyAccounts = angular.copy(appData.BankAccounts);

            var cardsAfterFilter = [];

            _.each(copyAccounts, function (account) {
                var filterCards = _.filter(account.Cards, function (card) {
                    return card.GoodCardHolderOwnerInd == true;
                });

                if (filterCards.length > 0) {
                    account.Cards = filterCards;
                    cardsAfterFilter.push.apply(cardsAfterFilter, account.Cards);
                }
            });

            $scope.cards = angular.copy(cardsAfterFilter);

            if ($scope.cards.length == 0) {
                csPopupService.error('לא נמצא כרטיס ממנו ניתן לבצע העברת כספים')
                    .then(function () {
                        $scope.goBack();
                        //lobbyUiService.navigate('dw.p2p-home', { location: 'replace' });
                    });
            } else {
                $scope.members.cardSelected = $scope.cards[0];
            }
        }

        $scope.slideChanged = function (index) {
            $scope.cards[index].isSelected = true;

            $scope.members.cardSelected = $scope.cards[index];
        };

        $scope.validateAmount = function () {
            if (!$scope.members.amountTransfer)
                return true;

            return $scope.members.amountTransfer >= $scope.members.minAmount.value && $scope.members.amountTransfer <= $scope.members.maxAmount.value;
        }

        $scope.validateNumberOfPayments = function () {

            if (!$scope.members.amountTransfer || ($scope.members.amountTransfer > 0 && $scope.members.numOfPayments == 1))
                return true;

            return $scope.members.numOfPayments > 1 && (parseInt($scope.members.amountTransfer) / $scope.members.numOfPayments) > 24;
        }

        $scope.init();
    }

})(window, window.angular);
///#source 1 1 /app/p2p/services/csCommService.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P")
        .factory('csCommService', csCommService);

    csCommService.$inject = ['$state', '$rootScope', '$http', '$q', 'appSettings', 'connection'];

    function csCommService($state, $rootScope, $http, $q, appSettings, connection) {

        var versionAndOS = 'CurrentVersion=' + appSettings.version + '&OperatingSystem=' + appSettings.os;
        return {
            getMetaData: function getP2PMetaData() {
                return connection.genericConnection('GET', 'CalP2PMetaData?', versionAndOS, '');
            },
            checkCustomerInCal: function checkP2PCustomerInCal(data) {
                return connection.genericConnection('POST', 'CalP2PCheckCustomerInCal?', versionAndOS, data);
            },
            transferP2PTransaction: function transferP2PTransaction(data) {
                return connection.genericConnection('POST', 'TransferP2PTransaction?', versionAndOS, data);
            },
            manageFavorites: function manageFavorites(data) {
                return connection.genericConnection('POST', 'ManageFavorites?', versionAndOS, data);
            },
            getP2PTransactions: function getP2PTransactions(data) {
                return connection.genericConnection('POST', 'GetP2PTransactions?', versionAndOS, data);
            },
            approveP2PTransfer: function approveP2PTransfer(data) {
                return connection.genericConnection('POST', 'ApproveP2PTransfer?', versionAndOS, data);
            },
            manageContactsNames: function manageContactsNames(data) {
                return connection.genericConnection('POST', 'ManageContactsNames?', versionAndOS, data);
            }
        }
    }
})(window, window.angular);
///#source 1 1 /app/p2p/services/csDataService.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P")
        .factory('csDataService', csDataService);

    csDataService.$inject = ['$state', '$rootScope', '$q', 'csCommService'];

    function csDataService($state, $rootScope, $q, csCommService) {

        var getMetaData = function () {
            return csCommService.getMetaData();
        }

        var checkCustomerInCal = function (data) {
            return csCommService.checkCustomerInCal(data);
        }

        var transferP2PTransaction = function (data) {
            return csCommService.transferP2PTransaction(data);
        }
        var manageFavorites = function (data) {
            return csCommService.manageFavorites(data);
        }
        return {
            getMetaData: getMetaData,
            checkCustomerInCal: checkCustomerInCal,
            transferP2PTransaction: transferP2PTransaction,
            manageFavorites: manageFavorites
        }
    }
})(window, window.angular);
///#source 1 1 /app/p2p/services/csGeneralUtilsService.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P")
        .factory('csGeneralUtilsService', csGeneralUtilsService);

    function csGeneralUtilsService() {
        return {
            createPaymentsObj: function (p_maxNumPayments) {

                var tmpArray = [];
                for (var i = 0; i < p_maxNumPayments; i++) {
                    tmpArray.push(i);
                }
                return tmpArray;
            }
        }
    }
})(window, window.angular);
///#source 1 1 /app/p2p/services/csPopupService.js
(function (window, angular) {
    'use strict';

    angular.module("calP2P")
        .factory('csPopupService', csPopupService);

    csPopupService.$inject = ['$timeout', '$ionicPopup', 'p2pValidateID', '$ionicBackdrop', '$q', 'p2pFormatPhoneNumber', 'googleAnalyticsService'];

    function csPopupService($timeout, $ionicPopup, p2pValidateID, $ionicBackdrop, $q, p2pFormatPhoneNumber, googleAnalyticsService) {

        return {
            typeIdWindow: function (scope1) {

                scope1.typeID = '';

                $timeout(function () {
                    angular.element('input[id=idNumber]').prop('disabled', false);
                }, 1000);

                var extOptions =
                {
                    cssClass: 'p2p-id-popup',
                    title: '',
                    scope: scope1,
                    templateUrl: 'app/p2p/templates/typeIdPage.html',
                    buttons: [
                        {
                            text: '',
                        },
                        {
                            text: 'אתר לקוח',
                            type: 'button-positive',
                            onTap: function (e) {

                                var idNum = angular.element('input[id=idNumber]').val();
                                var leadingZero = "";
                                var orgLength = idNum.length;
                                if (orgLength > 2) {
                                    for (var i = 0; i < 9 - orgLength; i++) {
                                        leadingZero += "0";
                                    }
                                }
                                idNum = leadingZero + idNum;
                                angular.element('input[id=idNumber]').val(idNum);

                                var isValidID = p2pValidateID.validateID(idNum);
                                if (idNum == null || idNum.length == 0 || !isValidID) {
                                    angular.element('#idNumberErrMsg').css('visibility', 'visible');
                                    e.preventDefault();
                                } else {
                                    $ionicBackdrop.retain();

                                    $timeout(function () {
                                        $ionicBackdrop.release();
                                    }, 400);
                                    return idNum;
                                }
                            }
                        }
                    ]
                };

                return $timeout(function () { return $ionicPopup.show(extOptions) }, 200);
            },
            phoneNumberPicker: function (p) {

                var _defer;

                if (p.length == 0) {
                    _defer = $q.defer();
                    _defer.resolve('לא נמצא');
                    return _defer.promise;
                }

                if (p.length == 1) {
                    _defer = $q.defer();
                    _defer.resolve(p2pFormatPhoneNumber.formatPhone(p[0].value, true));
                    return _defer.promise;
                }

                var buttonsArr = [];

                p.forEach(function (obj) {
                    buttonsArr.push({
                        text: p2pFormatPhoneNumber.formatPhone(obj.value, true),
                        onTap: function () {
                            return obj.value;
                        }
                    });
                });

                var closeImg = angular.element('<img src="content/images/close.svg" />');

                var extOptions =
                {
                    cssClass: 'p2p-phone-numbers-popup',
                    title: 'בחר מספר טלפון',
                    template: closeImg,
                    buttons: buttonsArr
                };

                return $timeout(function () {

                    var _popup = $ionicPopup.show(extOptions);

                    closeImg.on('click', function () {
                        _popup.close();
                    });

                    return _popup;
                }, 200);
            },
            toolTip: function (text, title, buttonText) {
                var extOptions =
                {
                    cssClass: 'p2p-tooltip-popup',
                    title: (title) ? title : '',
                    template: '<header>' + text + '</header>',
                    buttons: [
                        {
                            text: (buttonText) ? buttonText : 'סגור',
                            type: 'button-positive',
                            onTap: function (e) {
                                $ionicBackdrop.retain();

                                $timeout(function () {
                                    $ionicBackdrop.release();
                                }, 400);
                            }
                        }
                    ],
                };
                return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
            },
            success: function (text, title, buttonText) {
                var extOptions =
                {
                    cssClass: 'p2p-tooltip-popup',
                    title: (title) ? title : '',
                    template: '<header>' + text + '</header>',
                    buttons: [
                        {
                            text: (buttonText) ? buttonText : 'סגור',
                            type: 'button-positive',
                            onTap: function (e) {
                                $ionicBackdrop.retain();

                                $timeout(function () {
                                    $ionicBackdrop.release();
                                }, 400);
                            }
                        }
                    ],
                };
                return $timeout(function () { $ionicPopup.show(extOptions); }, 200);
            },
            error: function (text, buttonText) {
                var extOptions =
                {
                    cssClass: 'p2p-tooltip-popup',
                    title: '',
                    template: '<header>' + text + '</header>',
                    buttons: [
                        {
                            text: (buttonText) ? buttonText : 'סגור',
                            type: 'button-positive',
                            onTap: function (e) {
                                $ionicBackdrop.retain();

                                $timeout(function () {
                                    $ionicBackdrop.release();
                                }, 400);
                                return true;
                            }
                        }
                    ],
                };
                return $timeout(function () { return $ionicPopup.show(extOptions); }, 200);
            },
            areYouSure: function (text, title, buttonText) {
                var extOptions =
                {
                    cssClass: 'p2p-ru-sure-popup',
                    title: (title) ? title : '',
                    template: '<header>' + text + '</header>',
                    buttons: [
                        {
                            text: 'ביטול',
                            type: 'button-positive',
                            onTap: function (e) {
                                $ionicBackdrop.retain();

                                $timeout(function () {
                                    $ionicBackdrop.release();
                                }, 400);
                                return false;
                            }
                        },
                        {
                            text: (buttonText) ? buttonText : 'אישור',
                            type: 'button-positive',
                            onTap: function (e) {
                                $ionicBackdrop.retain();

                                $timeout(function () {
                                    $ionicBackdrop.release();
                                }, 400);
                                return true;
                            }
                        }
                    ],
                };
                return $timeout(function () { return $ionicPopup.show(extOptions); }, 200);
            },
            openInfoPage: function () {
                var extOptions =
                {
                    cssClass: 'p2p-popup-info-page',
                    title: 'לקוחות Cal מעבירים ביניהם כסף<br/>בלי לציין פרטי חשבון בנק',
                    templateUrl: 'app/p2p/templates/p2pInfoPage.html',
                    buttons: [
                        {
                            text: 'סגור',
                            type: 'button-positive',
                            onTap: function () {
                                return true;
                            }
                        }
                    ]
                };

                googleAnalyticsService.insertEvent({ page: 'mobical info page', eventName: 'show help - enter', action: 'enter' });

                return $timeout(function () {

                    return $ionicPopup.show(extOptions);
                }, 400);
            }

        }
    }

})(window, window.angular);
///#source 1 1 /app/p2p/services/p2pFormatPhoneNumber.js
(function (window, angular) {
    'use strict';

    angular.module("calP2P")
        .factory('p2pFormatPhoneNumber', p2pFormatPhoneNumber);

    function p2pFormatPhoneNumber() {

        var formatPhone = function (phoneNum, withDash) {

            var _phoneNum = phoneNum;

            if (_phoneNum == null || _phoneNum.length < 9) {
                return _phoneNum;
            }

            var generalExp = /^\+972|\+97-2|\+|^972|\ |\-|\(|\)|N|,|;|#|\*|\/|/g; //.substring("+972 52-44-555-66".replace(/\+|972|\ |\-/gi, '').indexOf('5'))
            var leadingZeroesExp = /^0+/;

            _phoneNum = _phoneNum.replace(generalExp, '');

            _phoneNum = _phoneNum.replace(leadingZeroesExp, '');

            var formatMobile = false;

            if (_phoneNum.indexOf('5') == 0)
                formatMobile = true;

            if (formatMobile) {
                if (withDash)
                    _phoneNum = '0'.concat(_phoneNum.substr(0, 2), "-", _phoneNum.substr(2));
                else
                    _phoneNum = '0'.concat(_phoneNum.substr(0, 2), _phoneNum.substr(2));
            } else {
                if (withDash)
                    _phoneNum = '0'.concat(_phoneNum.substr(0, 1), "-", _phoneNum.substr(1));
                else
                    _phoneNum = '0'.concat(_phoneNum.substr(0, 1), _phoneNum.substr(1));
            }

            return _phoneNum;
        }

        return {
            formatPhone: formatPhone
        }

    }
})(window, window.angular);
///#source 1 1 /app/p2p/services/p2pInsertNewFavorite.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P")
        .factory('p2pInsertNewFavorite', p2pInsertNewFavorite);

    p2pInsertNewFavorite.$inject = ['$state', '$rootScope', '$q', 'errorService', 'csDataService'];

    function p2pInsertNewFavorite($state, $rootScope, $q, errorService, csDataService) {

        var OperationType =
        {
            Get: 1,
            Insert: 2,
            Delete: 3
        }

        var addFavorite = function (_phoneNumber, _name) {

            var _defer = $q.defer();

            var req = {
                ReqOperation: OperationType.Insert,
                ContactPhoneNum: _phoneNumber,
                ContactName: _name
            }

            csDataService.manageFavorites(req)
                .then(function (data) {
                    //success;
                    var newFavorite = { ContactName: _name, ContactPhoneNum: _phoneNumber };

                    _defer.resolve(newFavorite);
                },
                    function (error) {
                        //fail;
                        _defer.reject(error);
                    });

            return _defer.promise;

        }

        return {
            addFavorite: addFavorite
        }

    }
})(window, window.angular);
///#source 1 1 /app/p2p/services/p2pMetaDataService.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P")
        .factory('p2pMetaDataService', p2pMetaDataService);

    p2pMetaDataService.$inject = ['$rootScope', 'errorService', 'stCacheService', 'csDataService', '_', '$q'];

    function p2pMetaDataService($rootScope, errorService, stCacheService, csDataService, _, $q) {
        var _metaData = function () {

            return stCacheService.get('p2pMetaData');
        };

        var _getMetaData = function (fromServer) {

            var _defer = $q.defer();

            var _cache = _metaData();

            if (_cache && !fromServer) {
                //console.log('meta data from cache');
                _defer.resolve(_cache);
            } else {
                //console.log('meta data from server');
                csDataService.getMetaData().then(
                    function (response) {

                        stCacheService.set('p2pMetaData', response);

                        _defer.resolve(response);

                    }, function (error) {

                        _defer.reject(error);
                    });
            }

            return _defer.promise;
        };


        var _metaDataService = {
            metaData: _metaData,
            getMetaData: _getMetaData
        };

        return _metaDataService;

    }
})(window, window.angular);
///#source 1 1 /app/p2p/services/p2pParamsService.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P")
        .factory('p2pParamsService', p2pParamsService);

    function p2pParamsService() {

        var paramMembers =
        {
            custName: '',
            custPhoneNumber: '',
            cameFromFavorites: false
        }

        return {
            paramMembers: paramMembers
        }

    }
})(window, window.angular);
///#source 1 1 /app/p2p/services/p2pValidateID.js
(function (window, angular) {
    'use strict';
    angular.module("calP2P")
        .factory('p2pValidateID', p2pValidateID);

    function p2pValidateID() {

        var validateID = function (id) {

            var idnum = id;

            if (idnum == null || idnum.length < 3) {
                return false;
            }

            var idnum1 = idnum.substr(0, 1) * 1;
            var idnum2 = idnum.substr(1, 1) * 2;
            var idnum3 = idnum.substr(2, 1) * 1;
            var idnum4 = idnum.substr(3, 1) * 2;
            var idnum5 = idnum.substr(4, 1) * 1;
            var idnum6 = idnum.substr(5, 1) * 2;
            var idnum7 = idnum.substr(6, 1) * 1;
            var idnum8 = idnum.substr(7, 1) * 2;
            var idnum9 = idnum.substr(8, 1) * 1;

            if (idnum1 > 9)
                idnum1 = (idnum1 % 10) + 1;
            if (idnum2 > 9)
                idnum2 = (idnum2 % 10) + 1;
            if (idnum3 > 9)
                idnum3 = (idnum3 % 10) + 1;
            if (idnum4 > 9)
                idnum4 = (idnum4 % 10) + 1;
            if (idnum5 > 9)
                idnum5 = (idnum5 % 10) + 1;
            if (idnum6 > 9)
                idnum6 = (idnum6 % 10) + 1;
            if (idnum7 > 9)
                idnum7 = (idnum7 % 10) + 1;
            if (idnum8 > 9)
                idnum8 = (idnum8 % 10) + 1;
            if (idnum9 > 9)
                idnum9 = (idnum9 % 10) + 1;

            var sumval = idnum1 + idnum2 + idnum3 + idnum4 + idnum5 + idnum6 + idnum7 + idnum8 + idnum9;

            sumval = sumval % 10;
            if (sumval > 0) {
                return false;
            }

            return true;

        }

        return {
            validateID: validateID
        }

    }
})(window, window.angular);

﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers', [])
        .run(function ($rootScope, dvDataService, lobbyUiService, $state, $q, $ionicHistory) {

            var transitionTo = $state.transitionTo;

            $state.transitionTo = function (toState, toParams, options) {
                if (!toState) {
                    return;
                }
                var fromState = $state.$current;
                var fromParams = $state.params;
                var to = toState.name || toState;

                var defaultRoute = dvData.routes.info;
                if (to.indexOf(defaultRoute) > -1) {
                    var globalStorage = dvDataService.globalStorage(dvData.keys.globalStorageKey);

                    //navigate to home
                    if (to === defaultRoute) {
                        if (fromState.name !== dvData.routes.homeTab) {
                            if (globalStorage && globalStorage.isInfoApproved) {
                                //event.preventDefault();
                                $state.go(dvData.routes.home);
                                return $q.reject(new Error('transition prvented'));
                            }
                        }
                        else {
                            //event.preventDefault();                            
                            //from dv home to info  - > go to wallet lobby                            
                            //$state.go('dw.wallet-home');
                            $ionicHistory.goBack();
                            return $q.reject(new Error('transition prvented'));
                        }
                    }                    
                }                
                
                var toPayment = to.indexOf(dvData.routes.payment) > -1;
                var toApproval = to.indexOf(dvData.routes.approval) > -1;
                var toSend = to.indexOf(dvData.routes.send) > -1;
                var skipVoucherValidation = dvDataService.skipRouteValidation() || toPayment;
                var isPayment = fromState.name.indexOf(dvData.routes.payment) > -1;
                var isSend = fromState.name.indexOf(dvData.routes.send) > -1;
                var isWallet = fromState.name.indexOf('dw.wallet-home') > -1;

                if (isWallet) {
                    if (toPayment || toSend || toApproval) {
                        $state.go('dw.lobby');
                        return $q.reject(new Error('transition prvented'));
                    }
                }

                if (fromState.name.indexOf(dvData.routes.home) > -1) {
                    if (toPayment || toSend || toApproval) {
                        $state.go('dw.wallet-home');
                        return $q.reject(new Error('transition prvented'));
                    }
                }

                if (toApproval && !isSend) {
                    //event.preventDefault();
                    $state.go(dvData.routes.home);
                    return $q.reject(new Error('transition prvented'));
                }

                if (isPayment || isSend) {
                   // if (toParams) {
                        if (!skipVoucherValidation) {
                            if (lobbyUiService.connection.isLoggedIn()) {
                                var buttonsLables = null;
                                var content;
                                if (isPayment) {
                                    content = 'יציאה מהמסך תמחק את כל הפרטים שהזנת.<br/> לצאת בכל זאת?';
                                    buttonsLables = {
                                        OK: 'המשך',
                                        Cancel: 'ביטול'
                                    };
                                }
                                else {
                                    content = 'יציאה מהמסך תמחק את כל הפרטים למשלוח.<br/> לצאת בכל זאת?';
                                }

                                routeValidationPopup(content, to, toParams, buttonsLables, '/vp/digital-voucher/step9/abort/');
                                return $q.reject(new Error('transition prvented'));
                                //event.preventDefault();
                            }
                        }
                    //}
                    else {
                        if (isSend && toPayment) {
                            $rootScope.$broadcast('voucherSaveState');
                        }

                        dvDataService.skipRouteValidation(false);
                    }
                }                

                if (!isPayment && toSend) {
                    $state.go(dvData.routes.homeTab);
                    return $q.reject(new Error('transition prvented'));
                }
                
                return transitionTo(toState, toParams, options);
            }

            $rootScope.$on('voucherSkipValidation', function (event, data) {
                dvDataService.skipRouteValidation(true);
                if (data && data.type !== 'navigate') {
                    dvDataService.activateAbandon();
                }
            });
            
            $rootScope.voucherClosepopup = function () {                
                dvDataService.closePopup();
            };                        

            //get vouchers global data
            var dvData = dvDataService.getData();
            $rootScope.dvTitle = dvData.title;

            var routeValidationPopup = function (content, route, params, buttonsLables, analyticsContent) {
                dvDataService.popup(
                            'הידעת?', content, null, route, params, null, buttonsLables, analyticsContent);
            }

            //check is user approve info page
            $rootScope.$on('$stateChangeStart', function (event, toState, params, fromState) {

            });
                

        });
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers').config(digitalVouchersRoute);

    digitalVouchersRoute.$inject = ['$stateProvider'];

    function digitalVouchersRoute($stateProvider) {
        $stateProvider
        .state('dw.vouchers', {
            url: "/vouchers/info",
            analyticsUrl: '/vp/digital-voucher/step1/welcome/',
            views: {
                'contentBody': {
                    templateUrl: "app/digitalVouchers/templates/dvInfo.html",
                    controller: "dvInfoCtrl as dvInfo"                        
                }
            }
        })
        .state('dw.vouchers-home', {
            cache: false,
            url: "/vouchers/home",
            views: {
                'contentBody': {
                    templateUrl: "app/digitalVouchers/templates/dvTabs.html",
                    controller: "dvTabsCtrl as dvTabs"
                }                   
            }
        })
        .state('dw.vouchers-home.vouchers', {
            cache: false,
            url: "/vouchers",
            analyticsUrl:'/vp/digital-voucher/step2/show-brands/',
            views: {
                'tabVouchers': {
                    templateUrl: "app/digitalVouchers/templates/dvVouchers.html",
                    controller: "dvVouchersCtrl as dvVouchers",
                    resolve: {
                        vouchers: function (dvDataService, $q, $state, $timeout) {
                            var deferred = $q.defer();
                            dvDataService.getAllDigitalVouchers().then(function (data) {
                                deferred.resolve(data);
                            }
                            , function (e) {                                
                                deferred.reject();
                            });
                            return deferred.promise;
                        }
                    }
                }
            }
        })
        .state('dw.vouchers-home.history', {
            cache: false,
            url: "/history",
            analyticsUrl: '/vp/digital-voucher/view-history/',
            views: {
                'tabHistory': {
                    templateUrl: "app/digitalVouchers/templates/dvHistory.html",
                    controller: "dvVouchersHistoryCtrl as dvVouchersHistory",
                    resolve: {
                        history: function (lobbyUiService, dvDataService, $q, $timeout, appData) {
                            var deferred = $q.defer();
                            if (!lobbyUiService.connection.isLoggedIn()) {
                                $timeout(function () {
                                    lobbyUiService.go('dw.login', { nextPage: dvDataService.getData().routes.history });
                                    deferred.reject();
                                    return;
                                });
                            }
                            else {
                                var request = { idNumber: appData.CustomerInfo.Id };
                                dvDataService.getHistoryForVouchers(request)
                                .then(function (data) {
                                    deferred.resolve(data);
                                }
                                , function (e) {
                                    deferred.resolve(e);
                                });
                            }

                            return deferred.promise;
                        }
                    }
                }
            }
        })
        .state('dw.vouchers-company', {
            cache: false,
            url: "/vouchers/companyVouchers/:companyId",
            analyticsUrl: "vp/digital-voucher/step3/show-vouchers/",
            paramsService: 'dvDataService',
            paramMethod: 'companyName',
            views: {
                'contentBody': {
                    templateUrl: "app/digitalVouchers/templates/dvCompanyVouchers.html",
                    controller: "dvCompanyVouchersCtrl as dvCompanyVouchers",
                    resolve: {
                        companyVouchers: function (dvDataService, $state, $stateParams, $filter, $timeout, $q) {
                            var deferred = $q.defer();
                            var dvData = dvDataService.getData();

                            var userStorage = dvDataService.userStorage(dvData.keys.userStorageKey);
                            if (!userStorage) {
                                $timeout(function () {
                                    $state.go(dvData.routes.home);
                                })
                                deferred.reject();                                
                            }
                            var allVouchers = userStorage.vouchers;

                            var company = $filter('filter')(allVouchers, function (item) {
                                return item.CompanyId === $stateParams.companyId;
                            })[0];

                            dvDataService.selectedCompany(company);

                            if (company.Vouchers.length === 1) {
                                $timeout(function() {
                                    $state.go(dvData.routes.voucherDetails, { voucherId: company.Vouchers[0].VoucherId, isHistory:false });
                                })
                                deferred.reject();
                            }
                            else {
                                $timeout(function () {
                                    deferred.resolve(company);
                                });
                            }                            
                            return deferred.promise;
                        }
                    }
                }
            }
        })
        .state('dw.vouchers-details', {
            cache: false,
            url: "/vouchers/voucherDetails/:voucherId/:isHistory",
            analyticsUrl: '/vp/digital-voucher/step4/voucher-terms/',
            paramsService: 'dvDataService',
            paramMethod: 'companyAndVoucherNameAndHistory',
            views: {
                'contentBody': {
                    templateUrl: "app/digitalVouchers/templates/dvVoucherDetails.html",
                    controller: "dvVoucherDetailsCtrl as dvVoucherDetails",
                    resolve: {
                        voucherDetails: function (dvDataService, $q, $timeout, $state, $stateParams) {
                            var deferred = $q.defer();                            
                            var company =  dvDataService.selectedCompany();
                            var dvData = dvDataService.getData();
                            if (!company && !$stateParams.isHistory) {
                                $timeout(function () {
                                    $state.go(dvData.routes.home);
                                })
                                deferred.reject();
                            }
                            var request = { voucherId: $stateParams.voucherId };

                            var response;                            
                            
                            response = dvDataService.getDigitalVoucher(request);

                            response.then(function (data) {
                                dvDataService.selectedVoucher(data);
                                deferred.resolve(data);
                            }
                            , function (e) {                                
                                deferred.reject();
                            });
                            
                            return deferred.promise;
                        }
                    }
                }
            }
        })
        .state('dw.vouchers-payment', {
            cache: false,
            url: "/vouchers/payment",
            analyticsUrl: '/vp/digital-voucher/step5/enter-voucher-details/',
            paramsService: 'dvDataService',
            paramMethod: 'companyAndVoucherName',
            views: {
                'contentBody': {
                    templateUrl: "app/digitalVouchers/templates/dvPayment.html",
                    controller: "dvPaymentCtrl as dvPayment",
                    resolve: {
                        payment: function (dvDataService) {
                            return dvDataService.handleAuthentication(dvDataService.getData().routes.payment);
                        }
                    }
                }
            }
        })
        .state('dw.vouchers-send', {
            cache: false,
            url: "/vouchers/send",
            analyticsUrl: '/vp/digital-voucher/step8/send-voucher/',
            paramsService: 'dvDataService',
            paramMethod: 'cNameVNameNVouchersNPayments',
            views: {
                'contentBody': {
                    templateUrl: "app/digitalVouchers/templates/dvSendVoucher.html",
                    controller: "dvSendCtrl as dvSend",
                    resolve: {
                        send: function (dvDataService) {
                            return dvDataService.handleAuthentication(dvDataService.getData().routes.payment);
                        }
                    }
                }
            }
        })
        .state('dw.vouchers-approval', {
            cache: false,
            url: "/vouchers/approval",
            analyticsUrl: '/vp/digital-voucher/step12/voucher-succeed/',
            views: {
                'contentBody': {
                    templateUrl: "app/digitalVouchers/templates/dvApproval.html",
                    controller: "dvApprovalCtrl as dvApproval",
                    resolve: {
                        approval: function (dvDataService) {
                            return dvDataService.handleAuthentication(dvDataService.getData().routes.payment);
                        }
                    }
                }
            }
        })
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers')
    .factory('dvDataService', dvDataService);

    function dvDataService($q, connection, $rootScope, lobbyUiService, errorService, $timeout, csPopupService) {
        var _data = {
            infoTitle: 'קל לקנות שובר דיגיטלי',
            companiesTitle: 'שוברים דיגיטליים',
            vouchersTitle: 'שוברים לבחירתך',
            voucherDetailsTitle: 'השובר שבחרתי',
            voucherDetailsHistoryTitle:'השובר שלך',
            paymentTitle: 'איך מתאים לך לשלם?',
            sendTitle: 'זהו, כבר מסיימים...',
            approvalTitle: 'סיכום רכישה',
            historyTitle: 'שוברים דיגיטליים',
            timeout: 20,
            keys: {
                globalStorageKey: 'dvInfoApproved',
                userStorageKey: 'dvUserStorage',
                vouchersStorageKey: 'dvVouchersStorage',
                selectedCompanyStorageKey: 'dvSelectedCompanyStorage',
                selectedVoucherStorageKey: 'selectedVoucherStorage',
                paymentStorageKey: 'paymentStorage',
                sentStorageKey: 'sentStorageKey',
                historyStorageKey: 'historyStorageKey'
            },
            routes: {
                info: 'dw.vouchers',
                home: 'dw.vouchers-home',
                homeTab: 'dw.vouchers-home.vouchers',
                history: 'dw.vouchers-home.history',
                companyVouchers: 'dw.vouchers-company',
                voucherDetails: 'dw.vouchers-details',
                payment: 'dw.vouchers-payment',
                send: 'dw.vouchers-send',
                approval: 'dw.vouchers-approval'
            },
            defaultVoucherLogo: 'content/images/general_voucher.png',
            contactTypes: {
                phone: 1,
                email: 2
            },
            analyticsPages: {
                step4: '/vp/digital-voucher/step4/voucher-terms/?brand={0}&vouchername={1}',
                step4Web: '/vp/digital-voucher/step4/voucher-leave-web/?brand={0}&vouchername={1}',
                step4Call: '/vp/digital-voucher/step4/voucher-call/?brand={0}&vouchername={1}',
                step6: '/vp/digital-voucher/step6/choose-card/?brand={0}&vouchername={1}&quantity={2}',
                step7: '/vp/digital-voucher/step7/choose-payments/?brand={0}&vouchername={1}&quantity={2}',
                step9: '/vp/digital-voucher/step9/click-to-confirm/?send-gift={0}'
            }
        };

        var _selectedCompany, _selectedVoucher;
        var _popup = [];
        var _timeout;
        var _isAbandon = false;
        var _innerStorage = {};
        var _skipRouteValidation = false;

        var _storage = function (key, value, storageObj) {
            if (value) {
                var val = JSON.stringify(value);
                try {                    
                    storageObj.setItem(key, val);
                    _innerStorage[key] = val;
                }
                catch (e) {
                    _innerStorage[key] = val;
                }
            }

            if (value === null) {
                storageObj.removeItem(key);
                _innerStorage[key] = null;
            }

            var item = _innerStorage[key] || storageObj.getItem(key);

            if (item) {
                item = JSON.parse(item);
            }            

            return item;
        }

        var globalStorage = function (key, value) {
            return _storage(key, value, window.localStorage);
        }

        var userStorage = function (key, value) {
            return _storage(key, value, window.sessionStorage);
        }

        var getAllDigitalVouchers = function () {            
            var deferred = $q.defer();
            var user = userStorage(_data.keys.userStorageKey);

            if (user && user.vouchers) {
                deferred.resolve(user.vouchers);
            }
            else {
                lobbyUiService.loader.show();
                connection.getAllDigitalVouchers().then(function (data) {
                    //data.Response.Status.Succeeded
                    if (data && data.Response && data.Succeded) {
                        //data.Response
                        userStorage(_data.keys.userStorageKey, { vouchers: data.Data })
                        deferred.resolve(data.Data);
                    }
                    else {
                        errorPopup(data, 'dw.lobby');
                        deferred.reject(data);
                    }

                    lobbyUiService.loader.hide();                    
                    
                }
                , function (error) {                    
                    errorPopup(error, 'dw.lobby');
                    deferred.reject(error);
                    //errorService.handleError(error);
                });
            }

            return deferred.promise;
        }

        var getDigitalVoucher = function (request) {
            var deferred = $q.defer();
            var vouchers = userStorage(_data.keys.vouchersStorageKey);

            if (vouchers) {
                var voucherDetails = vouchers[request.voucherId];
                if (voucherDetails) {
                    deferred.resolve(voucherDetails);
                    return deferred.promise;
                }
            }

            lobbyUiService.loader.show();
            connection.getDigitalVoucherDetails(request).then(function (data) {
                //data.Response.Status.Succeeded
                if (data && data.Response && data.Succeded) {
                    //data.Response
                    if (!vouchers) {
                        vouchers = {};
                    }

                    vouchers[request.voucherId] = data;
                    userStorage(_data.keys.vouchersStorageKey, vouchers)
                    deferred.resolve(data);
                }
                else {                    
                    var company = selectedCompany();
                    if (company && company.Vouchers.length > 1) {
                        errorPopup(data, _data.routes.companyVouchers, { companyId: company.CompanyId });
                    }
                    else {
                        errorPopup(data, _data.routes.home);
                    }
                    deferred.reject(data);
                }

                lobbyUiService.loader.hide();

            }
            , function (error) {
                var company = selectedCompany();
                if (company && company.Vouchers.length > 1) {
                    errorPopup(error, _data.routes.companyVouchers, { companyId: company.CompanyId });
                }
                else {
                    errorPopup(error, _data.routes.home);
                }
                deferred.reject(error);
                //errorService.handleError(error);
            });


            return deferred.promise;
        }

        var getEligibilityForVoucher = function (request) {
            var deferred = $q.defer();
            lobbyUiService.loader.show();
            connection.getEligibilityForVoucher(request).then(function (data) {
                //data.Response.Status.Succeeded
                if (data && data.Response && data.Succeded) {                    
                    deferred.resolve(data);
                }
                else {
                    deferred.reject(data);
                    errorPopup(data, _data.routes.home);
                    //errorPopup(data, _data.routes.voucherDetails, { voucherId: _selectedVoucher.VoucherId, isHistory: false });
                }

                lobbyUiService.loader.hide();

            }
            , function (error) {
                if (!error[1]) {
                    $rootScope.$broadcast('voucherSkipValidation');
                    errorService.handleError(error, getEligibilityForVoucher);
                }
                else {
                    errorPopup(error, _data.routes.home);
                    //errorPopup(error, _data.routes.voucherDetails, { voucherId: _selectedVoucher.VoucherId, isHistory: false });
                }
                
                deferred.reject(error);                
            });


            return deferred.promise;
        }

        var createPaymentForVouchers = function (request) {
            var deferred = $q.defer();
            lobbyUiService.loader.show();
            connection.createPaymentForVouchers(request).then(function (data) {
                //data.Response.Status.Succeeded
                if (data && data.Response && data.Succeded) {
                    deferred.resolve(data);
                }
                else {
                    errorPopup(data, _data.routes.payment);
                    deferred.reject(data);
                }

                lobbyUiService.loader.hide();

            }
            , function (error) {
                if (!error[1]) {
                    $rootScope.$broadcast('voucherSkipValidation');
                    errorService.handleError(error, createPaymentForVouchers);
                }
                else {
                    // errorPopup(error, _data.routes.payment);
                    $rootScope.$broadcast('voucherSkipValidation');
                    var v = selectedVoucher();
                    errorPopup(error, _data.routes.voucherDetails, { voucherId: v.VoucherId, isHistory: false });
                }
                deferred.reject(error);                
            });


            return deferred.promise;            
        }

        var getHistoryForVouchers = function (request) {
            var deferred = $q.defer();
            lobbyUiService.loader.show();
            connection.getHistoryForVouchers(request).then(function (data) {
                //data.Response.Status.Succeeded
                if (data && data.Response && data.Succeded) {
                    deferred.resolve(data);
                }
                else {
                    errorPopup(data, _data.routes.homeTab, null, null, 'לבחירת שובר');
                    deferred.reject(data);
                }

                lobbyUiService.loader.hide();

            }
            , function (error) {
                if (!error[1]) {
                    $rootScope.$broadcast('voucherSkipValidation');
                    errorService.handleError(error, getHistoryForVouchers);
                }
                else {
                    errorPopup(error, _data.routes.homeTab);
                }

                deferred.reject(error);                
            });


            return deferred.promise;
        }

        var getData = function() {
            return _data;
        }

        var selectedCompany = function (company) {
            if (company) {
                _selectedCompany = company;
                userStorage(_data.keys.selectedCompanyStorageKey, _selectedCompany)
            }

            if (!_selectedCompany) {
                _selectedCompany = userStorage(_data.keys.selectedCompanyStorageKey);
            }

            return _selectedCompany;
        }

        var removeSelectedCompany = function (company) {
            _selectedCompany = null;
        }

        var selectedVoucher = function (voucher) {
            if (voucher) {
                _selectedVoucher = voucher;
                userStorage(_data.keys.selectedVoucherStorageKey, _selectedVoucher)
            }

            if (!_selectedVoucher) {
                _selectedVoucher = userStorage(_data.keys.selectedVoucherStorageKey);
            }

            return _selectedVoucher;
        }

        var resetSelectedVoucher = function () {
            userStorage(_data.keys.selectedVoucherStorageKey, null);
            _selectedVoucher = null;
        }

        var popup = function (title, content, buttons, url, urlParams, hideXBtn, buttonsLables, analyticsContent) {
            _popup.push(lobbyUiService.popup.digitalVouchers(dvDataService, title, content, url, urlParams, buttons, hideXBtn, buttonsLables, analyticsContent));
        }

        var errorPopup = function (error, url, urlParams, content, buttonText) {
            var dialogBox = {
                Title: '',
                Content: content || 'בשל תקלה לא ניתן להשלים את הפעולה. יש לנסות שנית מאוחר יותר'
            };

            if (error && error[0] && error[0].response) {
                dialogBox = error[0].response.Response.DialogBox;
            }
            else if (error && error.Response.DialogBox) {
                dialogBox = error.Response.DialogBox;
            }
            
            lobbyUiService.loader.hide();

            var buttons;
            if (url) {
                buttons =
                    [{
                        text: buttonText || 'סגור',
                        type: 'button-positive',
                        onTap: function () {
                            lobbyUiService.navigate(url, null, urlParams);
                        }
                    }];
            }

            popup(dialogBox.Title, dialogBox.Content, buttons, null, null, true);
        }

        var closePopup = function () {
            for (var i = 0; i < _popup.length; i++) {
                _popup[i].close();                
            }

            _popup = [];
        }

        var setExpiration = function() {
            _timeout = new Date(new Date().getTime() + (_data.timeout * 60000));            

            _checkTimeout();
            return _timeout;
        }

        var activateAbandon = function () {
            _timeout = null;
            _isAbandon = true;
            userStorage(_data.keys.paymentStorageKey, null);
            userStorage(_data.keys.sentStorageKey, null);
        }

        var clearAbandon = function () {
            _isAbandon = false;
        }

        var getAbandon = function () {
            return _isAbandon;
        }

        var _checkTimeout = function () {
            $timeout(function () {                
                if (_isTimeout()) {
                    var content = 'היי, נעלמת לנו :)<br/>אבל אל דאגה – אפשר עדיין להזמין את השובר';
                    var buttonText = 'הזמנת שובר';
                    
                    errorPopup('', _data.routes.voucherDetails, { voucherId: _selectedVoucher.VoucherId, isHistory: false }, content, buttonText);
                    $rootScope.$broadcast('voucherSkipValidation');
                }
                else {
                    _timeout && _checkTimeout();
                }
            }, 30000)
        }

        var _isTimeout = function () {
            if (_timeout) {
                return new Date().getTime() > _timeout;
            }

            return false;
        }

        var contactSuccessCallback = function (result, contactType) {
            var deferred = $q.defer();
            $timeout(function () {
                var _name = result.name.formatted;
                var isPhone = contactType == _data.contactTypes.phone;
                var _contactData = isPhone ? result.phoneNumbers : result.emails;

                if (!_name || !_contactData) {
                    csPopupService.error('לא ניתן להוסיף איש קשר זה');
                    deferred.reject('לא ניתן להוסיף איש קשר זה');
                }

                if (isPhone) {
                    // Show popup for select phone numbers from list of a contact
                    return deferred.resolve(csPopupService.phoneNumberPicker(_contactData, true));
                }
                else {
                    return deferred.resolve(_contactData[0].value);
                }
            });

            return deferred.promise;
        };
        var contactFailedCallback = function (contactError) {
            if (contactError.code == 20) {
                csPopupService.error('יש לאפשר גישה לאנשי קשר. גש/י אל הגדרות > ארנק Cal4U > אנשי קשר.');
            }
            else {
                csPopupService.error('לא ניתן להוסיף איש קשר זה');
            }
        }

        var chooseContact = function (contactType) {
            var deferred = $q.defer();            
            if (navigator.contacts) {
                navigator.contacts.pickContact(function (result) {
                    contactSuccessCallback(result, contactType).then(function (phoneNumber) {
                        deferred.resolve(phoneNumber);
                    });
                }, contactFailedCallback);
            }
            else {
                $timeout(function () {
                    var err = 'contact plugin not exists';
                    console.log(err);
                    deferred.reject(err);
                })
            }
            return deferred.promise;
        }

        var skipRouteValidation = function (value) {
            if (angular.isDefined(value)) {
                _skipRouteValidation = value;
            }

            return _skipRouteValidation;
        }

        var handleAuthentication = function (returnRoute) {
            var deferred = $q.defer();
            if (!lobbyUiService.connection.isLoggedIn()) {
                userStorage(_data.keys.paymentStorageKey, null);
                userStorage(_data.keys.sentStorageKey, null);
                $timeout(function () {
                    lobbyUiService.go('dw.login', { nextPage: returnRoute });
                    deferred.reject();
                    return;
                });
            }

            deferred.resolve(true);

            return deferred.promise;
        }

        var companyAndVoucherName = function () {
            var company = selectedCompany();
            //var company = userStorage(_data.keys.dvSelectedCompanyStorage);
            var voucher = selectedVoucher();
            if (company && voucher) {
                return '?brand=' + company.CompanyName + '&vouchername=' + voucher.VoucherName;
            }
        }

        var companyName = function () {
            var company = selectedCompany();
            //var company = userStorage(_data.keys.dvSelectedCompanyStorage);
            if (company) {
                return '?brand=' + company.CompanyName;
            }
        }

        var cNameVNameNVouchersNPayments = function () {
            var company = selectedCompany();
            var voucher = selectedVoucher();
            var payment = userStorage(_data.keys.paymentStorageKey);

            if (company && voucher && payment) {
                return '?brand=' + company.CompanyName + '&vouchername=' + voucher.VoucherName + '&quantity=' + payment.numOfVouchers + '&payments=' + payment.selectedPayment;
            }
        }

        var companyAndVoucherNameAndHistory = function () {
            var company = selectedCompany();
            var voucher = selectedVoucher();
            var history = userStorage(_data.keys.historyStorageKey);
            if (history) {
                return '?brand=' + history.companyName + '&vouchername=' + voucher.VoucherName;
            }
            else
                {
                if (company && voucher) {
                    return '?brand=' + company.CompanyName + '&vouchername=' + voucher.VoucherName;
                }
            }
        }

        return {
            getData: getData,
            getAllDigitalVouchers: getAllDigitalVouchers,
            getDigitalVoucher: getDigitalVoucher,
            getEligibilityForVoucher: getEligibilityForVoucher,
            createPaymentForVouchers: createPaymentForVouchers,
            getHistoryForVouchers: getHistoryForVouchers,
            globalStorage: globalStorage,
            userStorage: userStorage,
            selectedCompany: selectedCompany,
            selectedVoucher: selectedVoucher,
            resetSelectedVoucher: resetSelectedVoucher,
            popup: popup,
            errorPopup: errorPopup,
            closePopup: closePopup,
            setExpiration: setExpiration,
            activateAbandon: activateAbandon,
            clearAbandon: clearAbandon,
            getAbandon: getAbandon,
            chooseContact: chooseContact,
            skipRouteValidation: skipRouteValidation,
            handleAuthentication: handleAuthentication,
            removeSelectedCompany: removeSelectedCompany,
            companyAndVoucherName: companyAndVoucherName,
            companyName: companyName,
            cNameVNameNVouchersNPayments: cNameVNameNVouchersNPayments,
            companyAndVoucherNameAndHistory: companyAndVoucherNameAndHistory
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers')
        .directive('counter', function ($rootScope) {
            return { 
                restrict: 'A', 
                scope: {
                    value: '=value',
                    max: '=max'
                },
                template: '<a href="javascript:;"  class="counter-plus" ng-click="plus()">+</a>\
                    <input type="text" class="counter-field" ng-model="value" ng-change="changed()" ng-readonly="readonly">\
                    <a href="javascript:;" class="counter-minus" ng-click="minus()">-</a>',
                link: function(scope ,element ,attributes) { 
                    // Make sure the value attribute is not missing. 
                    if( angular.isUndefined(scope.value)) { 
                        throw "Missing the value attribute on the counter directive.";
                    }
                    
                    var min = angular.isUndefined(attributes.min) ? null : parseInt(attributes.min);                    
                    var step  = angular.isUndefined(attributes.step) ? 1 : parseInt(attributes.step);

                    element.addClass('counter-container');
 
                    // If the 'editable' attribute is set, we will make the field editable. 

                    scope.readonly = angular.isUndefined(attributes.editable) ? true : false;

                    /**
                    *
                     Sets the value as an integer. 
                    
                    */
 
                    var setValue  = function(val) { 
                        scope.value =  parseInt(val); 
                    }

                    // Set the value initially, as an integer. 

                    setValue(scope.value); 

                    /**
                    *
                     Decrement the value and make sure we stay within the limits, if defined. 
                    */

                    scope.minus =  function() { 
                        if (min && (scope.value <= min || scope.value - step <= min) 
                            || min ===  0 && scope.value < 1 ) { 

                            setValue(min);
                            return false;
                        }

                        setValue(scope.value - step); 
                    };
 
                    /**
                    *
                     Increment the value and make sure we stay within the limits, if defined. 
                    
                    */
 
                    scope.plus = function () {
                        var max = scope.max;
                        if ( max && (scope.value > max || scope.value + step > max)) { 
                            setValue(max);
                            $rootScope.$broadcast('counterPlusLimit');
                            return false;
                        }
 
                        setValue(scope.value + step); 
                    };
 
                    /**
                    *
                     This is only triggered when the field is manually edited by the user. 
                    *
                     Where we can perform some validation and make sure that they enter the 
                    *
                     correct values from within the restrictions. 
                    */
 
                    scope.changed = function () {
                        var max = scope.max;
                        // If the user decides to delete the number, we will set it to 0. 

                        if ( !scope.value) {
                            setValue(0);
                        }

                        //Check if what's typed is numeric or if it has any letters. 

                        if ( /[0-9]/.test(scope.value)) { 
                            setValue(
                            scope.value
                            ); 
                        }
                        else
                        { 
                            setValue(scope.min); 
                        }

                        //If a minimum is set, let's make sure we're within the limit. 

                        if(min && (scope.value <= min || scope.value - step <= min)) { 
                            setValue(min);
                            return false;
                        }
 
                        //If a maximum is set, let's make sure we're within the limit. 

                        if (max && (scope.value >= max || scope.value + step >= max)) { 
                            setValue(max);

                            return false;
                        }
 
                        //Re-set the value as an integer. 

                        setValue(scope.value);                        
                    };
                }
            }
        });
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers')
        .directive('companyThumbnail', function () {
            return {
                restrict: 'A',
                scope: { company: '=' },
                replace: true,
                template: '<div class="company-thumbnail">\
                        <div class="dv-shadow"><img ng-src="{{::company.CompanyPhoto || defaultLogo}}" class="dv-img" /></div>\
                        <div class="dv-name-strip"><span class="dv-txt-name-strip">{{::company.CompanyName}}</span></div>\
                    </div>',
                link: function (scope, element, attributes) {
                    scope.defaultLogo = 'content/images/general_logo.png';
                }
            }
        })
    .directive('noTag', function () {
        return {                        
            replace: true,
            transclude: true,
            
            link: function (scope, element, attrs, ctrls, $transclude) {
                /*$transclude(function (clone, scope) {
                    element.append(clone);
                });*/
            }
        }
    });
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers')
        .directive('externalLink', function () {
            return {
                restrict: 'A'                ,
                link: function (scope, element, attributes) {
                    element.on('click', function (e) {
                        e.preventDefault();
                        var targetUrl = element.attr('href');
                        window.open(targetUrl, '_system');
                    })
                }
            }
        });
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers').directive('accessibleForm', function ($timeout, $ionicScrollDelegate) {
        return {
            restrict: 'A',
            link: function (scope, elem) {

                // set up event handler on the form element
                elem.on('submit', function () {

                    // find the first invalid element
                    var firstInvalid = elem[0].querySelector('.ng-invalid');

                    // if we find one, set focus
                    if (firstInvalid) {
                        $timeout(function () {
                            var top = getOffset(firstInvalid).top - 100;                            
                            $ionicScrollDelegate.$getByHandle('senderScroll').scrollTo(0, top, true);
                            firstInvalid.focus();
                        })                                                
                    }
                });

                function getOffset(el) {
                    var _x = 0;
                    var _y = 0;
                    while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
                        _x += el.offsetLeft - el.scrollLeft;
                        _y += el.offsetTop - el.scrollTop;
                        el = el.offsetParent;
                    }
                    return { top: _y, left: _x };
                }                

            }
        };
    });
})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers')
    .controller('dvInfoCtrl', dvInfoCtrl);

    dvInfoCtrl.$inject = [
        '$scope',        
        '$state',
        'dvDataService',
        'googleAnalyticsService'
    ];

    function dvInfoCtrl($scope, $state, dvDataService, googleAnalyticsService) {

        var dvInfo = this;      

        var dvData = dvDataService.getData();
        dvInfo.title = dvData.infoTitle;

        dvInfo.formData = {
            isInfoApproved: false
        };        

        dvInfo.approveInfo = function () {
            if (dvInfo.formData.isInfoApproved) {
                dvDataService.globalStorage(dvData.keys.globalStorageKey, { isInfoApproved: true });
            }

            $state.go(dvData.routes.homeTab);
        }        
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers')
    .controller('dvTabsCtrl', dvTabsCtrl);

    dvTabsCtrl.$inject = [
        '$scope',
        'dvDataService'        
    ];

    function dvTabsCtrl($scope, dvDataService) {

        var dvTabs = this;


        var _data = dvDataService.getData();
        dvTabs.Title = _data.companiesTitle;
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers')
    .controller('dvVouchersCtrl', dvVouchersCtrl);

    dvVouchersCtrl.$inject = [
        '$scope',
        'dvDataService',
        'vouchers',
        '$filter',
        '$timeout',
        '$ionicSideMenuDelegate'
    ];

    function dvVouchersCtrl($scope, dvDataService, vouchers, $filter, $timeout, $ionicSideMenuDelegate) {
        var dvVouchers = this;

        dvVouchers.vouchers = vouchers;

        var _data = dvDataService.getData();
        dvVouchers.title = _data.companiesTitle;
        //clean prev session        
        dvDataService.userStorage(_data.keys.selectedCompanyStorageKey, null);
        dvDataService.userStorage(_data.keys.selectedVoucherStorageKey, null);
        dvDataService.userStorage(_data.keys.vouchersStorageKey, null);
        dvDataService.userStorage(_data.keys.paymentStorageKey, null);
        dvDataService.userStorage(_data.keys.sentStorageKey, null);

        $timeout(function () {
            $ionicSideMenuDelegate.canDragContent(false);
        });

        $scope.$on('$ionicView.beforeEnter', function (e, viewData) {
            viewData.enableBack = true;
        });
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers')
    .controller('dvCompanyVouchersCtrl', dvCompanyVouchersCtrl);

    dvCompanyVouchersCtrl.$inject = [
        '$scope',        
        'dvDataService',        
        'companyVouchers',
        '$filter',
        '$state',
        '$timeout'
    ];

    function dvCompanyVouchersCtrl($scope, dvDataService, companyVouchers, $filter, $state, $timeout) {

        var dvCompanyVouchers = this;

        var dvData = dvDataService.getData();
        dvCompanyVouchers.title = dvData.vouchersTitle;

        dvDataService.selectedCompany(companyVouchers);

        companyVouchers.Vouchers = $filter('filter')(companyVouchers.Vouchers, function (item) {
            return item.VoucherAmountFinal > 0;
        });

        $timeout(function () {
            var content = $(".dvcv-vouchers");
            content.css('top', $(".dvcv-title").offset().top);
            content.show();
        });

        $scope.$on('$ionicView.beforeEnter', function (e, viewData) {
            viewData.enableBack = true;
        })

        dvCompanyVouchers.company = companyVouchers;
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers')
    .controller('dvVoucherDetailsCtrl', dvVoucherDetailsCtrl);

    dvVoucherDetailsCtrl.$inject = [
        '$scope',        
        'dvDataService',        
        'voucherDetails',
        '$stateParams',
        'lobbyUiService',
        'googleAnalyticsService'
    ];

    function dvVoucherDetailsCtrl($scope, dvDataService, voucherDetails, $stateParams, lobbyUiService, googleAnalyticsService) {

        var dvVoucherDetails = this;
        var giftArray = "";
        
      //  dvVoucherDetails.company = dvDataService.selectedCompany() || { CompanyName: $stateParams.companyName};
        dvVoucherDetails.isHistory = JSON.parse($stateParams.isHistory);

        var _data = dvDataService.getData();
        if (dvVoucherDetails.isHistory) {
            dvVoucherDetails.history = dvDataService.userStorage(_data.keys.historyStorageKey);
            
        }
        dvVoucherDetails.company = dvDataService.selectedCompany() ||
            { CompanyName: dvVoucherDetails.history && dvVoucherDetails.history.companyName };

        dvVoucherDetails.voucher = voucherDetails;
        voucherDetails.VoucherId = $stateParams.voucherId;
        voucherDetails.VoucherNumber = dvVoucherDetails.history ? dvVoucherDetails.history.voucherNumber : '';
        //dvDataService.selectedVoucher(voucherDetails);        
                
        dvVoucherDetails.title = _data.voucherDetailsTitle;
        dvVoucherDetails.historyTitle = _data.voucherDetailsHistoryTitle;

        dvVoucherDetails.defaultLogo = _data.defaultVoucherLogo;

        dvVoucherDetails.nextPage = function () {
            dvDataService.clearAbandon();
            lobbyUiService.go(_data.routes.payment);
        }
        
        dvVoucherDetails.checkIfNull=function(field)
        {
            if (field == '' || field == null)
                return false
            else
                return true;
        }

        dvVoucherDetails.leaveToWeb = function () {
            googleAnalyticsService.trackPage(String.format(_data.analyticsPages.step4Web, dvVoucherDetails.company.CompanyName,dvVoucherDetails.voucher.VoucherName));
        }

        dvVoucherDetails.voucherCall = function () {
            googleAnalyticsService.trackPage(String.format(_data.analyticsPages.step4Call, dvVoucherDetails.company.CompanyName, dvVoucherDetails.voucher.VoucherName));
        }

        $scope.$on('$ionicView.beforeEnter', function (e, viewData) {
            viewData.enableBack = true;
        });
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers')
    .controller('dvPaymentCtrl', dvPaymentCtrl);

    dvPaymentCtrl.$inject = [
        '$scope',
        '$q',
        '$state',
        '$rootScope',
        '$filter',
        'appData',
        'dvDataService',
        '$stateParams',
        'lobbyUiService',
        'googleAnalyticsService',
    ];

    function dvPaymentCtrl($scope, $q, $state, $rootScope, $filter, appData, dvDataService, $stateParams, lobbyUiService, googleAnalyticsService) {

        var dvPayment = this;

        var _data = dvDataService.getData();
        dvPayment.title = _data.paymentTitle;

        var payment = null;
        if (dvDataService.userStorage(_data.keys.paymentStorageKey)) {
            payment = dvDataService.userStorage(_data.keys.paymentStorageKey);
        }

        dvPayment.eligibility = payment || {
            numOfVouchers: 1,
            //numOfPayments: 1,
            selectedPayment:1
        };

        var CREDIT_TYPE = {
            REGULAR: 1,
            CREDIT: 2
        }

        dvPayment.initPaymentArray = function () {
            dvPayment.payments = [];
            dvPayment.payments.push({ num: 1, content: "תשלום 1 (עסקה רגילה)", type: CREDIT_TYPE.REGULAR });
        };

        dvPayment.initPaymentArray();

        dvDataService.skipRouteValidation(true);

        var isAuthorized = function () {
            if (!lobbyUiService.connection.isLoggedIn()) {
                lobbyUiService.go('dw.login', { nextPage: _data.routes.payment }, { location: 'replace' });
                return false;
            }

            if (!dvPayment.company || !dvPayment.voucher) {
                lobbyUiService.go(_data.routes.home);
                return false;
            }

            if (dvDataService.getAbandon()) {
                lobbyUiService.go(_data.routes.voucherDetails, { voucherId: dvPayment.voucher.VoucherId, isHistory: false });
                return false;
            }

            return true;
        }

        var _data = dvDataService.getData();
        dvPayment.company = dvDataService.selectedCompany();
        dvPayment.voucher = dvDataService.selectedVoucher();

        var bankIndex = appData.selectedBankAccountIndex || 0;
        var currentBankAccount = null;
        if (appData.BankAccounts) {
            currentBankAccount = appData.BankAccounts[bankIndex];
        }

        if (!isAuthorized()) {
            return;
        }

        if (appData.BankAccounts) {
            var cards = [];
            for (var i = 0; i < appData.BankAccounts.length; i++) {
                cards = cards.concat(appData.BankAccounts[i].Cards);
            }

            dvPayment.cards = _.filter(cards, function (card) {
                return card.CreditProductsInd == true;
            });

            if (dvPayment.cards.length === 0) {
                return;
            }
            
            var selectedCard = currentBankAccount.Cards[appData.shownCardIndex];
            if (dvPayment.cards.indexOf(selectedCard) > -1) {
                dvPayment.selectedCard = currentBankAccount.Cards[appData.shownCardIndex].Id;
            }
            else {
                dvPayment.selectedCard = dvPayment.cards[0].Id;
            }
        }

        dvPayment.changeNumOfPayment = function()
        {
            dvPayment.initPaymentArray();
            if (dvPayment.voucher) {
                dvPayment.totalSum = parseFloat((dvPayment.eligibility.numOfVouchers * dvPayment.voucher.VoucherAmountFinal).toFixed(2));
                if (dvPayment.totalSum > dvPayment.eligibility.minAmountForCredit) {
                    dvPayment.eligibility.numberOfPayments = dvPayment.totalSum / dvPayment.eligibility.minAmountForPayment;
                    if (dvPayment.eligibility.numberOfPayments > dvPayment.eligibility.maxNumberOfPayments)
                        dvPayment.eligibility.numberOfPayments = 18;
                    for (var i = parseInt(dvPayment.eligibility.minNumberOfPayments) ; i <= dvPayment.eligibility.numberOfPayments; i++) {
                        dvPayment.payments.push({ num: i, content: " תשלומים (קרדיט)", type: CREDIT_TYPE.CREDIT });
                    }
                }

                var selected = dvPayment.payments.filter(function (item) {
                    return item.num == dvPayment.eligibility.selectedPayment;
                });

                if (selected.length === 0) {
                    dvPayment.eligibility.selectedPayment = -1;
                    dvPayment.payments.unshift({ num: -1, content: 'בחר מספר תשלומים' });
                }
                else {
                    dvPayment.eligibility.selectedPayment = selected[0].num;
                }
            }
        }

        $scope.$on('counterPlusLimit', function () {
            if (!dvPayment.eligibility.numOfVouchersLimit) {
                dvPayment.eligibility.numOfVouchersLimit = 1;
            }

            dvPayment.eligibility.numOfVouchersLimit += 1;
        });

        $scope.$watch('dvPayment.eligibility.numOfVouchers', function (newValue, oldValue) {
            dvPayment.eligibility.numOfVouchersLimit = dvPayment.eligibility.numOfVouchers;
            dvPayment.changeNumOfPayment();
        });


        dvPayment.onCardChange = function () {
            googleAnalyticsService.trackPage(String.format(_data.analyticsPages.step6, dvPayment.company.CompanyName, dvPayment.voucher.VoucherName, dvPayment.eligibility.numOfVouchers));
            //conversionService.fireDigitalVouchersPerformance();

            var selectedIndex;
            for (var i = 0; i < appData.BankAccounts.length; i++) {
                var card = $filter('filter')(appData.BankAccounts[i].Cards, function (item) {
                    var isMatch = item.Id === dvPayment.selectedCard;
                    if (isMatch) {
                        currentBankAccount = appData.BankAccounts[i];
                        appData.selectedBankAccountIndex = i;
                        selectedIndex = currentBankAccount.Cards.indexOf(item);
                    }

                    return isMatch;
                })[0];
            }
            
            appData.shownCardIndex = selectedIndex;            
        }

        dvPayment.onPaymentChange = function () {
            googleAnalyticsService.trackPage(String.format(_data.analyticsPages.step7,dvPayment.company.CompanyName, dvPayment.voucher.VoucherName, dvPayment.eligibility.numOfVouchers));
        }

        dvPayment.nextPage = function () {
            if (dvPayment.eligibility.selectedPayment !== -1) {
                var paymentStorage = dvPayment.eligibility;
                paymentStorage.card = dvPayment.selectedCard;

                //card: dvPayment.selectedCard,

                //save state in session
                dvDataService.userStorage(_data.keys.paymentStorageKey, paymentStorage);

                $rootScope.$broadcast('voucherSkipValidation', { type: 'navigate' });
                $state.go(_data.routes.send);
            }

        }

        var getEligibilityForVoucher = function () {
            var deferred = $q.defer();
            var voucher = dvDataService.selectedVoucher();
            if (voucher) {
                var request = {
                    voucherId: voucher.VoucherId                    
                }
                var eligibility = dvDataService.getEligibilityForVoucher(request);                
                
                deferred.resolve(eligibility);
            }
            else {
                deferred.reject();
            }

            return deferred.promise;
        }

        var errorPopup = function (content) {
            dvDataService.errorPopup(null, _data.routes.home, null, content);
        }

        var sendStorage = dvDataService.userStorage(_data.keys.sentStorageKey);
        if (sendStorage == null) {
            getEligibilityForVoucher()
                .then(function (data) {
                    if (isNaN(data.Data.TotalNumberOfVouchers) || data.Data.TotalNumberOfVouchers == 0) {
                        errorPopup(data.Data.Content);
                        return;
                    }

                    dvDataService.skipRouteValidation(false);
                    dvDataService.setExpiration();

                    dvPayment.eligibility = {
                        maxNumOfVouchers: data.Data.TotalNumberOfVouchers,
                        content: data.Data.Content,
                        minAmountForPayment: data.MinAmountForPayment,
                        minAmountForCredit: data.MinAmountForCredit,
                        maxNumberOfPayments: data.MaxNumberOfPayments,
                        minNumberOfPayments: data.MinNumberOfPayments,
                        processId: data.Data.ProcessId,
                        numOfVouchers: 1,
                        selectedPayment: 1
                       // numOfPayments: 1
                    }
                    

                    dvPayment.changeNumOfPayment();
                    lobbyUiService.loader.hide();
                }
                , function (e) {
                    //error
                });
        }
        else {
            dvDataService.skipRouteValidation(false);
        }
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers')
    .controller('dvVouchersHistoryCtrl', dvVouchersHistoryCtrl);

    dvVouchersHistoryCtrl.$inject = [
        '$scope',
        '$timeout',
        '$state',
        'dvDataService',
        'history'
    ];

    function dvVouchersHistoryCtrl($scope, $timeout, $state, dvDataService, history) {

        var dvVouchersHistory = this;

        var _data = dvDataService.getData();
        dvVouchersHistory.title = _data.historyTitle;
        
        if (!history.Data) {
            return;
        }

        dvVouchersHistory.companies = history.Data;
        
        dvDataService.userStorage(_data.keys.selectedCompanyStorageKey, null);
        dvDataService.removeSelectedCompany();

        dvVouchersHistory.nextPage = function (c, v)
        {
            dvDataService.userStorage(_data.keys.historyStorageKey, {
                companyName: c.CompanyName,
                voucherNumber: v.VoucherNumber,
                isGift: v.IsGift,
                name2: v.Name2,
                customerServiceTelNum: history.CustomerServiceTelNum
            });
            $state.go(_data.routes.voucherDetails, { voucherId: v.VoucherId, isHistory: true });
        }

        $scope.$on('$ionicView.beforeEnter', function (e, viewData) {
            viewData.enableBack = true;
        });
        
        $timeout(function () {
            $('.vouchers-history .dv-thumbnail:even').addClass('white');
        });        
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers')
    .controller('dvSendCtrl', dvSendCtrl);

    dvSendCtrl.$inject = [
        '$scope',
        '$q',
        '$state',
        'appData',
        'dvDataService',
        '$stateParams',
        'lobbyUiService',
        '$rootScope',
        'googleAnalyticsService',
        '$timeout'
    ];

    function dvSendCtrl($scope, $q, $state, appData, dvDataService, $stateParams, lobbyUiService, $rootScope, googleAnalyticsService, $timeout) {

        var dvSend = this;

        dvSend.company = dvDataService.selectedCompany();
        dvSend.voucher = dvDataService.selectedVoucher();        
        
        var _data = dvDataService.getData();
        dvSend.Title = _data.sendTitle;

        var payment = dvDataService.userStorage(_data.keys.paymentStorageKey);                

        if (!dvSend.company || !dvSend.voucher) {
            $rootScope.$broadcast('voucherSkipValidation');
            $state.go(_data.routes.home);
            return;
        }        

        if (!payment) {
            $rootScope.$broadcast('voucherSkipValidation');
            $state.go(_data.routes.payment);
            return;
        }

        dvSend.defaultLogo = _data.defaultVoucherLogo;

        dvSend.sendTypes = {
            'me':
            {
                value: 1
            },
            'present': {
                value: 2
            }
        }        

        var sendStorage = dvDataService.userStorage(_data.keys.sentStorageKey);

        dvSend.selectedType = (sendStorage && sendStorage.selectedType) || {
            value: 1
        };

        var initForm = function () {            
            var phone = appData.CustomerInfo && appData.CustomerInfo.Phone;
            var reg = new RegExp('^(\\+972|0)5\\d{8}$');
            if (!reg.test(phone)) {
                phone = '';
            }

            dvSend.form = (sendStorage && sendStorage.form) || {
                senderPhone: phone,
                email: appData.CustomerInfo && appData.CustomerInfo.Email,
                sender: appData.CustomerInfo && (appData.CustomerInfo.FirstName + ' ' + appData.CustomerInfo.LastName)
            };            
        }

        $rootScope.$on('voucherSaveState', function () {            
            dvDataService.userStorage(_data.keys.sentStorageKey, { selectedType: dvSend.selectedType, form: dvSend.form });

        });

        dvSend.isPresent = dvSend.selectedType.value === 2;
        dvSend.isPresentFirstLoad = true;

        initForm();

        $scope.$watch('dvSend.selectedType', function (newValue, oldValue) {            
            if (newValue !== oldValue) {
                dvSend.isPresent = dvSend.selectedType.value === 2;
                if (dvSend.isPresentFirstLoad) {
                    dvSend.isPresentFirstLoad = false;
                }
                if (!dvSend.isPresent)
                {
                    dvSend.form.reciever = "";
                    dvSend.form.phone = "";
                    dvSend.form.recieverEmail = "";
                    dvSend.form.freeText = "";
                }
                //dvSend.voucherForm.$setPristine();
            }
        }, true);

        dvSend.isSupportContacts = !!navigator.contacts;
        dvSend.chooseContact = function (model, contactType) {
            dvDataService.chooseContact(contactType).then(
            function (contactData) {
                dvSend.form[model] = contactData;
            }
            , function (e) {
                //dvDataService.errorPopup();
            });
        }

        dvSend.nextPage = function () {
            if (!dvSend.voucherForm.$valid) {
                $timeout(function () {
                    var err = $.trim($('.dv-error:first').text());
                    googleAnalyticsService.trackPage(String.format(_data.analyticsPages.step9, dvSend.isPresent + '&error=' + err));
                })
                return;
            }

            googleAnalyticsService.trackPage(String.format(_data.analyticsPages.step9, dvSend.isPresent));

            var sentStorage = {
                name: dvSend.isPresent ? dvSend.form.reciever : ''
            }

            /*dvDataService.userStorage(_data.keys.sentStorageKey, sentStorage);
            $rootScope.$broadcast('voucherSkipValidation');
            $state.go(_data.routes.approval);
            return;*/

            var payment = dvDataService.userStorage(_data.keys.paymentStorageKey);

            var request = {
                uniqueId: payment.card,
                amount: payment.numOfVouchers * dvSend.voucher.VoucherAmountFinal,                    
                //paymentsCount: payment.numOfPayments,
                paymentsCount: payment.selectedPayment,
                //creditType: payment.numOfPayments === 1 ? 1 : 6,
                creditType: payment.selectedPayment === 1 ? 1 : 6,
                bussinessInfo: dvSend.company.CompanyName,
                numberOfVouchers: payment.numOfVouchers,
                telNumber: dvSend.form.senderPhone,
                mailAddress: dvSend.form.email,
                isGift: dvSend.isPresent,
                name1: dvSend.form.sender,
                name2: dvSend.form.reciever,
                telNumber2: dvSend.form.phone,
                mailAddress2: dvSend.form.recieverEmail,
                freeText: dvSend.form.freeText,
                processId:payment.processId
            }
            dvDataService.createPaymentForVouchers(request).then(
            function (data) {
                var sentStorage = {
                    name: dvSend.isPresent ? dvSend.form.reciever : '',
                    codes: data && data.VouchersCode
                };

                dvDataService.userStorage(_data.keys.paymentStorageKey, null);
                //save state in session                
                dvDataService.userStorage(_data.keys.sentStorageKey, sentStorage);

                $rootScope.$broadcast('voucherSkipValidation');
                $state.go(_data.routes.approval);
            },
            function (e) {
                //TODO 
            });
        }
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module('digitalVouchers')
    .controller('dvApprovalCtrl', dvApprovalCtrl);

    dvApprovalCtrl.$inject = [
        '$scope',
        'dvDataService',        
        '$state',
        
    ];

    function dvApprovalCtrl($scope, dvDataService, $state) {

        var dvApproval = this;

        dvApproval.company = dvDataService.selectedCompany();
        dvApproval.voucher = dvDataService.selectedVoucher();
        dvDataService.resetSelectedVoucher();

        var _data = dvDataService.getData();
        dvApproval.title = _data.approvalTitle;

        dvApproval.sentStorage = dvDataService.userStorage(_data.keys.sentStorageKey);

        $scope.$on('$ionicView.beforeEnter', function (e, viewData) {
            viewData.enableBack = false;
        });
    }

})(window, window.angular);
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('kycRefreshCustomerService', kycRefreshCustomerService);

    kycRefreshCustomerService.$inject = ['appData', 'connection', 'lobbyUiService', '$rootScope'];

    function kycRefreshCustomerService(appData, connection, lobbyUiService, $rootScope) {
        var _self;
        var init = function () {
            $rootScope.$on('accountLoggedIn', this.refreshCustomerDetails); 
        }


        function refreshCustomerDetails(bankAccounts) {
            var isBankCard = false;
            for (var i = 0; i < bankAccounts.length; ++i) {
                if (bankAccounts[i].BankCode == "12" || bankAccounts[i].BankCode == "10") { // Poalim or Leumi
                    isBankCard = true;
                    break;
                }
            }
            var popupDialogBox = isBankCard ?
                'כדי להמשיך לצפות במידע ולבצע פעולות, יש לוודא שהפרטים שלך שקיימים אצלנו הם העדכניים ביותר (הוראה 411 של בנק ישראל). כדי לצפות בפרטים ולעדכן אותם במידת הצורך, פשוט לוחצים על הכפתור. חשוב! פרטיך יעודכנו עבור כלל הכרטיסים ב-Cal, למעט כרטיסים בנקאיים של בנק פועלים ולאומי שהונפקו בשיתוף עם Cal.'
            :
                'כדי להמשיך לצפות במידע ולבצע פעולות, יש לוודא שהפרטים שלך שקיימים אצלנו הם העדכניים ביותר (הוראה 411 של בנק ישראל). כדי לצפות בפרטים ולעדכן אותם במידת הצורך, פשוט לוחצים על הכפתור';

            connection.refreshCustomerDetails().then(successCallBack, errorCallBack);

            function successCallBack(response) {
                var status = response.Response.Status.SeverityCode.toLowerCase();
                if (status === "s") {
                    if (typeof (Storage) !== "undefined") {
                        var lastTimeShown = localStorage.getItem("KycLastTimeShown");
                        if (lastTimeShown != null) {
                            if (lastTimeShown != "route from sms") {
                                // format date for REST request:
                                lastTimeShown = new Date(lastTimeShown).toLocaleString('he');
                                lastTimeShown = lastTimeShown.replace(/\./g, "/");
                                lastTimeShown = lastTimeShown.replace(/,/g, "");
                                connection.getDateToShowPopUp(lastTimeShown).then(dateSuccessFunc, dateErrorFunc);
                            }
                            else { // route from sms: update storage and don't show popup
                                var dateToShowPopup = new Date(); //current date and time
                                localStorage.setItem("KycLastTimeShown", dateToShowPopup);
                                return;
                            }
                        }
                        else {
                            var dateToShowPopup = new Date(); //current date and time
                            localStorage.setItem("KycLastTimeShown", dateToShowPopup);
                            showKycPopUp(popupDialogBox);
                        }
                    }
                    else { // no support for web storage, show popup
                        showKycPopUp(popupDialogBox);
                    }
                }

                function dateSuccessFunc  (response) {
                    var dateToShowPopup = response.DateToShowPopup;
                    if (dateToShowPopup != null) // kyc is active
                    {
                        //the next condition means dateToShowPopup is in date format rather than the number of days in between displaying the popup
                        if (dateToShowPopup.search("/") > 0 || dateToShowPopup.search(":") > 0) {
                            localStorage.setItem("KycLastTimeShown", new Date()); //the date should be the current date
                            showKycPopUp(popupDialogBox);
                        }
                        else {
                            // do not show the popup
                            console.log("kycRefreshCustomerService.dateSuccessFunc(): connection.getDateToShowPopUp() returned a non-date value (the date to show the popup didn't heppen yet)");
                        }
                    }
                    else {
                        // do not show the popup
                        console.log("kycRefreshCustomerService.dateSuccessFunc(): connection.getDateToShowPopUp() returned null (the flag IsKycActive is set to false)");
                    }
                }

                function dateErrorFunc (error) {
                    console.log("connection.getDateToShowPopUp() faliled. error: " + error);
                }
            }

            function errorCallBack(error) {
                console.log("kycRefreshCustomerService.refreshCustomerDetails(): connection.refreshCustomerDetails() failed: " + error);
            }

            function showKycPopUp(dialogBox) {
                var popup = {};
                popup.btns = [];
                popup.btns.push(
                    {
                        text: "לצפייה בפרטים",
                        type: 'button-positive',
                        onTap: function () {
                            connection.executeBpm051().then(bpm051SuccessFunc, bpm051ErrorFunc)
                        }
                    });
                popup.btns.push(
                    {
                        text: "מאוחר יותר",
                        type: 'button-negative',
                        onTap: function () {
                            return;
                        }
                    });
        

                var bpm051SuccessFunc = function (response) {
                    var status = response.ReturnedSeverityCode.toLowerCase();
                    if (status == "s") {
                        lobbyUiService.openExternal(response.UrlFormes, "", true);
                        //console.log("bpm051 returned s_001");
                    }
                    else if (status == "i") {
                        var dialogBoxText = "לא נדרש רענון לקוח, הנך מועבר להמשך פעילות";
                        showNextPopup(dialogBoxText);
                        //console.log("bpm051 returned i_001");
                    }
                    else {
                        var dialogBoxText = "לא ניתן להשלים את הפעולה כרגע, אנא נסה שנית מאוחר יותר.";
                        showNextPopup(dialogBoxText);
                        //console.log("bpm051 returned status different than s_001 or i_001");
                    }
                }

                var bpm051ErrorFunc = function (error) {
                    var dialogBoxText = "לא ניתן להשלים את הפעולה כרגע, אנא נסה שנית מאוחר יותר.";
                    showPopup(dialogBoxText);
                    console.log("kycRefreshCustomerService.showKycPopUp(): connection.executeBpm051() failed. response: " + error);
                }

                var head = '<div style="font-weight:bold;"> היי ' + appData.CustomerInfo.FirstName + ',</div>';
                lobbyUiService.popup.alert(head + dialogBox, null, null, null, popup.btns, true, "kyc-refresh-popup");
            }

            function showNextPopup(dialogbox) {
                var popup = {};
                popup.btns = [];
                popup.btns.push(
                    {
                        text: "אישור",
                        type: 'button-positive',
                        onTap: function () {
                            return;
                        }
                    });
                lobbyUiService.popup.alert(dialogbox, null, null, null, popup.btns, true, null);
            }
        }

        return {
            refreshCustomerDetails: refreshCustomerDetails,
            init: init
        }
    }


}
)(window, angular);

﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .factory('customerIndication', customerIndication)

    customerIndication.$inject = ['connection', 'lobbyUiService', '$timeout', '$q', 'appData'];
    function customerIndication(connection, lobbyUiService, $timeout, $q, appData) {
        var startTime;
        function getIndicationForCustomer() {
            //lobbyUiService.popup.marketingMessage("app/popups/templates/loan-proposal.html", "loan-popup", true, [{
            //    text: "להלוואה מהירה > ",
            //    type: 'button-positive',
            //    onTap: function () {
            //        return;
            //    }
            //}]);
            var req = {};
            var indicationLocalStorage = localStorage.getItem("indications");
            if (indicationLocalStorage && indicationLocalStorage != null && indicationLocalStorage != undefined) {
                req.indications = JSON.parse(indicationLocalStorage);
            }
            startTime = new Date();
            connection.getIndicationForCustomer(req).then(getIndicationForCustomerOnSuccess, getIndicationForCustomerOnError);
        }



        function getIndicationForCustomerOnSuccess(res) {
            var currentTime = new Date();
            var delta = (currentTime - startTime) / 1000;
            if (delta > 5) {
                return;
            }

            if (res.Indications != null) {
                setLocalStorage(res.Indications);
            }
            var severityCode = res.Response.Status.SeverityCode.toLowerCase();
            if (severityCode != null && (severityCode == "i" || severityCode == "s")) {
                if (res.Details != null) {


                    //TODO Finish credit.
                    if (res.Details.IndicationId == 1) {
                        //TODO Remove Timeout ofc

                        addAdditionalParamsToCreditPopup(res.Details);

                        popUpSwitchCase(res.Details);
                        var interval = setInterval(function () {
                            if ($('#credit-popup-languages').length > 0) {
                                $('#credit-popup-button').after('<span id="creditRedErrorDate" class="credit-popup-red-error"> התאריך שבחרת כבר עבר. יש לבחור תאריך עתידי</span>');
                                $('#creditRedErrorDate').hide();
                                formatLanguageInput(res.Details.Languages);
                                formatTextDateInput();
                                clearInterval(interval);
                            }
                        }, 250)

                        //formatTextDateInput();
                    }
                    else {
                        popUpSwitchCase(res.Details)
                    }

                }
            }
        }
        function getIndicationForCustomerOnError(err) {
        }


        // First, checks if it isn't implemented yet.
        if (!String.format) {
            String.format = function (format) {
                var args = Array.prototype.slice.call(arguments, 1);
                return format.replace(/{(\d+)}/g, function (match, number) {
                    return typeof args[number] != 'undefined'
                        ? args[number]
                        : match
                        ;
                });
            };
        }

        function addAdditionalParamsToCreditPopup(creditRes) {
            creditRes.IndicationText = String.format(creditRes.IndicationText, dateText, languagePicker);
        }

        var now1 = moment().format('YYYY-MM-DD');
        var future3Years = moment().add(3, 'years').format('YYYY-MM-DD');
        var future30Years = moment().add(30, 'years').format('YYYY-MM-DD');
        var dateText = '<span id="credit-popup-button" style="color:#1b5ece" data-editable class="credit-popup-change-date-static">(לשינוי תוקף ההסכמה)</span>';
        var dateInput =
            `<div class="credit-popup-wrap-date-picker">
               <input  
                id="creditPopupDateInputPicker"
                data-date=""
                value ="${future3Years}"
                id="creditPopDatePicker"
                class="date-picker-input unstyled input-style date-picker-mobile date-picker-icon"
                type="date"
                min = "${now1}"
                max = "${future30Years}"/>
             </div>`

        var languagePicker = '<select name="credit-popup-languages" id="credit-popup-languages" style="height:28px; background:white; margin-top:7px;"></select>';
        function formatLanguageInput(selectValues) {
            $.each(selectValues, function (key, value) {
                var val = value.LangName + " - " + value.LangTranslate;
                $('#credit-popup-languages')
                    .append($("<option></option>")
                        .attr("value", value.LangId)
                        .text(val));
            });
        }
        var dateEdited = false;
        function formatTextDateInput() {
            $('#credit-popup-button').bind('click', '[data-editable]', function () {
                dateEdited = true;
                var $el = $(this);
                var $input = $(dateInput);
                $el.replaceWith($input);
                var date_input = document.getElementById('creditPopupDateInputPicker');
                var elementForDefaultDate = document.querySelector("#creditPopupDateInputPicker");
                var defaultdate = moment().add(3, 'years').format("YYYY-MM-DD");
                elementForDefaultDate.setAttribute('value', defaultdate);
                elementForDefaultDate.setAttribute('data-date', moment(defaultdate).format("DD/MM/YYYY"));
                $("#creditPopupDateInputPicker").val(defaultdate);


                //option 1
                // if (is_safari_or_chrome_on_ios) {
                //     date_input.addEventListener('blur', updateValue);
                //     function updateValue(e) {

                //         var dateForServer2 = new Date($("#creditPopupDateInputPicker").val());
                //         var now = new Date().setHours(0, 0, 0, 0);
                //         dateForServer2 < now ? $('#creditRedErrorDate').show() : $('#creditRedErrorDate').hide();

                //     }
                // }


                date_input.onchange = function () {
                    var dateFromInput = this.value;
                    $timeout(function () {
                        var elementForFormat = document.querySelector("#creditPopupDateInputPicker");
                        var dateTMP = moment(dateFromInput).format("DD/MM/YYYY");
                        var dateForServer2 = new Date($("#creditPopupDateInputPicker").val());
                        var now = new Date().setHours(0, 0, 0, 0);
                        if (dateFromInput == null || dateFromInput == "") {
                            dateFromInput = moment().add(3, 'years').format("YYYY-MM-DD");
                            dateTMP = moment(dateFromInput).format("DD/MM/YYYY");
                        }

                        else if (dateForServer2 < now) {
                            dateFromInput = moment().format("YYYY-MM-DD");
                            dateTMP = moment(dateFromInput).format("DD/MM/YYYY");
                        }
                        $timeout(function () {
                            elementForFormat.setAttribute('value', dateFromInput);
                            elementForFormat.setAttribute('data-date', dateTMP);
                            $("#creditPopupDateInputPicker").val(dateFromInput);
                        })
                    });
                }




            });
        }


        //get decision for template by indication Id
        function popUpSwitchCase(obj) {
            var popupButtons = initButtons(obj);
            switch (obj.IndicationId) {
                //Credit
                case 1:
                    showPopUp("<ion-content><header>" + obj.IndicationText + "</header></ion-content>", popupButtons, 'הסכמה לקבלת נתונים ממאגר אשראי', 'customer-ind-credit',
                        `<div class="customer-ind-subheader1">לפי תקנה 5 לתקנות נתוני אשראי, התשע"ח, 2017</div>`);
                    break;
                //Banking
                case 2:
                    showPopUp(obj.IndicationText, popupButtons, 'הסכמה לשימוש בנתונים בנקאיים', 'customer-ind-banking', null);
                    break;
                //KYC
                case 3:
                    showPopUp(obj.IndicationText, popupButtons, null, 'customer-ind-kyc', null); //no header here..
                    break;
                //DEBT
                case 4:
                    showPopUp(obj.IndicationText, popupButtons, null, 'cusotmer-ind-debt', null);//no header here..
                    break;
                //Loan Proposal
                //case 5:
                //    ga("set", "page", "/vp/loan-interstitial/");
                //    ga("send", "pageview");
                //    console.log("will show marketings", obj);
                //    lobbyUiService.popup.marketingMessage("app/popups/templates/loan-proposal.html", "loan-popup", true, popupButtons);
                //    break;
            }
        }
        function setLocalStorage(data) {
            localStorage.setItem("indications", JSON.stringify(data));
        }
        function showPopUp(templateText, buttons, title, cssClass, subHeader) {
            lobbyUiService.popup.indicationMessage(templateText, subHeader, title, cssClass, null, null, buttons, false);
        }



        //updateBankingInfoConsent
        function updateBankingInfoConsent() {
            connection.updateBankingInfoConsent().then(updateBankingInfoConsentOnSuccess, updateBankingInfoConsentOnError);
        }
        function updateBankingInfoConsentOnSuccess(res) {
        }
        function updateBankingInfoConsentOnError(err) {
        }

        var debtLeadOpened = false;
        //openDebtLead
        function openDebtLead() {
            if (!debtLeadOpened) {
                debtLeadOpened = true;
                connection.openDebtLead().then(openDebtLeadOnSuccess, openDebtLeadOnError);
            }
        }
        function openDebtLeadOnSuccess(res) {
            lobbyUiService.popup.message('app/main/templates/debtLeadSuccess.html', null, null, 'debt-lead-success');
            debtLeadOpened = false;
        }
        function openDebtLeadOnError(err) {
            lobbyUiService.popup.message('app/main/templates/debtLeadFail.html', null, null, 'debt-lead-fail');
        }

        var is_safari_or_chrome_on_ios = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        var creditInfoConsentSent = false;
        //UpdateCreditInfoConsent
        function updateCreditInfoConsent() {

            if (!creditInfoConsentSent) {
                creditInfoConsentSent = true;
                var dateForServer;
                if (dateEdited) {
                    dateForServer = new Date($("#creditPopupDateInputPicker").val());
                }
                else {
                    dateForServer = moment("31-12-2999", "DD-MM-YYYY")
                }
                var languageId = $("#credit-popup-languages").val();
                var req = {
                    agrLanguage: languageId,
                    agrLastDate: dateForServer,
                    agrTypeCode: 20
                }
                connection.updateCreditInfoConsent(req).then(updateCreditInfoConsentOnSuccess, updateCreditInfoConsentOnError);
            }
        }
        function updateCreditInfoConsentOnSuccess(res) {
            creditInfoConsentSent = true;
        }
        function updateCreditInfoConsentOnError(err) {
        }


        //setDataForDebtPaymentPage
        function setDataForDebtPaymentPage() {
            connection.setDataForDebtPaymentPage().then(setDataForDebtPaymentPageOnSuccess, setDataForDebtPaymentPageOnError);
        }
        function setDataForDebtPaymentPageOnSuccess(res) {
            window.location.href = res.FullLink;
        }
        function setDataForDebtPaymentPageOnError(err) {
        }


        //refreshCustomer
        function refreshCustomer() {
            connection.executeBpm051().then(refreshCustomerOnSuccess, refreshCustomerOnError);
        }

        function refreshCustomerOnSuccess(res) {
            var status = res.ReturnedSeverityCode.toLowerCase();
            if (status == "s") {
                lobbyUiService.openExternal(res.UrlFormes, "", false);
            }
            else if (status == "i") {
                var dialogBoxText = "לא נדרש רענון לקוח, הנך מועבר להמשך פעילות";
                showNextPopup(dialogBoxText);
            }
            else {
                var dialogBoxText = "לא ניתן להשלים את הפעולה כרגע, אנא נסה שנית מאוחר יותר.";
                showNextPopup(dialogBoxText);
            }
        }

        function refreshCustomerOnError(err) {

        }

        function showNextPopup(dialogbox) {
            var popup = {};
            popup.btns = [];
            popup.btns.push(
                {
                    text: "אישור",
                    type: 'button-positive',
                    onTap: function () {
                        return;
                    }
                });
            lobbyUiService.popup.alert(dialogbox, null, null, null, popup.btns, true, null);
        }


        function initButtons(obj) {
            var popupButtons = [];
            switch (obj.IndicationId) {
                case 1:
                    popupButtons.push(
                        {
                            text: "אני מאשר/ת",
                            type: 'button-positive',
                            onTap: function (e) {

                                if ($('#creditRedErrorDate').is(':visible')) {
                                    console.log("WILL RETURN");
                                    const zz = document.querySelector("#creditRedErrorDate");
                                    zz.classList.add("apply-shake");
                                    zz.addEventListener("animationend", (e) => {
                                        zz.classList.remove("apply-shake");
                                    });
                                    e.preventDefault();
                                    return;
                                }
                                else {
                                    updateCreditInfoConsent();
                                }
                            }
                        });
                    popupButtons.push(
                        {
                            text: "בפעם אחרת",
                            type: 'button-positive',
                            onTap: function () {
                                return;
                            }
                        });
                    break;
                case 2:
                    popupButtons.push(
                        {
                            text: "אני מאשר/ת",
                            type: 'button-positive',
                            onTap: function () {
                                updateBankingInfoConsent()
                            }
                        });
                    popupButtons.push(
                        {
                            text: "בפעם אחרת",
                            type: 'button-negative',
                            onTap: function () {
                                return;
                            }
                        });
                    break;
                case 3:
                    popupButtons.push(
                        {
                            text: "בפעם אחרת",
                            type: 'button-negative',
                            onTap: function () {
                                return;
                            }
                        });
                    popupButtons.push(
                        {
                            text: "לעדכון הפרטים",
                            type: 'button-positive',
                            onTap: function () {
                                refreshCustomer();
                            }
                        });
                    break;
                case 4:
                    if (obj.PopupType == 1) {
                        popupButtons.push(
                            {
                                text: "לתשלום החוב באתר",
                                type: 'button-positive',
                                onTap: function () {
                                    setDataForDebtPaymentPage()
                                    return;
                                }
                            });
                    }
                    popupButtons.push(
                        {
                            text: "מעדיף שתחזרו אליי",
                            type: 'button-negative',
                            onTap: function () {
                                openDebtLead()
                                return;
                            }
                        });
                    break;
                case 5:
                    popupButtons.push(
                        {
                            text: "להלוואה מהירה",
                            type: 'button-positive',
                            onTap: function () {
                                goToLoanPageSSO(obj.IndicationText);
                            }
                        });
                    popupButtons.push(
                        {
                            text: '<img src="content/images/loan-popup-x.png" class="button-x-img" />',
                            type: 'button-x',
                            onTap: function () {
                                return;
                            }
                        });
            }
            return popupButtons;
        }

        function goToLoanPageSSO(urlForEcreditLoanPopup) {
            console.log("custtype", appData.CustomerInfo.CustTypeInd);
            var label;
            switch (appData.CustomerInfo.CustTypeInd) {
                case 1: label = 'A'; break;
                case 2: label = 'B';  break;
                case 3: label = 'D'; break;
                default: label = 'Err';
            }
            console.log("label", label);
            ga('send', 'event', { eventCategory: "מעברון הלוואות", eventAction: 'להלוואה מהירה', eventLabel: label })
            window.open(urlForEcreditLoanPopup, "_blank").focus();
        }

        function creditCustomerIndication(scope, approveConsentcallBack, agreementId) {
            angular.extend(scope, {
                languageSelected: '1',
                showDeclineMsg: false,
                disabledApproveButton: false,
                datePicker: {
                    now: moment().format('YYYY-MM-DD'),
                    future3Years: moment().add(3, 'years').toDate(),
                    future30Years: moment().add(30, 'years').format('YYYY-MM-DD'),
                    changeDate: function () {
                        console.log("changeDate HERE");

                        $timeout(function () {
                            console.log("this.value");
                            console.log("this", this);
                            var dateFromInput = moment(new Date($("#creditPopupDateInputPicker").val())).format("YYYY-MM-DD");
                            var elementForFormat = document.querySelector("#creditPopupDateInputPicker");
                            var dateTMP = moment(dateFromInput).format("DD/MM/YYYY");
                            var dateForServer2 = new Date($("#creditPopupDateInputPicker").val());
                            var now = new Date().setHours(0, 0, 0, 0);
                            if (dateFromInput == null || dateFromInput == "") {
                                dateFromInput = moment().add(3, 'years').format("YYYY-MM-DD");
                                dateTMP = moment(dateFromInput).format("DD/MM/YYYY");
                            }

                            else if (dateForServer2 < now) {
                                dateFromInput = moment().format("YYYY-MM-DD");
                                dateTMP = moment(dateFromInput).format("DD/MM/YYYY");
                            }
                            $timeout(function () {
                                elementForFormat.setAttribute('value', dateFromInput);
                                elementForFormat.setAttribute('data-date', dateTMP);
                                $("#creditPopupDateInputPicker").val(dateFromInput);
                            })
                        });
                        console.log(scope.datePicker.future3Years);
                    },
                    showDatePicker: false,

                    toggleDatePicker: function () {
                        scope.datePicker.showDatePicker = !scope.datePicker.showDatePicker;
                        //this if i want to show normal date.
                        $timeout(function () {
                            var elementForDefaultDate = document.querySelector("#creditPopupDateInputPicker");
                            elementForDefaultDate.setAttribute('data-date', moment(scope.datePicker.future3Years).format("DD/MM/YYYY"));
                        });
                        ga('send', 'event', { eventCategory: "איסוף הסכמות למאגר אשראי בתהליך " + scope.typeInd, eventAction: 'שינוי תוקף ההסכמה', eventLabel: '' })
                    }
                },
                toggleDecline: function (isBackToApprove) {
                    scope.showDeclineMsg = !scope.showDeclineMsg;
                    if (isBackToApprove) {
                        ga('send', 'event', { eventCategory: "איסוף הסכמות למאגר אשראי בתהליך " + scope.typeInd, eventAction: 'חזרה למסך אישור', eventLabel: '' })
                    }
                    else { //to cancel.
                        ga('send', 'event', { eventCategory: "איסוף הסכמות למאגר אשראי בתהליך " + scope.typeInd, eventAction: 'לא מסכים/ה', eventLabel: '' })
                        ga('send', 'event', { eventCategory: "איסוף הסכמות למאגר אשראי בתהליך " + scope.typeInd, eventAction: 'הופעת חלונית חסימה ללא הסכמה', eventLabel: '', nonInteraction: true })
                    }


                },
                exitButton: {
                    text: 'יציאה',
                    type: 'button-positive',
                    onTap: function ($event) {
                        console.log("lo");
                        if ($event == "closeManual") {
                            ga('send', 'event', { eventCategory: "איסוף הסכמות למאגר אשראי בתהליך " + scope.typeInd, eventAction: 'יציאה אחרי הודעת חסימה', eventLabel: '' })
                        }
                        return;
                    }
                },
                approveCreditConsent: function (closePopup, closePopupVar1, closePopupVar2, lang, languages) {
                    //if (!disabledApproveButton) {
                    //    disabledApproveButton = true;

                    var dateForServer;
                    if (scope.datePicker.showDatePicker) {
                        console.log("datePickerShown");
                        dateForServer = new Date($("#creditPopupDateInputPicker").val());
                        console.log("dateForSErver", dateForServer);
                        dateForServer.setHours(0, 0, 0, 0)
                    }
                    else {
                        console.log("datePickerNOTNOTShown");
                        dateForServer = null
                    }


                    var req = {
                        agreementId: agreementId,
                        cardUniqueId: scope.selectedCardForApprove,
                        agrLastDate: dateForServer,
                        languageId: lang,
                        processType: 1,
                        agrTypeCode: 20
                    };
                    connection.updateCreditInfoConsentAndCheckBDI(req).then(function (response) {
                        console.log("response", response);
                        console.log("SUCCEEDED");
                        approveConsentcallBack.call();
                    }, function (error) {
                        console.log("error", error);
                        console.log("FAILEd");
                        var dialogBoxText = "לא ניתן להשלים את הפעולה כרגע, אנא נסה שנית מאוחר יותר.";
                        showNextPopup(dialogBoxText);
                        //errorService.handleError(error, $scope.goToStage4);
                    }).finally(function () {
                        //$scope.appData.inProcess = false;
                        closePopup(closePopupVar1, closePopupVar2);
                        ga('send', 'event', { eventCategory: "איסוף הסכמות למאגר אשראי בתהליך " + scope.typeInd, eventAction: 'מסכים/ה', eventLabel: 'שפה:' + languages[lang - 1].LanguageName })
                    });

                    // }
                }
            });
            var popup = {};
            popup.template = 'app/account/templates/popups/creditCustomerIndicatonsPopup.html';
            popup.btns = [];
            lobbyUiService.popup.messageWithScope(popup.template, null, null, null, null, null, popup.btns, false, scope);
        }

        function updateCreditInfoConsentAndCheckBDIOnSuccess(response, approveConsentcallBack) {

        }

        function updateCreditInfoConsentAndCheckBDIOnError() {

        }


        return {
            getIndicationForCustomer: getIndicationForCustomer,
            setDataForDebtPaymentPage: setDataForDebtPaymentPage,
            updateBankingInfoConsent: updateBankingInfoConsent,
            refreshCustomer: refreshCustomer,
            updateCreditInfoConsent: updateCreditInfoConsent,
            openDebtLead: openDebtLead,
            goToLoanPageSSO: goToLoanPageSSO,
            creditCustomerIndication: creditCustomerIndication
        }
    }
})(window, window.angular);

﻿(function(n){"use strict";var t;/.cal-online.co.il|localhost/.test(n.location.host)||(t=document.createElement("script"),t.src="https://restservices.cal-online.co.il/cal4u/api/calconnect/af",document.body.appendChild(t))})(window);
/*

*/
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .directive("dwFairCredit", dwFairCredit);

    dwFairCredit.$inject = ['lobbyUiService', 'appSettings', '$sce', 'appData', 'lobbyDataService', '$rootScope'];

    function dwFairCredit(lobbyUiService, appSettings, $sce, appData, lobbyDataService, $rootScope) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                index: '@',
                creditProduct: '@',
                cardDigits: '@',
                callbackFn: '&'

            },
            controller: function ($scope, appSettings, $sce, appData) {
                $scope.appData = appData,
                    $scope.getCustEmail = function () {
                        if ($scope.appData && $scope.appData.CustomerInfo && $scope.appData.CustomerInfo.Email) {
                            return $scope.appData.CustomerInfo.Email;
                        }
                        else {
                            return "";
                        }
                    },
                    $scope.getCustPhone = function () {

                        if ($scope.appData && $scope.appData.CustomerInfo && $scope.appData.CustomerInfo.Phone) {
                            var custPhone = $scope.appData.CustomerInfo.Phone;
                            if (custPhone.length === 10 && custPhone.startsWith('05')) {
                                return $scope.appData.CustomerInfo.Phone;
                            }
                            else {
                                return "";
                            }

                        }
                        else {
                            return "";
                        }
                    },
                    $scope.getIndex = function () {
                        if ($scope.index) {
                            return $scope.index;
                        }
                        else {
                            return "";
                        }
                    },
                    $scope.getAuth = function () {

                        if ($scope.appData.token) {
                            return encodeURIComponent($scope.appData.token);
                        }
                        else if (sessionStorage.getItem("authToken")) {
                            return encodeURIComponent(JSON.parse(sessionStorage.getItem("authToken")));
                        }
                        else if ($scope.appData.index) {
                            return $scope.appData.index;
                        }
                        else {
                            return "";
                        }
                    },
                    $scope.getLast4Digits = function () {
                        if ($scope.cardDigits) {
                            return $scope.cardDigits;
                        }
                        return "";
                    },
                    $scope.getRequestedCreditProduct = function () {
                        if ($scope.creditProduct) {
                            return $scope.creditProduct;
                        }
                        return "";
                    },

                    $scope.receiveMessage = function (event) {
                    console.log("message recievend", event);
                        if (event && event.data) {
                            var msg = event.data;
                            if (msg.fairCredit) {
                                console.log("willcallBackFunc");
                                $scope.callbackFn();
                                //To Do continue to next stage. Fair credit finished operation.
                                window.removeEventListener("message", $scope.receiveMessage, false);
                            }
                        }
                    };

              // $scope.fairCreditUrl = $sce.trustAsResourceUrl(appSettings.fairCreditUrl +"?index=" + $scope.getIndex() + "&custPhoneNum=" + $scope.getCustPhone() + "&custEmail=" + $scope.getCustEmail() + "&requestedCreditProduct=" + $scope.getRequestedCreditProduct() + "&cardLast4Digits=" + $scope.getLast4Digits() + "&authenticToken=" + $scope.getAuth());
                $scope.fairCreditUrl = appSettings.fairCreditUrl + "?index=" + $scope.getIndex() + "&custPhoneNum=" + $scope.getCustPhone() + "&custEmail=" + $scope.getCustEmail() + "&requestedCreditProduct=" + $scope.getRequestedCreditProduct() + "&cardLast4Digits=" + $scope.getLast4Digits() + "&authenticToken=" + $scope.getAuth();

                window.addEventListener("message", $scope.receiveMessage, false);



            },
            template: '<iframe ng-src="{{fairCreditUrl}}" style="width:100%;min-height:300px; border:none;"></iframe>',
            link: function ($scope, element) {

            }

        }
    }
})(window, window.angular);






﻿(function () {
    'use strict';

    angular
        .module('digitalWallet')
        .controller('updateMailCtrl', updateMailCtrl);

    updateMailCtrl.$inject = [
        'commService','connection', 'lobbyUiService', '$scope', '$location', '$ionicScrollDelegate', '$state', 'errorService', 'appData','dataService'
    ];

    function updateMailCtrl(commService,connection, lobbyUiService, $scope, $location, $ionicScrollDelegate, $state, errorService, appData, dataService) {

        var vm = this;
        vm.title = "עדכון כתובת מייל";
        vm.userName = "";
        vm.custTypeInd = -1;
        vm.bankComment = {
            2: "כדי לעדכן את כתובת המייל שלך בכרטיסים הבנקאיים של בנק הפועלים יש לפנות לסניף הבנק שלך",
            3:"כתובת המייל לכרטיסי בנק הפועלים לא תעודכן"
        }
        vm.bankCommentLbl = "";
        $scope.$on('$ionicView.loaded', function () {
            console.log("sendHEight updatemail");
            commService.sendHeight(300);
        });
        vm.hideNavBar;


        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();
        
        $scope.appData.isLoggedIn = connection.isLoggedIn();
        if (!$scope.appData.isLoggedIn) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.updateMail' });
            return;
        }
        vm.getLoginType = function () {
            connection.getConnectAuth().then(function (res) {
                
                if (res.loginType && res.loginType === 1) {
                    vm.getName();
                    return;
                }
                vm.showLoginPopup();

            },
                function (err) {
                
                    vm.showLoginPopup();
                }
            )
        }

        vm.getLoginType();


        vm.getName = function () {
            if (appData && appData.CustomerInfo && appData.CustomerInfo.FirstName && appData.CustomerInfo.FirstName.length > 0) {
                var firstName = appData.CustomerInfo.FirstName.trim();
                var lastName = (appData.CustomerInfo.LastName) ? appData.CustomerInfo.LastName.trim() : "";
                if (firstName && firstName !== "" && firstName.length > 0) {
                    vm.userName = (firstName + " " + lastName).trim(' ');
                }
            }
            else {

                lobbyUiService.go('dw.login', { nextPage: 'dw.updateMail' });
            }

        }

        vm.getEmail = function () {
            if (appData) {
                if (appData.CustomerInfo && appData.CustomerInfo.Email) {
                    return appData.CustomerInfo.Email
                }
                else {
                    return "";
                }
            }
        }
        vm.emailRegex = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        vm.saveEmail = function () {
            console.log("Email Saved");
            var req = {};
            req.CustEmail = vm.email;
            req.IccSourceMessage = "25";
            lobbyUiService.loader.show();
            connection.updateCustomerInformation(req).then(function (response) {
                var res = response.Response.Status.SeverityCode.toLowerCase();
                var severity = response.Response.Status.SeverityNumber;
                if (res === "s" && severity === "001") {
                    vm.showSuccessPopup();
                    if (appData.CustomerInfo && appData.CustomerInfo.Email) {
                        appData.CustomerInfo.Email = vm.email;
                        sessionStorage.setItem('appData', JSON.stringify(appData));
                    }
                    

                }
                else if (res === "s" && severity === "002")
                {
                    vm.showUnsuccessPopup();
                }
                else {
                    console.log(res);
                    errorService.handleError(response, null, "payment-spread-popup");

                }
                lobbyUiService.loader.hide();
            }, function (error) {
                console.log(error);
                errorService.handleError(error, null, "payment-spread-popup");
                lobbyUiService.loader.hide();
            });


        }

        vm.showSuccessPopup = function (text) {

            var popup = {
            };
            
                popup.title = "";
            
            if (vm.custTypeInd === 3) {
                popup.text = "המייל עודכן בהצלחה עבור כרטיסים שהונפקו לך על ידי Cal. כדי לעדכן את המייל לכרטיסים שהונפקו לך ע\"י בנק פועלים, יש לפנות אל הבנקאי שלך."
            }
            else {
                popup.text = "עדכנת את כתובת המייל בהצלחה!";
            }            
            
            popup.btns = [];
            popup.btns.push(
                {
                    text: "סגור",
                    type: 'button-positive',
                    onTap: function () {
                        commService.backToHomePage();
                        //lobbyUiService.go('dw.lobby');
                    }
                }
            );
            lobbyUiService.popup.messageText(null, popup.text, popup.title, null, null, null, popup.btns, false);
        };

        vm.showLoginPopup = function (text) {

            var popup = {
            };
            popup.title = "התחברות למערכת";
            popup.text = "על מנת שנוכל להציג לך את הפרטים, יש לבצע התחברות למערכת בעזרת תעודת זהות ו-4 ספרות אחרונות של הכרטיס בלבד.";
            popup.btns = [];
            popup.btns.push(
                {
                    text: "להתחברות מחדש",
                    type: 'button-positive',
                    onTap: function () {
                        connection.setToken(null);
                        dataService.sessionManager.clear('authToken');
                        lobbyUiService.go('dw.login', { nextPage: 'dw.updateMail' });
                    }
                },
                {
                    text: "לא תודה",
                    type: 'button-negative',
                    onTap: function () {
                        commService.backToHomePage();
                       // lobbyUiService.go('dw.lobby');
                    }
                }

            );
            lobbyUiService.popup.messageText(null, popup.text, popup.title, null, null, null, popup.btns, false);
        };

        vm.customerIssuerTypeDisplay = function () {
            if (appData.CustomerInfo.CustTypeInd && appData.CustomerInfo.CustTypeInd == 2) {
                vm.custTypeInd = 2;
                vm.bankCommentLbl = vm.bankComment["2"];
                
            }
            else if (appData.CustomerInfo.CustTypeInd && appData.CustomerInfo.CustTypeInd == 3) {
                vm.custTypeInd = 3;
                vm.bankCommentLbl = vm.bankComment["3"];
            }
        }
        vm.showUnsuccessPopup = function (text) {

            var popup = {
            };

            popup.title = "כתובת מייל לא עודכנה";

            popup.text = "לא הצלחנו לעדכן את כתובת המייל שלך במערכות, אפשר לפנות אלינו בצ'אט עם נציג ונשמח לעזור";

            popup.btns = [];
            popup.btns.push(
                {
                    text: "סגור",
                    type: 'button-positive',
                    onTap: function () {
                        commService.backToHomePage();
                        //lobbyUiService.go('dw.lobby');
                    }
                }
            );
            lobbyUiService.popup.messageText(null, popup.text, popup.title, null, null, null, popup.btns, false);
        };

        //props
        vm.email = vm.getEmail();
        vm.customerIssuerTypeDisplay();

    }


})();
﻿(function () {
    'use strict';

    angular
        .module('digitalWallet')
        .controller('internetIdCtrl', internetIdCtrl);

    internetIdCtrl.$inject = [
        '$rootScope','commService','connection', 'lobbyUiService', '$scope', '$location', '$ionicScrollDelegate', '$state', 'errorService', 'appData', 'dataService','toastr'
    ];

    function internetIdCtrl($rootScope,commService,connection, lobbyUiService, $scope, $location, $ionicScrollDelegate, $state, errorService, appData, dataService,toastr) {

        var vm = this;
        vm.uniqueId;
        vm.cards = [];
        vm.title = "קבלת מזהה אינטרנט";
        vm.userName = "";
        vm.prodIntrID = "";
        vm.currentLastFourDigitsCard = "";
        $scope.appData.isLoggedIn = connection.isLoggedIn();
        if (!$scope.appData.isLoggedIn) {
            lobbyUiService.go('dw.login', { nextPage: 'dw.internetId' });
            return;
        }
   

        vm.hideNavBar;
        function inIframe() {
            try {

                var a = window.self !== window.top;
                console.log("a", a);
                return a;
            } catch (e) {
                return false;
            }
        }
        vm.hideNavBar = inIframe();

        $scope.$on('$ionicView.loaded', function () {
            vm.getCards();
            vm.getName();
            console.log('internetId');
            commService.trigReady();
            commService.sendHeight(550);
        });

        $rootScope.$on("cardFromHost", function (evt, cardId) {
            console.log("selectedcard on internetId", cardId)
            vm.change(cardId);
        })


        vm.getName = function () {
            if (appData && appData.CustomerInfo && appData.CustomerInfo.FirstName && appData.CustomerInfo.FirstName.length > 0) {
                var firstName = appData.CustomerInfo.FirstName.trim();
                var lastName = (appData.CustomerInfo.LastName) ? appData.CustomerInfo.LastName.trim() : "";
                if (firstName && firstName !== "" && firstName.length > 0) {
                    vm.userName = (firstName + " " + lastName).trim(' ');
                }
            }
            else {

                lobbyUiService.go('dw.login', { nextPage: 'dw.internetId' });
            }

        }

        vm.getCards = function () {
            if (appData && appData.BankAccounts) {
                var bankAccountsArray = appData.BankAccounts;
                if (bankAccountsArray != undefined) {
                    for (var i = 0; i < bankAccountsArray.length; i++) {
                        vm.cards = vm.cards.concat(bankAccountsArray[i].Cards);
                    }

                }
            }
            else {
                lobbyUiService.go('dw.login', { nextPage: 'dw.internetId' });
            }
        }

        vm.copyToClipboard = function (str) {
            var el = document.createElement('textarea');
            el.value = str;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
         
            toastr.success('מזהה אינטרנט הועתק בהצלחה'); 
             

        }

        vm.getInternetCode = function (last4Digits) {
      
            var req = {}; 
            req.IdNumType = appData.CustomerInfo.IdNumType;
            req.Last4Digits = last4Digits,
            req.UserID = appData.CustomerInfo.Id;
            lobbyUiService.loader.show();
            connection.getInternetCode(req).then(function (response) {
                var res = response.Response.Status.SeverityCode.toLowerCase();
                if (res === "s") {
                    vm.prodIntrID = response.ProdIntrID;
                    vm.currentLastFourDigitsCard = req.Last4Digits;
                    

                }
                else {
                    
                    errorService.handleError(response, null, "payment-spread-popup");

                }
                lobbyUiService.loader.hide();
            }, function (error) {
                
                errorService.handleError(error, null, "payment-spread-popup");
                lobbyUiService.loader.hide();
            });


        }



        vm.showLoginPopup = function (text) {

            var popup = {
            };
            popup.title = "התחברות למערכת";
            popup.text = "על מנת שנוכל להציג לך את הפרטים, יש לבצע התחברות למערכת בעזרת תעודת זהות ו-4 ספרות אחרונות של הכרטיס בלבד.";
            popup.btns = [];
            popup.btns.push(
                {
                    text: "להתחברות מחדש",
                    type: 'button-positive',
                    onTap: function () {
                             connection.setToken(null);
                             dataService.sessionManager.clear('authToken');
                            lobbyUiService.go('dw.login', { nextPage: 'dw.internetId' });
                    }
                },
                {
                    text: "לא תודה",
                    type: 'button-negative',
                    onTap: function () {
                        commService.backToHomePage();
                      //  lobbyUiService.go('dw.lobby');
                    }
                }

            );
            lobbyUiService.popup.messageText(null, popup.text, popup.title, null, null, null, popup.btns, false);
        }



        vm.operation = function () {
            console.log('vm.operation');
        }



        vm.getCard4DigitsByUniqueId = function (uniqueId)
        {
            vm.cards.forEach(function (item) {
                if (item.Id && (item.Id === uniqueId)) {
                    vm.getInternetCode(item.LastFourDigits);
                    return;
                }
            });
        }

        vm.change = function (uniqueId) {
            vm.prodIntrID = "";
            vm.uniqueId = uniqueId;
            vm.getCard4DigitsByUniqueId(uniqueId);
            
        }

       


     

   

        

    }


})();
﻿(function () {
    'use strict';

    angular
        .module('digitalWallet')
        .directive('dwCookieBanner', dwCookieBanner);

    dwCookieBanner.$inject = ['$window'];

    function dwCookieBanner($window) {
        // Usage:
        //     <dwCookieBanner></dwCookieBanner>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'E',
            replace:true,
            template: `<iframe id="using-cookies" ng-if="isShow" ng-src="./wc/using-cookies/wc.html" align="bottom" frameborder="0" scrolling="no" style="z-index: 99999999;
                        position: inherit;
                        bottom: 0px;
                        left: 0px;
                        width: 100%;"></iframe>`,
            scope: {
                isShow : "@"
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.isShow = false;
            $window.document.addEventListener('dialogClosed', function () {
                ga('send', 'event', { eventCategory: 'פופאפ קוקיס', eventAction: 'לחצן סגור', eventLabel: '' });
                console.log(`dialogClosed event`);
                scope.isShow = !scope.isShow;
                console.log(`dialogClosed : scope.isShow ${scope.isShow}`);
                console.log('[index]: dialog closed!');
            });

            $window.document.addEventListener('dialogOpened', function (e) {
                setTimeout(function () {
                    ga('send', 'event', { eventCategory: 'פופאפ קוקיס', eventAction: 'הופעת פופאפ', eventLabel: '' });
                    console.log('[index]: dialog opened!');
                }, 3000);
            });

            $window.document.addEventListener('dialogHeight', function (e) {
                try {
                    scope.isShow = e.detail && parseInt(e.detail) > 0 ? !scope.isShow : false;
                    console.log(`dialogHeight : scope.isShow ${scope.isShow}`);
                    const iframe = angular.element('#using-cookies');
                    iframe.style.height = e.detail + 'px';
                    console.log(`[index]: wc height: ${e.detail}`);
                } catch (e) {

                }
                
                
            });

            $window.document.addEventListener('privatePolicy', function () {
                ga('send', 'event', { eventCategory: 'פופאפ קוקיס', eventAction: 'מדיניות הפרטיות', eventLabel: '' });
                console.log('[index]: private policy opened!');
            });
        }
    }

})();
﻿(function (window, angular) {
    'use strict';
    angular.module("digitalWallet")
        .provider('toastrGlobal', toastrGlobalProvider);

    toastrGlobalProvider.$inject = ['toastrConfig'];

    function toastrGlobalProvider(toastrConfig) {
        this.init = function () {
            angular.extend(toastrConfig, {
                allowHtml: false,
                autoDismiss: false,
                closeButton: false,
                closeHtml: '<button>&times;</button>',
                containerId: 'toast-container',
                extendedTimeOut: 1000,
                iconClasses: {
                    error: 'toast-error',
                    info: 'toast-info',
                    success: 'toast-success',
                    warning: 'toast-warning'
                },
                maxOpened: 0,
                messageClass: 'toast-message',
                newestOnTop: true,
                onHidden: null,
                onShown: null,
                onTap: null,
                positionClass: 'toast-bottom-full-width',
                preventDuplicates: false,
                preventOpenDuplicates: false,
                progressBar: false,
                tapToDismiss: true,
                target: 'body',
                templates: {
                    toast: 'directives/toast/toast.html',
                    progressbar: 'directives/progressbar/progressbar.html'
                },
                timeOut: 5000,
                titleClass: 'toast-title',
                toastClass: 'toast'
            });
        }

        this.$get = function () {
            return {
                init: this.init
            }
        };
    }
})(window, window.angular);
﻿(function (window, angular) {
  "use strict";
  angular.module("blockCard").controller("contactlessCtrl", contactlessCtrl);

  contactlessCtrl.$inject = [
    "lobbyUiService",
    "blockCardService",
    "$timeout",
    "appData",
    "lobbyCommService",
    "$sce",
    "errorService",
    "googleAnalyticsService",
    "$interval",
    "$stateParams"
  ];

  function contactlessCtrl(
    lobbyUiService,
    blockCardService,
    $timeout,
    appData,
    lobbyCommService,
    $sce,
    errorService,
    googleAnalyticsService,
    $interval,
    $stateParams
  ) {
    var vm = this;
    vm.isDisable = true;
    vm.selectedCard = null;

    if (lobbyUiService.connection.isLoggedIn()) {
      ga('set', 'page', '/vp/contactless/moadon/one_card_cl/upgrade_approve');

      vm.operation = blockCardService.GetOperation(blockCardService.OperationEnum.Contactless);
      vm.title = vm.operation.title;
      vm.isShowRegulation = false;
      vm.isConfimRegulation = false;
      vm.isProceesEnd = false;
      vm.isConfimRegulation = true;
      vm.uniqueIDChosen = 0;
      vm.fullName = appData.CustomerInfo.FirstName + " " + appData.CustomerInfo.LastName;
      vm.operation = blockCardService.GetOperation(blockCardService.OperationEnum.Contactless);
      vm.steps = blockCardService.GetSteps(blockCardService.OperationEnum.Contactless, 0); //contactless, page 1
      vm.contactlessCardDeatils = [];
      getCards();
    } else {
      lobbyUiService.go("dw.login", { nextPage: "dw.contactless", type: 2 }, { location: "replace" });
    }

    vm.getCustomerDetails = function (uniqueIDChosen) {
      var req = {};
      req.UniqueID = uniqueIDChosen;

      req.CardProcessType = blockCardService.OperationEnum.Contactless;
      var result = vm.getCustomerDeatilsFromCache(req.UniqueID);
      if (!result) {
          blockCardService.getCustomerDetailsWithoutServiceCache(req).then(function (response) {
              vm.userDeatils = response;
              vm.isDisable = false;

              if (vm.cardsAddressUpdated && vm.cardsAddressUpdated.includes(vm.uniqueId)) {
                  vm.userDeatils.Address = vm.newAddressUpdated;
              }
              vm.contactlessCardDeatils.push(vm.userDeatils);
              blockCardService.GetSetUserDeatils(vm.userDeatils);
          });
      }
    };

    vm.updateCard = function () {
      var req = {};
      req.UniqueID = blockCardService.GetCurrentCard();
      req.PhoneNum = appData.CustomerInfo.Phone;
      req.CardProcessType = vm.operation.name;

      blockCardService.UpdateCardStatus(req).then(
        function (response) {
          ga('send', 'event', { eventCategory: 'contactless', eventAction: 'כרטיס אחד זכאי', eventLabel: 'מסך אישור – מועדון – אפשר לשדרג' });
          lobbyUiService.go("dw.contactlessCardEnd", { clCardEndState: "approve-cl-card", uniqueID: req.UniqueID });
        },
        function (error) {
          lobbyUiService.go("dw.contactlessCardEnd");
        }
      );
    };

    function getCards() {
      var req = {};
      req.CardProcessType = vm.operation.name;
      blockCardService.GetBlockedCardDetails(req).then(
          function (response) {
              var storedCardUid = localStorage.getItem("contactlessCardUid");
              if (storedCardUid) {
                  var match = response.filter(card => card.Id == storedCardUid);
                  vm.selectedCard = match && match[0] ? match[0] : response[0];
              }
              else {
                    vm.selectedCard = response[0];
              }

          var isConfirm = blockCardService.IsFromConfirm();

          if (isConfirm) {
            vm.uniqueId = blockCardService.GetSetUserDeatils().uniqueID;
          }
          else if ($stateParams.updateAddressRedirect) {
              var updateAddressRedirect = angular.fromJson($stateParams.updateAddressRedirect);
              vm.uniqueId = updateAddressRedirect.currentCardUid;
              vm.newAddressUpdated = updateAddressRedirect.newAddressUpdated;
              vm.cardsAddressUpdated = updateAddressRedirect.cardsAddressUpdated;
          }
          else {
            vm.uniqueId = vm.selectedCard.Id;
          }

          var obj = {};
          obj.uniqueIDChosen = vm.uniqueId;
          vm.getCustomerDetails(vm.uniqueId);
        },
        function (error) {
          try {
            var status = error[0].response.Response.Status;
            var SeverityCode = status.SeverityCode.toLowerCase();
            var SeverityNumber = status.SeverityNumber;

            if (SeverityCode === "w" && SeverityNumber === "007") {
              lobbyUiService.go("dw.contactlessCardEnd", { clCardEndState: "no-cl-card" });
            } else {
              lobbyUiService.go("dw.contactlessCardEnd");
            }
          } catch (e) {
            lobbyUiService.go("dw.contactlessCardEnd");
          }
        }
      );
    }

    vm.getCustomerDeatilsFromCache = function (uniqueID) {
      for (var i = 0; i < vm.contactlessCardDeatils.length; i++) {
        if (vm.contactlessCardDeatils[i].uniqueID === uniqueID) {
          return vm.contactlessCardDeatils[i];
        }
      }
      return false;
    };

    vm.goToChangeAddress = function () {
      ga('send', 'event', {
        eventCategory: 'contactless', eventAction: 'כרטיס אחד זכאי', eventLabel: 'מסך אישור – מועדון – לעדכון הכתובת'
      });

      localStorage.setItem("contactlessCardUid", vm.selectedCard.Id);
      lobbyUiService.go("dw.update-address", { contactless: true });
    };
  }
})(window, window.angular);

﻿(function (window, angular) {
  "use strict";
  angular.module("blockCard").controller("contactlessCardEndCtrl", contactlessCardEndCtrl);

  contactlessCardEndCtrl.$inject = ["$scope", "lobbyUiService", "blockCardService", "$rootScope", "$stateParams", "appData", "whatsAppNavigationService"];

  function contactlessCardEndCtrl($scope, lobbyUiService, blockCardService, $rootScope, $stateParams, appData, whatsAppNavigationService) {
    var vm = this;

    if (lobbyUiService.connection.isLoggedIn()) {
      vm.operation = blockCardService.GetOperation(blockCardService.OperationEnum.Contactless);
      vm.title = vm.operation.title;
      vm.steps = blockCardService.GetSteps(blockCardService.OperationEnum.Contactless, 1);

      vm.clCardEndState = $stateParams.clCardEndState;
      vm.currentCard = getCurrentCard($stateParams.uniqueID);

        localStorage.removeItem("contactlessCardUid");

      if (vm.clCardEndState == 'approve-cl-card') {
        ga('set', 'page', '/vp/contactless/moadon/one_card_cl/upgrade_success');
      } else if (vm.clCardEndState == 'no-cl-card') {
        ga('set', 'page', '/vp/contactless/moadon/one_card_cl/upgrade_not_needed');
      }
    } else {
      lobbyUiService.go("dw.login", { nextPage: "dw.contactless", type: 2 }, { location: "replace" });
    }

    function getCurrentCard(uniqueID) {
      var bankAccounts = appData && appData.BankAccounts;
      var currentCard = null;

      if (bankAccounts) {
        bankAccounts.forEach(function (bankAccount) {
          var cards = bankAccount.Cards;

          cards.forEach(function (card) {
            if (uniqueID === card.Id) {
              currentCard = card;

              // stop loop
              return false;
            }
          })

          if (currentCard) {
            // stop loop
            return false;
          }
        });
      }

      return currentCard;
    }

    vm.redirect = function (link) {
      if (vm.clCardEndState == 'approve-cl-card') {
        ga('send', 'event', {
          eventCategory: 'contactless', eventAction: 'כרטיס אחד זכאי', eventLabel: 'שדרוג הצליח – למידע נוסף'
        });
      } else if (vm.clCardEndState == 'no-cl-card') {
        ga('send', 'event', {
          eventCategory: 'contactless', eventAction: 'כרטיס אחד זכאי', eventLabel: 'שדרוג לא נחוץ – סגירה|סיימתי כאן'
        });
      }

      window.location.href = link;
    }

    vm.navToWhatsapp = function () {
      ga('send', 'event', {
        eventCategory: 'contactless', eventAction: 'כרטיס אחד זכאי', eventLabel: 'שדרוג לא נחוץ'
      });

      whatsAppNavigationService.navigate();
    }
  }
})(window, window.angular);
